import React, { forwardRef, useRef, useState, useImperativeHandle, useEffect, Component, createRef, useLayoutEffect, useContext, memo, useMemo } from 'react';
import BootstrapButton from 'react-bootstrap/Button';
import styled, { createGlobalStyle, ThemeContext, css } from 'styled-components';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import IcomoonReact from 'icomoon-react';
import dayjs from 'dayjs';
import { get as get$2, set } from 'dot-prop-immutable';
import Highcharts, { dateFormat } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import histogram from 'highcharts/modules/histogram-bellcurve';
import './images/dUKLFPfw.jpg';
import './images/fetdrvuE.jpg';
import './images/brwTEVKm.jpg';
import infAccuracy2bGrayscale from './images/dncJrwAG.jpg';
import infAccuracy3bGrayscale from './images/bhQtIiqV.jpg';
import infAccuracySSGrayscale from './images/cFbolLsF.jpg';
import baseballDirt from './images/fvYzEkNW.jpg';
import baseballWLogo from './images/qzireacR.jpg';
import blankHeatMap from './images/JZQojAbW.png';
import blueSky from './images/eRnlUvJE.jpg';
import lhbImgFront from './images/dDwMPuxv.gif';
import rhbImgFront from './images/eyBhYfZC.gif';
import lhbImgRear from './images/bFhPHVuR.gif';
import rhbImgRear from './images/OzskyXhK.gif';
import headshotEmptyImg from './images/fzMgImEI.png';
import ifGrassZoomOutNoStripe from './images/dGdLyIxY.jpg';
import ifGrass from './images/dYjFTjWd.jpg';
import './images/hISHJHLi.png';
import spinnerImg from './images/dhWJubOg.gif';
import searchReset from './images/bOZmhAGc.gif';
import catcherThrows2B from './images/elPoXyCz.png';
import catcherThrows3B from './images/eDaFGkKC.png';
import sprayChartOF from './images/bFhmWyCD.png';
import sprayChartIF from './images/egkYmVOe.png';
import sprayChartOfGrayscale from './images/fGavOSRD.png';
import sprayChartIfGrayscale from './images/IfnWPZLE.png';
import sprayChartIFBW from './images/xuKVdQLL.png';
import bb18x18 from './images/dWIVVTDM.png';
import evLaActual from './images/cTflbfJr.png';
import evLaDifference from './images/fVIDuzeG.png';
import evLaHitFx from './images/TBgaOoPu.png';
import homeplate from './images/ermuTHmM.png';
import batimpactlhh from './images/cqDgYuDz.png';
import batimpactrhh from './images/qevfoQQQ.png';
import batimpactlhhzoom from './images/eOHWUPbK.png';
import batimpactrhhzoom from './images/dAqBetdC.png';
import { useTranslation, withTranslation, initReactI18next } from 'react-i18next';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import Image from 'react-bootstrap/Image';
import HighchartsMore from 'highcharts/highcharts-more';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-bootstrap/Pagination';
import Highcharts$1, { isNumber as isNumber$3 } from 'highcharts/highcharts';
import Annotation from 'highcharts/modules/annotations';
import Spinner from 'react-bootstrap/Spinner';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import ReactDatePicker from 'react-datepicker';
import FormControl from 'react-bootstrap/FormControl';
import noUiSlider from 'nouislider';
import { CKEditor } from 'ckeditor4-react';
import { Dropdown as Dropdown$1, Form as Form$1, Col as Col$1, Row as Row$1, Card as Card$2, Button as Button$1, ToggleButtonGroup as ToggleButtonGroup$1, ToggleButton as ToggleButton$1, ButtonGroup } from 'react-bootstrap';
import ListGroup from 'react-bootstrap/ListGroup';
import Modal from 'react-bootstrap/Modal';
import Bowser from 'bowser';
import PropTypes from 'prop-types';
import Toast from 'react-bootstrap/Toast';
import Overlay from 'react-bootstrap/Overlay';
import normalizeWheel from 'normalize-wheel';
import Badge from 'react-bootstrap/Badge';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ModalDialog from 'react-bootstrap/ModalDialog';
import Container$k from 'react-bootstrap/Container';
import Card$1 from 'react-bootstrap/Card';
import BrokenAxis from 'highcharts/modules/broken-axis';
import { Rect, Transformer, Ellipse as Ellipse$1, Line as Line$1, Text as Text$1, Arrow as Arrow$1, Stage as Stage$1, Layer, Image as Image$1 } from 'react-konva';
import useImage from 'use-image';
import i18n from 'i18next';
export { default as i18n } from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const Button = (_a) => {
    var { children, variant = 'default', size = 'sm' } = _a, rest = __rest(_a, ["children", "variant", "size"]);
    return (React.createElement(BootstrapButton, Object.assign({ variant: variant, size: size }, rest), children));
};
const DefaultButtonAlt = (_a) => {
    var { children, size = 'sm' } = _a, rest = __rest(_a, ["children", "size"]);
    return (React.createElement(BootstrapButton, Object.assign({ size: size, style: { backgroundColor: '#C6D3DC', borderColor: 'darkgray', color: 'black' } }, rest), children));
};

/* eslint-disable */
// INSPIRED / CONVERTED FROM:
// pSBC - Shade Blend Convert - Version 4.0 - 02/18/2019
// https://github.com/PimpTrizkit/PJs/wiki/12.-Shade,-Blend-and-Convert-a-Web-Color-(pSBC.js)
// TODO: this file is very sloppy and I (BG) have done the bare minimum here to have TS stop throwing errors in this file.
// I did write pSBCr in TS, but wasn't 100% conffident on it so need someone to double check my work at some point
const pSBC = (p, c0, c1, l) => {
    let r, g, b, P, f, t, h, m = Math.round, a = typeof (c1) == "string";
    if (typeof (p) != "number" || p < -1 || p > 1 || typeof (c0) != "string" || (c0[0] != 'r' && c0[0] != '#') || (c1 && !a))
        return null;
    h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == "c" ? !h : false : h, f = pSBC.pSBCr(c0), P = p < 0, t = c1 && c1 != "c" ? pSBC.pSBCr(c1) : P ? { r: 0, g: 0, b: 0, a: -1 } : { r: 255, g: 255, b: 255, a: -1 }, p = P ? p * -1 : p, P = 1 - p;
    if (!f || !t)
        return null;
    if (l)
        r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
    else
        r = m(Math.pow((P * Math.pow(f.r, 2) + p * Math.pow(t.r, 2)), 0.5)), g = m(Math.pow((P * Math.pow(f.g, 2) + p * Math.pow(t.g, 2)), 0.5)), b = m(Math.pow((P * Math.pow(f.b, 2) + p * Math.pow(t.b, 2)), 0.5));
    a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
    if (h)
        return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";
    else
        return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2);
};
pSBC.pSBCr = (d) => {
    const i = parseInt, m = Math.round;
    let n = d.length, x = { r: 0, g: 0, b: 0, a: 0 };
    if (n > 9) {
        const [r, g, b, a] = (d = d.split(','));
        n = d.length;
        if (n < 3 || n > 4)
            return null;
        x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1;
    }
    else {
        if (n == 8 || n == 6 || n < 4)
            return null;
        if (n < 6)
            d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
        d = i(d.slice(1), 16);
        if (n == 9 || n == 5)
            x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = m((d & 255) / 0.255) / 1000;
        else
            x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1;
    }
    return x;
};

const buttonColor = (font, background) => `
    color: ${font};
    background-color: ${background};
    border-color: ${pSBC(-0.1, background)};
    &:hover {
        background-color: ${pSBC(-0.1, background)};
        border-color: ${pSBC(-0.2, background)};
    }
    &:active {
        background-color: ${pSBC(-0.2, background)};
        border-color: ${pSBC(-0.3, background)};
    }
`;

// color names from http://chir.ag/projects/name-that-color
var theme = {
    font: {
        body: "'Amble', sans-serif !important",
        header: "'Aleo', serif",
    },
    fontSize: {
        nav: '13px',
    },
    fontColors: {
        mineShaft: '#333333',
        tundora: '#454545',
        doveGray: '#737373',
        dodgerBlue: '#3292FF',
        sanMarino: '#3A6A9C',
        anakiwa: '#98CBFF',
        silverChalice: '#A6A6A6',
        silver: '#C6C6C6',
        darkBlue: '#154488',
        cerulean: '#0077d9',
        metallicBlue: '#204b76',
    },
    spacing: {
        body: '0.425px',
        header: '0.2px',
    },
    margin: {
        body: '1em',
    },
    border: {
        alto: '#CECECE',
        bombay: '#ADB0B2',
        paleSky: '#637785',
        mercury: '#E1E1E1',
    },
    background: {
        concrete: '#F3F3F3',
        geyser: '#C6D3DC',
        gallery: '#EDEDED',
        solitude: '#E5F4FF',
        mariner: '#2877D9',
        astronaut: '#244C74',
        codGray: '#111111',
        success: '#28A745',
        boulder: '#767676',
        blueZodiac: '#132448',
        firefly: '#0D1932',
        cerulean: '#0077d9',
        cello: '#1C3B5C',
        endeavour: '#005A9C',
        red: '#FF0000',
        tangerine: '#F78D00',
        darkblue: '#274D74',
        lightblue: '#98CBFD',
        white: '#FFFFFF',
    },
};
const bootstrapSm = 576;
const bootstrapMd = 768;
const bootstrapLg = 992;
const bootstrapXl = 1200;

var constants = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': theme,
    bootstrapSm: bootstrapSm,
    bootstrapMd: bootstrapMd,
    bootstrapLg: bootstrapLg,
    bootstrapXl: bootstrapXl
});

const StyledToggleButton$1 = styled(ToggleButton) `
    &&&.btn { 
        &&&.active {
            ${buttonColor('white', theme.background.mariner)};
        }
        &&&.disabled {
            ${buttonColor(theme.background.codGray, theme.background.concrete)};
        }
        ${buttonColor('black', theme.background.geyser)};
    }
`;
const StyledButtonGroup$1 = styled(ToggleButtonGroup) `
    ${(props) => (props.$separated ? `
        &&&& {
            > ${StyledToggleButton$1} {
                &:not(:last-child) {
                    border-top-right-radius: 0.25rem;
                    border-bottom-right-radius: 0.25rem;
                    margin-right: 7px;
                }
                &:not(:first-child) {
                    border-top-left-radius: 0.25rem;
                    border-bottom-left-radius: 0.25rem;
                }
            }
        }
    ` : '')}
    .btn-check:checked + .btn {
        ${buttonColor('white', theme.background.mariner)};
    }
`;
const ToggleButtons = (_a) => {
    var { options, onChange, separated = false, type = 'radio', name } = _a, rest = __rest(_a, ["options", "onChange", "separated", "type", "name"]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onToggleChange = onChange ? (newVal, event) => onChange(newVal, event.currentTarget.name, event) : undefined;
    return (React.createElement(StyledButtonGroup$1, Object.assign({ "$separated": separated, onChange: onToggleChange, type: type, name: name }, rest), options.map((o) => (React.createElement(StyledToggleButton$1, { key: o.value.toString(), id: `${name}-${o.value.toString()}`, value: o.value, disabled: o.disabled }, o.name)))));
};

const boxShadow = (shadow) => `
    -webkit-box-shadow: ${shadow};
    -moz-box-shadow: ${shadow};
    box-shadow: ${shadow};
`;
const borderRadiuses = (topright = 0, bottomright = 0, bottomleft = 0, topleft = 0) => `
    -webkit-border-top-right-radius: ${topright};
    -webkit-border-bottom-right-radius: ${bottomright};
    -webkit-border-bottom-left-radius: ${bottomleft};
    -webkit-border-top-left-radius: ${topleft};
    -moz-border-radius-topright: ${topright};
    -moz-border-radius-bottomright: ${bottomright};
    -moz-border-radius-bottomleft: ${bottomleft};
    -moz-border-radius-topleft: ${topleft};
    border-top-right-radius: ${topright};
    border-bottom-right-radius: ${bottomright};
    border-bottom-left-radius: ${bottomleft};
    border-top-left-radius: ${topleft};
    -moz-background-clip: padding;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
`;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#Tagged_templates
const mediaTaggedLiteral = (size) => (rawStrings, ...interpolatedStrings) => `
    @media (min-width: ${size}px) {
        ${rawStrings.map((value, idx) => `${value}${interpolatedStrings[idx] || ''}`).join('')}
    }
`;
const media = (minWidthPx) => mediaTaggedLiteral(minWidthPx);
media.sm = mediaTaggedLiteral(bootstrapSm);
media.md = mediaTaggedLiteral(bootstrapMd);
media.lg = mediaTaggedLiteral(bootstrapLg);
media.xl = mediaTaggedLiteral(bootstrapXl);

var mixins = /*#__PURE__*/Object.freeze({
    __proto__: null,
    boxShadow: boxShadow,
    borderRadiuses: borderRadiuses,
    media: media
});

var IcoMoonType = "selection";
var icons = [
	{
		icon: {
			paths: [
				"M914.856 1024c-282.128 0-510.713-229.1-510.713-511.743s228.585-512.257 510.713-512.257 510.713 229.1 510.713 511.743-228.585 511.743-510.713 511.743zM1687.618 511.743c0 186.884-89.581 353.174-228.585 458.2v-916.4c139.005 105.026 228.585 271.316 228.585 458.2zM1720.052 807.256c66.928-79.799 107.085-182.765 107.085-294.998s-40.157-215.2-107.085-294.998v589.997zM107.085 807.256c-66.928-80.314-107.085-183.28-107.085-295.513s40.157-215.2 107.085-294.998v589.997zM363.986 969.943c-138.49-105.026-228.070-271.316-228.070-458.2s89.066-353.174 228.070-458.2v916.4z"
			],
			attrs: [
				{
				}
			],
			width: 1827,
			isMulticolor: false,
			isMulticolor2: false,
			grid: 0,
			tags: [
				"yakkertech"
			]
		},
		attrs: [
			{
			}
		],
		properties: {
			order: 2,
			id: 0,
			name: "yakkertech",
			prevSize: 32,
			code: 59681
		},
		setIdx: 0,
		setId: 5,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M128 128h768v86h-768v-86zM128 384v-86h768v86h-768zM128 554v-84h768v84h-768zM128 726v-86h768v86h-768zM128 896v-86h768v86h-768z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"format_align_justify"
			],
			grid: 24,
			defaultCode: 59648
		},
		attrs: [
		],
		properties: {
			id: 58,
			ligatures: "format_align_justify",
			name: "format_align_justify",
			order: 5,
			prevSize: 24,
			code: 59648
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M682 854v-172h172v172h-172zM682 598v-172h172v172h-172zM426 342v-172h172v172h-172zM682 170h172v172h-172v-172zM426 598v-172h172v172h-172zM170 598v-172h172v172h-172zM170 854v-172h172v172h-172zM426 854v-172h172v172h-172zM170 342v-172h172v172h-172z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"apps"
			],
			grid: 24,
			defaultCode: 59649
		},
		attrs: [
		],
		properties: {
			id: 59,
			ligatures: "apps",
			name: "apps",
			order: 6,
			prevSize: 24,
			code: 59649
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 1
	},
	{
		icon: {
			paths: [
				"M854 128q18 0 30 12t12 30v256q0 18-12 31t-30 13h-726q-18 0-30-13t-12-31v-256q0-18 12-30t30-12h726zM854 554q18 0 30 13t12 31v256q0 18-12 30t-30 12h-726q-18 0-30-12t-12-30v-256q0-18 12-31t30-13h726z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"view_agenda"
			],
			grid: 24,
			defaultCode: 59650
		},
		attrs: [
		],
		properties: {
			id: 60,
			ligatures: "view_agenda",
			name: "view_agenda",
			order: 7,
			prevSize: 24,
			code: 59650
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 2
	},
	{
		icon: {
			paths: [
				"M422 826l-298-58 16-86 210 42 68-346-78 30v146h-84v-200l222-94q6 0 17-2t17-2q42 0 72 42l42 68q58 102 184 102v86q-142 0-234-106l-26 128 90 84v320h-86v-256l-90-84zM576 234q-34 0-60-26t-26-60 26-59 60-25 59 25 25 59-25 60-59 26z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"running_man"
			],
			grid: 24,
			defaultCode: 59652
		},
		attrs: [
		],
		properties: {
			ligatures: "running_man",
			id: 61,
			order: 8,
			prevSize: 24,
			name: "running_man",
			code: 59652
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 3
	},
	{
		icon: {
			paths: [
				"M598 640v128h128l-214 214-214-214h128v-128h172zM982 512l-214 214v-128h-128v-172h128v-128zM384 426v172h-128v128l-214-214 214-214v128h128zM426 384v-128h-128l214-214 214 214h-128v128h-172z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"open_with"
			],
			grid: 24,
			defaultCode: 59648
		},
		attrs: [
		],
		properties: {
			ligatures: "open_with",
			id: 62,
			order: 9,
			prevSize: 24,
			name: "open_with",
			code: 59651
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 4
	},
	{
		icon: {
			paths: [
				"M768 704h-101.49l-160-160 160-160h101.49v160l224-224-224-224v160h-128c-16.974 0-33.252 6.744-45.254 18.746l-178.746 178.744-178.746-178.746c-12-12-28.28-18.744-45.254-18.744h-192v128h165.49l160 160-160 160h-165.49v128h192c16.974 0 33.252-6.742 45.254-18.746l178.746-178.744 178.746 178.744c12.002 12.004 28.28 18.746 45.254 18.746h128v160l224-224-224-224v160z"
			],
			attrs: [
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"shuffle",
				"random",
				"player"
			],
			grid: 16
		},
		attrs: [
			{
			}
		],
		properties: {
			order: 10,
			id: 63,
			name: "shuffle",
			prevSize: 32,
			code: 59653
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 5
	},
	{
		icon: {
			paths: [
				"M128 320h640v192l256-256-256-256v192h-768v384h128zM896 704h-640v-192l-256 256 256 256v-192h768v-384h-128z"
			],
			attrs: [
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"loop",
				"repeat"
			],
			grid: 16
		},
		attrs: [
			{
			}
		],
		properties: {
			order: 11,
			id: 64,
			name: "loop1",
			prevSize: 32,
			code: 59654
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 6
	},
	{
		icon: {
			paths: [
				"M1023.556 343.672v-229.726c0-62.708-51.016-113.726-113.726-113.726h-796.104c-62.71 0-113.726 51.018-113.726 113.726v796.106c0 62.708 51.016 113.726 113.726 113.726h796.106c62.708 0 113.726-51.016 113.726-113.726v-556.084c0.29-1.674 0.442-3.394 0.442-5.15s-0.154-3.474-0.444-5.148zM696.87 60.19h212.964c29.642 0 53.758 24.116 53.758 53.758v204.892h-266.72v-258.648zM310.67 963.812h-196.946c-29.644 0-53.758-24.116-53.758-53.758v-205.018h250.704v258.774zM310.67 645.070h-250.704v-266.262h250.704v266.262zM310.672 318.838h-250.706v-204.892c0-29.642 24.114-53.758 53.758-53.758h196.948v258.648zM636.902 963.812h-266.264v-258.774h266.264v258.774zM636.902 645.070h-266.264v-266.262h266.264v266.262zM636.902 318.838h-266.264v-258.648h266.264v258.648zM963.59 910.054c0 29.642-24.116 53.758-53.758 53.758h-212.964v-258.774h266.72v205.018zM963.59 645.070h-266.72v-266.262h266.72v266.262z"
			],
			attrs: [
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"grid"
			],
			grid: 16,
			defaultCode: 59672
		},
		attrs: [
			{
			}
		],
		properties: {
			order: 12,
			id: 65,
			name: "grid",
			prevSize: 32,
			code: 59672
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 7
	},
	{
		icon: {
			paths: [
				"M926.89 779.781c22.217 22.217 58.239 22.217 80.45 0s22.217-58.239 0-80.45l-455.114-455.114c-22.217-22.217-58.239-22.217-80.45 0l-455.114 455.114c-22.217 22.217-22.217 58.239 0 80.45s58.239 22.217 80.45 0l414.883-414.883 414.883 414.883z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"chevron-up"
			],
			grid: 16,
			defaultCode: 59669
		},
		attrs: [
		],
		properties: {
			order: 13,
			id: 66,
			name: "chevron-up",
			prevSize: 32,
			code: 59669
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 8
	},
	{
		icon: {
			paths: [
				"M97.115 244.218c-22.217-22.217-58.237-22.217-80.453 0s-22.217 58.237 0 80.453l455.111 455.111c22.217 22.217 58.237 22.217 80.453 0l455.111-455.111c22.217-22.217 22.217-58.237 0-80.453s-58.237-22.217-80.453 0l-414.885 414.885-414.885-414.885z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"chevron-down"
			],
			grid: 16,
			defaultCode: 59670
		},
		attrs: [
		],
		properties: {
			order: 14,
			id: 67,
			name: "chevron-down",
			prevSize: 32,
			code: 59670
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 9
	},
	{
		icon: {
			paths: [
				"M362.666 128v369.15l426.666-369.15v768l-426.71-369.235 0.042 369.235h-127.998v-768h127.998z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"back"
			],
			grid: 16,
			defaultCode: 59649
		},
		attrs: [
		],
		properties: {
			order: 15,
			id: 68,
			name: "step-backward2",
			prevSize: 32,
			code: 59655
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 10
	},
	{
		icon: {
			paths: [
				"M401.631 75.38l-94.566 94.566-165.516-165.516-141.869 141.869 165.516 165.516-94.578 94.578 331.027 0.002z",
				"M614.587 948.004l94.566-94.566 165.516 165.516 141.869-141.869-165.516-165.516 94.578-94.578-331.027-0.002z",
				"M945.599 401.644l-94.566-94.566 165.516-165.516-141.869-141.869-165.516 165.516-94.578-94.578-0.002 331.027z",
				"M70.619 621.742l94.566 94.566-165.516 165.516 141.869 141.869 165.516-165.516 94.578 94.578 0.002-331.027z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"condense"
			],
			grid: 16,
			defaultCode: 59650
		},
		attrs: [
		],
		properties: {
			order: 16,
			id: 69,
			name: "shrink",
			prevSize: 32,
			code: 59656
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 11
	},
	{
		icon: {
			paths: [
				"M938.667 341.334c23.552 0 42.667 21.845 42.667 48.762v633.905h-170.667v-633.905c0-26.917 19.115-48.762 42.667-48.762h85.333zM682.667 554.668c23.552 0 42.667 21.026 42.667 46.933v422.4h-170.667v-422.4c0-25.907 19.115-46.933 42.667-46.933h85.333zM426.667 426.668c23.552 0 42.667 22.3 42.667 49.778v547.556h-170.667v-547.556c0-27.477 19.115-49.778 42.667-49.778h85.333zM170.667 640.001c23.552 0 42.667 21.504 42.667 48v336h-170.667v-336c0-26.496 19.115-48 42.667-48h85.333zM896 0.001c47.128 0 85.333 38.205 85.333 85.333s-38.205 85.333-85.333 85.333c-10.346 0-20.262-1.841-29.438-5.214l-142.456 118.712c0.807 4.713 1.227 9.559 1.227 14.502 0 47.128-38.205 85.333-85.333 85.333s-85.333-38.205-85.333-85.333l0.171 5.12-123.846-61.88c-11.814 7.808-25.683 12.757-40.623 13.859l-6.369 0.234c-13.573 0-26.406-3.169-37.799-8.807l-133.081 88.636 0.213 5.504c0 44.986-34.811 81.842-78.965 85.099l-6.369 0.234c-47.128 0-85.333-38.205-85.333-85.333s38.205-85.333 85.333-85.333c13.573 0 26.406 3.169 37.799 8.807l133.038-88.722-0.171-5.419c0-44.986 34.811-81.842 78.965-85.099l6.369-0.234c47.128 0 85.333 38.205 85.333 85.333l-0.213-5.163 123.889 61.922c11.814-7.808 25.683-12.757 40.623-13.859l6.369-0.234c10.362 0 20.292 1.847 29.48 5.229l142.414-118.727c-0.807-4.713-1.227-9.559-1.227-14.502 0-47.128 38.205-85.333 85.333-85.333z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"data"
			],
			grid: 16,
			defaultCode: 59651
		},
		attrs: [
		],
		properties: {
			order: 17,
			id: 70,
			name: "stats",
			prevSize: 32,
			code: 59657
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 12
	},
	{
		icon: {
			paths: [
				"M64 896h896v128h-896v-128zM128 512h768l-384 384-384-384zM384 512v-512h256v512h-256z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"download"
			],
			grid: 16,
			defaultCode: 59653
		},
		attrs: [
		],
		properties: {
			order: 18,
			id: 71,
			name: "download",
			prevSize: 32,
			code: 59658
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 13
	},
	{
		icon: {
			paths: [
				"M742.763 589.351l178.968 178.968 102.253-102.253 0.016 357.921-357.933-0.003 102.266-102.266-178.968-178.968 153.399-153.399zM281.25 589.364l153.399 153.399-178.968 178.968 102.253 102.253-357.921 0.016 0.003-357.933 102.266 102.266 178.968-178.968zM357.934 0.017l-102.266 102.266 178.968 178.968-153.399 153.399-178.968-178.968-102.253 102.253-0.016-357.921 357.934 0.003zM1023.986 0.001l-0.003 357.933-102.266-102.266-178.968 178.968-153.399-153.399 178.968-178.968-102.253-102.253 357.921-0.016z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"expand"
			],
			grid: 16,
			defaultCode: 59654
		},
		attrs: [
		],
		properties: {
			order: 19,
			id: 72,
			name: "enlarge",
			prevSize: 32,
			code: 59659
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 14
	},
	{
		icon: {
			paths: [
				"M512 165.818l400.841 346.182-400.841 346.182v-317.322l-400.841 317.322v-692.364l400.841 317.322v-317.322z"
			],
			width: 1024,
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"fast-forward"
			],
			grid: 16,
			defaultCode: 59655
		},
		attrs: [
		],
		properties: {
			order: 20,
			id: 73,
			name: "forward",
			prevSize: 32,
			code: 59660
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 15
	},
	{
		icon: {
			paths: [
				"M1024 57.297h-1024l393.967 452.415 0.004 456.992 236.062-152.896-0.076-304.060 394.042-452.452zM161.919 130.999h700.161l-305.786 351.112 0.034 291.626-88.656 57.422-0.003-349.086-305.749-351.076z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"filter-hollow"
			],
			grid: 16,
			defaultCode: 59656
		},
		attrs: [
		],
		properties: {
			order: 21,
			id: 74,
			name: "filter-hollow",
			prevSize: 32,
			code: 59661
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 16
	},
	{
		icon: {
			paths: [
				"M1024 57.296h-1024l393.967 452.415 0.004 456.992 236.062-152.896-0.076-304.060z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"filter-solid"
			],
			grid: 16,
			defaultCode: 59657
		},
		attrs: [
		],
		properties: {
			order: 22,
			id: 75,
			name: "filter-solid",
			prevSize: 32,
			code: 59662
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 17
	},
	{
		icon: {
			paths: [
				"M224.742 281.6l100.686 90.044-12.759 16.539c-30.855 40.427-47.327 88.206-47.094 138.511 0.232 15.85 1.856 31.239 5.104 46.17 0.232 1.378 0.696 2.297 0.928 3.215 0.464 1.148 0.928 2.297 1.16 3.675 3.711 15.161 7.656 26.646 12.063 36.753 0.232 0.689 0.696 1.378 1.16 2.067 0.464 0.919 1.16 2.067 1.624 3.215 6.263 13.093 12.528 24.349 19.487 34.226 0.464 0.919 1.16 1.378 1.624 2.067 0.696 0.689 1.392 1.608 1.856 2.297 8.352 11.255 16.704 21.132 25.751 29.861 0.928 0.689 1.856 1.608 3.016 2.526v0l2.552 2.067c9.511 8.729 19.024 16.309 28.999 22.97 2.087 1.378 4.408 2.526 6.496 3.905v0l3.248 1.837c9.744 5.743 19.487 10.796 29.231 15.161 4.872 2.067 9.976 3.905 15.080 5.743 9.28 3.215 18.328 5.973 27.375 8.040 6.496 1.378 13.224 2.756 19.952 3.675 1.856 0.459 3.711 0.459 5.568 0.689v0l-0.696-145.402 239.649 205.814-238.721 206.733-0.232-133.228c-6.032-0.689-12.063-1.148-18.328-2.067-6.496-0.689-13.224-1.608-19.72-2.756-4.176-0.689-8.352-1.608-12.296-2.526-9.976-2.067-18.791-4.364-27.375-6.662v0l-5.568-1.608c-159.148-47.549-266.328-187.438-266.562-348-0.231-82.693 27.608-160.792 80.503-225.798v0l16.239-19.754zM546.109-0l0.232 133.228c6.037 0.459 12.305 1.148 18.342 2.067 6.733 0.689 13.234 1.608 19.735 2.756 4.179 0.919 8.359 1.608 12.305 2.526 9.984 2.067 18.806 4.364 27.397 6.662v0l5.572 1.608c159.041 47.549 266.308 187.438 266.308 348 0.231 82.693-27.631 160.563-80.566 225.798v0l-16.252 19.754-100.765-90.044 12.77-16.539c31.111-40.427 47.364-88.435 47.132-138.511 0-15.85-1.625-31.469-4.876-46.4-0.232-1.378-0.696-2.297-0.929-3.215-0.464-1.148-0.929-2.526-1.161-3.675-3.714-14.701-7.43-26.416-12.073-36.753-0.232-0.919-0.696-1.837-1.161-2.526-0.464-0.919-0.929-1.837-1.393-2.756-6.268-13.322-12.77-24.579-19.502-34.226-0.696-0.919-1.161-1.608-1.858-2.297v0l-1.625-1.837c-7.894-11.026-16.485-20.903-25.772-30.091-0.929-0.689-1.858-1.608-3.018-2.526v0l-2.554-2.067c-9.519-8.729-19.039-16.309-29.022-22.97v0l-6.966-4.134-2.786-1.608c-9.519-5.743-19.271-10.796-29.255-15.161-4.876-2.067-9.984-3.905-15.092-5.743-8.822-3.215-17.877-5.743-27.397-8.040-6.501-1.378-13.234-2.756-19.967-3.675-1.625-0.459-3.483-0.459-5.341-0.689v0l0.464 145.631-239.838-205.814 238.909-206.733z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"loop"
			],
			grid: 16,
			defaultCode: 59658
		},
		attrs: [
		],
		properties: {
			order: 23,
			id: 76,
			name: "loop",
			prevSize: 32,
			code: 59663
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 18
	},
	{
		icon: {
			paths: [
				"M-0 64h170.666v128h-170.666v-128z",
				"M298.667 64h725.333v128h-725.332v-128z",
				"M-0 320h170.666v128h-170.666v-128z",
				"M298.667 320h725.333v128h-725.332v-128z",
				"M-0 576h170.666v128h-170.666v-128z",
				"M298.667 576h725.333v128h-725.332v-128z",
				"M-0 832h170.666v128h-170.666v-128z",
				"M298.667 832h725.333v128h-725.332v-128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"menu"
			],
			grid: 16,
			defaultCode: 59659
		},
		attrs: [
		],
		properties: {
			order: 24,
			id: 77,
			name: "list2",
			prevSize: 32,
			code: 59664
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 19
	},
	{
		icon: {
			paths: [
				"M84.48 512l422.397-464.636v929.272z",
				"M0 343.041h295.677v337.917h-295.677v-337.917z",
				"M725.321 332.792l298.679 298.679-59.736 59.736-298.679-298.679 59.736-59.736z",
				"M665.585 631.471l298.679-298.679 59.736 59.736-298.679 298.679-59.736-59.736z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"mute"
			],
			grid: 16,
			defaultCode: 59660
		},
		attrs: [
		],
		properties: {
			order: 25,
			id: 78,
			name: "mute",
			prevSize: 32,
			code: 59665
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 20
	},
	{
		icon: {
			paths: [
				"M472.614 0v78.77h-315.076c-41.525 0-75.546 32.132-78.553 72.891l-0.215 5.878v708.923c0 41.525 32.132 75.546 72.891 78.553l5.878 0.215h708.923c41.525 0 75.546-32.132 78.553-72.891l0.215-5.878v-315.076h78.77v315.076c0 87.006-70.532 157.538-157.538 157.538h-708.923c-87.006 0-157.538-70.532-157.538-157.538v-708.923c0-87.006 70.532-157.538 157.538-157.538h315.076z",
				"M1008.505 443.608l-158.35-158.35-359.248 359.231-111.396-111.396 359.276-359.259-148.018-147.963 431.662-13.925-13.925 431.662z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"open-menu"
			],
			grid: 16,
			defaultCode: 59661
		},
		attrs: [
		],
		properties: {
			order: 26,
			id: 79,
			name: "open-menu",
			prevSize: 32,
			code: 59666
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 21
	},
	{
		icon: {
			paths: [
				"M855.578 512l-687.159 384v-768z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"play"
			],
			grid: 16,
			defaultCode: 59662
		},
		attrs: [
		],
		properties: {
			order: 27,
			id: 80,
			name: "play",
			prevSize: 32,
			code: 59667
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 22
	},
	{
		icon: {
			paths: [
				"M850.748 1024.001c79.975 0 144.808-53.937 144.808-120.471v-783.059c0-66.534-64.833-120.471-144.808-120.471h-506.828c-79.975 0-144.808 53.937-144.808 120.471l0.057 220.863h113.778l-0.057-227.556h568.889v796.444h-568.889l0.057-227.556h-113.778l-0.057 220.863c0 66.534 64.833 120.471 144.808 120.471h506.828zM426.667 739.557l341.333-227.556-341.333-227.556-0.057 170.667h-398.165v113.778h398.165l0.057 170.667z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"send-to-phone"
			],
			grid: 16,
			defaultCode: 59663
		},
		attrs: [
		],
		properties: {
			order: 28,
			id: 81,
			name: "send-to-phone",
			prevSize: 32,
			code: 59668
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 23
	},
	{
		icon: {
			paths: [
				"M732.969 76.799c47.625 0 86.232 39.733 86.232 88.747v488.107c0 49.014-38.607 88.747-86.232 88.747h-646.737c-47.625 0-86.232-39.733-86.232-88.747v-488.107c0-49.014 38.607-88.747 86.232-88.747h646.737zM716.8 179.199h-614.4v460.8h614.4v-460.8z",
				"M937.768 281.599c47.625 0 86.232 39.733 86.232 88.747v488.107c0 49.014-38.607 88.747-86.232 88.747h-646.737c-47.625 0-86.232-39.733-86.232-88.747v-488.107c0-49.014 38.607-88.747 86.232-88.747h646.737zM921.6 383.999h-614.4v460.8h614.4v-460.8z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"share"
			],
			grid: 16,
			defaultCode: 59664
		},
		attrs: [
		],
		properties: {
			order: 29,
			id: 82,
			name: "share2",
			prevSize: 32,
			code: 59671
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 24
	},
	{
		icon: {
			paths: [
				"M489.74 934.957l-489.739-422.957 489.739-422.957v845.913zM623.305 934.957v-845.913h133.565v845.913h-133.565zM890.435 934.957v-845.913h133.565v845.913h-133.565z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"step-back"
			],
			grid: 16,
			defaultCode: 59665
		},
		attrs: [
		],
		properties: {
			order: 30,
			id: 83,
			name: "step-backward",
			prevSize: 32,
			code: 59673
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 25
	},
	{
		icon: {
			paths: [
				"M534.261 89.043l489.739 422.957-489.739 422.957v-845.913zM400.696 89.043v845.913h-133.565v-845.913h133.565zM133.566 89.043v845.913h-133.565v-845.913h133.565z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"step-forward"
			],
			grid: 16,
			defaultCode: 59666
		},
		attrs: [
		],
		properties: {
			order: 31,
			id: 84,
			name: "step-forward",
			prevSize: 32,
			code: 59674
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 26
	},
	{
		icon: {
			paths: [
				"M558.545 0l0.009 130.793c174.878 21.134 313.545 159.815 334.658 334.699l130.788-0.038v93.091l-130.793 0.009c-21.132 174.862-159.79 313.52-334.653 334.653l-0.009 130.793h-93.091l0.038-130.788c-174.9-21.115-313.59-159.805-334.705-334.705l-130.788 0.038v-93.091l130.793-0.009c21.134-174.878 159.815-313.545 334.699-334.658l-0.038-130.788h93.091zM558.559 201.244l-0.014 124.574h-93.091l0.033-124.581c-136.284 20.224-244.026 127.966-264.25 264.25l124.581-0.033v93.091l-124.574 0.014c20.242 136.262 127.975 243.982 264.243 264.204l-0.033-124.581h93.091l0.014 124.574c136.262-20.242 243.982-127.975 264.204-264.243l-124.581 0.033v-93.091l124.574-0.014c-20.24-136.247-127.95-243.957-264.197-264.197z"
			],
			attrs: [
				{
					strokeLinejoin: "miter",
					strokeLinecap: "butt",
					strokeMiterlimit: "4",
					strokeWidth: 46.54545454545455
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			colorPermutations: {
			},
			tags: [
				"target"
			],
			grid: 16,
			defaultCode: 59667
		},
		attrs: [
			{
				strokeLinejoin: "miter",
				strokeLinecap: "butt",
				strokeMiterlimit: "4",
				strokeWidth: 46.54545454545455
			}
		],
		properties: {
			order: 32,
			id: 85,
			name: "target",
			prevSize: 32,
			code: 59675
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 27
	},
	{
		icon: {
			paths: [
				"M1024 590.444l-512-397.426-512 397.428v-162.038l512-397.426 512 397.428zM896 576v384h-256v-256h-256v256h-256v-384l384-288z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"home",
				"house"
			],
			defaultCode: 59648,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "home, house",
			name: "home",
			order: 33,
			id: 86,
			prevSize: 32,
			code: 59676
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 28
	},
	{
		icon: {
			paths: [
				"M896 256v-128h-896v704c0 35.346 28.654 64 64 64h864c53.022 0 96-42.978 96-96v-544h-128zM832 832h-768v-640h768v640zM128 320h640v64h-640zM512 448h256v64h-256zM512 576h256v64h-256zM512 704h192v64h-192zM128 448h320v320h-320z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"newspaper",
				"news",
				"paper"
			],
			defaultCode: 59652,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "newspaper, news",
			name: "newspaper",
			order: 34,
			id: 87,
			prevSize: 32,
			code: 59677
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 29
	},
	{
		icon: {
			paths: [
				"M864 0h-768c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h768c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM832 896h-704v-768h704v768zM256 448h448v64h-448zM256 576h448v64h-448zM256 704h448v64h-448zM256 320h448v64h-448z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"file-text",
				"file",
				"document",
				"list",
				"paper"
			],
			defaultCode: 59682,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "file-text, file",
			name: "file-text",
			order: 35,
			id: 88,
			prevSize: 32,
			code: 59682
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 30
	},
	{
		icon: {
			paths: [
				"M864 0h-768c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h768c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM832 896h-704v-768h704v768zM256 576h448v64h-448zM256 704h448v64h-448zM320 288c0-53.019 42.981-96 96-96s96 42.981 96 96c0 53.019-42.981 96-96 96s-96-42.981-96-96zM480 384h-128c-52.8 0-96 28.8-96 64v64h320v-64c0-35.2-43.2-64-96-64z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"profile",
				"file",
				"document",
				"page",
				"user",
				"paper"
			],
			defaultCode: 59683,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "profile, file2",
			name: "profile",
			order: 36,
			id: 89,
			prevSize: 32,
			code: 59683
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 31
	},
	{
		icon: {
			paths: [
				"M917.806 357.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-368c-44.114 0-80 35.888-80 80v736c0 44.112 35.886 80 80 80h608c44.112 0 80-35.888 80-80v-496c0-14.332-4.372-39.35-42.194-90.924zM785.374 302.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-608c-8.672 0-16-7.328-16-16v-736c0-8.672 7.328-16 16-16 0 0 367.956-0.002 368 0v224c0 17.672 14.324 32 32 32h224v496z",
				"M602.924 42.196c-51.574-37.822-76.592-42.196-90.924-42.196h-368c-44.112 0-80 35.888-80 80v736c0 38.632 27.528 70.958 64 78.39v-814.39c0-8.672 7.328-16 16-16h486.876c-9.646-7.92-19.028-15.26-27.952-21.804z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"files-empty",
				"files",
				"documents",
				"papers",
				"pages"
			],
			defaultCode: 59685,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "files-empty, files",
			name: "files-empty",
			order: 37,
			id: 90,
			prevSize: 32,
			code: 59685
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 32
	},
	{
		icon: {
			paths: [
				"M640 256v-256h-448l-192 192v576h384v256h640v-768h-384zM192 90.51v101.49h-101.49l101.49-101.49zM64 704v-448h192v-192h320v192l-192 192v256h-320zM576 346.51v101.49h-101.49l101.49-101.49zM960 960h-512v-448h192v-192h320v640z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"copy",
				"duplicate",
				"files",
				"pages",
				"papers",
				"documents"
			],
			defaultCode: 59692,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "copy, duplicate",
			name: "copy",
			order: 38,
			id: 91,
			prevSize: 32,
			code: 59692
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 33
	},
	{
		icon: {
			paths: [
				"M448 128l128 128h448v704h-1024v-832z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"folder",
				"directory",
				"category",
				"browse"
			],
			defaultCode: 59695,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "folder, directory",
			name: "folder",
			order: 39,
			id: 92,
			prevSize: 32,
			code: 59695
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 34
	},
	{
		icon: {
			paths: [
				"M832 960l192-512h-832l-192 512zM128 384l-128 576v-832h288l128 128h416v128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"folder-open",
				"directory",
				"category",
				"browse"
			],
			defaultCode: 59696,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "folder-open, directory2",
			name: "folder-open",
			order: 40,
			id: 93,
			prevSize: 32,
			code: 59696
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 35
	},
	{
		icon: {
			paths: [
				"M320 384h128v128h-128zM512 384h128v128h-128zM704 384h128v128h-128zM128 768h128v128h-128zM320 768h128v128h-128zM512 768h128v128h-128zM320 576h128v128h-128zM512 576h128v128h-128zM704 576h128v128h-128zM128 576h128v128h-128zM832 0v64h-128v-64h-448v64h-128v-64h-128v1024h960v-1024h-128zM896 960h-832v-704h832v704z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"calendar",
				"date",
				"schedule",
				"time",
				"day"
			],
			defaultCode: 59731,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "calendar, date",
			name: "calendar",
			order: 41,
			id: 94,
			prevSize: 32,
			code: 59731
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 36
	},
	{
		icon: {
			paths: [
				"M576 706.612v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h896c0-128.968-166.898-235.64-384-253.388z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"user",
				"profile",
				"avatar",
				"person",
				"member"
			],
			defaultCode: 59761,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "user, profile2",
			name: "user",
			order: 42,
			id: 95,
			prevSize: 32,
			code: 59761
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 37
	},
	{
		icon: {
			paths: [
				"M384 736c0-151.234 95.874-280.486 230.032-330.2 16.28-36.538 25.968-77.164 25.968-117.8 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h397.306c-8.664-30.53-13.306-62.732-13.306-96z",
				"M736 448c-159.058 0-288 128.942-288 288s128.942 288 288 288c159.056 0 288-128.942 288-288s-128.942-288-288-288zM896 768h-128v128h-64v-128h-128v-64h128v-128h64v128h128v64z"
			],
			width: 1024,
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"user-plus",
				"user",
				"user-add",
				"profile",
				"avatar",
				"person",
				"member"
			],
			defaultCode: 59763,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "user-plus, user2",
			name: "user-plus",
			order: 43,
			id: 96,
			prevSize: 32,
			code: 59763
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 38
	},
	{
		icon: {
			paths: [
				"M64 0h384v64h-384zM576 0h384v64h-384zM952 320h-56v-256h-256v256h-256v-256h-256v256h-56c-39.6 0-72 32.4-72 72v560c0 39.6 32.4 72 72 72h304c39.6 0 72-32.4 72-72v-376h128v376c0 39.6 32.4 72 72 72h304c39.6 0 72-32.4 72-72v-560c0-39.6-32.4-72-72-72zM348 960h-248c-19.8 0-36-14.4-36-32s16.2-32 36-32h248c19.8 0 36 14.4 36 32s-16.2 32-36 32zM544 512h-64c-17.6 0-32-14.4-32-32s14.4-32 32-32h64c17.6 0 32 14.4 32 32s-14.4 32-32 32zM924 960h-248c-19.8 0-36-14.4-36-32s16.2-32 36-32h248c19.8 0 36 14.4 36 32s-16.2 32-36 32z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"binoculars",
				"lookup",
				"search",
				"find"
			],
			defaultCode: 59781,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "binoculars, lookup",
			name: "binoculars",
			order: 44,
			id: 97,
			prevSize: 32,
			code: 59781
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 39
	},
	{
		icon: {
			paths: [
				"M64 192h896v192h-896zM64 448h896v192h-896zM64 704h896v192h-896z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"menu",
				"list",
				"options",
				"lines",
				"hamburger"
			],
			defaultCode: 59837,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "menu, list3",
			name: "menu",
			order: 45,
			id: 98,
			prevSize: 32,
			code: 59837
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 40
	},
	{
		icon: {
			paths: [
				"M1024 397.050l-353.78-51.408-158.22-320.582-158.216 320.582-353.784 51.408 256 249.538-60.432 352.352 316.432-166.358 316.432 166.358-60.434-352.352 256.002-249.538z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"star-full",
				"rate",
				"star",
				"favorite",
				"bookmark"
			],
			defaultCode: 59865,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "star-full, rate3",
			name: "star-full",
			order: 46,
			id: 99,
			prevSize: 32,
			code: 59865
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 41
	},
	{
		icon: {
			paths: [
				"M794.317 329.694c0-56.525-45.841-102.4-102.4-102.4h-589.517c-56.559 0-102.4 45.875-102.4 102.4 0 95.744 0 268.868 0 364.612 0 56.525 45.841 102.4 102.4 102.4h589.517c56.559 0 102.4-45.875 102.4-102.4 0-95.744 0-268.868 0-364.612zM828.45 329.011l111.753-26.112c20.275-4.745 41.643 0.034 57.958 13.005 16.316 12.937 25.839 32.631 25.839 53.487v283.682c0 20.821-9.523 40.516-25.839 53.487-16.316 12.937-37.683 17.715-57.958 12.971l-111.753-26.112v-364.407z"
			],
			attrs: [
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"video-camera",
				"video",
				"media",
				"film",
				"movie"
			],
			defaultCode: 59668,
			grid: 16
		},
		attrs: [
			{
			}
		],
		properties: {
			ligatures: "video-camera, video3",
			name: "video-camera",
			order: 47,
			id: 100,
			prevSize: 32,
			code: 59678
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 42
	},
	{
		icon: {
			paths: [
				"M768 640v-128h-320v-128h320v-128l192 192zM704 576v256h-320v192l-384-192v-832h704v320h-64v-256h-512l256 128v576h256v-192z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"exit",
				"signout",
				"logout",
				"quit",
				"close"
			],
			defaultCode: 59924,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "exit, signout",
			name: "exit",
			order: 48,
			id: 101,
			prevSize: 32,
			code: 59924
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 43
	},
	{
		icon: {
			paths: [
				"M128 128h320v768h-320zM576 128h320v768h-320z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"pause",
				"player"
			],
			defaultCode: 59933,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "pause2, player9",
			name: "pause",
			order: 49,
			id: 102,
			prevSize: 32,
			code: 59933
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 44
	},
	{
		icon: {
			paths: [
				"M128 896v-768h128v352l320-320v320l320-320v704l-320-320v320l-320-320v352z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"first",
				"player"
			],
			defaultCode: 59937,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "first, player13",
			name: "previous",
			order: 50,
			id: 103,
			prevSize: 32,
			code: 59937
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 45
	},
	{
		icon: {
			paths: [
				"M896 128v768h-128v-352l-320 320v-320l-320 320v-704l320 320v-320l320 320v-352z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"last",
				"player"
			],
			defaultCode: 59938,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "last, player14",
			name: "next",
			order: 51,
			id: 104,
			prevSize: 32,
			code: 59938
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 46
	},
	{
		icon: {
			paths: [
				"M864 704c-45.16 0-85.92 18.738-115.012 48.83l-431.004-215.502c1.314-8.252 2.016-16.706 2.016-25.328s-0.702-17.076-2.016-25.326l431.004-215.502c29.092 30.090 69.852 48.828 115.012 48.828 88.366 0 160-71.634 160-160s-71.634-160-160-160-160 71.634-160 160c0 8.622 0.704 17.076 2.016 25.326l-431.004 215.504c-29.092-30.090-69.852-48.83-115.012-48.83-88.366 0-160 71.636-160 160 0 88.368 71.634 160 160 160 45.16 0 85.92-18.738 115.012-48.828l431.004 215.502c-1.312 8.25-2.016 16.704-2.016 25.326 0 88.368 71.634 160 160 160s160-71.632 160-160c0-88.364-71.634-160-160-160z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"share",
				"social"
			],
			defaultCode: 60034,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "share2, social",
			name: "share",
			order: 52,
			id: 105,
			prevSize: 32,
			code: 60034
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 47
	},
	{
		icon: {
			paths: [
				"M440.236 635.766c-13.31 0-26.616-5.076-36.77-15.23-95.134-95.136-95.134-249.934 0-345.070l192-192c46.088-46.086 107.36-71.466 172.534-71.466s126.448 25.38 172.536 71.464c95.132 95.136 95.132 249.934 0 345.070l-87.766 87.766c-20.308 20.308-53.23 20.308-73.54 0-20.306-20.306-20.306-53.232 0-73.54l87.766-87.766c54.584-54.586 54.584-143.404 0-197.99-26.442-26.442-61.6-41.004-98.996-41.004s-72.552 14.562-98.996 41.006l-192 191.998c-54.586 54.586-54.586 143.406 0 197.992 20.308 20.306 20.306 53.232 0 73.54-10.15 10.152-23.462 15.23-36.768 15.23z",
				"M256 1012c-65.176 0-126.45-25.38-172.534-71.464-95.134-95.136-95.134-249.934 0-345.070l87.764-87.764c20.308-20.306 53.234-20.306 73.54 0 20.308 20.306 20.308 53.232 0 73.54l-87.764 87.764c-54.586 54.586-54.586 143.406 0 197.992 26.44 26.44 61.598 41.002 98.994 41.002s72.552-14.562 98.998-41.006l192-191.998c54.584-54.586 54.584-143.406 0-197.992-20.308-20.308-20.306-53.232 0-73.54 20.306-20.306 53.232-20.306 73.54 0.002 95.132 95.134 95.132 249.932 0.002 345.068l-192.002 192c-46.090 46.088-107.364 71.466-172.538 71.466z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"link",
				"chain",
				"url",
				"uri",
				"anchor"
			],
			defaultCode: 59851,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "link, chain",
			name: "link",
			order: 53,
			id: 106,
			prevSize: 32,
			code: 59851
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 48
	},
	{
		icon: {
			paths: [
				"M864 0c88.364 0 160 71.634 160 160 0 36.020-11.91 69.258-32 96l-64 64-224-224 64-64c26.742-20.090 59.978-32 96-32zM64 736l-64 288 288-64 592-592-224-224-592 592zM715.578 363.578l-448 448-55.156-55.156 448-448 55.156 55.156z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"pencil",
				"write",
				"edit"
			],
			defaultCode: 59671,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "pencil, write",
			name: "pencil",
			order: 54,
			id: 107,
			prevSize: 32,
			code: 59679
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 49
	},
	{
		icon: {
			paths: [
				"M665.832 327.048l-64.952-64.922-324.81 324.742c-53.814 53.792-53.814 141.048 0 194.844 53.804 53.792 141.060 53.792 194.874 0l389.772-389.708c89.714-89.662 89.714-235.062 0-324.726-89.666-89.704-235.112-89.704-324.782 0l-409.23 409.178c-0.29 0.304-0.612 0.576-0.876 0.846-125.102 125.096-125.102 327.856 0 452.906 125.054 125.056 327.868 125.056 452.988 0 0.274-0.274 0.516-0.568 0.82-0.876l0.032 0.034 279.332-279.292-64.986-64.92-279.33 279.262c-0.296 0.268-0.564 0.57-0.846 0.844-89.074 89.058-233.98 89.058-323.076 0-89.062-89.042-89.062-233.922 0-322.978 0.304-0.304 0.604-0.582 0.888-0.846l-0.046-0.060 409.28-409.166c53.712-53.738 141.144-53.738 194.886 0 53.712 53.734 53.712 141.148 0 194.84l-389.772 389.7c-17.936 17.922-47.054 17.922-64.972 0-17.894-17.886-17.894-47.032 0-64.92l324.806-324.782z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"attachment",
				"paperclip"
			],
			defaultCode: 59853,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "attachment, paperclip",
			name: "attachment",
			order: 55,
			id: 108,
			prevSize: 32,
			code: 59853
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 50
	},
	{
		icon: {
			paths: [
				"M992 384h-352v-352c0-17.672-14.328-32-32-32h-192c-17.672 0-32 14.328-32 32v352h-352c-17.672 0-32 14.328-32 32v192c0 17.672 14.328 32 32 32h352v352c0 17.672 14.328 32 32 32h192c17.672 0 32-14.328 32-32v-352h352c17.672 0 32-14.328 32-32v-192c0-17.672-14.328-32-32-32z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"plus",
				"add",
				"sum"
			],
			defaultCode: 59914,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "plus, add",
			name: "plus",
			order: 56,
			id: 109,
			prevSize: 32,
			code: 59914
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 51
	},
	{
		icon: {
			paths: [
				"M0 416v192c0 17.672 14.328 32 32 32h960c17.672 0 32-14.328 32-32v-192c0-17.672-14.328-32-32-32h-960c-17.672 0-32 14.328-32 32z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"minus",
				"subtract",
				"minimize",
				"line"
			],
			defaultCode: 59915,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "minus, subtract",
			name: "minus",
			order: 57,
			id: 110,
			prevSize: 32,
			code: 59915
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 52
	},
	{
		icon: {
			paths: [
				"M1014.662 822.66c-0.004-0.004-0.008-0.008-0.012-0.010l-310.644-310.65 310.644-310.65c0.004-0.004 0.008-0.006 0.012-0.010 3.344-3.346 5.762-7.254 7.312-11.416 4.246-11.376 1.824-24.682-7.324-33.83l-146.746-146.746c-9.148-9.146-22.45-11.566-33.828-7.32-4.16 1.55-8.070 3.968-11.418 7.31 0 0.004-0.004 0.006-0.008 0.010l-310.648 310.652-310.648-310.65c-0.004-0.004-0.006-0.006-0.010-0.010-3.346-3.342-7.254-5.76-11.414-7.31-11.38-4.248-24.682-1.826-33.83 7.32l-146.748 146.748c-9.148 9.148-11.568 22.452-7.322 33.828 1.552 4.16 3.97 8.072 7.312 11.416 0.004 0.002 0.006 0.006 0.010 0.010l310.65 310.648-310.65 310.652c-0.002 0.004-0.006 0.006-0.008 0.010-3.342 3.346-5.76 7.254-7.314 11.414-4.248 11.376-1.826 24.682 7.322 33.83l146.748 146.746c9.15 9.148 22.452 11.568 33.83 7.322 4.16-1.552 8.070-3.97 11.416-7.312 0.002-0.004 0.006-0.006 0.010-0.010l310.648-310.65 310.648 310.65c0.004 0.002 0.008 0.006 0.012 0.008 3.348 3.344 7.254 5.762 11.414 7.314 11.378 4.246 24.684 1.826 33.828-7.322l146.746-146.748c9.148-9.148 11.57-22.454 7.324-33.83-1.552-4.16-3.97-8.068-7.314-11.414z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cross",
				"cancel",
				"close",
				"quit",
				"remove"
			],
			defaultCode: 59919,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "cross, cancel",
			name: "cross",
			order: 58,
			id: 111,
			prevSize: 32,
			code: 59919
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 53
	},
	{
		icon: {
			paths: [
				"M0 0h128v1024h-128v-1024z",
				"M832 643.002c82.624 0 154.57-19.984 192-49.5v-512c-37.43 29.518-109.376 49.502-192 49.502s-154.57-19.984-192-49.502v512c37.43 29.516 109.376 49.5 192 49.5z",
				"M608 32.528c-46.906-19.94-115.52-32.528-192-32.528-96.396 0-180.334 19.984-224 49.502v512c43.666-29.518 127.604-49.502 224-49.502 76.48 0 145.094 12.588 192 32.528v-512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"flag",
				"report",
				"mark"
			],
			defaultCode: 59852,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "flag, report",
			name: "flag",
			order: 59,
			id: 112,
			prevSize: 32,
			code: 59852
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 54
	},
	{
		icon: {
			paths: [
				"M321.008 1024c-68.246-142.008-31.902-223.378 20.55-300.044 57.44-83.956 72.244-167.066 72.244-167.066s45.154 58.7 27.092 150.508c79.772-88.8 94.824-230.28 82.782-284.464 180.314 126.012 257.376 398.856 153.522 601.066 552.372-312.532 137.398-780.172 65.154-832.85 24.082 52.676 28.648 141.85-20 185.126-82.352-312.276-285.972-376.276-285.972-376.276 24.082 161.044-87.296 337.144-194.696 468.73-3.774-64.216-7.782-108.528-41.55-169.98-7.58 116.656-96.732 211.748-120.874 328.628-32.702 158.286 24.496 274.18 241.748 396.622z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"fire",
				"flame",
				"hot",
				"popular"
			],
			defaultCode: 59817,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "fire, flame",
			name: "fire",
			order: 60,
			id: 113,
			prevSize: 32,
			code: 59817
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 55
	},
	{
		icon: {
			paths: [
				"M448 704h128v128h-128zM704 256c35.346 0 64 28.654 64 64v192l-192 128h-128v-64l192-128v-64h-320v-128h384zM512 96c-111.118 0-215.584 43.272-294.156 121.844s-121.844 183.038-121.844 294.156c0 111.118 43.272 215.584 121.844 294.156s183.038 121.844 294.156 121.844c111.118 0 215.584-43.272 294.156-121.844s121.844-183.038 121.844-294.156c0-111.118-43.272-215.584-121.844-294.156s-183.038-121.844-294.156-121.844zM512 0v0c282.77 0 512 229.23 512 512s-229.23 512-512 512c-282.77 0-512-229.23-512-512s229.23-512 512-512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"question",
				"help",
				"support"
			],
			defaultCode: 59913,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "question, help",
			name: "question",
			order: 61,
			id: 114,
			prevSize: 32,
			code: 59913
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 56
	},
	{
		icon: {
			paths: [
				"M448 304c0-26.4 21.6-48 48-48h32c26.4 0 48 21.6 48 48v32c0 26.4-21.6 48-48 48h-32c-26.4 0-48-21.6-48-48v-32z",
				"M640 768h-256v-64h64v-192h-64v-64h192v256h64z",
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"info",
				"information"
			],
			defaultCode: 59916,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "info, information",
			name: "info",
			order: 62,
			id: 115,
			prevSize: 32,
			code: 59916
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 57
	},
	{
		icon: {
			paths: [
				"M1088 128h-1024c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h1024c35.2 0 64-28.8 64-64v-640c0-35.2-28.8-64-64-64zM640 256h128v128h-128v-128zM832 448v128h-128v-128h128zM448 256h128v128h-128v-128zM640 448v128h-128v-128h128zM256 256h128v128h-128v-128zM448 448v128h-128v-128h128zM128 256h64v128h-64v-128zM128 448h128v128h-128v-128zM192 768h-64v-128h64v128zM768 768h-512v-128h512v128zM1024 768h-192v-128h192v128zM1024 576h-128v-128h128v128zM1024 384h-192v-128h192v128z"
			],
			width: 1152,
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"keyboard",
				"typing",
				"type"
			],
			defaultCode: 59733,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "keyboard, typing",
			name: "keyboard",
			order: 63,
			id: 116,
			prevSize: 32,
			code: 59733
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 58
	},
	{
		icon: {
			paths: [
				"M864 128l-480 480-224-224-160 160 384 384 640-640z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"checkmark",
				"tick",
				"correct",
				"accept",
				"ok"
			],
			defaultCode: 59920,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "checkmark, tick",
			name: "checkmark",
			order: 64,
			id: 117,
			prevSize: 32,
			code: 59920
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 59
	},
	{
		icon: {
			paths: [
				"M933.79 610.25c-53.726-93.054-21.416-212.304 72.152-266.488l-100.626-174.292c-28.75 16.854-62.176 26.518-97.846 26.518-107.536 0-194.708-87.746-194.708-195.99h-201.258c0.266 33.41-8.074 67.282-25.958 98.252-53.724 93.056-173.156 124.702-266.862 70.758l-100.624 174.292c28.97 16.472 54.050 40.588 71.886 71.478 53.638 92.908 21.512 211.92-71.708 266.224l100.626 174.292c28.65-16.696 61.916-26.254 97.4-26.254 107.196 0 194.144 87.192 194.7 194.958h201.254c-0.086-33.074 8.272-66.57 25.966-97.218 53.636-92.906 172.776-124.594 266.414-71.012l100.626-174.29c-28.78-16.466-53.692-40.498-71.434-71.228zM512 719.332c-114.508 0-207.336-92.824-207.336-207.334 0-114.508 92.826-207.334 207.336-207.334 114.508 0 207.332 92.826 207.332 207.334-0.002 114.51-92.824 207.334-207.332 207.334z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cog",
				"gear",
				"preferences",
				"settings",
				"generate",
				"control",
				"options"
			],
			defaultCode: 59796,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "cog, gear",
			name: "cog",
			order: 65,
			id: 118,
			prevSize: 32,
			code: 59796
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 60
	},
	{
		icon: {
			paths: [
				"M576 736l96 96 320-320-320-320-96 96 224 224z",
				"M448 288l-96-96-320 320 320 320 96-96-224-224z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"embed",
				"code",
				"html",
				"xml"
			],
			defaultCode: 60031,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "embed, code",
			name: "embed",
			order: 66,
			id: 119,
			prevSize: 32,
			code: 60031
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 61
	},
	{
		icon: {
			paths: [
				"M832 736l96 96 320-320-320-320-96 96 224 224z",
				"M448 288l-96-96-320 320 320 320 96-96-224-224z",
				"M701.298 150.519l69.468 18.944-191.987 704.026-69.468-18.944 191.987-704.026z"
			],
			width: 1280,
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"embed",
				"code",
				"html",
				"xml"
			],
			defaultCode: 60032,
			grid: 16
		},
		attrs: [
		],
		properties: {
			ligatures: "embed2, code2",
			name: "embed2",
			order: 67,
			id: 120,
			prevSize: 32,
			code: 60032
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 62
	},
	{
		icon: {
			paths: [
				"M192 1024h640l64-704h-768zM640 128v-128h-256v128h-320v192l64-64h768l64 64v-192h-320zM576 128h-128v-64h128v64z"
			],
			tags: [
				"bin",
				"trashcan",
				"remove",
				"delete",
				"recycle",
				"dispose"
			],
			defaultCode: 59821,
			grid: 16,
			attrs: [
			]
		},
		attrs: [
		],
		properties: {
			ligatures: "bin2, trashcan2",
			name: "bin2",
			order: 68,
			id: 121,
			prevSize: 32,
			code: 59821
		},
		setIdx: 1,
		setId: 2,
		iconIdx: 63
	},
	{
		icon: {
			paths: [
				"M786.286 512l78.857 77.143c10.857 10.286 14.857 25.714 11.429 40-4 14.286-15.429 25.714-29.714 29.143l-107.429 27.429 30.286 106.286c4 14.286 0 29.714-10.857 40-10.286 10.857-25.714 14.857-40 10.857l-106.286-30.286-27.429 107.429c-3.429 14.286-14.857 25.714-29.143 29.714-3.429 0.571-7.429 1.143-10.857 1.143-10.857 0-21.714-4.571-29.143-12.571l-77.143-78.857-77.143 78.857c-10.286 10.857-25.714 14.857-40 11.429-14.857-4-25.714-15.429-29.143-29.714l-27.429-107.429-106.286 30.286c-14.286 4-29.714 0-40-10.857-10.857-10.286-14.857-25.714-10.857-40l30.286-106.286-107.429-27.429c-14.286-3.429-25.714-14.857-29.714-29.143-3.429-14.286 0.571-29.714 11.429-40l78.857-77.143-78.857-77.143c-10.857-10.286-14.857-25.714-11.429-40 4-14.286 15.429-25.714 29.714-29.143l107.429-27.429-30.286-106.286c-4-14.286 0-29.714 10.857-40 10.286-10.857 25.714-14.857 40-10.857l106.286 30.286 27.429-107.429c3.429-14.286 14.857-25.714 29.143-29.143 14.286-4 29.714 0 40 10.857l77.143 79.429 77.143-79.429c10.286-10.857 25.143-14.857 40-10.857 14.286 3.429 25.714 14.857 29.143 29.143l27.429 107.429 106.286-30.286c14.286-4 29.714 0 40 10.857 10.857 10.286 14.857 25.714 10.857 40l-30.286 106.286 107.429 27.429c14.286 3.429 25.714 14.857 29.714 29.143 3.429 14.286-0.571 29.714-11.429 40z"
			],
			attrs: [
				{
				}
			],
			width: 878,
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"certificate"
			],
			grid: 14
		},
		attrs: [
			{
			}
		],
		properties: {
			order: 1,
			id: 0,
			prevSize: 28,
			code: 59649,
			name: "certificate"
		},
		setIdx: 0,
		setId: 8,
		iconIdx: 0
	}
];
var height$1 = 1024;
var metadata = {
	name: "icomoon"
};
var preferences = {
	showGlyphs: true,
	showQuickUse: true,
	showQuickUse2: true,
	showSVGs: true,
	fontPref: {
		prefix: "icon-",
		metadata: {
			fontFamily: "icomoon",
			majorVersion: 1,
			minorVersion: 0
		},
		metrics: {
			emSize: 1024,
			baseline: 6.25,
			whitespace: 50
		},
		embed: false,
		showMetadata: false
	},
	imagePref: {
		prefix: "icon-",
		png: true,
		useClassSelector: true,
		color: 0,
		bgColor: 16777215,
		classSelector: ".icon",
		name: "icomoon",
		height: 32,
		columns: 16,
		margin: 16
	},
	historySize: 50,
	showCodes: true,
	gridSize: 16
};
var iconSet = {
	IcoMoonType: IcoMoonType,
	icons: icons,
	height: height$1,
	metadata: metadata,
	preferences: preferences
};

var otherIcons = [
	{
		icon: {
			paths: [
				"M465.455 93.091c25.706 0 46.545 20.839 46.545 46.545 0 23.87-17.968 43.544-41.117 46.232l-5.428 0.313h-325.818c-23.87 0-43.544 17.968-46.232 41.117l-0.313 5.428v651.636c0 23.87 17.968 43.544 41.117 46.232l5.428 0.313h651.636c23.87 0 43.544-17.968 46.232-41.117l0.313-5.428v-320.171c0-25.706 20.839-46.545 46.545-46.545 23.87 0 43.544 17.968 46.232 41.117l0.313 5.428v320.171c0 74.365-58.132 135.152-131.432 139.399l-8.205 0.237h-651.636c-74.365 0-135.152-58.132-139.399-131.432l-0.237-8.205v-651.636c0-74.365 58.132-135.152 131.432-139.399l8.205-0.237h325.818zM781.633 42.552c56.737-56.737 148.725-56.737 205.462 0s56.737 148.725 0 205.462v0l-442.182 442.182c-5.965 5.965-13.439 10.197-21.624 12.243v0l-186.182 46.545c-34.089 8.522-64.967-22.356-56.445-56.445v0l46.545-186.182c2.046-8.184 6.278-15.658 12.243-21.624v0zM921.269 108.378c-20.382-20.382-53.429-20.382-73.811-0v0l-433.064 433.039-24.623 98.444 98.397-24.623 433.1-433.049c18.926-18.927 20.278-48.772 4.056-69.259v0z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-pencil"
			],
			grid: 16
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-pencil",
			prevSize: 32,
			code: 0
		},
		setIdx: 0,
		setId: 2,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M128 298.667h128v-128h85.333v128h128v85.333h-128v128h-85.333v-128h-128v-85.333zM554.667 640h341.333v85.333h-341.333v-85.333zM684.373 128h98.56l-443.307 768h-98.56l443.307-768z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-plus-minus"
			],
			grid: 24
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-plus-minus",
			prevSize: 32,
			code: 0
		},
		setIdx: 0,
		setId: 3,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M810.667 273.493l-60.16-60.16-238.507 238.507-238.507-238.507-60.16 60.16 238.507 238.507-238.507 238.507 60.16 60.16 238.507-238.507 238.507 238.507 60.16-60.16-238.507-238.507 238.507-238.507z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-cross"
			],
			grid: 24
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-cross",
			prevSize: 32,
			code: 0
		},
		setIdx: 0,
		setId: 4,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M44.522 89.043h1068.522v133.565h-1068.522zM44.522 445.217h1068.522v133.565h-1068.522zM44.522 801.391h1068.522v133.565h-1068.522z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-menu"
			],
			grid: 24
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-menu",
			prevSize: 32,
			code: 0
		},
		setIdx: 0,
		setId: 5,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M153.6 153.6h921.6v102.4h-921.6zM153.6 358.4h921.6v102.4h-921.6zM153.6 563.2h921.6v102.4h-921.6zM153.6 768h921.6v102.4h-921.6z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-move"
			],
			grid: 24
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-move",
			prevSize: 32,
			code: 0
		},
		setIdx: 0,
		setId: 7,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M365.714 585.143h1170.286v146.286h-1170.286zM365.714 292.571h1170.286v146.286h-1170.286zM365.714 0h1170.286v146.286h-1170.286zM365.714 877.714h1170.286v146.286h-1170.286z",
				"M0 585.143h219.429v146.286h-219.429zM0 292.571h219.429v146.286h-219.429zM0 0h219.429v146.286h-219.429zM0 877.714h219.429v146.286h-219.429z"
			],
			attrs: [
			],
			width: 1536,
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-affiliates"
			],
			grid: 0
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-affiliates",
			prevSize: 48,
			code: 0
		},
		setIdx: 0,
		setId: 8,
		iconIdx: 0
	},
	{
		icon: {
			paths: [
				"M843.992 147.741c2.91 6.827 5.578 15.36 8.003 25.6s3.638 19.261 3.638 27.063v162.377c0 7.802-1.698 16.335-5.093 25.6s-7.518 16.823-12.369 22.674l-62.572 80.457c-4.851 5.851-7.033 13.166-6.548 21.943s3.153 15.604 8.003 20.48l59.661 73.143c4.851 5.851 9.216 13.41 13.096 22.674s5.821 17.798 5.821 25.6v172.617c0 7.802-1.213 16.579-3.638 26.331s-5.093 18.042-8.003 24.869l-133.875 134.583c-6.791 3.901-15.279 6.827-25.465 8.777s-19.16 2.926-26.92 2.926h-630.083c-18.432 0-27.648-9.265-27.648-27.794v-968.411c0-7.802 2.668-14.385 8.003-19.749s11.884-8.046 19.645-8.046h630.083c7.761 0 16.734 1.219 26.92 3.657s18.675 5.12 25.465 8.046l133.875 134.583zM215.579 377.263h377.263v-161.684h-377.263v161.684zM215.579 754.526h377.263v-161.684h-377.263v161.684z",
				"M1318.278 754.526c19.394 0 29.091 9.697 29.091 29.091v211.292c0 19.394-9.697 29.091-29.091 29.091h-211.292c-19.394 0-29.091-9.697-29.091-29.091v-211.292c0-19.394 9.697-29.091 29.091-29.091h211.292z",
				"M2414.878 146.286c2.933 6.827 5.622 15.36 8.066 25.6s3.666 19.261 3.666 27.063v798.72c0 7.802-2.689 14.141-8.066 19.017s-11.977 7.314-19.798 7.314h-203.847c-7.821 0-22.976-2.438-27.864-7.314s-11.246-11.831-11.246-19.633v-263.314c0-7.802-2.348-19.408-7.726-24.284s-14.807-9.439-22.628-9.439l-257.57 0.616c-7.821 0-17.804 3.947-23.181 8.823s-12.263 17.098-12.263 24.9v263.314c0 7.802-3.061 14.141-7.95 19.017s-20.644 7.314-28.466 7.314h-203.847c-7.821 0-14.421-2.438-19.798-7.314s-8.066-11.215-8.066-19.017v-803.109c0.978-7.802 2.444-16.091 4.4-24.869s4.4-16.579 7.333-23.406l134.92-134.583c6.844-2.926 15.154-5.608 24.931-8.046s18.576-3.657 26.397-3.657h464.888c7.821 0 16.865 1.219 27.131 3.657s18.82 5.12 25.664 8.046l134.92 134.583zM2155.789 215.579h-323.368v269.474h323.368v-269.474z",
				"M2881.225 754.526c19.394 0 29.091 9.697 29.091 29.091v211.292c0 19.394-9.697 29.091-29.091 29.091h-211.292c-19.394 0-29.091-9.697-29.091-29.091v-211.292c0-19.394 9.697-29.091 29.091-29.091h211.292z",
				"M4390.278 754.526c19.394 0 29.091 9.697 29.091 29.091v211.292c0 19.394-9.697 29.091-29.091 29.091h-211.292c-19.394 0-29.091-9.697-29.091-29.091v-211.292c0-19.394 9.697-29.091 29.091-29.091h211.292z",
				"M3867.442 552.564c2.916 7.777 5.59 16.526 8.020 26.248s3.646 18.471 3.646 26.248v220.19c0 7.777-1.215 16.526-3.646 26.248s-5.104 17.985-8.020 24.79l-122.138 136.047c-6.805 3.889-15.311 6.805-25.519 8.749s-19.2 2.916-26.977 2.916h-539.208c-18.471 0-27.706-9.235-27.706-27.706v-159.765c0-7.777 2.673-14.339 8.020-19.686s11.909-8.020 19.686-8.020h357.262l73.126-1.020c7.777 0 14.339-2.43 19.686-7.291s8.020-11.18 8.020-18.957v-108.137c0-7.777-2.673-14.339-8.020-19.686s-11.909-8.020-19.686-8.020l-65.835-0.293h-195.401c-7.777 0-16.526-0.972-26.248-2.916s-17.985-4.375-24.79-7.291l-134.156-165.667c-3.889-7.777-6.805-16.526-8.749-26.248s-2.916-18.471-2.916-26.248v-220.19c0-7.777 0.972-16.526 2.916-26.248s4.861-17.985 8.749-24.79l134.156-134.156c6.805-2.916 15.068-5.59 24.79-8.020s18.471-3.646 26.248-3.646h530.789c7.777 0 14.339 2.673 19.686 8.020s8.020 11.909 8.020 19.686v159.415c0 7.777-2.673 14.339-8.020 19.686s-11.909 8.020-19.686 8.020h-433.045c-7.777 0-14.339 2.43-19.686 7.291s-8.020 11.18-8.020 18.957v162.38c0 7.777 2.673 14.339 8.020 19.686s11.909 8.020 19.686 8.020h272.311c7.777 0 16.769 0.972 26.977 2.916s18.714 4.375 25.519 7.291l122.138 111.195z",
				"M4911.537 215.579c-5.037 0-7.555 2.438-7.555 7.314v203.173c0 3.901 2.518 5.851 7.555 5.851h394.836c8.059 0 14.859 2.682 20.399 8.046s8.311 11.947 8.311 19.749v159.437c0 18.53-9.57 27.794-28.71 27.794h-394.836c-5.037 0-7.555 2.438-7.555 7.314v146.899c0 4.876 2.518 7.314 7.555 7.314h503.121c8.059 0 14.859 2.682 20.399 8.046s8.311 11.947 8.311 19.749v159.94c0 7.802-2.77 14.385-8.311 19.749s-12.34 8.046-20.399 8.046h-575.717c-8.059 0-17.125-0.975-27.199-2.926s-18.636-4.876-25.688-8.777l-139.018-134.583c-4.030-6.827-7.052-15.116-9.066-24.869s-3.022-18.53-3.022-26.331v-629.029c0-7.802 1.007-16.579 3.022-26.331s5.037-18.042 9.066-24.869l139.018-134.583c7.052-2.926 15.614-5.608 25.688-8.046s19.14-3.657 27.199-3.657h575.717c8.059 0 14.859 2.682 20.399 8.046s8.311 11.947 8.311 19.749v209.144c0 7.802-2.77-33.55-8.311-28.674s-12.34 7.314-20.399 7.314h-503.121z",
				"M5845.435 754.526c19.394 0 29.091 9.697 29.091 29.091v211.292c0 19.394-9.697 29.091-29.091 29.091h-211.292c-19.394 0-29.091-9.697-29.091-29.091v-211.292c0-19.394 9.697-29.091 29.091-29.091h211.292z"
			],
			attrs: [
			],
			width: 5875,
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"nyy-base"
			],
			grid: 0
		},
		attrs: [
		],
		properties: {
			order: 2,
			id: 0,
			name: "nyy-base",
			prevSize: 48,
			code: 0
		},
		setIdx: 0,
		setId: 9,
		iconIdx: 0
	},
	{
		attrs: [
		],
		icon: {
			attrs: [
			],
			grid: 24,
			isMulticolor: false,
			isMulticolor2: false,
			paths: [
				"M512 426q34 0 60 26t26 60-26 60-60 26-60-26-26-60 26-60 60-26zM768 426q34 0 60 26t26 60-26 60-60 26-60-26-26-60 26-60 60-26zM256 426q34 0 60 26t26 60-26 60-60 26-60-26-26-60 26-60 60-26z"
			],
			tags: [
				"nyy-info"
			]
		},
		iconIdx: 601,
		properties: {
			code: 59651,
			id: 601,
			ligatures: "nyy-info",
			name: "nyy-info",
			order: 5,
			prevSize: 24
		},
		setId: 2,
		setIdx: 0
	},
	{
		attrs: [
		],
		properties: {
			code: 59652,
			id: 602,
			ligatures: "nyy-circle",
			name: "nyy-circle",
			order: 5,
			prevSize: 32
		},
		icon: {
			paths: [
				"M512 938.667c235.639 0 426.667-191.027 426.667-426.667 0-235.642-191.027-426.667-426.667-426.667-235.642 0-426.667 191.025-426.667 426.667 0 235.639 191.025 426.667 426.667 426.667z"
			],
			attrs: [
				{
					fill: "none",
					strokeLinejoin: "round",
					strokeLinecap: "round",
					strokeMiterlimit: "4",
					strokeWidth: 24
				}
			],
			grid: 0,
			tags: [
				"circle(1)"
			]
		}
	}
];

// Additional icons added by hand to the Icomoon set
// To add any svg to this set, go to https://icomoon.io/app/#/select
// Click "Import Icons" and select the svg file. The icon should appear under "Untitled Set".
// Inspect that element and copy the path data from its <path> element "d" attr.
// Copy an element in the otherIcons.json array to create a new entry; copy the svg path into its "paths" property.
// Name the new icon something like "nyy-whatever" to differentiate it from the icomoon icons?
iconSet.icons = [...iconSet.icons, ...otherIcons];
const Icon = (_a) => {
    var { color = theme.fontColors.anakiwa, size = '2em' } = _a, rest = __rest(_a, ["color", "size"]);
    return (React.createElement(IcomoonReact, Object.assign({ className: "nyy-icon", iconSet: iconSet, color: color, size: size }, rest)));
};

const isNumber$2 = (...nums) => nums.every((n) => n !== undefined && n !== null && !isNaN(n));
const mean = (nums) => ((nums === null || nums === void 0 ? void 0 : nums.length) ? (nums.reduce((acc, x) => acc + x, 0) / nums.length) : 0);
const meanMap = (arr, key) => mean(arr === null || arr === void 0 ? void 0 : arr.map((x) => x[key]));
const inRange = (val, min, max) => Math.max(Math.min(val, max), min);

const ratio = (numerator, denominator) => {
    const hasInvalidArgs = !denominator || numerator === null;
    return hasInvalidArgs ? null : (numerator + 0.0) / denominator;
};
const percent = (decimal, precision = 0) => {
    const formattedNum = Number(decimal * 100).toLocaleString(undefined, {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
    });
    return `${formattedNum}%`;
};
// format(value, precision)
// format(value, isRateStat)
const format = (value, arg2) => {
    let formattedNum;
    if (isNumber$2(value)) {
        const isRateStat = arg2 === true;
        const precision = isRateStat ? 3 : (arg2 || 0);
        formattedNum = Number(value).toLocaleString(undefined, {
            minimumFractionDigits: precision,
            maximumFractionDigits: precision,
        });
        if (isRateStat) {
            formattedNum = formattedNum.replace('0.', '.');
        }
    }
    else {
        formattedNum = null;
    }
    if (formattedNum === '-0')
        formattedNum = '0'; // handle edge case of a rounded negative 0
    return formattedNum;
};
const ordinalRules = new Intl.PluralRules('en', { type: 'ordinal' });
const ordinal = (number, translate = null) => {
    let intUse = number;
    if (typeof number === 'string') {
        intUse = parseInt(number);
    }
    if (!isNumber$2(intUse))
        return null;
    if (translate) {
        return `${translate('format.number', { count: intUse, ordinal: true })}`;
    }
    const suffixId = ordinalRules.select(intUse);
    if (suffixId === 'one')
        return `${number}st`;
    if (suffixId === 'two')
        return `${number}nd`;
    if (suffixId === 'few')
        return `${number}rd`;
    return `${number}th`;
};
const plusMinus = (value, emptyValue = '') => {
    if (!isNumber$2(value))
        return emptyValue;
    if (value > 0)
        return `+${value}`;
    return value.toString();
};
const normalize = (stat, denom, adjdenom) => ratio(stat * adjdenom, denom);
const degreesToClock = (degrees) => {
    // Flip direction to counterclockwise, then shift so 3:00 is 0°
    // eslint-disable-next-line no-param-reassign
    degrees = ((360 - degrees + 90) % 360 + 360) % 360;
    const totalHours = degrees / 30;
    let hour = Math.floor(totalHours) % 12;
    hour = hour === 0 ? 12 : hour;
    let minutes = Math.round((totalHours - Math.floor(totalHours)) * 60);
    // Handle edge case where minutes == 60
    if (minutes === 60) {
        minutes = 0;
        hour = (hour % 12) + 1;
        if (hour === 13)
            hour = 1;
    }
    // Format with leading zero
    const hourStr = hour.toString().padStart(2, '0');
    const minutesStr = minutes.toString().padStart(2, '0');
    return `${hourStr}:${minutesStr}`;
};

const hits = (b1, b2, b3, hr) => (b1 + b2 + b3 + hr);
const walks = (ibb, ubb) => ibb + ubb;
const totalBases = (b1, b2, b3, hr) => b1 + (2 * b2) + (3 * b3) + (4 * hr);
const avg = (b1, b2, b3, hr, ab) => ratio(hits(b1, b2, b3, hr), ab);
const obp = (b1, b2, b3, hr, ibb, ubb, hbp, sf, ab) => {
    const onBase = hits(b1, b2, b3, hr) + walks(ibb, ubb) + hbp;
    const pa = ab + walks(ibb, ubb) + hbp + sf;
    return ratio(onBase, pa);
};
const slg = (b1, b2, b3, hr, ab) => ratio(totalBases(b1, b2, b3, hr), ab);
const ops = (b1, b2, b3, hr, ibb, ubb, hbp, sf, ab) => {
    const onBase = obp(b1, b2, b3, hr, ibb, ubb, hbp, sf, ab);
    const slugging = slg(b1, b2, b3, hr, ab);
    return onBase === null || slugging === null ? null : onBase + slugging;
};
const opsRV = (rv, pa) => {
    if (pa <= 0)
        return null;
    return 0.7592 + (3.284 * rv / pa);
};
const wOBA = (b1, b2, b3, hr, roe, ubb, hbp, ibb, sh, pa) => {
    // const num = (0.72 * ubb) + (0.75 * hbp) + (0.90 * b1) + (0.92 * roe) + (1.24 * b2) + (1.56 * b3) + (1.95 * hr);
    const num = (0.696 * ubb) + (0.726 * hbp) + (0.883 * b1) + (1.246 * b2) + (1.572 * b3) + (2.01 * hr);
    return ratio(num, pa - ibb - sh);
};
const gbFb = (gb, fb, pop) => ratio(gb, fb + pop);
const cBA = (b1, b2, b3, hr, ab, so) => ratio(hits(b1, b2, b3, hr), ab - so);
const babip = (b1, b2, b3, hr, ab, so, sf) => {
    const bip = b1 + b2 + b3;
    const reached = ab - so - hr + sf;
    return ratio(bip, reached);
};
const swingPct = (sw, pf, iballs, pitchouts) => ratio(sw, pf - iballs - pitchouts);
const missPct = (sw, cn) => ratio(sw - cn, sw);
const sec = (b1, b2, b3, hr, ubb, ibb, sb, cs, ab) => {
    const secondary = totalBases(b1, b2, b3, hr) - hits(b1, b2, b3, hr) + walks(ibb, ubb) + sb - cs;
    return ratio(secondary, ab);
};

const perXIP = (stat, outs, innings) => normalize(stat * 3.0, outs, innings);
const perIP = (stat, outs) => perXIP(stat, outs, 1);
const per9IP = (stat, outs) => perXIP(stat, outs, 9);
const per100IP = (stat, outs) => perXIP(stat, outs, 100);
const extraStrikesPer100 = (expstk, tkstk, tk) => {
    if (tk === 0)
        return null;
    return -1 * (100 * (expstk - tkstk) / tk);
};
const era = (er, outs) => normalize(er, outs, 27);
const whip = (b1, b2, b3, hr, ubb, outs) => perIP(b1 + b2 + b3 + hr + ubb, outs);
const rvERA = (rv) => {
    if (!rv)
        return null;
    return 4.4695 + (-136.900000 * rv);
};
const rvPerN = (rv, pa, n) => {
    if (pa === 0)
        return null;
    const v = (n * rv / pa);
    if (!Number.isFinite(v))
        return null;
    return v;
};

// eslint-disable-next-line max-len
const h2hStk = (tkStk, exptkStk, opptkStk, oppexptkStk, pitches, oppPitches, adjustmentFactor = 78) => {
    if (!pitches || !tkStk || !exptkStk || pitches === 0)
        return null;
    const h2hgained = (tkStk - exptkStk) - (((opptkStk * pitches) / oppPitches) - ((oppexptkStk * pitches) / oppPitches));
    return (adjustmentFactor * h2hgained / pitches);
};
const framingStk = (tkstk, exptkstk, pitches) => {
    if (!pitches || pitches === 0)
        return null;
    return (78 * (tkstk - exptkstk) / pitches);
};
const framingRuns = (tkstk, exptkstk, pitches) => {
    const fStk = framingStk(tkstk, exptkstk, pitches);
    return fStk === null ? null : 0.113 * fStk;
};
const framingRuns120 = (tkstk, exptkstk, pitches) => {
    const fStk = framingStk(tkstk, exptkstk, pitches);
    return fStk === null ? null : fStk * 120;
};
const catcherAccuracyScore = (throwswLoc, greatThrows, goodThrows, precision = 2) => {
    if (throwswLoc === 0 || throwswLoc === null)
        return null;
    return (((1.0 * (goodThrows - greatThrows)) + ((2.0 * throwswLoc) - goodThrows)) / throwswLoc).toFixed(precision);
};

const lob = (b1, b2, b3, hr, ubb, ibb, hbp, r) => {
    const leftOnBase = b1 + b2 + b3 + hr + ubb + ibb + hbp - r;
    const runnersOn = b1 + b2 + b3 + ubb + ibb + hbp;
    return ratio(leftOnBase, runnersOn);
};
const xW = (rs, ra, w, l) => {
    const pct = ratio(Math.pow(rs, 1.82), (Math.pow(rs, 1.82)) + (Math.pow(ra, 1.82)));
    if (!pct)
        return null;
    return pct * (w + l);
};
const xL = (rs, ra, w, l) => {
    const pct = ratio(Math.pow(rs, 1.82), (Math.pow(rs, 1.82)) + (Math.pow(ra, 1.82)));
    if (!pct)
        return null;
    return (1 - pct) * (w + l);
};

const innings = (outs) => Math.floor(outs / 3) + (outs % 3 * 0.1);
const minInnRequirement = (currentYear) => {
    const seasonStartDate = new Date(currentYear, 3, 3);
    const diffDays = dayjs().diff(seasonStartDate, 'day', true);
    let minInn;
    if (diffDays < 0)
        minInn = 0;
    else if (diffDays > 180)
        minInn = 50;
    else
        minInn = Math.floor(diffDays / 144.0 * 50); // eslint-disable-line no-mixed-operators
    return minInn;
};

const BASE_STATE = [[], [1], [2], [1, 2], [3], [1, 3], [2, 3], [1, 2, 3]];
const getNewBaseStateFromSelection = (currentState, selectedBaseNum) => {
    let tempState = currentState ? [...currentState] : [];
    if (tempState.includes(selectedBaseNum))
        tempState = tempState.filter((b) => b !== selectedBaseNum);
    else
        tempState.push(selectedBaseNum);
    return BASE_STATE.findIndex((bs) => tempState.every((b) => bs.includes(b)));
};
const BaseRunners = ({ baseState, onChange, options, emptyColor = theme.background.gallery, fillColor = theme.background.cerulean, width = 60, height = 44, }) => {
    const state = isNumber$2(baseState) ? BASE_STATE[baseState] : null;
    const enabledBaseNums = [0, 1, 2, 3].reduce((acc, baseNum) => [
        ...acc, !options || options.includes(getNewBaseStateFromSelection(state, baseNum)),
    ], new Array());
    const onClick = (baseNum) => {
        if (!onChange || !enabledBaseNums[baseNum])
            return;
        const newStateIdx = getNewBaseStateFromSelection(state, baseNum);
        onChange(newStateIdx, BASE_STATE[newStateIdx]);
    };
    return (React.createElement("svg", { viewBox: "0 0 91 67", width: typeof width === 'number' ? `${width}px` : width, height: typeof height === 'number' ? `${height}px` : height },
        React.createElement("g", { id: "base-runners", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("rect", { id: "runners-on-3", onClick: () => onClick(3), fill: (state === null || state === void 0 ? void 0 : state.includes(3)) ? fillColor : emptyColor, opacity: enabledBaseNums[3] ? 1 : 0.65, transform: "translate(22.000000, 45.000000) rotate(-315.000000) translate(-22.000000, -45.000000) ", x: "7", y: "30", width: "30", height: "30", rx: "2" }),
            React.createElement("rect", { id: "runners-on-1", onClick: () => onClick(1), fill: (state === null || state === void 0 ? void 0 : state.includes(1)) ? fillColor : emptyColor, opacity: enabledBaseNums[1] ? 1 : 0.65, transform: "translate(69.000000, 45.000000) rotate(-315.000000) translate(-69.000000, -45.000000) ", x: "54", y: "30", width: "30", height: "30", rx: "2" }),
            React.createElement("rect", { id: "runners-on-2", onClick: () => onClick(2), fill: (state === null || state === void 0 ? void 0 : state.includes(2)) ? fillColor : emptyColor, opacity: enabledBaseNums[2] ? 1 : 0.65, transform: "translate(46.000000, 22.000000) rotate(-315.000000) translate(-46.000000, -22.000000) ", x: "31", y: "7", width: "30", height: "30", rx: "2" }))));
};

const optsX = [1, 2, 3, 4, 5];
const optsY = [1, 2, 3, 4, 5];
const idsInZone = ['2.2', '2.3', '2.4', '3.2', '3.3', '3.4', '4.2', '4.3', '4.4'];
const boxSize = 30;
const boxPadding = 2;
const normalizeLocations = (locs) => {
    const initNLocations = {};
    return locs === null || locs === void 0 ? void 0 : locs.reduce((acc, l) => set(acc, `${l.locationx}.${l.locationy}`, true), initNLocations);
};
const PitchLocation$1 = ({ options, onChange, locations = [], size = 158, emptyColor = theme.background.gallery, strikeZoneColor = theme.border.alto, fillColor = theme.background.cerulean, singleSelectMode = false }) => {
    const nLocs = normalizeLocations(locations);
    const nOpts = normalizeLocations(options);
    const onClick = ({ currentTarget }) => {
        const { id } = currentTarget;
        if (!onChange || (nOpts && !get$2(nOpts, id)))
            return;
        const tempLocs = set(nLocs, id, !get$2(nLocs, id));
        const newLocations = Object.keys(tempLocs).reduce((acc, x) => {
            const xVals = Object.keys(tempLocs[x])
                .filter((y) => tempLocs[x][y])
                .map((y) => ({ locationx: Number(x), locationy: Number(y) }));
            return acc.concat(xVals);
        }, new Array());
        if (singleSelectMode && locations && locations.length > 0) {
            newLocations.forEach((loc) => {
                if (locations.filter((loc2) => loc2.locationx === loc.locationx && loc2.locationy === loc.locationy).length === 0) {
                    onChange([loc]);
                }
            });
        }
        else {
            onChange(newLocations);
        }
    };
    return (React.createElement("svg", { viewBox: "0 0 158 158", width: `${size}px`, height: `${size}px` },
        React.createElement("g", { id: "pitch-location", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("rect", { id: "strike-zone", width: (boxSize * 3) + (boxPadding * 3), height: (boxSize * 3) + (boxPadding * 3), x: boxSize + (boxPadding / 2), y: boxSize + (boxPadding / 2), rx: "2", strokeWidth: boxPadding, opacity: 0.5, stroke: theme.fontColors.doveGray }),
            optsX.map((x, xIdx) => (React.createElement(React.Fragment, { key: x }, optsY.map((y, yIdx) => {
                const id = `${x}.${y}`;
                return (React.createElement("rect", { key: id, id: id, 
                    // eslint-disable-next-line no-nested-ternary
                    fill: get$2(nLocs, id) ? fillColor : idsInZone.indexOf(id) !== -1 ? strikeZoneColor : emptyColor, opacity: (!nOpts || get$2(nOpts, id)) ? 1 : 0.65, onClick: onClick, width: boxSize, height: boxSize, x: xIdx * (boxSize + boxPadding), y: yIdx * (boxSize + boxPadding), rx: "2" }));
            })))))));
};

const hasData = (x) => x !== null && x !== undefined;
const isSelectAllValue = (value) => value === -1 || !hasData(value);
const isBallInHitLocation = (data, filterVal) => {
    var _a, _b, _c, _d;
    let isInLocation = false;
    if (hasData(data.isinfieldbip) && hasData(data.angleto2b) && hasData(data.distance) && hasData(data.ishr)) {
        isInLocation = (filterVal.ishr === undefined || !!data.ishr === filterVal.ishr)
            && (((_a = filterVal.angleto2b) === null || _a === void 0 ? void 0 : _a.min) === undefined || (isNumber$2(data.angleto2b) && data.angleto2b >= filterVal.angleto2b.min))
            && (((_b = filterVal.angleto2b) === null || _b === void 0 ? void 0 : _b.max) === undefined || (isNumber$2(data.angleto2b) && data.angleto2b <= filterVal.angleto2b.max))
            && (filterVal.isinfieldbip === undefined || !!data.isinfieldbip === filterVal.isinfieldbip)
            && (((_c = filterVal.distance) === null || _c === void 0 ? void 0 : _c.min) === undefined || (isNumber$2(data.distance) && data.distance >= filterVal.distance.min))
            && (((_d = filterVal.distance) === null || _d === void 0 ? void 0 : _d.max) === undefined || (isNumber$2(data.distance) && data.distance <= filterVal.distance.max));
    }
    return isInLocation;
};
const filterPlaylistFromParams = (playlist, filter) => playlist.filter(({ data }) => {
    let meetsFilterCriteria = true;
    Object.keys(filter).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const values = Array.isArray(filter[key]) ? filter[key] : [filter[key]];
        if (values.length) {
            meetsFilterCriteria = meetsFilterCriteria && values.some((filterVal) => {
                var _a;
                let meetsCriteria;
                if (isSelectAllValue(filterVal)) {
                    meetsCriteria = true;
                }
                else if (key === 'pitchLocations') {
                    meetsCriteria = filterVal.locationx === data.locationx && filterVal.locationy === data.locationy;
                }
                else if (key === 'hitLocations') {
                    meetsCriteria = isBallInHitLocation(data, filterVal);
                }
                else if (key === 'inning' && filterVal === 10) { // 10+ inning
                    meetsCriteria = isNumber$2(data.inning) && data.inning >= 10;
                }
                else if (key === 'bcbefore' && filterVal === true) { // any base runners
                    meetsCriteria = !!data.bcbefore;
                }
                else if (filterVal.min || filterVal.max) {
                    const isFilterGtMin = filterVal.min === undefined || filterVal.min === null || (isNumber$2(data[key]) && data[key] >= filterVal.min);
                    const isFilterLtMax = filterVal.max === undefined || filterVal.max === null || (isNumber$2(data[key]) && data[key] <= filterVal.max);
                    meetsCriteria = isFilterGtMin && isFilterLtMax;
                }
                else if (key === 'sourceLabels') {
                    meetsCriteria = (_a = data[key]) === null || _a === void 0 ? void 0 : _a.includes(filterVal);
                }
                else {
                    meetsCriteria = data[key] === filterVal;
                }
                return meetsCriteria;
            });
        }
    });
    return meetsFilterCriteria;
});

const sections$1 = [{
        id: 'hr-center',
        ishr: true,
        angleto2b: { min: -15, max: 15 },
        path: 'M3349 5376 c-2 -2 -58 -6 -124 -9 -265 -13 -594 -73 -897 -163 -146 -43 -404 -139 -412 -152 -2 -4 32 -97 75 -207 43 -110 102 -260 131 -332 28 -73 56 -133 61 -133 5 0 73 24 151 54 233 90 486 153 766 192 178 25 633 25 815 0 71 -9 132 -19 135 -21 3 -1 26 -6 51 -9 126 -17 423 -100 597 -168 57 -22 107 -36 111 -32 10 12 261 652 261 665 0 11 -184 80 -336 128 -209 65 -464 124 -634 146 -25 3 -56 8 -70 10 -101 18 -666 44 -681 31z',
    }, {
        id: 'hr-left',
        ishr: true,
        angleto2b: { max: -15 },
        path: 'M1665 4937 c-241 -124 -417 -233 -600 -371 -360 -271 -680 -606 -928 -971 l-67 -99 237 -238 c131 -131 241 -238 245 -238 4 0 27 26 50 58 247 333 488 584 787 821 186 148 481 332 666 416 41 19 75 38 75 43 0 4 -15 46 -34 93 -18 46 -77 195 -131 332 -53 136 -102 247 -108 247 -7 -1 -93 -42 -192 -93z',
    }, {
        id: 'hr-right',
        ishr: true,
        angleto2b: { min: 15 },
        path: 'M5072 4933 c-22 -60 -81 -211 -131 -337 -50 -127 -89 -230 -88 -230 15 -4 262 -129 322 -164 462 -267 859 -622 1204 -1079 34 -46 65 -83 69 -83 4 0 114 107 245 238 l238 239 -47 69 c-331 487 -776 907 -1281 1212 -141 85 -449 242 -475 242 -9 0 -30 -39 -56 -107z',
    }, {
        id: 'center',
        isinfieldbip: false,
        angleto2b: { min: -9, max: 9 },
        path: 'M3155 4580 c-132 -17 -248 -35 -353 -56 -24 -5 -31 -11 -27 -23 2 -9 9 -38 14 -66 6 -27 37 -174 70 -325 33 -151 87 -401 121 -555 114 -524 133 -610 135 -613 1 -1 68 4 148 13 176 18 323 19 477 1 63 -7 118 -10 122 -7 7 6 39 147 139 611 22 102 55 255 74 340 19 85 52 241 75 345 22 105 44 208 50 230 5 22 6 43 2 46 -9 8 -151 34 -302 55 -178 25 -559 26 -745 4z',
    }, {
        id: 'right-center',
        isinfieldbip: false,
        angleto2b: { min: 9, max: 27 },
        path: 'M4202 4267 c-28 -133 -81 -377 -117 -542 -94 -428 -165 -758 -168 -774 -1 -10 17 -19 58 -29 290 -67 566 -178 769 -309 38 -24 72 -41 76 -36 4 4 62 109 130 233 68 124 202 369 298 545 96 176 202 369 235 430 l59 110 -34 28 c-84 70 -370 248 -524 325 -98 49 -310 137 -428 177 -110 37 -272 85 -291 85 -5 0 -34 -109 -63 -243z',
    }, {
        id: 'left-center',
        isinfieldbip: false,
        angleto2b: { min: -27, max: -9 },
        path: 'M2675 4493 c-59 -14 -286 -91 -391 -133 -138 -55 -340 -154 -470 -231 -137 -81 -363 -236 -364 -250 0 -7 62 -118 444 -794 109 -192 219 -387 245 -432 25 -46 50 -83 54 -83 5 0 52 27 106 60 191 117 436 219 651 270 128 30 122 28 116 47 -5 16 -63 281 -146 663 -40 184 -132 607 -166 763 -29 132 -29 132 -79 120z',
    }, {
        id: 'right',
        isinfieldbip: false,
        angleto2b: { min: 27 },
        path: 'M5567 3838 c-8 -13 -28 -48 -44 -78 -66 -121 -453 -827 -555 -1013 -59 -109 -108 -201 -107 -205 0 -4 47 -43 105 -87 99 -75 306 -276 406 -395 l47 -55 496 495 496 496 -67 89 c-130 174 -322 393 -451 516 -98 93 -293 259 -305 259 -4 0 -14 -10 -21 -22z',
    }, {
        id: 'left',
        isinfieldbip: false,
        angleto2b: { max: -27 },
        path: 'M1315 3774 c-121 -101 -325 -304 -443 -439 -108 -124 -272 -340 -272 -358 0 -7 221 -233 490 -502 l491 -490 27 31 c15 17 56 66 92 109 83 99 240 249 350 333 47 36 89 69 93 73 5 3 -69 143 -164 310 -568 1004 -571 1009 -573 1009 0 0 -41 -34 -91 -76z',
    }, {
        id: 'second',
        isinfieldbip: true,
        distance: { min: 60 },
        angleto2b: { min: 0, max: 22.5 },
        path: 'M3510 2263 l0 -659 118 -13 c119 -12 275 -46 345 -76 36 -15 38 -15 46 7 5 13 26 59 46 103 20 44 82 179 137 300 56 121 124 272 153 335 29 63 83 180 119 259 36 80 66 148 66 152 0 8 -163 81 -271 120 -181 66 -431 116 -636 126 l-123 6 0 -660z',
    }, {
        id: 'short',
        isinfieldbip: true,
        distance: { min: 60 },
        angleto2b: { min: -22.5, max: 0 },
        path: 'M3260 2909 c-195 -25 -337 -58 -498 -114 -144 -50 -312 -126 -312 -140 0 -7 63 -152 141 -321 77 -170 195 -428 261 -574 66 -146 121 -266 122 -267 1 -1 33 9 71 23 93 34 208 60 328 75 l97 11 0 659 0 659 -72 -1 c-40 -1 -102 -5 -138 -10z',
    }, {
        id: 'first',
        isinfieldbip: true,
        distance: { min: 60 },
        angleto2b: { min: 22.5 },
        path: 'M4572 2623 c-6 -16 -65 -147 -132 -293 -119 -258 -144 -313 -304 -663 -42 -92 -76 -171 -76 -176 0 -6 28 -24 63 -41 109 -55 226 -140 324 -233 l94 -91 421 421 421 421 -39 49 c-135 169 -315 340 -485 462 -88 63 -259 171 -272 171 -3 0 -10 -12 -15 -27z',
    }, {
        id: 'third',
        isinfieldbip: true,
        distance: { min: 60 },
        angleto2b: { max: -22.5 },
        path: 'M2298 2576 c-237 -147 -471 -357 -640 -574 l-42 -53 421 -421 420 -420 89 89 c93 92 201 174 317 237 37 21 67 39 67 41 0 4 -116 258 -284 625 -34 74 -102 224 -152 332 -49 109 -93 197 -99 198 -5 0 -49 -25 -97 -54z',
    }, {
        id: 'infield',
        isinfieldbip: true,
        distance: { max: 60 },
        path: 'M3350 1543 c-229 -36 -409 -105 -590 -226 -76 -51 -260 -222 -260 -241 0 -6 223 -234 495 -506 l495 -495 505 505 c278 278 505 509 505 513 0 18 -103 115 -200 189 -238 179 -512 270 -805 267 -66 -1 -131 -4 -145 -6z',
    }];
/* eslint-enable max-len */
const areSectionsEqual = (a, b) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return a.ishr === b.ishr && a.isinfieldbip === b.isinfieldbip
        && ((_a = a.angleto2b) === null || _a === void 0 ? void 0 : _a.min) === ((_b = b.angleto2b) === null || _b === void 0 ? void 0 : _b.min) && ((_c = a.angleto2b) === null || _c === void 0 ? void 0 : _c.max) === ((_d = b.angleto2b) === null || _d === void 0 ? void 0 : _d.max)
        && ((_e = a.distance) === null || _e === void 0 ? void 0 : _e.min) === ((_f = b.distance) === null || _f === void 0 ? void 0 : _f.min) && ((_g = a.distance) === null || _g === void 0 ? void 0 : _g.max) === ((_h = b.distance) === null || _h === void 0 ? void 0 : _h.max);
};
const HitLocationSelect = ({ onChange, data, value, width = 270, height = 209, emptyColor = theme.background.gallery, fillColor = theme.background.cerulean }) => {
    let disabledSections = {};
    if (data)
        disabledSections = sections$1.reduce((acc, s) => (Object.assign(Object.assign({}, acc), { [s.id]: data.every((x) => !isBallInHitLocation(x, s)) })), {});
    const initSelectedSections = {};
    const selectedSections = (value || []).reduce((acc, v) => {
        const section = sections$1.find((s) => areSectionsEqual(s, v));
        if (section) {
            acc[section.id] = section;
        }
        return acc;
    }, initSelectedSections);
    const onClick = (section) => {
        const selected = Object.assign(Object.assign({}, selectedSections), { [section.id]: selectedSections[section.id] ? null : section });
        const criteria = Object.keys(selected).filter((id) => selected[id]).map((id) => {
            const { ishr, isinfieldbip, angleto2b, distance } = selected[id];
            return { ishr, isinfieldbip, angleto2b, distance };
        });
        onChange(criteria);
    };
    return (React.createElement("svg", { viewBox: "0 0 700 543", width: typeof width === 'number' ? `${width}px` : width, height: typeof height === 'number' ? `${height}px` : height },
        React.createElement("g", { id: "hit-location", transform: "translate(0, 543) scale(0.1,-0.1)", fill: "none", stroke: "none" }, sections$1.map((x) => (React.createElement("path", { key: x.id, id: x.id, onClick: (disabledSections[x.id] && !selectedSections[x.id]) ? undefined : () => onClick(x), fill: selectedSections[x.id] ? fillColor : emptyColor, opacity: disabledSections[x.id] ? 0.65 : 1, d: x.path }))))));
};

/* eslint-disable max-len */
const viewBoxX = 99;
const viewBoxY = 74;
const parkRadiusX = 56;
const parkRadiusY = 64;
const ballRadius = 4;
const wallWidth = 3;
const avgWallDistanceMLB = 370.59;
const homePlateX = viewBoxX / 2;
const homePlateY = viewBoxY - 1;
const HitLocation = ({ locations, width = 99, height = 74, ballinplayx = 0, ballinplayy = 0, ishr = false }) => {
    const hitLocations = locations || [{ ballinplayx, ballinplayy, ishr }];
    return (React.createElement("svg", { viewBox: `0 0 ${viewBoxX} ${viewBoxY}`, width: typeof width === 'number' ? `${width}px` : width, height: typeof height === 'number' ? `${height}px` : height },
        React.createElement("defs", null,
            React.createElement("path", { d: "M49.5970663,0 C70.3069325,0 88.5173655,10.3479901 99.0003437,25.9885765 L49.3499162,74.0003456 L-2.08498247e-05,26.2796753 C10.4513823,10.4765151 28.7589859,0 49.5970663,0 Z", id: "path-1" })),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { transform: "translate(-890.000000, -106.000000)" },
                React.createElement("g", { transform: "translate(0.000000, 10.000000)" },
                    React.createElement("g", { transform: "translate(12.000000, 49.000000)" },
                        React.createElement("g", { id: "chart-data" },
                            React.createElement("g", { id: "hit-location-small", transform: "translate(878.000000, 47.000000)" },
                                React.createElement("mask", { id: "mask-2", fill: "white" },
                                    React.createElement("use", { xlinkHref: "#path-1" })),
                                React.createElement("use", { fill: "#EDEDED", fillRule: "evenodd", xlinkHref: "#path-1" }),
                                React.createElement("ellipse", { stroke: theme.fontColors.silverChalice, strokeWidth: wallWidth, mask: "url(#mask-2)", cx: "50", cy: "73", rx: parkRadiusX, ry: parkRadiusY }),
                                React.createElement("ellipse", { stroke: "#737373", strokeWidth: "1", fill: theme.border.alto, fillRule: "evenodd", mask: "url(#mask-2)", cx: "50", cy: "70", rx: "31", ry: "33" }),
                                hitLocations.map(({ ballinplayx: x, ballinplayy: y, ishr: hr }) => {
                                    let scaledDistanceOfBall;
                                    const angleFrom2bRads = Math.atan2(x, y);
                                    const scaledDistanceToWall = (parkRadiusY * parkRadiusX)
                                        / Math.sqrt((Math.pow((parkRadiusY * Math.sin(angleFrom2bRads)), 2)) + (Math.pow((parkRadiusX * Math.cos(angleFrom2bRads)), 2)));
                                    if (hr) {
                                        scaledDistanceOfBall = scaledDistanceToWall + (ballRadius / 2) + wallWidth;
                                    }
                                    else {
                                        const distance = Math.sqrt((Math.pow(x, 2)) + (Math.pow(y, 2)));
                                        scaledDistanceOfBall = Math.min(distance, avgWallDistanceMLB) / avgWallDistanceMLB * scaledDistanceToWall;
                                        scaledDistanceOfBall = Math.min(scaledDistanceOfBall, scaledDistanceToWall - (ballRadius / 2) - wallWidth);
                                    }
                                    const translatedX = homePlateX + (scaledDistanceOfBall * Math.sin(angleFrom2bRads));
                                    const translatedY = homePlateY - (scaledDistanceOfBall * Math.sin((Math.PI / 2) - Math.abs(angleFrom2bRads)));
                                    return (React.createElement("g", { key: `g_${ballinplayx}_${ballinplayy}_${hr}`, strokeWidth: "1", fillRule: "evenodd", fill: theme.background.red },
                                        React.createElement("circle", { cx: translatedX, cy: translatedY, r: ballRadius })));
                                }),
                                ";"))))))));
};

var GlobalStyle = createGlobalStyle `
    .bootstrap {
        &, .form-control, .form-control:focus {
            color: ${(props) => { var _a; return (((_a = props.theme) === null || _a === void 0 ? void 0 : _a.isDarkMode) ? theme.border.alto : theme.fontColors.mineShaft); }}
        }
        .form-control {
            min-height: calc(1.5em + 0.75rem + 2px);
        }

        .btn {
            &.btn-default {
                ${(props) => {
    var _a;
    return (((_a = props.theme) === null || _a === void 0 ? void 0 : _a.isDarkMode)
        ? buttonColor(theme.fontColors.silver, theme.fontColors.tundora)
        : buttonColor(theme.fontColors.tundora, theme.background.gallery));
}};
            }
            &.btn-primary {
                ${buttonColor('white', theme.background.mariner)};
                &.btn.dropdown-toggle::after {
                    color: white;
                }
            }
            &.btn-danger {
                ${buttonColor('white', theme.background.red)};
            }
            &.dropdown-toggle:after {
                color: ${theme.fontColors.doveGray};
            }
        }

        a {
            color: ${(props) => { var _a; return (((_a = props.theme) === null || _a === void 0 ? void 0 : _a.isDarkMode) ? theme.fontColors.doveGray : theme.fontColors.cerulean); }};
            text-decoration: none;
            background-color: transparent;
        }

        a, .btn-link, .page-link {
            color: ${(props) => { var _a; return (((_a = props.theme) === null || _a === void 0 ? void 0 : _a.isDarkMode) ? theme.fontColors.doveGray : theme.fontColors.cerulean); }};
            &:hover {
              color: ${(props) => {
    var _a, _b;
    return pSBC(0.45 * (((_a = props.theme) === null || _a === void 0 ? void 0 : _a.isDarkMode) ? 1 : -1), ((_b = props.theme) === null || _b === void 0 ? void 0 : _b.isDarkMode) ? theme.fontColors.doveGray : theme.fontColors.cerulean);
}};
            }
        }

        .page-item.active .page-link {
            background-color: ${theme.fontColors.dodgerBlue};
            border-color: ${theme.fontColors.dodgerBlue};
        }

        .badge {
            &.badge-primary {
                ${buttonColor('white', theme.background.endeavour)};
            }
        }

        .grid-striped {
            .row:nth-of-type(odd) {
                background-color: ${theme.background.solitude};
                padding-top: 1em;
                padding-bottom: 1em;
            }
        }

        ${(props) => {
    var _a;
    return (((_a = props.theme) === null || _a === void 0 ? void 0 : _a.isDarkMode) ? `.form-control {
            border-color: ${theme.fontColors.tundora};
            &, &:focus {
                background-color: transparent;
            }
        }` : '');
}}
    }
`;

const styles = {
    pSBC,
    theme,
    mixins,
    constants,
};
// https://stackoverflow.com/a/3943023
// eslint-disable-next-line max-len
const textColorForRgbBackground = (r, g, b, lightColor, darkColor, threshold) => (((r * 0.299) + (g * 0.587) + (b * 0.114) > (threshold !== null && threshold !== void 0 ? threshold : 162)) ? (darkColor !== null && darkColor !== void 0 ? darkColor : theme.fontColors.mineShaft) : (lightColor !== null && lightColor !== void 0 ? lightColor : '#ffffff'));
// this more involved algorithm was offered as an alternative that may be more W3C compliant. but i personally preferred the results above.
// rgb = [r, g, b].map((val) => {
//     let c = val / 255.0;
//     if (c <= 0.04045) c /= 12.92; else c = ((c + 0.055) / 1.055) ** 2.4;
//     return c;
// });
// const lum = (0.2126 * rgb[0]) + (0.7152 * rgb[1]) + (0.0722 * rgb[2]);
// return lum > 0.179 ? '#000000' : '#ffffff';
const textColorForHexBackground = (hex, lightColor, darkColor, threshold) => {
    let hexval = hex !== null && hex !== void 0 ? hex : '';
    if (hexval.startsWith('#'))
        hexval = hexval.substring(1);
    if (hexval.length === 3) {
        hexval = `${hexval[0]}${hexval[0]}${hexval[1]}${hexval[1]}${hexval[2]}${hexval[2]}`;
    }
    if (hexval.length !== 6)
        return null;
    return textColorForRgbBackground(parseInt(hexval.substring(0, 2), 16), parseInt(hexval.substring(2, 4), 16), parseInt(hexval.substring(4, 6), 16), lightColor, darkColor, threshold);
};

const StyledVideoButton$1 = styled.div `
    display: inline-block;
    position: relative;
    cursor: pointer;
    > span {
        font-size: calc(${({ $size }) => (isNumber$2($size) ? `${$size}px` : $size)} * 0.33);
        color: white;
        text-transform: uppercase;
        font-weight: bold;
        position: absolute;
        top: 0;
        left: calc(${({ $size }) => (isNumber$2($size) ? `${$size}px` : $size)} * 0.12);
        height: 100%;
        display: flex;
        align-items: center;
    }
`;
const StyledTextLink = styled.div `
    color: ${({ $color }) => $color};
    cursor: pointer;
    : hover {
        text-decoration: underline;
    }
`;
const VideoButton = (_a) => {
    var _b;
    var { icon, color = styles.theme.background.astronaut, size = '2em', text, textColor, showCameraIcon = true, onClick } = _a, rest = __rest(_a, ["icon", "color", "size", "text", "textColor", "showCameraIcon", "onClick"]);
    let iconColor = color;
    if (!iconColor && (icon === null || icon === void 0 ? void 0 : icon.toUpperCase()) === 'AB')
        iconColor = styles.theme.background.astronaut;
    const tc = (_b = textColor !== null && textColor !== void 0 ? textColor : textColorForHexBackground(color)) !== null && _b !== void 0 ? _b : '#fff';
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledVideoButton$1, Object.assign({ "$size": size, onClick: onClick }, rest),
            text && React.createElement(StyledTextLink, { "$color": tc }, text),
            showCameraIcon && React.createElement(Icon, { color: iconColor, size: size, icon: "video-camera" }),
            icon && React.createElement("span", null, icon))));
};

const StyledToggleButton = styled(ToggleButton) `
    &&&.btn { 
        &&&.active {
            ${buttonColor('white', theme.background.mariner)};
        }
        &&&.disabled {
            ${buttonColor(theme.background.codGray, theme.background.concrete)};
        }
        ${buttonColor('black', theme.background.white)};
    }
`;
const StyledButtonGroup = styled(ToggleButtonGroup) `
    ${(props) => (props.$separated ? `
        &&&& {
            > ${StyledToggleButton} {
                &:not(:last-child) {
                    border-top-right-radius: 0.25rem;
                    border-bottom-right-radius: 0.25rem;
                    margin-right: 7px;                    
                }
                &:not(:first-child) {
                    border-top-left-radius: 0.25rem;
                    border-bottom-left-radius: 0.25rem;
                }
            }
        }
    ` : '')}
    .btn-check:checked + .btn {
        ${buttonColor('white', theme.background.mariner)};
    }
    .btn {
        border: 2px solid ${theme.background.concrete} !important;
    }
`;
const IconToggleButtons = (_a) => {
    var { options, onChange, separated = false, type = 'radio', name } = _a, rest = __rest(_a, ["options", "onChange", "separated", "type", "name"]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onToggleChange = onChange ? (newVal, event) => onChange(newVal, event.currentTarget.name, event) : undefined;
    return (React.createElement(StyledButtonGroup, Object.assign({ "$separated": separated, onChange: onToggleChange, type: type, name: name }, rest), options.map((o) => (React.createElement(StyledToggleButton, { key: o.value.toString(), id: `${name}-${o.value.toString()}`, value: o.value, disabled: o.disabled, variant: o.variant },
        React.createElement(Icon, { icon: o.name, size: o.size || '1em' }))))));
};

const wristband = { width: 320, height: 380, margin: 37, padding: 0 };
const strengths2 = { width: 260, height: 308, margin: 37, padding: 0 };
const HEATMAP_MODELS = [
    { id: 126, name: 'HeatMaps' },
    { id: 127, name: 'SwingMaps' },
    { id: 128, name: 'SwingMapsByPitchType' },
    { id: 129, name: 'HeatMapsByPitchType' },
    { id: 148, name: 'HeatMapsPitcher' },
    { id: 149, name: 'PitchLocationActual' },
    { id: 216, name: 'HeatMapsPitcher2' },
    { id: 320, name: 'PitcherHeatMaps' },
    { id: 217, name: 'CatcherWristband' },
    { id: 141, name: 'PitchingPlans' },
    { id: 124, name: 'DefensivePositions' },
    { id: 125, name: 'DefensivePositionsIF' },
];
const heatMapModelIds = HEATMAP_MODELS.reduce((acc, m) => (Object.assign(Object.assign({}, acc), { [m.name]: m.id })), {});
const getHeatmapSizeByType = (modelId, size) => {
    let sizes = { margin: 0, padding: 0, height: size, width: size };
    let sizeConstants;
    if (modelId === heatMapModelIds.CatcherWristband)
        sizeConstants = wristband;
    else if (modelId === heatMapModelIds.HeatMapsPitcher2)
        sizeConstants = strengths2;
    if (sizeConstants) {
        const { width, height, margin } = sizeConstants;
        const padding = (size / width) * margin;
        sizes = {
            margin,
            padding,
            height: (height / width * size) - (2 * padding),
            width: size - (2 * padding),
        };
    }
    return sizes;
};

const BaseChartContainer = styled.div `
    margin-left: auto;
    margin-right: auto;
    ${({ $width }) => ($width ? `width: ${$width}px;` : '')}
    ${({ $useBodyFont }) => ($useBodyFont ? `
        svg {
            font-family: inherit !important;
        }
    ` : '')}
`;
const BaseChart = forwardRef((_a, ref) => {
    var { options, width, useBodyFont = true, useHistogramModule = false } = _a, rest = __rest(_a, ["options", "width", "useBodyFont", "useHistogramModule"]);
    const { credits } = options, opts = __rest(options, ["credits"]);
    const optionsWithDefault = Object.assign({ credits: Object.assign({ enabled: false }, credits) }, opts);
    const highchartsModule = useHistogramModule ? histogram(Highcharts) : Highcharts;
    return (React.createElement(BaseChartContainer, { "$width": width, "$useBodyFont": useBodyFont },
        React.createElement(HighchartsReact, Object.assign({ ref: ref, highcharts: highchartsModule, options: optionsWithDefault }, rest))));
});
BaseChart.Container = BaseChartContainer;

const sizesWidth$1 = { xs: 110, sm: 230, lg: 350, ptloc: 240, ocsheet: 192, ocsheetsm: 192 * 0.8 };
const sizesHeight$1 = { xs: 90, sm: 230, lg: 350, ptloc: 278, ocsheet: 222, ocsheetsm: 222 * 0.8 };
const sizesAxisWidth$1 = { xs: 125, sm: 200, lg: 300, ptloc: 218, ocsheet: 174, ocsheetsm: 174 * 0.8 };
const sizesAxisHeight$1 = { xs: 125, sm: 200, lg: 300, ptloc: 218, ocsheet: 160, ocsheetsm: 160 * 0.8 };
const sizesBatterWidth = { xs: 21, sm: 80, lg: 120, ptloc: 103, ocsheet: 64, ocsheetsm: 64 * 0.8 };
const sizesBatterHeight = { xs: 57, sm: 270, lg: 410, ptloc: 310, ocsheet: 216, ocsheetsm: 216 * 0.8 };
const sizesLhbPosition = {
    xs: { x: 0, y: 15 },
    sm: { x: -5, y: -40 },
    lg: { x: -10, y: -80 },
    ptloc: { x: 0, y: -25 },
    ocsheet: { x: 0, y: -20 },
    ocsheetsm: { x: 0, y: -20 * 0.8 },
};
const sizesRhbPosition = {
    xs: { x: 88, y: 15 },
    sm: { x: 145, y: -40 },
    lg: { x: 220, y: -80 },
    ptloc: { x: 134, y: -25 },
    ocsheet: { x: 125, y: -20 },
    ocsheetsm: { x: 125 * 0.8, y: -20 * 0.8 },
};
const heatmapBackgroundHeight$1 = { xs: 187, sm: 300, lg: 450, ptloc: 328, ocsheet: 240, ocsheetsm: 190 };
const heatmapBackgroundWidth$1 = { xs: 150, sm: 248, lg: 365, ptloc: 270, ocsheet: 200, ocsheetsm: 158 };
const heatmapBackgroundX$1 = { xs: -20, sm: -7, lg: -16, ptloc: -40, ocsheet: -2, ocsheetsm: 2 };
const heatmapBackgroundY$1 = { xs: -49, sm: -50, lg: -75, ptloc: -10, ocsheet: -40, ocsheetsm: -30 };
const LOCAL_STORAGE_CHARTLEGEND_KEY = 'chart_legend';
const sizes$1 = {
    width: sizesWidth$1,
    height: sizesHeight$1,
    axiswidth: sizesAxisWidth$1,
    axisheight: sizesAxisHeight$1,
    batterwidth: sizesBatterWidth,
    batterheight: sizesBatterHeight,
    lhbposition: sizesLhbPosition,
    rhbposition: sizesRhbPosition,
    heatmapbackgroundheight: heatmapBackgroundHeight$1,
    heatmapbackgroundwidth: heatmapBackgroundWidth$1,
    heatmapbackgroundx: heatmapBackgroundX$1,
    heatmapbackgroundy: heatmapBackgroundY$1,
};
const StrikeZone$3 = forwardRef(({ size = 'lg', enableZoom = true, minX = -2.25, maxX = 2.25, minY = 0.25, maxY = 4.75, height, showbatter = true, showlhb = false, showlegend = false, legendposition = 'float', yopposite = false, seriesData, showSeries = true, showoffgrid = true, sztop = 3.41, szbottom = 1.57, contourPoints, pitcherView = true, pointshrinkcutoff = 250, heatMapBackground, showHeatMapBackground = true, heatMapBackground2, heatMapBackgroundOpacity, showHeatMapBackground2 = true, modalContainer, pitchVideoFn, multiVideoFn, videoPlayerModal: VideoPlayerModal, exportPlaylistCallback, onClick, hideGrid, showStrikeZone = true, hideAxis = false, legendClickFn, customLegend, preventLegendSeriesHover = false, ignoreLocalStorageChartLegend = true, tooltipFormatter, }, outerRef) => {
    const ref = useRef(null);
    const [series, updateSeries] = useState(onSeriesAssignment(seriesData));
    const [elements, setElements] = useState({});
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    // Update state when prop changes through
    useEffect(() => {
        var _a;
        redraw();
        updateSeries(showSeries ? onSeriesAssignment(fixOffGridPoints(((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null, seriesData)) : []);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref, contourPoints, seriesData, showSeries, showHeatMapBackground, showHeatMapBackground2, pitcherView]);
    function redraw() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (!chart)
            return;
        if (showStrikeZone)
            renderStrikeZone(chart);
        renderHeatMapBackground(chart);
        renderBatter(chart);
        showContourPoints(chart);
    }
    const legendConfig = Object.assign({ enabled: showlegend }, customLegend);
    if (customLegend === null || customLegend === undefined) {
        if (legendposition === 'float') {
            legendConfig.align = 'right';
            legendConfig.verticalAlign = 'top';
            legendConfig.layout = 'vertical';
            legendConfig.floating = true;
            legendConfig.x = -16;
            legendConfig.y = 10;
        }
        else if (legendposition === 'below') {
            legendConfig.align = 'center';
            legendConfig.floating = true;
            if (size && size !== 'lg') {
                legendConfig.itemDistance = 10;
                legendConfig.width = '100%';
            }
            if (size === 'sm') {
                legendConfig.itemWidth = 100;
                legendConfig.itemStyle = {
                    fontSize: '10px',
                };
                legendConfig.margin = 0;
            }
        }
    }
    function onSeriesAssignment(_series) {
        const numScatterPoints = _series
            .filter((s) => !s.type || s.type === 'scatter')
            .map((x) => (x.data ? x.data.length : 0))
            .reduce((a, b) => a + b, 0);
        return _series.map((s) => {
            var _a;
            const mappedSeries = Object.assign(Object.assign({}, s), { data: (_a = s.data) === null || _a === void 0 ? void 0 : _a.filter((d) => isNumber$2(d.x, d.y)).map((d) => (pitcherView ? d : Object.assign(Object.assign({}, d), { x: d.x * -1 }))) });
            if (numScatterPoints > pointshrinkcutoff && (!s.type || s.type === 'scatter')) {
                mappedSeries.marker = Object.assign(Object.assign({}, mappedSeries.marker), { radius: !mappedSeries.marker ? 2 : Math.max(1, mappedSeries.marker.radius - 2) });
            }
            return mappedSeries;
        });
    }
    function renderBatter(chart) {
        let batterImg;
        let batterPosition;
        if (pitcherView) {
            batterImg = showlhb ? lhbImgFront : rhbImgFront;
            batterPosition = showlhb ? 'lhb' : 'rhb';
        }
        else {
            batterImg = showlhb ? lhbImgRear : rhbImgRear;
            batterPosition = showlhb ? 'rhb' : 'lhb';
        }
        const { x, y } = sizes$1[`${batterPosition}position`][size];
        const w = sizes$1.batterwidth[size];
        const h = sizes$1.batterheight[size];
        const imgattr = {
            zIndex: 2,
            opacity: 0.4,
        };
        if (elements.batterRender) {
            elements.batterRender.element.remove();
        }
        if (showbatter) {
            elements.batterRender = chart.renderer
                .image(batterImg, x, y, w, h)
                .attr(imgattr)
                .add();
        }
        setElements(elements);
    }
    function showContourPoints(chart) {
        if (!(contourPoints === null || contourPoints === void 0 ? void 0 : contourPoints.length))
            return;
        const xmultiplier = pitcherView ? -1 : 1;
        const path = new Array();
        path.push('M');
        path.push(chart.xAxis[0].toPixels(xmultiplier * contourPoints[0].platex, false));
        path.push(chart.yAxis[0].toPixels(contourPoints[0].platez, false));
        path.push('L');
        for (let i = 1; i < contourPoints.length; i += 25) {
            path.push(chart.xAxis[0].toPixels(xmultiplier * contourPoints[i].platex, false));
            path.push(chart.yAxis[0].toPixels(contourPoints[i].platez, false));
        }
        path.push('Z');
        if (elements.szcontour) {
            elements.szcontour.element.remove();
        }
        elements.szcontour = chart.renderer.path(path)
            .attr({
            'stroke-width': 1,
            stroke: 'rgba(255,128,128,.7)',
            fill: 'rgba(255,128,128,.05)',
            zIndex: 2,
        })
            .add();
        setElements(elements);
    }
    function fixOffGridPoints(chart, _series) {
        if (!chart || !showoffgrid)
            return _series;
        const xrange = chart.xAxis[0].getExtremes();
        const yrange = chart.yAxis[0].getExtremes();
        for (let i = 0; i < _series.length; i += 1) {
            if (!isNaN(parseInt(showoffgrid.toString()))) {
                if (parseInt(showoffgrid.toString()) !== i) {
                    continue; // eslint-disable-line no-continue
                }
            }
            if (_series[i].data.length > 0) {
                for (let j = 0; j < _series[i].data.length; j += 1) {
                    const point = _series[i].data[j];
                    if (isNumber$2(point.x, point.y) && (point.x < xrange.min || xrange.max < point.x || point.y <= yrange.min || yrange.max <= point.y)) {
                        /* eslint-disable no-param-reassign, no-nested-ternary */
                        _series[i].data[j].x = (point.x <= xrange.min ? xrange.min + 0.05 : (xrange.max < point.x ? xrange.max - 0.05 : point.x));
                        _series[i].data[j].y = (point.y <= yrange.min ? yrange.min + 0.05 : (yrange.max < point.y ? yrange.max - 0.05 : point.y));
                        /* eslint-enable no-param-reassign, no-nested-ternary */
                    }
                }
            }
        }
        return _series;
    }
    function renderStrikeZone(chart) {
        if (elements.strikeZone) {
            elements.strikeZone.forEach((el) => {
                el.element.remove();
            });
        }
        const x = chart.xAxis[0].toPixels(-0.833, false); // for some reason we have to add these offsets
        const y = chart.yAxis[0].toPixels(sztop, false); // for some reason we have to add these offsets
        const h = chart.yAxis[0].toPixels(szbottom, false) - chart.yAxis[0].toPixels(sztop, false);
        const w = chart.xAxis[0].toPixels(0.833, false) - chart.xAxis[0].toPixels(-0.833, false);
        const rectattr = {
            'stroke-width': 1,
            stroke: '#979595',
            fill: 'none',
            zIndex: 1,
        };
        const szoverall = chart.renderer.rect(x, y, w, h, 0).attr(rectattr).add();
        const szv1 = chart.renderer.rect(x, y, (w / 3.0), h, 0).attr(rectattr).add();
        const szv2 = chart.renderer.rect(x, y, 2 * (w / 3.0), h, 0).attr(rectattr).add();
        const szh1 = chart.renderer.rect(x, y, w, (h / 3.0), 0).attr(rectattr).add();
        const szh2 = chart.renderer.rect(x, y, w, 2 * (h / 3.0), 0).attr(rectattr).add();
        elements.strikeZone = [szoverall, szv1, szv2, szh1, szh2];
        setElements(elements);
    }
    function renderHeatMapBackground(chart) {
        if (elements.heatMap) {
            elements.heatMap.element.remove();
        }
        if (elements.heatMap2) {
            elements.heatMap2.element.remove();
        }
        if (heatMapBackground || heatMapBackground2) {
            const imgattr = {
                zIndex: 1,
                opacity: heatMapBackgroundOpacity || (hideGrid ? 0.75 : 0.45),
                scaleX: pitcherView ? 1 : -1,
                translateX: pitcherView ? 0 : sizes$1.heatmapbackgroundwidth[size] + (sizes$1.heatmapbackgroundx[size] * 2),
            };
            const heatMap = heatMapBackground && showHeatMapBackground ? chart.renderer
                .image(heatMapBackground, sizes$1.heatmapbackgroundx[size], sizes$1.heatmapbackgroundy[size], sizes$1.heatmapbackgroundwidth[size], sizes$1.heatmapbackgroundheight[size])
                .attr(imgattr)
                .add() : undefined;
            elements.heatMap = heatMap;
            const imgattr2 = {
                zIndex: 1,
                opacity: hideGrid ? 0.5 : 0.25,
            };
            const heatMap2 = heatMapBackground2 && showHeatMapBackground2 ? chart.renderer
                .image(heatMapBackground2, sizes$1.heatmapbackgroundx[size], sizes$1.heatmapbackgroundy[size], sizes$1.heatmapbackgroundwidth[size], sizes$1.heatmapbackgroundheight[size])
                .attr(imgattr2)
                .add() : undefined;
            elements.heatMap2 = heatMap2;
            setElements(elements);
        }
    }
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq, playid) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq, playid);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const fetchMultiVideo = (pitches) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const pitchIds = pitches
                .filter(({ gameid, eventseq, pitchseq }) => isNumber$2(gameid, eventseq, pitchseq))
                .map(({ gameid, eventseq, pitchseq }) => ({ gameid: Number(gameid), eventseq: Number(eventseq), pitchseq: Number(pitchseq) }));
            const playlist = yield multiVideoFn(pitchIds);
            setVideoPlaylist(playlist);
        }
        catch (_b) {
            closePitchVideo();
        }
    });
    let margin;
    if (size === 'ptloc')
        margin = showlhb ? [45, 0, 8, 37] : [45, 0, 8, -13];
    else if (size === 'xs')
        margin = [-18, 0, 0, -7];
    else
        margin = [0, 0, 0, 17];
    const hideChartTicksAndGrids = /* hideGrid || */ ['ptloc', 'xs'].includes(size);
    if (!ignoreLocalStorageChartLegend) {
        const legendJson = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_CHARTLEGEND_KEY) || '[]');
        series.forEach((x) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const leg = legendJson.find((y) => y.id === x.id);
            if (leg != null)
                x.visible = leg.visible;
        });
    }
    const chartConfig = {
        chart: {
            type: 'scatter',
            height: height || sizes$1.height[size],
            width: sizes$1.width[size],
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
            spacing: hideChartTicksAndGrids ? [0, 0, 0, 0] : [10, 10, 15, 10],
            margin,
            events: {
                selection: function selection(e) {
                    var _a, _b;
                    if (multiVideoFn && ((_a = e.xAxis) === null || _a === void 0 ? void 0 : _a.length) && ((_b = e.yAxis) === null || _b === void 0 ? void 0 : _b.length)) {
                        const [{ min: minXAxis, max: maxXAxis }] = e.xAxis;
                        const [{ min: minYAxis, max: maxYAxis }] = e.yAxis;
                        const points = this.series.filter((s) => s.visible).flatMap((s) => s.points.filter((point) => {
                            const { enabled, x, y } = point;
                            return enabled !== false && x >= minXAxis && x <= maxXAxis && typeof y === 'number' && y >= minYAxis && y <= maxYAxis;
                        }));
                        if (points.length) {
                            fetchMultiVideo(points.map((p) => ({
                                gameid: p.gameid,
                                pitchseq: p.pitchseq,
                                eventseq: p.eventseq,
                            })));
                        }
                    }
                    return false; // Don't zoom
                },
            },
        },
        colors: ['#3366FF', '#BF0B23', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        plotOptions: {
            series: {
                marker: {
                    radius: 2,
                    symbol: 'circle',
                },
                stickyTracking: false,
                turboThreshold: 0,
                dataLabels: {
                    allowOverlap: true,
                    // padding: 2,
                    crop: false,
                    overflow: 'justify',
                },
                point: {
                    events: {
                        click: function click() {
                            if ((this.gameid && this.eventseq && this.pitchseq) || this.playid) {
                                if (onClick)
                                    return onClick(this);
                                if (pitchVideoFn)
                                    return fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq, this.playid);
                            }
                            return null;
                        },
                    },
                },
                events: {
                    legendItemClick(e) {
                        const chart = this.chart.legend.allItems;
                        if (chart !== undefined && !ignoreLocalStorageChartLegend) {
                            window.localStorage.setItem(LOCAL_STORAGE_CHARTLEGEND_KEY, JSON.stringify(chart.map((ch) => ({
                                id: ch.options.id,
                                visible: this.index === ch.index ? !ch.visible : ch.visible,
                                name: ch.name,
                            }))));
                        }
                        if (legendClickFn) {
                            const returnLegend = [];
                            const thisLegendItem = e.target;
                            returnLegend.push(Object.assign(Object.assign({}, thisLegendItem), { visible: !thisLegendItem.visible }));
                            this.chart.series.filter((x) => x.index !== thisLegendItem.index).forEach((x) => {
                                if (x.visible) {
                                    returnLegend.push(Object.assign({}, x));
                                }
                                else {
                                    returnLegend.push(Object.assign({}, x));
                                }
                            });
                            legendClickFn(returnLegend);
                        }
                        return this;
                    },
                },
                states: {
                    inactive: {
                        opacity: preventLegendSeriesHover ? 1 : 0.2,
                    },
                },
            },
        },
        legend: legendConfig,
        xAxis: {
            visible: !hideAxis,
            height: sizes$1.axisheight[size],
            width: sizes$1.axisheight[size],
            min: minX,
            max: maxX,
            gridLineWidth: 0,
            tickInterval: 1,
            tickLength: hideChartTicksAndGrids ? 0 : 6,
            minorTickInterval: 0.25,
            minorTickLength: hideChartTicksAndGrids ? 0 : 4,
            minorTickWidth: hideChartTicksAndGrids ? 0 : 1,
            minorGridLineWidth: (hideGrid || hideChartTicksAndGrids) ? 0 : 1,
            minorGridLineColor: '#FCF8F8',
            minPadding: 0,
            maxPadding: 0,
            lineColor: hideChartTicksAndGrids ? 'transparent' : undefined,
            labels: {
                enabled: !hideChartTicksAndGrids,
                reserveSpace: false,
            },
        },
        yAxis: {
            visible: !hideAxis,
            height: sizes$1.axisheight[size],
            width: sizes$1.axisheight[size],
            min: minY,
            max: maxY,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 1,
            tickLength: hideChartTicksAndGrids ? 0 : 6,
            minorTickInterval: 0.25,
            minorTickLength: hideChartTicksAndGrids ? 0 : 4,
            minorTickWidth: hideChartTicksAndGrids ? 0 : 1,
            minorGridLineWidth: (hideGrid || hideChartTicksAndGrids) ? 0 : 1,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: yopposite,
            lineColor: hideChartTicksAndGrids ? 'transparent' : undefined,
            title: {
                text: null,
            },
            labels: {
                enabled: !hideChartTicksAndGrids,
                reserveSpace: false,
                x: yopposite ? 5 : -5,
            },
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                if (!this.point.tooltip && !this.point.name)
                    return false;
                return `<b>${this.series.name}</b><br/>${this.point.tooltip || this.point.name}`;
            },
            outside: true,
        },
        series,
        title: {
            align: 'center',
            floating: true,
            verticalAlign: 'top',
            text: undefined,
        },
        credits: {
            enabled: false,
        },
    };
    return (React.createElement(React.Fragment, null,
        !!(pitchVideoFn || multiVideoFn) && !!VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer, exportPlaylist: (clips) => { closePitchVideo(); if (exportPlaylistCallback)
                exportPlaylistCallback(clips); } })),
        React.createElement(BaseChart, { ref: ref, width: sizes$1.width[size], options: chartConfig, useBodyFont: false })));
});

const handedness = (batsThrowsEnum, isFullText = false, translate = null) => {
    let textValue = isFullText ? 'Unknown' : '-';
    if (!isNaN(batsThrowsEnum)) {
        const value = Number(batsThrowsEnum);
        if (translate) {
            if (value === 1)
                textValue = isFullText ? translate('baseball.right') : translate('baseball.abbr-right');
            else if (value === 2)
                textValue = isFullText ? translate('baseball.left') : translate('baseball.abbr-left');
            else if (value === 3)
                textValue = isFullText ? translate('baseball.switch') : translate('baseball.abbr-switch');
        }
        else if (value === 1)
            textValue = isFullText ? 'Right' : 'R';
        else if (value === 2)
            textValue = isFullText ? 'Left' : 'L';
        else if (value === 3)
            textValue = isFullText ? 'Switch' : 'S';
    }
    return textValue;
};
const yesNo = (value, isFullText = false, translate = null) => {
    let yesNoVal = null;
    if (value === true || value === 1 || value === 'true' || value === 'True') {
        if (translate) {
            yesNoVal = isFullText ? translate('common.yes') : translate('common.abbr-yes');
        }
        else {
            yesNoVal = isFullText ? 'Yes' : 'Y';
        }
    }
    else if (value === false || value === 0 || value === 'false' || value === 'False') {
        if (translate) {
            yesNoVal = isFullText ? translate('common.no') : translate('common.abbr-no');
        }
        else {
            yesNoVal = isFullText ? 'No' : 'N';
        }
    }
    return yesNoVal;
};
const rosterState = (stateEnum, isFullText = false, translate = null) => {
    let textValue = '';
    if (translate) {
        textValue = isFullText ? translate('common.unknown') : '--';
        if (!isNaN(stateEnum)) {
            const value = Number(stateEnum);
            if (value === 1)
                textValue = isFullText ? translate('shared.rosterstate.active') : translate('shared.rosterstate.abbr-active');
            else if (value === 2)
                textValue = isFullText ? translate('shared.rosterstate.optioned') : translate('shared.rosterstate.abbr-optioned');
            else if (value === 3)
                textValue = isFullText ? translate('shared.rosterstate.designated') : translate('shared.rosterstate.abbr-designated');
            else if (value === 4)
                textValue = isFullText ? translate('shared.rosterstate.15il') : translate('shared.rosterstate.abbr-15il');
            else if (value === 5)
                textValue = isFullText ? translate('shared.rosterstate.60il') : translate('shared.rosterstate.abbr-60il');
            else if (value === 6)
                textValue = isFullText ? translate('shared.rosterstate.free-agent') : translate('shared.rosterstate.abbr-free-agent');
            else if (value === 7)
                textValue = isFullText ? translate('shared.rosterstate.inactive') : translate('shared.rosterstate.abbr-inactive');
            else if (value === 8)
                textValue = isFullText ? translate('shared.rosterstate.restricted') : translate('shared.rosterstate.abbr-restricted');
            else if (value === 9)
                textValue = isFullText ? translate('shared.rosterstate.7il') : translate('shared.rosterstate.abbr-7il');
            else if (value === 10)
                textValue = isFullText ? translate('shared.rosterstate.60il-minor') : translate('shared.rosterstate.abbr-60il-minor');
            else if (value === 11)
                textValue = isFullText ? translate('shared.rosterstate.7concussion') : translate('shared.rosterstate.abbr-7concussion');
            else if (value === 12)
                textValue = isFullText ? translate('shared.rosterstate.suspended') : translate('shared.rosterstate.abbr-suspended');
            else if (value === 13)
                textValue = isFullText ? translate('shared.rosterstate.non-roster-invite') : translate('shared.rosterstate.abbr-non-roster-invite');
            else if (value === 14)
                textValue = isFullText ? translate('shared.rosterstate.10il') : translate('shared.rosterstate.abbr-10il');
        }
    }
    else {
        textValue = isFullText ? 'Unknown' : '--';
        if (!isNaN(stateEnum)) {
            const value = Number(stateEnum);
            if (value === 1)
                textValue = isFullText ? 'Active' : 'ACT';
            else if (value === 2)
                textValue = isFullText ? 'Optioned' : 'OPT';
            else if (value === 3)
                textValue = isFullText ? 'Designated' : 'DES';
            else if (value === 4)
                textValue = isFullText ? '15-Day DL' : '15D';
            else if (value === 5)
                textValue = isFullText ? '60-Day DL' : '60D';
            else if (value === 6)
                textValue = isFullText ? 'Free Agent' : 'FA';
            else if (value === 7)
                textValue = isFullText ? 'Inactive' : 'INACT';
            else if (value === 8)
                textValue = isFullText ? 'Restricted' : 'RES';
            else if (value === 9)
                textValue = isFullText ? '7-Day DL' : '7D';
            else if (value === 10)
                textValue = isFullText ? '60-Day Minor DL' : '60D';
            else if (value === 11)
                textValue = isFullText ? '7-Day Concussion' : '7DC';
            else if (value === 12)
                textValue = isFullText ? 'Suspended' : 'SUS';
            else if (value === 13)
                textValue = isFullText ? 'Non-Roster Invite' : 'NRI';
            else if (value === 14)
                textValue = isFullText ? '10-Day DL' : '10D';
        }
    }
    return textValue;
};
const grade = (gradeEnum, isAmateurGrade = false) => {
    let textValue = '-';
    if (!isNaN(gradeEnum)) {
        const value = Number(gradeEnum);
        if (value === 1)
            textValue = isAmateurGrade ? 'A' : '8';
        else if (value === 2)
            textValue = isAmateurGrade ? 'A-' : '7';
        else if (value === 3)
            textValue = isAmateurGrade ? 'B+' : '6+';
        else if (value === 4)
            textValue = isAmateurGrade ? 'B' : '6';
        else if (value === 5)
            textValue = isAmateurGrade ? 'B-' : '6-';
        else if (value === 6)
            textValue = isAmateurGrade ? 'C+' : '5+';
        else if (value === 7)
            textValue = isAmateurGrade ? 'C' : '5';
        else if (value === 8)
            textValue = isAmateurGrade ? 'C-' : '5-';
        else if (value === 9)
            textValue = isAmateurGrade ? 'D+' : '4+';
        else if (value === 10)
            textValue = isAmateurGrade ? 'D' : '4';
        else if (value === 11)
            textValue = isAmateurGrade ? 'D-' : '4-';
        else if (value === 12)
            textValue = isAmateurGrade ? 'E' : '3';
        else if (value === 13)
            textValue = isAmateurGrade ? 'F' : '2';
        else if (value === 14)
            textValue = 'G';
        else if (value === 15)
            textValue = isAmateurGrade ? 'H' : '1';
        else if (value === 16)
            textValue = 'P';
        else if (value === 17)
            textValue = 'R';
    }
    return textValue;
};
const hsClassName = (classEnum, isFullText = false, translate = null) => {
    if (translate) {
        let textValue = isFullText ? translate('common.unknown') : '--';
        if (!isNaN(classEnum)) {
            const value = Number(classEnum);
            if (value === 1)
                textValue = isFullText ? translate('shared.class.freshman') : translate('shared.class.abbr-freshman');
            else if (value === 2)
                textValue = isFullText ? translate('shared.class.sophomore') : translate('shared.class.abbr-sophomore');
            else if (value === 3)
                textValue = isFullText ? translate('shared.class.junior') : translate('shared.class.abbr-junior');
            else if (value === 4)
                textValue = isFullText ? translate('shared.class.senior') : translate('shared.class.abbr-senior');
            else if (value === 5)
                textValue = isFullText ? translate('shared.class.high-school') : translate('shared.class.abbr-high-school');
            else if (value === 6)
                textValue = isFullText ? translate('shared.class.jr-college-1') : translate('shared.class.abbr-jr-college-1');
            else if (value === 7)
                textValue = isFullText ? translate('shared.class.jr-college-2') : translate('shared.class.abbr-jr-college-2');
        }
        return textValue;
    }
    let textValue = isFullText ? 'Unknown' : '--';
    if (!isNaN(classEnum)) {
        const value = Number(classEnum);
        if (value === 1)
            textValue = isFullText ? 'Freshman' : 'C1';
        else if (value === 2)
            textValue = isFullText ? 'Sophomore' : 'C2';
        else if (value === 3)
            textValue = isFullText ? 'Junior' : 'C3';
        else if (value === 4)
            textValue = isFullText ? 'Senior' : 'C4';
        else if (value === 5)
            textValue = isFullText ? 'High School' : 'HS';
        else if (value === 6)
            textValue = isFullText ? '1st Yr Junior College' : 'JC1';
        else if (value === 7)
            textValue = isFullText ? '2nd Yr Junior College' : 'JC2';
    }
    return textValue;
};
const hitType = (hittype, isFullText = false, translate = null) => {
    let textValue = '';
    if (translate) {
        if (!isNaN(hittype)) {
            const value = Number(hittype);
            if (value === 0)
                textValue = isFullText ? translate('baseball.pitchresult.groundball') : translate('baseball.pitchresult.abbr-groundball');
            else if (value === 1)
                textValue = isFullText ? translate('baseball.pitchresult.flyball') : translate('baseball.pitchresult.abbr-flyball');
            else if (value === 2)
                textValue = isFullText ? translate('baseball.pitchresult.linedrive') : translate('baseball.pitchresult.abbr-linedrive');
            else if (value === 3)
                textValue = isFullText ? translate('baseball.pitchresult.popfly') : translate('baseball.pitchresult.abbr-popup');
            else if (value >= 4 && value <= 6)
                textValue = translate('baseball.pitchresult.bunt');
        }
    }
    else if (!isNaN(hittype)) {
        const value = Number(hittype);
        if (value === 0)
            textValue = isFullText ? 'Ground Ball' : 'GB';
        else if (value === 1)
            textValue = isFullText ? 'Fly Ball' : 'FB';
        else if (value === 2)
            textValue = isFullText ? 'Line Drive' : 'LD';
        else if (value === 3)
            textValue = isFullText ? 'Pop Fly' : 'Pop';
        else if (value >= 4 && value <= 6)
            textValue = 'Bunt';
    }
    return textValue;
};
const pitchResult = (resultid, isFullDescription = false, translate = null) => {
    let textValue = 'Unknown';
    if (translate) {
        if (!isNaN(resultid)) {
            const value = Number(resultid);
            if (isFullDescription) {
                if (value === 0)
                    textValue = translate('baseball.pitchresult.no-pitch');
                else if (value === 1)
                    textValue = translate('baseball.balls_one');
                else if (value === 2)
                    textValue = translate('baseball.pitchresult.intentional-ball');
                else if (value === 3)
                    textValue = translate('baseball.pitchresult.pitchout');
                else if (value === 4)
                    textValue = translate('baseball.pitchresult.taken-strike');
                else if (value === 5)
                    textValue = translate('baseball.pitchresult.swing-miss-pitchout');
                else if (value === 6)
                    textValue = translate('baseball.pitchresult.swing-miss');
                else if (value === 7)
                    textValue = translate('baseball.pitchresult.bunt-miss');
                else if (value === 8)
                    textValue = translate('baseball.pitchresult.foul-ball');
                else if (value === 9)
                    textValue = translate('baseball.pitchresult.foul-bunt');
                else if (value === 10)
                    textValue = translate('baseball.pitchresult.foul-ball-hit-run');
                else if (value === 11)
                    textValue = translate('baseball.pitchresult.foul-bunt-hit-run');
                else if (value === 12)
                    textValue = translate('baseball.pitchresult.foul-tip');
                else if (value === 13)
                    textValue = translate('baseball.pitchresult.foul-tip-hit-run');
                else if (value === 14)
                    textValue = translate('baseball.pitchresult.in-play');
                else if (value === 15)
                    textValue = translate('baseball.pitchresult.in-play-hit-run');
                else if (value === 16)
                    textValue = translate('baseball.pitchresult.catcher-block');
                else if (value === 17)
                    textValue = `${translate('baseball.pitchresult.pickoff')} ${translate('baseball.pitcher_one')} ${translate('common.to')} ${translate('baseball.1b')}`;
                else if (value === 18)
                    textValue = `${translate('baseball.pitchresult.pickoff')} ${translate('baseball.pitcher_one')} ${translate('common.to')} ${translate('baseball.2b')}`;
                else if (value === 19)
                    textValue = `${translate('baseball.pitchresult.pickoff')} ${translate('baseball.pitcher_one')} ${translate('common.to')} ${translate('baseball.3b')}`;
                else if (value === 20)
                    textValue = `${translate('baseball.catcher_one')} ${translate('baseball.pitchresult.pickoff')}`;
                else if (value === 21)
                    textValue = `${translate('baseball.balls_one')} - ${translate('baseball.pitchresult.no-pitch')}`;
            }
            else if (value === 1)
                textValue = translate('baseball.balls_one');
            else if (value === 2)
                textValue = `${translate('baseball.balls_one')} (Int)`;
            else if (value === 3)
                textValue = `${translate('baseball.balls_one')} (PO)`;
            else if (value === 4)
                textValue = `${translate('baseball.strikes_one')} (${translate('baseball.looking')})`;
            else if (value >= 5 && value <= 7)
                textValue = `${translate('baseball.strikes_one')} (${translate('baseball.swinging')})`;
            else if (value >= 8 && value <= 11)
                textValue = translate('baseball.pitchresult.foul');
            else if (value >= 12 && value <= 13)
                textValue = translate('baseball.pitchresult.foul-tip');
            else if (value >= 14 && value <= 15)
                textValue = translate('baseball.pitchresult.in-play');
            else if (value >= 17 && value <= 19)
                textValue = translate('baseball.pitchresult.pickoff');
        }
    }
    else if (!isNaN(resultid)) {
        const value = Number(resultid);
        if (isFullDescription) {
            if (value === 0)
                textValue = 'No Pitch';
            else if (value === 1)
                textValue = 'Ball';
            else if (value === 2)
                textValue = 'Intentional Ball';
            else if (value === 3)
                textValue = 'Pitchout';
            else if (value === 4)
                textValue = 'Taken Strike';
            else if (value === 5)
                textValue = 'Swing and Miss at Pitchout';
            else if (value === 6)
                textValue = 'Swing and Miss';
            else if (value === 7)
                textValue = 'Bunt and Miss';
            else if (value === 8)
                textValue = 'Foul Ball';
            else if (value === 9)
                textValue = 'Foul Bunt';
            else if (value === 10)
                textValue = 'Foul Ball on Hit and Run';
            else if (value === 11)
                textValue = 'Foul Bunt on Hit and Run';
            else if (value === 12)
                textValue = 'Foul Tip';
            else if (value === 13)
                textValue = 'Foul Tip on Hit and Run';
            else if (value === 14)
                textValue = 'In Play';
            else if (value === 15)
                textValue = 'In Play on Hit and Run';
            else if (value === 16)
                textValue = 'Catcher Block';
            else if (value === 17)
                textValue = 'Pickoff Pitcher to 1B';
            else if (value === 18)
                textValue = 'Pickoff Pitcher to 2B';
            else if (value === 19)
                textValue = 'Pickoff Pitcher to 3B';
            else if (value === 20)
                textValue = 'Catcher Pickoff';
            else if (value === 21)
                textValue = 'Ball - No Pitch';
        }
        else if (value === 1)
            textValue = 'Ball';
        else if (value === 2)
            textValue = 'Ball (Int)';
        else if (value === 3)
            textValue = 'Ball (PO)';
        else if (value === 4)
            textValue = 'Strike (Looking)';
        else if (value >= 5 && value <= 7)
            textValue = 'Strike (Swinging)';
        else if (value >= 8 && value <= 11)
            textValue = 'Foul';
        else if (value >= 12 && value <= 13)
            textValue = 'Foul Tip';
        else if (value >= 14 && value <= 15)
            textValue = 'In Play';
        else if (value >= 17 && value <= 19)
            textValue = 'Pickoff';
    }
    return textValue;
};
const LEVELS = [
    { id: 0, abbr: 'UNK', name: 'Unknown', sortorder: 99 },
    { id: 1, abbr: 'AAA', name: 'Triple A', sortorder: 3 },
    { id: 2, abbr: 'AA', name: 'Double A', sortorder: 4 },
    { id: 3, abbr: 'A+', name: 'Single A (Advanced)', sortorder: 5 },
    { id: 4, abbr: 'A', name: 'Single A (Full Season)', sortorder: 6 },
    { id: 5, abbr: 'A-', name: 'Single A (Short Season)', sortorder: 7 },
    { id: 6, abbr: 'INT', name: 'International Baseball', sortorder: 13 },
    { id: 7, abbr: 'MIN', name: 'Minor League Baseball', sortorder: 2 },
    { id: 8, abbr: 'MLB', name: 'Major League Baseball', sortorder: 1 },
    { id: 9, abbr: 'OLY', name: 'Olympic Baseball', sortorder: 12 },
    { id: 10, abbr: 'R', name: 'Rookie', sortorder: 8 },
    { id: 11, abbr: 'WIN', name: 'Winter Leagues', sortorder: 11 },
    { id: 20, abbr: 'SPR', name: 'Major League Spring Training', sortorder: 30 },
    { id: 21, abbr: 'POS', name: 'Major League Post Season', sortorder: 31 },
    { id: 22, abbr: 'NPS', name: 'Nippon Professional Post Season', sortorder: 32 },
    { id: 23, abbr: 'ASG', name: 'All-Star Exhibition', sortorder: 33 },
    { id: 24, abbr: 'EXT', name: 'Extended Spring Training', sortorder: 34 },
    { id: 25, abbr: 'INS', name: 'Instructional League', sortorder: 37 },
    { id: 26, abbr: 'MST', name: 'Minor League Spring Training', sortorder: 35 },
    { id: 27, abbr: 'DTL', name: 'DSL Parallel League ', sortorder: 36 },
    { id: 28, abbr: 'ISH', name: 'International Showcase ', sortorder: 38 },
    { id: 29, abbr: 'SIM', name: 'Simulated Games ', sortorder: 39 },
    { id: 31, abbr: 'DV1', name: 'NCAA Division I Baseball', sortorder: 50 },
    { id: 32, abbr: 'DV2', name: 'NCAA Division II Baseball', sortorder: 51 },
    { id: 33, abbr: 'DV3', name: 'NCAA Division III Baseball', sortorder: 52 },
    { id: 34, abbr: 'NJC', name: 'NJCAA Division I Baseball', sortorder: 53 },
    { id: 35, abbr: 'NJ2', name: 'NJCAA Division II Baseball', sortorder: 54 },
    { id: 36, abbr: 'NJ3', name: 'NJCAA Division III Baseball', sortorder: 55 },
    { id: 37, abbr: 'NAI', name: 'NAIA Division I Baseball', sortorder: 56 },
    { id: 38, abbr: 'SUM', name: 'Summer League Baseball', sortorder: 57 },
    { id: 39, abbr: 'HS', name: 'High School', sortorder: 58 },
    { id: 40, abbr: 'SHO', name: 'High School Showcase', sortorder: 59 },
    { id: 101, abbr: 'MEX', name: 'Mexican Leagues', sortorder: 20 },
    { id: 102, abbr: 'NPB', name: 'Nippon Professional Baseball', sortorder: 21 },
    { id: 103, abbr: 'IND', name: 'Independent League Baseball', sortorder: 22 },
    { id: 104, abbr: 'KBO', name: 'Korean Baseball Organization', sortorder: 23 },
    { id: 105, abbr: 'CUB', name: 'Cuban Baseball Leagues', sortorder: 24 },
    { id: 106, abbr: 'IWL', name: 'Indy Winter Leagues', sortorder: 40 },
    { id: 107, abbr: 'CSL', name: 'Cuban Senior Development League (U23)', sortorder: 25 },
    { id: 108, abbr: 'CYL', name: 'Cuban Youth Development League (U18-)', sortorder: 26 },
    { id: 109, abbr: 'KPS', name: 'Korean Baseball Post Season', sortorder: 27 },
];
const BASE_EVENTS = (translate = null) => {
    if (translate) {
        return [
            { id: 0, abbr: '--', name: translate('shared.events.unofficial') },
            { id: 1, abbr: '1B', name: translate('shared.events.single') },
            { id: 2, abbr: '2B', name: translate('shared.events.double') },
            { id: 3, abbr: '3B', name: translate('shared.events.triple') },
            { id: 4, abbr: 'HR', name: translate('baseball.home-run') },
            { id: 5, abbr: 'UBB', name: translate('shared.events.unintentional-walk'), altName: translate('shared.events.walk') },
            { id: 6, abbr: 'HBP', name: translate('shared.events.hit-by-pitch') },
            { id: 7, abbr: 'SO', name: translate('shared.events.strike-out') },
            { id: 8, abbr: 'Out', name: translate('shared.events.batted-out') },
            { id: 9, abbr: 'Int', name: translate('shared.events.catcher-interference') },
            { id: 10, abbr: 'IBB', name: translate('shared.events.intentional-walk'), altName: `${translate('shared.events.walk')} (Int)` },
            { id: 11, abbr: 'SH', name: translate('shared.events.sacrifice-hit') },
            { id: 12, abbr: 'SF', name: translate('shared.events.sacrifice-fly') },
            { id: 13, abbr: 'FC', name: translate('shared.events.fielders-choice') },
            { id: 14, abbr: 'RoE', name: translate('shared.events.reach-on-error') },
            { id: 15, abbr: 'BInt', name: translate('shared.events.batter-interference-out'), altName: translate('shared.events.interference-batter') },
            { id: 100, abbr: translate('common.unknown'), name: translate('common.unknown') },
            { id: 101, abbr: 'SB', name: translate('shared.events.stolen-base') },
            { id: 102, abbr: 'CS', name: translate('shared.events.caught-stealing') },
            { id: 103, abbr: 'PO', name: translate('baseball.pitchresult.pickoff') },
            { id: 104, abbr: 'WP', name: translate('shared.events.wild-pitch') },
            { id: 105, abbr: 'PB', name: translate('shared.events.passed-ball') },
            { id: 106, abbr: 'BLK', name: translate('shared.events.balk') },
            { id: 107, abbr: 'AoE', name: translate('shared.events.advance-on-error'), altName: translate('shared.events.advance-on-error-short') },
            { id: 108, abbr: 'POE', name: translate('shared.events.pickoff-error') },
            { id: 109, abbr: 'OA', name: translate('shared.events.out-advancing') },
            { id: 110, abbr: 'AoT', name: translate('shared.events.advance-on-throw') },
            { id: 111, abbr: 'BRInt', name: translate('shared.events.base-runners-interference') },
            { id: 112, abbr: 'DI', name: translate('shared.events.defensive-indifference') },
            { id: 113, abbr: 'FFE', name: translate('shared.events.foul-fly') },
            { id: 114, abbr: 'OB', name: translate('shared.events.obstruction') },
        ];
    }
    return [{ id: 0, abbr: '--', name: 'Unofficial' },
        { id: 1, abbr: '1B', name: 'Single' },
        { id: 2, abbr: '2B', name: 'Double' },
        { id: 3, abbr: '3B', name: 'Triple' },
        { id: 4, abbr: 'HR', name: 'Home Run' },
        { id: 5, abbr: 'UBB', name: 'Unintentional Walk', altName: 'Walk' },
        { id: 6, abbr: 'HBP', name: 'Hit By Pitch' },
        { id: 7, abbr: 'SO', name: 'Strike Out' },
        { id: 8, abbr: 'Out', name: 'Batted Out' },
        { id: 9, abbr: 'Int', name: 'Catcher Interference' },
        { id: 10, abbr: 'IBB', name: 'Intentional Walk', altName: 'Walk (Int)' },
        { id: 11, abbr: 'SH', name: 'Sacrifice Hit' },
        { id: 12, abbr: 'SF', name: 'Sacrifice Fly' },
        { id: 13, abbr: 'FC', name: 'Fielders Choice' },
        { id: 14, abbr: 'RoE', name: 'Reach On Error' },
        { id: 15, abbr: 'BInt', name: 'Batter Interference/Out', altName: 'Interference (Batter)' },
        { id: 100, abbr: 'Unknown', name: 'Unknown' },
        { id: 101, abbr: 'SB', name: 'Stolen Base' },
        { id: 102, abbr: 'CS', name: 'Caught Stealing' },
        { id: 103, abbr: 'PO', name: 'Pickoff' },
        { id: 104, abbr: 'WP', name: 'Wild Pitch' },
        { id: 105, abbr: 'PB', name: 'Passed Ball' },
        { id: 106, abbr: 'BLK', name: 'Balk' },
        { id: 107, abbr: 'AoE', name: 'Advance on Error', altName: 'Adv on Error' },
        { id: 108, abbr: 'POE', name: 'Pickoff/Error' },
        { id: 109, abbr: 'OA', name: 'Out Advancing' },
        { id: 110, abbr: 'AoT', name: 'Advance on Throw' },
        { id: 111, abbr: 'BRInt', name: 'Base Runners Interference' },
        { id: 112, abbr: 'DI', name: 'Defensive Indifference' },
        { id: 113, abbr: 'FFE', name: 'Foul Fly/Error' },
        { id: 114, abbr: 'OB', name: 'Obstruction' },
    ];
};
// Do not translate, these are to match DB values
const TRANSLATION_CONTEXTS = [
    { id: 0, name: 'Unknown' },
    { id: 1, name: 'Shared' },
    { id: 2, name: 'ComponentLibrary' },
    { id: 3, name: 'PlayerPortal' },
];
const baseEvent = (baseevent, isFullText = false, emptyvalue = '', translate = null) => {
    let event = emptyvalue;
    if (!isNumber$2(baseevent))
        event = baseevent.toString();
    else {
        const value = BASE_EVENTS(translate).find(({ id }) => id === baseevent);
        if (value)
            event = isFullText ? value.name : value.abbr;
    }
    return event;
};

const positionName = (positionEnum, translate = null) => {
    const position = typeof positionEnum === 'number' ? positionEnum : parseInt(positionEnum);
    switch (position) {
        case 1: return translate ? translate('baseball.positions.abbr-pitcher') : 'P';
        case 11: return translate ? translate('baseball.positions.abbr-pitcher-starting') : 'SP';
        case 12: return translate ? translate('baseball.positions.abbr-pitcher-relief') : 'RP';
        case 2: return translate ? translate('baseball.positions.abbr-catcher') : 'C';
        case 3: return translate ? translate('baseball.positions.abbr-first-base') : '1B';
        case 4: return translate ? translate('baseball.positions.abbr-second-base') : '2B';
        case 5: return translate ? translate('baseball.positions.abbr-third-base') : '3B';
        case 6: return translate ? translate('baseball.positions.abbr-shortstop') : 'SS';
        case 7: return translate ? translate('baseball.positions.abbr-leftfield') : 'LF';
        case 8: return translate ? translate('baseball.positions.abbr-centerfield') : 'CF';
        case 9: return translate ? translate('baseball.positions.abbr-rightfield') : 'RF';
        case 10: return translate ? translate('baseball.positions.abbr-designated-hitter') : 'DH';
        case 13: return translate ? translate('baseball.positions.abbr-infield') : 'INF';
        case 14: return translate ? translate('baseball.positions.abbr-outfield') : 'OF';
        default: return '--';
    }
};
const positionAbbrToInt = (positionAbbr) => {
    switch (positionAbbr) {
        case 'P': return 1;
        case 'SP': return 11;
        case 'RP': return 12;
        case 'C': return 2;
        case '1B': return 3;
        case '2B': return 4;
        case '3B': return 5;
        case 'SS': return 6;
        case 'LF': return 7;
        case 'CF': return 8;
        case 'RF': return 9;
        case 'DH': return 10;
        case 'INF': return 13;
        case 'OF': return 14;
        default: return 0;
    }
};
const positionLongName = (positionEnum, translate = null) => {
    switch (positionEnum) {
        case 0: return translate ? translate('baseball.positions.no-position') : 'No Position';
        case 1: return translate ? translate('baseball.pitcher_one') : 'Pitcher';
        case 11: return translate ? translate('baseball.positions.pitcher-starting') : 'Starting Pitcher';
        case 12: return translate ? translate('baseball.positions.pitcher-relief') : 'Relief Pitcher';
        case 2: return translate ? translate('baseball.catcher_one') : 'Catcher';
        case 3: return translate ? translate('baseball.positions.first-base') : 'First Base';
        case 4: return translate ? translate('baseball.positions.second-base') : 'Second Base';
        case 5: return translate ? translate('baseball.positions.third-base') : 'Third Base';
        case 6: return translate ? translate('baseball.positions.shortstop') : 'Shortstop';
        case 7: return translate ? translate('baseball.positions.left-field') : 'Left Field';
        case 8: return translate ? translate('baseball.positions.center-field') : 'Center Field';
        case 9: return translate ? translate('baseball.positions.right-field') : 'Right Field';
        case 10: return translate ? translate('baseball.positions.designated-hitter') : 'Designated Hitter';
        default: return undefined;
    }
};

const freeAgentYear = (faYear, isAbbrYear = false) => {
    if (!faYear)
        return null;
    return isAbbrYear
        ? `'${(faYear - 1) % 100}-'${faYear % 100}`
        : `${faYear - 1}-${faYear % 100}`;
};
const formatSalary = (salary, withDollarSign = false, precision) => {
    let formattedSalary = null;
    if (salary > 0 && salary < 1000) {
        // always show $ so that we don't mistake tiny salaries for larger ones
        formattedSalary = `$${salary.toFixed(precision || 0)}`;
    }
    else if (salary >= 1000) {
        const currencySign = withDollarSign ? '$' : '';
        if (salary < 1000000) {
            formattedSalary = `${currencySign}${(salary / 1000.00).toFixed(precision || 0)}k`;
        }
        else {
            formattedSalary = `${currencySign}${(salary / 1000000.00).toFixed(precision !== undefined ? precision : 1)}M`;
        }
    }
    return formattedSalary;
};
const formatSalaryMillions = (salary, withDollarSign = false, precision) => {
    if (salary === null)
        return null;
    const currencySign = withDollarSign ? '$' : '';
    if (salary === 0)
        return `${currencySign}0M`;
    const sign = salary < 0 ? '-' : '';
    return `${sign}${currencySign}${(Math.abs(salary) / 1000000.00).toFixed(precision !== undefined ? precision : 1)}M`;
};
const floatSafeModulus = (val, step) => {
    const valDecCount = (val.toString().split('.')[1] || '').length;
    const stepDecCount = (step.toString().split('.')[1] || '').length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(parseFloat(val.toString()).toFixed(decCount).replace('.', ''));
    const stepInt = parseInt(step.toFixed(decCount).replace('.', ''));
    return (valInt % stepInt) / (Math.pow(10, decCount));
};
const height = (heightIn, showWithTicks = false) => {
    if (heightIn >= 0) {
        const feet = Math.floor(heightIn / 12);
        const inches = floatSafeModulus(heightIn, 12);
        return showWithTicks ? `${Math.abs(feet) > 0 ? `${feet}'` : ''}${inches}"` : `${Math.abs(feet) > 0 ? `${feet}-` : ''}${inches}`;
    }
    return null;
};
const validAge = (years) => (years > 5 ? years : null);

/* eslint-disable max-len */
const PITCH_TYPES = (translate = null) => {
    if (translate) {
        return [
            { id: 0, name: translate('common.unknown'), abbr: '--', sortorder: 0, color: '#000000' },
            { id: 1, name: translate('baseball.pitches.fastball_one'), abbr: translate('baseball.pitches.abbr-fastball'), sortorder: 1, color: '#777777' },
            { id: 2, name: translate('baseball.pitches.curve'), abbr: translate('baseball.pitches.abbr-curveball'), sortorder: 4, color: '#a6cee3', isfxtype: true },
            { id: 3, name: translate('baseball.pitches.slider'), abbr: translate('baseball.pitches.abbr-slider'), sortorder: 5, color: '#1f78b4', isfxtype: true },
            { id: 4, name: translate('baseball.pitches.changeup_one'), abbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#33a02c', isfxtype: true },
            { id: 5, name: translate('baseball.pitches.sinker'), abbr: translate('baseball.pitches.abbr-sinker'), sortorder: 7, color: '#b15928', isfxtype: true },
            { id: 6, name: translate('baseball.pitches.knuckleball'), abbr: translate('baseball.pitches.abbr-knuckleball'), sortorder: 8, color: '#fb9a99', isfxtype: true },
            { id: 7, name: translate('baseball.pitches.splitter'), abbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#cab2d6', isfxtype: true },
            { id: 8, name: translate('baseball.pitches.cutter'), abbr: translate('baseball.pitches.abbr-cutter'), sortorder: 10, color: '#6a3d9a', isfxtype: true },
            { id: 9, name: translate('baseball.pitches.fastball-2'), abbr: translate('baseball.pitches.abbr-fastball-2'), sortorder: 2, color: '#e31a1c', isfxtype: true },
            { id: 10, name: translate('baseball.pitches.fastball-4'), abbr: translate('baseball.pitches.abbr-fastball-4'), sortorder: 3, color: '#ff7f00', isfxtype: true },
            { id: 11, name: translate('baseball.pitches.knuckle-curve'), abbr: translate('baseball.pitches.abbr-knuckle-curve'), sortorder: 21, color: '#b2df8a' },
            { id: 12, name: translate('baseball.pitches.forkball'), abbr: translate('baseball.pitches.abbr-forkball'), sortorder: 22, color: '#ffff99' },
            { id: 13, name: translate('baseball.pitches.gyroball'), abbr: translate('baseball.pitches.abbr-gyroball'), sortorder: 23, color: '#fdbf6f' },
            { id: 14, name: translate('baseball.pitches.screwball'), abbr: translate('baseball.pitches.abbr-screwball'), sortorder: 24, color: '#440000' },
            { id: 15, name: translate('baseball.pitches.shuuto'), abbr: translate('baseball.pitches.abbr-shuuto'), sortorder: 25, color: '#cccccc' },
            { id: 16, name: translate('baseball.pitches.fastball-topspin'), abbr: translate('baseball.pitches.abbr-fastball-topspin'), sortorder: 26, color: '#006b3c', isfxtype: true },
            { id: 100, name: translate('baseball.pitches.breaking-ball_one'), abbr: translate('baseball.pitches.abbr-breaking-ball'), sortorder: 98 },
            { id: 101, name: translate('baseball.pitches.offspeed'), abbr: translate('baseball.pitches.abbr-offspeed'), sortorder: 99 },
        ];
    }
    return [
        { id: 0, name: 'Unknown', abbr: '--', sortorder: 0, color: '#000000' },
        { id: 1, name: 'Fastball', abbr: 'FB', sortorder: 1, color: '#777777' },
        { id: 2, name: 'Curve', abbr: 'CB', sortorder: 4, color: '#a6cee3', isfxtype: true },
        { id: 3, name: 'Slider', abbr: 'SL', sortorder: 5, color: '#1f78b4', isfxtype: true },
        { id: 4, name: 'Changeup', abbr: 'CH', sortorder: 6, color: '#33a02c', isfxtype: true },
        { id: 5, name: 'Sinker', abbr: 'SI', sortorder: 7, color: '#b15928', isfxtype: true },
        { id: 6, name: 'Knuckleball', abbr: 'KN', sortorder: 8, color: '#fb9a99', isfxtype: true },
        { id: 7, name: 'Splitter', abbr: 'SP', sortorder: 9, color: '#cab2d6', isfxtype: true },
        { id: 8, name: 'Cutter', abbr: 'CT', sortorder: 10, color: '#6a3d9a', isfxtype: true },
        { id: 9, name: 'Two-Seam Fastball', abbr: '2FB', sortorder: 2, color: '#e31a1c', isfxtype: true },
        { id: 10, name: 'Four-Seam Fastball', abbr: '4FB', sortorder: 3, color: '#ff7f00', isfxtype: true },
        { id: 11, name: 'Knuckle Curve', abbr: 'KNC', sortorder: 21, color: '#b2df8a' },
        { id: 12, name: 'Forkball', abbr: 'FKB', sortorder: 22, color: '#ffff99' },
        { id: 13, name: 'Gyroball', abbr: 'GYR', sortorder: 23, color: '#fdbf6f' },
        { id: 14, name: 'Screwball', abbr: 'SRW', sortorder: 24, color: '#440000' },
        { id: 15, name: 'Shuuto', abbr: 'SHU', sortorder: 25, color: '#cccccc' },
        { id: 16, name: 'Topspin Fastball', abbr: 'TFB', sortorder: 26, color: '#006b3c', isfxtype: true },
        { id: 100, name: 'Breaking Ball', abbr: 'BRK', sortorder: 98 },
        { id: 101, name: 'Offspeed', abbr: 'OFF', sortorder: 99 },
    ];
};
const PITCH_SUB_TYPES = (translate = null) => {
    if (translate) {
        return [
            { id: 20, name: translate('baseball.pitchsubtypes.curveball.rhp'), abbr: translate('baseball.pitchsubtypes.abbr-curveball.rhp'), typeid: 2, typename: translate('baseball.pitches.curve'), typeabbr: translate('baseball.pitches.abbr-curveball'), sortorder: 4, color: '#1e3a8a' },
            { id: 21, name: translate('baseball.pitchsubtypes.curveball.lhp'), abbr: translate('baseball.pitchsubtypes.abbr-curveball.lhp'), typeid: 2, typename: translate('baseball.pitches.curve'), typeabbr: translate('baseball.pitches.abbr-curveball'), sortorder: 4, color: '#1e3a8a' },
            { id: 22, name: translate('baseball.pitchsubtypes.curveball.dropdown'), abbr: translate('baseball.pitchsubtypes.abbr-curveball.dropdown'), typeid: 2, typename: translate('baseball.pitches.curve'), typeabbr: translate('baseball.pitches.abbr-curveball'), sortorder: 4, color: '#3b82f6' },
            { id: 23, name: translate('baseball.pitchsubtypes.curveball.slow'), abbr: translate('baseball.pitchsubtypes.abbr-curveball.slow'), typeid: 2, typename: translate('baseball.pitches.curve'), typeabbr: translate('baseball.pitches.abbr-curveball'), sortorder: 4, color: '#1e40af' },
            { id: 30, name: translate('baseball.pitchsubtypes.slider.rhp'), abbr: translate('baseball.pitchsubtypes.abbr-slider.rhp'), typeid: 3, typename: translate('baseball.pitches.slider'), typeabbr: translate('baseball.pitches.abbr-slider'), sortorder: 5, color: '#0369a1' },
            { id: 31, name: translate('baseball.pitchsubtypes.slider.lhp'), abbr: translate('baseball.pitchsubtypes.abbr-slider.lhp'), typeid: 3, typename: translate('baseball.pitches.slider'), typeabbr: translate('baseball.pitches.abbr-slider'), sortorder: 5, color: '#0369a1' },
            { id: 32, name: translate('baseball.pitchsubtypes.slider.dropdown'), abbr: translate('baseball.pitchsubtypes.abbr-slider.dropdown'), typeid: 3, typename: translate('baseball.pitches.slider'), typeabbr: translate('baseball.pitches.abbr-slider'), sortorder: 5, color: '#475569' },
            { id: 33, name: translate('baseball.pitchsubtypes.slider.gyro'), abbr: translate('baseball.pitchsubtypes.abbr-slider.gyro'), typeid: 3, typename: translate('baseball.pitches.slider'), typeabbr: translate('baseball.pitches.abbr-slider'), sortorder: 5, color: '#713f12' },
            { id: 34, name: translate('baseball.pitchsubtypes.slider.sweeper'), abbr: translate('baseball.pitchsubtypes.abbr-slider.sweeper'), typeid: 3, typename: translate('baseball.pitches.slider'), typeabbr: translate('baseball.pitches.abbr-slider'), sortorder: 5, color: '#06b6d4' },
            { id: 35, name: translate('baseball.pitchsubtypes.slider.whirly'), abbr: translate('baseball.pitchsubtypes.abbr-slider.whirly'), typeid: 3, typename: translate('baseball.pitches.slider'), typeabbr: translate('baseball.pitches.abbr-slider'), sortorder: 5, color: '#a5f3fc' },
            { id: 40, name: translate('baseball.pitchsubtypes.changeup_one.rhp'), abbr: translate('baseball.pitchsubtypes.abbr-changeup.rhp'), typeid: 4, typename: translate('baseball.pitches.changeup_one'), typeabbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#064e3b' },
            { id: 41, name: translate('baseball.pitchsubtypes.changeup_one.lhp'), abbr: translate('baseball.pitchsubtypes.abbr-changeup.lhp'), typeid: 4, typename: translate('baseball.pitches.changeup_one'), typeabbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#064e3b' },
            { id: 42, name: translate('baseball.pitchsubtypes.changeup_one.dropdown'), abbr: translate('baseball.pitchsubtypes.abbr-changeup.dropdown'), typeid: 4, typename: translate('baseball.pitches.changeup_one'), typeabbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#047857' },
            { id: 43, name: translate('baseball.pitchsubtypes.changeup_one.twoseam'), abbr: translate('baseball.pitchsubtypes.abbr-changeup.twoseam'), typeid: 4, typename: translate('baseball.pitches.changeup_one'), typeabbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#059669' },
            { id: 44, name: translate('baseball.pitchsubtypes.changeup_one.fourseam'), abbr: translate('baseball.pitchsubtypes.abbr-changeup.fourseam'), typeid: 4, typename: translate('baseball.pitches.changeup_one'), typeabbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#10b981' },
            { id: 45, name: translate('baseball.pitchsubtypes.changeup_one.oneseam'), abbr: translate('baseball.pitchsubtypes.abbr-changeup.oneseam'), typeid: 4, typename: translate('baseball.pitches.changeup_one'), typeabbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#34d399' },
            { id: 46, name: translate('baseball.pitchsubtypes.changeup_one.looper'), abbr: translate('baseball.pitchsubtypes.abbr-changeup.looper'), typeid: 4, typename: translate('baseball.pitches.changeup_one'), typeabbr: translate('baseball.pitches.abbr-changeup'), sortorder: 6, color: '#6ee7b7' },
            { id: 70, name: translate('baseball.pitchsubtypes.splitter.rhp'), abbr: translate('baseball.pitchsubtypes.abbr-splitter.rhp'), typeid: 7, typename: translate('baseball.pitches.splitter'), typeabbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#f3e8ff' },
            { id: 71, name: translate('baseball.pitchsubtypes.splitter.lhp'), abbr: translate('baseball.pitchsubtypes.abbr-splitter.lhp'), typeid: 7, typename: translate('baseball.pitches.splitter'), typeabbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#f3e8ff' },
            { id: 72, name: translate('baseball.pitchsubtypes.splitter.dropdown'), abbr: translate('baseball.pitchsubtypes.abbr-splitter.dropdown'), typeid: 7, typename: translate('baseball.pitches.splitter'), typeabbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#f5d0fe' },
            { id: 73, name: translate('baseball.pitchsubtypes.splitter.twoseam'), abbr: translate('baseball.pitchsubtypes.abbr-splitter.twoseam'), typeid: 7, typename: translate('baseball.pitches.splitter'), typeabbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#e9d5ff' },
            { id: 74, name: translate('baseball.pitchsubtypes.splitter.fourseam'), abbr: translate('baseball.pitchsubtypes.abbr-splitter.fourseam'), typeid: 7, typename: translate('baseball.pitches.splitter'), typeabbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#d8b4fe' },
            { id: 75, name: translate('baseball.pitchsubtypes.splitter.oneseam'), abbr: translate('baseball.pitchsubtypes.abbr-splitter.oneseam'), typeid: 7, typename: translate('baseball.pitches.splitter'), typeabbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#c084fc' },
            { id: 76, name: translate('baseball.pitchsubtypes.splitter.looper'), abbr: translate('baseball.pitchsubtypes.abbr-splitter.looper'), typeid: 7, typename: translate('baseball.pitches.splitter'), typeabbr: translate('baseball.pitches.abbr-splitter'), sortorder: 9, color: '#9333ea' },
            { id: 80, name: translate('baseball.pitchsubtypes.cutter.rhp'), abbr: translate('baseball.pitchsubtypes.abbr-cutter.rhp'), typeid: 8, typename: translate('baseball.pitches.cutter'), typeabbr: translate('baseball.pitches.abbr-cutter'), sortorder: 10, color: '#581c87' },
            { id: 81, name: translate('baseball.pitchsubtypes.cutter.lhp'), abbr: translate('baseball.pitchsubtypes.abbr-cutter.lhp'), typeid: 8, typename: translate('baseball.pitches.cutter'), typeabbr: translate('baseball.pitches.abbr-cutter'), sortorder: 10, color: '#581c87' },
            { id: 82, name: translate('baseball.pitchsubtypes.cutter.dropdown'), abbr: translate('baseball.pitchsubtypes.abbr-cutter.dropdown'), typeid: 8, typename: translate('baseball.pitches.cutter'), typeabbr: translate('baseball.pitches.abbr-cutter'), sortorder: 10, color: '#701a75' },
            { id: 83, name: translate('baseball.pitchsubtypes.cutter.oneseam'), abbr: translate('baseball.pitchsubtypes.abbr-cutter.oneseam'), typeid: 8, typename: translate('baseball.pitches.cutter'), typeabbr: translate('baseball.pitches.abbr-cutter'), sortorder: 10, color: '#6b21a8' },
            { id: 84, name: translate('baseball.pitchsubtypes.cutter.fourseam'), abbr: translate('baseball.pitchsubtypes.abbr-cutter.fourseam'), typeid: 8, typename: translate('baseball.pitches.cutter'), typeabbr: translate('baseball.pitches.abbr-cutter'), sortorder: 10, color: '#86198f' },
            { id: 85, name: translate('baseball.pitchsubtypes.cutter.curly'), abbr: translate('baseball.pitchsubtypes.abbr-cutter.curly'), typeid: 8, typename: translate('baseball.pitches.cutter'), typeabbr: translate('baseball.pitches.abbr-cutter'), sortorder: 10, color: '#7e22ce' },
            { id: 90, name: translate('baseball.pitchsubtypes.fastball-2.rhp'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-2.rhp'), typeid: 9, typename: translate('baseball.pitches.fastball-2'), typeabbr: translate('baseball.pitches.abbr-fastball-2'), sortorder: 2, color: '#fecaca' },
            { id: 91, name: translate('baseball.pitchsubtypes.fastball-2.lhp'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-2.lhp'), typeid: 9, typename: translate('baseball.pitches.fastball-2'), typeabbr: translate('baseball.pitches.abbr-fastball-2'), sortorder: 2, color: '#fecaca' },
            { id: 92, name: translate('baseball.pitchsubtypes.fastball-2.dropdown'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-2.dropdown'), typeid: 9, typename: translate('baseball.pitches.fastball-2'), typeabbr: translate('baseball.pitches.abbr-fastball-2'), sortorder: 2, color: '#fca5a5' },
            { id: 93, name: translate('baseball.pitchsubtypes.fastball-2.oneseam'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-2.oneseam'), typeid: 9, typename: translate('baseball.pitches.fastball-2'), typeabbr: translate('baseball.pitches.abbr-fastball-2'), sortorder: 2, color: '#f87171' },
            { id: 94, name: translate('baseball.pitchsubtypes.fastball-2.looper'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-2.looper'), typeid: 9, typename: translate('baseball.pitches.fastball-2'), typeabbr: translate('baseball.pitches.abbr-fastball-2'), sortorder: 2, color: '#ef4444' },
            { id: 95, name: translate('baseball.pitchsubtypes.fastball-2.cutsinker'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-2.cutsinker'), typeid: 9, typename: translate('baseball.pitches.fastball-2'), typeabbr: translate('baseball.pitches.abbr-fastball-2'), sortorder: 2, color: '#b91c1c' },
            { id: 100, name: translate('baseball.pitchsubtypes.fastball-4.rhp'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-4.rhp'), typeid: 10, typename: translate('baseball.pitches.fastball-4'), typeabbr: translate('baseball.pitches.abbr-fastball-4'), sortorder: 3, color: '#c2410c' },
            { id: 101, name: translate('baseball.pitchsubtypes.fastball-4.lhp'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-4.lhp'), typeid: 10, typename: translate('baseball.pitches.fastball-4'), typeabbr: translate('baseball.pitches.abbr-fastball-4'), sortorder: 3, color: '#c2410c' },
            { id: 102, name: translate('baseball.pitchsubtypes.fastball-4.dropdown'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-4.dropdown'), typeid: 10, typename: translate('baseball.pitches.fastball-4'), typeabbr: translate('baseball.pitches.abbr-fastball-4'), sortorder: 3, color: '#fb923c' },
            { id: 103, name: translate('baseball.pitchsubtypes.fastball-4.offset'), abbr: translate('baseball.pitchsubtypes.abbr-fastball-4.offset'), typeid: 10, typename: translate('baseball.pitches.fastball-4'), typeabbr: translate('baseball.pitches.abbr-fastball-4'), sortorder: 3, color: '#fdba74' },
        ];
    }
    return [
        { id: 20, name: 'RHP', abbr: 'CB-R', typeid: 2, typename: 'Curve', typeabbr: 'CB', sortorder: 4, color: '#1e3a8a' },
        { id: 21, name: 'LHP', abbr: 'CB-L', typeid: 2, typename: 'Curve', typeabbr: 'CB', sortorder: 4, color: '#1e3a8a' },
        { id: 22, name: 'Drop-Down', abbr: 'DDCB', typeid: 2, typename: 'Curve', typeabbr: 'CB', sortorder: 4, color: '#3b82f6' },
        { id: 23, name: 'Slow', abbr: 'SLOW', typeid: 2, typename: 'Curve', typeabbr: 'CB', sortorder: 4, color: '#1e40af' },
        { id: 30, name: 'RHP', abbr: 'SL-R', typeid: 3, typename: 'Slider', typeabbr: 'SL', sortorder: 5, color: '#0369a1' },
        { id: 31, name: 'LHP', abbr: 'SL-L', typeid: 3, typename: 'Slider', typeabbr: 'SL', sortorder: 5, color: '#0369a1' },
        { id: 32, name: 'Drop-Down', abbr: 'DDSL', typeid: 3, typename: 'Slider', typeabbr: 'SL', sortorder: 5, color: '#475569' },
        { id: 33, name: 'Gyro', abbr: 'GYRO', typeid: 3, typename: 'Slider', typeabbr: 'SL', sortorder: 5, color: '#713f12' },
        { id: 34, name: 'Sweeper', abbr: 'SW', typeid: 3, typename: 'Slider', typeabbr: 'SL', sortorder: 5, color: '#06b6d4' },
        { id: 35, name: 'Whirly', abbr: 'WH', typeid: 3, typename: 'Slider', typeabbr: 'SL', sortorder: 5, color: '#a5f3fc' },
        { id: 40, name: 'RHP', abbr: 'CH-R', typeid: 4, typename: 'Changeup', typeabbr: 'CH', sortorder: 6, color: '#064e3b' },
        { id: 41, name: 'LHP', abbr: 'CH-L', typeid: 4, typename: 'Changeup', typeabbr: 'CH', sortorder: 6, color: '#064e3b' },
        { id: 42, name: 'Drop-Down', abbr: 'DDCH', typeid: 4, typename: 'Changeup', typeabbr: 'CH', sortorder: 6, color: '#047857' },
        { id: 43, name: 'Two-Seam', abbr: '2CH', typeid: 4, typename: 'Changeup', typeabbr: 'CH', sortorder: 6, color: '#059669' },
        { id: 44, name: 'Four-Seam', abbr: '4CH', typeid: 4, typename: 'Changeup', typeabbr: 'CH', sortorder: 6, color: '#10b981' },
        { id: 45, name: 'One-Seam', abbr: '1CH', typeid: 4, typename: 'Changeup', typeabbr: 'CH', sortorder: 6, color: '#34d399' },
        { id: 46, name: 'Looper', abbr: 'LPCH', typeid: 4, typename: 'Changeup', typeabbr: 'CH', sortorder: 6, color: '#6ee7b7' },
        { id: 70, name: 'RHP', abbr: 'SP-R', typeid: 7, typename: 'Splitter', typeabbr: 'SP', sortorder: 9, color: '#f3e8ff' },
        { id: 71, name: 'LHP', abbr: 'SP-L', typeid: 7, typename: 'Splitter', typeabbr: 'SP', sortorder: 9, color: '#f3e8ff' },
        { id: 72, name: 'Drop-Down', abbr: 'DDSP', typeid: 7, typename: 'Splitter', typeabbr: 'SP', sortorder: 9, color: '#f5d0fe' },
        { id: 73, name: 'Two-Seam', abbr: '2SP', typeid: 7, typename: 'Splitter', typeabbr: 'SP', sortorder: 9, color: '#e9d5ff' },
        { id: 74, name: 'Four-Seam', abbr: '4SP', typeid: 7, typename: 'Splitter', typeabbr: 'SP', sortorder: 9, color: '#d8b4fe' },
        { id: 75, name: 'One-Seam', abbr: '1SP', typeid: 7, typename: 'Splitter', typeabbr: 'SP', sortorder: 9, color: '#c084fc' },
        { id: 76, name: 'Looper', abbr: 'LPSP', typeid: 7, typename: 'Splitter', typeabbr: 'SP', sortorder: 9, color: '#9333ea' },
        { id: 80, name: 'RHP', abbr: 'CT-R', typeid: 8, typename: 'Cutter', typeabbr: 'CT', sortorder: 10, color: '#581c87' },
        { id: 81, name: 'LHP', abbr: 'CT-L', typeid: 8, typename: 'Cutter', typeabbr: 'CT', sortorder: 10, color: '#581c87' },
        { id: 82, name: 'Drop-Down', abbr: 'DDCT', typeid: 8, typename: 'Cutter', typeabbr: 'CT', sortorder: 10, color: '#701a75' },
        { id: 83, name: 'One-Seam', abbr: '1CT', typeid: 8, typename: 'Cutter', typeabbr: 'CT', sortorder: 10, color: '#6b21a8' },
        { id: 84, name: 'Four-Seam', abbr: '4CT', typeid: 8, typename: 'Cutter', typeabbr: 'CT', sortorder: 10, color: '#86198f' },
        { id: 85, name: 'Curly', abbr: 'CRLY', typeid: 8, typename: 'Cutter', typeabbr: 'CT', sortorder: 10, color: '#7e22ce' },
        { id: 90, name: 'RHP', abbr: '2S-R', typeid: 9, typename: 'Two-Seam Fastball', typeabbr: '2FB', sortorder: 2, color: '#fecaca' },
        { id: 91, name: 'LHP', abbr: '2S-L', typeid: 9, typename: 'Two-Seam Fastball', typeabbr: '2FB', sortorder: 2, color: '#fecaca' },
        { id: 92, name: 'Drop-Down', abbr: 'DD2F', typeid: 9, typename: 'Two-Seam Fastball', typeabbr: '2FB', sortorder: 2, color: '#fca5a5' },
        { id: 93, name: 'One-Seam', abbr: '1FB', typeid: 9, typename: 'Two-Seam Fastball', typeabbr: '2FB', sortorder: 2, color: '#f87171' },
        { id: 94, name: 'Looper', abbr: 'LP2F', typeid: 9, typename: 'Two-Seam Fastball', typeabbr: '2FB', sortorder: 2, color: '#ef4444' },
        { id: 95, name: 'Cut Sinker', abbr: 'CTSK', typeid: 9, typename: 'Two-Seam Fastball', typeabbr: '2FB', sortorder: 2, color: '#b91c1c' },
        { id: 100, name: 'RHP', abbr: '4S-R', typeid: 10, typename: 'Four-Seam Fastball', typeabbr: '4FB', sortorder: 3, color: '#c2410c' },
        { id: 101, name: 'LHP', abbr: '4S-L', typeid: 10, typename: 'Four-Seam Fastball', typeabbr: '4FB', sortorder: 3, color: '#c2410c' },
        { id: 102, name: 'Drop-Down', abbr: 'DD4F', typeid: 10, typename: 'Four-Seam Fastball', typeabbr: '4FB', sortorder: 3, color: '#fb923c' },
        { id: 103, name: 'Off-Set Looper', abbr: 'OFLP', typeid: 10, typename: 'Four-Seam Fastball', typeabbr: '4FB', sortorder: 3, color: '#fdba74' },
    ];
};
const getPitchType = (translate, pitchTypeVal) => {
    let pitchType = null;
    if (isNumber$2(pitchTypeVal)) {
        const intVal = typeof pitchTypeVal === 'number' ? pitchTypeVal : parseInt(pitchTypeVal);
        if (!isNaN(intVal)) {
            pitchType = PITCH_TYPES(translate).find((x) => x.id === intVal);
        }
    }
    return pitchType;
};
const getPitchTypeIdFromName = (pitchNameOrAbbr, translate = null) => {
    var _a;
    if (!pitchNameOrAbbr)
        return null;
    return ((_a = PITCH_TYPES(translate).find((x) => [x.name, x.abbr].includes(pitchNameOrAbbr))) === null || _a === void 0 ? void 0 : _a.id) || null;
};
const pitchType = (value, abbr = false, emptyvalue, translate = null) => {
    const pt = getPitchType(translate, value);
    if (pt) {
        return abbr ? pt.abbr : pt.name;
    }
    return emptyvalue !== undefined ? emptyvalue : value;
};
const pitchTypeColor = (value, translate = null) => { var _a; return ((_a = getPitchType(translate, value)) === null || _a === void 0 ? void 0 : _a.color) || PITCH_TYPES(translate)[0].color; };
const getPitchSubType = (translate, pitchSubTypeVal) => {
    let pitchSubType = null;
    if (isNumber$2(pitchSubTypeVal)) {
        const intVal = typeof pitchSubTypeVal === 'number' ? pitchSubTypeVal : parseInt(pitchSubTypeVal);
        if (!isNaN(intVal)) {
            pitchSubType = PITCH_SUB_TYPES(translate).find((x) => x.id === intVal);
        }
    }
    return pitchSubType;
};
const pitchSubType = (value, abbr = false, emptyvalue, translate = null) => {
    const pt = getPitchSubType(translate, value);
    if (pt) {
        return abbr ? pt.abbr : pt.name;
    }
    return emptyvalue !== undefined ? emptyvalue : value;
};
const pitchTypeOrSubType = (value, abbr = false, emptyvalue, translate = null) => {
    const pt = getPitchType(translate, value);
    if (pt) {
        return abbr ? pt.abbr : pt.name;
    }
    const pst = getPitchSubType(translate, value);
    if (pst) {
        return abbr ? pst.abbr : pst.name;
    }
    return emptyvalue !== undefined ? emptyvalue : value;
};
const pitchSubTypeColor = (type) => {
    var _a, _b, _c, _d;
    if (!type.fxsubtype) {
        return pitchTypeColor((_b = (_a = type.fxtype) !== null && _a !== void 0 ? _a : type.pitchtype) !== null && _b !== void 0 ? _b : type.type);
    }
    return (_d = (_c = getPitchSubType(null, type.fxsubtype)) === null || _c === void 0 ? void 0 : _c.color) !== null && _d !== void 0 ? _d : PITCH_TYPES(null)[0].color;
};
const repertoireColor = (repertoire, type) => {
    const orderedRepertoire = repertoire
        .map((r) => ({ fxtype: r.fxtype, fxsubtype: r.fxsubtype, color: undefined }))
        .sort((a, b) => (a.fxtype === b.fxtype ? (a.fxsubtype - b.fxsubtype) : (a.fxtype - b.fxtype)));
    const colors = PITCH_TYPES().filter((pt) => !!pt.id && !!pt.color).map((pt) => ({
        fxtype: pt.id,
        color: pt.color,
    })).sort((a, b) => a.fxtype - b.fxtype);
    for (let i = 0; i < orderedRepertoire.length; i++) {
        const or = orderedRepertoire[i];
        const colorIndex = colors.findIndex((c) => c.fxtype === or.fxtype);
        if (colorIndex >= 0) {
            if (or.fxtype === type.fxtype && or.fxsubtype === type.fxsubtype) {
                return colors[colorIndex].color;
            }
            or.color = colors[colorIndex].color;
            colors.splice(colorIndex, 1);
        }
    }
    for (let i = 0; i < orderedRepertoire.length; i++) {
        const or = orderedRepertoire[i];
        if (!or.color) {
            if (or.fxtype === type.fxtype && or.fxsubtype === type.fxsubtype) {
                return colors[0].color;
            }
            or.color = colors[0].color;
            colors.splice(0, 1);
        }
    }
    return undefined;
};
const pitchTypeDisplayName = (type, abbrFxType, abbrFxSubType, translate = null) => {
    var _a, _b;
    const typeDisplayName = pitchType((_b = (_a = type.fxtype) !== null && _a !== void 0 ? _a : type.pitchtype) !== null && _b !== void 0 ? _b : type.type, abbrFxType, undefined, translate);
    if (!typeDisplayName) {
        return undefined;
    }
    const subTypeDisplayName = pitchSubType(type.fxsubtype, abbrFxSubType, undefined, translate);
    return `${typeDisplayName}${subTypeDisplayName ? ` (${subTypeDisplayName})` : ''}`;
};

dayjs.extend(utc);
dayjs.extend(timezone);
const age = (date) => {
    if (!date)
        return null;
    const ageDays = dayjs().diff(date, 'days');
    return ageDays / 365.242199;
};
const internationalizeDate = (translate, val, yearLong = true, yearShort = false, month = true, day = true, hour = false, minute = false, second = false, amPm = false, isUTC = true, timeZone = 'America/New_York') => {
    let formattedDate = '';
    let dt = (isUTC && typeof val === 'string' && !val.endsWith('Z')) ? `${val}Z` : val;
    dt = dayjs(dt).tz(timeZone);
    if (dt.isValid()) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const formatObject = {};
        if (yearLong) {
            formatObject.year = 'numeric';
        }
        else if (yearShort) {
            formatObject.year = '2-digit';
        }
        if (month) {
            formatObject.month = 'numeric';
        }
        if (day) {
            formatObject.day = 'numeric';
        }
        if (hour) {
            formatObject.hour = 'numeric';
        }
        if (minute) {
            formatObject.minute = 'numeric';
        }
        if (second) {
            formatObject.second = 'numeric';
        }
        if (amPm) {
            formatObject.hour12 = true;
        }
        formattedDate = translate('format.datetime', { val: dt, formatParams: { val: formatObject }, interpolation: { escapeValue: false } });
        return formattedDate;
    }
    return '';
};
const dateTranslate = (translate, val) => internationalizeDate(translate, val, false, true, true, true, false, false, false, false);
const dateTimeTranslate = (translate, val, abbr = true, isUTC = true, timeZone = 'America/New_York') => internationalizeDate(translate, val, !abbr, abbr, true, true, true, true, false, true, isUTC, timeZone);
const militaryTimeTranslate = (translate, val, isUTC = true, timeZone = 'America/New_York') => internationalizeDate(translate, val, false, false, false, false, true, true, false, false, isUTC, timeZone);
// These are the original, non-translation-aware versions for use such as BASE
const date = (val, format = 'M/D/YY') => {
    let formattedDate = '';
    const parsedDate = dayjs(val);
    if (parsedDate.isValid()) {
        formattedDate = parsedDate.format(format);
    }
    return formattedDate;
};
const dateTime = (val, abbr = true, isUTC = true, timeZone = 'America/New_York') => {
    let dt = (isUTC && typeof val === 'string' && !val.endsWith('Z')) ? `${val}Z` : val;
    if (timeZone)
        dt = dayjs(dt).tz(timeZone);
    return date(dt, `M/D/YY${abbr ? '' : 'YY'} h:mm a`);
};

const elide = (str, len) => {
    if (str.length > len)
        return `${str.substring(0, len)}...`;
    return str;
};

const base64ToBlob = (heatmap) => {
    const { ContentType, HeatMapImg } = heatmap;
    if (!ContentType || !HeatMapImg)
        return null;
    // https://stackoverflow.com/a/12300351
    const byteString = atob(HeatMapImg);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: ContentType });
    return URL.createObjectURL(blob);
};

const Container$j = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
function onSeriesAssignment$1(series, pointshrinkcutoff) {
    const numScatterPoints = series
        .filter((s) => !s.type || s.type === 'scatter')
        .map((x) => (x.data ? x.data.length : 0))
        .reduce((a, b) => a + b, 0);
    if (numScatterPoints <= pointshrinkcutoff) {
        return series;
    }
    const computedSeries = series.map((s) => {
        var _a;
        if (s.type && s.type !== 'scatter')
            return s;
        return Object.assign(Object.assign({}, s), { marker: Object.assign(Object.assign({}, s.marker), { radius: !((_a = s.marker) === null || _a === void 0 ? void 0 : _a.radius) ? 2 : Math.max(1, s.marker.radius - 2) }) });
    });
    return computedSeries;
}
const PitchChart = ({ titleX, titleY, maxY, minY, minRangeY, yplotbands, seriesData, dataPoints, pitchVideoFn, modalContainer, videoPlayerModal: VideoPlayerModal, width = 260, enableZoom = true, pointshrinkcutoff = 250, scaleY = 1, subscaleY = 0.25, onClick, minX = 0, xAxisType, yAxisLabels, yTooltipFormatter, }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    if (!(seriesData === null || seriesData === void 0 ? void 0 : seriesData.length)) {
        return React.createElement(Container$j, { style: { width } },
            React.createElement("em", null, translate('components.charts.no-pitches')));
    }
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq, playid) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq, playid);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const chartConfig = {
        chart: {
            width,
            height: width,
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
        },
        colors: ['#3366FF', '#BF0B23', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        plotOptions: {
            series: {
                marker: {
                    radius: 2,
                    symbol: 'circle',
                },
                stickyTracking: false,
                color: '#ff0000',
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if (onClick)
                                return onClick(this);
                            if ((this.gameid && this.eventseq && this.pitchseq) || this.playid) {
                                fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq, this.playid);
                            }
                            return null;
                        },
                    },
                },
            },
            spline: {
                allowPointSelect: false,
                enableMouseTracking: false,
                lineWidth: 1,
                marker: {
                    enabled: false,
                },
            },
        },
        legend: {
            enabled: true,
            x: 30,
            align: 'center',
        },
        credits: {
            enabled: false,
        },
        xAxis: {
            min: minX,
            max: null,
            gridLineWidth: 0,
            tickInterval: 10,
            tickLength: 6,
            minorTickInterval: 5,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 1,
            minorGridLineColor: '#FCF8F8',
            minPadding: 0,
            maxPadding: 0,
            startOnTick: true,
            endOnTick: true,
            title: {
                text: titleX,
            },
            plotBands: seriesData.inningBreaks,
            type: xAxisType,
        },
        yAxis: {
            min: minY,
            max: maxY,
            minRange: minRangeY,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: scaleY,
            tickLength: 6,
            minorTickInterval: subscaleY,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 1,
            minorGridLineColor: '#FCF8F8',
            startOnTick: true,
            endOnTick: true,
            minPadding: 0,
            maxPadding: 0,
            opposite: false,
            title: {
                text: titleY,
            },
            labels: yAxisLabels || {
                formatter() {
                    // hack for spinrate RPMs
                    if (this.value >= 1000)
                        return (Number(this.value) / 1000).toFixed(1);
                    return this.value.toString();
                },
            },
            plotBands: yplotbands,
        },
        tooltip: {
            formatter() {
                var _a;
                if (!this.point.tooltip)
                    return null;
                let tooltip = `<b>${this.series.name}: ${(_a = this.point.y) === null || _a === void 0 ? void 0 : _a.toFixed(2)}</b><br/>`;
                if (yTooltipFormatter != null)
                    tooltip = `<b>${this.series.name}: ${yTooltipFormatter(this.point.y)}</b><br/>`;
                tooltip += this.point.tooltip;
                return tooltip;
            },
        },
        series: onSeriesAssignment$1(seriesData, pointshrinkcutoff),
        title: {
            text: undefined,
            align: 'center',
            floating: true,
            verticalAlign: 'top',
        },
    };
    // Adjust series
    const seriesDataData = seriesData.flatMap((x) => x.data).map(({ y }) => y || 0);
    const newMinY = seriesDataData.length ? Math.min(...seriesDataData) : null;
    const newMaxY = seriesDataData.length ? Math.max(...seriesDataData) : null;
    // Adjust yAxis
    if (minRangeY && newMaxY != null && newMinY != null && (newMaxY - newMinY < minRangeY)) {
        const md = ((newMaxY - newMinY) / 2) + newMinY;
        const min = Math.floor((md - (minRangeY / 2)) * 4) / 4;
        const max = min + minRangeY;
        chartConfig.yAxis.min = min;
        chartConfig.yAxis.max = max;
    }
    // Adjust xAxis
    let xtick;
    let xsubtick;
    let labelinterval;
    if (dataPoints >= 100) {
        xtick = 5;
        xsubtick = 5;
        labelinterval = 20;
    }
    else if (dataPoints >= 40) {
        xtick = 5;
        xsubtick = 5;
        labelinterval = 10;
    }
    else if (dataPoints >= 20) {
        xtick = 5;
        xsubtick = 1;
    }
    else if (dataPoints >= 10) {
        xtick = 2;
        xsubtick = 1;
    }
    else {
        xtick = 1;
        xsubtick = 1;
    }
    chartConfig.xAxis = Object.assign(Object.assign({}, chartConfig.xAxis), { max: dataPoints, tickInterval: xtick, minorTickInterval: xsubtick, labels: {
            formatter() {
                if (xAxisType === 'datetime')
                    return internationalizeDate(translate, this.value, false, true, true, true);
                if (!labelinterval || (Number(this.value) % labelinterval === 0))
                    return this.value.toString();
                return '';
            },
        } });
    return (React.createElement(Container$j, null,
        pitchVideoFn && VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false })));
};

class WebGLPathDisplay extends Component {
    constructor(props) {
        super(props);
        this.pathDisplayContainer = React.createRef();
        this.texturesLoading = 0;
        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera();
        this.renderer = new THREE.WebGLRenderer({ antialias: true });
    }
    componentDidMount() {
        this.init(this.props);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.strikeZone !== this.props.strikeZone || nextProps.pitches !== this.props.pitches;
    }
    componentDidUpdate() {
        this.init(this.props);
    }
    setupBallpark(scene) {
        this.texturesLoading += 1;
        const ifDirtTexture = new THREE.TextureLoader().load(baseballDirt, (texture) => {
            texture.wrapT = THREE.RepeatWrapping;
            texture.wrapS = texture.wrapT;
            texture.offset.set(0, 0);
            texture.repeat.set(0.25, 0.25);
            this.texturesLoading -= 1;
        });
        this.texturesLoading += 1;
        const ifGrassTexture = new THREE.TextureLoader().load(ifGrass, (texture) => {
            texture.wrapT = THREE.RepeatWrapping;
            texture.wrapS = texture.wrapT;
            texture.offset.set(0, 0);
            texture.repeat.set(44, 44);
            this.texturesLoading -= 1;
        });
        const planeGeometry = new THREE.PlaneGeometry(440, 460);
        const planeMaterial = new THREE.MeshPhongMaterial({ color: 0x007700, specular: 0x111111, shininess: 10, map: ifGrassTexture });
        const plane = new THREE.Mesh(planeGeometry, planeMaterial);
        plane.position.y = 155;
        plane.position.x = 3.2;
        plane.position.z = 0;
        plane.receiveShadow = true;
        scene.add(plane);
        const pitchersMound = {
            x: 0,
            y: 59,
            radius: 9,
            extrudeSettings: { steps: 2, depth: 0.1, bevelEnabled: true, bevelThickness: 0.1, bevelSize: 1, bevelSegments: 1 },
            material: new THREE.MeshPhongMaterial({ color: 0xffab87, wireframe: false, specular: 0x111111, shininess: 10, map: ifDirtTexture }),
        };
        this.drawCircleExtrude(pitchersMound);
        const homeCircle = {
            x: 0,
            y: 0,
            radius: 13,
            extrudeSettings: { steps: 2, depth: 0.1, bevelEnabled: false },
            material: new THREE.MeshPhongMaterial({ color: 0xffab87, wireframe: false, specular: 0x111111, shininess: 10, map: ifDirtTexture }),
        };
        this.drawCircleExtrude(homeCircle);
        const homePlate = {
            x: 0,
            y: 0,
            points: [{ x: 0.70835, y: 0.70835 }, { x: 0, y: 0.70835 }, { x: -1.4167, y: 0 }, { x: 0, y: -0.70835 }, { x: 0.70835, y: -0.70835 }],
            extrudeSettings: { depth: 0.25, bevelEnabled: false },
            material: new THREE.MeshBasicMaterial({ color: 0xf2f2f2, wireframe: false }),
        };
        this.drawPolygonExtrude(homePlate);
        const pitchersRubber = {
            x: -1,
            y: 60.5,
            points: [{ x: 2, y: 0 }, { x: 0, y: 0.5 }, { x: -2, y: 0 }, { x: 0, y: -0.5 }],
            extrudeSettings: { depth: 0.35, bevelEnabled: false },
            material: new THREE.MeshBasicMaterial({ color: 0xf2f2f2, wireframe: false }),
        };
        this.drawPolygonExtrude(pitchersRubber);
        const szGeometry = new THREE.Geometry();
        szGeometry.vertices.push(new THREE.Vector3(-0.833, 1.4167, 1.595));
        szGeometry.vertices.push(new THREE.Vector3(-0.833, 1.4167, 3.365));
        szGeometry.vertices.push(new THREE.Vector3(0.833, 1.4167, 3.365));
        szGeometry.vertices.push(new THREE.Vector3(0.833, 1.4167, 1.595));
        szGeometry.vertices.push(new THREE.Vector3(-0.833, 1.4167, 1.595));
        const szMaterial = new THREE.LineBasicMaterial({ color: 0xf0f0f0 });
        const szObject = new THREE.Line(szGeometry, szMaterial);
        scene.add(szObject);
        const ifDirt = {
            x: 0,
            y: 0,
            points: [{ x: 63.64, y: 63.64 }, { x: -63.64, y: 63.64 }, { x: -63.64, y: -63.64 }, { x: 63.64, y: -63.64 }],
            holex: 0,
            holey: 4.24,
            hole: [{ x: 59.4, y: 59.4 }, { x: -59.4, y: 59.4 }, { x: -59.4, y: -59.4 }, { x: 59.4, y: -59.4 }],
            extrudeSettings: { depth: 0.1, bevelEnabled: false },
            material: new THREE.MeshPhongMaterial({ color: 0xffab87, wireframe: false, specular: 0x111111, shininess: 10, map: ifDirtTexture }),
        };
        this.drawPolygonExtrude(ifDirt);
        const lhhBattersBox = {
            x: 1.2083,
            y: 3.7083,
            points: [{ x: 4, y: 0 }, { x: 0, y: -6 }, { x: -4, y: 0 }, { x: 0, y: 6 }],
            holex: 1.4166,
            holey: 3.5,
            hole: [{ x: 3.5834, y: 0 }, { x: 0, y: -5.5834 }, { x: -3.5834, y: 0 }, { x: 0, y: 5.5834 }],
            extrudeSettings: { depth: 0.25, bevelEnabled: false },
            material: new THREE.MeshBasicMaterial({ color: 0xf0f0f0, wireframe: false }),
        };
        this.drawPolygonExtrude(lhhBattersBox);
        const rhhBattersBox = {
            x: -1.2083,
            y: 3.7083,
            points: [{ x: -4, y: 0 }, { x: 0, y: -6 }, { x: 4, y: 0 }, { x: 0, y: 6 }],
            holex: -1.4166,
            holey: 3.5,
            hole: [{ x: -3.5834, y: 0 }, { x: 0, y: -5.5834 }, { x: 3.5834, y: 0 }, { x: 0, y: 5.5834 }],
            extrudeSettings: { depth: 0.25, bevelEnabled: false },
            material: new THREE.MeshBasicMaterial({ color: 0xf0f0f0, wireframe: false }),
        };
        this.drawPolygonExtrude(rhhBattersBox);
    }
    init({ pitches, strikeZone, width, height, view = 'catcher', disableControls = false, showBackdrop = false, showBall = true, }) {
        const container = this.pathDisplayContainer.current;
        container.innerHTML = '';
        this.scene = new THREE.Scene();
        if (showBackdrop) ;
        else {
            new THREE.TextureLoader().load(blueSky, (texture) => { this.scene.background = texture; });
        }
        this.camera = new THREE.PerspectiveCamera(70, width / height, 1, 2000);
        this.camera.up = new THREE.Vector3(0, 0, 1);
        this.scene.add(this.camera);
        this.scene.add(new THREE.AmbientLight(0xf0f0f0));
        const light = new THREE.SpotLight(0xffffff, 1.5);
        light.position.set(0, 350, 200);
        light.castShadow = true;
        light.shadow = new THREE.SpotLightShadow(new THREE.PerspectiveCamera(70, 1, 200, 2000));
        light.shadow.bias = -0.000222;
        light.shadow.mapSize.width = 1024;
        light.shadow.mapSize.height = 1024;
        this.scene.add(light);
        this.texturesLoading = 0;
        this.setupBallpark(this.scene);
        if (strikeZone)
            this.buildStrikeZone(strikeZone);
        if (showBall)
            this.buildBall(pitches);
        this.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(width, height);
        this.renderer.shadowMap.enabled = true;
        container.appendChild(this.renderer.domElement);
        const direction = new THREE.Vector3();
        this.camera.getWorldDirection(direction);
        // Controls
        this.controls = undefined;
        if (!disableControls) {
            this.controls = new OrbitControls(this.camera, this.renderer.domElement);
            this.controls.dampingFactor = 0.2; // inertia factor when dragging
            this.controls.zoomSpeed = 0.5;
            this.controls.rotateSpeed = 0.1;
            this.controls.maxDistance = 925; // prevent from zooming out so far that the background goes off-scene
            this.controls.addEventListener('change', this.renderScene.bind(this));
            this.controls.target.addScaledVector(direction, 0);
        }
        switch (view) {
            case 'catcher':
                this.camera.position.set(0, -1.5, 1.78);
                if (this.controls) {
                    this.controls.target.set(0, 56, 6);
                }
                else {
                    this.camera.lookAt(0, 55, 1.79);
                }
                break;
            case 'rhh':
                this.camera.position.set(-2.5, -1, 5.25);
                if (this.controls)
                    this.controls.target.set(0, 56, 6);
                break;
            case 'lhh':
                this.camera.position.set(2.5, -1, 5.25);
                if (this.controls)
                    this.controls.target.set(0, 56, 6);
                break;
            case 'side':
                this.camera.position.set(-18, 25, 2.25);
                if (this.controls)
                    this.controls.target.set(0, 25, 2.25);
                break;
            case 'overhead':
                this.camera.position.set(-0.01, 25, 25);
                if (this.controls)
                    this.controls.target.set(0.01, 25, 0.5);
                break;
            default:
                this.camera.position.set(0, 55, 10.25);
                if (this.controls)
                    this.controls.target.set(-10, 0, 0);
                break;
        }
        if (this.controls)
            this.controls.update();
        pitches.forEach((pitch) => {
            const points = new Array();
            pitch.positions.forEach((pos) => {
                points.push(new THREE.Vector3(pos.posx, pos.posy, pos.posz));
            });
            const curve = new THREE.CatmullRomCurve3(points);
            const geometry = new THREE.TubeBufferGeometry(curve, 64, 0.055, 8, false);
            const mesh = new THREE.Mesh(geometry, pitch.meshphongmaterial);
            this.scene.add(mesh);
            const circlegeometry = new THREE.CircleGeometry(0.085, 32);
            const circle = new THREE.Mesh(circlegeometry, pitch.meshphongmaterial);
            circle.position.x = pitch.platelocpitch.posx;
            circle.position.y = pitch.platelocpitch.posy;
            circle.position.z = pitch.platelocpitch.posz;
            circle.rotation.x = Math.PI / 2;
            this.scene.add(circle);
        });
        // TODO: add tooltips like http://jsfiddle.net/mmalex/ycnh0wze/
        this.renderer.render(this.scene, this.camera);
        this.animate();
    }
    buildBall(pitches) {
        pitches.forEach((pitch) => {
            if (!pitch.pitcherid || pitch.pitcherid > 2) {
                const geometry = new THREE.SphereGeometry(0.12, 32, 32, 0, Math.PI * 2, 0, Math.PI);
                this.texturesLoading += 1;
                const texture = new THREE.TextureLoader().load(baseballWLogo, () => { this.texturesLoading -= 1; });
                const material = new THREE.MeshBasicMaterial({
                    map: texture,
                });
                const ball = new THREE.Mesh(geometry, material);
                ball.position.z = pitch.platelocpitch.posz;
                ball.position.y = pitch.platelocpitch.posy;
                ball.position.x = pitch.platelocpitch.posx;
                this.scene.add(ball);
            }
        });
    }
    /*
    buildBackdrop() {
        var backdropTexture = new THREE.TextureLoader().load('/bbops/Content/images/webgltextures/yankeestadiumbackdrop.png');
        var backdropGeometry = new THREE.PlaneGeometry(968, 374);
        backdropGeometry.rotateX(Math.PI/2);
        var backdropMaterial = new THREE.MeshPhongMaterial({ needsUpdate: true, map: backdropTexture });
        var backdrop = new THREE.Mesh(backdropGeometry, backdropMaterial);
        backdrop.position.y = 460;
        backdrop.position.z = 187;
        scene.add(backdrop);
    }
    */
    buildStrikeZone(strikeZone) {
        if (strikeZone.length) {
            const szHGeometry = new THREE.Geometry();
            strikeZone.forEach((point) => {
                szHGeometry.vertices.push(new THREE.Vector3(point.platex, 1.4167, point.platez));
            });
            szHGeometry.vertices.push(new THREE.Vector3(strikeZone[0].platex, 1.4167, strikeZone[0].platez));
            const szHMaterial = new THREE.LineBasicMaterial({ color: 0xff0000 });
            const szHObject = new THREE.Line(szHGeometry, szHMaterial);
            this.scene.add(szHObject);
        }
    }
    drawCircleExtrude(shape) {
        const sh = new THREE.Shape();
        const { x } = shape;
        const { y } = shape;
        const { radius } = shape;
        sh.moveTo(x, y + radius);
        sh.quadraticCurveTo(x + radius, y + radius, x + radius, y);
        sh.quadraticCurveTo(x + radius, y - radius, x, y - radius);
        sh.quadraticCurveTo(x - radius, y - radius, x - radius, y);
        sh.quadraticCurveTo(x - radius, y + radius, x, y + radius);
        const shGeometry = new THREE.ExtrudeBufferGeometry(sh, shape.extrudeSettings);
        const shMesh = new THREE.Mesh(shGeometry, shape.material);
        this.scene.add(shMesh);
    }
    drawPolygonExtrude(shape) {
        const sh = new THREE.Shape();
        let { x } = shape;
        let { y } = shape;
        sh.moveTo(x, y);
        shape.points.forEach((point) => {
            sh.bezierCurveTo(x, y, x + point.x, y + point.y, x + point.x, y + point.y);
            x += point.x;
            y += point.y;
        });
        if (shape.hole && shape.holex && shape.holey) {
            const h = new THREE.Shape();
            let hx = shape.holex;
            let hy = shape.holey;
            h.moveTo(hx, hy);
            shape.hole.forEach((point) => {
                h.bezierCurveTo(hx, hy, hx + point.x, hy + point.y, hx + point.x, hy + point.y);
                hx += point.x;
                hy += point.y;
            });
            sh.holes.push(h);
        }
        const shGeometry = new THREE.ExtrudeGeometry(sh, shape.extrudeSettings);
        const shMesh = new THREE.Mesh(shGeometry, shape.material);
        this.scene.add(shMesh);
    }
    animate() {
        if (this.controls || this.texturesLoading > 0) {
            window.requestAnimationFrame(this.animate.bind(this));
            if (this.controls)
                this.controls.update();
        }
        this.renderScene();
    }
    renderScene() {
        this.camera.updateMatrixWorld();
        this.renderer.render(this.scene, this.camera);
    }
    render() {
        return (React.createElement("div", { ref: this.pathDisplayContainer }));
    }
}

const StyledHeatMap = styled.div `
    height: ${(props) => props.height - 40}px !important;
    width: ${(props) => props.width}px;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    > div {
        position: relative;        
        overflow: hidden;
        height: ${(props) => props.height - 12}px;
        width: 100%;
        > img {
            z-index: 101;
            position: absolute;
            height: ${(props) => props.height - 50}px;
            left: ${(props) => ((props.reverse ? !props.islhb : props.islhb) ? 0 : 135)}px;
            top: 0px;
        }
        > div {
            width: 100%;
            margin-top: 150px;
            text-align: center;
        }
        > span > img {
            position: absolute;
            z-index: 100;
            width: ${(props) => props.width + (props.isHeatMap3 ? -5.5 : 20)}px;
            height: ${(props) => props.height + (props.isHeatMap3 ? 3 : 18)}px;
            top: -20px;
            left: ${(props) => {
    const leftLhb = props.isHeatMap3 ? 16 : -23;
    const leftRhb = props.isHeatMap3 ? -12 : -20;
    return `${(props.reverse ? !props.islhb : props.islhb) ? leftLhb : leftRhb}px`;
}};
            ${(props) => (props.reverse ? 'transform: scaleX(-1);' : '')}
        }
    }
`;
const StyledOuterHeatMap = styled.div `
    {
        margin-left: ${(props) => (props.islhb ? -15 : 0)}px !important;
    }
`;
const HeatMap = ({ islhb, src = null, srcAlt = null, showAlt = false, height = 290, width = 240, catcherPerspective = false, isHeatMap3 }) => {
    const { t: translate } = useTranslation();
    let batterImg;
    if (catcherPerspective) {
        batterImg = islhb ? lhbImgRear : rhbImgRear;
    }
    else {
        batterImg = islhb ? lhbImgFront : rhbImgFront;
    }
    return (React.createElement(StyledHeatMap, { height: height, width: width, islhb: islhb, reverse: catcherPerspective, isHeatMap3: !!isHeatMap3 },
        React.createElement(StyledOuterHeatMap, { islhb: islhb },
            React.createElement(Image, { src: batterImg, alt: "" }),
            !src && React.createElement("div", null, translate('components.charts.not-enough-data')),
            src && (React.createElement("span", null,
                React.createElement(Image, { src: (srcAlt && showAlt) ? srcAlt : src }))))));
};

const StyledHeatmapSVGOverlay = styled.svg `
    position: absolute;
    top: ${({ $padding }) => $padding}px;
    left: ${({ $padding }) => $padding}px;
`;
const StyledHeatMapContainer = styled.div `
    position: relative;
    max-width: ${({ $width }) => $width}px;
    > img {
        width: 100%;
        ${({ $reverse }) => ($reverse ? 'transform: scaleX(-1);' : '')}
    }
`;
const StyledHeatMapImgBackground = styled.div `
    background-color: white;
    position: absolute;
    z-index: -1;
    ${({ $padding }) => `
        width: calc(100% - ${2 * $padding}px);
        height: calc(100% - ${2 * $padding}px);
        margin: ${$padding}px ${$padding}px;
    `};
`;
const HeatMapImgContainer = ({ type, src, children, plateX, plateZ, size = 150, includeBackground = false, reverse = false }) => {
    const { height, width, padding } = getHeatmapSizeByType(type, size);
    return (React.createElement(StyledHeatMapContainer, { "$width": size, "$reverse": reverse },
        includeBackground && React.createElement(StyledHeatMapImgBackground, { "$padding": padding }),
        React.createElement(Image, { src: src }),
        children,
        isNumber$2(plateX, plateZ) && (React.createElement(StyledHeatmapSVGOverlay, { "$padding": padding, height: height, width: width },
            React.createElement("circle", { cx: (width / 2) + (inRange(plateX, -1.65, 1.65) / 1.65 * (width / 2)), cy: height - (inRange(plateZ - 0.4, 0, 4.35) / 4.35 * height), r: "5", fill: "black" }),
            React.createElement("circle", { cx: (width / 2) + (inRange(plateX, -1.65, 1.65) / 1.65 * (width / 2)), cy: height - (inRange(plateZ - 0.4, 0, 4.35) / 4.35 * height), r: "3", fill: "white" })))));
};

const StyledCatcherWristbandBadge = styled.div `
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    text-align: center;
    z-index: 99;
    font-size: ${({ $fontSize }) => $fontSize + 3}px;
    -webkit-print-color-adjust: exact;
    padding: ${({ $size }) => $size / 15}px ${({ $grade, $size }) => $size / ($grade === 10 ? 18.75 : 10)}px;
    background-color: ${({ $grade }) => {
    if ($grade === 0)
        return '#013220';
    if ($grade === 1)
        return '#335B4C';
    if ($grade === 2)
        return '#668479';
    if ($grade === 3)
        return '#99ADA5';
    if ($grade === 7)
        return '#D09999';
    if ($grade === 8)
        return '#B96666';
    if ($grade === 9)
        return '#A23333';
    if ($grade === 10)
        return '#8B0000';
    return '#FFFFFF';
}};
    color: ${({ $grade }) => {
    if ($grade === 3 || $grade === 4)
        return '#013220';
    if ($grade === 5)
        return '#000000';
    if ($grade === 6)
        return '#8B0000';
    return '#FFFFFF';
}};
    border: 1px solid ${({ $grade }) => {
    if ($grade < 5)
        return '#00FF00';
    if ($grade === 5)
        return '#000000';
    return '#FF0000';
}};
`;
const CatcherWristbandHeatMap = ({ is2K, plateX, plateZ, src = null, grade = null, size = 150, redX = false, greenBox = false, dashGreenBox = false, selected = false, otz = false, kFree = false, includeBackground = false, isCatcherPerspective = false, }) => {
    const { t: translate } = useTranslation();
    const { width, height, padding: heatMapPadding } = getHeatmapSizeByType(heatMapModelIds.CatcherWristband, size);
    const fontSize = 0.14 * size;
    return (React.createElement(HeatMapImgContainer, { size: size, type: heatMapModelIds.CatcherWristband, src: src || blankHeatMap, plateX: plateX, plateZ: plateZ, includeBackground: includeBackground, reverse: isCatcherPerspective },
        isNumber$2(grade) && (React.createElement(StyledCatcherWristbandBadge, { "$grade": grade, "$fontSize": fontSize + 3, "$size": size }, grade)),
        redX && (React.createElement(StyledHeatmapSVGOverlay, { "$padding": heatMapPadding, height: height, width: width },
            React.createElement("line", { x1: "3", y1: "3", x2: width - 3, y2: height - 3, style: { stroke: 'rgb(0,0,0)', strokeWidth: 2 } }),
            React.createElement("line", { x1: width - 3, y1: "3", x2: "3", y2: height - 3, style: { stroke: 'rgb(0,0,0)', strokeWidth: 2 } }))),
        greenBox && (React.createElement(StyledHeatmapSVGOverlay, { "$padding": heatMapPadding, height: height, width: width },
            React.createElement("rect", { x: "0", y: "0", width: width, height: height, style: { fill: 'none', stroke: '#008000', strokeWidth: 3 + Math.ceil(height / 100) } }))),
        dashGreenBox && (React.createElement(StyledHeatmapSVGOverlay, { "$padding": heatMapPadding, height: height, width: width },
            React.createElement("rect", { x: "0", y: "0", width: width, height: height, style: { fill: 'none', stroke: '#000000', strokeWidth: 3 + Math.ceil(height / 100) } }))),
        selected && (React.createElement(StyledHeatmapSVGOverlay, { "$padding": heatMapPadding, height: height, width: width },
            !!src && (React.createElement(React.Fragment, null,
                React.createElement("text", { x: "5", y: "20", fontSize: fontSize, fill: "#000" }, is2K ? '3-2' : '0-0'),
                React.createElement("text", { x: width - (fontSize - 16) - (!is2K && kFree ? 46 : 32), y: height - 4, fontSize: fontSize, fill: "#000" }, is2K ? '3-2' : '0-0'),
                !is2K && kFree && (
                // eslint-disable-next-line react/no-unknown-property
                React.createElement("g", { transform: "scale (-1, 1)", "transform-origin": "center" },
                    React.createElement("text", { x: width - 49, y: "20", fontSize: fontSize, fill: "#000" }, translate('baseball.abbr-strikeout-k')),
                    React.createElement("text", { x: "7", y: height - 4, fontSize: fontSize, fill: "#000" }, translate('baseball.abbr-strikeout-k')))))),
            !src && (React.createElement(React.Fragment, null,
                React.createElement("text", { x: (width / 2) - (!is2K && kFree ? 22 : 15), y: height / 2, fontSize: fontSize, fill: "#000" }, is2K ? '3-2' : '0-0'),
                !is2K && kFree && (
                // eslint-disable-next-line react/no-unknown-property
                React.createElement("g", { transform: "scale (-1, 1)", "transform-origin": "center" },
                    React.createElement("text", { x: (width / 2) - 22, y: height / 2, fontSize: fontSize, fill: "#000" }, translate('baseball.abbr-strikeout-k')))))))),
        is2K && otz && (React.createElement(StyledHeatmapSVGOverlay, { "$padding": heatMapPadding, height: height, width: width },
            !!src && (React.createElement(React.Fragment, null,
                !selected && React.createElement("text", { x: "5", y: "20", fontSize: fontSize, fill: "#000" }, translate('components.charts.abbr-out-zone')),
                React.createElement("text", { x: "5", y: height - 4, fontSize: fontSize, fill: "#000" }, translate('components.charts.abbr-out-zone')))),
            !src && (React.createElement("text", { x: (width / 2) - 14, y: (height / 2) + 20, fontSize: fontSize, fill: "#000" }, translate('components.charts.abbr-out-zone')))))));
};

const StyledBallSpin = styled.div `
    border-radius: 10px;
    overflow: hidden;
    canvas {
        border-radius: 10px;
    }
`;
class BallSpin extends Component {
    constructor(props) {
        super(props);
        this.ball = null;
        this.camera = null;
        this.renderer = null;
        this.scene = null;
        this.ballSpinContainer = createRef();
        // there is an issue with rotation speeds when rerendering the component
        // this count is here to reset the recursive animation process
        this.renderCount = 0;
        this.texturesLoading = 0;
        this.animate = this.animate.bind(this);
        this.init = this.init.bind(this);
        this.axis = new THREE.Vector3(1, 0, 0).normalize();
        this.axis.applyAxisAngle(new THREE.Vector3(0, 0, 1).normalize(), THREE.MathUtils.degToRad(props.theta * -1));
        this.axis.applyAxisAngle(new THREE.Vector3(0, 1, 0).normalize(), THREE.MathUtils.degToRad(props.phi));
    }
    componentDidMount() {
        this.init();
    }
    componentDidUpdate(prevProps) {
        if (this.props.animate && !prevProps.animate && !this.texturesLoading) {
            this.animate(this.renderCount, this.props.perspective);
        }
        else if (this.props.phi !== prevProps.phi || this.props.theta !== prevProps.theta) {
            this.init();
        }
    }
    componentWillUnmount() {
        this.renderCount = 0;
    }
    init() {
        this.renderCount += 1;
        const container = this.ballSpinContainer.current;
        const { phi, theta } = this.props;
        this.texturesLoading = 0;
        this.scene = new THREE.Scene();
        new THREE.TextureLoader().load(ifGrassZoomOutNoStripe, (texture) => { this.scene.background = texture; });
        this.camera = new THREE.PerspectiveCamera(70, 1, 1, 2000);
        this.camera.position.set(0, -200, 0);
        this.camera.up = new THREE.Vector3(0, 0, 1);
        this.camera.lookAt(new THREE.Vector3(0, 0, 0));
        this.scene.add(this.camera);
        this.scene.add(new THREE.AmbientLight(0xf0f0f0));
        const light = new THREE.SpotLight(0xffffff, 1.5);
        light.position.set(0, 350, 200);
        light.castShadow = true;
        light.shadow = new THREE.SpotLightShadow(new THREE.PerspectiveCamera(70, 1, 200, 2000));
        light.shadow.bias = -0.000222;
        light.shadow.mapSize.width = 1024;
        light.shadow.mapSize.height = 1024;
        this.scene.add(light);
        this.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(this.props.size, this.props.size);
        this.renderer.shadowMap.enabled = true;
        container.innerHTML = '';
        container.appendChild(this.renderer.domElement);
        const geometry = new THREE.SphereGeometry(80, 32, 32, 0, Math.PI * 2, 0, Math.PI);
        this.texturesLoading += 1;
        const texture = new THREE.TextureLoader().load(baseballWLogo, () => { this.texturesLoading -= 1; });
        const material = new THREE.MeshBasicMaterial({
            map: texture,
        });
        this.ball = new THREE.Mesh(geometry, material);
        // rotate the ball into alignment with the spin axis and add it to the scene
        this.ball.rotateY(THREE.MathUtils.degToRad(phi));
        this.ball.rotateZ(THREE.MathUtils.degToRad(theta * -1));
        this.scene.add(this.ball);
        // add orthogonal disk
        const diskGeom = new THREE.RingGeometry(75, 110, 32);
        diskGeom.lookAt(this.axis); // set the normal vector of the ring geometry to be the spin axis
        const diskMat = new THREE.MeshBasicMaterial({ color: 0x0000ff, side: THREE.DoubleSide, transparent: true, opacity: 0.5 });
        const disk = new THREE.Mesh(diskGeom, diskMat);
        this.scene.add(disk);
        const origin = new THREE.Vector3(0, 0, 0);
        const length = 100;
        const hex = 0xff0000;
        const hex2 = 0xffff00;
        const arrowHelper = new THREE.ArrowHelper(this.axis, origin, length, hex);
        const redCylinderGeometry = new THREE.CylinderBufferGeometry(5, 5, 100, 16);
        redCylinderGeometry.translate(0, 75, 0);
        const redCylinderEdges = new THREE.EdgesGeometry(redCylinderGeometry);
        const edgeLine = new THREE.LineSegments(redCylinderEdges, new THREE.LineBasicMaterial({ color: 0x880000 }));
        const redCylinder = new THREE.Mesh(redCylinderGeometry, new THREE.MeshBasicMaterial({ color: 0xff0000 }));
        arrowHelper.add(redCylinder);
        arrowHelper.add(edgeLine);
        const arrowHelper2 = new THREE.ArrowHelper(new THREE.Vector3(-this.axis.x, -this.axis.y, -this.axis.z), origin, length, hex2);
        this.scene.add(arrowHelper);
        this.scene.add(arrowHelper2);
        this.renderer.render(this.scene, this.camera);
        this.animate(this.renderCount, this.props.perspective);
    }
    animate(currentRenderCount, perspective) {
        if ((this.props.animate || this.texturesLoading > 0) && currentRenderCount === this.renderCount) {
            window.requestAnimationFrame(() => this.animate(currentRenderCount, perspective));
        }
        this.renderBall(perspective);
    }
    rotateBall(perspective) {
        const spinDirection = perspective === 'pitcher' ? -1 : 1;
        this.ball.rotateOnWorldAxis(this.axis, spinDirection * 0.05);
    }
    renderBall(perspective) {
        this.renderer.render(this.scene, this.camera);
        if (this.props.animate) {
            this.rotateBall(perspective);
        }
    }
    render() {
        return (React.createElement(StyledBallSpin, { ref: this.ballSpinContainer }));
    }
}
BallSpin.defaultProps = {
    size: 300,
    perspective: 'catcher',
};

const Container$i = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
const mapPitchesToSeries$3 = (translate, pitches, keyX, keyY, marker, opacity = 0.8, enableMouseTracking = true, abbreviateName = false, colorFunc) => {
    const initPitchTypeGroups = [];
    const pitchTypeGroups = pitches.reduce((acc, p) => {
        var _a, _b;
        if (!acc.find((x) => x.pitchtype === p.pitchtype && x.fxsubtype === p.fxsubtype)) {
            acc.push({
                pitchtype: p.pitchtype,
                fxsubtype: p.fxsubtype,
                points: [],
            });
        }
        const pitchGroup = acc.find((x) => x.pitchtype === p.pitchtype && x.fxsubtype === p.fxsubtype);
        if (((_b = (_a = pitchGroup === null || pitchGroup === void 0 ? void 0 : pitchGroup.points) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : Number.MAX_SAFE_INTEGER) < 500 && p[keyX] !== null && p[keyY] !== null) {
            pitchGroup === null || pitchGroup === void 0 ? void 0 : pitchGroup.points.push(Object.assign(Object.assign({}, p), { x: p[keyX], y: p[keyY], color: colorFunc(p), marker }));
        }
        return acc;
    }, initPitchTypeGroups);
    return pitchTypeGroups.map((pt) => ({
        type: 'scatter',
        data: pt.points,
        name: (pitchTypeDisplayName(pt, abbreviateName, abbreviateName, translate)
            || pitchType(0, abbreviateName, undefined, translate)),
        opacity,
        enableMouseTracking,
        id: `${pt.pitchtype}${pt.fxsubtype != null ? `-${pt.fxsubtype}` : ''}`,
        color: colorFunc({ pitchtype: pt.pitchtype, fxsubtype: pt.fxsubtype }),
    })).filter((g) => { var _a; return (_a = g === null || g === void 0 ? void 0 : g.data) === null || _a === void 0 ? void 0 : _a.length; });
};
const PitchBreakPlotChart = forwardRef(({ pitches, videoPlayerModal: VideoPlayerModal, pitchVideoFn, multiVideoFn, modalContainer, keyX = 'breakx', keyY = 'breakz', labelX = '', labelY = '', minX = null, minY = null, maxX = null, maxY = null, minMaxCoordinate = 5, height = 210, width = 210, enableZoom = true, perspective = 'pitcher', allPitches = [], seriesData = [], plotLinesX = [], plotLinesY = [], showlegend = false, abbreviateName = false, colorFunc = (pt) => pitchTypeColor(pt.pitchtype), turboThreshold = 10000, tooltipFormatter, }, outerRef) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    const labelXuse = labelX === '' ? translate('components.charts.break-x-in') : labelX;
    const labelYuse = labelY === '' ? translate('components.charts.break-z-in') : labelY;
    if (!(pitches === null || pitches === void 0 ? void 0 : pitches.length) && !seriesData.length) {
        return React.createElement(Container$i, { style: { width } },
            React.createElement("em", null, translate('components.charts.no-pitches')));
    }
    const pitchSeries = mapPitchesToSeries$3(translate, pitches, keyX, keyY, { radius: 4, lineWidth: 1, lineColor: '#333' }, 0.8, true, abbreviateName, colorFunc);
    const allPitchSeries = mapPitchesToSeries$3(translate, allPitches || [], keyX, keyY, { radius: 2 }, 0.3, false, abbreviateName, colorFunc);
    const pitchTypeSeries = allPitchSeries.concat(pitchSeries).concat(seriesData);
    const xAbsVals = pitchTypeSeries.flatMap(({ data }) => data.map(({ x }) => Math.abs(x || 0)));
    const yAbsVals = pitchTypeSeries.flatMap(({ data }) => data.map(({ y }) => Math.abs(y || 0)));
    const chartScale = Math.max(minMaxCoordinate - 1, ...xAbsVals, ...yAbsVals) + 1;
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq, playid) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq, playid);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const fetchMultiVideo = (videoPitches) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const pitchIds = videoPitches
                .filter(({ gameid, eventseq, pitchseq }) => isNumber$2(gameid, eventseq, pitchseq))
                .map(({ gameid, eventseq, pitchseq }) => ({ gameid: Number(gameid), eventseq: Number(eventseq), pitchseq: Number(pitchseq) }));
            const playlist = yield multiVideoFn(pitchIds);
            setVideoPlaylist(playlist);
        }
        catch (_b) {
            closePitchVideo();
        }
    });
    const chartConfig = {
        chart: {
            type: 'scatter',
            animation: false,
            plotBorderWidth: 1,
            zoomType: enableZoom ? 'xy' : undefined,
            backgroundColor: undefined,
            height,
            width,
            events: {
                selection(e) {
                    var _a, _b;
                    if (multiVideoFn && ((_a = e.xAxis) === null || _a === void 0 ? void 0 : _a.length) && ((_b = e.yAxis) === null || _b === void 0 ? void 0 : _b.length)) {
                        const [{ min: minXAxis, max: maxXAxis }] = e.xAxis;
                        const [{ min: minYAxis, max: maxYAxis }] = e.yAxis;
                        const points = this.series.flatMap((s) => s.points.filter((point) => {
                            const { enabled, x, y } = point;
                            return enabled !== false && x >= minXAxis && x <= maxXAxis && typeof y === 'number' && y >= minYAxis && y <= maxYAxis;
                        }));
                        if (points.length) {
                            fetchMultiVideo(points.map((p) => ({
                                gameid: p.gameid,
                                pitchseq: p.pitchseq,
                                eventseq: p.eventseq,
                            })));
                        }
                        return false;
                    }
                    return true;
                },
            },
        },
        title: {
            text: undefined,
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            scatter: {
                animation: false,
                stickyTracking: false,
                marker: {
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: '#000',
                        },
                    },
                },
            },
            series: {
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if ((this.gameid && this.eventseq && this.pitchseq) || this.playid) {
                                fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq, this.playid);
                            }
                        },
                    },
                },
                turboThreshold,
            },
        },
        legend: {
            enabled: showlegend,
            width: '100%',
            x: width * 0.1,
            align: 'center',
        },
        xAxis: {
            min: minX != null ? minX : -chartScale,
            max: maxX != null ? maxX : chartScale,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 3,
            tickLength: 6,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: false,
            reversed: !perspective || perspective === 'pitcher',
            title: {
                text: labelXuse,
            },
            plotLines: [{
                    color: 'lightgrey',
                    value: 0,
                    width: 1,
                }, ...plotLinesX],
        },
        yAxis: {
            min: minY != null ? minY : -chartScale,
            max: maxY != null ? maxY : chartScale,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 3,
            tickLength: 6,
            minorTickInterval: 3,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: false,
            title: {
                text: labelYuse,
            },
            plotLines: [{
                    color: 'lightgrey',
                    value: 0,
                    width: 1,
                }, ...plotLinesY],
        },
        tooltip: {
            formatter(tooltip) {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                if (!this.point.tooltip && !this.point.name)
                    return tooltip.defaultFormatter.call(this, tooltip);
                return `<b>${this.series.name}</b><br/>${this.point.tooltip || this.point.name}`;
            },
        },
        series: pitchTypeSeries,
    };
    return (React.createElement(Container$i, null,
        pitchVideoFn && VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { immutable: true, ref: ref, width: width, options: chartConfig, useBodyFont: false })));
});

/* eslint-disable react/no-this-in-sfc */
const Container$h = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
const LineChart = ({ seriesData, width, titleX, minY, maxY, minX, maxX, dateFormatX, isDateX = false, showLegend = false, title = '', subtitle = '', titleY = '', legendposition = 'float', }) => {
    const legendConfig = {
        enabled: showLegend,
    };
    if (legendposition === 'float' || !legendposition) {
        legendConfig.align = 'right';
        legendConfig.verticalAlign = 'top';
    }
    else if (legendposition === 'below') {
        legendConfig.align = 'center';
    }
    const chartConfig = {
        title: {
            text: title,
        },
        subtitle: {
            text: subtitle,
        },
        xAxis: {
            min: minX,
            max: maxX,
            title: {
                text: titleX,
            },
            type: isDateX ? 'datetime' : undefined,
            labels: {
                formatter() {
                    if (isDateX)
                        return Highcharts.dateFormat(dateFormatX, Number(this.value));
                    return this.value.toString();
                },
            },
            endOnTick: true,
            showFirstLabel: false,
            startOnTick: true,
        },
        yAxis: {
            min: minY,
            max: maxY,
            title: {
                text: titleY,
            },
            endOnTick: true,
            showFirstLabel: false,
            startOnTick: true,
        },
        tooltip: {
            formatter(tooltip) {
                if (isDateX)
                    return `<b>${Highcharts.dateFormat(dateFormatX, this.point.x)}</b><br />${this.point.y}`;
                return tooltip.defaultFormatter.call(this, tooltip);
            },
        },
        plotOptions: {
            series: {
                label: {
                    connectorAllowed: false,
                },
            },
        },
        legend: legendConfig,
        series: seriesData,
    };
    return (React.createElement(Container$h, null,
        React.createElement(BaseChart, { width: width, options: chartConfig, useBodyFont: false })));
};

const StyledContainer$6 = styled.div `
    display: flex;
    flex-wrap: wrap;
    width: ${(props) => props.width}px;
    height: ${(props) => props.width}px;
    border: 1px solid #737373;
    border-radius: 5px;

    background: url("data:image/svg+xml;utf8,
        <svg xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='none' viewBox='0 0 100 100'> 
            <path d='M0 0 L0 100 L100 100 L100 0' fill='%23EDEDED' />    
            <path d='M0 0 L25 34' stroke='%23737373' stroke-width='0.5' />
            <path d='M100 0 L75 34' stroke='%23737373' stroke-width='0.5' />
            <path d='M0 100 L25 67' stroke='%23737373' stroke-width='0.5' />   
            <path d='M100 100 L75 67' stroke='%23737373' stroke-width='0.5' /> 
        </svg>"
    );
    background-repeat:no-repeat;
    background-position:center center;
    background-size: 100% 100%, auto;
`;
const StyledUpDown = styled.div `
    width: ${(props) => props.width}px;
    height: ${(props) => props.width / 6}px;
`;
const StyledInOut = styled.div `
    width: ${(props) => (props.width / 4) - 1}px;
    height: ${(props) => props.width / 6}px;
`;
const StyledCenter = styled.div `
    width: ${(props) => props.width / 2}px;
    height: ${(props) => props.width / 3}px;
    margin: auto;
    position: relative;
    background-color: #737373;
    border: 1px solid #737373;
`;
const StyledContent = styled.div `
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${(props) => props.width / 3}px;
    font-size: ${(props) => props.fontsize || '1.3em'};
    font-weight: ${(props) => props.fontweight || 'normal'};
    color: ${(props) => props.fontcolor || '#515151'};
`;
const StyledOverall = styled.div `
    width: ${(props) => props.width}px;
    display: flex;
    justify-content: center;
    font-size: 1.4em;
    font-weight: bold;
    margin-top: 10px;
`;
const addSign$1 = (value) => {
    if (typeof value !== 'number')
        return value;
    if (value > 0)
        return `+${value.toFixed(1)}`;
    return value.toFixed(1);
};
const ReceivingChart = ({ width = 200, split, up, down, gloveSide, armSide, total }) => (React.createElement("div", null,
    React.createElement(StyledContainer$6, { width: width },
        React.createElement(StyledUpDown, { width: width },
            React.createElement(StyledContent, { width: width }, addSign$1(up))),
        React.createElement(StyledInOut, { width: width },
            React.createElement(StyledContent, { width: width }, addSign$1(gloveSide))),
        React.createElement(StyledCenter, { width: width },
            React.createElement(StyledContent, { fontsize: "1.5em", fontcolor: "white", fontweight: "bold", width: width }, split)),
        React.createElement(StyledInOut, { width: width },
            React.createElement(StyledContent, { width: width }, addSign$1(armSide))),
        React.createElement(StyledUpDown, { width: width },
            React.createElement(StyledContent, { width: width }, addSign$1(down)))),
    React.createElement(StyledOverall, { width: width }, addSign$1(total))));

const CatcherDepth = ({ seriesData, width, title = '', subtitle = '', titleDataY = '', titleHistogramY = '', titleDataX = '', titleHistogramX = '', }) => {
    const { t: translate } = useTranslation();
    const { name, data, leagueAverage } = seriesData;
    const titleDataYuse = titleDataY === '' ? translate('components.charts.data') : titleDataY;
    const titleDataXuse = titleDataX === '' ? translate('components.charts.data') : titleDataX;
    const titleHistogramYuse = titleHistogramY === '' ? translate('components.charts.histogram') : titleHistogramY;
    const titleHistogramXuse = titleHistogramX === '' ? translate('components.charts.histogram') : titleHistogramX;
    histogram(Highcharts);
    const ref = useRef(null);
    const chartConfig = {
        title: {
            text: title,
        },
        subtitle: {
            text: subtitle,
        },
        xAxis: [{
                title: { text: titleDataXuse },
                alignTicks: false,
                visible: false,
            }, {
                title: { text: titleHistogramXuse },
                alignTicks: false,
                opposite: true,
                plotLines: [{
                        color: 'red',
                        dashStyle: 'LongDashDot',
                        value: leagueAverage,
                        width: 2,
                        zIndex: 99,
                    }],
            }],
        yAxis: [{
                title: { text: titleDataYuse },
                visible: false,
            }, {
                title: { text: titleHistogramYuse },
                opposite: true,
            }],
        plotOptions: {
            histogram: {
                accessibility: {
                    pointDescriptionFormatter(point) {
                        const ix = point.index + 1;
                        const x1 = point.x.toFixed(3);
                        const x2 = point.x2.toFixed(3);
                        const val = point.y;
                        return `${ix}. ${x1} to ${x2}, ${val}.`;
                    },
                },
                tooltip: {
                    pointFormatter() {
                        const { x, x2, y } = this;
                        return `<strong>${translate('components.charts.depth')}</strong>: ${x.toFixed(2)} in. - ${x2.toFixed(2)} in.<br/><strong>${translate('components.charts.count')}</strong>: ${y}`;
                    },
                },
            },
        },
        series: [{
                name,
                type: 'histogram',
                xAxis: 1,
                yAxis: 1,
                baseSeries: 's1',
                zIndex: -1,
            }, {
                name: translate('components.charts.data'),
                type: 'scatter',
                data,
                id: 's1',
                marker: {
                    radius: 1.5,
                },
                visible: false,
                showInLegend: false,
            }],
        credits: {
            enabled: false,
        },
    };
    return (React.createElement(BaseChartContainer, { "$width": width, "$useBodyFont": false },
        React.createElement(HighchartsReact, { ref: ref, highcharts: Highcharts, options: chartConfig })));
};

const Container$g = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
const GloveLocation = ({ seriesData, categories, width, title, subtitle, titleX, titleY, tooltipSuffix, type = 'column' }) => {
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        const chart = ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        renderBattersBoxes(chart);
    }, [ref, seriesData]); // eslint-disable-line react-hooks/exhaustive-deps
    function renderBattersBoxes(chart) {
        var _a, _b;
        const rectattr = {
            'stroke-width': 2,
            stroke: 'lightgrey',
            fill: 'none',
            zIndex: 1,
        };
        const playerSeries = (_b = (_a = chart.xAxis[0]) === null || _a === void 0 ? void 0 : _a.series[0]) === null || _b === void 0 ? void 0 : _b.data;
        if (!playerSeries)
            return;
        const platePath = new Array();
        const { min, max } = chart.xAxis[0].getExtremes();
        const midPoint = chart.xAxis[0].toPixels((min + max) / 2, false);
        const leftEdge = chart.xAxis[0].toPixels(1, false);
        const rightEdge = chart.xAxis[0].toPixels(4, false);
        const segmentLength = (rightEdge - leftEdge) / 2;
        platePath.push('M');
        platePath.push(leftEdge, 50);
        platePath.push('L');
        platePath.push(leftEdge, segmentLength);
        platePath.push(midPoint, chart.plotHeight + 40);
        platePath.push(rightEdge, segmentLength);
        platePath.push(rightEdge, 50);
        platePath.push(leftEdge, 50);
        chart.renderer.path(platePath).attr(rectattr).add();
    }
    const chartConfig = {
        chart: {
            type,
            height: 400,
            width: 700,
        },
        title: {
            text: title,
        },
        subtitle: {
            text: subtitle,
        },
        xAxis: {
            categories,
            title: {
                text: titleX,
            },
        },
        yAxis: {
            title: {
                text: titleY,
                align: 'high',
            },
            labels: {
                overflow: 'justify',
            },
        },
        tooltip: {
            valueSuffix: tooltipSuffix,
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: true,
                },
            },
        },
        credits: {
            enabled: false,
        },
        series: seriesData,
    };
    return (React.createElement(Container$g, null,
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable react/no-this-in-sfc */
const HomePlateChart = ({ seriesData, legendPosition, onClick, height = 350, width = 350, minX = -6, maxX = 6, minY = -6, maxY = 6, oppositeY = false, showLegend = true, enableZoom = false, turboThreshold = 1000, }) => {
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        const chart = ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        renderBattersBoxes(chart);
    }, [ref, seriesData]); // eslint-disable-line react-hooks/exhaustive-deps
    function renderBattersBoxes(chart) {
        const bbtop = 3.7083;
        const bbbottom = -2.2917;
        const x1 = chart.xAxis[0].toPixels(-5.2083, false);
        const x2 = chart.xAxis[0].toPixels(1.2083, false);
        const y = chart.yAxis[0].toPixels(bbtop, false);
        const h = chart.yAxis[0].toPixels(bbbottom, false) - chart.yAxis[0].toPixels(bbtop, false);
        const w = chart.xAxis[0].toPixels(-1.2083, false) - chart.xAxis[0].toPixels(-5.2083, false);
        const rectattr = {
            'stroke-width': 1,
            stroke: '#333333',
            fill: 'none',
            zIndex: 1,
        };
        chart.renderer.rect(x1, y, w, h, 0).attr(rectattr).add();
        chart.renderer.rect(x2, y, w, h, 0).attr(rectattr).add();
        const platePath = new Array();
        platePath.push('M');
        platePath.push(chart.xAxis[0].toPixels(0, false));
        platePath.push(chart.yAxis[0].toPixels(0, false));
        platePath.push('L');
        platePath.push(chart.xAxis[0].toPixels(0.7083, false));
        platePath.push(chart.yAxis[0].toPixels(0.7083, false));
        platePath.push(chart.xAxis[0].toPixels(0.7083, false));
        platePath.push(chart.yAxis[0].toPixels(1.4167, false));
        platePath.push(chart.xAxis[0].toPixels(-0.7083, false));
        platePath.push(chart.yAxis[0].toPixels(1.4167, false));
        platePath.push(chart.xAxis[0].toPixels(-0.7083, false));
        platePath.push(chart.yAxis[0].toPixels(0.7083, false));
        platePath.push(chart.xAxis[0].toPixels(0, false));
        platePath.push(chart.yAxis[0].toPixels(0, false));
        platePath.push('Z');
        chart.renderer.path(platePath).attr(rectattr).add();
        const bhpPath = new Array();
        bhpPath.push('M');
        bhpPath.push(chart.xAxis[0].toPixels(-1.7917, false));
        bhpPath.push(chart.yAxis[0].toPixels(-2.2917, false));
        bhpPath.push('L');
        bhpPath.push(chart.xAxis[0].toPixels(-1.7917, false));
        bhpPath.push(chart.yAxis[0].toPixels(-8, false));
        bhpPath.push(chart.xAxis[0].toPixels(1.7917, false));
        bhpPath.push(chart.yAxis[0].toPixels(-8, false));
        bhpPath.push(chart.xAxis[0].toPixels(1.7917, false));
        bhpPath.push(chart.yAxis[0].toPixels(-2.2917, false));
        chart.renderer.path(bhpPath).attr(rectattr).add();
    }
    let legendConfig = { enabled: showLegend };
    if (legendPosition === 'float' || !legendPosition) {
        legendConfig = Object.assign(Object.assign({}, legendConfig), { align: 'right', verticalAlign: 'top', layout: 'vertical', floating: true, x: -16, y: 10 });
    }
    else if (legendPosition === 'below') {
        legendConfig = Object.assign(Object.assign({}, legendConfig), { align: 'center' });
    }
    else if (legendPosition === 'upperleft') {
        legendConfig = Object.assign(Object.assign({}, legendConfig), { align: 'left', verticalAlign: 'top', layout: 'vertical', floating: true, x: 22, y: -6 });
    }
    const chartConfig = {
        chart: {
            type: 'scatter',
            height,
            width,
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
        },
        colors: ['#3366FF', '#BF0B23', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        title: { text: undefined },
        plotOptions: {
            series: {
                marker: {
                    radius: 2,
                    symbol: 'circle',
                },
                stickyTracking: false,
                point: {
                    events: {
                        click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (onClick)
                                    return onClick(this);
                            }
                            return null;
                        },
                    },
                },
                turboThreshold,
            },
        },
        legend: legendConfig,
        xAxis: {
            min: minX,
            max: maxX,
            gridLineWidth: 0,
            tickInterval: 1,
            tickLength: 6,
            minorTickInterval: 0.25,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            minPadding: 0,
            maxPadding: 0,
        },
        yAxis: {
            min: minY,
            max: maxY,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 1,
            tickLength: 6,
            minorTickInterval: 0.25,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: oppositeY,
            title: {
                text: null,
            },
        },
        tooltip: {
            formatter() {
                if (!this.point.tooltip && !this.point.name)
                    return false;
                let tooltip = `<b>${this.series.name}</b><br />`;
                if (this.point.tooltip) {
                    tooltip += this.point.tooltip;
                }
                else {
                    tooltip += this.point.name;
                }
                return tooltip;
            },
        },
        series: seriesData,
    };
    return (React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false }));
};

const StyledContainer$5 = styled.div `
    width: ${(props) => props.width}px;
`;
const StyledLegend$2 = styled.table `
    width: 100%;
    border: 1px solid 
`;
const StyledLegendData$1 = styled.td `
&& {
    text-align: center;
    padding: 2px 6px 2px 3px;
    border: solid 1px #999999;
}`;
const StyledColorBlock$1 = styled.a `
&& {
    width: 15px; 
    height: 15px; 
    display: inline-block; 
    background-color: ${(props) => props.color};
}`;
const CatcherAccuracy = ({ base, seriesData, modalContainer, pitchVideoFn, onClick, videoPlayerModal: VideoPlayerModal, enableZoom = true, height = 500, width = 400, minX = 0, maxX = 400, minY = 0, maxY = 500, showLegend = true, }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [videoPlaylist, setVideoPlaylist] = useState();
    // Update state when prop changes through
    useEffect(() => {
        redraw();
    }, [ref, base, seriesData]); // eslint-disable-line react-hooks/exhaustive-deps
    let bgGroup;
    const renderBackgroundImage = () => {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        const xExtent = chart.xAxis[0].getExtremes();
        const yExtent = chart.yAxis[0].getExtremes();
        const arcAdjustment = (500 / (yExtent.max - yExtent.min));
        // create an SVG group and remove it first if it already exists
        if (bgGroup != null)
            bgGroup.element.remove();
        bgGroup = chart.renderer.g().add();
        // add background image scaled to current extents
        const img = base === 2 ? catcherThrows2B : catcherThrows3B;
        chart.renderer
            .image(img, chart.xAxis[0].toPixels(minX, false), chart.yAxis[0].toPixels(maxY, false), width * (width / (xExtent.max - xExtent.min)), height * (height / (yExtent.max - yExtent.min)))
            .attr({
            zIndex: 2,
            opacity: 0.75,
        })
            .add(bgGroup);
        // draw two concentric circles at (255,230), scaled to current extents
        // (arbitrarily chose Y-extent for scaling _arcAdjustment, so there will probably be some squishyness but i bet nobody notices)
        chart.renderer
            .circle(chart.xAxis[0].toPixels(255, false), chart.yAxis[0].toPixels(230, false), 78 * arcAdjustment)
            .attr({
            fill: 'transparent',
            stroke: '#999999',
            'stroke-width': 1,
        }).add(bgGroup);
        chart.renderer
            .circle(chart.xAxis[0].toPixels(255, false), chart.yAxis[0].toPixels(230, false), 124 * arcAdjustment)
            .attr({
            fill: 'transparent',
            stroke: '#999999',
            'stroke-width': 1,
        }).add(bgGroup);
    };
    function redraw() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        renderBackgroundImage();
        chart.redraw();
    }
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const chartConfig = {
        chart: {
            type: 'scatter',
            height,
            width,
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
            margin: [0, 0, 0, 0],
        },
        colors: ['#3366FF', '#BF0B23', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        title: {
            text: undefined,
        },
        plotOptions: {
            series: {
                marker: {
                    radius: 4,
                    symbol: 'circle',
                },
                stickyTracking: false,
                color: '#ff0000',
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (onClick)
                                    return onClick(this);
                                return fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq);
                            }
                            return null;
                        },
                    },
                },
            },
        },
        legend: {
            enabled: false,
        },
        xAxis: {
            height,
            width,
            min: minX,
            max: maxX,
            gridLineWidth: 0,
            tickInterval: 100,
            tickLength: 0,
            minorTickLength: 0,
            minorGridLineWidth: 0,
            minPadding: 0,
            maxPadding: 0,
            startOnTick: true,
            endOnTick: true,
            labels: { enabled: false },
            title: { text: undefined },
        },
        yAxis: {
            height,
            width,
            min: minY,
            max: maxY,
            gridLineWidth: 0,
            lineWidth: 0,
            tickInterval: 100,
            tickLength: 0,
            minorTickLength: 0,
            minorGridLineWidth: 0,
            minPadding: 0,
            maxPadding: 0,
            startOnTick: true,
            endOnTick: true,
            labels: { enabled: false },
            title: { text: undefined },
        },
        tooltip: {
            formatter() {
                let tooltip = '';
                if (this.point.tooltip)
                    tooltip += this.point.tooltip;
                tooltip += this.point.name;
                return tooltip;
            },
        },
        series: seriesData,
        loading: undefined,
    };
    const defaultSeries = base === 2 ? [
        { data: [], name: '<1.82', index: 1, id: 'set1', color: '#cc0000', threshold: 1.82 },
        { data: [], name: '1.82-1.90', index: 2, id: 'set2', color: '#dddd00', threshold: 1.90 },
        { data: [], name: '1.90-1.98', index: 3, id: 'set3', color: '#009900', threshold: 1.98 },
        { data: [], name: '1.98-2.06', index: 4, id: 'set4', color: '#0000cc', threshold: 2.06 },
        { data: [], name: '2.06+', index: 5, id: 'set5', color: '#aa00aa', threshold: 999 },
    ] : [
        { data: [], name: '<1.40', index: 1, id: 'set1', color: '#cc0000', threshold: 1.401 },
        { data: [], name: '1.40-1.46', index: 2, id: 'set2', color: '#dddd00', threshold: 1.468 },
        { data: [], name: '1.46-1.50', index: 3, id: 'set3', color: '#009900', threshold: 1.502 },
        { data: [], name: '1.50-1.56', index: 4, id: 'set4', color: '#0000cc', threshold: 1.568 },
        { data: [], name: '1.56+', index: 5, id: 'set5', color: '#aa00aa', threshold: 999 },
    ];
    return (React.createElement(StyledContainer$5, { width: width },
        !!pitchVideoFn && !!VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false }),
        !!showLegend && (React.createElement(StyledLegend$2, null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement(StyledLegendData$1, { colSpan: defaultSeries.length }, base === 2 ? `${translate('baseball.2b')} ${translate('components.charts.pop-times')}` : `${translate('baseball.3b')} ${translate('components.charts.pop-times')}`)),
                React.createElement("tr", null, defaultSeries.map((d) => React.createElement(StyledLegendData$1, { key: d.id },
                    React.createElement(StyledColorBlock$1, { color: d.color }),
                    React.createElement("br", null),
                    d.name))))))));
};

const StyledContainer$4 = styled.div `
    width: ${(props) => props.width}px;
`;
const StyledLegend$1 = styled.table `
    width: 100%;
    border: 1px solid 
`;
const StyledLegendData = styled.td `
&& {
    text-align: center;
    padding: 2px 6px 2px 3px;
    border: solid 1px #999999;
}`;
const StyledColorBlock = styled.a `
&& {
    width: 15px; 
    height: 15px; 
    display: inline-block; 
    background-color: ${(props) => props.color};
}`;
const InfielderAccuracy$1 = forwardRef(({ position, seriesData, modalContainer, pitchVideoFn, onClick, videoPlayerModal: VideoPlayerModal, enableZoom = true, width = 700, minX = 0, maxX = width, minY = 0, showLegend = true, tooltipFormatter, }, outerRef) => {
    const defaultWidth = 700;
    const defaultHeight = 550;
    const aspectRatio = defaultWidth / defaultHeight; // Aspect ratio of 7:5
    const height = width / aspectRatio;
    const maxY = height;
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState();
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const [chartConfig, setChartConfig] = useState({
        chart: {
            type: 'scatter',
            height,
            width,
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
            margin: [0, 0, 0, 0],
        },
        colors: ['#3366FF', '#BF0B23', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        title: {
            text: undefined,
        },
        plotOptions: {
            series: {
                marker: {
                    radius: 4,
                    symbol: 'circle',
                },
                stickyTracking: false,
                color: '#ff0000',
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (onClick) {
                                    return onClick(this);
                                }
                                return fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq);
                            }
                            return null;
                        },
                    },
                },
            },
        },
        legend: {
            enabled: false,
        },
        xAxis: {
            height,
            width,
            min: minX,
            max: maxX,
            gridLineWidth: 0,
            tickInterval: 100,
            tickLength: 0,
            minorTickLength: 0,
            minorGridLineWidth: 0,
            minPadding: 0,
            maxPadding: 0,
            startOnTick: true,
            endOnTick: true,
            labels: { enabled: false },
            title: { text: undefined },
        },
        yAxis: {
            height,
            width,
            min: minY,
            max: maxY,
            gridLineWidth: 0,
            lineWidth: 0,
            tickInterval: 100,
            tickLength: 0,
            minorTickLength: 0,
            minorGridLineWidth: 0,
            minPadding: 0,
            maxPadding: 0,
            startOnTick: true,
            endOnTick: true,
            labels: { enabled: false },
            title: { text: undefined },
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                if (this.point.tooltip === undefined)
                    return false;
                let tooltip = `<b>${this.point.name || this.series.name}</b>`;
                if (this.point.tooltip)
                    tooltip += `<br/>${this.point.tooltip}`;
                return tooltip;
            },
        },
        series: seriesData,
        loading: undefined,
    });
    // Update state when prop changes through
    useEffect(() => {
        redraw();
        setChartConfig((prevConfig) => (Object.assign(Object.assign({}, prevConfig), { series: seriesData })));
    }, [ref, position, seriesData]); // eslint-disable-line react-hooks/exhaustive-deps
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    let bgGroup;
    const renderBackgroundImage = () => {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        const xRange = 22; // +/- 11 on the x-axis (total 22 units)
        const yRange = 17; // -5 to +11 on the y-axis (total 17 units)
        const arcAdjustment = height / Math.min(xRange, yRange); // Adjustment factor
        // create an SVG group and remove it first if it already exists
        if (bgGroup != null)
            bgGroup.element.remove();
        bgGroup = chart.renderer.g().add();
        // Add background image based on the selected position
        let img;
        if (position === 5) {
            img = infAccuracy3bGrayscale;
        }
        else if (position === 4) {
            img = infAccuracy2bGrayscale;
        }
        else if (position === 6) {
            img = infAccuracySSGrayscale;
        }
        chart.renderer
            .image(img, chart.xAxis[0].toPixels(minX, false), chart.yAxis[0].toPixels(maxY, false), width, height)
            .attr({
            zIndex: 2,
        })
            .add(bgGroup);
        // Adjusting the coordinates for the center (0, 3) on a 20x20 grid
        const gridYMin = -5;
        const gridYMax = 11;
        const gridYRange = gridYMax - gridYMin;
        // Coordinates for the center (0, 3)
        const xc = width / 2;
        const yc = height * (1 - (3 - gridYMin) / gridYRange);
        // Ellipse axes scaling based on the chart dimensions
        const a = 7.5 * arcAdjustment; // Major axis length
        const b = a / 1.5; // Minor axis length
        const a2 = 9 * arcAdjustment; // Major axis length for outer ellipse
        const b2 = a2 / 1.5; // Minor axis length for outer ellipse
        // Draw the inner ellipse
        chart.renderer
            .createElement('ellipse').attr({
            cx: xc,
            cy: yc,
            rx: a,
            ry: b,
            'stroke-width': 2,
            fill: 'transparent',
            stroke: '#000',
        }).add();
        // Draw the outer ellipse
        chart.renderer
            .createElement('ellipse').attr({
            cx: xc,
            cy: yc,
            rx: a2,
            ry: b2,
            fill: 'transparent',
            stroke: '#000',
            'stroke-width': 2,
        }).add();
        // Draw the line passing through the grid, based on the y-axis center position
        chart.renderer
            .createElement('line')
            .attr({
            x1: chart.plotLeft,
            y1: chart.plotTop + yc + 4 * arcAdjustment,
            x2: chart.plotLeft + chart.plotWidth,
            y2: chart.plotTop + yc + 4 * arcAdjustment,
            stroke: 'black',
            'stroke-width': 2,
            'stroke-dasharray': '8, 4',
            zIndex: 3,
        })
            .add(bgGroup);
    };
    function redraw() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        renderBackgroundImage();
        chart.redraw();
    }
    const defaultSeries = [
        { data: [], name: translate('components.charts.safe'), index: 1, id: 'set1', color: '#cc0000' },
        { data: [], name: translate('baseball.outs_one'), index: 2, id: 'set3', color: '#35a84c' },
    ];
    if (!(seriesData === null || seriesData === void 0 ? void 0 : seriesData.length)) {
        return React.createElement(StyledContainer$4, { className: "mt-4" },
            React.createElement("em", null, translate('components.charts.no-balls-in-play')));
    }
    return (React.createElement(StyledContainer$4, { width: width },
        !!pitchVideoFn && !!VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false }),
        !!showLegend && (React.createElement(StyledLegend$1, null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement(StyledLegendData, { colSpan: defaultSeries.length },
                        position,
                        " ",
                        translate('components.charts.throws'))),
                React.createElement("tr", null, defaultSeries.map((d) => React.createElement(StyledLegendData, { key: d.id },
                    React.createElement(StyledColorBlock, { color: d.color }),
                    React.createElement("br", null),
                    d.name))))))));
});

const StyledContainer$3 = styled.div `
    width: ${(props) => props.width}px;
`;
const CatcherTimes = ({ seriesData, enableZoom, minX, maxX, titleX, minY, maxY, titleY, modalContainer, pitchVideoFn, videoPlayerModal: VideoPlayerModal, onClick, height = 500, width = 400, }) => {
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const chartConfig = {
        chart: {
            type: 'scatter',
            height,
            width,
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
        },
        title: {
            text: undefined,
        },
        plotOptions: {
            series: {
                marker: {
                    radius: 4,
                    symbol: 'circle',
                },
                stickyTracking: false,
                color: '#ff0000',
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (onClick)
                                    return onClick(this);
                                return fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq);
                            }
                            return null;
                        },
                    },
                },
            },
        },
        legend: {
            enabled: false,
        },
        xAxis: {
            min: minX,
            max: maxX,
            startOnTick: true,
            endOnTick: true,
            title: {
                text: titleX,
            },
            labels: {
                formatter() {
                    if (typeof (this === null || this === void 0 ? void 0 : this.value) === 'string')
                        return Number(this.value).toFixed(2);
                    if (typeof (this === null || this === void 0 ? void 0 : this.value) === 'number')
                        return this.value.toFixed(2);
                    return '';
                },
            },
        },
        yAxis: {
            min: minY,
            max: maxY,
            startOnTick: true,
            endOnTick: true,
            title: {
                text: titleY,
            },
            labels: {
                formatter() {
                    if (typeof (this === null || this === void 0 ? void 0 : this.value) === 'string')
                        return Number(this.value).toFixed(2);
                    if (typeof (this === null || this === void 0 ? void 0 : this.value) === 'number')
                        return this.value.toFixed(2);
                    return '';
                },
            },
        },
        tooltip: {
            formatter() {
                let tooltip = '';
                if (this.point.tooltip)
                    tooltip += this.point.tooltip;
                tooltip += this.point.name;
                return tooltip;
            },
        },
        series: seriesData,
    };
    return (React.createElement(StyledContainer$3, { width: width },
        !!pitchVideoFn && !!VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable react/no-this-in-sfc */
const Container$f = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
const ScatterPlotChart = ({ width = 500, height = undefined, typeX = undefined, minX = undefined, maxX = undefined, typeY = undefined, minY = undefined, maxY = undefined, title = '', subtitle = '', titleX = '', tooltipLabelX = '', titleY = '', tooltipLabelY = '', seriesData, tooltipFormatter = undefined, }) => {
    const ref = useRef(null);
    if (Array.isArray(seriesData) && !(seriesData === null || seriesData === void 0 ? void 0 : seriesData.length)) {
        return React.createElement(Container$f, null,
            React.createElement("em", null, "No Data"));
    }
    const chartConfig = {
        chart: {
            type: 'scatter',
            zoomType: 'xy',
            height,
        },
        title: {
            text: title,
        },
        subtitle: {
            text: subtitle,
        },
        xAxis: {
            type: typeX,
            title: {
                text: titleX,
            },
            labels: {
                formatter() {
                    if (typeX === 'datetime' && typeof this.value === 'number') {
                        return Highcharts.dateFormat('%b \'%y', Number(this.value));
                    }
                    return this.value.toString();
                },
            },
            min: minX,
            max: maxX,
            startOnTick: true,
            endOnTick: true,
            tickInterval: typeX === 'datetime' ? (24 * 3000 * 1000 * 30) : undefined,
        },
        yAxis: {
            type: typeY,
            title: {
                text: titleY,
            },
            min: minY,
            max: maxY,
        },
        plotOptions: {
            scatter: {
                marker: {
                    radius: 5,
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: 'rgb(100,100,100)',
                        },
                    },
                },
            },
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                let valueX = this.x ? this.x.toString() : '';
                let valueY = this.y ? this.y.toString() : '';
                if (typeX === 'datetime')
                    valueX = Highcharts.dateFormat('%e %b \'%y', this.x);
                if (typeY === 'datetime')
                    valueY = Highcharts.dateFormat('%e %b \'%y', this.x);
                return `<div>${valueX}${tooltipLabelX}, ${valueY}${tooltipLabelY}</div>`;
            },
        },
        series: seriesData,
    };
    return (React.createElement(Container$f, null,
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false })));
};

const Container$e = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;

        div {
            overflow: visible !important;
        }
        svg {
            overflow: visible !important;

            .highcharts-axis {
                display: none;
            }
        }
        .highcharts-container {
            z-index: unset !important;
            overflow: unset !important;
        }
    }
`;
const SprayChart$3 = forwardRef(({ type, seriesData, enableZoom, enableLegend, disableLegendClick, onClick, pitchVideoFn, multiVideoFn, videoPlayerModal: VideoPlayerModal, modalContainer, sizeMultiplier = 1, preventLegendSeriesHover = false, tooltipFormatter, isGrayScale = false, }, outerRef) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const [bgImgPath, setBgImgPath] = useState(null);
    // Update state when prop changes through
    useEffect(() => {
        drawBackground();
    }, [ref, type, seriesData]); // eslint-disable-line react-hooks/exhaustive-deps
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    if (!(seriesData === null || seriesData === void 0 ? void 0 : seriesData.length)) {
        return React.createElement(Container$e, { className: "mt-4" },
            React.createElement("em", null, translate('components.charts.no-balls-in-play')));
    }
    const fetchPitchVideo = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
        setVideoPlaylist(playlist);
    });
    const fetchMultiVideo = (pitches) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        const pitchIds = pitches
            .filter(({ gameid, eventseq, pitchseq }) => isNumber$2(gameid, eventseq, pitchseq))
            .map(({ gameid, eventseq, pitchseq }) => ({ gameid: Number(gameid), eventseq: Number(eventseq), pitchseq: Number(pitchseq) }));
        const playlist = yield multiVideoFn(pitchIds);
        setVideoPlaylist(playlist);
    });
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const pixOF = 1.165 * sizeMultiplier;
    const pixIF = 2.23 / sizeMultiplier;
    const pixIFBW = 0.67 / sizeMultiplier;
    let canvasWidth = 0;
    let width = 0;
    let height = 0;
    let axisWidth = 0;
    let axisHeight = 0;
    // Defaulted to Yankee Stadium. Need to update this to accept other venues.
    let image = '';
    if (type === 'outfield') {
        canvasWidth = 550 / sizeMultiplier;
        width = 500 / sizeMultiplier;
        height = 404 / sizeMultiplier;
        axisWidth = (canvasWidth * pixOF);
        axisHeight = (height * pixOF);
        image = isGrayScale ? sprayChartOfGrayscale : sprayChartOF;
    }
    else if (type === 'infield') {
        canvasWidth = 500 / sizeMultiplier;
        width = 500 / sizeMultiplier;
        height = 404 / sizeMultiplier;
        axisWidth = canvasWidth / pixIF;
        axisHeight = height / pixIF;
        image = isGrayScale ? sprayChartIfGrayscale : sprayChartIF;
    }
    else if (type === 'infieldbw') {
        canvasWidth = 134 / sizeMultiplier;
        width = 134 / sizeMultiplier;
        height = 134 / sizeMultiplier;
        axisWidth = canvasWidth / pixIFBW;
        axisHeight = height / pixIFBW;
        image = sprayChartIFBW;
    }
    function drawBackground() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        const xExtent = chart.xAxis[0].getExtremes();
        const yExtent = chart.yAxis[0].getExtremes();
        // draw the park/infield background
        if (bgImgPath != null) {
            bgImgPath.element.remove();
        }
        setBgImgPath(chart.renderer.image(image, chart.xAxis[0].toPixels(-1 * (axisWidth / 2), false) + (0.5 * (canvasWidth - width)), chart.yAxis[0].toPixels((axisHeight), false), width * (axisWidth / (xExtent.max - xExtent.min)), height * (axisHeight / (yExtent.max - yExtent.min)))
            .attr({
            zIndex: -999
        })
            .add());
    }
    const chartConfig = {
        chart: {
            type: 'scatter',
            height,
            width: canvasWidth,
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
            marginBottom: 0,
            marginTop: 0,
            marginLeft: 0,
            marginRight: 0,
            events: {
                selection: function selection(e) {
                    var _a, _b;
                    if (multiVideoFn && ((_a = e.xAxis) === null || _a === void 0 ? void 0 : _a.length) && ((_b = e.yAxis) === null || _b === void 0 ? void 0 : _b.length)) {
                        const [{ min: minXAxis, max: maxXAxis }] = e.xAxis;
                        const [{ min: minYAxis, max: maxYAxis }] = e.yAxis;
                        const points = this.series.flatMap((s) => s.points.filter((point) => {
                            const { enabled, visible, x, y } = point;
                            return enabled !== false && visible !== false
                                && x >= minXAxis && x <= maxXAxis && typeof y === 'number' && y >= minYAxis && y <= maxYAxis;
                        }));
                        if (points.length)
                            fetchMultiVideo(points);
                    }
                    return false; // Don't zoom
                },
            },
        },
        colors: ['#3366FF', '#BF0B23', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        title: { text: undefined },
        plotOptions: {
            series: {
                marker: {
                    radius: 3,
                    symbol: 'circle',
                },
                stickyTracking: false,
                point: {
                    events: {
                        click: function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (onClick)
                                    return onClick(this);
                                if (pitchVideoFn)
                                    return fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq);
                            }
                            return null;
                        },
                    },
                },
                states: {
                    inactive: {
                        opacity: preventLegendSeriesHover ? 1 : 0.2,
                    },
                },
                events: {
                    legendItemClick() {
                        if (disableLegendClick) {
                            return false;
                        }
                        return true;
                    }
                }
            },
        },
        legend: {
            enabled: enableLegend,
            y: 50,
            useHTML: disableLegendClick,
            labelFormatter() {
                if (disableLegendClick) {
                    return `<span style="pointer-events: none;">${this.name}</span>`;
                }
                return this.name;
            }
        },
        xAxis: {
            height,
            width: canvasWidth,
            min: -1 * (axisWidth / 2),
            max: (axisWidth / 2),
            gridLineWidth: 0,
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            labels: {
                enabled: false,
            },
        },
        yAxis: {
            height,
            width: canvasWidth,
            min: (type === 'infield' ? 1.5 : 0),
            max: axisHeight,
            gridLineWidth: 0,
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            title: {
                text: null,
            },
            labels: {
                enabled: false,
            },
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                if (this.point.tooltip === undefined)
                    return false;
                let tooltip = `<b>${this.point.name || this.series.name}</b>`;
                if (this.point.tooltip)
                    tooltip += `<br/>${this.point.tooltip}`;
                return tooltip;
            },
        },
        series: seriesData,
    };
    return (React.createElement(Container$e, null,
        pitchVideoFn && VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false })));
});

/* eslint-disable @typescript-eslint/no-explicit-any */
const generatexplotlines = (levels) => levels.map((l) => ({
    value: l.gameDate.getTime(),
    color: '#B9B9B9',
    width: 1,
    dashStyle: 'Dash',
    label: {
        text: l.levelAbbr,
        rotation: 270,
        x: 12,
        y: 35,
        style: {
            color: '#A2A2A2',
        },
    },
}));
const leagueAvgPlotlineColor = 'rgba(255, 128, 128, .5)';
const targetPlotlineColor = 'rgba(0, 255, 0, .8)';
const generateyplotlines = (leagueAvgRate) => ({
    value: leagueAvgRate,
    color: leagueAvgPlotlineColor,
    width: 4,
    events: {
        mouseover(e) {
            const series = this.axis.series[0];
            const { chart } = series;
            const PointClass = series.pointClass;
            const { tooltip } = chart;
            const point = (new PointClass()).init(series, ['avg', this.options.value]);
            const normalizedEvent = chart.pointer.normalize(e);
            point.tooltipPos = [
                normalizedEvent.chartX - chart.plotLeft,
                normalizedEvent.chartY - chart.plotTop,
            ];
            tooltip.refresh(point);
        },
        mouseout() {
            this.axis.chart.tooltip.hide();
        },
    },
});
const generatetargetplotline = (targetVal) => ({
    value: targetVal,
    color: targetPlotlineColor,
    width: 2,
    events: {
        mouseover(e) {
            const series = this.axis.series[0];
            const { chart } = series;
            const PointClass = series.pointClass;
            const { tooltip } = chart;
            const point = (new PointClass()).init(series, ['target', this.options.value]);
            const normalizedEvent = chart.pointer.normalize(e);
            point.tooltipPos = [
                normalizedEvent.chartX - chart.plotLeft,
                normalizedEvent.chartY - chart.plotTop,
            ];
            tooltip.refresh(point);
        },
        mouseout() {
            this.axis.chart.tooltip.hide();
        },
    },
});
const ObjectiveMetricChart = ({ seriesData, minY, maxY, minX, maxX, labelFormat, leagueAvg, targetVal, levels, showLeagueAvgLineName, showTargetLineName, disableLegendInteractivity }) => {
    const dateArray = [];
    const currentDate = minX;
    while (currentDate <= maxX) {
        dateArray.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
    }
    const tickPositions = dateArray.filter((d) => d.getDate() === 1)
        .map((d) => (new Date(`${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`)).getTime());
    let seriesDataUse = seriesData;
    if (showLeagueAvgLineName) { // these are to allow the user to add to the legend the target/league lines (by passing in what to call them, since it needs to be translated)
        seriesDataUse = [...seriesDataUse, { color: leagueAvgPlotlineColor, name: showLeagueAvgLineName, data: [], type: 'line', legendSymbol: 'lineMarker' }];
    }
    if (showTargetLineName) {
        seriesDataUse = [...seriesDataUse, { color: targetPlotlineColor, name: showTargetLineName, data: [], type: 'line', legendSymbol: 'lineMarker' }];
    }
    const chartConfig = {
        title: undefined,
        series: seriesDataUse.map((series) => (Object.assign(Object.assign({}, series), { events: disableLegendInteractivity ? {
                legendItemClick(event) {
                    event.preventDefault();
                },
            } : {} }))),
        xAxis: {
            plotLines: generatexplotlines(levels),
            labels: {
                formatter() {
                    return dateFormat('%b %e', Number(this.value));
                },
            },
            tickPositions,
        },
        yAxis: {
            title: undefined,
            plotLines: leagueAvg ? [generateyplotlines(leagueAvg), generatetargetplotline(targetVal)] : [generatetargetplotline(targetVal)],
            labels: {
                format: labelFormat,
            },
            max: maxY,
            min: minY,
        },
        chart: {
            height: 250,
            backgroundColor: 'transparent',
            plotBackgroundColor: 'white',
        },
        legend: {
            enabled: true,
        },
    };
    return React.createElement(BaseChart, { options: chartConfig, height: 250 });
};

/* eslint-disable react/no-this-in-sfc */
HighchartsMore(Highcharts);
const Container$d = styled.div `
    ${BaseChartContainer} {
        min-height: 50px;
        text-align: center;
    }
`;
function roundCornerBox(pathBBox, radius) {
    const { x, y, width, height } = pathBBox;
    const eightPoints = [
        { x, y: y + radius },
        { x: x + radius, y },
        { x: x - radius + width, y },
        { x: x + width, y: y + radius },
        { x: x + width, y: y + height - radius },
        { x: x + width - radius, y: y + height },
        { x: x + radius, y: y + height },
        { x, y: y + height - radius },
    ];
    const controlPoints = [
        { x, y },
        { x: x + width, y },
        { x: x + width, y: y + height },
        { x, y: y + height },
    ];
    let controlPointIndex = 0;
    let lastCommand = 'Q';
    let controlPoint = controlPoints[0];
    let d = '';
    eightPoints.forEach((point, index) => {
        if (index === 0) {
            d += `M ${point.x} ${point.y} `;
            return;
        }
        if (lastCommand === 'Q') {
            controlPoint = controlPoints[controlPointIndex];
            d += `${lastCommand} ${controlPoint.x} ${controlPoint.y} ${point.x} ${point.y}`;
            lastCommand = 'L';
            // eslint-disable-next-line no-plusplus
            controlPointIndex++;
        }
        else {
            d += `${lastCommand} ${point.x} ${point.y} `;
            lastCommand = 'Q';
        }
    });
    d += 'z';
    return d;
}
const PerformanceScienceBoxChart = ({ seriesData, width, height = 400, titleX, minY, maxY, minX, maxX, showLegend = false, title = '', subtitle = '', titleY = '', plotLineValue, minLabel = '', maxLabel = '', }) => {
    const chartConfig = {
        chart: {
            type: 'boxplot',
            inverted: true,
            height,
            events: {
                render() {
                    const { points } = this.series[0];
                    let pathBBox;
                    let path;
                    // calculate an appropriate radius based on the percentage of the graph taken up by the plot
                    const impliedRadius = Math.ceil(128 * (points[0].high - points[0].low) / (maxY - minY));
                    const radius = impliedRadius > 15 ? 15 : impliedRadius; // cap the radius at 15
                    Highcharts.each(points, (p) => {
                        if (p.graphic != null) {
                            // eslint-disable-next-line prefer-destructuring
                            path = p.graphic.element.children[2];
                            pathBBox = path.getBBox();
                            path.setAttribute('d', roundCornerBox(pathBBox, radius));
                        }
                    }, this);
                },
            },
        },
        title: {
            text: title,
            style: {
                fontSize: '14px',
                fontWeight: 'bold',
            },
            y: height * 0.175,
        },
        subtitle: {
            text: subtitle,
        },
        xAxis: {
            min: minX,
            max: maxX,
            title: {
                text: titleX,
            },
            showFirstLabel: false,
            lineWidth: 0,
            gridLineColor: 'transparent',
            labels: { enabled: false },
            plotLines: [{ color: '#cccccc', width: 2, value: 0, zIndex: 0 }],
        },
        yAxis: {
            min: minY,
            max: maxY,
            title: {
                text: titleY,
            },
            tickPositioner() {
                return [minY, maxY];
            },
            endOnTick: true,
            showFirstLabel: true,
            startOnTick: true,
            plotLines: [{ color: '#9cccfe', width: 5, value: plotLineValue, zIndex: 0 }],
            gridLineColor: 'transparent',
            labels: {
                y: title.length > 0 ? -0.3 * height : -0.5 * height,
                formatter() {
                    const label = this.axis.defaultLabelFormatter.call(this);
                    if (minLabel === '' && maxLabel === '')
                        return label;
                    if (label === minY.toString() && minLabel !== '')
                        return minLabel;
                    if (label === maxY.toString() && maxLabel !== '')
                        return maxLabel;
                    return label;
                },
            },
        },
        plotOptions: {
            boxplot: {
                color: '#0C5DA5',
                fillColor: '#0C5DA5',
                lineWidth: 0,
                medianColor: '#0C5DA5',
                medianWidth: 0,
                stemWidth: 0,
                whiskerColor: 'transparent',
                whiskerLength: '20%',
                whiskerWidth: 0,
                grouping: false,
            },
        },
        legend: {
            enabled: showLegend,
            align: 'right',
            verticalAlign: 'top',
        },
        series: seriesData,
    };
    return (React.createElement(Container$d, null,
        React.createElement(BaseChart, { width: width, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable react/no-this-in-sfc */
HighchartsMore(Highcharts);
const Container$c = styled.div `
    ${BaseChartContainer} {
        min-height: 50px;
        text-align: center;
    }
`;
const yAxisBank = {
    8: {
        min: 0.5,
        max: 8.5,
        minorTickInterval: 'auto',
        minorTickWidth: 0,
        minorTickColor: 'transparent',
        tickWidth: 0,
        tickPosition: 'inside',
        tickColor: 'transparent',
        labels: {
            enabled: false,
        },
        plotBands: [{
                from: 0.5,
                to: 1.5,
                color: '#B51B1B',
                thickness: 30,
            }, {
                from: 1.5,
                to: 2.5,
                color: '#F54B4E',
                thickness: 30,
            }, {
                from: 2.5,
                to: 3.5,
                color: '#FD9D9F',
                thickness: 30,
            }, {
                from: 3.5,
                to: 4.5,
                color: '#CECECE',
                thickness: 30,
            }, {
                from: 4.5,
                to: 5.5,
                color: '#C7E3FE',
                thickness: 30,
            }, {
                from: 5.5,
                to: 6.5,
                color: '#99CCFD',
                thickness: 30,
            }, {
                from: 6.5,
                to: 7.5,
                color: '#137AD6',
                thickness: 30,
            }, {
                from: 7.5,
                to: 8.5,
                color: '#274D74',
                thickness: 30,
            }],
    },
    5: {
        min: 0.5,
        max: 5.5,
        minorTickInterval: 'auto',
        minorTickWidth: 0,
        minorTickColor: 'transparent',
        tickWidth: 0,
        tickPosition: 'inside',
        tickColor: 'transparent',
        labels: {
            enabled: false,
        },
        plotBands: [{
                from: 0.5,
                to: 1.5,
                color: '#F84949',
                thickness: 30,
            }, {
                from: 1.5,
                to: 2.5,
                color: '#FF9D9D',
                thickness: 30,
            }, {
                from: 2.5,
                to: 3.5,
                color: '#CECECE',
                thickness: 30,
            }, {
                from: 3.5,
                to: 4.5,
                color: '#98CBFF',
                thickness: 30,
            }, {
                from: 4.5,
                to: 5.5,
                color: '#0077D9',
                thickness: 30,
            }],
    },
    3: {
        min: 0.5,
        max: 3.5,
        minorTickInterval: 'auto',
        minorTickWidth: 0,
        minorTickColor: 'transparent',
        tickWidth: 0,
        tickPosition: 'inside',
        tickColor: 'transparent',
        labels: {
            enabled: false,
        },
        plotBands: [{
                from: 0.5,
                to: 1.5,
                color: '#F84949',
                thickness: 30,
            }, {
                from: 1.5,
                to: 2.5,
                color: '#CECECE',
                thickness: 30,
            }, {
                from: 2.5,
                to: 3.5,
                color: '#0077D9',
                thickness: 30,
            }],
    },
};
const GasGaugeChart = ({ seriesData, width = 174, height = 174, title = '', plotBandsNum = 5, }) => {
    const yAxis = yAxisBank[plotBandsNum];
    const chartConfig = {
        chart: {
            type: 'gauge',
            height,
            plotBorderWidth: 0,
            plotShadow: false,
            backgroundColor: 'transparent',
            margin: [0, 0, 0, 0],
            spacing: [0, 0, 0, 0],
        },
        title: {
            text: title,
        },
        tooltip: {
            enabled: false,
        },
        pane: {
            startAngle: -120,
            endAngle: 120,
            background: [{
                    backgroundColor: 'transparent',
                    borderWidth: 0,
                }],
        },
        // the value axis
        yAxis,
        plotOptions: {
            gauge: {
                dial: {
                    baseWidth: 10,
                    radius: '85%',
                },
            },
        },
        series: seriesData,
    };
    return (React.createElement(Container$c, null,
        React.createElement(BaseChart, { width: width, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable react/no-this-in-sfc */
HighchartsMore(Highcharts);
const Container$b = styled.div `
    ${BaseChartContainer} {
        min-height: 50px;
        text-align: center;
    }
`;
const generateYAxis = (plotBandsNum, lowerBound, upperBound, dataColor) => {
    const yAxis = {
        min: 0.5,
        max: 0.5 + plotBandsNum,
        minorTickInterval: 1,
        minorTickWidth: 0,
        minorTickColor: 'transparent',
        tickWidth: 0,
        tickInterval: 1,
        tickPosition: 'inside',
        tickColor: 'transparent',
        labels: {
            enabled: false,
            style: {
                color: '#123F6A',
                fontWeight: 'bold',
            },
        },
        lineColor: 'transparent',
        plotBands: [],
    };
    const gap = 0.033;
    const lb = lowerBound < upperBound ? lowerBound : upperBound;
    const ub = lowerBound < upperBound ? upperBound : lowerBound;
    const bandWidth = (plotBandsNum - (gap * (plotBandsNum - 1))) / plotBandsNum;
    for (let plotband = 1; plotband <= plotBandsNum; plotband++) {
        yAxis.plotBands.push({
            from: 0.5 + ((plotband - 1) * bandWidth) + ((plotband - 1) * gap),
            to: 0.5 + ((plotband - 1) * bandWidth) + ((plotband - 1) * gap) + bandWidth,
            color: lb <= plotband && plotband <= ub ? dataColor : '#CECECE',
            thickness: lb <= plotband && plotband <= ub ? 26 : 20,
            outerRadius: lb <= plotband && plotband <= ub ? '103%' : '100%',
        });
    }
    return yAxis;
};
const WedgeChart = ({ width = 300, height = 200, title = '', plotBandsNum = 5, lowerBound = 3, upperBound = 3, dataColor = '#003260', show2080Labels = false, draftBoardMode = false, }) => {
    const { t: translate } = useTranslation();
    const style2080 = {
        fontSize: height >= 300 ? '14px' : '10px',
        fontWeight: 'bold',
        color: 'rgba(51,51,51,1)',
    };
    const baseProps2080 = {
        linkedTo: 0,
        lineWidth: 0,
        minorTickLength: 0,
        tickWidth: 0,
        zIndex: 99,
    };
    const yAxis2080 = [
        Object.assign(Object.assign({}, baseProps2080), { tickPositions: [1], labels: {
                x: draftBoardMode ? -40 : -10,
                // eslint-disable-next-line no-nested-ternary
                y: draftBoardMode ? 15 : (height >= 300 ? 60 : 45),
                style: style2080,
                format: draftBoardMode ? translate('components.charts.min') : translate('components.charts.minimal'),
            } }),
        Object.assign(Object.assign({}, baseProps2080), { tickPositions: [2], labels: {
                x: -50,
                y: -20,
                style: style2080,
                format: `${translate('components.charts.very')}</br>${translate('components.charts.low')}`,
            } }),
        Object.assign(Object.assign({}, baseProps2080), { tickPositions: [3], labels: {
                x: -40,
                y: -30,
                style: style2080,
                format: translate('components.charts.low'),
            } }),
        Object.assign(Object.assign({}, baseProps2080), { tickPositions: [4], labels: {
                x: 0,
                y: -35,
                style: style2080,
                format: translate('components.charts.moderate'),
            } }),
        Object.assign(Object.assign({}, baseProps2080), { tickPositions: [5], labels: {
                x: 40,
                y: -30,
                style: style2080,
                format: translate('components.charts.high'),
            } }),
        Object.assign(Object.assign({}, baseProps2080), { tickPositions: [6], labels: {
                x: 50,
                y: -20,
                style: style2080,
                format: `${translate('components.charts.very')}</br>${translate('components.charts.high')}`,
            } }),
        Object.assign(Object.assign({}, baseProps2080), { tickPositions: [7], labels: {
                x: draftBoardMode ? 40 : 10,
                // eslint-disable-next-line no-nested-ternary
                y: draftBoardMode ? 15 : (height >= 300 ? 60 : 45),
                style: style2080,
                format: draftBoardMode ? translate('components.charts.max') : translate('components.charts.maximal'),
            } })
    ];
    const yAxis = generateYAxis(plotBandsNum, lowerBound, upperBound, dataColor);
    const seriesData = [{
            name: translate('components.charts.speed'),
            data: [],
            dataLabels: {
                enabled: false,
            },
        }];
    for (let dataPoint = lowerBound; dataPoint <= upperBound; dataPoint++) {
        seriesData[0].data.push(dataPoint);
    }
    const chartConfig = {
        chart: {
            type: 'gauge',
            height,
            plotBorderWidth: 0,
            plotShadow: false,
            backgroundColor: 'transparent',
            margin: [10, 0, 0, 0],
            spacing: [0, 0, 0, 0],
        },
        title: {
            text: title,
            verticalAlign: 'bottom',
            floating: true,
            style: {
                color: 'rgba(51,51,51,1)',
                fontWeight: '700',
                fontSize: '16px',
                fontFamily: 'Amble',
                letterSpacing: '0px',
                lineHeight: '16px',
            },
            y: draftBoardMode ? 12 : 2,
        },
        tooltip: {
            enabled: false,
        },
        pane: {
            startAngle: -120,
            endAngle: 120,
            background: [{
                    backgroundColor: 'transparent',
                    borderWidth: 0,
                }],
        },
        // the value axis
        yAxis: show2080Labels ? [yAxis, ...yAxis2080] : yAxis,
        plotOptions: {
            gauge: {
                dial: {
                    baseWidth: 0,
                    radius: '0%',
                },
                pivot: {
                    radius: 0,
                },
            },
        },
        series: seriesData,
    };
    return (React.createElement(Container$b, null,
        React.createElement(BaseChart, { immutable: true, width: width, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable react/no-this-in-sfc */
HighchartsMore(Highcharts);
const Container$a = styled.div `
    ${BaseChartContainer} {
        min-height: 24px;
        text-align: center;
    }
`;
const colorBuckets = (v) => {
    switch (Math.abs(v)) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
            return 'rgba(255,255,255,1.0)';
        case 15:
            return 'rgba(255, 230, 230, 1.0)';
        case 16:
            return 'rgba(255, 195, 195, 1.0)';
        case 17:
            return 'rgba(255, 180, 180, 1.0)';
        case 18:
            return 'rgba(250, 165, 165, 1.0)';
        case 19:
            return 'rgba(245, 150, 150, 1.0)';
        case 20:
            return 'rgba(240, 135, 135, 1.0)';
        case 21:
            return 'rgba(235, 120, 120, 1.0)';
        case 22:
            return 'rgba(230, 105, 105, 1.0)';
        case 23:
            return 'rgba(225, 90, 90, 1.0)';
        case 24:
            return 'rgba(220, 75, 75, 1.0)';
        case 25:
            return 'rgba(215, 60, 60, 1.0)';
        case 26:
            return 'rgba(210, 45, 45, 1.0)';
        case 27:
            return 'rgba(205, 30, 30, 1.0)';
        case 28:
            return 'rgba(200, 15, 15, 1.0)';
        case 29:
            return 'rgba(195, 0, 0, 1.0)';
        case 30:
            return 'rgba(180, 0, 0, 1.0)';
        default:
            return 'rgba(0,0,0,1.0)';
    }
};
const PerformanceScienceSymmetryChart = ({ width, height = 400, title = '', dotSize = 12, gridLineWidth = 10, score, }) => {
    const { t: translate } = useTranslation();
    // eslint-disable-next-line no-nested-ternary
    const val = score > 30 ? 30 : (score < -30 ? -30 : Math.round(score));
    const series = [{
            type: 'scatter',
            color: colorBuckets(val),
            data: [[val, 0]],
            marker: {
                lineColor: '#cecece',
                lineWidth: 2,
            },
        }];
    const chartConfig = {
        chart: {
            type: 'scatter',
            height,
            backgroundColor: 'rgba(0,0,0,0)',
        },
        title: {
            text: title,
        },
        tooltip: {
            enabled: false,
        },
        xAxis: {
            min: -30,
            max: 30,
            startOnTick: true,
            endOnTick: true,
            showLastLabel: false,
            visible: false,
            reversed: true,
        },
        yAxis: [{
                title: {
                    text: translate('baseball.abbr-left'),
                    rotation: 0,
                    y: 4,
                },
                gridLineWidth,
                labels: {
                    enabled: false,
                },
            }, {
                linkedTo: 0,
                opposite: true,
                labels: {
                    enabled: false,
                },
                title: {
                    text: translate('baseball.abbr-right'),
                    rotation: 0,
                    y: 4,
                },
            }],
        legend: {
            enabled: false,
        },
        plotOptions: {
            scatter: {
                marker: {
                    radius: dotSize,
                },
            },
        },
        series,
    };
    return (React.createElement(Container$a, null,
        React.createElement(BaseChart, { width: width, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable react/no-this-in-sfc */
HighchartsMore(Highcharts);
const Container$9 = styled.div `
    ${BaseChartContainer} {
        min-height: 24px;
        text-align: center;
    }
`;
const PerformanceScienceAsymmetryChart = ({ width = 400, height = 300, title = '', upperVal = 15, lowerVal = 5, medianVal = 10, dataLabelFontSize = '3.0em', labelY = -15, titleY = -11, }) => {
    const { t: translate } = useTranslation();
    const seriesData = [{
            name: translate('components.charts.speed'),
            data: [medianVal],
            dataLabels: {
                enabled: true,
                borderWidth: 0,
                formatter() {
                    return `${Math.round(Math.abs(this.y))}%`;
                },
                style: {
                    color: '#002E60',
                    fontWeight: 'bold',
                    fontSize: dataLabelFontSize,
                },
                y: labelY,
            },
        }];
    const yAxis = {
        min: -30,
        max: 30,
        reversed: true,
        minorTickInterval: 1,
        minorTickWidth: 0,
        minorTickColor: 'transparent',
        tickWidth: 2,
        tickLength: 15,
        tickInterval: 10,
        tickPosition: 'inside',
        tickColor: '#FFFFFF',
        labels: {
            enabled: false,
            style: {
                color: '#123F6A',
                fontWeight: 'bold',
            },
        },
        lineColor: 'transparent',
        plotBands: [{
                from: lowerVal,
                to: upperVal,
                color: '#9AAFC0',
                thickness: width >= 300 && height >= 300 ? 15 : 10,
                outerRadius: '83%',
            }, {
                from: medianVal - 0.40,
                to: medianVal + 0.40,
                color: '#002E60',
                thickness: width >= 300 && height >= 300 ? 22 : 17,
                outerRadius: '83%',
            }, {
                from: -20,
                to: 20,
                color: '#CECECE',
                thickness: 10,
                outerRadius: '96.5%',
            }, {
                from: -30,
                to: -20,
                color: '#E2364E',
                thickness: 10,
                outerRadius: '96.5%',
            }, {
                from: 20,
                to: 30,
                color: '#E2364E',
                thickness: 10,
                outerRadius: '96.5%',
            }],
    };
    const yAxisLabels = [
        {
            linkedTo: 0,
            lineWidth: 0,
            minorTickLength: 0,
            tickWidth: 0,
            zIndex: 99,
            tickPositions: [-30],
            labels: {
                x: width >= 300 && height >= 300 ? 10 : 35,
                y: width >= 300 && height >= 300 ? 40 : 30,
                style: {
                    fontSize: '30px',
                    fontWeight: 'bold',
                    color: '#7D7D7D',
                },
                format: 'R',
            },
        }, {
            linkedTo: 0,
            lineWidth: 0,
            minorTickLength: 0,
            tickWidth: 0,
            zIndex: 99,
            tickPositions: [30],
            labels: {
                x: width >= 300 && height >= 300 ? -10 : -35,
                y: width >= 300 && height >= 300 ? 40 : 30,
                style: {
                    fontSize: '30px',
                    fontWeight: 'bold',
                    color: '#7D7D7D',
                },
                format: 'L',
            },
        },
    ];
    // eslint-disable-next-line no-nested-ternary
    const chartConfig = {
        chart: {
            type: 'gauge',
            height,
            plotBorderWidth: 0,
            plotShadow: false,
            backgroundColor: 'transparent',
            margin: 0,
        },
        pane: {
            startAngle: -120,
            endAngle: 120,
            background: [{
                    backgroundColor: 'transparent',
                    borderWidth: 0,
                }],
        },
        title: {
            text: title,
            verticalAlign: 'bottom',
            floating: true,
            style: {
                color: 'rgba(51,51,51,1)',
                fontWeight: '700',
                fontSize: '16px',
                fontFamily: 'Amble',
                letterSpacing: '0px',
                lineHeight: '16px',
            },
            y: titleY,
        },
        tooltip: {
            enabled: false,
        },
        xAxis: {
            min: -30,
            max: 30,
            startOnTick: true,
            endOnTick: true,
            showLastLabel: false,
            visible: false,
        },
        yAxis: [yAxis, ...yAxisLabels],
        legend: {
            enabled: false,
        },
        plotOptions: {
            gauge: {
                dial: {
                    baseWidth: 0,
                    radius: '0%',
                },
                pivot: {
                    radius: 0,
                },
            },
        },
        series: seriesData,
    };
    return (React.createElement(Container$9, null,
        React.createElement(BaseChart, { width: width, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable react/no-this-in-sfc */
HighchartsMore(Highcharts);
const Container$8 = styled.div `
    ${BaseChartContainer} {
        min-height: 24px;
        text-align: center;
    }
`;
const PerformanceScienceAthleticIndexChart = ({ width = 300, height = 175, title = '', data, }) => {
    const { t: translate } = useTranslation();
    let dataLabel = null;
    if (data.pmedianVal != null && data.fmedianVal != null) {
        dataLabel = `<span class="present-label">${format(data.pmedianVal, 0)}|</span><span class="future-label">${format(data.fmedianVal, 0)}</span>`;
    }
    else if (data.pmedianVal != null) {
        dataLabel = `<span class="present-label single-grade">${format(data.pmedianVal, 0)}</span>`;
    }
    else if (data.fmedianVal != null) {
        dataLabel = `<span class="future-label single-grade">${format(data.fmedianVal, 0)}</span>`;
    }
    const seriesData = [{
            name: translate('components.charts.speed'),
            data: [data.pmedianVal],
            dataLabels: {
                enabled: true,
                borderWidth: 0,
                format: dataLabel,
                useHTML: true,
                y: -30,
                x: 0,
            },
        }];
    const yAxis = {
        min: 20,
        max: 80,
        minorTickInterval: 1,
        minorTickWidth: 0,
        minorTickColor: 'transparent',
        tickWidth: 2,
        tickLength: 12,
        tickInterval: 10,
        tickPosition: 'inside',
        tickColor: '#FFFFFF',
        labels: {
            enabled: false,
            style: {
                color: '#123F6A',
                fontWeight: '700',
                fontFamily: 'Amble',
                letterSpacing: '0px',
            },
        },
        lineColor: 'transparent',
        plotBands: [{
                from: data.plowerVal,
                to: data.pupperVal,
                color: '#9AAFC0',
                thickness: 10,
                outerRadius: '84%',
            }, {
                from: data.pmedianVal - 0.40,
                to: data.pmedianVal + 0.40,
                color: '#002E60',
                thickness: 17,
                outerRadius: '84%',
            }, {
                from: data.flowerVal,
                to: data.fupperVal,
                color: '#F3B2BA',
                thickness: 10,
                outerRadius: '112%',
            }, {
                from: data.fmedianVal - 0.25,
                to: data.fmedianVal + 0.25,
                color: '#E2364E',
                thickness: 16,
                outerRadius: '119%',
            }, {
                from: 20,
                to: 80,
                color: '#CECECE',
                thickness: 10,
                outerRadius: '98.5%',
            }],
    };
    // eslint-disable-next-line no-nested-ternary
    const chartConfig = {
        chart: {
            type: 'gauge',
            height,
            plotBorderWidth: 0,
            plotShadow: false,
            backgroundColor: 'transparent',
        },
        pane: {
            center: ['50%', '70%'],
            size: '125%',
            startAngle: -120,
            endAngle: 120,
            background: [{
                    backgroundColor: 'transparent',
                    borderWidth: 0,
                }],
        },
        title: {
            text: title,
            verticalAlign: 'bottom',
            floating: true,
            style: {
                color: 'rgba(51,51,51,1)',
                fontWeight: '700',
                fontSize: '16px',
                fontFamily: 'Amble',
                letterSpacing: '0px',
                lineHeight: '16px',
            },
            y: 30,
        },
        tooltip: {
            enabled: false,
        },
        xAxis: {
            min: -30,
            max: 30,
            startOnTick: true,
            endOnTick: true,
            showLastLabel: false,
            visible: false,
        },
        yAxis,
        legend: {
            enabled: false,
        },
        plotOptions: {
            gauge: {
                dial: {
                    baseWidth: 0,
                    radius: '0%',
                },
                pivot: {
                    radius: 0,
                },
            },
        },
        series: seriesData,
    };
    return (React.createElement(Container$8, null,
        React.createElement(BaseChart, { width: width, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable react/no-this-in-sfc */
const PerformanceScienceFilledCircle = ({ innerCircle, outerCircle, width = 10, }) => {
    const CircleDiv = styled.div `
        width: ${2 * width}px;
        height: ${2 * width}px;
    `;
    return (React.createElement(CircleDiv, null,
        React.createElement("svg", { width: (width + 5) * 2, height: (width + 5) * 2, xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { cx: width + 5, cy: width + 5, r: width, strokeWidth: "0", fill: "#002E60", fillOpacity: "100%" }),
            !outerCircle && (React.createElement("circle", { cx: width + 5, cy: width + 5, r: 0.75 * width, strokeWidth: "0", fill: "#FFFFFF", fillOpacity: "100%" })),
            !innerCircle && (React.createElement("circle", { cx: width + 5, cy: width + 5, r: 0.5 * width, strokeWidth: "0", fill: "#FFFFFF", fillOpacity: "100%" })),
            innerCircle && (React.createElement("circle", { cx: width + 5, cy: width + 5, r: 0.5 * width, strokeWidth: "0", fill: "#002E60", fillOpacity: "100%" })))));
};

/* eslint-disable max-len */
const StyledPercentageCircleContainer = styled.div `
/****************************************************************
 *
 * CSS Percentage Circle
 * Author: Andre Firchow
 *
*****************************************************************/
.rect-auto, .c100.p51 .slice, .c100.p52 .slice, .c100.p53 .slice, .c100.p54 .slice, .c100.p55 .slice, .c100.p56 .slice, .c100.p57 .slice, .c100.p58 .slice, .c100.p59 .slice, .c100.p60 .slice, .c100.p61 .slice, .c100.p62 .slice, .c100.p63 .slice, .c100.p64 .slice, .c100.p65 .slice, .c100.p66 .slice, .c100.p67 .slice, .c100.p68 .slice, .c100.p69 .slice, .c100.p70 .slice, .c100.p71 .slice, .c100.p72 .slice, .c100.p73 .slice, .c100.p74 .slice, .c100.p75 .slice, .c100.p76 .slice, .c100.p77 .slice, .c100.p78 .slice, .c100.p79 .slice, .c100.p80 .slice, .c100.p81 .slice, .c100.p82 .slice, .c100.p83 .slice, .c100.p84 .slice, .c100.p85 .slice, .c100.p86 .slice, .c100.p87 .slice, .c100.p88 .slice, .c100.p89 .slice, .c100.p90 .slice, .c100.p91 .slice, .c100.p92 .slice, .c100.p93 .slice, .c100.p94 .slice, .c100.p95 .slice, .c100.p96 .slice, .c100.p97 .slice, .c100.p98 .slice, .c100.p99 .slice, .c100.p100 .slice {
    clip: rect(auto, auto, auto, auto);
}

.pie, .c100 .bar, .c100.p51 .fill, .c100.p52 .fill, .c100.p53 .fill, .c100.p54 .fill, .c100.p55 .fill, .c100.p56 .fill, .c100.p57 .fill, .c100.p58 .fill, .c100.p59 .fill, .c100.p60 .fill, .c100.p61 .fill, .c100.p62 .fill, .c100.p63 .fill, .c100.p64 .fill, .c100.p65 .fill, .c100.p66 .fill, .c100.p67 .fill, .c100.p68 .fill, .c100.p69 .fill, .c100.p70 .fill, .c100.p71 .fill, .c100.p72 .fill, .c100.p73 .fill, .c100.p74 .fill, .c100.p75 .fill, .c100.p76 .fill, .c100.p77 .fill, .c100.p78 .fill, .c100.p79 .fill, .c100.p80 .fill, .c100.p81 .fill, .c100.p82 .fill, .c100.p83 .fill, .c100.p84 .fill, .c100.p85 .fill, .c100.p86 .fill, .c100.p87 .fill, .c100.p88 .fill, .c100.p89 .fill, .c100.p90 .fill, .c100.p91 .fill, .c100.p92 .fill, .c100.p93 .fill, .c100.p94 .fill, .c100.p95 .fill, .c100.p96 .fill, .c100.p97 .fill, .c100.p98 .fill, .c100.p99 .fill, .c100.p100 .fill {
    position: absolute;
    border: 0.18em solid #254c75;
    width: 0.64em;
    height: 0.64em;
    clip: rect(0em, 0.5em, 1em, 0em);
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    border-radius: 50%;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
}

.pie-fill, .c100.p51 .bar:after, .c100.p51 .fill, .c100.p52 .bar:after, .c100.p52 .fill, .c100.p53 .bar:after, .c100.p53 .fill, .c100.p54 .bar:after, .c100.p54 .fill, .c100.p55 .bar:after, .c100.p55 .fill, .c100.p56 .bar:after, .c100.p56 .fill, .c100.p57 .bar:after, .c100.p57 .fill, .c100.p58 .bar:after, .c100.p58 .fill, .c100.p59 .bar:after, .c100.p59 .fill, .c100.p60 .bar:after, .c100.p60 .fill, .c100.p61 .bar:after, .c100.p61 .fill, .c100.p62 .bar:after, .c100.p62 .fill, .c100.p63 .bar:after, .c100.p63 .fill, .c100.p64 .bar:after, .c100.p64 .fill, .c100.p65 .bar:after, .c100.p65 .fill, .c100.p66 .bar:after, .c100.p66 .fill, .c100.p67 .bar:after, .c100.p67 .fill, .c100.p68 .bar:after, .c100.p68 .fill, .c100.p69 .bar:after, .c100.p69 .fill, .c100.p70 .bar:after, .c100.p70 .fill, .c100.p71 .bar:after, .c100.p71 .fill, .c100.p72 .bar:after, .c100.p72 .fill, .c100.p73 .bar:after, .c100.p73 .fill, .c100.p74 .bar:after, .c100.p74 .fill, .c100.p75 .bar:after, .c100.p75 .fill, .c100.p76 .bar:after, .c100.p76 .fill, .c100.p77 .bar:after, .c100.p77 .fill, .c100.p78 .bar:after, .c100.p78 .fill, .c100.p79 .bar:after, .c100.p79 .fill, .c100.p80 .bar:after, .c100.p80 .fill, .c100.p81 .bar:after, .c100.p81 .fill, .c100.p82 .bar:after, .c100.p82 .fill, .c100.p83 .bar:after, .c100.p83 .fill, .c100.p84 .bar:after, .c100.p84 .fill, .c100.p85 .bar:after, .c100.p85 .fill, .c100.p86 .bar:after, .c100.p86 .fill, .c100.p87 .bar:after, .c100.p87 .fill, .c100.p88 .bar:after, .c100.p88 .fill, .c100.p89 .bar:after, .c100.p89 .fill, .c100.p90 .bar:after, .c100.p90 .fill, .c100.p91 .bar:after, .c100.p91 .fill, .c100.p92 .bar:after, .c100.p92 .fill, .c100.p93 .bar:after, .c100.p93 .fill, .c100.p94 .bar:after, .c100.p94 .fill, .c100.p95 .bar:after, .c100.p95 .fill, .c100.p96 .bar:after, .c100.p96 .fill, .c100.p97 .bar:after, .c100.p97 .fill, .c100.p98 .bar:after, .c100.p98 .fill, .c100.p99 .bar:after, .c100.p99 .fill, .c100.p100 .bar:after, .c100.p100 .fill {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
}

.c100 {
    position: relative;
    font-size: 120px;
    width: 1em;
    height: 1em;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    border-radius: 50%;
    float: left;
    margin: 0 0.1em 0.1em 0;
    background-color: #cccccc;
}

    .c100 *, .c100 *:before, .c100 *:after {
        -webkit-box-sizing: content-box;
        -moz-box-sizing: content-box;
        box-sizing: content-box;
    }

    .c100.center {
        float: none;
        margin: 0 auto;
    }

    .c100.big {
        font-size: 240px;
    }

    .c100.small {
        font-size: 80px;
    }

    .c100 > span {
        position: absolute;
        width: 100%;
        z-index: 1;
        left: 0;
        top: -0.5em;
        width: 4em;
        line-height: 5em;
        font-size: 0.25em;
        color: #254c75;
        font-weight: bold;
        display: block;
        text-align: center;
        white-space: nowrap;
        -webkit-transition-property: all;
        -moz-transition-property: all;
        -o-transition-property: all;
        transition-property: all;
        -webkit-transition-duration: 0.2s;
        -moz-transition-duration: 0.2s;
        -o-transition-duration: 0.2s;
        transition-duration: 0.2s;
        -webkit-transition-timing-function: ease-out;
        -moz-transition-timing-function: ease-out;
        -o-transition-timing-function: ease-out;
        transition-timing-function: ease-out;
    }

    .c100 > div.captiontext {
        position: absolute;
        width: 100%;
        font-weight: bold;
        z-index: 1;
        left: 50%;
        margin-left: -2.5em;
        top: 75%;
        width: 5em;
        line-height: 5em;
        font-size: 0.12em;
        color: #254c75;
        display: block;
        text-align: center;
        white-space: nowrap;
        -webkit-transition-property: all;
        -moz-transition-property: all;
        -o-transition-property: all;
        transition-property: all;
        -webkit-transition-duration: 0.2s;
        -moz-transition-duration: 0.2s;
        -o-transition-duration: 0.2s;
        transition-duration: 0.2s;
        -webkit-transition-timing-function: ease-out;
        -moz-transition-timing-function: ease-out;
        -o-transition-timing-function: ease-out;
        transition-timing-function: ease-out;
    }

    .c100:after {
        position: absolute;
        top: 0.18em;
        left: 0.18em;
        display: block;
        content: " ";
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        -ms-border-radius: 50%;
        -o-border-radius: 50%;
        border-radius: 50%;
        background-color: whitesmoke;
        width: 0.64em;
        height: 0.64em;
        -webkit-transition-property: all;
        -moz-transition-property: all;
        -o-transition-property: all;
        transition-property: all;
        -webkit-transition-duration: 0.2s;
        -moz-transition-duration: 0.2s;
        -o-transition-duration: 0.2s;
        transition-duration: 0.2s;
        -webkit-transition-timing-function: ease-in;
        -moz-transition-timing-function: ease-in;
        -o-transition-timing-function: ease-in;
        transition-timing-function: ease-in;
    }

    .c100 .slice {
        position: absolute;
        width: 1em;
        height: 1em;
        clip: rect(0em, 1em, 1em, 0.5em);
    }

    .c100.p1 .bar {
        -webkit-transform: rotate(3.6deg);
        -moz-transform: rotate(3.6deg);
        -ms-transform: rotate(3.6deg);
        -o-transform: rotate(3.6deg);
        transform: rotate(3.6deg);
    }

    .c100.p2 .bar {
        -webkit-transform: rotate(7.2deg);
        -moz-transform: rotate(7.2deg);
        -ms-transform: rotate(7.2deg);
        -o-transform: rotate(7.2deg);
        transform: rotate(7.2deg);
    }

    .c100.p3 .bar {
        -webkit-transform: rotate(10.8deg);
        -moz-transform: rotate(10.8deg);
        -ms-transform: rotate(10.8deg);
        -o-transform: rotate(10.8deg);
        transform: rotate(10.8deg);
    }

    .c100.p4 .bar {
        -webkit-transform: rotate(14.4deg);
        -moz-transform: rotate(14.4deg);
        -ms-transform: rotate(14.4deg);
        -o-transform: rotate(14.4deg);
        transform: rotate(14.4deg);
    }

    .c100.p5 .bar {
        -webkit-transform: rotate(18deg);
        -moz-transform: rotate(18deg);
        -ms-transform: rotate(18deg);
        -o-transform: rotate(18deg);
        transform: rotate(18deg);
    }

    .c100.p6 .bar {
        -webkit-transform: rotate(21.6deg);
        -moz-transform: rotate(21.6deg);
        -ms-transform: rotate(21.6deg);
        -o-transform: rotate(21.6deg);
        transform: rotate(21.6deg);
    }

    .c100.p7 .bar {
        -webkit-transform: rotate(25.2deg);
        -moz-transform: rotate(25.2deg);
        -ms-transform: rotate(25.2deg);
        -o-transform: rotate(25.2deg);
        transform: rotate(25.2deg);
    }

    .c100.p8 .bar {
        -webkit-transform: rotate(28.8deg);
        -moz-transform: rotate(28.8deg);
        -ms-transform: rotate(28.8deg);
        -o-transform: rotate(28.8deg);
        transform: rotate(28.8deg);
    }

    .c100.p9 .bar {
        -webkit-transform: rotate(32.4deg);
        -moz-transform: rotate(32.4deg);
        -ms-transform: rotate(32.4deg);
        -o-transform: rotate(32.4deg);
        transform: rotate(32.4deg);
    }

    .c100.p10 .bar {
        -webkit-transform: rotate(36deg);
        -moz-transform: rotate(36deg);
        -ms-transform: rotate(36deg);
        -o-transform: rotate(36deg);
        transform: rotate(36deg);
    }

    .c100.p11 .bar {
        -webkit-transform: rotate(39.6deg);
        -moz-transform: rotate(39.6deg);
        -ms-transform: rotate(39.6deg);
        -o-transform: rotate(39.6deg);
        transform: rotate(39.6deg);
    }

    .c100.p12 .bar {
        -webkit-transform: rotate(43.2deg);
        -moz-transform: rotate(43.2deg);
        -ms-transform: rotate(43.2deg);
        -o-transform: rotate(43.2deg);
        transform: rotate(43.2deg);
    }

    .c100.p13 .bar {
        -webkit-transform: rotate(46.8deg);
        -moz-transform: rotate(46.8deg);
        -ms-transform: rotate(46.8deg);
        -o-transform: rotate(46.8deg);
        transform: rotate(46.8deg);
    }

    .c100.p14 .bar {
        -webkit-transform: rotate(50.4deg);
        -moz-transform: rotate(50.4deg);
        -ms-transform: rotate(50.4deg);
        -o-transform: rotate(50.4deg);
        transform: rotate(50.4deg);
    }

    .c100.p15 .bar {
        -webkit-transform: rotate(54deg);
        -moz-transform: rotate(54deg);
        -ms-transform: rotate(54deg);
        -o-transform: rotate(54deg);
        transform: rotate(54deg);
    }

    .c100.p16 .bar {
        -webkit-transform: rotate(57.6deg);
        -moz-transform: rotate(57.6deg);
        -ms-transform: rotate(57.6deg);
        -o-transform: rotate(57.6deg);
        transform: rotate(57.6deg);
    }

    .c100.p17 .bar {
        -webkit-transform: rotate(61.2deg);
        -moz-transform: rotate(61.2deg);
        -ms-transform: rotate(61.2deg);
        -o-transform: rotate(61.2deg);
        transform: rotate(61.2deg);
    }

    .c100.p18 .bar {
        -webkit-transform: rotate(64.8deg);
        -moz-transform: rotate(64.8deg);
        -ms-transform: rotate(64.8deg);
        -o-transform: rotate(64.8deg);
        transform: rotate(64.8deg);
    }

    .c100.p19 .bar {
        -webkit-transform: rotate(68.4deg);
        -moz-transform: rotate(68.4deg);
        -ms-transform: rotate(68.4deg);
        -o-transform: rotate(68.4deg);
        transform: rotate(68.4deg);
    }

    .c100.p20 .bar {
        -webkit-transform: rotate(72deg);
        -moz-transform: rotate(72deg);
        -ms-transform: rotate(72deg);
        -o-transform: rotate(72deg);
        transform: rotate(72deg);
    }

    .c100.p21 .bar {
        -webkit-transform: rotate(75.6deg);
        -moz-transform: rotate(75.6deg);
        -ms-transform: rotate(75.6deg);
        -o-transform: rotate(75.6deg);
        transform: rotate(75.6deg);
    }

    .c100.p22 .bar {
        -webkit-transform: rotate(79.2deg);
        -moz-transform: rotate(79.2deg);
        -ms-transform: rotate(79.2deg);
        -o-transform: rotate(79.2deg);
        transform: rotate(79.2deg);
    }

    .c100.p23 .bar {
        -webkit-transform: rotate(82.8deg);
        -moz-transform: rotate(82.8deg);
        -ms-transform: rotate(82.8deg);
        -o-transform: rotate(82.8deg);
        transform: rotate(82.8deg);
    }

    .c100.p24 .bar {
        -webkit-transform: rotate(86.4deg);
        -moz-transform: rotate(86.4deg);
        -ms-transform: rotate(86.4deg);
        -o-transform: rotate(86.4deg);
        transform: rotate(86.4deg);
    }

    .c100.p25 .bar {
        -webkit-transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        -o-transform: rotate(90deg);
        transform: rotate(90deg);
    }

    .c100.p26 .bar {
        -webkit-transform: rotate(93.6deg);
        -moz-transform: rotate(93.6deg);
        -ms-transform: rotate(93.6deg);
        -o-transform: rotate(93.6deg);
        transform: rotate(93.6deg);
    }

    .c100.p27 .bar {
        -webkit-transform: rotate(97.2deg);
        -moz-transform: rotate(97.2deg);
        -ms-transform: rotate(97.2deg);
        -o-transform: rotate(97.2deg);
        transform: rotate(97.2deg);
    }

    .c100.p28 .bar {
        -webkit-transform: rotate(100.8deg);
        -moz-transform: rotate(100.8deg);
        -ms-transform: rotate(100.8deg);
        -o-transform: rotate(100.8deg);
        transform: rotate(100.8deg);
    }

    .c100.p29 .bar {
        -webkit-transform: rotate(104.4deg);
        -moz-transform: rotate(104.4deg);
        -ms-transform: rotate(104.4deg);
        -o-transform: rotate(104.4deg);
        transform: rotate(104.4deg);
    }

    .c100.p30 .bar {
        -webkit-transform: rotate(108deg);
        -moz-transform: rotate(108deg);
        -ms-transform: rotate(108deg);
        -o-transform: rotate(108deg);
        transform: rotate(108deg);
    }

    .c100.p31 .bar {
        -webkit-transform: rotate(111.6deg);
        -moz-transform: rotate(111.6deg);
        -ms-transform: rotate(111.6deg);
        -o-transform: rotate(111.6deg);
        transform: rotate(111.6deg);
    }

    .c100.p32 .bar {
        -webkit-transform: rotate(115.2deg);
        -moz-transform: rotate(115.2deg);
        -ms-transform: rotate(115.2deg);
        -o-transform: rotate(115.2deg);
        transform: rotate(115.2deg);
    }

    .c100.p33 .bar {
        -webkit-transform: rotate(118.8deg);
        -moz-transform: rotate(118.8deg);
        -ms-transform: rotate(118.8deg);
        -o-transform: rotate(118.8deg);
        transform: rotate(118.8deg);
    }

    .c100.p34 .bar {
        -webkit-transform: rotate(122.4deg);
        -moz-transform: rotate(122.4deg);
        -ms-transform: rotate(122.4deg);
        -o-transform: rotate(122.4deg);
        transform: rotate(122.4deg);
    }

    .c100.p35 .bar {
        -webkit-transform: rotate(126deg);
        -moz-transform: rotate(126deg);
        -ms-transform: rotate(126deg);
        -o-transform: rotate(126deg);
        transform: rotate(126deg);
    }

    .c100.p36 .bar {
        -webkit-transform: rotate(129.6deg);
        -moz-transform: rotate(129.6deg);
        -ms-transform: rotate(129.6deg);
        -o-transform: rotate(129.6deg);
        transform: rotate(129.6deg);
    }

    .c100.p37 .bar {
        -webkit-transform: rotate(133.2deg);
        -moz-transform: rotate(133.2deg);
        -ms-transform: rotate(133.2deg);
        -o-transform: rotate(133.2deg);
        transform: rotate(133.2deg);
    }

    .c100.p38 .bar {
        -webkit-transform: rotate(136.8deg);
        -moz-transform: rotate(136.8deg);
        -ms-transform: rotate(136.8deg);
        -o-transform: rotate(136.8deg);
        transform: rotate(136.8deg);
    }

    .c100.p39 .bar {
        -webkit-transform: rotate(140.4deg);
        -moz-transform: rotate(140.4deg);
        -ms-transform: rotate(140.4deg);
        -o-transform: rotate(140.4deg);
        transform: rotate(140.4deg);
    }

    .c100.p40 .bar {
        -webkit-transform: rotate(144deg);
        -moz-transform: rotate(144deg);
        -ms-transform: rotate(144deg);
        -o-transform: rotate(144deg);
        transform: rotate(144deg);
    }

    .c100.p41 .bar {
        -webkit-transform: rotate(147.6deg);
        -moz-transform: rotate(147.6deg);
        -ms-transform: rotate(147.6deg);
        -o-transform: rotate(147.6deg);
        transform: rotate(147.6deg);
    }

    .c100.p42 .bar {
        -webkit-transform: rotate(151.2deg);
        -moz-transform: rotate(151.2deg);
        -ms-transform: rotate(151.2deg);
        -o-transform: rotate(151.2deg);
        transform: rotate(151.2deg);
    }

    .c100.p43 .bar {
        -webkit-transform: rotate(154.8deg);
        -moz-transform: rotate(154.8deg);
        -ms-transform: rotate(154.8deg);
        -o-transform: rotate(154.8deg);
        transform: rotate(154.8deg);
    }

    .c100.p44 .bar {
        -webkit-transform: rotate(158.4deg);
        -moz-transform: rotate(158.4deg);
        -ms-transform: rotate(158.4deg);
        -o-transform: rotate(158.4deg);
        transform: rotate(158.4deg);
    }

    .c100.p45 .bar {
        -webkit-transform: rotate(162deg);
        -moz-transform: rotate(162deg);
        -ms-transform: rotate(162deg);
        -o-transform: rotate(162deg);
        transform: rotate(162deg);
    }

    .c100.p46 .bar {
        -webkit-transform: rotate(165.6deg);
        -moz-transform: rotate(165.6deg);
        -ms-transform: rotate(165.6deg);
        -o-transform: rotate(165.6deg);
        transform: rotate(165.6deg);
    }

    .c100.p47 .bar {
        -webkit-transform: rotate(169.2deg);
        -moz-transform: rotate(169.2deg);
        -ms-transform: rotate(169.2deg);
        -o-transform: rotate(169.2deg);
        transform: rotate(169.2deg);
    }

    .c100.p48 .bar {
        -webkit-transform: rotate(172.8deg);
        -moz-transform: rotate(172.8deg);
        -ms-transform: rotate(172.8deg);
        -o-transform: rotate(172.8deg);
        transform: rotate(172.8deg);
    }

    .c100.p49 .bar {
        -webkit-transform: rotate(176.4deg);
        -moz-transform: rotate(176.4deg);
        -ms-transform: rotate(176.4deg);
        -o-transform: rotate(176.4deg);
        transform: rotate(176.4deg);
    }

    .c100.p50 .bar {
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        -o-transform: rotate(180deg);
        transform: rotate(180deg);
    }

    .c100.p51 .bar {
        -webkit-transform: rotate(183.6deg);
        -moz-transform: rotate(183.6deg);
        -ms-transform: rotate(183.6deg);
        -o-transform: rotate(183.6deg);
        transform: rotate(183.6deg);
    }

    .c100.p52 .bar {
        -webkit-transform: rotate(187.2deg);
        -moz-transform: rotate(187.2deg);
        -ms-transform: rotate(187.2deg);
        -o-transform: rotate(187.2deg);
        transform: rotate(187.2deg);
    }

    .c100.p53 .bar {
        -webkit-transform: rotate(190.8deg);
        -moz-transform: rotate(190.8deg);
        -ms-transform: rotate(190.8deg);
        -o-transform: rotate(190.8deg);
        transform: rotate(190.8deg);
    }

    .c100.p54 .bar {
        -webkit-transform: rotate(194.4deg);
        -moz-transform: rotate(194.4deg);
        -ms-transform: rotate(194.4deg);
        -o-transform: rotate(194.4deg);
        transform: rotate(194.4deg);
    }

    .c100.p55 .bar {
        -webkit-transform: rotate(198deg);
        -moz-transform: rotate(198deg);
        -ms-transform: rotate(198deg);
        -o-transform: rotate(198deg);
        transform: rotate(198deg);
    }

    .c100.p56 .bar {
        -webkit-transform: rotate(201.6deg);
        -moz-transform: rotate(201.6deg);
        -ms-transform: rotate(201.6deg);
        -o-transform: rotate(201.6deg);
        transform: rotate(201.6deg);
    }

    .c100.p57 .bar {
        -webkit-transform: rotate(205.2deg);
        -moz-transform: rotate(205.2deg);
        -ms-transform: rotate(205.2deg);
        -o-transform: rotate(205.2deg);
        transform: rotate(205.2deg);
    }

    .c100.p58 .bar {
        -webkit-transform: rotate(208.8deg);
        -moz-transform: rotate(208.8deg);
        -ms-transform: rotate(208.8deg);
        -o-transform: rotate(208.8deg);
        transform: rotate(208.8deg);
    }

    .c100.p59 .bar {
        -webkit-transform: rotate(212.4deg);
        -moz-transform: rotate(212.4deg);
        -ms-transform: rotate(212.4deg);
        -o-transform: rotate(212.4deg);
        transform: rotate(212.4deg);
    }

    .c100.p60 .bar {
        -webkit-transform: rotate(216deg);
        -moz-transform: rotate(216deg);
        -ms-transform: rotate(216deg);
        -o-transform: rotate(216deg);
        transform: rotate(216deg);
    }

    .c100.p61 .bar {
        -webkit-transform: rotate(219.6deg);
        -moz-transform: rotate(219.6deg);
        -ms-transform: rotate(219.6deg);
        -o-transform: rotate(219.6deg);
        transform: rotate(219.6deg);
    }

    .c100.p62 .bar {
        -webkit-transform: rotate(223.2deg);
        -moz-transform: rotate(223.2deg);
        -ms-transform: rotate(223.2deg);
        -o-transform: rotate(223.2deg);
        transform: rotate(223.2deg);
    }

    .c100.p63 .bar {
        -webkit-transform: rotate(226.8deg);
        -moz-transform: rotate(226.8deg);
        -ms-transform: rotate(226.8deg);
        -o-transform: rotate(226.8deg);
        transform: rotate(226.8deg);
    }

    .c100.p64 .bar {
        -webkit-transform: rotate(230.4deg);
        -moz-transform: rotate(230.4deg);
        -ms-transform: rotate(230.4deg);
        -o-transform: rotate(230.4deg);
        transform: rotate(230.4deg);
    }

    .c100.p65 .bar {
        -webkit-transform: rotate(234deg);
        -moz-transform: rotate(234deg);
        -ms-transform: rotate(234deg);
        -o-transform: rotate(234deg);
        transform: rotate(234deg);
    }

    .c100.p66 .bar {
        -webkit-transform: rotate(237.6deg);
        -moz-transform: rotate(237.6deg);
        -ms-transform: rotate(237.6deg);
        -o-transform: rotate(237.6deg);
        transform: rotate(237.6deg);
    }

    .c100.p67 .bar {
        -webkit-transform: rotate(241.2deg);
        -moz-transform: rotate(241.2deg);
        -ms-transform: rotate(241.2deg);
        -o-transform: rotate(241.2deg);
        transform: rotate(241.2deg);
    }

    .c100.p68 .bar {
        -webkit-transform: rotate(244.8deg);
        -moz-transform: rotate(244.8deg);
        -ms-transform: rotate(244.8deg);
        -o-transform: rotate(244.8deg);
        transform: rotate(244.8deg);
    }

    .c100.p69 .bar {
        -webkit-transform: rotate(248.4deg);
        -moz-transform: rotate(248.4deg);
        -ms-transform: rotate(248.4deg);
        -o-transform: rotate(248.4deg);
        transform: rotate(248.4deg);
    }

    .c100.p70 .bar {
        -webkit-transform: rotate(252deg);
        -moz-transform: rotate(252deg);
        -ms-transform: rotate(252deg);
        -o-transform: rotate(252deg);
        transform: rotate(252deg);
    }

    .c100.p71 .bar {
        -webkit-transform: rotate(255.6deg);
        -moz-transform: rotate(255.6deg);
        -ms-transform: rotate(255.6deg);
        -o-transform: rotate(255.6deg);
        transform: rotate(255.6deg);
    }

    .c100.p72 .bar {
        -webkit-transform: rotate(259.2deg);
        -moz-transform: rotate(259.2deg);
        -ms-transform: rotate(259.2deg);
        -o-transform: rotate(259.2deg);
        transform: rotate(259.2deg);
    }

    .c100.p73 .bar {
        -webkit-transform: rotate(262.8deg);
        -moz-transform: rotate(262.8deg);
        -ms-transform: rotate(262.8deg);
        -o-transform: rotate(262.8deg);
        transform: rotate(262.8deg);
    }

    .c100.p74 .bar {
        -webkit-transform: rotate(266.4deg);
        -moz-transform: rotate(266.4deg);
        -ms-transform: rotate(266.4deg);
        -o-transform: rotate(266.4deg);
        transform: rotate(266.4deg);
    }

    .c100.p75 .bar {
        -webkit-transform: rotate(270deg);
        -moz-transform: rotate(270deg);
        -ms-transform: rotate(270deg);
        -o-transform: rotate(270deg);
        transform: rotate(270deg);
    }

    .c100.p76 .bar {
        -webkit-transform: rotate(273.6deg);
        -moz-transform: rotate(273.6deg);
        -ms-transform: rotate(273.6deg);
        -o-transform: rotate(273.6deg);
        transform: rotate(273.6deg);
    }

    .c100.p77 .bar {
        -webkit-transform: rotate(277.2deg);
        -moz-transform: rotate(277.2deg);
        -ms-transform: rotate(277.2deg);
        -o-transform: rotate(277.2deg);
        transform: rotate(277.2deg);
    }

    .c100.p78 .bar {
        -webkit-transform: rotate(280.8deg);
        -moz-transform: rotate(280.8deg);
        -ms-transform: rotate(280.8deg);
        -o-transform: rotate(280.8deg);
        transform: rotate(280.8deg);
    }

    .c100.p79 .bar {
        -webkit-transform: rotate(284.4deg);
        -moz-transform: rotate(284.4deg);
        -ms-transform: rotate(284.4deg);
        -o-transform: rotate(284.4deg);
        transform: rotate(284.4deg);
    }

    .c100.p80 .bar {
        -webkit-transform: rotate(288deg);
        -moz-transform: rotate(288deg);
        -ms-transform: rotate(288deg);
        -o-transform: rotate(288deg);
        transform: rotate(288deg);
    }

    .c100.p81 .bar {
        -webkit-transform: rotate(291.6deg);
        -moz-transform: rotate(291.6deg);
        -ms-transform: rotate(291.6deg);
        -o-transform: rotate(291.6deg);
        transform: rotate(291.6deg);
    }

    .c100.p82 .bar {
        -webkit-transform: rotate(295.2deg);
        -moz-transform: rotate(295.2deg);
        -ms-transform: rotate(295.2deg);
        -o-transform: rotate(295.2deg);
        transform: rotate(295.2deg);
    }

    .c100.p83 .bar {
        -webkit-transform: rotate(298.8deg);
        -moz-transform: rotate(298.8deg);
        -ms-transform: rotate(298.8deg);
        -o-transform: rotate(298.8deg);
        transform: rotate(298.8deg);
    }

    .c100.p84 .bar {
        -webkit-transform: rotate(302.4deg);
        -moz-transform: rotate(302.4deg);
        -ms-transform: rotate(302.4deg);
        -o-transform: rotate(302.4deg);
        transform: rotate(302.4deg);
    }

    .c100.p85 .bar {
        -webkit-transform: rotate(306deg);
        -moz-transform: rotate(306deg);
        -ms-transform: rotate(306deg);
        -o-transform: rotate(306deg);
        transform: rotate(306deg);
    }

    .c100.p86 .bar {
        -webkit-transform: rotate(309.6deg);
        -moz-transform: rotate(309.6deg);
        -ms-transform: rotate(309.6deg);
        -o-transform: rotate(309.6deg);
        transform: rotate(309.6deg);
    }

    .c100.p87 .bar {
        -webkit-transform: rotate(313.2deg);
        -moz-transform: rotate(313.2deg);
        -ms-transform: rotate(313.2deg);
        -o-transform: rotate(313.2deg);
        transform: rotate(313.2deg);
    }

    .c100.p88 .bar {
        -webkit-transform: rotate(316.8deg);
        -moz-transform: rotate(316.8deg);
        -ms-transform: rotate(316.8deg);
        -o-transform: rotate(316.8deg);
        transform: rotate(316.8deg);
    }

    .c100.p89 .bar {
        -webkit-transform: rotate(320.4deg);
        -moz-transform: rotate(320.4deg);
        -ms-transform: rotate(320.4deg);
        -o-transform: rotate(320.4deg);
        transform: rotate(320.4deg);
    }

    .c100.p90 .bar {
        -webkit-transform: rotate(324deg);
        -moz-transform: rotate(324deg);
        -ms-transform: rotate(324deg);
        -o-transform: rotate(324deg);
        transform: rotate(324deg);
    }

    .c100.p91 .bar {
        -webkit-transform: rotate(327.6deg);
        -moz-transform: rotate(327.6deg);
        -ms-transform: rotate(327.6deg);
        -o-transform: rotate(327.6deg);
        transform: rotate(327.6deg);
    }

    .c100.p92 .bar {
        -webkit-transform: rotate(331.2deg);
        -moz-transform: rotate(331.2deg);
        -ms-transform: rotate(331.2deg);
        -o-transform: rotate(331.2deg);
        transform: rotate(331.2deg);
    }

    .c100.p93 .bar {
        -webkit-transform: rotate(334.8deg);
        -moz-transform: rotate(334.8deg);
        -ms-transform: rotate(334.8deg);
        -o-transform: rotate(334.8deg);
        transform: rotate(334.8deg);
    }

    .c100.p94 .bar {
        -webkit-transform: rotate(338.4deg);
        -moz-transform: rotate(338.4deg);
        -ms-transform: rotate(338.4deg);
        -o-transform: rotate(338.4deg);
        transform: rotate(338.4deg);
    }

    .c100.p95 .bar {
        -webkit-transform: rotate(342deg);
        -moz-transform: rotate(342deg);
        -ms-transform: rotate(342deg);
        -o-transform: rotate(342deg);
        transform: rotate(342deg);
    }

    .c100.p96 .bar {
        -webkit-transform: rotate(345.6deg);
        -moz-transform: rotate(345.6deg);
        -ms-transform: rotate(345.6deg);
        -o-transform: rotate(345.6deg);
        transform: rotate(345.6deg);
    }

    .c100.p97 .bar {
        -webkit-transform: rotate(349.2deg);
        -moz-transform: rotate(349.2deg);
        -ms-transform: rotate(349.2deg);
        -o-transform: rotate(349.2deg);
        transform: rotate(349.2deg);
    }

    .c100.p98 .bar {
        -webkit-transform: rotate(352.8deg);
        -moz-transform: rotate(352.8deg);
        -ms-transform: rotate(352.8deg);
        -o-transform: rotate(352.8deg);
        transform: rotate(352.8deg);
    }

    .c100.p99 .bar {
        -webkit-transform: rotate(356.4deg);
        -moz-transform: rotate(356.4deg);
        -ms-transform: rotate(356.4deg);
        -o-transform: rotate(356.4deg);
        transform: rotate(356.4deg);
    }

    .c100.p100 .bar {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }

    .c100:hover {
        cursor: default;
    }

        .c100:hover > span {
            width: 3.33em;
            line-height: 3.33em;
            font-size: 0.3em;
            color: #254c75;
        }

        .c100:hover:after {
            top: 0.04em;
            left: 0.04em;
            width: 0.92em;
            height: 0.92em;
        }

    .c100.dark {
        background-color: #777777;
    }

        .c100.dark .bar,
        .c100.dark .fill {
            border-color: #c6ff00 !important;
        }

        .c100.dark > span {
            color: #777777;
        }

        .c100.dark:after {
            background-color: #666666;
        }

        .c100.dark:hover > span {
            color: #c6ff00;
        }

    .c100.green .bar, .c100.green .fill {
        border-color: #4db53c !important;
    }

    .c100.green:hover > span {
        color: #4db53c;
    }

    .c100.green.dark .bar, .c100.green.dark .fill {
        border-color: #5fd400 !important;
    }

    .c100.green.dark:hover > span {
        color: #5fd400;
    }

    .c100.orange .bar, .c100.orange .fill {
        border-color: #dd9d22 !important;
    }

    .c100.orange:hover > span {
        color: #dd9d22;
    }

    .c100.orange.dark .bar, .c100.orange.dark .fill {
        border-color: #e08833 !important;
    }

    .c100.orange.dark:hover > span {
        color: #e08833;
    }

`;
const PercentageCircle = ({ value, is2080 = false }) => {
    let valueclass = value;
    if (is2080) {
        valueclass = Math.floor(100 * ((value - 20) / 60));
    }
    return (React.createElement(StyledPercentageCircleContainer, { className: "center", style: { marginBottom: '10px' } },
        React.createElement("div", { className: `c100 p${valueclass}` },
            React.createElement("span", null, value),
            React.createElement("div", { className: "slice" },
                React.createElement("div", { className: "bar" }),
                React.createElement("div", { className: "fill" })))));
};

/* eslint-disable react/no-this-in-sfc */
const Container$7 = styled.div `
    ${BaseChartContainer} {
        min-height: 50px;
        text-align: center;
    }
`;
// eslint-disable-next-line no-mixed-operators
Highcharts.SVGRenderer.prototype.symbols.line = (x, y, w, h) => ['M', x + w / 2, y, 'L', x + w / 2, y + h, 'z'];
const PerformanceScienceProjectabilityBarChart = ({ seriesData, width = 325, height = 40, title, titleStyle, formatter }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    if (formatter === undefined) {
        // eslint-disable-next-line
        formatter = function () {
            // eslint-disable-next-line
            return this.y;
            // eslint-disable-next-line
        };
    }
    const chartConfig = {
        chart: {
            type: 'columnrange',
            height,
            width,
            margin: [12, 10, 12, 10],
            backgroundColor: 'transparent',
            inverted: true,
        },
        legend: {
            enabled: false,
        },
        title: {
            text: title,
            style: titleStyle,
            verticalAlign: 'bottom',
            margin: 0,
        },
        xAxis: {
            visible: false,
            categories: [translate('components.charts.present'), translate('components.charts.future')],
        },
        yAxis: {
            visible: true,
            labels: { enabled: false, align: 'center' },
            showFirstLabel: true,
            showLastLabel: true,
            title: { text: null },
            tickPositions: [20, 30, 40, 50, 60, 70, 80],
            min: 20,
            max: 80,
            offset: -24,
            lineColor: 'green',
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            columnrange: {
                borderRadius: 5,
                dataLabels: {
                    enabled: false,
                    formatter,
                },
                pointPadding: 0,
                groupPadding: 0,
            },
            scatter: {
                marker: {
                    symbol: 'line',
                    lineWidth: 3,
                    radius: 6,
                },
                dataLabels: { enabled: true },
            },
        },
        credits: {
            enabled: false,
        },
        series: seriesData,
    };
    return (React.createElement(Container$7, null,
        React.createElement(BaseChart, { ref: ref, width: width, height: height, options: chartConfig, useBodyFont: false })));
};

var COLUMN_TYPES;
(function (COLUMN_TYPES) {
    COLUMN_TYPES["TEXT"] = "text";
    COLUMN_TYPES["NUMBER"] = "number";
    COLUMN_TYPES["RATE"] = "ratestat";
    COLUMN_TYPES["YESNO"] = "yesno";
    COLUMN_TYPES["PERCENT"] = "percent";
    COLUMN_TYPES["NODE"] = "node";
})(COLUMN_TYPES || (COLUMN_TYPES = {}));
const evaluateIfFunction = (evalObj, ...params) => (typeof evalObj === 'function') && evalObj(...params);
const formatCell = (row, col, isHeader, idx, sortedData, translate = null) => {
    const colType = col.type || COLUMN_TYPES.NUMBER;
    const isRateStat = colType === COLUMN_TYPES.RATE;
    const isNumberType = colType === COLUMN_TYPES.NUMBER || isRateStat;
    let formattedValue;
    let cellValue;
    if (isHeader) {
        cellValue = evaluateIfFunction(col.title) || col.title;
        formattedValue = cellValue;
    }
    else {
        const evaluatedValue = evaluateIfFunction(col.transform, row, idx, sortedData);
        if (evaluatedValue !== false && evaluatedValue !== null && evaluatedValue !== undefined) {
            cellValue = evaluatedValue;
        }
        else {
            cellValue = get$2(row, col.id);
        }
        formattedValue = cellValue;
        if (isNumberType) {
            formattedValue = format(cellValue, isRateStat ? true : col.precision);
        }
        else if (colType === COLUMN_TYPES.PERCENT) {
            if (isNumber$2(cellValue)) {
                formattedValue = percent(cellValue, col.precision);
            }
            else {
                formattedValue = null;
            }
        }
        else if (colType === COLUMN_TYPES.YESNO) {
            formattedValue = yesNo(cellValue, false, translate);
        }
    }
    return { isNumber: isNumberType, formattedValue, cellValue };
};
const sortTableRows = (sortBy, translate = null) => (a, b) => {
    let sortVal = 0;
    if ((sortBy === null || sortBy === void 0 ? void 0 : sortBy.col) && a && b) {
        const aCell = formatCell(a, sortBy.col, undefined, undefined, undefined, translate);
        const bCell = formatCell(b, sortBy.col, undefined, undefined, undefined, translate);
        let compare;
        let aCellValue = aCell.cellValue;
        let bCellValue = bCell.cellValue;
        if (typeof sortBy.col.sortBy === 'function' && !Array.isArray(a) && !Array.isArray(b)) {
            aCellValue = sortBy.col.sortBy(a);
            bCellValue = sortBy.col.sortBy(b);
        }
        // Handle null/undefined values
        const aIsNull = aCellValue === null || aCellValue === undefined;
        const bIsNull = bCellValue === null || bCellValue === undefined;
        if (aIsNull && !bIsNull) {
            return 1; // Push a to the bottom
        }
        if (!aIsNull && bIsNull) {
            return -1; // Push b to the bottom
        }
        if (aIsNull && bIsNull) {
            return 0; // Both are null/undefined, consider them equal
        }
        // Compare non-null/undefined values
        if ((aCell.isNumber && bCell.isNumber) || isNumber$2(aCellValue, bCellValue)) {
            compare = Number(aCellValue || 0) - Number(bCellValue || 0);
        }
        else {
            compare = (aCellValue || '').toString().localeCompare((bCellValue || '').toString());
        }
        sortVal = compare * (sortBy.isDesc ? -1 : 1);
    }
    return sortVal;
};

const AscDescIcon = styled.i.attrs({ className: 'dropdown-toggle' }) `
    &:after {
        ${(props) => (props.asc ? 'transform: rotate(180deg)' : '')};
    }
`;
const HeaderTitle = styled.div `
    display: flex;
    align-items: center;
    .header-title {
        flex-grow: 1;
    }
`;
const StyledButton$1 = styled.button `
    && {
        font-size: 0.5em !important;
        background-color: transparent;
        border: none;
        padding: 0 5px;
        &:focus {
            outline: none;
            border: none;
        }
        transform: rotate(${(props) => props.rotation}deg);
}
`;
const RowGroupCell = styled.div `
    display: flex;
    justify-content: center;
`;
const DataTableCell = (_a) => {
    var { row, col, header = false, sortDirectionDesc, statTooltip: StatTooltip, isRowGroupCell = false, onRowGroupIndexChange, rowIndex = -1, sortedData = [], customClass } = _a, rest = __rest(_a, ["row", "col", "header", "sortDirectionDesc", "statTooltip", "isRowGroupCell", "onRowGroupIndexChange", "rowIndex", "sortedData", "customClass"]);
    const { t: translate } = useTranslation();
    const { cellValue, formattedValue, isNumber } = formatCell(row, col, header, rowIndex, sortedData, translate);
    let cellClass = ' ';
    if (!header && col.cellClass) {
        const value = evaluateIfFunction(col.cellClass, row, cellValue, formattedValue) || col.cellClass;
        cellClass += (typeof value === 'string' || value instanceof String) ? `${value} ` : '';
    }
    else if (header && col.headerClass) {
        const value = evaluateIfFunction(col.headerClass, row, cellValue, formattedValue) || col.headerClass;
        cellClass += (typeof value === 'string' || value instanceof String) ? `${value} ` : '';
    }
    if (isNumber) {
        cellClass += 'number-value ';
    }
    if (col.isSticky) {
        cellClass += 'sticky ';
    }
    if (rest.onClick) {
        cellClass += 'has-click-handler ';
    }
    if (customClass) {
        cellClass += ` ${customClass}`;
    }
    let cellColSpan = 1;
    if (col.colSpan != null) {
        const value = evaluateIfFunction(col.colSpan, row, cellValue, formattedValue);
        if (typeof value === 'number')
            cellColSpan = value;
    }
    if (typeof col.colSpan === 'number') {
        cellColSpan = col.colSpan;
    }
    if (cellColSpan === 0)
        return (React.createElement("td", { style: { display: 'none' } }));
    if (header) {
        let title = formattedValue;
        if (StatTooltip && col.statistic) {
            title = React.createElement(StatTooltip, { statistic: col.statistic, placement: col.tooltipPlacement }, title);
        }
        return (React.createElement("th", Object.assign({ className: cellClass }, rest),
            React.createElement(HeaderTitle, null,
                React.createElement("div", { className: "header-title" }, title),
                sortDirectionDesc !== undefined && React.createElement(AscDescIcon, { asc: sortDirectionDesc === false }))));
    }
    const nullHandledCellValue = formattedValue || '--';
    if (col.isSticky)
        return (React.createElement("th", Object.assign({ colSpan: cellColSpan, className: cellClass }, rest), nullHandledCellValue));
    if (isRowGroupCell) {
        return (React.createElement("td", Object.assign({ className: cellClass }, rest),
            React.createElement(RowGroupCell, null,
                React.createElement(StyledButton$1, { rotation: 90, onClick: onRowGroupIndexChange ? () => onRowGroupIndexChange(-1) : undefined },
                    React.createElement(Icon, { icon: "chevron-down" })),
                React.createElement("div", null, nullHandledCellValue),
                React.createElement(StyledButton$1, { rotation: -90, onClick: onRowGroupIndexChange ? () => onRowGroupIndexChange(1) : undefined },
                    React.createElement(Icon, { icon: "chevron-down" })))));
    }
    return (React.createElement("td", Object.assign({ colSpan: cellColSpan, className: cellClass }, rest), nullHandledCellValue));
};

const StyleExpandButton = styled.button `
    && {
        font-size: 0.5em !important;
        background-color: transparent;
        border: none;
        padding: 2px;
        &:focus {
            outline: none;
            border: none;
        }
    }
`;
const StyledDrilldownBtn = styled.svg `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.25rem;
    height: 18px;
    width: 18px;
    padding: 2px;
    border: 2px solid transparent;
    cursor: pointer;
    transform: rotate(${(props) => (props.$isOpen ? '0' : '270')}deg);

    &:hover {
        border: 2px solid #cccccc;
    }
`;
const DataTableRow = ({ sortedData, row, rowIndex, filteredColumns, rowClassName, hasExpandableRows = false, initExpanded = false, }) => {
    var _a;
    const [isDrilldownExpanded, setIsDrilldownExpanded] = useState(initExpanded);
    useEffect(() => {
        setIsDrilldownExpanded(initExpanded);
    }, [row, initExpanded]);
    const [selectedRowGroupIndex, setSelectedRowGroupIndex] = useState(0);
    if (Array.isArray(row) && !row.length)
        return React.createElement(React.Fragment, null);
    const isRowGroup = Array.isArray(row);
    const selectedRow = isRowGroup ? row[selectedRowGroupIndex] : row;
    const { drilldown, drilldownParent, forceIsDrilldownTableRow } = selectedRow;
    const isDrilldownTableRow = forceIsDrilldownTableRow || (drilldown && (Array.isArray(drilldown) ? ((_a = drilldown[0]) === null || _a === void 0 ? void 0 : _a.type) === 'tr' : drilldown.type === 'tr'));
    return (React.createElement(React.Fragment, { key: rowIndex },
        React.createElement("tr", { className: rowClassName },
            hasExpandableRows && drilldown && (React.createElement("td", null,
                React.createElement(StyleExpandButton, { type: "button", onClick: () => setIsDrilldownExpanded(!isDrilldownExpanded) },
                    React.createElement(StyledDrilldownBtn, { "$isOpen": isDrilldownExpanded, viewBox: "0 0 24 15" },
                        React.createElement("path", { fill: "#2877d9", d: "M2.8299999 0L12 9.1700001L21.17 0L24 2.8299999L12 14.83L0 2.8299999L2.8299999 0Z" }))))),
            hasExpandableRows && !drilldown && (React.createElement("td", null, "\u00A0")),
            filteredColumns.map((col, colIdx) => (React.createElement(DataTableCell, { key: col.id, col: col, row: selectedRow, rowIndex: rowIndex, sortedData: sortedData, isRowGroupCell: isRowGroup && colIdx === 0, onRowGroupIndexChange: (n) => {
                    if (!Array.isArray(row))
                        return;
                    let nextIndex = selectedRowGroupIndex + n;
                    if (nextIndex >= row.length) {
                        nextIndex = 0;
                    }
                    else if (nextIndex < 0) {
                        nextIndex = row.length - 1;
                    }
                    setSelectedRowGroupIndex(nextIndex);
                } })))),
        drilldownParent && !isDrilldownTableRow && isDrilldownExpanded && (React.createElement("tr", null,
            React.createElement("td", { colSpan: filteredColumns.length + 1 }, drilldownParent))),
        drilldown && isDrilldownTableRow && isDrilldownExpanded && drilldown,
        drilldown && !isDrilldownTableRow && isDrilldownExpanded && (React.createElement("tr", null,
            React.createElement("td", { colSpan: filteredColumns.length + 1 }, drilldown)))));
};

function DataTableHeaderCell(_a) {
    var _b;
    var { onClick, sortBy, col, sortable = false } = _a, rest = __rest(_a, ["onClick", "sortBy", "col", "sortable"]);
    const onColHeaderClick = (sortable && onClick) ? () => onClick(col) : undefined;
    const sortDirectionDesc = (sortable && ((_b = sortBy.col) === null || _b === void 0 ? void 0 : _b.id) === col.id) ? !!sortBy.isDesc : undefined;
    return (React.createElement(DataTableCell, Object.assign({ header: true, onClick: onColHeaderClick, col: col, sortDirectionDesc: sortDirectionDesc }, rest)));
}

const stickyBoxShadowWidth = '13px';
const tableBorder = `1px solid ${theme.border.bombay}`;
const headerColor = theme.background.astronaut;
const headerBorderColor = pSBC(-0.2, headerColor);
const StyledTable$1 = styled(Table) `
    > :not(caption) > * > * {
        box-shadow: none !important;
    }
    th {
        border: none; //override BASE style
    }

    th.sticky {
        position: sticky;
        left: 0;
    }
    &.is-scrolling th.sticky {
        //box-shadow element for right-side
        &:not(.table-title):after {
            content: '';
            height: 100%;
            position: absolute;
            top: 0;
            right: -${stickyBoxShadowWidth};
            width: ${stickyBoxShadowWidth};
            ${boxShadow(`${stickyBoxShadowWidth} 0px 10px -10px inset rgba(0, 0, 0, .5)`)}
        }
        //fake border to make it seem like table does not move
        &:before {
            content: '';
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            border-left: ${tableBorder};
        }
        &.table-title:before {
            border-left-color: ${headerBorderColor};
        }
        + td, + th {
            padding-left: ${stickyBoxShadowWidth};
        }
    }
    tbody th.sticky {
        font-weight: inherit;
    }
    tbody th.sticky, tfoot th.sticky {
        background-color: white;
    }
    thead > tr > th, tbody > tr > th:not(.sticky) {
        background-color: ${theme.background.geyser} !important;
    }

    &&.table {
        background-color: white;
        border: ${tableBorder};
        margin-bottom: 0;
        &.is-scrolling {
            border-left: none;
        }
        tbody, thead, tfoot {
            td, th {
                vertical-align: middle;
                line-height: 1.2;
                &.has-click-handler:hover {
                    cursor: pointer;
                }
            }
        }
        tbody, tfoot {
            td, th {
                border: none;
            }
        }
        thead th {
            border-top: ${tableBorder};
            border-bottom: ${tableBorder} !important;
        }
        thead th, tbody th {
            &.table-title, &.table-subtitle {
                color: white;
                white-space: nowrap;
                max-width: 1px;
            }
            &.table-title {
                background-color: ${headerColor} !important;
                border-top-color: ${headerBorderColor};
                text-transform: uppercase;
                padding-top: 6px;
                padding-bottom: 6px;
                letter-spacing: .75px;
                &:first-of-type {
                    border-left: 1px solid ${headerBorderColor};
                }
                &:last-of-type {
                    border-right: 1px solid ${headerBorderColor};
                }
            }
            &.table-subtitle {
                font-weight: normal;
                background-color: ${theme.background.endeavour};
            }
        }
        tfoot {
            font-weight: bold;
            border-top: ${tableBorder};
            border-top-width: 2px;
        }
    }
    &&.table-striped {
        tbody tr:nth-of-type(odd) {
            &, th.sticky {
                background-color: ${theme.background.solitude};
            }
            > td {
                background-color: inherit;
        }
    }
    &&.table-hover {
        tbody tr:hover {
            background-color: #ffffcc;
            th.sticky {
                background-color: #ffffcc;
            }
            > td {
                background-color: #ffffcc;
            }
        }
    }
    &&.table-dark {
        tbody th.sticky, tfoot th.sticky {
            background-color: ${theme.background.codGray};
        }
        thead > tr > th, tbody > tr > th:not(.sticky) {
            background-color: #3E444A;
            color: ${theme.fontColors.silver};
        }
        &.table {
            tfoot {
                color: ${theme.fontColors.silver};
            }
        }
        &.table-striped {
            tbody tr:nth-of-type(odd) {
                &, th.sticky {
                    background-color: #343a40;
                }
            }
        }
        &.table-hover {
            tbody tr:hover {
                background-color: #43494E;
                th.sticky {
                    background-color: #43494E;
                }
            }
        }
    }
    .number-value {
        text-align: center;
    }
    p {
        margin-top: 0.25em;
        margin-bottom: 0.25em;
    }
    // Needed to override global bootstrap class when table is the child of another table
    .unstriped-rows tr > td {
        background-color: white !important;
    }
`;
const defaultProps = {
    size: 'sm',
    responsive: true,
    hover: true,
    striped: true,
};
StyledTable$1.defaultProps = defaultProps;

/* eslint-env browser */
const DataTable = ({ className, toprows, toprowsClasses, rows, superheader, columns, subheader, footer, title, subtitle, statTooltip, rowClass, rowKey, responsive = true, sortable = false, striped = true, hover = true, hideHeader = false, 
// toggleExpandedRowCallback,
pagination, onSortChange, }) => {
    const { t: translate } = useTranslation();
    const [isTableScrolling, setIsTableScrolling] = useState(false);
    // const {isDarkMode = false} = useContext(ThemeContext);
    // const variant = false ? 'dark' : undefined;
    const variant = undefined;
    // filter columns by role/defined
    const filteredColumns = columns.filter((c) => c);
    // watch for resize so we can add "sticky" effect styling
    const hasStickyColumn = filteredColumns.some((c) => c.isSticky);
    const hasHeaderRow = columns.some((c) => c.title);
    const tableRef = useRef(null);
    useLayoutEffect(() => {
        var _a;
        if (responsive && hasStickyColumn && ((_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.parentElement)) {
            const parent = tableRef.current.parentElement;
            const checkAndSetIfTableScrolls = () => setIsTableScrolling(parent.scrollWidth > parent.offsetWidth);
            // https://stackoverflow.com/a/19014495/2486531
            window.addEventListener('resize', checkAndSetIfTableScrolls);
            checkAndSetIfTableScrolls();
            return () => window.removeEventListener('resize', checkAndSetIfTableScrolls);
        }
        return () => { }; // eslint-disable-line @typescript-eslint/no-empty-function
    }, [responsive, hasStickyColumn]);
    // configure sorting
    let initSortObj = {};
    if (sortable && typeof sortable === 'object' && sortable.id) {
        const sortCol = columns.find((c) => c.id === sortable.id);
        if (sortCol)
            initSortObj = { col: sortCol, isDesc: !!sortable.isDesc };
    }
    const [sortBy, setSortBy] = useState(initSortObj);
    // const [expandedRows, setExpandedRows] = useState(new Array<number>());
    const onHeaderCellClick = (headerCol) => {
        var _a;
        const newSortBy = {
            col: headerCol,
            isDesc: ((_a = sortBy.col) === null || _a === void 0 ? void 0 : _a.id) === headerCol.id ? !sortBy.isDesc : !!sortBy.isDesc,
        };
        setSortBy(newSortBy);
        if (onSortChange) {
            onSortChange(newSortBy);
        }
    };
    const onHeaderCellClickNoOp = () => ({});
    let sortedRows = sortable ? [...rows].sort(sortTableRows(sortBy, translate)) : rows;
    if ((pagination === null || pagination === void 0 ? void 0 : pagination.page) && (pagination === null || pagination === void 0 ? void 0 : pagination.pageSize)) {
        sortedRows = sortedRows.slice((pagination.page - 1) * pagination.pageSize, pagination.page * pagination.pageSize);
    }
    const hasExpandableRows = sortedRows.some((r) => !Array.isArray(r) && r.drilldown) || (footer && footer.some((r) => !Array.isArray(r) && r.drilldown));
    return (React.createElement(StyledTable$1, { size: "sm", variant: variant, responsive: responsive, striped: striped, hover: hover, ref: tableRef, className: `${className} ${isTableScrolling ? 'is-scrolling' : ''}` },
        (hasHeaderRow || title || subtitle) && hideHeader !== true && (React.createElement("thead", null,
            title && (React.createElement("tr", null,
                React.createElement("th", { className: `table-title ${hasStickyColumn ? 'sticky' : ''}` }, title),
                filteredColumns.length > 1 && (React.createElement("th", { className: "table-title", colSpan: hasExpandableRows ? filteredColumns.length : filteredColumns.length - 1 })))),
            subtitle && (React.createElement("tr", null,
                React.createElement("th", { className: `table-subtitle ${hasStickyColumn ? 'sticky' : ''}` }, subtitle),
                filteredColumns.length > 1 && (React.createElement("th", { className: "table-subtitle", colSpan: hasExpandableRows ? filteredColumns.length : filteredColumns.length - 1 })))),
            superheader,
            hasHeaderRow && (React.createElement("tr", null,
                hasExpandableRows && (React.createElement("th", null, "\u00A0")),
                filteredColumns.map((col) => (React.createElement(DataTableHeaderCell, { key: col.id, col: col, onClick: col.orderable === false ? onHeaderCellClickNoOp : onHeaderCellClick, sortable: !!sortable, sortBy: sortBy, statTooltip: statTooltip }))))),
            subheader)),
        React.createElement("tbody", { className: striped ? 'striped-rows' : 'unstriped-rows' },
            toprows && toprows.map((row, idx) => (React.createElement("tr", { key: rowKey && !Array.isArray(row) ? row[rowKey] : idx },
                hasExpandableRows && (React.createElement("td", null, "\u00A0")),
                filteredColumns.map((col) => (React.createElement(DataTableCell, { key: col.id, col: col, row: row, customClass: toprowsClasses && (toprowsClasses[idx] || '') })))))),
            sortedRows.map((row, idx, self) => {
                // const toggleExpandedRow = () => {
                //     if (toggleExpandedRowCallback) {
                //         toggleExpandedRowCallback(row, !expandedRows.includes(idx));
                //     }
                //     if (expandedRows.includes(idx)) return setExpandedRows(expandedRows.filter((r) => r !== idx));
                //     return setExpandedRows([...expandedRows, idx]);
                // };
                let rowClassName;
                if (typeof rowClass === 'function')
                    rowClassName = rowClass(row);
                else if (rowClass && !Array.isArray(row))
                    rowClassName = row[rowClass];
                return (React.createElement(DataTableRow, { key: rowKey && !Array.isArray(row) ? row[rowKey] : idx, row: row, rowIndex: idx, sortedData: self, rowClassName: rowClassName, hasExpandableRows: hasExpandableRows, filteredColumns: filteredColumns, initExpanded: (row === null || row === void 0 ? void 0 : row.initExpanded) || false }));
            })),
        footer && (React.createElement("tfoot", null, footer.map((row, idx, self) => (React.createElement(DataTableRow, { key: rowKey && !Array.isArray(row) ? row[rowKey] : idx, row: row, rowIndex: idx, sortedData: self, hasExpandableRows: hasExpandableRows, filteredColumns: filteredColumns, initExpanded: (row === null || row === void 0 ? void 0 : row.initExpanded) || false })))))));
};

const SyledPagination = styled(Pagination) `
    && {
        margin: 5px 0;
    }
    justify-content: ${({ position }) => {
    if (position === 'right')
        return 'flex-end';
    if (position === 'center')
        return 'center';
    return 'flex-start';
}};
`;
const DataTablePagination = ({ totalItems, itemsPerPage, page, onPageChange, size, position = 'right', maxSize = 5, href = '#' }) => {
    const totalPages = totalItems > 0 ? Math.ceil(totalItems / itemsPerPage) : 1;
    const currentPage = Math.min(Math.max(page, 1), totalPages);
    const isOnFirstPage = currentPage === 1;
    const isOnLastPage = currentPage === totalPages;
    let innerPaginationStart;
    let innerPaginationEnd;
    let ellipsesStart = false;
    let ellipsesEnd = false;
    if (totalPages > 2 && totalPages <= maxSize + 2) {
        innerPaginationStart = 2;
        innerPaginationEnd = totalPages - 1;
    }
    else if (totalPages > maxSize + 2) {
        if (currentPage <= 1 + Math.ceil(maxSize / 2)) {
            innerPaginationStart = 2;
            innerPaginationEnd = innerPaginationStart + maxSize - 1;
            ellipsesEnd = true;
        }
        else if (currentPage >= totalPages - Math.ceil(maxSize / 2)) {
            innerPaginationEnd = totalPages - 1;
            innerPaginationStart = innerPaginationEnd - maxSize + 1;
            ellipsesStart = true;
        }
        else {
            ellipsesStart = true;
            ellipsesEnd = true;
            innerPaginationStart = currentPage - Math.floor(maxSize / 2);
            innerPaginationEnd = currentPage + Math.floor(maxSize / 2);
        }
    }
    return (React.createElement(SyledPagination, { size: size, position: position },
        React.createElement(Pagination.First, { disabled: isOnFirstPage, onClick: () => !isOnFirstPage && onPageChange(1), href: href }),
        React.createElement(SyledPagination.Prev, { disabled: isOnFirstPage, onClick: () => !isOnFirstPage && onPageChange(currentPage - 1), href: href }),
        React.createElement(Pagination.Item, { active: isOnFirstPage, onClick: () => !isOnFirstPage && onPageChange(1), href: href }, "1"),
        ellipsesStart && React.createElement(Pagination.Ellipsis, { onClick: () => onPageChange(currentPage - maxSize + 1), href: href }),
        !!innerPaginationEnd && new Array(innerPaginationEnd - innerPaginationStart + 1).fill(undefined).map((_, idx) => {
            const pageNum = innerPaginationStart + idx;
            const active = pageNum === currentPage;
            return (React.createElement(Pagination.Item, { key: pageNum, active: active, onClick: () => !active && onPageChange(pageNum), href: href }, pageNum));
        }),
        ellipsesEnd && React.createElement(Pagination.Ellipsis, { onClick: () => onPageChange(currentPage + maxSize - 1), href: href }),
        totalPages > 1 && (React.createElement(Pagination.Item, { active: isOnLastPage, onClick: () => !isOnLastPage && onPageChange(totalPages), href: href }, totalPages)),
        React.createElement(Pagination.Next, { disabled: isOnLastPage, onClick: () => !isOnLastPage && onPageChange(currentPage + 1), href: href }),
        React.createElement(Pagination.Last, { disabled: isOnLastPage, onClick: () => !isOnLastPage && onPageChange(totalPages), href: href })));
};

/* eslint-disable react/no-this-in-sfc */
const StyledPercentileStatRow = styled.div `
    display: flex;
    justify-content: flex-start;
    padding: 0 ${(props) => (props.size !== 'xs' ? '20px' : '0')};
    label {
        font-weight: bold;
        font-size: 1.1em;
        display: flex;
        align-items: center;
        margin-bottom: 0;
        width: 150px;
        justify-content: flex-start;
    }
`;
const StyledPercentileStat = styled.div `
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: start;
    margin: 0 10px;
`;
const PercentileChart = ({ teamid, percentilesToDisplay, statAllTeams, leagueid, displayTeams, teamLogos, hideMedianDisplay, hideLabels, labelLeft, labelMiddle, labelRight, simplifyTooltip, hideTooltip, singleDataPoint, size, showValueOnPoint, svgWidth, labelWidth, statlineWidth, }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const evaluateIfFunction = (evalObj, ...params) => (typeof evalObj === 'function') && evalObj(...params);
    let iSvgWidth = svgWidth !== null && svgWidth !== void 0 ? svgWidth : 900;
    let iLabelWidth = labelWidth !== null && labelWidth !== void 0 ? labelWidth : 145;
    let iStatlineWidth = statlineWidth !== null && statlineWidth !== void 0 ? statlineWidth : 882;
    if (size) {
        switch (size) {
            case 'l':
                iSvgWidth = 750;
                iLabelWidth = 150;
                iStatlineWidth = 735;
                break;
            case 'm':
                iSvgWidth = 500;
                iLabelWidth = 138;
                iStatlineWidth = 507;
                break;
            case 's':
                iSvgWidth = 250;
                iLabelWidth = 136;
                iStatlineWidth = 258;
                break;
            case 'xs':
                iSvgWidth = 200;
                iLabelWidth = 90;
                iStatlineWidth = 200;
                break;
            case 'xl':
            default:
                iSvgWidth = 900;
                iLabelWidth = 145;
                iStatlineWidth = 882;
                break;
        }
    }
    const formatValue = (value, p) => {
        const isRateStat = p.type === COLUMN_TYPES.RATE;
        let formattedValue = '';
        if (p.type === COLUMN_TYPES.PERCENT) {
            const formattedPercent = Number(value * 100).toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });
            formattedValue = `${Number(formattedPercent)}%`;
        }
        else {
            const precision = isRateStat ? 3 : p.precision || 1;
            formattedValue = Number(value).toLocaleString(undefined, {
                minimumFractionDigits: precision,
                maximumFractionDigits: precision,
            });
            if (isRateStat) {
                formattedValue = formattedValue.replace('0.', '.');
            }
        }
        return formattedValue;
    };
    const drawPercentileLocation = (p) => {
        const sortedTeamRankings = statAllTeams ? statAllTeams
            .filter((t) => t.teamid !== null)
            .map((stat) => {
            const value = evaluateIfFunction(p.transform, stat);
            return {
                id: stat.teamid,
                name: `${(stat.city)} ${(stat.name)}`,
                value,
                statistic: p.statistic,
                title: p.title.toString(),
                displayPercentOnLine: null,
                fillColorHex: '',
                textColorHex: '',
            };
        })
            .sort((a, b) => b.value - a.value) : [];
        if (p.qualityType === 1) {
            sortedTeamRankings.reverse();
        }
        const teamIds = [];
        const teamsFiltered = sortedTeamRankings
            .filter((element) => {
            const isDuplicate = teamIds.includes(element.id);
            if (!isDuplicate) {
                teamIds.push(element.id);
                return true;
            }
            return false;
        });
        let activeDatapoint = teamsFiltered.find((s) => s.id === teamid);
        if (!activeDatapoint && singleDataPoint) {
            activeDatapoint = {
                id: 1,
                name: 'SingleStat',
                value: singleDataPoint.value,
                statistic: singleDataPoint.name,
                title: singleDataPoint.name,
                displayPercentOnLine: singleDataPoint.displayPercentOnLine,
                fillColorHex: singleDataPoint.fillColorHex,
                textColorHex: singleDataPoint.textColorHex,
            };
        }
        else if (!activeDatapoint) {
            return React.createElement(React.Fragment, null, translate('components.charts.team-or-data-required')); // Cannot continue without a team OR datapoint
        }
        const rankingPosition = teamsFiltered.indexOf(activeDatapoint);
        const statsMedians = statAllTeams ? statAllTeams
            .filter((t) => t.teamid === null && t.leagueid === leagueid)
            .map((stat) => {
            let value = evaluateIfFunction(p.transform, stat);
            if (p.needsAverage === true) {
                value = ratio(value, teamsFiltered.length);
            }
            return { teamid: stat.teamid,
                name: `${(stat.city)} ${(stat.name)}`,
                value,
                statistic: p.statistic,
                title: p.id === 'rperg' ? translate('components.charts.abbr-rg') : p.title,
                stddev: stat[p.stddev] };
        }) : [];
        const median = statsMedians.length === 0
            ? ratio(sortedTeamRankings.reduce((a, b) => a + b.value, 0), teamsFiltered.length) : statsMedians[0].value;
        const ranking = ratio(rankingPosition, teamsFiltered.length);
        const formattedRanking = ranking != null ? percent(ranking) : '';
        const formattedMedian = formatValue(median, p);
        const formattedValue = formatValue(activeDatapoint.value, p);
        // eslint-disable-next-line no-nested-ternary, max-len
        const sliderPosition = singleDataPoint && activeDatapoint && activeDatapoint.displayPercentOnLine ? ((iSvgWidth * (activeDatapoint.displayPercentOnLine * 0.01)) - 10)
            : ranking != null ? Math.floor(iSvgWidth * ranking) : 0;
        const colorShading = activeDatapoint && singleDataPoint && activeDatapoint.fillColorHex ? activeDatapoint.fillColorHex : 'rgba(235, 235, 235, 1)';
        const fontColor = '#333333';
        const circleBorderColor = '#9b9b9b';
        const medianPos = displayTeams ? '40' : '20';
        // eslint-disable-next-line max-len, no-nested-ternary
        const medianFont = activeDatapoint && singleDataPoint && activeDatapoint.textColorHex ? activeDatapoint.textColorHex : displayTeams ? fontColor : '#fff';
        const medianColor = displayTeams ? '#fff' : '#9b9b9b';
        const teams = displayTeams
            ? teamsFiltered
                .map((team, i) => {
                var _a;
                const rank = ratio(i, teamsFiltered.length);
                const teamSliderPosition = rank != null ? Math.floor(iSvgWidth * rank) : 0;
                const formattedTeamValue = formatValue(team.value, p);
                const logo = (_a = teamLogos === null || teamLogos === void 0 ? void 0 : teamLogos.find((t) => t.teamid === team.id)) === null || _a === void 0 ? void 0 : _a.logoSvg;
                return { team, rank, teamSliderPosition, formattedTeamValue, logo };
            })
            : teamsFiltered;
        const teamLogo = teamLogos === null || teamLogos === void 0 ? void 0 : teamLogos.find((t) => t.teamid === teamid).logoSvg;
        const chartData = {
            activeDatapoint,
            formattedRanking,
            formattedValue,
            formattedMedian,
            median,
            medianPos,
            medianFont,
            medianColor,
            sliderPosition,
            rankingPosition,
            colorShading,
            fontColor,
            circleBorderColor,
            teamLogo,
            teams,
        };
        return (React.createElement(React.Fragment, null,
            !hideMedianDisplay && (React.createElement("g", { id: `${(chartData.activeDatapoint.name)}-${(chartData.activeDatapoint.statistic)}-median-group`, transform: `translate(416, ${(chartData.medianPos)})` },
                React.createElement("rect", { id: `${(chartData.activeDatapoint.name)}-${(chartData.activeDatapoint.statistic)}-median-rect`, width: "40", height: "20", fill: `${chartData.medianColor}`, stroke: `${chartData.medianColor}`, rx: "5", ry: "5" },
                    React.createElement("title", null, `${(chartData.activeDatapoint.title)}: ${(chartData.formattedMedian)}`)),
                React.createElement("text", { id: `${(chartData.activeDatapoint.name)}-${(chartData.activeDatapoint.statistic)}-median-text`, x: "20", y: "10", textAnchor: "middle", fill: `${chartData.medianFont}`, alignmentBaseline: "central", fontSize: ".6rem", fontWeight: "bold" },
                    chartData.formattedMedian,
                    React.createElement("title", null, `${(chartData.activeDatapoint.title)}: ${(chartData.formattedMedian)}`)))),
            React.createElement("g", { id: `${(chartData.activeDatapoint.name)}-${(chartData.activeDatapoint.statistic)}-value-group`, transform: `translate(${(sliderPosition)}, 30)` },
                React.createElement("circle", { id: `${(chartData.activeDatapoint.name)}-${(chartData.activeDatapoint.statistic)}-value-circle`, r: "14", fill: `${(chartData.colorShading)}`, stroke: `${chartData.circleBorderColor}`, strokeWidth: "2" }, !hideTooltip && (React.createElement("title", null,
                    !simplifyTooltip && `${(chartData.activeDatapoint.name)}`,
                    '\n',
                    !simplifyTooltip && `${(chartData.activeDatapoint.title)}: ${(chartData.formattedValue)}`,
                    '\n',
                    !simplifyTooltip && `${translate('components.charts.rank')}: ${(chartData.rankingPosition + 1)}`,
                    simplifyTooltip && chartData.formattedValue))),
                React.createElement("image", { x: "-10", y: "-10", width: "20", height: "20", xlinkHref: chartData.teamLogo }, !hideTooltip && (React.createElement("title", null,
                    !simplifyTooltip && `${(chartData.activeDatapoint.name)}`,
                    '\n',
                    !simplifyTooltip && `${(chartData.activeDatapoint.title)}: ${(chartData.formattedValue)}`,
                    '\n',
                    !simplifyTooltip && `${translate('components.charts.rank')}: ${(chartData.rankingPosition + 1)}`,
                    simplifyTooltip && chartData.formattedValue))),
                showValueOnPoint && (React.createElement("text", { id: `${(chartData.activeDatapoint.name)}-${(chartData.activeDatapoint.statistic)}-datapoint-text`, x: "0", y: "0", textAnchor: "middle", fill: `${chartData.medianFont}`, alignmentBaseline: "central", fontSize: ".6rem", fontWeight: "bold" }, chartData.activeDatapoint.value))),
            React.createElement("g", null, displayTeams && (chartData.teams.map((t, index) => (React.createElement(React.Fragment, null, t.team.id !== teamid && (React.createElement(React.Fragment, null,
                React.createElement("image", { x: `${(t.teamSliderPosition - 10)}`, y: "20", width: "20", height: "20", xlinkHref: t.logo }, !hideTooltip && (React.createElement("title", null,
                    !simplifyTooltip && `${(t.team.name)}`,
                    '\n',
                    !simplifyTooltip && `${(t.team.title)}: ${(t.formattedTeamValue)}`,
                    '\n',
                    !simplifyTooltip && `${translate('components.charts.rank')}: ${(index + 1)}`,
                    simplifyTooltip && t.formattedTeamValue))))))))))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: ref },
            percentilesToDisplay.map((p, index) => (React.createElement("div", { key: p.id }, p.isActive && (React.createElement(StyledPercentileStatRow, { id: `${(p.id)}-${(index)}-row`, key: p.id, size: size },
                React.createElement("label", { id: `${(p.id)}-${(index)}-label`, style: { width: `${iLabelWidth}px` } }, evaluateIfFunction(p.title) || p.title),
                React.createElement(StyledPercentileStat, { id: `${(p.id)}-${(index)}-stat` },
                    React.createElement("svg", { height: "60", style: { overflow: 'visible', width: iSvgWidth }, id: `${(p.id)}-${(index)}-svg` },
                        React.createElement("g", { id: `${(p.id)}-${(index)}-svg-group` },
                            React.createElement("line", { x1: "0", x2: "96.6%", y1: "30", y2: "30", stroke: "#9b9b9b", strokeWidth: "3px", id: `${(p.id)}-${(index)}-line` }),
                            React.createElement("circle", { id: `${(p.id)}-${(index)}-circle1`, cx: "0%", cy: "30", r: "2", fill: "#9b9b9b", stroke: "#9b9b9b", strokeWidth: "3px" }),
                            React.createElement("circle", { id: `${(p.id)}-${(index)}-circle2`, cx: "96.6%", cy: "30", r: "2", fill: "#9b9b9b", stroke: "#9b9b9b", strokeWidth: "3px" }),
                            drawPercentileLocation(p))))))))),
            hideLabels !== true && (React.createElement(StyledPercentileStatRow, { size: size },
                React.createElement("label", { style: { width: `${iLabelWidth}px` } }),
                React.createElement(StyledPercentileStat, null,
                    React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', width: `${iStatlineWidth}px` } },
                        React.createElement("label", { style: { display: 'flex', justifyContent: 'flex-start' } }, labelLeft),
                        React.createElement("label", { style: { display: 'flex', justifyContent: 'center' } }, labelMiddle),
                        React.createElement("label", { style: { display: 'flex', justifyContent: 'flex-end' } }, labelRight))))))));
};

const EV_LA_CHART_BACKGROUND_TYPE = {
    hitFx: 1,
    actual: 2,
    diff: 3,
};
const backgroundMap = {
    [EV_LA_CHART_BACKGROUND_TYPE.hitFx]: evLaHitFx,
    [EV_LA_CHART_BACKGROUND_TYPE.actual]: evLaActual,
    [EV_LA_CHART_BACKGROUND_TYPE.diff]: evLaDifference,
};
const StyledChartWrapper = styled.div `
    background-image: url(${(props) => backgroundMap[props.$backgroundType]});
    background-repeat: no-repeat;
    background-size: cover;
    height: ${(props) => props.$height}px !important;
    width: ${(props) => props.$width}px !important;
    overflow: hidden;
`;
const sizeMap = {
    md: { height: 326, width: 280, center: [1, 190], multiplier: 2.79 },
    lg: { height: 407, width: 350, center: [1, 238], multiplier: 2.45 },
};
const EvLaChart$1 = forwardRef(({ size = 'lg', seriesData, showGrid, videoPlayerModal: VideoPlayerModal, pitchVideoFn, multiVideoFn, modalContainer, backgroundType = EV_LA_CHART_BACKGROUND_TYPE.hitFx, tooltipFormatter }, outerRef) => {
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const fetchMultiVideo = (pitches) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const pitchIds = pitches
                .filter(({ gameid, eventseq, pitchseq }) => isNumber$2(gameid, eventseq, pitchseq))
                .map(({ gameid, eventseq, pitchseq }) => ({ gameid: Number(gameid), eventseq: Number(eventseq), pitchseq: Number(pitchseq) }));
            const playlist = yield multiVideoFn(pitchIds);
            setVideoPlaylist(playlist);
        }
        catch (_b) {
            closePitchVideo();
        }
    });
    const sizeObj = sizeMap[size];
    const chartConfig = {
        title: undefined,
        chart: {
            type: 'line',
            polar: true,
            width: sizeObj.width * sizeObj.multiplier,
            height: sizeObj.height * sizeObj.multiplier,
            backgroundColor: undefined,
            margin: [0, 0, 0, 0],
            events: {
                selection: function selection(e) {
                    var _a, _b;
                    if (multiVideoFn && ((_a = e.xAxis) === null || _a === void 0 ? void 0 : _a.length) && ((_b = e.yAxis) === null || _b === void 0 ? void 0 : _b.length)) {
                        const [{ min: minXAxis, max: maxXAxis }] = e.xAxis;
                        const [{ min: minYAxis, max: maxYAxis }] = e.yAxis;
                        const points = this.series.flatMap((s) => s.points.filter((point) => {
                            const { enabled, x, y } = point;
                            return enabled !== false && x >= minXAxis && x <= maxXAxis && typeof y === 'number' && y >= minYAxis && y <= maxYAxis;
                        }));
                        if (points.length)
                            fetchMultiVideo(points);
                    }
                    return false; // Don't zoom
                },
            },
            zoomType: 'xy',
        },
        pane: {
            startAngle: 0,
            endAngle: 180,
            center: sizeObj.center,
        },
        xAxis: {
            min: 0,
            max: 360,
            opposite: true,
            visible: showGrid,
        },
        yAxis: {
            min: 60,
            max: 130,
            visible: showGrid,
        },
        plotOptions: {
            series: {
                point: {
                    events: {
                        click: function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (pitchVideoFn)
                                    return fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq);
                            }
                            return null;
                        },
                    },
                },
            },
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                if (!this.point.tooltip && !this.point.name)
                    return false;
                return `<b>${this.series.name}</b><br/>${this.point.tooltip || this.point.name}`;
            },
        },
        series: seriesData.map((sd) => (Object.assign(Object.assign({}, sd), { type: 'scatter', data: sd.data.map((_a) => {
                var { launchangle, exitvelo } = _a, rest = __rest(_a, ["launchangle", "exitvelo"]);
                return (Object.assign({ x: 180 - (2 * launchangle), y: exitvelo }, rest));
            }) }))),
    };
    return (React.createElement(React.Fragment, null,
        !!(pitchVideoFn || multiVideoFn) && !!VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(StyledChartWrapper, { "$height": sizeObj.height, "$width": sizeObj.width, "$backgroundType": backgroundType },
            React.createElement(BaseChart, { ref: ref, options: chartConfig }))));
});

/* eslint-disable react/no-this-in-sfc */
const Container$6 = styled.div `
    ${BaseChartContainer} {
        text-align: center;
    }
`;
const NtilesChart = ({ width = 500, height = 400, title = '', seriesData, statTooltip: StatTooltip, thresholdOnlyTooltip = false, }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    if (Array.isArray(seriesData) && !(seriesData === null || seriesData === void 0 ? void 0 : seriesData.length)) {
        return React.createElement(Container$6, null,
            React.createElement("em", null, translate('components.charts.no-data')));
    }
    const chartSections = [
        {
            type: 'category',
            gridLineColor: '#cdcdcd',
            gridLineWidth: 1,
            alternateGridColor: '#E6F5FF',
            labels: {
                formatter() {
                    var _a, _b;
                    return (_b = (_a = seriesData[0]) === null || _a === void 0 ? void 0 : _a.data[this.pos]) === null || _b === void 0 ? void 0 : _b.lowText;
                },
                align: 'center',
                style: {
                    textTransform: 'uppercase',
                    color: '#333',
                },
                x: -15,
            },
            title: {
                text: null,
            },
            lineColor: '#cdcdcd',
        },
        {
            type: 'category',
            gridLineColor: '#cdcdcd',
            gridLineWidth: 1,
            alternateGridColor: '#E6F5FF',
            linkedTo: 0,
            lineWidth: 0,
            labels: {
                formatter() {
                    return '';
                },
                y: 3,
                x: -15,
                align: 'center',
                style: {
                    color: '#333',
                    fontSize: '10px',
                    fontWeight: 'bold',
                },
            },
        },
        {
            type: 'category',
            gridLineColor: '#cdcdcd',
            gridLineWidth: 1,
            alternateGridColor: '#E6F5FF',
            linkedTo: 0,
            opposite: true,
            lineColor: '#cdcdcd',
            labels: {
                formatter() {
                    var _a, _b;
                    return (_b = (_a = seriesData[0]) === null || _a === void 0 ? void 0 : _a.data[this.pos]) === null || _b === void 0 ? void 0 : _b.highText;
                },
                align: 'center',
                style: {
                    textTransform: 'uppercase',
                    color: '#333',
                },
                x: 15,
            },
        },
    ];
    const chartConfig = {
        chart: {
            type: 'scatter',
            inverted: true,
            backgroundColor: 'none',
            spacing: [0, 20, 5, 0],
            height,
        },
        title: {
            text: title,
        },
        subtitle: {
            text: undefined,
        },
        legend: {
            enabled: false,
        },
        xAxis: chartSections,
        yAxis: {
            opposite: true,
            title: {
                text: undefined,
                style: {
                    color: '#333',
                    fontSize: '14px',
                },
            },
            labels: {
                format: '{value}th',
                style: {
                    color: '#333',
                    fontSize: '8px',
                },
                rotation: 0,
                autoRotation: undefined,
            },
            min: 0,
            max: 100,
            startOnTick: true,
            endOnTick: true,
            minTickInterval: 25,
            minRange: 100,
            tickInterval: 25,
            tickPositions: [0, 25, 50, 75, 100],
            minColor: '#cdcdcd',
            maxColor: '#cdcdcd',
            gridLineColor: '#cdcdcd',
            showLastLabel: false,
            showFirstLabel: false,
        },
        tooltip: {
            formatter() {
                return `${this.point.ntileData.statname}
                    ${!thresholdOnlyTooltip ? `<br /><b>${ordinal(this.point.ntileData.percentile, translate)}: ${this.point.value}${this.point.units}</b>` : ''}
                    <br />${translate('format.number', { count: 25, ordinal: true })}: ${this.point.ntileData.p25}${this.point.units}
                    <br />${translate('format.number', { count: 50, ordinal: true })}: ${this.point.ntileData.p50}${this.point.units}
                    <br />${translate('format.number', { count: 75, ordinal: true })}: ${this.point.ntileData.p75}${this.point.units}`;
            },
        },
        plotOptions: {
            scatter: {
                zones: [{
                        value: 25,
                        color: 'rgb(0, 122, 213)',
                    }, {
                        value: 75,
                        color: 'rgb(240, 240, 240)',
                    }, {
                        color: 'rgb(247, 46, 46)',
                    }],
                marker: {
                    lineWidth: 1,
                    lineColor: '#222',
                    radius: 6,
                },
            },
        },
        series: seriesData.map((ser) => (Object.assign(Object.assign({}, ser), { data: ser.data.map((pt) => (Object.assign(Object.assign({}, pt), { marker: {
                    symbol: 'circle',
                }, dataLabels: {
                    enabled: false,
                } }))) }))),
    };
    return (React.createElement(Container$6, null,
        React.createElement("div", { className: "d-flex justify-content-center" },
            React.createElement("div", { style: { marginBottom: 3, paddingTop: 68, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingRight: 16 } }, seriesData[0].data.map((sd) => (React.createElement("b", { key: sd.name, style: { height: `calc(100% / ${seriesData[0].data.length})`, display: 'flex', alignItems: 'center' } }, StatTooltip && (React.createElement(StatTooltip, { statistic: sd.statistic },
                React.createElement("div", null,
                    sd.name,
                    React.createElement("br", null),
                    React.createElement("span", { dangerouslySetInnerHTML: {
                            __html: sd.value != null ? `${sd.value}${sd.units ? `${sd.units}` : ''}` : '--',
                        } })))))))),
            React.createElement("div", null,
                React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false })),
            seriesData[0].data.some((sd) => { var _a, _b, _c; return ((_a = sd.ntileData) === null || _a === void 0 ? void 0 : _a.extraData) && ((_c = (_b = sd.ntileData) === null || _b === void 0 ? void 0 : _b.extraData) === null || _c === void 0 ? void 0 : _c.length) > 0; }) && (React.createElement("div", { style: { marginBottom: 3, paddingTop: 68, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingRight: 16 } }, seriesData[0].data.map((sd) => {
                var _a;
                if (((_a = sd === null || sd === void 0 ? void 0 : sd.ntileData) === null || _a === void 0 ? void 0 : _a.extraData) != null && sd.ntileData.extraData.length > 0) {
                    return (React.createElement("span", { key: `${sd.name}extra`, style: { height: `calc(100% / ${seriesData[0].data.length})`, display: 'flex', alignItems: 'center' } },
                        React.createElement("div", null, sd.ntileData.extraData.map((ed) => (React.createElement("span", { key: `${sd.name}e${ed.name}` },
                            React.createElement("b", null,
                                ed.name,
                                ": "),
                            ed.value,
                            React.createElement("br", null)))))));
                }
                return '';
            }))))));
};

/* eslint-disable react/no-this-in-sfc */
const SprintExertionsChart = ({ sprints, height = 300 }) => {
    const chartConfig = {
        chart: {
            type: 'column',
            marginRight: 30,
            height,
        },
        title: {
            text: undefined,
        },
        yAxis: {
            title: {
                text: 'MPH',
            },
            lineWidth: 1,
            gridLineColor: 'transparent',
            lineColor: styles.theme.fontColors.silverChalice,
        },
        xAxis: {
            type: 'datetime',
            startOnTick: true,
            labels: {
                formatter() {
                    if (this.value) {
                        return date(this.value, 'HH:mm');
                    }
                    return '';
                },
            },
            endOnTick: true,
            tickPosition: 'inside',
            tickColor: styles.theme.fontColors.silverChalice,
            lineColor: styles.theme.fontColors.silverChalice,
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            column: {
                pointWidth: 1,
                maxPointWidth: 1,
                color: styles.theme.border.alto,
                dataLabels: {
                    overflow: 'allow',
                    allowOverlap: true,
                    crop: false,
                    enabled: true,
                    useHTML: true,
                    formatter() {
                        return '<div style="height: 6px; width: 6px; background-color: #254C75; border-radius: 9999px;" />';
                    },
                    y: 10,
                },
            },
        },
        legend: {
            enabled: false,
        },
        series: [{
                type: 'column',
                data: sprints.map((s) => ({
                    x: new Date(s.datetime).getTime(),
                    y: s.mph,
                })),
            }],
    };
    return React.createElement(BaseChart, { options: chartConfig });
};

/* eslint-disable react/no-this-in-sfc */
const TrunkRotationPieChart = ({ rotation, flexion, tilt, height = 350 }) => {
    const { t: translate } = useTranslation();
    const chartConfig = {
        chart: {
            type: 'pie',
            height,
        },
        title: {
            text: undefined,
        },
        plotOptions: {
            pie: {
                borderWidth: 0,
                enableMouseTracking: false,
                innerSize: '60%',
                dataLabels: {
                    formatter() {
                        if (this.y) {
                            return percent(this.y, 0);
                        }
                        return '-';
                    },
                    distance: 15,
                    style: {
                        fontSize: '16px',
                        fontFamily: "'Amble', sans-serif",
                    },
                    padding: 0,
                },
                showInLegend: true,
                point: {
                    events: {
                        legendItemClick() {
                            return false;
                        },
                    },
                },
            },
        },
        legend: {
            enabled: true,
            symbolWidth: 12,
            symbolHeight: 12,
            symbolRadius: 0,
            useHTML: true,
            itemStyle: {
                fontSize: '12px',
                lineHeight: '14px',
                fontWeight: '700',
                fontFamily: "'Amble', sans-serif",
            },
        },
        colors: ['#0078da', '#204b76', '#cfcfcf'],
        series: [{
                type: 'pie',
                data: [
                    { name: translate('components.charts.flexion'), y: flexion },
                    { name: translate('components.charts.rotation'), y: rotation },
                    { name: translate('components.charts.tilt'), y: tilt },
                ],
            }],
        tooltip: {
            enabled: false,
        },
    };
    return React.createElement(BaseChart, { options: chartConfig });
};

const CHUNK_DIFF_MINUTES$1 = 8;
const getChunks$1 = (swings) => {
    if (!swings.length) {
        return [];
    }
    let lastDateTime = new Date(swings[0].datetime);
    let chunkIndex = 0;
    const chunks = [[swings[0]]];
    for (let i = 1; i < swings.length; i++) {
        const swing = swings[i];
        const swingDateTime = new Date(swing.datetime);
        const minutesDiff = (swingDateTime.getTime() - lastDateTime.getTime()) / (1000 * 60);
        if (minutesDiff > CHUNK_DIFF_MINUTES$1) {
            chunkIndex += 1;
            chunks[chunkIndex] = [swing];
        }
        else {
            chunks[chunkIndex].push(swing);
        }
        lastDateTime = swingDateTime;
    }
    return chunks;
};
const getChartConfig$1 = (translate, chunk, isFirst, maxMagnitude, height) => {
    var _a, _b;
    return ({
        chart: {
            type: 'column',
            marginRight: 15,
            height,
        },
        title: {
            text: undefined,
        },
        yAxis: {
            title: {
                text: translate('components.charts.rotation-speed-degs'),
            },
            lineWidth: 1,
            gridLineColor: 'transparent',
            lineColor: styles.theme.fontColors.silverChalice,
            visible: isFirst,
            min: 0,
            max: maxMagnitude,
            offset: isFirst ? 15 : undefined,
        },
        xAxis: {
            type: 'datetime',
            labels: {
                enabled: false,
            },
            lineColor: styles.theme.fontColors.silverChalice,
            tickWidth: 0,
            title: {
                useHTML: true,
                text: `${militaryTimeTranslate(translate, chunk.map((s) => s.datetime).reduce((a, b) => (a < b ? a : b)), true, (_a = chunk[0]) === null || _a === void 0 ? void 0 : _a.timezonename)}–
            <br/>${militaryTimeTranslate(translate, chunk.map((s) => s.datetime).reduce((a, b) => (a > b ? a : b)), true, (_b = chunk[0]) === null || _b === void 0 ? void 0 : _b.timezonename)}`,
                style: {
                    whiteSpace: 'nowrap',
                    fontSize: '11px',
                },
            },
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            column: {
                pointWidth: 1,
                color: styles.theme.border.alto,
                dataLabels: {
                    overflow: 'allow',
                    allowOverlap: true,
                    crop: false,
                    enabled: true,
                    useHTML: true,
                    formatter() {
                        return '<div style="height: 6px; width: 6px; background-color: #254C75; border-radius: 9999px;" />';
                    },
                    y: 10,
                },
            },
        },
        legend: {
            enabled: false,
        },
        series: [{
                type: 'column',
                data: chunk.map((s) => ({
                    x: new Date(s.datetime).getTime(),
                    y: s.magnitude,
                })),
            }],
    });
};
const getTimeGaps$1 = (chunks) => {
    const timeGaps = chunks.map((chunk) => new Date(chunk[chunk.length - 1].datetime).getTime() - new Date(chunk[0].datetime).getTime());
    const timeGapSum = timeGaps.reduce((sum, v) => (sum + v), 0);
    const newTimeGaps = timeGaps.map((g, i) => Math.max(g, timeGapSum * (i ? 0.15 : 0.3)));
    const newTimeGapSum = newTimeGaps.reduce((sum, v) => (sum + v), 0);
    return { timeGaps: newTimeGaps, timeGapSum: newTimeGapSum };
};
const SwingTimelineChart = ({ swings, height = 350 }) => {
    const { t: translate } = useTranslation();
    const chunks = getChunks$1(swings);
    const maxMagnitude = Math.max(...swings.map((s) => s.magnitude));
    const { timeGaps, timeGapSum } = getTimeGaps$1(chunks);
    return (React.createElement("div", { className: "d-flex" }, chunks.map((chunk, index) => (React.createElement("div", { style: { width: `calc(100% * ${timeGaps[index] / timeGapSum}` }, key: chunk[0].swingid },
        React.createElement(BaseChart, { options: getChartConfig$1(translate, chunk, index === 0, maxMagnitude, height) }))))));
};

const THROW_TYPES = {
    game: 1,
    bullpen: 2,
    warmup: 3,
    other: 4,
};
const CHUNK_DIFF_MINUTES = 8;
const getPregameChunks = (throws) => {
    if (!throws.length) {
        return [];
    }
    let lastDateTime = new Date(throws[0].datetime);
    let chunkIndex = 0;
    const chunks = [[throws[0]]];
    for (let i = 1; i < throws.length; i++) {
        const t = throws[i];
        const throwDateTime = new Date(t.datetime);
        const minutesDiff = (throwDateTime.getTime() - lastDateTime.getTime()) / (1000 * 60);
        if (minutesDiff > CHUNK_DIFF_MINUTES) {
            chunkIndex += 1;
            chunks[chunkIndex] = [t];
        }
        else {
            chunks[chunkIndex].push(t);
        }
        lastDateTime = throwDateTime;
    }
    return chunks;
};
const getGameChunks = (throws) => {
    var _a;
    if (!throws.length)
        return [];
    let currentInning = (_a = throws[0].inning) !== null && _a !== void 0 ? _a : null;
    let chunkIndex = 0;
    const chunks = [[throws[0]]];
    for (let i = 0; i < throws.length; i++) {
        const t = throws[i];
        if (t.inning !== currentInning) {
            chunkIndex += 1;
            chunks[chunkIndex] = [t];
        }
        else {
            chunks[chunkIndex].push(t);
        }
        currentInning = t.inning;
    }
    return chunks;
};
const getChunks = (throws) => {
    if (!throws.length) {
        return [];
    }
    const firstWarmupIndex = throws.findIndex((t) => t.throwtype === THROW_TYPES.game || t.throwtype === THROW_TYPES.warmup);
    if (firstWarmupIndex >= 0) {
        const pregamePitches = throws.slice(0, firstWarmupIndex);
        const gamePitches = throws.slice(firstWarmupIndex, throws.length);
        return [...getPregameChunks(pregamePitches), ...getGameChunks(gamePitches)];
    }
    return getPregameChunks(throws);
};
const getTitle = (inning) => (inning ? `Inn ${inning}` : '&nbsp;');
const getChartConfig = (translate, chunk, isFirst, height) => {
    var _a, _b, _c, _d;
    return ({
        chart: {
            type: 'column',
            marginRight: 15,
            height,
        },
        title: {
            useHTML: !((_a = chunk.find((t) => t.inning)) === null || _a === void 0 ? void 0 : _a.inning),
            text: getTitle((_b = chunk.find((t) => t.inning)) === null || _b === void 0 ? void 0 : _b.inning),
            style: {
                fontFamily: '"Amble", sans-serif',
                fontSize: '14px',
                fontWeight: '700',
                whiteSpace: 'nowrap',
            },
        },
        yAxis: {
            title: {
                text: translate('components.charts.throw-intensity'),
            },
            lineWidth: 1,
            gridLineColor: 'transparent',
            lineColor: styles.theme.fontColors.silverChalice,
            visible: isFirst,
            min: 0,
            max: 100,
            offset: isFirst ? 15 : undefined,
        },
        xAxis: {
            type: 'datetime',
            labels: {
                enabled: false,
            },
            lineColor: styles.theme.fontColors.silverChalice,
            tickWidth: 0,
            title: {
                useHTML: true,
                text: `${militaryTimeTranslate(translate, chunk.map((s) => s.datetime).reduce((a, b) => (a < b ? a : b)), true, (_c = chunk[0]) === null || _c === void 0 ? void 0 : _c.timezonename)}–
            <br />${militaryTimeTranslate(translate, chunk.map((s) => s.datetime).reduce((a, b) => (a > b ? a : b)), true, (_d = chunk[0]) === null || _d === void 0 ? void 0 : _d.timezonename)}`,
                style: {
                    whiteSpace: 'nowrap',
                    fontSize: '11px',
                },
            },
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            column: {
                pointWidth: 1,
                maxPointWidth: 1,
                color: styles.theme.border.alto,
                dataLabels: {
                    overflow: 'allow',
                    allowOverlap: true,
                    crop: false,
                    enabled: true,
                    useHTML: true,
                    formatter() {
                        return `<div 
                            style="
                                height: 6px;
                                width: 6px;
                                background-color: ${this.point.options.throwtype === THROW_TYPES.game ? '#FF0000' : '#254C75'};
                                border-radius: 9999px;
                            " />`;
                    },
                    y: 10,
                },
            },
        },
        legend: {
            enabled: false,
        },
        series: [{
                type: 'column',
                data: chunk.map((s) => ({
                    x: new Date(s.datetime).getTime(),
                    y: s.intensity * 100,
                    throwtype: s.throwtype,
                })),
            }],
    });
};
const getTimeGaps = (chunks) => {
    const timeGaps = chunks.map((chunk) => new Date(chunk[chunk.length - 1].datetime).getTime() - new Date(chunk[0].datetime).getTime());
    const timeGapSum = timeGaps.reduce((sum, v) => (sum + v), 0);
    const newTimeGaps = timeGaps.map((g, i) => Math.max(g, timeGapSum * (i ? 0.15 : 0.26)));
    const newTimeGapSum = newTimeGaps.reduce((sum, v) => (sum + v), 0);
    return { timeGaps: newTimeGaps, timeGapSum: newTimeGapSum };
};
const ThrowTimelineChart = ({ throws, height = 350 }) => {
    const { t: translate } = useTranslation();
    const chunks = getChunks(throws);
    const { timeGaps, timeGapSum } = getTimeGaps(chunks);
    return (React.createElement("div", { className: "d-flex" }, chunks.map((chunk, index) => (React.createElement("div", { style: { width: `calc(100% * ${timeGaps[index] / timeGapSum}` }, key: chunk[0].throwid },
        React.createElement(BaseChart, { options: getChartConfig(translate, chunk, index === 0, height) }))))));
};

/* eslint-disable no-mixed-operators */
function seamOrientationSeriesify(data, seamCt, radius, fillColor) {
    const seriesData = {
        type: 'scatter',
        data: data ? data.map((row) => ({
            x: seamCt === 2 ? row.axis_x_2s : row.axis_x_4s,
            y: seamCt === 2 ? row.axis_z_2s : row.axis_z_4s,
            gamedate: date(row.gamedate),
            awayteam: row.awayteam,
            hometeam: row.hometeam,
            battername: row.battername,
            balls: row.balls,
            strikes: row.strikes,
            inning: row.inning,
        })) : null,
        marker: { radius, fillColor },
        color: fillColor,
    };
    return seriesData;
}
function renderBaseballSeams(chart, seamCt) {
    const ball = {
        x: 0,
        y: 0,
        r: 1,
    };
    const innerCircleAttr = {
        'stroke-width': 1,
        stroke: '#CCCCCC',
        fill: 'none',
        zIndex: 1,
    };
    const circleAttr = {
        'stroke-width': 1,
        stroke: '#777777',
        fill: 'none',
    };
    const seamsPathTop = new Array();
    const seamsPathBottom = new Array();
    const seamsPath2S = new Array();
    const Ff = 1;
    const B = 0.45;
    for (let i = 0; i <= 360; i++) {
        const alpha = i * Math.PI / 180;
        const x = Math.cos(alpha) - B * Math.cos(3 * alpha);
        const y = Math.sin(alpha) + B * Math.sin(3 * alpha);
        const z = Ff * Math.cos(2 * alpha);
        const r = Math.sqrt(1 + B * B + (Ff * Ff - 2 * B) * Math.cos(2 * alpha) * Math.cos(2 * alpha) + 2 * B * Math.sin(2 * alpha) * Math.sin(2 * alpha));
        const xNorm = ball.r * (x / r);
        const yNorm = ball.r * (y / r);
        const zNorm = ball.r * (z / r);
        if (zNorm < 0 && yNorm > 0 && seamsPathTop.length === 0) {
            seamsPathTop.push('M');
            seamsPathTop.push(chart.xAxis[0].toPixels(xNorm, false));
            seamsPathTop.push(chart.yAxis[0].toPixels(yNorm, false));
            seamsPathTop.push('L');
        }
        else if (zNorm < 0 && yNorm < 0 && seamsPathBottom.length === 0) {
            seamsPathBottom.push('M');
            seamsPathBottom.push(chart.xAxis[0].toPixels(xNorm, false));
            seamsPathBottom.push(chart.yAxis[0].toPixels(yNorm, false));
            seamsPathBottom.push('L');
        }
        else if (zNorm < 0 && yNorm > 0) {
            seamsPathTop.push(chart.xAxis[0].toPixels(xNorm, false));
            seamsPathTop.push(chart.yAxis[0].toPixels(yNorm, false));
        }
        else if (zNorm < 0 && yNorm < 0) {
            seamsPathBottom.push(chart.xAxis[0].toPixels(xNorm, false));
            seamsPathBottom.push(chart.yAxis[0].toPixels(yNorm, false));
        }
        if (yNorm < 0 && seamsPath2S.length === 0) {
            seamsPath2S.push('M');
            seamsPath2S.push(chart.xAxis[0].toPixels(zNorm, false));
            seamsPath2S.push(chart.yAxis[0].toPixels(xNorm, false));
            seamsPath2S.push('L');
        }
        if (yNorm < 0) {
            seamsPath2S.push(chart.xAxis[0].toPixels(zNorm, false));
            seamsPath2S.push(chart.yAxis[0].toPixels(xNorm, false));
        }
    }
    chart.renderer.circle(chart.xAxis[0].toPixels(ball.x, false), chart.yAxis[0].toPixels(ball.y, false), chart.xAxis[0].toPixels(ball.r, false) - chart.xAxis[0].toPixels(0, false)).attr(circleAttr).add();
    if (seamCt === 4) {
        chart.renderer.circle(chart.xAxis[0].toPixels(ball.x, false), chart.yAxis[0].toPixels(ball.y, false), chart.xAxis[0].toPixels(0.6, false) - chart.xAxis[0].toPixels(0, false)).attr(innerCircleAttr).add();
        chart.renderer.circle(chart.xAxis[0].toPixels(ball.x, false), chart.yAxis[0].toPixels(ball.y, false), chart.xAxis[0].toPixels(0.33, false) - chart.xAxis[0].toPixels(0, false)).attr(innerCircleAttr).add();
        chart.renderer.path(seamsPathTop).attr(circleAttr).add();
        chart.renderer.path(seamsPathBottom).attr(circleAttr).add();
    }
    else if (seamCt === 2) {
        chart.renderer.path(seamsPath2S).attr(circleAttr).add();
        const seamsPath2SLines1 = new Array();
        seamsPath2SLines1.push('M');
        seamsPath2SLines1.push(chart.xAxis[0].toPixels(1, false));
        seamsPath2SLines1.push(chart.yAxis[0].toPixels(0, false));
        seamsPath2SLines1.push('L');
        seamsPath2SLines1.push(chart.xAxis[0].toPixels(-1, false));
        seamsPath2SLines1.push(chart.yAxis[0].toPixels(0, false));
        chart.renderer.path(seamsPath2SLines1).attr(innerCircleAttr).add();
        const seamsPath2SLines2 = new Array();
        seamsPath2SLines2.push('M');
        seamsPath2SLines2.push(chart.xAxis[0].toPixels(0, false));
        seamsPath2SLines2.push(chart.yAxis[0].toPixels(1, false));
        seamsPath2SLines2.push('L');
        seamsPath2SLines2.push(chart.xAxis[0].toPixels(0, false));
        seamsPath2SLines2.push(chart.yAxis[0].toPixels(-1, false));
        chart.renderer.path(seamsPath2SLines2).attr(innerCircleAttr).add();
    }
}
const SeamOrientationChart = ({ seamOrientationData, seamOrientationAllData, onClick, height = 350, width = 350, minX = -1.1, maxX = 1.1, minY = -1.1, maxY = 1.1, oppositeY = false, enableZoom = false, turboThreshold = 10000, seamCt = 4, title = null, }) => {
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        const chart = ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        renderBaseballSeams(chart, seamCt);
    }, [ref, seamOrientationData, seamCt]); // eslint-disable-line react-hooks/exhaustive-deps
    const legendConfig = { enabled: false };
    let fgRadius = 1.25;
    if (seamOrientationData.length > 50 && seamOrientationData.length < 150)
        fgRadius = 2.25;
    if (seamOrientationData.length <= 50)
        fgRadius = 3.25;
    const seriesData = seamOrientationSeriesify(seamOrientationData, seamCt, fgRadius, 'rgba(55, 117, 255, 0.75)');
    const seriesAllData = seamOrientationSeriesify(seamOrientationAllData, seamCt, 1, 'rgba(155, 155, 155, 0.35)');
    seriesAllData.enableMouseTracking = false;
    const chartConfig = {
        chart: {
            type: 'scatter',
            height,
            width,
            backgroundColor: undefined,
            zoomType: enableZoom ? 'xy' : undefined,
        },
        title: {
            text: title,
        },
        colors: ['#3366FF', '#BF0B23', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
        plotOptions: {
            series: {
                marker: {
                    radius: 2,
                    symbol: 'circle',
                },
                stickyTracking: false,
                point: {
                    events: {
                        click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (onClick)
                                    return onClick(this);
                            }
                            return null;
                        },
                    },
                },
                turboThreshold,
            },
        },
        legend: legendConfig,
        xAxis: {
            min: minX,
            max: maxX,
            gridLineWidth: 0,
            tickInterval: 1,
            tickLength: 6,
            minorTickInterval: 0.25,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            minPadding: 0,
            maxPadding: 0,
        },
        yAxis: {
            min: minY,
            max: maxY,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 1,
            tickLength: 6,
            minorTickInterval: 0.25,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: oppositeY,
            title: {
                text: null,
            },
        },
        tooltip: {
            formatter() {
                var _a, _b, _c, _d, _e, _f, _g;
                // eslint-disable-next-line max-len
                return `<b>${(_a = this.point) === null || _a === void 0 ? void 0 : _a.gamedate} ${(_b = this.point) === null || _b === void 0 ? void 0 : _b.awayteam} @ ${(_c = this.point) === null || _c === void 0 ? void 0 : _c.hometeam}</b><br />Batter: ${(_d = this.point) === null || _d === void 0 ? void 0 : _d.battername}<br />${(_e = this.point) === null || _e === void 0 ? void 0 : _e.inning} Inn ${(_f = this.point) === null || _f === void 0 ? void 0 : _f.balls}-${(_g = this.point) === null || _g === void 0 ? void 0 : _g.strikes} Count`;
            },
            shared: true,
        },
        series: [seriesAllData, seriesData],
    };
    return (React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false }));
};

const Container$5 = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
// eslint-disable-next-line max-len
const getAverageSeries = (pitches, key, name, fillColor, visible, symbol) => {
    const x = pitches.reduce((acc, p) => acc + parseFloat(p[`${key}x`]), 0.0) / pitches.length;
    const y = pitches.reduce((acc, p) => acc + parseFloat(p[`${key}z`]), 0.0) / pitches.length;
    const series = {
        type: 'scatter',
        name,
        data: [{ x, y }],
        marker: { symbol, radius: 5, fillColor, lineColor: 'rgba(0, 0, 0, 0.75)', lineWidth: 1 },
        zIndex: 99,
        visible,
        color: fillColor,
    };
    return series;
};
const seriesTypes$1 = [
    { name: 'components.charts.drag', key: 'drag_break', fillColor: '#CC0000', ismlb: true, visible: true, symbol: 'circle' },
    { name: 'components.charts.magnus', key: 'magnus_break', fillColor: '#0000CC', ismlb: true, visible: true, symbol: 'circle' },
    { name: 'components.charts.seam', key: 'seam_break', fillColor: '#006600', ismlb: true, visible: true, symbol: 'circle' },
    { name: 'components.charts.total', key: 'total_break', fillColor: '#444444', ismlb: true, visible: true, symbol: 'circle' },
    { name: 'components.charts.drag', key: 'drag_break', fillColor: '#CC2222', ismlb: false, visible: true, symbol: 'diamond' },
    { name: 'components.charts.magnus', key: 'magnus_break', fillColor: '#2222CC', ismlb: false, visible: true, symbol: 'diamond' },
    { name: 'components.charts.seam', key: 'seam_break', fillColor: '#226622', ismlb: false, visible: true, symbol: 'diamond' },
    { name: 'components.charts.total', key: 'total_break', fillColor: '#666666', ismlb: false, visible: true, symbol: 'diamond' },
];
const mapPitchesToSeries$2 = (translate, pitches) => {
    const series = [];
    seriesTypes$1.forEach((ser) => {
        const name = `${ser.ismlb ? 'MLB' : 'MILB'} ${translate(ser.name)}`;
        let bgRadius = 0.75;
        if (pitches.filter((p) => p.ismlb === ser.ismlb).length < 125)
            bgRadius = 1.25;
        if (pitches.filter((p) => p.ismlb === ser.ismlb).length > 0) {
            series.push(getAverageSeries(pitches.filter((p) => p.ismlb === ser.ismlb), ser.key, name, `${ser.fillColor}99`, ser.visible, ser.symbol));
            series.push({
                type: 'scatter',
                name,
                data: pitches ? pitches.filter((p) => p.ismlb === ser.ismlb).map((row) => ({
                    x: row[`${ser.key}x`],
                    y: row[`${ser.key}z`],
                })) : [],
                marker: { symbol: ser.symbol, radius: ser.ismlb ? bgRadius : 1.33 * bgRadius, fillColor: `${ser.fillColor}55` },
                color: ser.fillColor,
                visible: ser.visible,
                showInLegend: false,
                linkedTo: ':previous',
            });
        }
    });
    return series;
};
const BreakComponentsChart = ({ pitches, videoPlayerModal: VideoPlayerModal, pitchVideoFn, modalContainer, minX = null, minY = null, maxX = null, maxY = null, height = 210, width = 210, enableZoom = true, showlegend = false, title = null, turboThreshold = 10000, isCurrentLevelMLB = true, }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const labelXuse = translate('components.charts.break-x-in');
    const labelYuse = translate('components.charts.break-z-in');
    seriesTypes$1.forEach((ser) => {
        ser.visible = ser.ismlb === isCurrentLevelMLB;
    });
    if (!(pitches === null || pitches === void 0 ? void 0 : pitches.length)) {
        return React.createElement(Container$5, { style: { width } },
            React.createElement("em", null, translate('components.charts.no-pitches')));
    }
    const pitchSeries = mapPitchesToSeries$2(translate, pitches);
    const xAbsVals = pitchSeries.flatMap(({ data }) => data.map(({ x }) => Math.abs(x || 0)));
    const yAbsVals = pitchSeries.flatMap(({ data }) => data.map(({ y }) => Math.abs(y || 0)));
    const chartScale = Math.max(...xAbsVals, ...yAbsVals) + 1;
    const fetchPitchVideo = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
        setVideoPlaylist(playlist);
    });
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const chartConfig = {
        chart: {
            type: 'scatter',
            animation: false,
            plotBorderWidth: 1,
            zoomType: enableZoom ? 'xy' : undefined,
            backgroundColor: undefined,
            height,
            width,
        },
        title: {
            text: title,
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            scatter: {
                animation: false,
                stickyTracking: false,
                marker: {
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: '#000',
                        },
                    },
                },
            },
            series: {
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq);
                            }
                        },
                    },
                },
                turboThreshold,
            },
        },
        legend: {
            enabled: showlegend,
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
        },
        xAxis: {
            min: minX != null ? minX : -chartScale,
            max: maxX != null ? maxX : chartScale,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 3,
            tickLength: 6,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: false,
            title: {
                text: labelXuse,
            },
            plotLines: [{
                    color: 'lightgrey',
                    value: 0,
                    width: 1,
                }],
        },
        yAxis: {
            min: minY != null ? minY : -chartScale,
            max: maxY != null ? maxY : chartScale,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 3,
            tickLength: 6,
            minorTickInterval: 3,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: false,
            title: {
                text: labelYuse,
            },
            plotLines: [{
                    color: 'lightgrey',
                    value: 0,
                    width: 1,
                }],
        },
        tooltip: {
            formatter() {
                return `<b>${this.series.name}</b><br><b>${labelXuse}: </b>${format(this.x, 2)}";<br><b>${labelYuse}: </b>${format(this.y, 2)}"`;
            },
            shared: true,
        },
        series: pitchSeries,
    };
    return (React.createElement(Container$5, null,
        pitchVideoFn && VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false })));
};

const Container$4 = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
const seriesTypes = [
    { name: 'baseball.pitches.fastball-2-alt', key: 'fb2', pitchtype: 9, fillColor: 'rgba(255, 0, 0, 0.5)' },
    { name: 'baseball.pitches.fastball-4-alt', key: 'fb4', pitchtype: 10, fillColor: 'rgba(0, 0, 255, 0.5)' },
    { name: 'baseball.pitches.cutter', key: 'ct', pitchtype: 8, fillColor: 'rgba(0, 100, 0, 0.5)' },
    { name: 'baseball.pitches.changeup_one', key: 'ch', pitchtype: 4, fillColor: 'rgba(0, 0, 0, 0.5)' },
    { name: 'baseball.pitches.splitter', key: 'sp', pitchtype: 7, fillColor: 'rgba(100, 0, 100, 0.5)' },
];
const mapPitchesToSeries$1 = (translate, pitches, lines, ismlb, playerid, yearid) => {
    const series = [];
    seriesTypes.forEach((ser) => {
        const p = pitches.filter((x) => x.fxtype === ser.pitchtype && x.ismlb === ismlb);
        let player = pitches.filter((x) => x.fxtype === ser.pitchtype && x.ismlb === ismlb && x.pitcherid === playerid);
        let playerPrevYear = [];
        if (yearid !== null) {
            playerPrevYear = player.filter((x) => x.yearid !== yearid);
            player = player.filter((x) => x.yearid === yearid);
        }
        const seriesColorString = pitchTypeColor(ser.pitchtype, translate);
        if (p.length > 0) {
            if (player.length > 0) {
                series.push({
                    type: 'scatter',
                    name: translate(ser.name),
                    data: player.map((row) => ({
                        x: row.gyrodegree,
                        y: row.total_perp_break,
                        pitchername: row.pitchername,
                        yearid: row.yearid,
                    })),
                    marker: { radius: 7, fillColor: seriesColorString, lineColor: 'rgba(0, 0, 0, 0.75)', lineWidth: 1 },
                    color: seriesColorString,
                    showInLegend: true,
                    zIndex: 99,
                });
            }
            else {
                series.push({
                    type: 'scatter',
                    name: translate(ser.name),
                    data: [],
                    marker: { radius: 7, fillColor: seriesColorString, lineColor: 'rgba(0, 0, 0, 0.75)', lineWidth: 1 },
                    color: seriesColorString,
                    showInLegend: true,
                    zIndex: 99,
                });
            }
            if (playerPrevYear.length > 0) {
                series.push({
                    type: 'scatter',
                    name: translate(ser.name),
                    data: playerPrevYear.map((row) => ({
                        x: row.gyrodegree,
                        y: row.total_perp_break,
                        pitchername: row.pitchername,
                        yearid: row.yearid,
                    })),
                    marker: { symbol: 'triangle', radius: 7, fillColor: `${seriesColorString}CC`, lineColor: 'rgba(0, 0, 0, 0.75)', lineWidth: 1 },
                    color: `${seriesColorString}CC`,
                    showInLegend: false,
                    linkedTo: ':previous',
                    zIndex: 98,
                });
            }
            series.push({
                type: 'scatter',
                name: translate(ser.name),
                data: p.map((row) => ({
                    x: row.gyrodegree,
                    y: row.total_perp_break,
                    pitchername: row.pitchername,
                })),
                marker: { radius: 0.75, fillColor: `${seriesColorString}88` },
                color: `${seriesColorString}88`,
                showInLegend: false,
                linkedTo: ':previous',
            });
            series.push({
                type: 'scatter',
                name: `${translate(ser.name)} ${translate('common.abbr-average')}`,
                data: lines.map((row) => ({
                    x: row.gyrodegree,
                    y: row[`${ser.key}_${ismlb ? 'mlb' : 'milb'}`],
                    pitchername: 'League Average',
                })),
                marker: { radius: 1, fillColor: seriesColorString },
                color: seriesColorString,
                showInLegend: true,
            });
        }
    });
    return series;
};
const GyroSeamChart = ({ pitches, lines, videoPlayerModal: VideoPlayerModal, pitchVideoFn, modalContainer, minX = null, minY = null, maxX = null, maxY = null, height = 210, width = 210, enableZoom = true, showlegend = false, title = null, ismlb = true, playerid, turboThreshold = 10000, yearid = null, }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const labelXuse = translate('components.charts.gyro-degree');
    const labelYuse = translate('components.charts.signed-seam-break');
    if (!(pitches === null || pitches === void 0 ? void 0 : pitches.length)) {
        return React.createElement(Container$4, { style: { width } },
            React.createElement("em", null, translate('components.charts.no-pitches')));
    }
    const pitchSeries = mapPitchesToSeries$1(translate, pitches, lines, ismlb, playerid, yearid);
    const xAbsVals = pitchSeries.flatMap(({ data }) => data.map(({ x }) => Math.abs(x || 0)));
    const yAbsVals = pitchSeries.flatMap(({ data }) => data.map(({ y }) => Math.abs(y || 0)));
    const chartScale = Math.max(...xAbsVals, ...yAbsVals) + 1;
    const fetchPitchVideo = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
        setVideoPlaylist(playlist);
    });
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const chartConfig = {
        chart: {
            type: 'scatter',
            animation: false,
            plotBorderWidth: 1,
            zoomType: enableZoom ? 'xy' : undefined,
            backgroundColor: undefined,
            height,
            width,
        },
        title: {
            text: title,
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            scatter: {
                animation: false,
                stickyTracking: false,
                marker: {
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: '#000',
                        },
                    },
                },
            },
            series: {
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq);
                            }
                        },
                    },
                },
                turboThreshold,
            },
        },
        legend: {
            enabled: showlegend,
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
        },
        xAxis: {
            min: minX != null ? minX : -chartScale,
            max: maxX != null ? maxX : chartScale,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 3,
            tickLength: 6,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: false,
            title: {
                text: labelXuse,
            },
            plotLines: [{
                    color: 'lightgrey',
                    value: 0,
                    width: 1,
                }],
            reversed: true,
        },
        yAxis: {
            min: minY != null ? minY : -chartScale,
            max: maxY != null ? maxY : chartScale,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 3,
            tickLength: 6,
            minorTickInterval: 3,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: false,
            title: {
                text: labelYuse,
            },
            plotLines: [{
                    color: 'lightgrey',
                    value: 0,
                    width: 1,
                }],
        },
        tooltip: {
            formatter() {
                var _a, _b, _c;
                // eslint-disable-next-line max-len
                return `<b>Pitch Type: </b>${((_a = this.point) === null || _a === void 0 ? void 0 : _a.yearid) || ''} ${(_b = this.series) === null || _b === void 0 ? void 0 : _b.name}<br><b>Pitcher: </b>${(_c = this.point) === null || _c === void 0 ? void 0 : _c.pitchername}<br><b>${labelXuse}: </b>${format(this.x, 0)}&deg;<br><b>${labelYuse}: </b>${format(this.y, 2)}"`;
            },
            shared: true,
        },
        series: pitchSeries,
    };
    return (React.createElement(Container$4, null,
        pitchVideoFn && VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { immutable: true, ref: ref, width: width, options: chartConfig, useBodyFont: false })));
};

const StyledContainer$2 = styled.div `
    width: ${(props) => props.width}px;
    height: ${(props) => props.height}px;
`;
const ThreeSixtyBreakdownChart = ({ onClick, height = 55, width = 55, filterdata, }) => {
    const ref = useRef(null);
    const chartConfig = {
        chart: {
            plotBackgroundColor: undefined,
            plotBorderWidth: undefined,
            plotShadow: false,
            type: 'pie',
            height,
            width,
        },
        title: {
            text: undefined,
        },
        tooltip: {
            enabled: false,
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                startAngle: -112.5,
                colors: [
                    '#FFFFFF',
                    '#FFFFFF',
                    '#FFFFFF',
                    '#FFFFFF',
                    '#FFFFFF',
                    '#FFFFFF',
                    '#FFFFFF',
                    '#FFFFFF',
                ],
                borderColor: '#002255',
                dataLabels: {
                    enabled: false,
                },
                size: height - 6,
            },
        },
        series: [
            {
                type: 'pie',
                animation: false,
                colorByPoint: true,
                slicedOffset: 0,
                data: [
                    { name: '1', y: 45, states: { select: { color: '#b4cef5' } } },
                    { name: '2', y: 45, states: { select: { color: '#b4cef5' } } },
                    { name: '3', y: 45, states: { select: { color: '#b4cef5' } } },
                    { name: '4', y: 45, states: { select: { color: '#b4cef5' } } },
                    { name: '5', y: 45, states: { select: { color: '#b4cef5' } } },
                    { name: '6', y: 45, states: { select: { color: '#b4cef5' } } },
                    { name: '7', y: 45, states: { select: { color: '#b4cef5' } } },
                    { name: '8', y: 45, states: { select: { color: '#b4cef5' } } },
                ],
                events: {
                    click(event) {
                        const value = event.point.x + 1;
                        onClick(value);
                    },
                },
            },
        ],
    };
    function redraw() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        if (chart && chart.series.length > 0 && chart.series[0].points) {
            chart.getSelectedPoints().forEach((p) => p.select(false));
            chart.series[0].points.forEach((p) => {
                if (filterdata.includes(Number(p.name))) {
                    p.select(true, true);
                }
            });
            chart.redraw();
        }
    }
    useEffect(() => {
        redraw();
    }, [ref, filterdata]); // eslint-disable-line react-hooks/exhaustive-deps
    return (React.createElement(StyledContainer$2, { width: width, height: height },
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false })));
};

/* eslint-disable camelcase */
const ChartDiv = styled.div `
    display: flex;
    flex-wrap: wrap;
`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const buildSeriesData = (stats, player, percentiles) => [{
        data: stats.map((s) => {
            if (s.key) {
                let y = null;
                if (player[`${s.key}_ntile`])
                    y = s.reversed ? 100 - player[`${s.key}_ntile`] : player[`${s.key}_ntile`];
                return (Object.assign(Object.assign({}, s), { value: s.formatter(player[s.key]), y, ntileData: {
                        percentile: format(s.reversed ? 100 - player[`${s.key}_ntile`] : player[`${s.key}_ntile`], 0),
                        statname: s.name,
                        p25: s.formatter(percentiles[`${s.key}_p${s.reversed ? '75' : '25'}`]),
                        p50: s.formatter(percentiles[`${s.key}_p50`]),
                        p75: s.formatter(percentiles[`${s.key}_p${s.reversed ? '25' : '75'}`]),
                    } }));
            }
            return null;
        }).filter((x) => x),
    }];
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
const PitcherStrengthsPercentiles = ({ className = '', overview, statTooltip, }) => {
    const { player, percentiles } = overview;
    const { t: translate } = useTranslation();
    const overallChart = [{
            key: 'hitfxera',
            formatter: (v) => (v != null ? format(v, 2) : '--'),
            name: translate('sections.reports.pitcher.hitfx-era'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 2,
            statistic: 'HitFX2ERA',
        }, {
            key: 'ubbrate',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.walk-percentage'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 1,
            statistic: 'UBBPercent',
        }, {
            key: 'krate',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.strikeout-percentage'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'KPercent',
        }, {
            key: 'cq',
            formatter: (v) => (v != null ? format(v, 1) : '--'),
            name: translate('sections.reports.pitcher.contact-quality'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 1,
            statistic: 'ContactQuality',
        }, {
            key: 'pitchfxera',
            formatter: (v) => (v != null ? format(v, 2) : '--'),
            name: translate('sections.reports.pitcher.pitchfx-era'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 2,
            statistic: 'PitchFXERA',
        }, {
            key: 'stuffera',
            formatter: (v) => (v != null ? format(v, 2) : '--'),
            name: translate('sections.reports.pitcher.stuff-era'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 2,
            statistic: 'StuffERA',
        }, {
            key: 'breakera',
            formatter: (v) => (v != null ? format(v, 2) : '--'),
            name: translate('sections.reports.pitcher.break-era'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 2,
            statistic: 'BreakERA',
        }, {
            key: 'locera',
            formatter: (v) => (v != null ? format(v, 2) : '--'),
            name: translate('sections.reports.pitcher.location-era'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 2,
            statistic: 'LocERA',
        }];
    const controllingTheZone = [overallChart[1], {
            key: 'stk',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.strike-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'Stk',
        }, {
            key: 'kzon',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.kzon-pct'),
            units: '%',
            lowText: 'Low',
            highText: 'High',
            precision: 1,
            statistic: 'KZon',
        }, {
            key: 'firstpstk',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.first-pitch-strike-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: '1PitStk',
        }, {
            key: 'wayahead',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.way-ahead'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'WayAhead',
        }, {
            key: 'closepitch',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.close-pitch-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'ClosePitch',
        }, {
            key: 'wastepitch',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.waste-pitch-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 1,
            statistic: 'WastedPitPercent',
        }];
    const missingBats = [overallChart[2], {
            key: 'ms',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.miss-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'Ms',
        }, {
            key: 'msinz',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.miss-in-zone-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'MsInZon',
        }, {
            key: 'tkstk',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.called-stk-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'CalledStk',
        }, {
            key: 'ch',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.chase-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'Ch',
        }, {
            key: 'putaway',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.put-away-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'PutAwayPct',
        }];
    const limitingDamage = [overallChart[3], {
            key: 'cr',
            formatter: (v) => (v != null ? format(v, 1) : '--'),
            name: translate('sections.reports.pitcher.contact-results'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 1,
            statistic: 'ContactResults',
        }, {
            key: 'gb',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('baseball.abbr-groundball-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'GBPercent',
        }, {
            key: 'pop',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.popup-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            precision: 1,
            statistic: 'PopPercent',
        }, {
            key: 'hitvelocity',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.exit-velo'),
            units: 'mph',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 1,
            statistic: 'ExitVelo',
        }, {
            key: 'wellhit',
            formatter: (v) => (v != null ? format(v, 0) : '--'),
            name: translate('sections.reports.pitcher.well-hit-pct'),
            units: '%',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 1,
            statistic: 'WellHitPercent',
        }, {
            key: 'slg',
            formatter: (v) => (v != null ? format(v, true) : '--'),
            name: translate('baseball.abbr-slugging'),
            units: '',
            lowText: 'Poor',
            highText: 'Great',
            reversed: true,
            precision: 3,
            statistic: 'SLG',
        }];
    if (!player || player.length === 0 || !percentiles || percentiles.length === 0) {
        return (React.createElement("div", null, "No Data"));
    }
    return (React.createElement(ChartDiv, { className: `${className} text-center justify-content-around` },
        React.createElement(NtilesChart, { width: 300, height: 450, title: translate('sections.reports.pitcher.overall'), seriesData: buildSeriesData(overallChart, player[0], percentiles[0]), statTooltip: statTooltip }),
        React.createElement(NtilesChart, { width: 300, height: 402, title: translate('sections.reports.pitcher.controlling-the-zone'), seriesData: buildSeriesData(controllingTheZone, player[0], percentiles[0]), statTooltip: statTooltip }),
        React.createElement(NtilesChart, { width: 300, height: 355, title: translate('sections.reports.pitcher.missing-bats'), seriesData: buildSeriesData(missingBats, player[0], percentiles[0]), statTooltip: statTooltip }),
        React.createElement(NtilesChart, { width: 300, height: 402, title: translate('sections.reports.pitcher.limiting-damage'), seriesData: buildSeriesData(limitingDamage, player[0], percentiles[0]), statTooltip: statTooltip })));
};

const StyledCenteredLabel = styled.div `
    text-align: center;
    padding: 2px;
    font-size: 1.5em;
    font-weight: bold;
`;
const StyledBreakdownContainer = styled.div `
    display: table;
    overflow: hidden;
    text-align: center;
`;
const StyledLeftRightLabel = styled.div `
    display: table-cell;
    vertical-align: middle;
    padding: 2px;
    font-size: 1.3em;
    font-weight: bold;
`;
const addSign = (value) => {
    if (value === null || value === undefined)
        return '--';
    const formatted = format(value, 2);
    if (formatted > 0)
        return `+${formatted}`;
    return formatted;
};
const getColor = (value) => {
    if (value === null || value === undefined)
        return 'transparent';
    if (value < -0.05)
        return 'rgba(50, 220, 50, .95)'; // darker green
    if (value >= -0.05 && value <= -0.02)
        return 'rgba(0, 220, 0, .50)'; // lighter green
    if (value > -0.02 && value < 0.02)
        return 'transparent'; // neutral
    if (value >= 0.02 && value <= 0.05)
        return 'rgba(255, 50, 50, .70)'; // lighter red
    if (value > 0.05)
        return 'rgba(255, 50, 50, .95)'; // darker red
    return 'transparent';
};
const isLightGreenOrTransparent = (color) => color === 'transparent' || color.startsWith('rgba(0, 220, 0');
const FirstStepChart = ({ width = 500, forward, back, left, right, }) => {
    const ref = useRef(null);
    const [chartConfig, setChartConfig] = useState({});
    const defaultWidth = 500;
    const defaultHeight = 500;
    const aspectRatio = defaultWidth / defaultHeight;
    const height = width / aspectRatio;
    function redraw() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        if (chart && chart.series.length > 0 && chart.series[0].points) {
            chart.getSelectedPoints().forEach((p) => p.select(false));
            chart.redraw();
        }
    }
    useEffect(() => {
        const forwardColor = getColor(forward.average);
        const leftColor = getColor(left.average);
        const rightColor = getColor(right.average);
        const backColor = getColor(back.average);
        setChartConfig({
            chart: {
                plotBackgroundColor: undefined,
                plotBorderWidth: undefined,
                plotShadow: false,
                type: 'pie',
                height,
                width,
            },
            title: {
                text: undefined,
            },
            tooltip: {
                enabled: false,
            },
            credits: {
                enabled: false,
            },
            plotOptions: {
                pie: {
                    startAngle: -45,
                    colors: [forwardColor, rightColor, backColor, leftColor],
                    borderColor: '#002255',
                    dataLabels: {
                        enabled: true,
                        distance: -50,
                        formatter() {
                            const { point } = this;
                            const value = [forward, right, back, left][point.index].average;
                            const color = isLightGreenOrTransparent([forwardColor, rightColor, backColor, leftColor][point.index]) ? '#000000' : '#FFFFFF';
                            return `<span style="color: ${color}">${addSign(value)}</span>`;
                        },
                        style: {
                            fontSize: '1.3em',
                            fontWeight: 'bold',
                            textOutline: 'none',
                        },
                    },
                    size: 300,
                    enableMouseTracking: false,
                },
            },
            series: [
                {
                    type: 'pie',
                    animation: false,
                    slicedOffset: 0,
                    data: [
                        { name: '1', y: 45 },
                        { name: '2', y: 45 },
                        { name: '3', y: 45 },
                        { name: '4', y: 45 },
                    ],
                },
            ],
        });
        redraw();
    }, [forward, back, left, right]); // eslint-disable-line react-hooks/exhaustive-deps
    return (React.createElement("div", { className: "d-flex flex-column justify-content-center" },
        React.createElement(StyledCenteredLabel, null,
            "In (",
            forward.count,
            ")"),
        React.createElement(StyledBreakdownContainer, null,
            React.createElement(StyledLeftRightLabel, null,
                "Left (",
                left.count,
                ")"),
            React.createElement(BaseChart, { width: width, options: chartConfig, useBodyFont: false }),
            React.createElement(StyledLeftRightLabel, null,
                "Right (",
                right.count,
                ")")),
        React.createElement(StyledCenteredLabel, null,
            "Back (",
            back.count,
            ")")));
};

const Container$3 = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
function onSeriesAssignment(series, pointshrinkcutoff) {
    const numScatterPoints = series
        .filter((s) => !s.type || s.type === 'scatter')
        .map((x) => (x.data ? x.data.length : 0))
        .reduce((a, b) => a + b, 0);
    if (numScatterPoints <= pointshrinkcutoff) {
        return series;
    }
    const computedSeries = series.map((s) => {
        var _a;
        if (s.type && s.type !== 'scatter')
            return s;
        return Object.assign(Object.assign({}, s), { marker: Object.assign(Object.assign({}, s.marker), { radius: !((_a = s.marker) === null || _a === void 0 ? void 0 : _a.radius) ? 2 : Math.max(1, s.marker.radius - 2) }) });
    });
    return computedSeries;
}
const HangtimeChart = forwardRef(({ titleX, titleY, minRangeY, yplotbands, seriesData, pitchVideoFn, modalContainer, videoPlayerModal: VideoPlayerModal, width = 800, pointshrinkcutoff = 250, subscaleY = 0.50, onClick, xAxisType, tooltipFormatter, enableLegend = true, }, outerRef) => {
    const defaultWidth = 800;
    const defaultHeight = 500;
    const aspectRatio = defaultWidth / defaultHeight;
    const height = width / aspectRatio;
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    if (!(seriesData === null || seriesData === void 0 ? void 0 : seriesData.length)) {
        return React.createElement(Container$3, { style: { width } },
            React.createElement("em", null, translate('components.charts.no-pitches')));
    }
    const closePitchVideo = () => {
        setIsVideoPlayerOpen(false);
        setVideoPlaylist(null);
    };
    const fetchPitchVideo = (gameid, eventseq, pitchseq, playid) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq, playid);
            setVideoPlaylist(playlist);
        }
        catch (_a) {
            closePitchVideo();
        }
    });
    const chartConfig = {
        chart: {
            width,
            height,
            backgroundColor: undefined,
        },
        plotOptions: {
            series: {
                marker: {
                    radius: 2,
                    symbol: 'circle',
                },
                stickyTracking: false,
                color: '#ff0000',
                point: {
                    events: {
                        click: pitchVideoFn && function click() {
                            if (onClick)
                                return onClick(this);
                            if ((this.gameid && this.eventseq && this.pitchseq) || this.playid) {
                                fetchPitchVideo(this.gameid, this.eventseq, this.pitchseq, this.playid);
                            }
                            return null;
                        },
                    },
                },
                events: {
                    legendItemClick(event) {
                        const { chart } = this;
                        const { series } = chart;
                        const clickedSeries = series[event.target.index];
                        if (clickedSeries.type !== 'scatter') {
                            return true;
                        }
                        const visibleScatterSeries = series.filter((s) => s.visible && s.type === 'scatter');
                        const onlyVisibleScatter = visibleScatterSeries.length === 1 && visibleScatterSeries[0] === clickedSeries;
                        if (onlyVisibleScatter) {
                            series.forEach((s) => {
                                if (s.type === 'scatter') {
                                    s.update({ visible: true }, false);
                                }
                            });
                        }
                        else {
                            series.forEach((s) => {
                                if ((s).type === 'scatter') {
                                    (s).update({ visible: false }, false);
                                }
                            });
                            clickedSeries.update({ visible: true }, false);
                        }
                        chart.redraw();
                        return false;
                    }
                }
            },
            spline: {
                allowPointSelect: false,
                enableMouseTracking: false,
                lineWidth: 1,
                marker: {
                    enabled: false,
                },
            },
        },
        legend: {
            enabled: enableLegend,
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
        },
        credits: {
            enabled: false,
        },
        xAxis: {
            min: 0,
            max: 150,
            tickInterval: 15,
            gridLineWidth: 0,
            tickLength: 10,
            minorTickInterval: 5,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 1,
            minorGridLineColor: '#FCF8F8',
            minPadding: 0,
            maxPadding: 0,
            startOnTick: true,
            endOnTick: true,
            title: {
                text: titleX,
            },
            type: xAxisType,
        },
        yAxis: {
            min: 1,
            max: 8,
            tickInterval: 1,
            minRange: minRangeY,
            gridLineWidth: 0,
            lineWidth: 1,
            minorTickInterval: subscaleY,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 1,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0.05,
            maxPadding: 0.05,
            title: {
                text: titleY,
            },
            plotBands: yplotbands,
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                if (this.point.tooltip === undefined)
                    return false;
                let tooltip = `<b>${this.point.name || this.series.name}</b>`;
                if (this.point.tooltip)
                    tooltip += `<br/>${this.point.tooltip}`;
                return tooltip;
            },
        },
        series: onSeriesAssignment(seriesData, pointshrinkcutoff),
        title: {
            text: undefined,
            align: 'center',
            floating: true,
            verticalAlign: 'top',
        },
    };
    const seriesDataData = seriesData.flatMap((x) => x.data).map(({ y }) => y || 0);
    const newMinY = seriesDataData.length ? Math.min(...seriesDataData) : null;
    const newMaxY = seriesDataData.length ? Math.max(...seriesDataData) : null;
    if (minRangeY && newMaxY != null && newMinY != null && (newMaxY - newMinY < minRangeY)) {
        const md = ((newMaxY - newMinY) / 2) + newMinY;
        const min = Math.floor((md - (minRangeY / 2)) * 4) / 4;
        const max = min + minRangeY;
        chartConfig.yAxis.min = min;
        chartConfig.yAxis.max = max;
    }
    return (React.createElement(Container$3, null,
        pitchVideoFn && VideoPlayerModal && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: closePitchVideo, playlist: videoPlaylist, container: modalContainer })),
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false })));
});

/* eslint-disable react/no-this-in-sfc */
Annotation(Highcharts$1);
const getBackgrondImage = (isLhb, zoom, pitcher) => {
    if (zoom) {
        if (pitcher) {
            return isLhb ? batimpactlhhzoom : batimpactrhhzoom;
        }
        return isLhb ? batimpactrhhzoom : batimpactlhhzoom;
    }
    if (pitcher) {
        return isLhb ? batimpactlhh : batimpactrhh;
    }
    return isLhb ? batimpactrhh : batimpactlhh;
};
const ChartWrapper = styled.div `
    background-image: url(${(props) => getBackgrondImage(props.$isLhb, props.$zoom, props.$pitcher)});
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: contain;
    height: ${(props) => props.$sizeMultiplier * 412}px;
    width: ${(props) => props.$sizeMultiplier * 600} px;
`;
const degrees = 27;
const radians = degrees * Math.PI / 180;
const transformPoints = (isLhb, zoom, pitcherView, points) => points.map((p) => {
    if (p.x === null || p.x === undefined || p.y === null || p.y === undefined) {
        return Object.assign(Object.assign({}, p), { x: undefined, y: undefined });
    }
    const transformedX = (pitcherView ? 1 : -1) * (((p.x * Math.cos(radians)) - (p.y * Math.sin(radians))));
    const transformedY = (p.x * Math.sin(radians)) + (p.y * Math.cos(radians));
    if (zoom) {
        if (pitcherView) {
            return Object.assign(Object.assign({}, p), { x: (transformedX * 2.38 * (430 / 600)) - 4.7, y: (transformedY * 2.38) - 1.6 });
        }
        return Object.assign(Object.assign({}, p), { x: (transformedX * 2.38 * (430 / 600)) + 4.7, y: (transformedY * 2.38) - 1.8 });
    }
    if (pitcherView) {
        return Object.assign(Object.assign({}, p), { x: (transformedX * 1.58 * (330 / 600)) + (isLhb ? 0.8 : 0.2), y: (transformedY * 1.58) + 0.9 });
    }
    return Object.assign(Object.assign({}, p), { x: (transformedX * 1.58 * (330 / 600)) + (isLhb ? -0.3 : -0.8), y: (transformedY * 1.58) + 0.8 });
});
const BatImpactChart$2 = forwardRef(({ className, isLhb = false, seriesData, tooltipFormatter, pitchVideoFn, multiVideoFn, pitchTypeLeagueAverages, zoom = false, pitcherView = true, sizeMultiplier = 1, }, outerRef) => {
    const ref = useRef(null);
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    const options = {
        chart: {
            type: 'scatter',
            height: (zoom ? 450 : 350) * sizeMultiplier,
            width: 600 * sizeMultiplier,
            backgroundColor: undefined,
            zoomType: 'xy',
            events: {
                selection: function selection(e) {
                    var _a, _b;
                    if (multiVideoFn && ((_a = e.xAxis) === null || _a === void 0 ? void 0 : _a.length) && ((_b = e.yAxis) === null || _b === void 0 ? void 0 : _b.length)) {
                        const [{ min: minXAxis, max: maxXAxis }] = e.xAxis;
                        const [{ min: minYAxis, max: maxYAxis }] = e.yAxis;
                        const points = this.series.flatMap((s) => s.points.filter((point) => {
                            const { enabled, visible, x, y } = point;
                            return enabled !== false && visible !== false
                                && x >= minXAxis && x <= maxXAxis && typeof y === 'number' && y >= minYAxis && y <= maxYAxis;
                        }));
                        if (points.length) {
                            multiVideoFn(points.filter((p) => isNumber$2(p.gameid, p.eventseq, p.pitchseq)).map((p) => ({
                                gameid: Number(p.gameid),
                                eventseq: Number(p.eventseq),
                                pitchseq: Number(p.pitchseq),
                            })));
                        }
                    }
                    return false; // Don't zoom
                },
            },
        },
        title: {
            text: undefined,
        },
        legend: {
            enabled: false,
        },
        xAxis: {
            visible: false,
            reversed: isLhb,
            min: -20,
            max: 20,
        },
        yAxis: {
            visible: false,
            min: -20,
            max: 20,
        },
        series: seriesData.map((sd) => (Object.assign(Object.assign({}, sd), { type: 'scatter', data: transformPoints(isLhb, zoom, pitcherView, sd.data) }))),
        annotations: pitchTypeLeagueAverages ? [{
                zIndex: 0,
                shapes: pitchTypeLeagueAverages.map((s) => ({
                    type: 'ellipse',
                    xAxis: 0,
                    yAxis: 0,
                    points: transformPoints(isLhb, zoom, pitcherView, [{
                            x: s.x + (s.majorRadius * Math.cos(s.angle)),
                            y: s.y + (s.majorRadius * Math.sin(s.angle)),
                        }, {
                            x: s.x - (s.majorRadius * Math.cos(s.angle)),
                            y: s.y - (s.majorRadius * Math.sin(s.angle)),
                        }]).filter((x) => x.x !== undefined && x.y !== undefined)
                        .map((x) => (Object.assign(Object.assign({}, x), { xAxis: 0, yAxis: 0 }))),
                    ry: s.minorRadius,
                    stroke: pitchSubTypeColor(s),
                    fill: `${pitchSubTypeColor(s)}33`,
                    strokeWidth: 1.5,
                })),
                draggable: '',
            }] : undefined,
        plotOptions: {
            scatter: {
                stickyTracking: false,
            },
            series: {
                point: {
                    events: {
                        click: function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (pitchVideoFn)
                                    return pitchVideoFn(this.gameid, this.eventseq, this.pitchseq);
                            }
                            return null;
                        },
                    },
                },
            },
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                return '';
            },
        },
    };
    return (React.createElement(ChartWrapper, { "$isLhb": isLhb, "$zoom": zoom, "$pitcher": pitcherView, "$sizeMultiplier": sizeMultiplier, className: className },
        React.createElement(BaseChart, { ref: ref, options: options })));
});

/* eslint-disable react/no-this-in-sfc */
Annotation(Highcharts$1);
const headingAverageMap = new Map([
    [2, 25.06],
    [3, 21.63],
    [4, 23.27],
    [6, 17.31],
    [7, 23.77],
    [8, 11.28],
    [9, 1.36],
    [10, -0.21],
    [32, 25.84],
    [33, 20.64],
    [34, 23.07],
]);
const headingStandardDeviationMap = new Map([
    [2, 9.59],
    [3, 8.16],
    [4, 8.81],
    [6, 5.99],
    [7, 8.93],
    [8, 8.65],
    [9, 7.02],
    [10, 6.99],
    [33, 9.2],
    [34, 7.44],
]);
const HeadingChart$2 = forwardRef(({ seriesData, orderedPitchTypes, tooltipFormatter, pitchVideoFn, multiVideoFn, showLeagueAverageEllipses = false, disableJitter = false, sizeMultiplier = 1, min = -70, max = 70, }, outerRef) => {
    const ref = useRef(null);
    const { t: translate } = useTranslation();
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    const series = seriesData.map((sd) => (Object.assign(Object.assign({}, sd), { type: 'scatter' })));
    const options = {
        chart: {
            type: 'scatter',
            height: Math.max(Math.min(orderedPitchTypes.length * 80, 400), 200) * sizeMultiplier,
            width: 480 * sizeMultiplier,
            zoomType: 'xy',
            events: {
                selection: function selection(e) {
                    var _a, _b;
                    if (multiVideoFn && ((_a = e.xAxis) === null || _a === void 0 ? void 0 : _a.length) && ((_b = e.yAxis) === null || _b === void 0 ? void 0 : _b.length)) {
                        const [{ min: minXAxis, max: maxXAxis }] = e.xAxis;
                        const [{ min: minYAxis, max: maxYAxis }] = e.yAxis;
                        const points = this.series.flatMap((s) => s.points.filter((point) => {
                            const { enabled, visible, heading, x, y } = point;
                            return enabled !== false && visible !== false && heading !== null
                                && x >= minXAxis && x <= maxXAxis && typeof y === 'number' && y >= minYAxis && y <= maxYAxis;
                        }));
                        if (points.length) {
                            multiVideoFn(points.filter((p) => isNumber$2(p.gameid, p.eventseq, p.pitchseq)).map((p) => ({
                                gameid: Number(p.gameid),
                                eventseq: Number(p.eventseq),
                                pitchseq: Number(p.pitchseq),
                            })));
                        }
                    }
                    return false; // Don't zoom
                },
            },
        },
        title: {
            text: undefined,
        },
        xAxis: {
            title: {
                text: translate('components.charts.heading'),
                style: {
                    fontSize: '13px',
                    fontWeight: 'bold',
                    color: 'black',
                },
            },
            min,
            max,
            tickInterval: 30,
            labels: {
                formatter() {
                    return `${+this.value > 0 ? '+' : ''}${this.value}°`;
                },
                style: {
                    fontSize: '12px',
                    color: 'black',
                },
            },
            plotLines: [-60, -30, 0, 30, 60].map((pl) => ({
                value: pl,
                color: '#c2c2c2',
                width: pl ? 2 : 3,
                dashStyle: 'Dash',
            })),
            lineColor: 'black',
            lineWidth: 2,
        },
        yAxis: {
            title: undefined,
            labels: {
                formatter() {
                    var _a;
                    return ((_a = pitchTypeOrSubType(orderedPitchTypes[+this.value], true)) === null || _a === void 0 ? void 0 : _a.toString()) || '';
                },
                style: {
                    fontSize: '12px',
                    color: 'black',
                },
            },
            gridLineWidth: 0,
            min: -1,
            max: orderedPitchTypes.length,
            tickInterval: 1,
            lineColor: 'black',
            lineWidth: 2,
        },
        tooltip: {
            formatter() {
                if (tooltipFormatter)
                    return tooltipFormatter(this.series, this.point);
                return '';
            },
        },
        legend: {
            enabled: false,
        },
        plotOptions: {
            scatter: {
                jitter: disableJitter ? undefined : {
                    y: 0.1,
                    x: 0,
                },
            },
            series: {
                point: {
                    events: {
                        click: function click() {
                            if (this.gameid && this.eventseq && this.pitchseq) {
                                if (pitchVideoFn)
                                    return pitchVideoFn(this.gameid, this.eventseq, this.pitchseq);
                            }
                            return null;
                        },
                    },
                },
            },
        },
        annotations: [showLeagueAverageEllipses ? {
                zIndex: 2,
                shapes: orderedPitchTypes.map((opt, index) => {
                    var _a, _b, _c, _d;
                    return ({
                        type: 'ellipse',
                        xAxis: 0,
                        yAxis: 0,
                        points: [{
                                x: ((_a = headingAverageMap.get(opt)) !== null && _a !== void 0 ? _a : 0) - (1.5 * ((_b = headingStandardDeviationMap.get(opt)) !== null && _b !== void 0 ? _b : 0)),
                                y: index,
                                xAxis: 0,
                                yAxis: 0,
                            }, {
                                x: ((_c = headingAverageMap.get(opt)) !== null && _c !== void 0 ? _c : 0) + (1.5 * ((_d = headingStandardDeviationMap.get(opt)) !== null && _d !== void 0 ? _d : 0)),
                                y: index,
                                xAxis: 0,
                                yAxis: 0,
                            }],
                        ry: 0.25,
                        stroke: pitchSubTypeColor({ fxtype: opt > 10 ? opt / 10 : opt, fxsubtype: opt > 10 ? opt : null }),
                        fill: `${pitchSubTypeColor({ fxtype: opt > 10 ? opt / 10 : opt, fxsubtype: opt > 10 ? opt : null })}33`,
                        strokeWidth: 1.5,
                    });
                }),
                draggable: '',
            } : {}, {
                zIndex: 1,
                shapeOptions: {
                    src: 'data:image/png;base64,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',
                },
                shapes: orderedPitchTypes.map((opt, index) => {
                    var _a;
                    return ({
                        type: 'image',
                        width: 11,
                        height: 33,
                        point: {
                            x: ((_a = headingAverageMap.get(opt)) !== null && _a !== void 0 ? _a : 0) - 1.75,
                            y: index + 0.5,
                            xAxis: 0,
                            yAxis: 0,
                        },
                    });
                }),
                draggable: '',
            }],
        series,
    };
    return React.createElement(BaseChart, { key: seriesData, ref: ref, options: options });
});

const LoadingSpinner$1 = (props) => (React.createElement(Spinner, Object.assign({ animation: "border" }, props)));

const StyledSpinner = styled.div `
    background: transparent url(${spinnerImg}) no-repeat center;
    height: 15px;
    width: 15px;
`;
const StyledLoadingSpinner$1 = styled.div `
    h6 {
        font-weight: bold;
    }
    h6, ${StyledSpinner} {
        display: inline-block;
    }
    h6 + ${StyledSpinner} {
        position: relative;
        top: 2px;
    }
`;
const LoadingSpinner = ({ withText = false }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(StyledLoadingSpinner$1, null,
        withText && React.createElement("h6", null,
            translate('common.loading'),
            "...\u00A0"),
        React.createElement(StyledSpinner, null)));
};

const StyledName$1 = styled.span `
    color: ${({ handedness }) => {
    if (handedness === 3)
        return '#0000CC';
    if (handedness === 2)
        return '#CC0000';
    return theme.fontColors.mineShaft;
}};
    font-weight: bold;
`;
const PlayerName = ({ throws, bats, player = {}, name = '', formal = false }) => {
    let playerName = name;
    if (!playerName) {
        // covering our bases. Player names and IDs come in all shapes and sizes depending on the API call
        playerName = formal ? player.FormalName : player.FullName;
        if (!playerName) {
            const firstName = player.UsesName || player.usesname;
            const lastName = player.LastName || player.lastname;
            playerName = formal ? `${lastName}, ${firstName}` : `${firstName} ${lastName}`;
        }
    }
    let handedness = throws === true ? player.Throws || player.throws : throws;
    if (handedness === undefined || handedness === null) {
        handedness = bats === true ? player.Bats || player.bats : bats;
    }
    return (React.createElement(StyledName$1, { handedness: handedness }, playerName));
};

/* eslint-disable react/no-danger */
const StyledStatPopover = styled(Popover) `
    h5.popover-header {
        font-size: 1.25em;
    }
    .popover-body {
        font-size: 1.05em;
        min-width: 165px;
    }
`;
const StyledPopoverTriggerText = styled.span `
    border-bottom: 1px dotted;
`;
const StatTooltip = ({ children, onToggle, definition, isLoading = false, placement = 'top' }) => {
    const { t: translate, i18n } = useTranslation();
    const languageCode = i18n.language;
    const target = useRef(null);
    const [definitionText, setDefinitionText] = useState('');
    const [definitionTitle, setDefinitionTitle] = useState('');
    useEffect(() => {
        if (languageCode) {
            let primaryDef = '';
            let primaryTitle = '';
            switch (languageCode) {
                case 'es': // spanish
                    primaryDef = (definition === null || definition === void 0 ? void 0 : definition.DefinitionTextSpanish) || (definition === null || definition === void 0 ? void 0 : definition.DefinitionTextEnglish) || '';
                    primaryTitle = (definition === null || definition === void 0 ? void 0 : definition.TitleSpanish) || (definition === null || definition === void 0 ? void 0 : definition.TitleEnglish) || '';
                    break;
                case 'ja':
                    primaryDef = (definition === null || definition === void 0 ? void 0 : definition.DefinitionTextJapanese) || (definition === null || definition === void 0 ? void 0 : definition.DefinitionTextEnglish) || '';
                    primaryTitle = (definition === null || definition === void 0 ? void 0 : definition.TitleJapanese) || (definition === null || definition === void 0 ? void 0 : definition.TitleEnglish) || '';
                    break;
                case 'ko':
                    primaryDef = (definition === null || definition === void 0 ? void 0 : definition.DefinitionTextKorean) || (definition === null || definition === void 0 ? void 0 : definition.DefinitionTextEnglish) || '';
                    primaryTitle = (definition === null || definition === void 0 ? void 0 : definition.TitleKorean) || (definition === null || definition === void 0 ? void 0 : definition.TitleEnglish) || '';
                    break;
                case 'en':
                default:
                    primaryDef = (definition === null || definition === void 0 ? void 0 : definition.DefinitionTextEnglish) || '';
                    primaryTitle = (definition === null || definition === void 0 ? void 0 : definition.TitleEnglish) || '';
                    break;
            }
            setDefinitionTitle(primaryTitle || '');
            setDefinitionText(primaryDef || primaryTitle || '');
        }
    }, [languageCode, definition]);
    const title = definitionText ? (definitionTitle || children) : children;
    const popover = (React.createElement(StyledStatPopover, { id: "stat-tooltip" },
        React.createElement(StyledStatPopover.Header, { as: "h5" }, title),
        React.createElement(StyledStatPopover.Body, null,
            isLoading && `${translate('common.loading')}...`,
            !isLoading && !!definitionText && React.createElement("span", { dangerouslySetInnerHTML: { __html: definitionText } }))));
    return (React.createElement("div", { ref: target },
        React.createElement(OverlayTrigger
        // eslint-disable-next-line no-nested-ternary
        , { 
            // eslint-disable-next-line no-nested-ternary
            placement: placement === 'left' ? 'left' : placement === 'right' ? 'right' : placement === 'bottom' ? 'bottom' : 'top', overlay: popover, container: target, onToggle: onToggle },
            React.createElement(StyledPopoverTriggerText, null, children))));
};

const StyledDropdown$8 = styled(Dropdown) `
    .btn {
        min-height: 23px;
        min-width: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    &.suppress-carat .dropdown-toggle::after {
        display: none !important; 
    }
`;
const StyledMenu$2 = styled(Dropdown.Menu) `
    max-height: 275px;
    overflow-y: auto;
    .dropdown-item {
        cursor: pointer;
        padding: 5px;
        letter-spacing: inherit;
        &.active {
            font-weight: 900;
        }   
    }
`;
const DropdownInput = (_a) => {
    var { className, options, onSelect, value, disabled, title = '', variant = 'default', size = 'sm', align = 'start', inline = false, suppressCarat = false } = _a, rest = __rest(_a, ["className", "options", "onSelect", "value", "disabled", "title", "variant", "size", "align", "inline", "suppressCarat"]);
    const selectedValue = value && typeof value === 'object' ? value.name : value;
    const onOptionSelect = (option, e) => {
        if (!onSelect)
            return undefined;
        const selectedOption = options.find((x) => { var _a; return ((_a = x.name) === null || _a === void 0 ? void 0 : _a.toString()) === option.toString(); });
        return onSelect(selectedOption || option, option.toString(), e);
    };
    return (React.createElement(StyledDropdown$8, Object.assign({}, rest, { className: suppressCarat ? `${className} suppress-carat` : className, style: { display: inline ? 'inline' : '' }, onSelect: (option, e) => onOptionSelect(option, e), align: align }),
        React.createElement(Dropdown.Toggle, { variant: variant, size: size, disabled: disabled, style: { display: inline ? 'inline' : '' } }, selectedValue != null ? selectedValue : title),
        React.createElement(StyledMenu$2, { align: align }, options.map((option) => (React.createElement(Dropdown.Item, { active: selectedValue === option.name, key: (option.key || option.value || option.name), eventKey: option.name.toString(), href: option.href, as: option.href ? undefined : 'button', type: option.href ? undefined : 'button' }, option.name))))));
};

const buttonLabelSpacing = 5;
const StyledCheckboxRadioContainer = styled.div `
    position: relative;
    height: ${(props) => props.size}px;
    padding-${(props) => props.direction}: ${(props) => props.size + buttonLabelSpacing}px;
    margin-right: ${buttonLabelSpacing * 2}px;
    display: inline-block;
    label {
        line-height: ${(props) => props.size / 10.0};
        color: ${(props) => (props.theme.isDarkMode ? theme.fontColors.doveGray : theme.fontColors.sanMarino)};
        padding-${(props) => props.direction}: ${(props) => buttonLabelSpacing + (props.size / 2.0)}px;
        margin-${(props) => props.direction}: -${(props) => buttonLabelSpacing + (props.size / 2.0)}px;
        user-select: none;
        white-space: nowrap;
        &:hover {
            cursor: pointer;
        }
        &:before, &:after {
            position: absolute;
        }
        &:before {
            content: '';
            ${(props) => props.direction}: 0;
            width: ${(props) => props.size}px;
            height: ${(props) => props.size}px;
            display: inline-block;
            border-radius: 100%;
            text-align: center;
            background: white;
            border: 1px solid ${theme.border.bombay};
            transition: all .1s ease-in-out;
        }
        &:after {
            content: '';
            display: inline-block;
            ${(props) => props.direction}: 0;
            transition: all .2s ease-in-out .1s;
        }
    }
    input[type="${(props) => props.buttonType}"] {
        opacity: 0;
        position: absolute;
        left: -9999px;
        &:checked + label:before {
            background-color: ${(props) => (props.theme.isDarkMode ? theme.fontColors.silver : theme.background.astronaut)};
            border-color: ${(props) => pSBC(-0.2, props.theme.isDarkMode ? theme.fontColors.silver : theme.background.astronaut)};
        }
    }
`;
const BaseCheckboxRadioButton = (_a) => {
    var { id, size, type, onChange, label = '', labelDirection = 'right', onLabelClick } = _a, rest = __rest(_a, ["id", "size", "type", "onChange", "label", "labelDirection", "onLabelClick"]);
    return (React.createElement(StyledCheckboxRadioContainer, { className: "nyy-checkbox-radio-container", size: size, direction: labelDirection === 'left' ? 'right' : 'left', buttonType: type },
        React.createElement("input", Object.assign({ type: type, id: id, onChange: onChange, readOnly: !onChange }, rest)),
        React.createElement("label", { onClick: onLabelClick, htmlFor: onLabelClick ? undefined : id }, label)));
};

const StyledCheckbox = styled(BaseCheckboxRadioButton) `
    + label:after {
        border-left: 2px solid transparent;
        border-bottom: 2px solid transparent;
        transform: rotate(-45deg);
        height: ${(props) => props.size * 0.3}px;
        width: ${(props) => props.size / 2.0}px;
        top: ${(props) => props.size * 0.3}px;
        margin: 0 ${(props) => props.size / 4.0}px;
    }
    &[type="checkbox"]:checked + label:after {
        border-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : 'white')};
    }
`;
const Checkbox = (_a) => {
    var { size = 20 } = _a, rest = __rest(_a, ["size"]);
    return (React.createElement(StyledCheckbox, Object.assign({ type: "checkbox", size: size }, rest)));
};

const StyledDropdown$7 = styled(Dropdown) `
    .btn {
        min-height: 23px;
        min-width: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
`;
const StyledMenu$1 = styled(Dropdown.Menu) `
    min-width: 100% !important;
    max-height: 275px;
    overflow-y: auto;
    .dropdown-item {
        cursor: pointer;
        padding: 5px;
        letter-spacing: inherit;
        &.active {
            font-weight: 900;
        }   
    }
`;
const StyledFormCheck = styled(Form.Check) `
   > label {
        width: 100%;
        cursor: pointer;
   }
`;
const CheckboxDropdownInput = (_a) => {
    var { options, onChange, disabled, title = '', titleOverrideFormat = false, variant = 'default', size = 'sm', alignRight = false, inline = false, id } = _a, rest = __rest(_a, ["options", "onChange", "disabled", "title", "titleOverrideFormat", "variant", "size", "alignRight", "inline", "id"]);
    const { t: translate } = useTranslation();
    const alignProp = { sm: '' };
    if (alignRight)
        alignProp.sm = 'end';
    const updateCheckboxForm = (key) => (e) => {
        if (!onChange)
            return undefined;
        const selectedOption = options.find((x) => x.name === key);
        return onChange(selectedOption, key, e);
    };
    return (React.createElement(StyledDropdown$7, Object.assign({}, rest, { style: { display: inline ? 'inline' : '' } }),
        React.createElement(Dropdown.Toggle, { variant: variant, size: size, disabled: disabled, style: { display: inline ? 'inline' : '' } }, titleOverrideFormat ? title : `${translate('components.form.select')} ${title} ${translate('components.form.stats')}`),
        React.createElement(StyledMenu$1, { align: alignProp }, options.map((option) => (React.createElement(Form.Group, { className: "dropdown-item mb-0", style: { cursor: 'default' }, controlId: option.name.toString(), key: option.name },
            React.createElement(StyledFormCheck, { type: "checkbox", key: option.name, id: `${id ? `${id}_` : ''}checkbox_${option.name}`, name: `checkbox_${option.name}`, label: option.name, checked: option.checked, onChange: updateCheckboxForm(option.name.toString()) })))))));
};

const StyledDatePickerContainer = styled.div `
    position: relative;
    display: inline-block;
    > button {
        position: absolute;
        right: 5px;
        top: 8px;
        padding: 0;
        margin: 0;
        border: none;
        background-color: inherit;
    }
    .form-control {
        padding-right: ${(props) => (props.isFormControlSmall ? 28 : 8)}px;
    }
    .react-datepicker__today-button, .react-datepicker__header, .react-datepicker__day:hover {
        background-color: ${(props) => (props.theme.isDarkMode ? theme.fontColors.tundora : theme.background.gallery)};
    }
    .react-datepicker__month-container {
        background-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : 'white')};
    }
    .react-datepicker__current-month, .react-datepicker__day, .react-datepicker__day-name, .react-datepicker__today-button {
        color: ${(props) => (props.theme.isDarkMode ? theme.border.alto : theme.fontColors.mineShaft)};
    }
    .react-datepicker__day--selected, .react-datepicker__day--keyboard-selected {
        background-color: ${theme.fontColors.dodgerBlue};
        color: white;
        &:hover {
            background-color: ${pSBC(-0.25, theme.fontColors.dodgerBlue)};
        }
    }
    .react-datepicker__navigation--next {
        border-left-color: ${theme.fontColors.doveGray};
        &:hover {
            border-left-color: ${pSBC(-0.25, theme.fontColors.doveGray)};
        }
    }
    .react-datepicker__navigation--previous {
        border-right-color: ${theme.fontColors.doveGray};
        &:hover {
            border-right-color: ${pSBC(-0.25, theme.fontColors.doveGray)};
        }
    }
    .react-datepicker__time-container--with-today-button {
        right: -85px;
    }
    .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
        li.react-datepicker__time-list-item--selected {
            background-color: ${theme.fontColors.dodgerBlue};
        }
    }

    .react-datepicker__day--keyboard-selected,
    .react-datepicker__month-text--keyboard-selected,
    .react-datepicker__quarter-text--keyboard-selected,
    .react-datepicker__year-text--keyboard-selected {
        border-radius: inherit;
        background-color: #B6D3FE;
        color: inherit;
    }
    .react-datepicker__month--selected,
    .react-datepicker__month--in-selecting-range,
    .react-datepicker__month--in-range,
    .react-datepicker__quarter--selected,
    .react-datepicker__quarter--in-selecting-range,
    .react-datepicker__quarter--in-range {
        border-radius: 0.3rem;
        background-color: #B6D3FE;
        color: #fff;
    }
`;
const DatePicker = (_a) => {
    var { onSelect, value, placeholder, size = 'sm', alignRight = false } = _a, rest = __rest(_a, ["onSelect", "value", "placeholder", "size", "alignRight"]);
    const { t: translate } = useTranslation();
    const isFormControlSmall = size === 'sm';
    const selected = typeof value === 'string' ? new Date(value) : value;
    const ref = useRef(null);
    let isopen = false;
    const toggle = () => {
        var _a;
        isopen = !isopen;
        (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.setOpen(isopen);
    };
    return (React.createElement(StyledDatePickerContainer, { isFormControlSmall: isFormControlSmall },
        React.createElement(ReactDatePicker, Object.assign({ ref: ref, className: `form-control ${isFormControlSmall ? 'form-control-sm' : undefined}`, selected: selected, onChange: onSelect, placeholderText: placeholder, todayButton: translate('common.today'), popperPlacement: alignRight ? 'bottom-end' : 'bottom-start', dateFormat: "yyyy-MM-dd" }, rest)),
        React.createElement("button", { type: "button", onClick: () => toggle() },
            React.createElement(Icon, { icon: "calendar", color: theme.fontColors.dodgerBlue, size: isFormControlSmall ? '18px' : '24px' }))));
};

const checkedFillRatio = 0.5;
const StyledRadioButton = styled(BaseCheckboxRadioButton) `
    &&[type="radio"] {
        &:checked + label:before {
            border: 2px solid ${(props) => pSBC(-0.2, props.theme.isDarkMode ? theme.fontColors.silver : theme.background.astronaut)};
            background-color: white;
        }
        &:checked + label:after {
            border-radius: 100%;
            background-color: ${(props) => pSBC(-0.2, props.theme.isDarkMode ? theme.fontColors.silver : theme.background.astronaut)};
            height: ${(props) => props.size * checkedFillRatio}px;
            width: ${(props) => props.size * checkedFillRatio}px;
            top: ${(props) => props.size * (1 - checkedFillRatio) / 2.0}px;
            margin: 0 ${(props) => props.size * (1 - checkedFillRatio) / 2.0}px;
        }
    }
`;
const RadioButton = (_a) => {
    var { size = 20 } = _a, rest = __rest(_a, ["size"]);
    return (React.createElement(StyledRadioButton, Object.assign({ type: "radio", size: size }, rest)));
};

const StyledSliderContainer = styled.div `
    flex-grow: 1;
    padding-right: 8px;
    /**** inspired by nouislider.css ****/
    .nyySlider-target, .nyySlider-target * {
        -webkit-touch-callout: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        touch-action: none;
        user-select: none;
        box-sizing: border-box;
    }
    .nyySlider-target {
        position: relative;
    }
    .nyySlider-base, .nyySlider-connects {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 1;
    }
    .nyySlider-connects {
        overflow: hidden;
        z-index: 0;
    }
    .nyySlider-connect, .nyySlider-origin {
        will-change: transform;
        position: absolute;
        z-index: 1;
        top: 0;
        right: 0;
        -webkit-transform-style: preserve-3d;
        transform-origin: 0 0;
        transform-style: flat;
    }
    .nyySlider-connect {
        height: 100%;
        width: 100%;
    }
    .nyySlider-origin {
        height: 10%;
        width: 10%;
    }
    //offet direction
    .nyySlider-txt-dir-rtl.nyySlider-horizontal .nyySlider-origin {
        left: 0;
        right: auto;
    }
    //Give origins 0 height/width so they don't interfere with clicking the connect elements.
    .nyySlider-horizontal .nyySlider-origin {
        height: 0;
    }
    .nyySlider-handle {
        backface-visibility: hidden;
        position: absolute;
    }
    .nyySlider-touch-area {
        height: 100%;
        width: 100%;
    }
    .nyySlider-state-tap {
        .nyySlider-connect, .nyySlider-origin {
            //transition: transform 0.3s;
        }
    }
    .nyySlider-state-drag * {
        cursor: inherit !important;
    }
    //Slider size and handle placement
    .nyySlider-horizontal {
        height: 18px;
        .nyySlider-handle {
            width: 28px;
            height: 28px;
            right: -17px;
            top: -5.5px;
        }
    }
    .nyySlider-txt-dir-rtl.nyySlider-horizontal .nyySlider-handle {
        left: -17px;
        right: auto;
    }
    //Styling
    //Giving the connect element a border radius causes issues with using transform: scale
    .nyySlider-target, .nyySlider-connects {
        border-radius: 10px;
    }
    .nyySlider-target {
        background: #FFFFFF;
        //border: 1px solid #D3D3D3;
        //box-shadow: inset 0 1px 1px #F0F0F0, 0 3px 6px -5px #BBB;
    }
    .nyySlider-connect {
        background: ${theme.background.cerulean};
    }
    //Handles and cursors
    .nyySlider-draggable {
        cursor: ew-resize;
    }
    .nyySlider-handle {
        border: 2px solid #7b7b7b;
        border-radius: 100%;
        background: ${theme.border.alto};
        cursor: default;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    }
    .nyySlider-handle, .nyySlider-touch-area {
        &:focus {
            outline: none;
        }
    }
    .nyySlider-active {
        box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;
    }
    //Horizontal layout
    .nyySlider-pips-horizontal {
        padding: 10px 0;
        height: 80px;
        top: 100%;
        left: 0;
        width: 100%;
    }
    .nyySlider-value-horizontal {
        transform: translate(-50%, 50%);
    }
    .nyySlider-rtl .nyySlider-value-horizontal {
        transform: translate(50%, 50%);
    }
    .nyySlider-marker-horizontal {
        &.nyySlider-marker {
            margin-left: -1px;
            width: 2px;
            height: 5px;
        }
        &.nyySlider-marker-sub {
            height: 10px;
        }
        &.nyySlider-marker-large {
            height: 15px;
        }
    }
`;
class ProgressSlider extends Component {
    constructor(props) {
        super(props);
        this.slider = null;
        this.sliderContainer = createRef();
        this.onSliderInput = this.onSliderInput.bind(this);
    }
    componentDidMount() {
        this.slider = noUiSlider.create(this.sliderContainer.current, {
            start: 0,
            connect: 'lower',
            cssPrefix: 'nyySlider-',
            range: {
                min: 0,
                max: 100,
            },
        });
        this.slider.on('slide', this.onSliderInput);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.value !== this.props.value || nextProps.max !== this.props.max;
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && this.slider) {
            this.slider.set(this.props.value / (this.props.max || 1) * 100.0);
        }
    }
    onSliderInput(_val, _handle, rawValues) {
        const [unencodedSliderVal] = rawValues;
        this.props.onChange(unencodedSliderVal * this.props.max / 100.0);
    }
    render() {
        return (React.createElement(StyledSliderContainer, null,
            React.createElement("div", { ref: this.sliderContainer })));
    }
}
ProgressSlider.defaultProps = {
    max: 100,
    value: 0,
};

const StyledSliderRangeInput = styled(StyledSliderContainer) `
    flex-grow: 1;
    padding: 5px 10px 5px 3px;
    min-width: 150px;
    .nyySlider-target {
        background: ${styles.theme.background.geyser};
        ${({ $disabled }) => ($disabled ? `
            opacity: 0.6;
            pointer-events: none;
        ` : '')}
    }
    .nyySlider-handle {
        ${({ $disabled }) => ($disabled ? `
            border-radius: 0%;
            width: auto !important;
            padding: 0 2px;
            background-color: white;
            border: 1px solid #0077d9;
            color: #0077d9;
            opacity: 0.8;
        ` : '')}
    }
`;
const StyledSliderRangeInputContainer = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    .form-control {
        max-width: 72px;
        &:first-child {
            margin-right: 10px;
        }
        &:last-child {
            margin-left: 10px;
        }
    }
`;
class BaseSliderRange extends Component {
    constructor(props) {
        super(props);
        this.slider = null;
        this.sliderContainer = createRef();
        this.onSliderChange = this.onSliderChange.bind(this);
    }
    componentDidMount() {
        const _a = this.props.config, { range } = _a, rest = __rest(_a, ["range"]);
        this.slider = noUiSlider.create(this.sliderContainer.current, Object.assign({ cssPrefix: 'nyySlider-', step: this.props.step, margin: this.props.margin, range: range || { min: this.props.min, max: this.props.max } }, rest));
        this.slider.on('change', this.onSliderChange);
        this.slider.on('update', (_value, _handle, rawValues) => {
            if (this.props.onChangingValue) {
                this.props.onChangingValue(rawValues.length > 1 ? rawValues : rawValues[0]);
            }
        });
        this.slider.on('start', () => {
            if (this.props.onChanging) {
                this.props.onChanging(true);
            }
        });
        this.slider.on('end', () => {
            if (this.props.onChanging) {
                this.props.onChanging(false);
            }
        });
    }
    componentDidUpdate(prevProps) {
        var _a;
        if (this.props.value !== undefined && prevProps.value !== this.props.value) {
            (_a = this.slider) === null || _a === void 0 ? void 0 : _a.set(this.props.value);
        }
    }
    onSliderChange(_val, _handle, rawValues) {
        this.props.onChange(rawValues.length > 1 ? rawValues : rawValues[0]);
    }
    render() {
        return (React.createElement(StyledSliderRangeInput, { "$disabled": !!this.props.disabled },
            React.createElement("div", { ref: this.sliderContainer })));
    }
}
BaseSliderRange.defaultProps = {
    min: 0,
    max: 100,
    step: 1,
    margin: 1,
};

const Slider = (_a) => {
    var { onChange, value, min = 0, max = 100, connect = 'lower', disabled = false, showInput = true, inputDirection = 'left' } = _a, rest = __rest(_a, ["onChange", "value", "min", "max", "connect", "disabled", "showInput", "inputDirection"]);
    const val = value !== undefined ? value : min;
    const config = Object.assign({ start: val, connect }, rest);
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipValue, setTooltipValue] = useState(0);
    const onSliderMoving = (moving) => setShowTooltip(moving);
    const onSliderMovingValue = (movingValue) => setTooltipValue(movingValue);
    const tooltipOverrideValue = showTooltip ? tooltipValue : null;
    const onSliderInputChange = ({ currentTarget }) => onChange(currentTarget.value ? Number(currentTarget.value) : min);
    const sliderInput = (React.createElement(FormControl, { value: tooltipOverrideValue || val, onChange: onSliderInputChange, type: "number", min: min, max: max, size: "sm" }));
    const onSlideValueChange = (slideVal) => onChange(Array.isArray(slideVal) ? slideVal[0] : slideVal);
    return (React.createElement(StyledSliderRangeInputContainer, null,
        showInput && inputDirection !== 'right' && sliderInput,
        React.createElement(BaseSliderRange, { onChange: onSlideValueChange, min: min, max: max, value: value, disabled: disabled, config: config, onChanging: onSliderMoving, onChangingValue: onSliderMovingValue }),
        showInput && inputDirection === 'right' && sliderInput));
};

const Range = (_a) => {
    var { onChange, value, min = 0, max = 100, connect = true, disabled = false, showInput = true, step, margin } = _a, rest = __rest(_a, ["onChange", "value", "min", "max", "connect", "disabled", "showInput", "step", "margin"]);
    const [minVal, maxVal] = value || [min, max];
    const config = Object.assign({ start: [minVal, maxVal], connect }, rest);
    const [showMovingValue, setShowMovingValue] = useState(false);
    const [movingValue, setMovingValue] = useState([0, 0]);
    const onSliderMoving = (moving) => setShowMovingValue(moving);
    const onSliderMovingValue = (mvl) => setMovingValue(mvl);
    const onMinValChange = ({ currentTarget }) => onChange([
        currentTarget.value ? Number(currentTarget.value) : minVal, maxVal,
    ]);
    const onMaxValChange = ({ currentTarget }) => onChange([
        minVal, currentTarget.value ? Number(currentTarget.value) : maxVal,
    ]);
    const onRangeValueChange = (val) => onChange(Array.isArray(val) ? val : [val]);
    const minOverride = showMovingValue ? movingValue[0] : null;
    const maxOverride = showMovingValue ? movingValue[1] : null;
    return (React.createElement(StyledSliderRangeInputContainer, null,
        showInput && (React.createElement(FormControl, { value: minOverride !== null && minOverride !== void 0 ? minOverride : minVal, onChange: onMinValChange, type: "number", min: min, max: maxVal, size: "sm" })),
        React.createElement(BaseSliderRange, { onChange: onRangeValueChange, min: min, max: max, value: value, disabled: disabled, config: config, step: step, margin: margin, onChanging: onSliderMoving, onChangingValue: onSliderMovingValue }),
        showInput && (React.createElement(FormControl, { value: maxOverride !== null && maxOverride !== void 0 ? maxOverride : maxVal, onChange: onMaxValChange, type: "number", min: minVal, max: max, size: "sm" }))));
};

const defaultConfig = {
    versionCheck: false,
    toolbar: [
        ['Paste', 'PasteText', 'PasteFromWord'],
        ['Image', 'Flash'],
        ['Bold', 'Italic', 'Underline', 'TextColor', 'RemoveFormat'],
        ['Table', 'NumberedList', 'BulletedList', 'Indent', 'Outdent', 'Link'],
        ['Format', 'Font', 'FontSize'],
    ],
};
const CKEditorInput = (_a) => {
    var { onChange, onBlur, config = defaultConfig } = _a, rest = __rest(_a, ["onChange", "onBlur", "config"]);
    return (React.createElement(CKEditor, Object.assign({ config: config, onChange: onChange ? ({ editor }) => onChange(editor.getData()) : undefined, onBlur: onBlur ? ({ editor }) => onBlur(editor.getData()) : undefined }, rest)));
};

const StyledContainer$1 = styled.div `
    text-align: center;
    display: flex;
    flex-direction: ${({ $vertical }) => ($vertical ? 'column' : 'row')}
`;
const StyledLabelContainer = styled.div `
    height: 34px;
    line-height: 34px;
    padding: ${({ $vertical }) => ($vertical ? '0' : '0 5px')};
    margin-bottom: ${({ $vertical }) => ($vertical ? '5px' : '0')};
`;
const StyledLabel$3 = styled.label `
    font-size: 13px;
    font-weight: bold;
    margin-bottom: ${({ $vertical }) => ($vertical ? '0' : '0.5em')};
`;
const StyledToggleContainer = styled.label `
    position: relative;
    display: inline-block;
    height: ${({ $vertical }) => ($vertical ? '60px' : '34px')};
    width: ${({ $vertical }) => ($vertical ? '34px' : '60px')};
`;
const StyledInput = styled.input `
    opacity: 0;
    width: 0;
    height: 0;
    &:checked + .toggle {
        background-color: #2877D9;
    }
    &:focus + .toggle {
        box-shadow: 0 0 1px #2877D9;
    }
    &:checked + .toggle:before {
        -webkit-transform: ${({ $vertical }) => ($vertical ? 'translateY(-26px)' : 'translateX(26px)')};
        -ms-transform: ${({ $vertical }) => ($vertical ? 'translateY(-26px)' : 'translateX(26px)')};
        transform: ${({ $vertical }) => ($vertical ? 'translateY(-26px)' : 'translateX(26px)')};
    }
    
`;
const StyledSpan = styled.span `
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 34px;
    &:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 50%;
    }
`;
const Switch = ({ checked, onChange, onClick, vertical = false, onLabel = 'On', offLabel = 'Off' }) => {
    const { t: translate } = useTranslation();
    const labelOnUse = onLabel === 'On' ? translate('components.form.on') : onLabel;
    const labelOffUse = offLabel === 'Off' ? translate('components.form.off') : offLabel;
    return (React.createElement(StyledContainer$1, { "$vertical": vertical },
        React.createElement(StyledLabelContainer, { "$vertical": vertical },
            React.createElement(StyledLabel$3, { "$vertical": vertical }, vertical ? labelOnUse : labelOffUse)),
        React.createElement("div", null,
            React.createElement(StyledToggleContainer, { "$vertical": vertical },
                React.createElement(StyledInput, { type: "checkbox", checked: checked, "$vertical": vertical, onChange: onChange, onClick: onClick }),
                React.createElement(StyledSpan, { className: "toggle" }))),
        React.createElement(StyledLabelContainer, { "$vertical": vertical },
            React.createElement(StyledLabel$3, { "$vertical": vertical }, vertical ? labelOffUse : labelOnUse))));
};

const StyledContainer = styled.div `
    justify-content: space-between;
    > div {
        flex-grow: 1;
        display: flex;
        align-items: center;
        > span {
            flex: 0;
        }
    }
    input {
        max-width: 200px;
    }
      
    input[type="number"] {
        max-width: 75px;
    }
    .dropdown > .btn {
        width: 100%;
        min-width: 75px;
    }
`;
const FormInputContainer = ({ label, children, className }) => (React.createElement(StyledContainer, { className: `${className} d-flex align-items-center` },
    React.createElement("span", { className: "me-1" }, label),
    React.createElement("div", null, children)));

const ALL_VALUE$2 = -1;
const ALL_ATTACK_VALUE$2 = -2;
const ALL_2K_VALUE$2 = -3;
const COUNTS$2 = [
    { id: 0, name: '0-0', balls: 0, strikes: 0 },
    { id: 1, name: '1-0', balls: 1, strikes: 0 },
    { id: 2, name: '2-0', balls: 2, strikes: 0 },
    { id: 3, name: '3-0', balls: 3, strikes: 0 },
    { id: 4, name: '0-1', balls: 0, strikes: 1 },
    { id: 5, name: '1-1', balls: 1, strikes: 1 },
    { id: 6, name: '2-1', balls: 2, strikes: 1 },
    { id: 7, name: '3-1', balls: 3, strikes: 1 },
    { id: 8, name: '0-2', balls: 0, strikes: 2 },
    { id: 9, name: '1-2', balls: 1, strikes: 2 },
    { id: 10, name: '2-2', balls: 2, strikes: 2 },
    { id: 11, name: '3-2', balls: 3, strikes: 2 },
];

const StyledToggleButtons$b = styled(ToggleButtons) `
    display: inline-grid !important;
    grid-template-columns: min-content repeat(${(props) => props.$numCols - 1}, minmax(0, 1fr));
    row-gap: 0.25rem;

    .btn {
        width: ${(props) => props.$width}px;

        ${(props) => (props.$hasAll ? `&:first-of-type {
            display: block;
            width: 40px;
            grid-row: span ${props.$numRows} / span ${props.$numRows};
        }` : '')}
    }
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const CountSelect = ({ className, setCounts, counts }) => {
    const { t: translate } = useTranslation();
    const setFilterWithAll = (e) => {
        let newVal = [];
        if (!e.length || (e.includes(ALL_VALUE$2) && !(counts === null || counts === void 0 ? void 0 : counts.includes(ALL_VALUE$2)))) {
            newVal = [ALL_VALUE$2];
        }
        else if (!e.length || (e.includes(ALL_ATTACK_VALUE$2) && !(counts === null || counts === void 0 ? void 0 : counts.includes(ALL_ATTACK_VALUE$2)))) {
            newVal = [ALL_ATTACK_VALUE$2];
        }
        else if (!e.length || (e.includes(ALL_2K_VALUE$2) && !(counts === null || counts === void 0 ? void 0 : counts.includes(ALL_2K_VALUE$2)))) {
            newVal = [ALL_2K_VALUE$2];
        }
        else {
            newVal = e.filter((x) => x !== ALL_VALUE$2 && x !== ALL_ATTACK_VALUE$2 && x !== ALL_2K_VALUE$2);
        }
        setCounts(newVal);
    };
    return (React.createElement("div", { className: `d-flex ${className}` },
        React.createElement(StyledToggleButtons$b, { type: "checkbox", name: "count", options: [{ name: translate('common.all'), value: ALL_VALUE$2 }].concat(COUNTS$2.map((ct) => ({ name: ct.name, value: ct.id }))), separated: true, "$width": 42, "$numCols": 5, "$numRows": 3, "$hasAll": true, value: counts, onChange: (e) => setFilterWithAll(e) }),
        React.createElement(StyledToggleButtons$b, { type: "checkbox", name: "count", options: [
                { name: translate('components.hitmon.all-attack'), value: ALL_ATTACK_VALUE$2 },
                { name: translate('components.hitmon.all-2k'), value: ALL_2K_VALUE$2 },
            ], separated: true, "$width": 80, "$numRows": 2, "$numCols": 1, value: counts, onChange: (e) => setFilterWithAll(e) })));
};

const StyledDropdown$6 = styled(Dropdown$1) `
    .dropdown-toggle.form-control {
        width: 100%;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' 
            viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' 
            stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right .75rem center;
        background-size: 16px 12px;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-right: 24px !important;
        display: block;
        text-align: left;
        color: #212529 !important;

        ::after {
            display: none !important;
        }
        min-height: 35px !important;
        cursor: pointer;
    }

    .dropdown-toggle::after {
        display: none !important;
    }
`;
const StyledDropdownMenu = styled(Dropdown$1.Menu) `
    max-height: 24rem;
    overflow: auto;
    min-width: ${(props) => props.$minWidth || '20rem'} !important;
    width: 100%;
`;
const StyledOption = styled.div `
    display: flex;
    align-items: center;
    padding: 0.375rem 0.5rem;
    cursor: pointer;
    user-select: none;

    &:hover {
        background-color: ${theme.fontColors.dodgerBlue};
        color: white;
    }

    .form-check {
        min-height: unset;
        margin-bottom: 0 !important;

        .form-check-input {
            margin-top: 0 !important;
        }
    }
`;
const StyledLoadMore = styled.div `
    cursor: pointer;
    text-align: center;
    color: ${theme.fontColors.doveGray};
    font-size: 0.75rem;
    padding: 0.5rem 0.25rem;

    &:hover {
        background-color: ${theme.fontColors.dodgerBlue};
        color: white;
    }
`;
const StyleOptionName = styled.div `
    ${(props) => (props.$canExclusiveSelect ? `
        &:hover {
            text-decoration: underline;
        }
    ` : '')}
`;
const PAGE_ITEM_COUNT = 100;
const MultiSelect = ({ className, style, children, options, value, setValue, allowSearch, allowLoadMore, displayFormClass, canExclusiveSelect, overrideDisplayValue, emptyValue = 'All', $minWidth, disabled, }) => {
    const { t: translate } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [pages, setPages] = useState(1);
    const containerRef = useRef();
    const onOptionClick = (v) => {
        if (value.includes(v)) {
            setValue(value.filter((x) => x !== v));
        }
        else {
            setValue([...value, v]);
        }
    };
    const onToggle = (newIsOpen) => {
        setIsOpen(newIsOpen);
        if (newIsOpen) {
            setSearchValue('');
            setPages(1);
            if (allowSearch) {
                setTimeout(() => {
                    var _a, _b;
                    (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.getElementsByClassName('search')[0]) === null || _b === void 0 ? void 0 : _b.focus();
                }, 0);
            }
        }
    };
    const onNameClick = (e, option) => {
        if (canExclusiveSelect) {
            e.stopPropagation();
            setValue([option.value]);
        }
    };
    const filteredOptions = searchValue.trim() ? options.filter((o) => { var _a; return (_a = o.filterValue) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchValue.trim().toLowerCase()); }) : options;
    const selectedOptions = options.filter((o) => value.includes(o.value));
    const displayValue = overrideDisplayValue || (selectedOptions.length === options.length ? translate('common.all') : (selectedOptions.map((o) => (typeof o.name === 'object' ? (o.name.props.children.filter((c) => typeof c === 'string').join(' ')) : o.name)).join(', ') || emptyValue));
    return (React.createElement(StyledDropdown$6, { className: className, style: style, onToggle: onToggle, ref: containerRef },
        React.createElement(Dropdown$1.Toggle, { as: "span" }, children
            || (React.createElement(Form$1.Control, { size: "sm", className: `${displayFormClass} dropdown-toggle ${disabled ? '' : 'bg-white'}`, value: displayValue, readOnly: true, disabled: disabled }))),
        isOpen && (React.createElement(StyledDropdownMenu, { "$minWidth": $minWidth, className: `${allowSearch ? 'pt-0' : ''} ${allowLoadMore ? 'pb-0' : ''}` },
            allowSearch && (React.createElement("div", { className: "px-2 pt-2 pb-1 sticky-top bg-white" },
                React.createElement(Form$1.Control, { className: "search", size: "sm", value: searchValue, onChange: (e) => setSearchValue(e.target.value), placeholder: translate('common.search') }))),
            filteredOptions.slice(0, allowLoadMore ? pages * PAGE_ITEM_COUNT : filteredOptions.length).map((o) => (React.createElement(StyledOption, { className: "multi-select-option", onClick: () => onOptionClick(o.value), key: o.value },
                React.createElement(Form$1.Check, { className: "me-2 form-check", checked: value.includes(o.value), readOnly: true }),
                React.createElement("div", null,
                    React.createElement(StyleOptionName, { "$canExclusiveSelect": canExclusiveSelect, onClick: (e) => onNameClick(e, o) }, o.name),
                    o.description && React.createElement("small", { className: "text-muted", style: { whiteSpace: 'break-spaces' } }, o.description))))),
            allowLoadMore && pages * PAGE_ITEM_COUNT < filteredOptions.length && (React.createElement(StyledLoadMore, { onClick: () => setPages((p) => p + 1) }, translate('common.load-more')))))));
};

const StyledCheckboxSelect = styled.div `
    .value-label:hover {
        text-decoration: underline;
        cursor: pointer;
    }
    .nyy-checkbox-radio-container {
        margin-right: 0;
        label::before {
            top: 0;
        }
    }
`;
function CheckboxSelect({ className, title, options, value, setValue }) {
    const { t: translate } = useTranslation();
    const onCheckboxClick = (v) => {
        if (value.includes(v))
            setValue(value.filter((x) => x !== v));
        else
            setValue([...value, v]);
    };
    return (React.createElement(StyledCheckboxSelect, { className: `d-flex align-items-center ${className}` },
        title,
        " (",
        React.createElement("div", { className: "value-label", onClick: () => setValue(options.map((o) => o.value)) }, translate('common.all')),
        "):\u00A0",
        options.map((o) => (React.createElement("div", { key: o.value, className: "d-flex align-items-center me-2" },
            React.createElement(Checkbox, { checked: value.includes(o.value), onChange: () => onCheckboxClick(o.value), id: o.value.toString(), name: o.value.toString(), size: 14 }),
            React.createElement("div", { className: "value-label", onClick: () => setValue([o.value]) }, o.name))))));
}

const StyledToggle = styled(BootstrapButton) `
  &&&& {
    width: ${(props) => props.$isSubMenu && '100%'};
    font-size: ${(props) => !props.$isSubMenu && '1.2em;'};
    padding: ${(props) => (props.$isSubMenu ? '10px 20px' : '.25rem .5rem')};
    text-align: ${(props) => props.$isSubMenu && 'left'};
    font-size: ${(props) => props.$isSubMenu && '0.8em'};
    border-radius: ${(props) => props.$showBorder && '5px'};
    border: ${(props) => (props.$showBorder ? `2px solid ${theme.fontColors.anakiwa}` : 'none')};
    border-bottom: ${(props) => props.$isSubMenu && `0.5px solid ${theme.fontColors.dodgerBlue}`};
    background-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : theme.background.astronaut)};
    color: ${(props) => (props.$isSubMenu ? 'white' : theme.fontColors.anakiwa)};
    box-shadow: none;
    &:hover {
        background-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : theme.background.astronaut)};
        cursor: ${(props) => props.$isSubMenu && 'pointer'};
    }
    &:focus {
        background-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : theme.background.astronaut)};
    }
    &:active {
        background-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : theme.background.astronaut)};
    }
    &:after {
        color: ${theme.fontColors.anakiwa};
        content: ${(props) => (!props.$showIcon ? '' : (props.$customIcon && 'none'))};
    }
  }
`;
const StyledDropdown$5 = styled.div `
    && {
        border-radius: 0px;
        background-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : theme.background.astronaut)};
        width: 250px;
        padding: 5px;
        padding-bottom: 10px;
        left: ${(props) => (props.$alignRight ? '-20px' : undefined)};
    };
    border: ${(props) => props.theme.isDarkMode && `1px solid ${theme.background.astronaut}`};
}`;
const DropdownMenu = ({ children, label, customIcon, showBorder = false, alignRight = false, isSubMenu = false, showIcon = true, popperConfig = {}, disabled = false, drop, show, onToggle }) => (React.createElement(Dropdown, { drop: drop, show: show, onToggle: onToggle },
    React.createElement(Dropdown.Toggle, { as: StyledToggle, "$showBorder": showBorder, "$showIcon": showIcon, "$customIcon": customIcon, "$isSubMenu": isSubMenu, disabled: disabled },
        label && React.createElement("span", null, label),
        showIcon && customIcon && React.createElement(Icon, { icon: customIcon, size: "1.5em" })),
    React.createElement(Dropdown.Menu, { className: isSubMenu ? 'sub-menu' : '', as: StyledDropdown$5, "$alignRight": alignRight, "$isSubMenu": isSubMenu, popperConfig: popperConfig }, children)));

const StyledNavMenuItem = styled(Dropdown.Item) `&&{
    font-size: 0.8em;
    color: white;
    cursor: auto;
    padding: ${(props) => (props.featured ? '10px 20px' : '5px 20px')};
    border-bottom: ${(props) => props.featured && `0.5px solid ${theme.fontColors.dodgerBlue}`};
    &:hover {
        cursor: pointer;
        color: white;
        background-color: ${theme.fontColors.dodgerBlue};
    }
}`;
const StyledLabel$2 = styled.span `
{
    ${(props) => props.$hasIcon && 'margin-left: 20px'};
}`;
const NavMenuItem = ({ label, icon, href, featured = false }) => (React.createElement(StyledNavMenuItem, { featured: featured, href: href },
    icon && React.createElement(Icon, { icon: icon }),
    label && React.createElement(StyledLabel$2, { "$hasIcon": !!icon }, label)));

const emitEvent = (messageType, messageData = {}) => {
    const event = new CustomEvent('action-menu-item', { detail: Object.assign({ messageType }, messageData) });
    window.dispatchEvent(event);
};

const StyledActionMenuItem = styled(Dropdown.Item) `&&{
    font-size: 0.8em;
    color: white;
    cursor: auto;
    &:hover {
        color: white;
        cursor: pointer;
        background-color: ${(props) => (props.href ? theme.fontColors.dodgerBlue : theme.background.astronaut)};
    }
    padding: 10px 20px;
    border-bottom: 0.5px solid ${theme.fontColors.dodgerBlue};
    &:last-child {
        border-bottom: none;
    }
}`;
const ActionMenuItem = (_a) => {
    var { label, icon, href, actionType, onClick } = _a, rest = __rest(_a, ["label", "icon", "href", "actionType", "onClick"]);
    return (React.createElement(StyledActionMenuItem, Object.assign({ href: href, onClick: () => (onClick ? onClick() : emitEvent(actionType)) }, rest),
        icon && React.createElement(Icon, { icon: icon }),
        label && React.createElement("span", null, label)));
};

const StyledMenuItem$1 = styled(Dropdown.Item) `&&{
    font-size: 0.8em;
    color: white;
    padding: 5px 20px;
    cursor: auto;
    &:hover {
        color: white;
        background-color: ${(props) => (props.href ? theme.fontColors.dodgerBlue : theme.background.astronaut)};
    }
}`;
const BaseMenuItem = ({ label, icon }) => (React.createElement(StyledMenuItem$1, null,
    icon && React.createElement(Icon, { icon: icon }),
    label && React.createElement("span", null, label)));

const BaseModal = styled(Modal) `&&
    .modal-header {
        background-color: ${theme.background.astronaut};
        color: white;
        justify-content: space-around;
        font-size: 18px;
    }
    .list-group-flush {
        margin: 10px 0px 10px 0px;
    }
    .list-group-item {
        :hover {
            cursor: pointer;
        }
        //values from bootstrap that for whatever reason aren't being applied
        &.list-group-item-dark {
            color: #1b1e21;
            background-color: #c6c8ca;
            &.list-group-item-action {
                &:focus, &:hover {
                    color: #1b1e21;
                    background-color: #b9bbbe; 
                }
            }
        }
        &.list-group-item-action {
            width: unset;
            border-color: darkgray;
            border-width: 1px;
            border-radius: 5px;
            margin: 2px 12px;
            font-weight: bold;
        }
    }
`;

const StyledModal$1 = styled(BaseModal) `
    && .modal-body {
        padding: 0;
        background-color: lightgray;
    }
    .list-group-item {
        // padding: 7.5px 15px;
        &:last-child {
            border-bottom-right-radius: inherit;
            border-bottom-left-radius: inherit;
        }
    }
`;
function SelectListModal(_a) {
    var { title, options, onHide, label } = _a, rest = __rest(_a, ["title", "options", "onHide", "label"]);
    const themeContext = useContext(ThemeContext);
    const variant = (themeContext === null || themeContext === void 0 ? void 0 : themeContext.isDarkMode) ? 'dark' : undefined;
    const onSelect = (selectedValue) => onHide(selectedValue);
    return (React.createElement(StyledModal$1, Object.assign({ onHide: () => onSelect(), size: "sm" }, rest),
        React.createElement(StyledModal$1.Header, null, title),
        React.createElement(StyledModal$1.Body, null,
            React.createElement(ListGroup, { variant: "flush" }, options.map((opt, idx) => {
                let labelVal;
                if (typeof label === 'function')
                    labelVal = label(opt);
                else if (typeof label === 'string')
                    labelVal = get$2(opt, label);
                else
                    labelVal = opt.toString();
                return (React.createElement(ListGroup.Item, { action: true, key: idx, variant: variant, onClick: () => onSelect(opt) }, labelVal));
            })))));
}

const StyledDialogModal = styled(BaseModal) `
    font-size: 1.15em;
    .modal-body > p {
        text-align: center;
        margin-bottom: 0;
        white-space: pre-wrap;
    }
    .col-form-label {
        font-weight: bold;
        font-size: .75rem !important;
    }
`;
const StyledDefaultButtonAlt = styled(DefaultButtonAlt) `
    min-width: 60px;
    font-weight: bold;
    padding: 4px 10px;
`;
const StyledButton = styled(Button) `
    min-width: 60px;
    font-weight: bold;
    padding: 4px 10px;
`;
const BaseDialogModal = (_a) => {
    var { children, onHide, onResolve, canResolve = true, onReject, canReject = true, resolveTxt, closeTxt, rejectTxt, size = 'sm', headerTxt } = _a, rest = __rest(_a, ["children", "onHide", "onResolve", "canResolve", "onReject", "canReject", "resolveTxt", "closeTxt", "rejectTxt", "size", "headerTxt"]);
    return (React.createElement(StyledDialogModal, Object.assign({ onHide: onHide, size: size }, rest),
        headerTxt && React.createElement(StyledDialogModal.Header, null, headerTxt),
        React.createElement(StyledDialogModal.Body, null, children),
        React.createElement(StyledDialogModal.Footer, null,
            closeTxt && React.createElement(StyledDefaultButtonAlt, { onClick: onHide }, closeTxt),
            !!rejectTxt && !!onReject && React.createElement(StyledButton, { variant: "danger", onClick: onReject, disabled: !canReject }, rejectTxt),
            !!resolveTxt && !!onResolve && React.createElement(StyledButton, { variant: "primary", onClick: onResolve, disabled: !canResolve }, resolveTxt))));
};

const ConfirmModal = (_a) => {
    var { message, onConfirm, confirmTxt = '', cancelTxt = '' } = _a, rest = __rest(_a, ["message", "onConfirm", "confirmTxt", "cancelTxt"]);
    const { t: translate } = useTranslation();
    const confirmTxtUse = confirmTxt === '' ? translate('common.ok') : confirmTxt;
    const cancelTxtUse = cancelTxt === '' ? translate('common.cancel') : cancelTxt;
    return (React.createElement(BaseDialogModal, Object.assign({ resolveTxt: confirmTxtUse, closeTxt: cancelTxtUse, onResolve: onConfirm }, rest),
        React.createElement("p", null, message)));
};

const CheckRoles = ({ children, checkRoles = () => false, checkUserName = () => false, roles = [], excludedRoles = [], allRoles = [], userNames = [], }) => {
    let roleList = new Array();
    if (Array.isArray(roles))
        roleList = roles;
    else if (roles)
        roleList = [roles];
    if (excludedRoles.length && checkRoles(excludedRoles)) {
        return null;
    }
    if (allRoles.length && !checkRoles(allRoles, true)) {
        return null;
    }
    if ((roleList.length && !checkRoles(roleList)) && (!userNames.length || !checkUserName(userNames))) {
        return null;
    }
    return React.createElement(React.Fragment, null, children);
};

/// <reference types="styled-components/cssprop" />
const screenOnlyStyle = css `
    @media print {
        display: none;
        visibility: hidden;
        position: absolute;
        top: -1000px;
    }
`;
const ScreenOnly = ({ children }) => (
// eslint-disable-next-line react/no-unknown-property
React.createElement("span", { css: screenOnlyStyle }, children));

const checkRoles = (roles, input, requireAllRoles = false) => {
    const inputRolesArr = Array.isArray(input) ? input : [input];
    const userHasRole = (r) => roles.includes(r);
    return requireAllRoles ? inputRolesArr.every(userHasRole) : inputRolesArr.some(userHasRole);
};
const checkUserName = (userName, input) => {
    const inputNamesArr = Array.isArray(input) ? new Set(input) : new Set([input]);
    return inputNamesArr.has(userName);
};

const StyledNote = styled.div `
    ${({ $canEditNote }) => ($canEditNote ? `
        &:hover {
            cursor: pointer;
            background-color: #FFFF77;
        }
    ` : '')}
    && {
        p, ul {
            margin: 0.25em 0;
        }
        > ul {
            padding-left: 20px;
        }
    }
`;
const StyledNoteInfo = styled.div `
    text-align: right;
    border-top: 1px solid ${styles.theme.border.alto};
    color: ${styles.theme.fontColors.silverChalice};
    font-style: italic;
    padding-right: 10px;
    font-size: 0.8em;
    white-space: nowrap;
    ${({ $printInfo }) => (!$printInfo ? screenOnlyStyle : '')}
`;
const ReportNote = ({ note, initValue, onNoteClick, isLoading = false, readOnly = true, showInfo = true, showSpanish = false, printInfo = false }) => {
    var _a;
    const { t: translate } = useTranslation();
    const isNoteDefined = !!(note === null || note === void 0 ? void 0 : note.NoteID);
    const isSpanish = isNoteDefined && showSpanish && ((_a = note.Type) === null || _a === void 0 ? void 0 : _a.HasSpanish) && !!note.EsNote;
    const canEditNote = !readOnly && !!(note === null || note === void 0 ? void 0 : note.CanEdit);
    let noteHTML = initValue ? `<span>${initValue}</span>` : undefined;
    if (isNoteDefined)
        noteHTML = isSpanish ? note.EsNote : note.Note;
    else if (!noteHTML && canEditNote)
        noteHTML = `<span>${translate('components.report.add-note')}...</span>`;
    return (React.createElement("div", null,
        isLoading && React.createElement(LoadingSpinner, null),
        note && (React.createElement("div", null,
            noteHTML && (React.createElement(StyledNote, { "$canEditNote": canEditNote, onClick: canEditNote ? onNoteClick : undefined, dangerouslySetInnerHTML: { __html: noteHTML } })),
            (showInfo || printInfo) && isNoteDefined && !!note.User && (React.createElement(StyledNoteInfo, { "$printInfo": printInfo },
                !isSpanish && (React.createElement(React.Fragment, null,
                    translate('components.report.last-updated'),
                    ":\u00A0",
                    dateTimeTranslate(translate, note.LastUpdateDate),
                    "\u00A0 (",
                    note.User.LastName,
                    ",\u00A0",
                    note.User.FirstName.substring(0, 2),
                    ")")),
                isSpanish && (React.createElement(React.Fragment, null,
                    translate('components.report.last-updated'),
                    ":\u00A0",
                    dateTimeTranslate(translate, note.EsLastUpdateDate, true),
                    "\u00A0(",
                    note.EsLastUpdateUserName,
                    ")"))))))));
};

const borderColor = pSBC(-0.1, theme.background.geyser);
var tabTheme = {
    borderColor,
    border: `1px solid ${borderColor}`,
    margin: '10px',
    borderRadius: '5px',
};

const browser = Bowser.getParser(window.navigator.userAgent);
const engineName = browser.getEngineName();
const platform = browser.getPlatformType(true);
const webkit = engineName === 'WebKit';
const mobile = platform === 'mobile';
const tablet = platform === 'tablet';
const ios = (mobile || tablet) && webkit;
const desktop = platform === 'desktop';
var browser$1 = {
    webkit,
    tablet,
    mobile: mobile || tablet,
    mobileOnly: mobile,
    ios,
    desktop,
};

const paddingLeftRight = 10;
const paddingLeftRightMobile = 4;
const { fontColors, background, fontSize } = theme;
const BaseTab = styled.span `
    ${borderRadiuses(tabTheme.borderRadius, 0, 0, tabTheme.borderRadius)}
    cursor: pointer;
    display: block;
    padding: 8px ${browser$1.mobileOnly ? paddingLeftRightMobile : paddingLeftRight}px;
    border: ${tabTheme.border};
    background: ${(props) => (props.theme.isDarkMode ? fontColors.mineShaft : background.geyser)} !important;
    color: ${(props) => (props.theme.isDarkMode ? fontColors.silverChalice : fontColors.tundora)} !important;
    font-size: ${fontSize.nav};
    &:hover, &:active, &:focus {
        text-decoration: none !important;
    }
    &.active-tab, &.active {
        background: ${({ theme, $activeColor = 'white' }) => (theme.isDarkMode ? background.codGray : $activeColor)} !important;
        color: ${(props) => (props.theme.isDarkMode ? fontColors.silver : fontColors.dodgerBlue)} !important;
        border-bottom-color: ${({ theme, $activeColor = 'white' }) => (theme.isDarkMode ? background.codGray : $activeColor)};
        font-weight: bold;
        pointer-events: none;
    }
    &:not(.active-tab) {
        &:hover {
            background-color: ${(props) => pSBC(-0.2, props.theme.isDarkMode ? fontColors.mineShaft : background.geyser)} !important;
            border-color: ${(props) => pSBC(-0.3, props.theme.isDarkMode ? fontColors.mineShaft : background.geyser)};
        }
    }
    ${({ $alert }) => ($alert ? `
        position: relative;
        padding-right: ${paddingLeftRight + 3}px;
        &::after {
            content: '●';
            font-size: 16px;
            color: ${background.tangerine};
            position: absolute;
            right: 1px;
            top: -4px;
        }
    ` : '')}
`;

const Tab = (_a) => {
    var { children, active, activeColor, className = '', alert = false } = _a, rest = __rest(_a, ["children", "active", "activeColor", "className", "alert"]);
    return (React.createElement(BaseTab, Object.assign({ active: active, activeClassName: "active-tab", className: `${className}${active ? ' active-tab ' : ''}`, "$alert": !!alert, "$activeColor": activeColor }, rest), children));
};

const StyledTabPanel$1 = styled.div `
    clear: both;
    margin: 0 -${theme.margin.body} -${theme.margin.body} -${theme.margin.body};
    padding: ${theme.margin.body};
    border-top: ${tabTheme.border};
    background-color: ${(props) => (props.theme.isDarkMode ? theme.background.codGray : props.$activeColor)};
    ${({ $active }) => ($active === false ? 'display: none' : 'display: block')};
    StyledTabPanel {
        border-top: none;
    }
`;
const TabPanel = ({ children, active, activeColor = 'white' }) => (React.createElement(StyledTabPanel$1, { "$active": active, "$activeColor": activeColor }, children));

function useCombinedRefs(...refs) {
    const targetRef = React.useRef(null);
    React.useEffect(() => {
        refs.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(targetRef.current);
            }
            else if (ref !== null) {
                ref.current = targetRef.current;
            }
        });
    }, [refs]);
    return targetRef;
}
const ScrollContainer = styled.div `
    overflow-x: auto;
    overflow-y: hidden;
    position: relative;
    top: 4px;
    min-height: 37px;
`;
const StyledTabArea = styled.div `
    display: flex;
    justify-content: flex-${({ $align }) => ($align === 'right' ? 'end' : 'start')};
    > * {
        margin-right: 2.5px;
        text-align: center;
        white-space: nowrap;
    }
`;
const TabContainer = forwardRef(({ children, align = 'left' }, ref) => {
    const innerRef = useRef(null);
    const combinedRef = useCombinedRefs(ref, innerRef);
    return (React.createElement(ScrollContainer, { ref: combinedRef },
        React.createElement(StyledTabArea, { "$align": align }, children)));
});

const BaseSubtab = styled.span `
    cursor: pointer;
    font-size: ${theme.fontSize.nav};
    padding: 5px;
    &.active-tab {
        font-weight: 900;
        color: ${(props) => (props.theme.isDarkMode ? theme.fontColors.silver : theme.fontColors.sanMarino)};
        &:focus {
            text-decoration: none;
        }
    }
    &:hover {
        text-decoration: underline;
    }
`;

const SubtabContainer = styled.div `
    margin: 5px;
    text-align: left;
    font-size: 1.1em;
`;
const Subtabs = ({ tabs, onSelect, activeTab }) => (React.createElement(SubtabContainer, null, tabs.map((tab, i) => (React.createElement(React.Fragment, { key: tab.key },
    React.createElement(BaseSubtab, { onClick: () => onSelect(tab), className: (activeTab === null || activeTab === void 0 ? void 0 : activeTab.key) === tab.key ? 'active-tab' : '' },
        tab.title,
        !!tab.alert && React.createElement("span", { className: "ms-1 small label label-warning" }, tab.alert === true ? 1 : tab.alert),
        !!tab.count && React.createElement("span", { className: tab.todayCount ? 'ms-1 small label label-info' : 'ms-1 small label label-default' }, tab.count)),
    i + 1 < tabs.length && React.createElement("span", null, "|"))))));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const StateTabs = ({ tabs, defaultTabIndex = 0 }) => {
    const [activeTab, setActiveTab] = useState(tabs[defaultTabIndex]);
    useEffect(() => {
        var _a;
        setActiveTab((_a = tabs.find((t) => t.key === activeTab.key)) !== null && _a !== void 0 ? _a : tabs[defaultTabIndex]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabs]);
    return (React.createElement(React.Fragment, null,
        React.createElement(TabContainer, null, tabs.map((t) => {
            const isActive = activeTab.key === t.key;
            return React.createElement(Tab, { key: t.key, active: isActive, onClick: isActive ? undefined : () => setActiveTab(t) }, t.title);
        })),
        React.createElement(TabPanel, null, activeTab.component)));
};
StateTabs.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        title: PropTypes.string.isRequired,
        component: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.node]).isRequired,
    })).isRequired,
    defaultTabIndex: PropTypes.number,
};

const StyledToastHeader = styled(Toast.Header) `&&
    border: none;
    button {
        font-size: 1.5em;
        opacity: 1;
        span {
            color: white;
            line-height: 0.75;                
        }
    }
`;
const StyledToast = styled(Toast) `
    position: absolute;
    top: 25px;
    right: 25px;
    padding: 10px;
    width: 250px;
    z-index: 999;
    &&& {
        &, ${StyledToastHeader} {
            background-color: ${theme.background.success};
            color: white;
        }
        border-radius: 5px;
    }
`;
const StyledToastBody = styled(Toast.Body) `
    padding-top: 5px;
`;
const ToastNotification = ({ message, clearMessage, header = 'Toast Message' }) => (React.createElement(StyledToast, { show: message && message.length > 0, onClose: clearMessage, autohide: true, delay: 3000 },
    React.createElement(StyledToastHeader, null,
        React.createElement("strong", { className: "me-auto" }, header)),
    React.createElement(StyledToastBody, null, message)));

const VideoPlayerButton = ({ title, icon, onClick, isActive = false, className = '', containerClassName = '', loading = false, disabled = false, iconColor = theme.fontColors.silver, showLabel = false, }) => (React.createElement("div", { className: containerClassName },
    React.createElement(Button, { variant: "dark", title: title, onClick: onClick, className: `${className} ${isActive ? 'active' : ''}`, disabled: disabled || loading },
        React.createElement(Icon, { icon: icon, color: isActive ? 'white' : iconColor }),
        loading && React.createElement(LoadingSpinner$1, null)),
    showLabel && React.createElement("label", null, title)));
var VideoPlayerButton$1 = styled(VideoPlayerButton) `
    position: relative;
    touch-action: none;
    &&& {
        background-color: transparent;
        &, &:not(:disabled):not(.disabled) {
            border: 2px solid ${theme.fontColors.silver};
            &, &:focus {
                box-shadow: none;
            }
            &.active, &:active {
                background-color: ${theme.background.cerulean};
                border-color: ${theme.fontColors.silver};
                &, &:focus {
                    box-shadow: none;
                }
            }
        }
    }
    && {
        .spinner-border {
            position: absolute;
            top: 4px;
            left: 4.5px;
            margin: 0;
        }
    }
    &:hover {
        cursor: pointer;
    }
`;

const StyledVideo = styled.video `
    max-width: 100%;
    ${({ $maxHeight }) => ($maxHeight ? `max-height: ${$maxHeight};` : '')}
    ${({ $minHeight }) => ($minHeight ? `min-height: ${$minHeight};` : '')}
    &:focus {
        outline: none;
    }
`;
class Video extends Component {
    constructor(props) {
        super(props);
        this.videoPlayerRef = createRef();
        this.onVideoLoadedData = this.onVideoLoadedData.bind(this);
        this.onPlayback = this.onPlayback.bind(this);
        this.onVideoEnd = this.onVideoEnd.bind(this);
        this.onVideoError = this.onVideoError.bind(this);
        this.setCurrentTime = this.setCurrentTime.bind(this);
    }
    componentDidMount() {
        this.videoPlayerRef.current.addEventListener('loadeddata', this.onVideoLoadedData);
        this.videoPlayerRef.current.addEventListener('timeupdate', this.onPlayback);
        this.videoPlayerRef.current.addEventListener('ended', this.onVideoEnd);
        this.videoPlayerRef.current.addEventListener('error', this.onVideoError);
        if (this.props.setCurrentTime) {
            this.props.setCurrentTime(this.setCurrentTime);
        }
        if (this.props.videoRef) {
            this.props.videoRef(this.videoPlayerRef);
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.play !== prevProps.play && this.videoPlayerRef.current) {
            if (this.props.play) {
                this.videoPlayerRef.current.play();
                if (typeof this.props.play === 'number') {
                    this.videoPlayerRef.current.playbackRate = this.props.play;
                }
            }
            else {
                this.videoPlayerRef.current.pause();
            }
        }
        if (!this.props.src && prevProps.src && this.videoPlayerRef.current) { // video not found (on filter)
            this.videoPlayerRef.current.pause();
            this.videoPlayerRef.current.removeAttribute('src');
            this.videoPlayerRef.current.load();
        }
    }
    componentWillUnmount() {
        if (this.videoPlayerRef.current) {
            this.videoPlayerRef.current.removeEventListener('loadeddata', this.onVideoLoadedData);
            this.videoPlayerRef.current.removeEventListener('timeupdate', this.onPlayback);
            this.videoPlayerRef.current.removeEventListener('ended', this.onVideoEnd);
            this.videoPlayerRef.current.removeEventListener('error', this.onVideoError);
        }
    }
    onPlayback(e) { if (this.props.onPlayback)
        this.props.onPlayback(e); }
    onVideoEnd(e) { if (this.props.onVideoEnd)
        this.props.onVideoEnd(e); }
    onVideoLoadedData(e) { if (this.props.onVideoLoad)
        this.props.onVideoLoad(e); }
    onVideoError(e) { if (this.props.onVideoError)
        this.props.onVideoError(e); }
    setCurrentTime(currentTime) { if (this.videoPlayerRef.current)
        this.videoPlayerRef.current.currentTime = currentTime; }
    render() {
        const { src, onClick, maxHeight, minHeight, autoPlay = true, controls = false, mute = false, loop = false } = this.props;
        return (React.createElement(StyledVideo, { ref: this.videoPlayerRef, src: src || undefined, autoPlay: autoPlay, onClick: onClick, controls: controls, muted: !!mute, loop: !!loop, "$maxHeight": typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight, "$minHeight": typeof minHeight === 'number' ? `${minHeight}px` : minHeight, playsInline: true }));
    }
}
Video.defaultProps = {
    play: true,
};

const PLAY_PAUSE = 'play';
const LOOP = 'loop';
const PLAY_FROM_BEGINNING = 'goBack';
const STEP_BACK = 'stepBackward';
const STEP_FORWARD = 'stepForward';
const FULLSCREEN = 'fullscreen';
const MUTE = 'mute';
const STATS = 'stats';
const FILTER = 'filter';
const PLAYLIST = 'playlist';
const FRAME_GRAB = 'frameGrab';
const GRID_SIZE = 'gridSize';
const REPORT_BAD_VIDEO = 'reportBadVideo';
const HEATMAP = 'heatmap';
const FRAME_RATE = 29.97 * 2;
const LOCAL_STORAGE_ANGLE_KEY = 'last_viewed_angle';
const LOCAL_STORAGE_ANGLE_KEY_APPROACHTAB = 'last_viewed_angle_approach';
const LOCAL_STORAGE_DATA_VIEW_KEY = 'video_stats_open';
const LOCAL_STORAGE_MUTE_KEY = 'video_player_muted';
const LOCAL_STORAGE_HEATMAP_KEY = 'show_video_heatmap';
const videoPlayerBackground = 'black';
const fullscreenSectionMixin = css `
    ${(props) => (props.fullscreen ? `
        position: absolute;
        z-index: 9;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
    ` : '')}
`;
const sideContentHeader = css `
    padding: 5px 15px 5px;
    text-align: left;
    && {
        h4 {
            margin: 10px 0;
            font-weight: bold;
            font-family: ${theme.font.body};
        }
    }
`;
const sideContentFooter = css `
    background-color: ${theme.background.cello};
    padding: 15px 20px;
    .btn + .btn {
        margin-left: 12px;
    }
`;
const sideContentWidth = 340;
const filterMarginBottom = '9px';
const headerHeight = 50;
const statsContainerHeight = 145;
const videoMaxSizePadding = { desktop: 50, mobile: 25 };
const footerHeight = { desktop: 64, mobile: 50 };

const fullscreenHeaderHeight = '45px';
const StyledListGroup = styled(ListGroup) `
    text-align: left;
    &&, .list-group-item.list-group-item.list-group-item {
        border-radius: 0;
    }
    && .list-group-item, && .list-group-item-action {
        padding: 5px 10px;
        p {
            margin-bottom: 0;
            font-size: .9em;
            &.h6 {
                font-size: 1.1em;
                font-weight: bold;
            }
        }
        &.active {
            background: ${theme.background.astronaut};
            border: none;
            &:focus {
                outline: none;
            }
        }
        &:hover {
            cursor: pointer;
        }
    }
    && .list-group-item {
        border-color: ${theme.border.alto};
    }
`;
const StyledVideoPlaylist = styled.div `
    position: relative;
    width: ${sideContentWidth}px;
    display: flex;
    flex-direction: column;
    ${StyledListGroup} {
        flex-grow: 1;
        position: relative;
        > div {
            position: absolute;
            left: 0;
            top: 0;
            overflow-y: auto;
            height: 100%;
            width: 100%;
        }
    }
`;
const StyledVideoPlaylistContainer$1 = styled.div `
    ${fullscreenSectionMixin}
    ${StyledVideoPlaylist} {
        height: 100%;
        background-color: white;
        ${(props) => (props.fullscreen ? `
            left: 0;
        ` : '')}
    }
`;
const StyledVideoPlaylistHeader$1 = styled.div `
    ${sideContentHeader}
    height: ${fullscreenHeaderHeight};
    flex-grow: 0;
    border-bottom: 1px solid ${theme.border.alto};
    background-color: white;
`;
const StyledVideoPlaylistFooter = styled.div `
    ${sideContentFooter};
    text-align: left;
`;
const VideoPlaylist = ({ playlist, activeIdx, onVideoClick, isFullScreenMode, hideDisplay }) => {
    const { t: translate } = useTranslation();
    const playlistGroupRef = useRef(null);
    useEffect(() => {
        var _a;
        const activeVideoElem = (_a = playlistGroupRef.current) === null || _a === void 0 ? void 0 : _a.children[activeIdx];
        if (activeVideoElem) {
            const { offsetTop, offsetHeight: listItemHeight } = activeVideoElem;
            const { scrollTop, offsetHeight: containerHeight } = playlistGroupRef.current;
            const scrollContainerBottom = scrollTop + containerHeight;
            const listItemBottom = offsetTop + listItemHeight;
            if ((listItemBottom > scrollContainerBottom) || (offsetTop < scrollTop)) {
                playlistGroupRef.current.scrollTop = offsetTop - listItemHeight - 2;
            }
        }
    }, [activeIdx, playlistGroupRef]);
    const onPlaylistItemClick = (idx) => (e) => {
        e.stopPropagation();
        return onVideoClick(idx);
    };
    return (React.createElement(StyledVideoPlaylistContainer$1, { fullscreen: isFullScreenMode, onClick: isFullScreenMode ? hideDisplay : undefined },
        React.createElement(StyledVideoPlaylist, null,
            React.createElement(StyledVideoPlaylistHeader$1, null,
                React.createElement("h4", null,
                    translate('components.video.pitch-list'),
                    " (",
                    playlist.length,
                    ")")),
            React.createElement(StyledListGroup, { ref: playlistGroupRef },
                React.createElement("div", null, playlist.map(({ title, description, pitchId }, idx) => (React.createElement(StyledListGroup.Item, { key: pitchId || idx, action: true, active: activeIdx === idx, onClick: onPlaylistItemClick(idx) },
                    React.createElement("div", null,
                        React.createElement("p", { className: "h6" }, title),
                        React.createElement("p", null, description))))))),
            React.createElement(StyledVideoPlaylistFooter, null,
                React.createElement(Button, { onClick: isFullScreenMode ? undefined : hideDisplay }, translate('common.cancel'))))));
};
var VideoPlaylist$1 = memo(VideoPlaylist, (prevProps, nextProps) => prevProps.playlist === nextProps.playlist
    && prevProps.activeIdx === nextProps.activeIdx
    && prevProps.isFullScreenMode === nextProps.isFullScreenMode);

const StyledPlaylistTab = styled(Tab) `
    font-weight: bold;
    opacity: 0.4;
    border-color: ${pSBC(-0.3, theme.background.blueZodiac)};
    position: relative;
    && {
        background-color: ${theme.background.blueZodiac} !important;
        color:  white !important;
    }
    &:not(.active-tab):hover {
        opacity: 0.8;
        background-color: ${theme.background.blueZodiac} !important;
        color:  white !important;
    }
    &.active-tab {
        border-bottom-color: ${theme.background.blueZodiac};
        opacity: 1;
    }
    .nyy-icon {
        margin-left: 33px;
    }
    .spinner-border {
        height: 1.5em;
        width: 1.5em;
        position: absolute;
        right: .5em;
        top: .5em;
    }
`;
// check for ios to not overflow mobile info at top of screen
const StyledPlaylistTabContent = styled.div `
    ${(props) => ((props.fullscreen && browser$1.ios) ? 'padding-top: 15px;' : '')}
    background: ${videoPlayerBackground};
    > div {
        scrollbar-width: none;
        -ms-overflow-style: none;  
        ::-webkit-scrollbar { 
            display: none;
        }
    }
`;
const VideoPlaylistTabs = ({ playlist, activeIdx, toggleStats, onVideoClick, loadPitchData, statsContent, isStatsOpen = false, isFullScreenMode = false }) => {
    const playlistGroupRef = useRef(null);
    useEffect(() => {
        var _a;
        const activeVideoElem = (_a = playlistGroupRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.active-tab');
        if (activeVideoElem) {
            const { offsetLeft, offsetWidth: listItemWidth } = activeVideoElem;
            const { scrollLeft, offsetWidth: containerWidth } = playlistGroupRef.current;
            const scrollContainerRight = scrollLeft + containerWidth;
            const listItemRight = offsetLeft + listItemWidth;
            if ((listItemRight > scrollContainerRight) || (offsetLeft < scrollLeft)) {
                playlistGroupRef.current.scrollLeft = offsetLeft - 75;
            }
        }
    }, [activeIdx, playlistGroupRef]);
    return (React.createElement(StyledPlaylistTabContent, { fullscreen: isFullScreenMode },
        React.createElement(TabContainer, { ref: playlistGroupRef }, playlist.map(({ title, pitchId }, idx) => {
            const isActiveTab = idx === activeIdx;
            return (React.createElement("div", { key: pitchId || idx, onClick: isActiveTab ? () => toggleStats() : undefined },
                React.createElement(StyledPlaylistTab, { onClick: () => onVideoClick(idx), className: isActiveTab ? 'active-tab' : '' },
                    React.createElement("span", null, title),
                    isActiveTab && loadPitchData && (React.createElement(Icon, { size: "1em", color: theme.background.cerulean, icon: `chevron-${isStatsOpen ? 'down' : 'up'}` })))));
        })),
        statsContent));
};

const StyledTopBottomInning = styled.span `
    font-size: 10px;
`;
const StyledOutsLabel = styled.span `
    font-weight: normal;
`;
const StyledScoreboardTable = styled.table `
    max-width: 135px;
    tr {
        &:first-of-type td:not(:last-child) {
            //width: 1px;
        }
        &:last-of-type td {
            vertical-align: middle;
            text-align: center;
            &:last-child {
                padding-right: 13.5px;
            }
        }
        &:first-of-type, &:last-of-type {
            td:last-child {
                text-align: right;
            }
        }
    }
`;
const StyledPitchInfoStats = styled.div `
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    table, hr {
        width: 100%;
    }
    hr {
        border-top-color: #979595;
        margin: 2.5px 0;
    }
`;
const PitchInfoStats = (props) => {
    const { t: translate } = useTranslation();
    return (React.createElement(StyledPitchInfoStats, null,
        React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("th", null, translate('baseball.batter')),
                    React.createElement("td", null, props.batter)),
                React.createElement("tr", null,
                    React.createElement("th", null, translate('baseball.pitcher_one')),
                    React.createElement("td", null, props.pitcher)),
                React.createElement("tr", null,
                    React.createElement("th", null, translate('common.date')),
                    React.createElement("td", null, props.pitchtime ? dateTimeTranslate(translate, props.pitchtime) : dateTranslate(translate, props.gamedate))),
                React.createElement("tr", null,
                    React.createElement("th", null, translate('components.video.result')),
                    React.createElement("td", null, pitchResult(props.resultid, false, translate))))),
        React.createElement("hr", null),
        React.createElement(StyledScoreboardTable, null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, props.awayteamabbr),
                    React.createElement("td", null, props.istop ? props.scorebatting : props.scorefielding),
                    React.createElement("td", { rowSpan: 2 }, props.bcbefore !== null && React.createElement(BaseRunners, { width: 42, height: 31, baseState: props.bcbefore }))),
                React.createElement("tr", null,
                    React.createElement("td", null, props.hometeamabbr),
                    React.createElement("td", null, props.istop ? props.scorefielding : props.scorebatting)),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement(StyledTopBottomInning, null, props.istop ? '▲' : '▼'),
                        "\u00A0",
                        props.inning),
                    React.createElement("td", null, props.outsbefore !== null && (React.createElement(React.Fragment, null,
                        props.outsbefore,
                        "\u00A0",
                        React.createElement(StyledOutsLabel, null, translate('baseball.outs', { count: props.outsbefore }))))),
                    React.createElement("td", null,
                        props.balls,
                        "-",
                        props.strikes))))));
};

/* eslint-disable max-len */
const StyledPitchTypePill = styled(Badge).attrs({ pill: true }) `
    &&& {
        font-size: 12px;
        padding: 3px 12px;
    }
    && {
        > p {
            margin: 0 0 3px;
        }
    }
    > span {
        font-weight: normal;
    }
`;
const PitchTypeLocationStats = (props) => {
    const { t: translate } = useTranslation();
    let strikeZoneSeries = null;
    if (isNumber$2(props.platex, props.platez)) {
        strikeZoneSeries = [
            { type: 'scatter', marker: { radius: 5 }, data: [{ x: props.platex, y: props.platez }] },
        ];
    }
    return (React.createElement(React.Fragment, null,
        !props.isMobileView && !!props.pitchtype && (React.createElement(StyledPitchTypePill, { variant: "primary" },
            React.createElement("p", null,
                pitchType(props.pitchtype, undefined, undefined, translate),
                props.fxsubtype && ` (${pitchSubType(props.fxsubtype, true, undefined, translate)})`),
            !!props.velocity && React.createElement("span", null, translate('format.abbr-mph', { value: format(props.velocity, 0) })))),
        strikeZoneSeries && (React.createElement(StrikeZone$3, { size: "xs", showlhb: !!props.islhb, yopposite: !!props.islhb, seriesData: strikeZoneSeries }))));
};

const getPlateLoc$1 = (pitch, ax0Adj, az0Adj, isExaggerated = false) => {
    // y = 1.4167 at the plate
    // use quadratic formula with known value of 1.4167 for y to determine the time,
    // then use that to provide the x, y and z of the point where it crosses the plate.
    // 0.5*y2*t^2 + y1*t + y0 = 1.4167
    // a = 0.5*y2, b = y1, c = y0 - 1.4167
    // t = (-b+-sqrt(b^2 - 4ac))/2a
    const a = pitch.ay0 / 2;
    const b = pitch.vy0;
    const c = pitch.y0 - 1.4167;
    const t1 = ((-1 * b) + Math.sqrt((Math.pow(b, 2)) - (4 * a * c))) / (2 * a);
    const t2 = ((-1 * b) - Math.sqrt((Math.pow(b, 2)) - (4 * a * c))) / (2 * a);
    const t = t1 && t2 > 0 ? (t1 > t2 ? t2 : t1) : (t1 > 0 ? t1 : t2); // eslint-disable-line no-nested-ternary
    const x = pitch.x0 + (t * pitch.vx0) + ((Math.pow(t, 2)) * 0.5 * pitch.ax0);
    const y = pitch.y0 + (t * pitch.vy0) + ((Math.pow(t, 2)) * 0.5 * pitch.ay0);
    const z = pitch.z0 + (t * pitch.vz0) + ((Math.pow(t, 2)) * 0.5 * pitch.az0);
    if (isExaggerated) {
        const vx0Adj = ((x * 1.5) - pitch.x0 - (0.5 * ax0Adj * (Math.pow(t, 2)))) / t;
        const vz0Adj = (2.5 + ((z - 2.5) * 1.5) - pitch.z0 - (0.5 * az0Adj * (Math.pow(t, 2)))) / t;
        const xAdj = pitch.x0 + (t * vx0Adj) + ((Math.pow(t, 2)) * 0.5 * ax0Adj);
        const zAdj = pitch.z0 + (t * vz0Adj) + ((Math.pow(t, 2)) * 0.5 * az0Adj);
        return {
            posx: xAdj, posy: y, posz: zAdj, origx: x, origz: z,
        };
    }
    return {
        posx: x, posy: y, posz: z, origx: x, origz: z,
    };
};
// Code to correct break x and z
const getRapsodo9PFitBreaks = (data, extension) => {
    const x0 = Number(data.x0);
    const vx0 = Number(data.speedX);
    const ax0 = Number(data.ax0);
    const vy0 = Number(data.speedY);
    const ay0 = Number(data.ay0);
    const z0 = Number(data.z0);
    const vz0 = Number(data.speedZ);
    const az0 = Number(data.az0);
    // https://dev.azure.com/basesrc/_git/BallCap?path=%2FBallCap%2FServices%2FAnalyticsService.cs
    const ext = extension || 20.5; // use 20.5 extension (40' break) as default unless provided
    const time5055 = ((-1 * vy0) - Math.sqrt((Math.pow(vy0, 2)) - (2 * ay0 * (48.59 - (60.5 - ext))))) / ay0; // time from 50ft to 55ft
    const time50HP = ((-1 * vy0) - Math.sqrt((Math.pow(vy0, 2)) - (2 * ay0 * (48.59 - (17.0 / 12.0))))) / ay0; // Time from 50ft to home plate
    const vx55 = vx0 + (ax0 * time5055); // x velocity at 55ft
    const vz55 = vz0 + (az0 * time5055); // z velocity at 55ft
    const x55 = (0.5 * ax0 * (Math.pow(time5055, 2))) + (vx0 * time5055) + x0; // x position at 55ft
    const z55 = (0.5 * az0 * (Math.pow(time5055, 2))) + (vz0 * time5055) + z0; // z position at 55ft
    let pls = (0.5 * ax0 * (Math.pow(time50HP, 2))) + (vx0 * time50HP) + x0; // horizontal location at front of home plate
    const plh = (0.5 * az0 * (Math.pow(time50HP, 2))) + (vz0 * time50HP) + z0; // vertical location at front of home plate
    let relx = -12 * ((pls - x55) - (vx55 * (time50HP - time5055))); // horizontal movement measured from 55ft P/fx scale
    const relz = 12 * ((plh - z55) - (vz55 * (time50HP - time5055)) // vertical movement measured from 55ft P/fx scale
        + ((32.174 / 2) * (Math.pow((time50HP - time5055), 2))));
    pls *= -1;
    relx *= -1;
    return {
        PlateX: Math.round(pls),
        PlateZ: Math.round(plh),
        BreakX: Math.round(relx),
        BreakZ: Math.round(relz),
    };
};
const mapPitchPaths = (pitchOrPitchArray, islhp, pitchType) => {
    const pitchpaths = new Array();
    const pitchpathsExaggerated = new Array();
    const pitches = Array.isArray(pitchOrPitchArray) ? pitchOrPitchArray : [pitchOrPitchArray];
    pitches.forEach((pit) => {
        if (!isNumber$2(pit.x0, pit.y0, pit.z0, pit.vx0, pit.vy0, pit.vz0, pit.ax0, pit.ay0, pit.az0))
            return;
        const p = pit;
        let pitchcolor = null;
        let opacity = 1;
        let transparent = true;
        if (!p.pitcherid || p.pitcherid <= 2) {
            pitchcolor = 0xcccccc;
            opacity = 0.5;
        }
        else {
            transparent = false;
            let percentage = 0;
            if (pitchType && p.init_speed && (pitchType.maxvelo - pitchType.minvelo) > 0) {
                percentage = Math.max(Math.min((1 + ((p.init_speed - pitchType.midvelo) / ((pitchType.maxvelo - pitchType.minvelo) / 2))) / 2, 1), 0);
            }
            if (percentage > 0.9) {
                pitchcolor = 0xff0000;
            }
            else if (percentage > 0.75) {
                pitchcolor = 0xff5400;
            }
            else if (percentage > 0.5) {
                pitchcolor = 0xff7700;
            }
            else if (percentage > 0.25) {
                pitchcolor = 0xffa200;
            }
            else if (percentage > 0.1) {
                pitchcolor = 0xffd100;
            }
            else {
                pitchcolor = 0xffff00;
            }
        }
        const adjx = islhp ? 11 : -11;
        const adjz = -25;
        const coeff = 3;
        const ax0Adj = adjx + (coeff * (p.ax0 - adjx));
        const az0Adj = adjz + (coeff * (p.az0 - adjz));
        const pitchPath = {
            pitchtype: p.pitchtype,
            pitcherid: p.pitcherid,
            linematerial: pitchcolor
                ? new THREE.LineBasicMaterial({ color: pitchcolor, opacity, transparent })
                : new THREE.LineBasicMaterial({ color: 0x000000, opacity, transparent: true }),
            meshmaterial: pitchcolor
                ? new THREE.MeshBasicMaterial({ color: pitchcolor, opacity, transparent })
                : new THREE.MeshBasicMaterial({ color: 0x000000, opacity, transparent: true }),
            meshphongmaterial: pitchcolor ? new THREE.MeshPhongMaterial({
                color: pitchcolor, specular: 0x222222, shininess: 0, opacity, transparent,
            }) : new THREE.MeshBasicMaterial({ color: 0x000000, opacity, transparent: true }),
            platelocpitch: getPlateLoc$1(p, ax0Adj, az0Adj),
            positions: [],
        };
        const pitchPathExaggerated = Object.assign(Object.assign({}, pitchPath), { platelocpitch: getPlateLoc$1(p, ax0Adj, az0Adj, true), positions: [] });
        let { x0: x, y0: y, z0: z } = p;
        let i = 0;
        while (y > 1.42 && z > 0 && i < 20) {
            x = p.x0 + ((i / 20.0) * p.vx0) + ((Math.pow((i / 20.0), 2)) * 0.5 * p.ax0);
            y = p.y0 + ((i / 20.0) * p.vy0) + ((Math.pow((i / 20.0), 2)) * 0.5 * p.ay0);
            z = p.z0 + ((i / 20.0) * p.vz0) + ((Math.pow((i / 20.0), 2)) * 0.5 * p.az0);
            const vx0Adj = i > 0 ? ((x * 1.5) - p.x0 - (0.5 * ax0Adj * (Math.pow((i / 20.0), 2)))) / (i / 20.0) : 0;
            const vz0Adj = i > 0 ? (2.5 + ((z - 2.5) * 1.5) - p.z0 - (0.5 * az0Adj * (Math.pow((i / 20.0), 2)))) / (i / 20.0) : 0;
            const xAdj = p.x0 + ((i / 20.0) * vx0Adj) + ((Math.pow((i / 20.0), 2)) * 0.5 * ax0Adj);
            const zAdj = p.z0 + ((i / 20.0) * vz0Adj) + ((Math.pow((i / 20.0), 2)) * 0.5 * az0Adj);
            if (y > 1.42 && z > 0) {
                pitchPath.positions.push({ posx: x, posy: y, posz: z });
                pitchPathExaggerated.positions.push({ posx: xAdj, posy: y, posz: zAdj });
            }
            else {
                pitchPath.positions.push(pitchPath.platelocpitch);
                pitchPathExaggerated.positions.push(pitchPathExaggerated.platelocpitch);
            }
            i += 1;
        }
        pitchpaths.push(pitchPath);
        pitchpathsExaggerated.push(pitchPathExaggerated);
    });
    return { pitchpaths, pitchpaths_exaggerated: pitchpathsExaggerated }; // eslint-disable-line camelcase
};

const StyledPitchBreakStats = styled.div `
    display: flex;
    flex-direction: column;
    text-align: right;
    justify-content: space-around;
    b {
        margin-left: 5px;
    }
    ${({ $hasPitchPaths }) => (!$hasPitchPaths ? `
        > div {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            > div + div {
                margin-left: 10px;
                width: 30px;
                text-align: left;
            }
            + div {
                margin-top: 8.5px;
            }
        }
    ` : '')}
`;
const PitchBreakStats = ({ isMobileView, islhp, breakz, breakz54, breakx, breakx54, x0, y0, z0, vx0, vy0, vz0, ax0, ay0, az0 }) => {
    const { t: translate } = useTranslation();
    const pitchPath = useMemo(() => (isMobileView ? null : mapPitchPaths({ x0, y0, z0, vx0, vy0, vz0, ax0, ay0, az0 }, !!islhp)), [isMobileView, x0, y0, z0, vx0, vy0, vz0, ax0, ay0, az0, islhp]);
    const hasPitchPaths = !!(pitchPath === null || pitchPath === void 0 ? void 0 : pitchPath.pitchpaths.length);
    const hasBreak54 = isNumber$2(breakx54, breakz54);
    return (React.createElement("div", { className: "d-flex" },
        React.createElement(StyledPitchBreakStats, { className: `${(pitchPath === null || pitchPath === void 0 ? void 0 : pitchPath.pitchpaths.length) ? 'me-3' : ''}`, "$hasPitchPaths": hasPitchPaths },
            React.createElement("div", null,
                !isMobileView && (React.createElement("div", null, translate('components.video.horizontal'))),
                React.createElement("div", null,
                    translate('baseball.break-x'),
                    ":",
                    React.createElement("b", null, format(hasBreak54 ? breakx54 : breakx, 1)))),
            React.createElement("div", null,
                !isMobileView && (React.createElement("div", null, translate('components.video.vertical'))),
                React.createElement("div", null,
                    translate('baseball.break-z'),
                    ":",
                    React.createElement("b", null, format(hasBreak54 ? breakz54 : breakz, 1))))),
        hasPitchPaths && (React.createElement(WebGLPathDisplay, { width: 100, height: 112, pitches: pitchPath.pitchpaths, disableControls: true }))));
};

const StyledPitchSpinStats = styled.div `
`;
const PitchSpinStats = (props) => {
    const { t: translate } = useTranslation();
    const tiltRow = props.tilt && (React.createElement("tr", null,
        React.createElement("th", null, translate('components.video.tilt')),
        React.createElement("td", null, props.tilt)));
    const totalSpinRow = props.spinrate > 0 && (React.createElement("tr", null,
        React.createElement("th", null, translate('components.video.total-spin')),
        React.createElement("td", null, format(props.spinrate))));
    const transverseSpinRow = props.transversespin && props.spinrate > 0 && (React.createElement("tr", null,
        React.createElement("th", null, translate('components.video.transverse')),
        React.createElement("td", null, percent(ratio(props.transversespin, props.spinrate), 1))));
    const gyrospinRow = props.gyrospin && (React.createElement("tr", null,
        React.createElement("th", null, translate('components.video.gyro-spin')),
        React.createElement("td", null, format(props.gyrospin))));
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledPitchSpinStats, { className: `pitch-spin-stats ${!props.isMobileView && isNumber$2(props.phi, props.theta) ? 'me-3' : ''}` },
            !props.isMobileView && (React.createElement("table", null,
                React.createElement("tbody", null,
                    tiltRow,
                    totalSpinRow,
                    transverseSpinRow,
                    gyrospinRow))),
            props.isMobileView && (React.createElement("table", null,
                React.createElement("tbody", null,
                    tiltRow,
                    totalSpinRow))),
            props.isMobileView && (transverseSpinRow || gyrospinRow) && (React.createElement("table", null,
                React.createElement("tbody", null,
                    transverseSpinRow,
                    gyrospinRow)))),
        !props.isMobileView && isNumber$2(props.phi, props.theta) && (React.createElement(BallSpin, { size: 112, phi: props.phi, theta: props.theta }))));
};

const StyledPitchInPlayStats = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: ${({ $hasLocation }) => ($hasLocation ? 'space-between' : 'center')};
    height: 100%;
    && {
        p {
            margin-bottom: 0;
        }
    }
`;
const PitchInPlayStats = (props) => {
    const { t: translate } = useTranslation();
    const hasBallInPlayLoc = isNumber$2(props.ballinplayx, props.ballinplayy);
    const hitProperties = [
        isNumber$2(props.hitvelocity) ? `${translate('format.abbr-mph', { value: format(props.hitvelocity, 1) })}` : null,
        isNumber$2(props.launchangle) ? `${format(props.launchangle, 1)}°` : null,
        isNumber$2(props.distance) ? `${format(props.distance, 0)}${translate('components.video.filters.abbr-feet')}` : null,
    ].filter((x) => x);
    return (React.createElement(StyledPitchInPlayStats, { "$hasLocation": hasBallInPlayLoc },
        React.createElement("div", null,
            React.createElement("p", null,
                React.createElement("b", null,
                    hitType(props.hittype, true, translate),
                    isNumber$2(props.bipfielderpos) && props.bipfielderpos > 0 ? ` ${translate('common.to')} ${positionName(props.bipfielderpos, translate)}` : '')),
            !!hitProperties.length && React.createElement("p", null,
                "(",
                hitProperties.join(', '),
                ")"),
            props.eventdescription && React.createElement("p", null,
                translate('components.video.result'),
                ": ",
                React.createElement("b", null, props.eventdescription))),
        hasBallInPlayLoc && (React.createElement(HitLocation, { ballinplayx: props.ballinplayx, ballinplayy: props.ballinplayy, ishr: !!props.ishr }))));
};

const VerticalRule = styled.div `
    border-left: 1px solid ${theme.border.paleSky};
    width: 1px;
    flex-grow: 0;
`;
const StyledVideoStatsSection = styled.div `
    display: flex;
    align-items: center;
    font-size: 12px;
    table {
        th, td {
            padding: 2.5px;
        }
        th {
            text-align: right;
            font-weight: normal;
        }
        td {
            font-weight: bold;
            text-align: left;
        }
    }
`;
const StyledPitchInfoSection = styled(StyledVideoStatsSection) `
    table tr td:nth-of-type(2) {
        text-align: right;
    }
`;
const StyledPitchLocationSection = styled(StyledVideoStatsSection) `
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;
const StyledVideoStats = styled.div `
    height: ${statsContainerHeight}px;
    position: relative;
    background-color: ${theme.background.blueZodiac};
    display: flex;
    justify-content: space-around;
    padding: 10px 0;
    color: white;
    ${VerticalRule} {
        opacity: 0.4;
    }
    .spinner-border, .no-data-message {
        margin-top: 47.5px;
    }
`;
const VideoStats = ({ data, containerWidth, isMobileView = false, loading = false, isFullScreenMode = false }) => {
    const { t: translate } = useTranslation();
    const sections = [];
    if (!loading && data) {
        if (!isMobileView && (data.batter || data.pitcher || data.pitchtime || data.gamedate)) {
            sections.push(React.createElement(StyledPitchInfoSection, null,
                React.createElement(PitchInfoStats, Object.assign({}, data))));
        }
        sections.push(React.createElement(StyledPitchLocationSection, null,
            React.createElement(PitchTypeLocationStats, Object.assign({ isMobileView: isMobileView }, data))));
        if (isNumber$2(data.breakz, data.breakx)) {
            const { breakx, breakz } = data, rest = __rest(data, ["breakx", "breakz"]);
            sections.push(React.createElement(StyledVideoStatsSection, null,
                React.createElement(PitchBreakStats, Object.assign({ isMobileView: isMobileView, breakx: breakx, breakz: breakz }, rest))));
        }
        if (isNumber$2(data.spinrate)) {
            const { spinrate } = data, rest = __rest(data, ["spinrate"]);
            sections.push(React.createElement(StyledVideoStatsSection, null,
                React.createElement(PitchSpinStats, Object.assign({ isMobileView: isMobileView, spinrate: spinrate }, rest))));
        }
        if (!!data.islastpitch && isNumber$2(data.hittype)) {
            const { hittype } = data, rest = __rest(data, ["hittype"]);
            sections.push(React.createElement(StyledVideoStatsSection, null,
                React.createElement(PitchInPlayStats, Object.assign({ hittype: hittype }, rest))));
        }
    }
    if (sections.length === 5 && isNumber$2(containerWidth) && containerWidth < bootstrapLg) {
        sections.splice(0, 1);
    }
    return (React.createElement(StyledVideoStats, { fullscreen: isFullScreenMode },
        loading && React.createElement(LoadingSpinner$1, null),
        !loading && !sections.length && (React.createElement("div", { className: "no-data-message" }, translate('components.video.no-data-found'))),
        !loading && !!sections.length && sections.map((section, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(React.Fragment, { key: idx },
            idx > 0 && !isMobileView && React.createElement(VerticalRule, null),
            section)))));
};
const videoStatsMemo = memo(VideoStats, (prevProps, nextProps) => {
    var _a, _b, _c, _d, _e, _f;
    return ((_a = prevProps.data) === null || _a === void 0 ? void 0 : _a.gameid) === ((_b = nextProps.data) === null || _b === void 0 ? void 0 : _b.gameid)
        && ((_c = prevProps.data) === null || _c === void 0 ? void 0 : _c.eventseq) === ((_d = nextProps.data) === null || _d === void 0 ? void 0 : _d.eventseq)
        && ((_e = prevProps.data) === null || _e === void 0 ? void 0 : _e.pitchseq) === ((_f = nextProps.data) === null || _f === void 0 ? void 0 : _f.pitchseq)
        && prevProps.isFullScreenMode === nextProps.isFullScreenMode
        && prevProps.loading === nextProps.loading
        && prevProps.containerWidth === nextProps.containerWidth;
});

const buttonHeight = 40;
const buttonMargin = 9;
const StyledVideoToggleButtons = styled(ToggleButtons) `
    padding-right: 16px;
    flex-wrap: ${(props) => (props.$numRows > 1 ? 'wrap' : '')};
    flex-direction: ${(props) => (props.$numRows > 1 ? 'column' : 'row')};
    ${(props) => `max-height: ${props.$numRows * (buttonHeight + buttonMargin)}px;`}
    &&& {
        .btn {
            flex: 0 0 auto;
            width: 42px;
            height: ${buttonHeight}px;
            font-size: 14px;
            margin-bottom: ${buttonMargin}px;
            display: flex;
            align-items: center;
            justify-content: center;
            ${(props) => (props.$includeAll ? `
                &:first-of-type {
                    height: ${(props.$numRows * (buttonHeight + buttonMargin)) - buttonMargin}px;
                    padding: 
                }
            ` : '')}
            &.disabled, :disabled {
                box-shadow: none;
            }
            &:not(:first-of-type) {
                width: ${(props) => (isNumber$2(props.$width) ? (`${props.$width || 42}px`) : props.$width)};
            }
        }
    }
`;
const VideoFilterToggleButton = ({ filter, name, options, playlist, onChange, rows, includeAll = true, type = 'checkbox', defaultValue = -1, width, ignoreSort = false }) => {
    const filterOptions = [...options];
    if (includeAll) {
        filterOptions.unshift({ name: 'All', value: -1 });
    }
    const numRows = rows || (Math.floor(filterOptions.length / 6) + 1);
    const mappedOptions = filterOptions.map((o, idx) => {
        const option = typeof o === 'object' ? o : { name: o.toString(), value: o };
        return Object.assign(Object.assign({}, option), { idx, disabled: playlist === null ? false : (playlist != null && option.value !== -1 && !playlist.some(({ data }) => {
                var _a, _b;
                if (name === 'bcbefore' && option.value)
                    return !!data.bcbefore;
                if (name === 'inning' && option.value === 10)
                    return data.inning >= 10;
                if (name === 'sourceLabels')
                    return (_a = data[name]) === null || _a === void 0 ? void 0 : _a.includes((_b = option.value) === null || _b === void 0 ? void 0 : _b.toString());
                return data[name] === option.value;
            })) });
    }).sort((a, b) => {
        if (numRows === 1 || ignoreSort)
            return 0;
        if (includeAll && a.idx === 0)
            return -1;
        if (includeAll && b.idx === 0)
            return 1;
        const numCols = includeAll ? 5 : 6;
        return ((a.idx - (includeAll ? 1 : 0)) % numCols) - ((b.idx - (includeAll ? 1 : 0)) % numCols);
    });
    return (React.createElement(StyledVideoToggleButtons, { "$includeAll": includeAll, "$numRows": numRows, "$width": width, name: name, type: type, options: mappedOptions, value: filter && filter[name], onChange: (value, btnName) => onChange(value, btnName, type === 'checkbox'), defaultValue: defaultValue, separated: true }));
};

const StyledVideoFilterSection$1 = styled.div `
    padding: 12px 12px 0 0;
    text-align: left;
    label {
        font-size: 11px;
        padding-right: 7px;
        text-align: right;
        color: ${theme.fontColors.tundora};
    }
    .filter-title {
        margin-bottom:2px;
        text-align: left;
        label {
            font-weight: bold;
            margin-bottom: 0;
            width: initial;
        }
    }
    && {
        .btn.btn-link {
            padding: 0;
            line-height: 0;
            position: relative;
            top: -1.5px;
        }
    }
`;
const VideoFilterSection$1 = ({ title, children, playlist, requiredFields, onClear, className }) => {
    const { t: translate } = useTranslation();
    const fields = Array.isArray(requiredFields) ? requiredFields : [requiredFields];
    const hasAnyDataWithFields = playlist.some(({ data }) => fields.every((f) => data[f] !== null && data[f] !== undefined));
    return (React.createElement(React.Fragment, null, hasAnyDataWithFields && (React.createElement(StyledVideoFilterSection$1, { className: className },
        React.createElement("div", { className: "filter-title" },
            React.createElement("label", null, title),
            onClear && React.createElement(Button, { variant: "link", size: "sm", onClick: onClear },
                "(",
                translate('common.clear'),
                ")")),
        children))));
};

const StyledVideoFilterBaseRunners = styled.div `
    display: flex;
    justify-content: space-between;
    align-items: start;
    margin-bottom: ${filterMarginBottom};
    ${StyledVideoToggleButtons} {
        .btn {
            &:first-of-type, &:last-of-type {
                margin-bottom: 0 !important;
            }
            &:not(:first-of-type) {
                width: 87.5px !important;
            }
        }
    }
    svg {
        margin-right: 15px;
    }
`;
const VideoFilterBaseRunners = ({ playlist, onChange, filter, rows = 1 }) => {
    const { t: translate } = useTranslation();
    const basesEmptyOptions = [{ name: translate('components.video.filters.none-on'), value: 0, id: 'baserunners-0' }, { name: translate('components.video.filters.some-on'), value: 1, id: 'baserunners-1' }];
    const onHasRunnersChange = (value) => {
        onChange(value, 'hasRunners');
        onChange(null, 'bcbefore');
    };
    const onBaseRunnersChange = (value) => {
        onChange(value ? null : undefined, 'hasRunners');
        onChange(value || undefined, 'bcbefore');
    };
    return (React.createElement(StyledVideoFilterBaseRunners, null,
        React.createElement(VideoFilterToggleButton, { filter: filter, name: "hasRunners", onChange: (value) => onHasRunnersChange(value), options: basesEmptyOptions, playlist: playlist, rows: rows, type: "radio" }),
        React.createElement(BaseRunners, { baseState: filter.bcbefore === true ? 0 : filter.bcbefore, onChange: (value) => onBaseRunnersChange(value), emptyColor: theme.border.mercury })));
};

const VideoFilterSectionTitle = ({ title }) => (React.createElement("div", { className: "border-top text-start mt-4 pt-2" }, title));

const StyledVideoFilterSection = styled.div `
    display: flex;
    align-items: center;
    padding: 12px 0 0 0;
    text-align: left;
    label {
        font-size: 11px;
        padding-right: 7px;
        text-align: right;
        color: ${theme.fontColors.tundora};
    }
    .filter-title {
        margin-bottom:2px;
        text-align: left;
        label {
            font-weight: bold;
            margin-bottom: 0;
            width: initial;
        }
    }
    && {
        .btn.btn-link {
            padding: 0;
            line-height: 0;
            position: relative;
            top: -1.5px;
        }
        .btn.btn-default {
            background-color: ${theme.background.geyser};
        }
    }
`;
const VideoFilterSection = ({ title, children, playlist, requiredFields, onClear, className, filter, filterFields }) => {
    const fields = Array.isArray(requiredFields) ? requiredFields : [requiredFields];
    const visibleFields = filterFields ? (Array.isArray(filterFields) ? filterFields : [filterFields]) : fields;
    const [isVisible, setIsVisible] = useState(!!visibleFields
        .every((f) => Object.keys(filter).find((k) => k === f) && filter[f] !== null && filter[f] !== undefined));
    const hasAnyDataWithFields = playlist.some(({ data }) => fields.every((f) => data[f] !== null && data[f] !== undefined));
    const updateIsVisible = () => {
        if (isVisible && onClear) {
            onClear();
        }
        setIsVisible(!isVisible);
    };
    return (React.createElement(React.Fragment, null, hasAnyDataWithFields && (React.createElement(StyledVideoFilterSection, { className: className },
        React.createElement(Row, { className: "w-100 align-items-center" },
            React.createElement(Col, { sm: 4 },
                React.createElement(Button, { variant: isVisible ? 'primary' : 'default', onClick: updateIsVisible, className: "me-2 flex-shrink-0 shadow-none border-0 p-2 font-weight-bold rounded", size: undefined }, title)),
            React.createElement(Col, { sm: 8 }, isVisible && children))))));
};

const VideoFilterRange = ({ filter, name, onChange, playlist, step, margin }) => {
    const pitchesWithData = playlist.filter(({ data }) => isNumber$2(data[name]));
    let min = 0;
    let max = 0;
    if (pitchesWithData.length) {
        min = Math.min(...pitchesWithData.map(({ data }) => data[name]));
        max = Math.max(...pitchesWithData.map(({ data }) => data[name]));
    }
    const onInputChange = ([newMin, newMax]) => {
        if (newMin <= min && newMax >= max) {
            onChange(undefined, name);
        }
        else {
            onChange(newMin, `${name}.min`);
            onChange(newMax, `${name}.max`);
        }
    };
    return (React.createElement("div", null,
        React.createElement(Range, { showInput: true, min: Math.floor(min), max: Math.ceil(max), value: filter[name] ? [filter[name].min, filter[name].max] : undefined, onChange: onInputChange, step: step, margin: margin })));
};

const VideoFilterPitchLocation = ({ locations, playlist, onChange }) => {
    const { t: translate } = useTranslation();
    const pitchLocationOpts = playlist.map((p) => p.data).filter((x) => x.locationx && x.locationy);
    return (React.createElement(React.Fragment, null,
        React.createElement("label", null,
            translate('baseball.1b'),
            " ",
            translate('components.video.filters.side')),
        React.createElement(PitchLocation$1, { options: pitchLocationOpts, locations: locations, onChange: (value) => onChange(value, 'pitchLocations'), emptyColor: theme.border.mercury }),
        React.createElement("label", null,
            translate('baseball.3b'),
            " ",
            translate('components.video.filters.side'))));
};

const StyledAdvancedIconContainer$3 = styled.div `
    width: 100%;
    margin-bottom: ${filterMarginBottom};
    svg {
        margin-left: ${filterMarginBottom};
        margin-right: ${filterMarginBottom};
    }
    label {
        white-space: nowrap;
    }
`;
const PitchingFilters$1 = ({ filter, playlist, onChange, onClear }) => {
    var _a;
    const { t: translate } = useTranslation();
    return (React.createElement("div", null,
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.pitch-location'), playlist: playlist, requiredFields: ['locationx', 'locationy'], filterFields: "pitchLocations", onClear: ((_a = filter.pitchLocations) === null || _a === void 0 ? void 0 : _a.length) ? () => onClear('pitchLocations') : undefined, filter: filter },
            React.createElement(StyledAdvancedIconContainer$3, null,
                React.createElement(VideoFilterPitchLocation, { playlist: playlist, locations: filter.pitchLocations, onChange: onChange }))),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.pitch-velo'), playlist: playlist, requiredFields: "velocity", onClear: () => onClear('velocity'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "velocity", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.spin-rate'), playlist: playlist, requiredFields: "spinrate", onClear: () => onClear('spinrate'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "spinrate", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.break') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.vertical-break'), playlist: playlist, requiredFields: "breakz54", onClear: () => onClear('breakz54'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "breakz54", onChange: onChange, playlist: playlist, step: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.horizontal-break'), playlist: playlist, requiredFields: "breakx54", onClear: () => onClear('breakx54'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "breakx54", onChange: onChange, playlist: playlist, step: 0.1 })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.release') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.horizontal-release'), playlist: playlist, requiredFields: "initposx_55", onClear: () => onClear('initposx_55'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "initposx_55", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.vertical-release'), playlist: playlist, requiredFields: "initposz_55", onClear: () => onClear('initposz_55'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "initposz_55", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.abbr-earned-run-avg') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.rv-era'), playlist: playlist, requiredFields: "rvactualNorm", onClear: () => onClear('rvactualNorm'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "rvactualNorm", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.01 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.expected-rv-era'), playlist: playlist, requiredFields: "rvexpNorm", onClear: () => onClear('rvexpNorm'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "rvexpNorm", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.pfx-era'), playlist: playlist, requiredFields: "rvpitchfxNorm", onClear: () => onClear('rvpitchfxNorm'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "rvpitchfxNorm", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.break-era'), playlist: playlist, requiredFields: "rvbreakNorm", onClear: () => onClear('rvbreakNorm'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "rvbreakNorm", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.stuff-era'), playlist: playlist, requiredFields: "rvstuffNorm", onClear: () => onClear('rvstuffNorm'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "rvstuffNorm", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.location-era'), playlist: playlist, requiredFields: "rvlocNorm", onClear: () => onClear('rvlocNorm'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "rvlocNorm", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 }))));
};

const StyledAdvancedIconContainer$2 = styled.div `
    width: 100%;
    margin-bottom: ${filterMarginBottom};
    svg {
        margin-left: ${filterMarginBottom};
        margin-right: ${filterMarginBottom};
    }
    label {
        white-space: nowrap;
    }
`;
const StyledHitLocationContainer$1 = styled(StyledAdvancedIconContainer$2) `
    position: relative;
    && {
        .btn-group {
            position: static;
            .btn {
                position: absolute;
                &:nth-of-type(1) { left: 0; } 
                &:nth-of-type(3) { left: 40px; } 
                &:nth-of-type(2) { left: 246px; } 
                &:nth-of-type(4) { left: 204px; } 
                &:nth-of-type(1), &:nth-of-type(2) { bottom: 55px; } 
                &:nth-of-type(3), &:nth-of-type(4) { bottom: 5px; }
            }
        }
    }
    &&&& {
        .btn-group .btn {
            margin: 0;
        }
    }
`;
const HittingFilters$1 = ({ filter, playlist, onChange, onClear }) => {
    var _a;
    const { t: translate } = useTranslation();
    const hitTypeOptions = [{ name: translate('baseball.pitchresult.abbr-groundball'), value: 0 }, { name: translate('baseball.pitchresult.abbr-flyball'), value: 1 }, { name: translate('baseball.pitchresult.abbr-popup'), value: 3 }, { name: translate('baseball.pitchresult.abbr-linedrive'), value: 2 }];
    return (React.createElement("div", null,
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.hit-location'), playlist: playlist, requiredFields: ['hittype', 'isinfieldbip', 'distance', 'angleto2b', 'ishr'], filterFields: "hitLocations", onClear: ((_a = filter.hitLocations) === null || _a === void 0 ? void 0 : _a.length) ? () => onClear('hitLocations') : undefined, filter: filter },
            React.createElement("div", null,
                React.createElement(StyledHitLocationContainer$1, null,
                    React.createElement(HitLocationSelect, { data: playlist.map((x) => x.data), value: filter.hitLocations, onChange: (value) => onChange(value, 'hitLocations'), emptyColor: theme.border.mercury }),
                    React.createElement(VideoFilterToggleButton, { filter: filter, name: "hittype", onChange: onChange, options: hitTypeOptions, playlist: playlist, includeAll: false })))),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.exit-velo'), playlist: playlist, requiredFields: "hitvelocity", onClear: () => onClear('hitvelocity'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "hitvelocity", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.contact') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.contact-result'), playlist: playlist, requiredFields: "contactResult", onClear: () => onClear('contactResult'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "contactResult", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.contact-quality'), playlist: playlist, requiredFields: "contactQuality", onClear: () => onClear('contactQuality'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "contactQuality", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.launch-angle') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.vert-launch-angle'), playlist: playlist, requiredFields: "vertla", onClear: () => onClear('vertla'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "vertla", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.horizontal-launch-angle'), playlist: playlist, requiredFields: "horizla", onClear: () => onClear('horizla'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "horizla", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.zone') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.zone-depth'), playlist: playlist, requiredFields: "zonedepth", onClear: () => onClear('zonedepth'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "zonedepth", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.swing') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.swinging'), playlist: playlist, requiredFields: "swinging", onClear: () => onClear('swinging'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "swinging", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.swinging-first-pitch'), playlist: playlist, requiredFields: "swingingFirstPitch", onClear: () => onClear('swingingFirstPitch'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "swingingFirstPitch", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.swinging-in-zone'), playlist: playlist, requiredFields: "swingingInZone", onClear: () => onClear('swingingInZone'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "swingingInZone", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.chase'), playlist: playlist, requiredFields: "chase", onClear: () => onClear('chase'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "chase", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.miss'), playlist: playlist, requiredFields: "miss", onClear: () => onClear('miss'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "miss", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.miss-in-zone'), playlist: playlist, requiredFields: "missInZone", onClear: () => onClear('missInZone'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "missInZone", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.in-zone'), playlist: playlist, requiredFields: "inZone", onClear: () => onClear('inZone'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "inZone", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.strikeout'), playlist: playlist, requiredFields: "strikeout", onClear: () => onClear('strikeout'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "strikeout", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.unintentional-walk'), playlist: playlist, requiredFields: "unintentionalWalk", onClear: () => onClear('unintentionalWalk'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "unintentionalWalk", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.swing-decision-score') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.score'), playlist: playlist, requiredFields: "swds", onClear: () => onClear('swds'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "swds", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: `${translate('components.video.filters.score')} (${translate('components.video.filters.should-swing')})`, playlist: playlist, requiredFields: "swingDecisionScoreShouldSwing", onClear: () => onClear('swingDecisionScoreShouldSwing'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "swingDecisionScoreShouldSwing", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: `${translate('components.video.filters.score')} (${translate('components.video.filters.should-take')})`, playlist: playlist, requiredFields: "swingDecisionScoreShouldTake", onClear: () => onClear('swingDecisionScoreShouldTake'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "swingDecisionScoreShouldTake", onChange: onChange, playlist: playlist }))));
};

const FieldingFilters$1 = ({ filter, playlist, onChange, onClear }) => {
    const { t: translate } = useTranslation();
    return (React.createElement("div", null,
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.fielder-approach'), playlist: playlist, requiredFields: "fapproach", onClear: () => onClear('fapproach'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fapproach", onChange: onChange, options: [translate('components.video.filters.stand'), translate('components.video.filters.sprint'), translate('components.video.filters.dive'), translate('components.video.filters.jog'), translate('components.video.filters.jump'), translate('components.video.filters.slide')], playlist: playlist, width: 50 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.fielding-method'), playlist: playlist, requiredFields: "fmethod", onClear: () => onClear('fmethod'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fmethod", onChange: onChange, options: [translate('components.video.filters.backhand'), translate('components.video.filters.barehand'), translate('components.video.filters.forehand'), translate('components.video.filters.no-touch'), translate('components.video.filters.over-shoulder')], playlist: playlist, width: 120 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.fielder-movement'), playlist: playlist, requiredFields: "fmove", onClear: () => onClear('fmove'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fmove", onChange: onChange, options: [translate('components.video.filters.back'), translate('components.video.filters.forward'), translate('components.video.filters.right'), translate('components.video.filters.left'), translate('components.video.filters.no-move')], playlist: playlist, width: 85 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.fielder-throw'), playlist: playlist, requiredFields: "fthrow", onClear: () => onClear('fthrow'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fthrow", onChange: onChange, options: [translate('components.video.filters.feet-planted'), translate('components.video.filters.on-move'), translate('components.video.filters.jump-throw'), translate('components.video.filters.from-ground'), translate('components.video.filters.glove-flip')], playlist: playlist, width: 120 })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.difficulty') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.difficulty-opps'), playlist: playlist, requiredFields: "diffopps", onClear: () => onClear('diffopps'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "diffopps", onChange: onChange, options: [1, 2, 3, 4, 5], playlist: playlist, rows: 1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.difficulty-made'), playlist: playlist, requiredFields: "diffmade", onClear: () => onClear('diffmade'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "diffmade", onChange: onChange, options: [1, 2, 3, 4, 5], playlist: playlist, rows: 1 })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.alignment') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.has-shift'), playlist: playlist, requiredFields: "hasShift", onClear: () => onClear('hasShift'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "hasShift", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.runners-on'), playlist: playlist, requiredFields: "runnersOn", onClear: () => onClear('runnersOn'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "runnersOn", onChange: onChange, options: [translate('common.yes'), translate('common.no')], playlist: playlist })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.throw') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.throw-velocity'), playlist: playlist, requiredFields: "throwvelo", onClear: () => onClear('throwvelo'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "throwvelo", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.exchange'), playlist: playlist, requiredFields: "exchange", onClear: () => onClear('exchange'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "exchange", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.route') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.starting-depth'), playlist: playlist, requiredFields: "startingdepth", onClear: () => onClear('startingdepth'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "startingdepth", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.route-efficiency'), playlist: playlist, requiredFields: "routeeffic", onClear: () => onClear('routeeffic'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "routeeffic", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.first-step'), playlist: playlist, requiredFields: "firststep", onClear: () => onClear('firststep'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "firststep", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.first-step-efficiency'), playlist: playlist, requiredFields: "firststepeffic", onClear: () => onClear('firststepeffic'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "firststepeffic", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.top-speed'), playlist: playlist, requiredFields: "topspeed", onClear: () => onClear('topspeed'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "topspeed", onChange: onChange, playlist: playlist, step: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.sprint-speed'), playlist: playlist, requiredFields: "sprintspeed", onClear: () => onClear('sprintspeed'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "sprintspeed", onChange: onChange, playlist: playlist, step: 0.1 })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.distance-covered'), playlist: playlist, requiredFields: "distcovered", onClear: () => onClear('distcovered'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "distcovered", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.top-acceleration'), playlist: playlist, requiredFields: "topacceladj", onClear: () => onClear('topacceladj'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "topacceladj", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.probabilities') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.catch-probability'), playlist: playlist, requiredFields: "catchprobability", onClear: () => onClear('catchprobability'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "catchprobability", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.out-probability'), playlist: playlist, requiredFields: "outProbability", onClear: () => onClear('outProbability'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "outProbability", onChange: onChange, playlist: playlist })),
        React.createElement(VideoFilterSectionTitle, { title: translate('components.video.filters.other') }),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.hang-time'), playlist: playlist, requiredFields: "hangtime", onClear: () => onClear('hangtime'), filter: filter },
            React.createElement(VideoFilterRange, { filter: filter, name: "hangtime", onChange: onChange, playlist: playlist, step: 0.01, margin: 0.1 }))));
};

const OtherFilters$1 = ({ filter, playlist, onChange, onClear }) => {
    const { t: translate } = useTranslation();
    const sourceLabelOptions = Array
        .from((new Set(playlist.map((v) => { var _a, _b; return (_b = (_a = v.data.sourceLabels) === null || _a === void 0 ? void 0 : _a.filter((l) => l)) !== null && _b !== void 0 ? _b : []; }).flat())))
        .sort((a, b) => a.localeCompare(b));
    return (React.createElement("div", null,
        React.createElement(VideoFilterSection, { title: translate('baseball.inning'), playlist: playlist, requiredFields: "inning", onClear: () => onClear('inning'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "inning", onChange: onChange, options: [1, 2, 3, 4, 5, 6, 7, 8, 9, { name: '10+', value: 10 }], playlist: playlist })),
        React.createElement(VideoFilterSection, { title: translate('components.video.filters.video-angle'), playlist: playlist, requiredFields: "sourceLabels", onClear: () => onClear('sourceLabels'), filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "sourceLabels", onChange: onChange, options: sourceLabelOptions, playlist: playlist, width: 200, rows: Math.ceil(sourceLabelOptions.length / 3.0), ignoreSort: true }))));
};

const videoFilterPadding = '0 15px 15px';
const StyledVideoFilterHeader = styled.div `
    ${sideContentHeader}
    > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid ${theme.border.alto};
    }
`;
const StyledVideoFilterFilters = styled.div `
    flex-grow: 1;
    position: relative;
    > div {
        padding: ${videoFilterPadding};
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        overflow-y: auto;
    }
`;
const StyledVideoFilterFooter = styled.div `
    ${sideContentFooter}
    display: flex;
    justify-content: end;
    position: sticky;
    bottom: -11px;
    z-index: 1;
`;
const StyledVideoFilter = styled.div `
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    z-index: 10;
`;
const StyledVideoFilterContainer = styled.div `
    ${fullscreenSectionMixin}
    ${StyledVideoFilter} {
        height: 100%;
        background-color: white;
    }
`;
const tabs = (translate) => [
    {
        title: translate('components.video.filters.pitching'),
        key: 'pitching',
        filterKeys: ['pitchLocations', 'velocity', 'breakz54', 'breakx54', 'spinrate', 'initposx_55', 'initposz_55', 'rvactualNorm',
            'rvexpNorm', 'rvpitchfxNorm', 'rvbreakNorm', 'rvstuffNorm', 'rvlocNorm'],
        component: ({ filter, playlist, onChange, onClear }) => (React.createElement(PitchingFilters$1, { filter: filter, playlist: playlist, onChange: onChange, onClear: onClear })),
    },
    {
        title: translate('components.video.filters.hitting'),
        key: 'hitting',
        filterKeys: ['hitLocations', 'hitvelocity', 'hittype', 'contactResult', 'contactQuality', 'vertla', 'horizla', 'zonedepth',
            'swinging', 'swingingFirstPitch', 'swingingInZone', 'chase', 'miss', 'missInZone', 'inZone', 'strikeout', 'unintentionalWalk',
            'swds', 'swingDecisionScoreShouldSwing', 'swingDecisionScoreShouldTake'],
        component: ({ filter, playlist, onChange, onClear }) => (React.createElement(HittingFilters$1, { filter: filter, playlist: playlist, onChange: onChange, onClear: onClear })),
    },
    {
        title: translate('components.video.filters.fielding'),
        filterKeys: ['fapproach', 'fmethod', 'fmove', 'fthrow', 'diffopps', 'diffmade', 'hasShift', 'runnersOn', 'throwvelo', 'exchange',
            'startingdepth', 'routeeffic', 'firststep', 'firststepeffic', 'topspeed', 'sprintspeed', 'distcovered', 'topacceladj',
            'catchprobability', 'outProbability', 'hangtime'],
        key: 'fielding',
        component: ({ filter, playlist, onChange, onClear }) => (React.createElement(FieldingFilters$1, { filter: filter, playlist: playlist, onChange: onChange, onClear: onClear })),
    },
    {
        title: translate('components.video.filters.other'),
        filterKeys: ['inning', 'sourceLabels'],
        key: 'other',
        component: ({ filter, playlist, onChange, onClear }) => (React.createElement(OtherFilters$1, { filter: filter, playlist: playlist, onChange: onChange, onClear: onClear }))
    },
];
const VideoFilter = ({ filter: appliedFilter, onFilter, playlist, isFullScreenMode, isMobileView, hideDisplay }) => {
    const { t: translate } = useTranslation();
    const pitchTypeOptions = PITCH_TYPES(translate)
        .filter((p) => p.sortorder > 0 && p.sortorder < 20)
        .sort((a, b) => a.sortorder - b.sortorder)
        .map((p) => ({ name: p.abbr, value: p.id }));
    const lhpOptions = [{ name: translate('baseball.lhp'), value: 1 }, { name: translate('baseball.rhp'), value: 0 }];
    const lhbOptions = [{ name: translate('baseball.lhh'), value: 1 }, { name: translate('baseball.rhh'), value: 0 }];
    const [filter, setFilter] = useState(appliedFilter);
    const [activeTabKey, setActiveTabKey] = useState(tabs(translate)[0].key);
    const onTabSelect = ({ key }) => setActiveTabKey(key);
    const activeTab = tabs(translate).find(({ key }) => key === activeTabKey);
    const onApply = (appliedPlaylist, tempFilter) => {
        onFilter(appliedPlaylist, Object.assign({}, tempFilter));
        hideDisplay();
    };
    const onCancel = () => {
        setFilter(Object.assign({}, appliedFilter));
        hideDisplay();
    };
    const onChange = (value, name, isMultiselect) => setFilter((tempFilter) => {
        var _a;
        let newValue = value;
        if (isMultiselect) {
            // scenario 1: all options are deselected
            if (Array.isArray(newValue) && !newValue.length) {
                newValue = [-1];
            }
            else {
                const newDestinctOptions = newValue.filter((v) => !isSelectAllValue(v));
                if (newDestinctOptions.length) {
                    const numOldDistinctOptions = ((_a = tempFilter[name]) === null || _a === void 0 ? void 0 : _a.filter((v) => !isSelectAllValue(v)).length) || 0;
                    // scenario 2: Only "All" was checked and user selects an individual value to filter by
                    if (!numOldDistinctOptions)
                        newValue = newDestinctOptions;
                    // scenario 3: options were filtered, and user wants to go back to "All"
                    else if (numOldDistinctOptions && Array.isArray(newValue) && newValue.length > newDestinctOptions.length)
                        newValue = [-1];
                    // scenario 4: multiple non-"All" values are selected
                    // (do nothing)
                }
            }
        }
        return set(tempFilter, name, newValue);
    });
    const onClear = (name) => setFilter((tempFilter) => (Object.assign(Object.assign({}, tempFilter), { [name]: undefined })));
    const onClearAll = () => {
        setFilter({});
        onApply(playlist, {});
    };
    const playlistToBeApplied = filterPlaylistFromParams(playlist, filter);
    const numAppliedFilters = (filterKeys) => Object.entries(filter)
        .filter(([key]) => { var _a; return (_a = filterKeys === null || filterKeys === void 0 ? void 0 : filterKeys.includes(key)) !== null && _a !== void 0 ? _a : true; })
        .filter(([, f]) => {
        const filterAsArray = Array.isArray(f) ? f : [f];
        return filterAsArray.some((x) => !isSelectAllValue(x));
    }).length;
    return (React.createElement(StyledVideoFilterContainer, { className: `${isFullScreenMode ? 'fullscreen' : ''} ${isMobileView ? 'mobile-view' : ''}`, fullscreen: isFullScreenMode, onClick: isFullScreenMode ? hideDisplay : undefined },
        React.createElement(StyledVideoFilter, { onClick: (e) => e.stopPropagation() },
            React.createElement(StyledVideoFilterHeader, null,
                React.createElement("div", null,
                    React.createElement("h4", null,
                        translate('components.video.filters.filters'),
                        " (",
                        numAppliedFilters(),
                        ")"),
                    React.createElement(VideoPlayerButton$1, { icon: "cross", onClick: onCancel, className: "border-0" }))),
            React.createElement(StyledVideoFilterFilters, null,
                React.createElement("div", { className: "h-100 w-100" },
                    React.createElement("div", { className: "container d-flex flex-wrap align-content-start" },
                        React.createElement(VideoFilterSection$1, { title: translate('components.video.filters.pither-hand'), playlist: playlist, requiredFields: "pitcherHand" },
                            React.createElement(VideoFilterToggleButton, { filter: filter, name: "pitcherHand", onChange: onChange, options: lhpOptions, playlist: playlist, type: "radio" })),
                        React.createElement(VideoFilterSection$1, { title: translate('components.video.filters.batter-hand'), playlist: playlist, requiredFields: "batterHand" },
                            React.createElement(VideoFilterToggleButton, { filter: filter, name: "batterHand", onChange: onChange, options: lhbOptions, playlist: playlist, type: "radio" })),
                        React.createElement(VideoFilterSection$1, { title: `${translate('baseball.count')} (${translate('baseball.balls_other')})`, playlist: playlist, requiredFields: "balls" },
                            React.createElement(VideoFilterToggleButton, { filter: filter, name: "balls", onChange: onChange, options: [0, 1, 2, 3], playlist: playlist })),
                        React.createElement(VideoFilterSection$1, { title: `${translate('baseball.count')} (${translate('baseball.strikes_other')})`, playlist: playlist, requiredFields: "strikes" },
                            React.createElement(VideoFilterToggleButton, { filter: filter, name: "strikes", onChange: onChange, options: [0, 1, 2], playlist: playlist })),
                        React.createElement(VideoFilterSection$1, { title: translate('baseball.outs_other'), playlist: playlist, requiredFields: "outsbefore" },
                            React.createElement(VideoFilterToggleButton, { filter: filter, name: "outsbefore", onChange: onChange, options: [0, 1, 2], playlist: playlist })),
                        React.createElement(VideoFilterSection$1, { title: translate('components.video.filters.baserunners'), playlist: playlist, requiredFields: ['bcbefore', 'hasRunners'] },
                            React.createElement(VideoFilterBaseRunners, { playlist: playlist, filter: filter, onChange: onChange })),
                        React.createElement(VideoFilterSection$1, { title: translate('components.video.filters.pitch-type'), playlist: playlist, requiredFields: "type" },
                            React.createElement(VideoFilterToggleButton, { filter: filter, name: "type", onChange: onChange, options: pitchTypeOptions, playlist: playlist, rows: 1 }))),
                    React.createElement("div", { className: "w-100" },
                        React.createElement(TabContainer, null, tabs(translate).map((t) => {
                            const { key, title } = t, rest = __rest(t, ["key", "title"]);
                            return (React.createElement(Tab, Object.assign({ key: key, active: t === activeTab, onClick: () => onTabSelect(t) }, rest, { className: "flex-grow-1" }),
                                title,
                                " (",
                                numAppliedFilters(t.filterKeys),
                                ")"));
                        })),
                        React.createElement(TabPanel, null,
                            React.createElement("div", { className: "container" }, activeTab === null || activeTab === void 0 ? void 0 : activeTab.component({ filter, playlist, onChange, onClear })))))),
            React.createElement(StyledVideoFilterFooter, null,
                React.createElement("div", null,
                    React.createElement(Button, { onClick: onClearAll }, translate('common.clear')),
                    React.createElement(Button, { variant: "primary", onClick: () => onApply(playlistToBeApplied, filter) }, translate('common.apply')))))));
};
var VideoFilter$1 = memo(VideoFilter, (prevProps, nextProps) => prevProps.filter === nextProps.filter
    && prevProps.playlist === nextProps.playlist
    && prevProps.isFullScreenMode === nextProps.isFullScreenMode
    && prevProps.isMobileView === nextProps.isMobileView);

const StyledDownloadModal = styled(BaseModal) `&&
    z-index: 1061;
    .modal-body {
        padding: 5px;
    }
    .table-responsive {
        min-height: 310px;
        max-height: 400px;
        thead th {
            white-space: nowrap;
            .dropdown {
                display: inline-block;
            }
        }
        .nyy-checkbox-radio-container {
            margin: 0;
            label {
                color: initial;
            }
        }
        .btn.btn-link {
            padding: 0;
        }
    }
`;
const DownloadVideosModal = ({ download, playlist, modalContainer }) => {
    const { t: translate } = useTranslation();
    const [showDownloadModal, setShowModal] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [videoPreviewSrc, setVideoPreviewSrc] = useState();
    const mappedPlaylist = playlist.map((p, idx) => (Object.assign(Object.assign({}, p), { idx, angles: p.sources.reduce((acc, s) => (Object.assign(Object.assign({}, acc), { [s.label]: s.file })), {}), angleOptions: p.sources.map((s) => ({ name: s.label })) })));
    const mainAngle = mappedPlaylist[0].angleOptions[0].name;
    // eslint-disable-next-line no-nested-ternary
    const defaultAngles = mappedPlaylist.map((p) => (p.angles[mainAngle] ? mainAngle : (p.angleOptions.length > 0 ? p.angleOptions[0].name : null)));
    const [angleHeaderValue, setAngleHeaderValue] = useState(mainAngle);
    const [selectedVideos, setSelectedVideos] = useState(Array(mappedPlaylist.length).fill(true));
    const [selectedAngles, setSelectedAngles] = useState(defaultAngles);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);
    const selectHeaderAngle = (_val, key) => {
        setAngleHeaderValue(key);
        setSelectedAngles((angles) => angles.map((angle, idx) => {
            const pitchAngleOptions = mappedPlaylist[idx].angleOptions;
            return pitchAngleOptions.some((ao) => ao.name === key) ? key : angle;
        }));
    };
    const selectVideoAngle = (idx, key) => {
        setSelectedAngles((angles) => ([...angles.slice(0, idx), key, ...angles.slice(idx + 1)]));
    };
    const selectHeaderInclude = (e) => {
        const { checked } = e.currentTarget;
        setSelectedVideos(Array(mappedPlaylist.length).fill(checked));
    };
    const selectVideoInclude = (idx, e) => {
        const { checked } = e.currentTarget;
        setSelectedVideos((selected) => ([...selected.slice(0, idx), checked, ...selected.slice(idx + 1)]));
    };
    const downloadVideos = () => __awaiter(void 0, void 0, void 0, function* () {
        const videoSources = selectedVideos
            .reduce((acc, cur, idx) => {
            if (cur)
                return [...acc, idx];
            return acc;
        }, new Array())
            .map((selectedIndex) => mappedPlaylist[selectedIndex].angles[selectedAngles[selectedIndex]]);
        handleClose();
        setIsDownloading(true);
        yield download(videoSources);
        setIsDownloading(false);
    });
    const allAngleOptions = Array.from(new Set(mappedPlaylist.flatMap((p) => p.angleOptions).map((s) => s.name))).map((name) => ({ name }));
    const tableColumns = [
        { id: 'video-button',
            type: COLUMN_TYPES.NODE,
            transform: ({ idx, angles }) => (React.createElement(Button, { variant: "link", onClick: () => setVideoPreviewSrc(angles[selectedAngles[idx]]) },
                React.createElement(Icon, { icon: "video-camera" }))) },
        { id: 'idx', title: '#', transform: ({ idx }) => idx + 1 },
        { id: 'title',
            type: COLUMN_TYPES.NODE,
            title: translate('components.video.title'),
            transform: ({ title, description }) => (React.createElement("div", null,
                title,
                React.createElement("br", null),
                React.createElement("small", null, description))) },
        { id: 'angle',
            type: COLUMN_TYPES.NODE,
            cellClass: 'text-center',
            headerClass: 'text-center',
            title: () => (React.createElement(DropdownInput, { options: allAngleOptions, value: angleHeaderValue, onSelect: selectHeaderAngle })),
            transform: ({ angleOptions, idx }) => (React.createElement(DropdownInput, { options: angleOptions, value: selectedAngles[idx], onSelect: (_val, key) => selectVideoAngle(idx, key) })) },
        { id: 'include',
            type: COLUMN_TYPES.NODE,
            cellClass: 'text-center',
            headerClass: 'text-center',
            title: () => (React.createElement(Checkbox, { label: translate('components.video.abbr-include'), labelDirection: "left", checked: selectedVideos.every((v) => v), onChange: selectHeaderInclude, id: "playlistcheckbox" })),
            transform: ({ idx }) => (React.createElement(Checkbox, { checked: selectedVideos[idx], onChange: (e) => selectVideoInclude(idx, e), id: `playlistcheckbox_${idx}` })) },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(VideoPlayerButton$1, { title: translate('components.video.download'), icon: "download", onClick: handleShow, loading: isDownloading, showLabel: true }),
        React.createElement(StyledDownloadModal, { show: showDownloadModal, onHide: handleClose, container: modalContainer },
            React.createElement(StyledDownloadModal.Header, null, translate('components.video.download-clips')),
            React.createElement(StyledDownloadModal.Body, null,
                React.createElement(DataTable, { columns: tableColumns, rows: mappedPlaylist }),
                videoPreviewSrc && (React.createElement("div", { className: "mt-2 text-center" },
                    React.createElement(Video, { src: videoPreviewSrc, controls: true })))),
            React.createElement(StyledDownloadModal.Footer, null,
                React.createElement(Button, { variant: "secondary", onClick: handleClose }, translate('common.cancel')),
                React.createElement(Button, { variant: "primary", onClick: downloadVideos }, translate('components.video.download'))))));
};
var DownloadVideosModal$1 = memo(DownloadVideosModal, (prevProps, nextProps) => prevProps.playlist === nextProps.playlist);

const SelectGridSizeModal = ({ onSelectGridSize, modalContainer, isActive = false }) => {
    const { t: translate } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const options = [
        { name: translate('components.video.large'), value: 100 },
        { name: translate('components.video.medium'), value: 50 },
        { name: translate('components.video.small'), value: 25 },
    ];
    const onButtonClick = () => {
        if (isActive)
            onSelectGridSize(null);
        else
            setShowModal(true);
    };
    const onModalHide = (selectedValue) => {
        setShowModal(false);
        if (selectedValue)
            onSelectGridSize(selectedValue.value);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(VideoPlayerButton$1, { title: translate('components.video.display-grid'), icon: "grid", onClick: onButtonClick, showLabel: true, isActive: isActive }),
        React.createElement(SelectListModal, { title: translate('components.video.please-select-grid'), options: options, label: "name", show: showModal, onHide: onModalHide, container: modalContainer })));
};

const ReportBadVideoModal = ({ modalContainer, isActive = false, onClick, reportBadVideo, currentVideo, selectedAngle, errors }) => {
    const { t: translate } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [subject, setSubject] = useState('');
    const [description, setDescription] = useState('');
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
        setShowModal(true);
    };
    const submit = () => __awaiter(void 0, void 0, void 0, function* () {
        if (reportBadVideo) {
            yield reportBadVideo(subject, description, currentVideo, selectedAngle, errors);
        }
        setShowModal(false);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(VideoPlayerButton$1, { title: translate('components.video.report-bad-video'), icon: "video-camera", onClick: handleClick, showLabel: true, isActive: isActive }),
        React.createElement(BaseModal, { show: showModal, onHide: () => setShowModal(false), container: modalContainer },
            React.createElement(BaseModal.Header, null, translate('components.video.report-bad-video')),
            React.createElement(BaseModal.Body, null,
                React.createElement(Form$1.Group, null,
                    React.createElement(Form$1.Control, { className: "reportBadVideoModalField", type: "text", placeholder: translate('components.video.subject'), value: subject, onChange: (e) => setSubject(e.target.value) })),
                React.createElement(Form$1.Group, null,
                    React.createElement(Form$1.Control, { className: "reportBadVideoModalField", type: "text", as: "textarea", placeholder: translate('components.video.description'), rows: 3, value: description, onChange: (e) => setDescription(e.target.value) }))),
            React.createElement(BaseModal.Footer, null,
                React.createElement(Button, { variant: "secondary", onClick: () => setShowModal(false) }, translate('common.cancel')),
                React.createElement(Button, { variant: "primary", onClick: submit, disabled: !subject }, translate('common.submit'))))));
};

const StyledVideoPlayerHeatmap = styled.div `
    position: absolute;
    left: 0;
    bottom: 0;
    opacity: 0.85;
    && {
        .spinner-border {
            margin-top: -50px;
            margin-left: 20px;
        }
        .no-data-message {
            color: white;
            width: 90px;
            word-spacing: 90px;
            margin-bottom: 15px;
        }
    }
`;
const heatMapSize = 200;
const VideoPlayerHeatmap = ({ heatmap, plateX, plateZ }) => {
    const { t: translate } = useTranslation();
    const src = (heatmap === null || heatmap === void 0 ? void 0 : heatmap.HeatMapImg) && base64ToBlob(heatmap);
    return (React.createElement(StyledVideoPlayerHeatmap, null,
        (heatmap === null || heatmap === void 0 ? void 0 : heatmap.loading) && React.createElement(LoadingSpinner$1, null),
        src && heatmap.ModelID === heatMapModelIds.CatcherWristband && (React.createElement(CatcherWristbandHeatMap, { src: src, size: heatMapSize, plateX: plateX, plateZ: plateZ, is2K: heatmap.Split === 'TwoStrikes', grade: heatmap.val, includeBackground: true })),
        src && heatmap.ModelID !== heatMapModelIds.CatcherWristband && (React.createElement(HeatMapImgContainer, { src: src, type: heatmap.ModelID, size: heatMapSize, plateX: plateX, plateZ: plateZ, includeBackground: true })),
        heatmap === null && (React.createElement("p", { className: "no-data-message" }, translate('components.video.no-heatmap')))));
};
var VideoPlayerHeatmap$1 = memo(VideoPlayerHeatmap, (prevProps, nextProps) => {
    var _a, _b, _c, _d, _e, _f;
    return ((_a = prevProps.heatmap) === null || _a === void 0 ? void 0 : _a.loading) === ((_b = nextProps.heatmap) === null || _b === void 0 ? void 0 : _b.loading)
        && ((_c = prevProps.heatmap) === null || _c === void 0 ? void 0 : _c.ContentType) === ((_d = nextProps.heatmap) === null || _d === void 0 ? void 0 : _d.ContentType)
        && ((_e = prevProps.heatmap) === null || _e === void 0 ? void 0 : _e.HeatMapImg) === ((_f = nextProps.heatmap) === null || _f === void 0 ? void 0 : _f.HeatMapImg)
        && prevProps.plateX === nextProps.plateX
        && prevProps.plateZ === nextProps.plateZ;
});

const StyledVideoPlayerGridTable = styled.table `
    ${({ $width, $height, $offsetX, $offsetY }) => `
        width: ${$width}px;
        height: ${$height}px;
        ${($offsetX ? `margin-left: -${$offsetX}px;` : '')}
        ${($offsetY ? `margin-top: -${$offsetY}px;` : '')}
    `}
    table-layout: fixed;
    td {
        border: 1px solid ${theme.border.bombay};
    }
    > tbody > tr {
        &:first-child > td { border-top: none; }
        &:last-child > td { border-bottom: none; }
        > td:first-child { border-left: none; }
        > td:last-child { border-right: none; }
    }
`;
const StyledVideoPlayerGrid = styled.div `
    position: absolute;
    overflow: hidden;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
`;
const VideoPlayerGrid = (_a) => {
    var { gridSize, containerWidth, containerHeight } = _a, rest = __rest(_a, ["gridSize", "containerWidth", "containerHeight"]);
    const cols = new Array(Math.ceil(containerWidth / gridSize)).fill(0).map((x, idx) => x + idx);
    const rows = new Array(Math.ceil(containerHeight / gridSize)).fill(0).map((y, idx) => y + idx);
    const width = gridSize * cols.length;
    const height = gridSize * rows.length;
    return (React.createElement(StyledVideoPlayerGrid, Object.assign({}, rest),
        React.createElement(StyledVideoPlayerGridTable, { "$width": width, "$height": height, "$offsetX": (width - containerWidth) / 2, "$offsetY": (height - containerHeight) / 2 },
            React.createElement("tbody", null, rows.map((row) => (React.createElement("tr", { key: row }, cols.map((col) => React.createElement("td", { key: col })))))))));
};
var VideoPlayerGrid$1 = memo(VideoPlayerGrid, (prevProps, nextProps) => prevProps.gridSize === nextProps.gridSize
    && prevProps.containerWidth === nextProps.containerWidth
    && prevProps.containerHeight === nextProps.containerHeight);

const StyledVideoPlayer$1 = styled.div.attrs({ className: 'modal-border-bottom' }) `
    display: flex;
    flex-direction: column;
    max-width: 100%;
    background-color: ${videoPlayerBackground};
    flex-grow: 1;
`;
const StyledVideoContainer$1 = styled.div `
    flex-grow: 1;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    ${(props) => (props.$fullscreen ? 'position: relative;' : '')}
    ${(props) => (props.$fullscreen ? `
        video {
            min-height: 100%;
            width: auto;
            max-height: 1px; // fill-available (deprecated?)
        }
    ` : '')}
    .no-data-message {
        text-transform: uppercase;
        font-size: 1.25em;
        text-align: center;
    }
`;
const StyledVideoControlsSection = styled.div `
    margin-right: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    &.flex-grow-1 {
        flex-grow: 1;
    }
    ${VideoPlayerButton$1} {
        margin: 0 5px;
    }
    &&& ${VideoPlayerButton$1} {
        padding: 4px 5px;
    }
    && label {
        margin: 0 0 0 10px;
        color: ${theme.fontColors.silver};
        font-size: 1.4em;
    }
    ${(props) => (props.$width >= bootstrapMd ? `
        &&& ${VideoPlayerButton$1} {
            padding: 8px 8.5px;
        }
    ` : '')}
    ${(props) => (props.$width >= bootstrapLg ? `
        margin-right: 30px;
        &&& ${VideoPlayerButton$1} {
            &.high-use {
                padding-left: 17.5px;
                padding-right: 17.5px;
            }
        }
    ` : '')}
`;
const StyledVideoControls = styled.div.attrs({ className: 'modal-border-bottom' }) `
    background-color: ${videoPlayerBackground};
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 5px;
    height: ${footerHeight.mobile}px;
    ${StyledVideoControlsSection}:last-of-type {
        margin-right: 0;
    }
    ${(props) => (!browser$1.mobileOnly && props.$width >= bootstrapMd ? `
        height: ${footerHeight.desktop}px;
    ` : '')}
    ${(props) => (props.$width >= bootstrapXl ? `
        padding-left: 15px;
        padding-right: 15px;
    ` : '')}
`;
const StyledVideoPlaylistContainer = styled.div.attrs({ className: 'video-playlist-container' }) `
    display: flex;
    flex-direction: column;
    max-width: 100%;
    position: relative;
    ${(props) => (props.$roundCorners ? `
        border: 1px solid ${styles.pSBC(-0.1, styles.theme.background.geyser)};
        border-radius: 0.25rem;
        overflow: clip;
    ` : '')}
`;
const StyledVideoPlaylistHeader = styled.div.attrs({ className: 'modal-border-top' }) `
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: ${theme.background.blueZodiac};
    min-height: ${headerHeight}px;
    text-align: left;
    && h4 {
        color: white;
        font-weight: bold;
        margin: 7px 10px 0;
        + label {
            margin-left: 25px;
            margin-bottom: 4px;
        }
    }
    ${StyledVideoControlsSection}:last-of-type {
        margin-right: 5px;
    }
    ${(props) => (props.$width >= bootstrapXl ? `
        && h4 {
            margin-left: 15px;
            + label {
                margin-left: 30px;
            }
        }
        ${StyledVideoControlsSection}:last-of-type {
            margin-right: 15px;
        }
    ` : '')}
`;
const StyledFullScreenVideoControlsSection = styled(StyledVideoControlsSection) `
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background-color: rgba(0, 0, 0, .65);
    padding: 10px 5px;
    height: 100%;
    max-height: 235px;
    ${(props) => (props.$width >= bootstrapMd ? `
        max-height: ${props.$has5Buttons ? '375px' : '350px'};
        padding-top: 20px;
        padding-bottom: 20px;
    ` : '')}
    ${(props) => (props.$width >= bootstrapLg ? `
        &&& ${VideoPlayerButton$1}.high-use {
            padding: 8px 8.5px;
        }
    ` : '')}
`;
const StyledFullScreenVideoControls = styled(StyledVideoControls) `
    background: transparent;
    position: absolute;
    top: 0;
    ${(props) => (props.$left ? 'left: 0;' : '')}
    ${(props) => (props.$right ? 'right: 0;' : '')}
    display: flex;
    align-items: center;
    padding: 0 !important;
    height: 100%;
    ${(props) => (props.$left ? `
        ${StyledFullScreenVideoControlsSection} {
            padding-left: 5px;
            ${borderRadiuses('5px', '5px')}
        }
        ${props.$width >= bootstrapMd ? `
            ${StyledFullScreenVideoControlsSection} {
                padding-left: 7.5px;
            }
        ` : ''}
    ` : '')}
    ${(props) => (props.$right ? `
        ${StyledFullScreenVideoControlsSection} {
            padding-right: 5px;
            ${borderRadiuses(0, 0, '5px', '5px')}
        }
        ${props.$width >= bootstrapMd ? `
            ${StyledFullScreenVideoControlsSection} {
                padding-right: 7.5px;
            }
        ` : ''}
    ` : '')}
`;
const StyledVideoContentContainer = styled.div `
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 1;
    outline: none;
    .spinner-border {
        position: absolute;
        margin-left: calc(50% - 16px);
    }
    video:not([src]) {
        display: none;
        visibility: hidden;
    }
`;
const StyledVideoMessage = styled.div `
    width: 100%;
    label {
        color: ${theme.fontColors.silver};
        font-size: 1.4em;
        position: absolute;
        width: 100%;
        left: 0;
        top: 50%;
        + label {
            font-size: 1.2em;
            margin-top: 22.5px;
        }
    }
`;
const StyledVideoNotFound = styled(StyledVideoMessage) `
    position: relative;
    padding-top: ${9 / 16 * 100}%;
`;
const StyledVideoError = styled(StyledVideoMessage) `
    position: absolute;
`;
const StyledActionMenuPopover = styled(Popover) `
    &&& {
        background-color: ${videoPlayerBackground};
        border-color: ${theme.fontColors.silver};
        > .arrow {
            &:after {
                border-top-color: ${videoPlayerBackground};
            }
            &:before {
                border-top-color: ${theme.fontColors.silver};
            }
        }
        z-index: 1040;
    }
    .popover-body > div:not(:last-of-type) {
        margin-bottom: 10px;
    }
`;
const StyledMobileHeader = styled.div `
    background-color: ${theme.background.blueZodiac};
    padding: 10px;
    font-size: 1.2em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    > div {
        font-weight: bold;
        color: white;
    }
    > small {
        font-weight: normal;
        margin-left: 15px;
        color: ${theme.fontColors.dodgerBlue};
        font-size: 90%;
    }
    ${StyledVideoStats} {
        height: 65px;
        opacity: 0.8;
        padding-bottom: 0;
        .highcharts-container {
            position: absolute !important;
            top: -5px;
        }
        .spinner-border, .no-data-message {
            margin-top: 12px;
        }
    }
    ${StyledPitchBreakStats} {
        > div {
            > div {
                display: inline-block;
                + div {
                    margin-left: 5px;
                    width: 30px;
                    text-align: left;
                }
            }
            + div {
                margin-top: 2.5px;
            }
        }
    }
    ${StyledPitchSpinStats} {
        display: flex;
        table + table {
            margin-left: 10px;
        }
    }
    ${StyledPitchInPlayStats} {
        flex-direction: row;
        align-items: center;
        > p {
           margin: 0; 
        }
        > svg {
            height: 50px;
            width: auto;
            margin-left: 15px;
        }
    }
`;
const StyledVideoFrameDisplay = styled.div `
    position: absolute;
    right: 10px;
    bottom: 5px;
    color: white;
    font-size: 2em;
`;
const getVideoAngle = (sources, angleName) => {
    if (!sources)
        return {};
    let selectedAngle;
    if (angleName)
        selectedAngle = sources.find((s) => s.label === angleName);
    if (!selectedAngle)
        selectedAngle = sources.find((s) => s.default) || sources[0];
    return selectedAngle;
};
// These two methods allow specification of a different behavior for certain pages
// that have videoplayers. Swapping the keys to get different values from the
// browser storage and the default angle method for changing the default
// behavior for that key.
const getStorageKeyForSpecialtyPlayer = (specialtyAngleKey) => {
    switch (specialtyAngleKey) {
        case 'approach-lhh':
        case 'approach-rhh':
            return LOCAL_STORAGE_ANGLE_KEY_APPROACHTAB;
        default:
            return LOCAL_STORAGE_ANGLE_KEY;
    }
};
const getSpecialtyPlayerKeyWithDefaultAngle = (specialtyAngleKey) => {
    const keyValue = window.localStorage.getItem(getStorageKeyForSpecialtyPlayer(specialtyAngleKey));
    if ((keyValue !== '' && keyValue != null) || (specialtyAngleKey == null || specialtyAngleKey === '')) {
        return keyValue;
    }
    // if there isn't already a value for that key, see what it should be and return it
    // spec the angle of player you want for each possible specialty key
    switch (specialtyAngleKey) {
        case 'approach-lhh':
            return 'RH Batters View'; // Note that these are intentionally flipped versus handedness
        case 'approach-rhh':
            return 'LH Batters View';
        default:
            return window.localStorage.getItem(getStorageKeyForSpecialtyPlayer(specialtyAngleKey));
    }
};
const setNewPlaylist = (props) => {
    var _a, _b, _c, _d;
    const nextState = {
        toastMessage: '',
        errorMessage: {},
        sliderTimeValue: 0,
        maxVideoTime: 0,
        currentVideoIdx: 0,
        filteredPlaylist: props.playlist,
        filter: {},
        actionMenu: {},
        advancedPitchData: {},
        metadata: {},
        heatMaps: {},
        selectedAngle: getVideoAngle((_a = props.playlist[0]) === null || _a === void 0 ? void 0 : _a.sources, props.overrideAngleKey || getSpecialtyPlayerKeyWithDefaultAngle(props.specialtyAngleKey)),
        selectedAngleLabel: (_c = getVideoAngle((_b = props.playlist[0]) === null || _b === void 0 ? void 0 : _b.sources, props.overrideAngleKey
            || getSpecialtyPlayerKeyWithDefaultAngle(props.specialtyAngleKey))) === null || _c === void 0 ? void 0 : _c.label,
        selectedData: (_d = props.playlist[0]) === null || _d === void 0 ? void 0 : _d.data,
        controls: {
            [PLAY_PAUSE]: props.autoPlay ? 1 : false,
            [MUTE]: (props.autoPlay && browser$1.webkit) || window.localStorage.getItem(LOCAL_STORAGE_MUTE_KEY) === 'true',
            [STATS]: props.alwaysShowPitchData || window.localStorage.getItem(LOCAL_STORAGE_DATA_VIEW_KEY) === 'true',
            [HEATMAP]: window.localStorage.getItem(LOCAL_STORAGE_HEATMAP_KEY) === 'true',
            [FILTER]: props.alwaysShowFilter,
        },
        containerWidth: 0,
        errors: [],
    };
    return nextState;
};
class VideoPlayer extends Component {
    constructor(props) {
        super(props);
        this.playlistContainerRef = createRef();
        this.videoContentContainerRef = createRef();
        this.videoControlsContainerRef = createRef();
        this.actionMenuRef = createRef();
        this.videoPlayerHeight = null;
        this.videoRef = null;
        this.setCurrentVideoTime = () => { }; // eslint-disable-line @typescript-eslint/no-empty-function
        this.state = setNewPlaylist(this.props);
        this.toggleControl = this.toggleControl.bind(this);
        this.toggleSliderEvent = this.toggleSliderEvent.bind(this);
        this.toggleFullScreenMode = this.toggleFullScreenMode.bind(this);
        this.toggleActionMenu = this.toggleActionMenu.bind(this);
        this.toggleStats = this.toggleStats.bind(this);
        this.toggleMute = this.toggleMute.bind(this);
        this.toggleHeatmap = this.toggleHeatmap.bind(this);
        this.onVideoLoadedData = this.onVideoLoadedData.bind(this);
        this.onSliderChange = this.onSliderChange.bind(this);
        this.onPlayback = this.onPlayback.bind(this);
        this.goToNextVideo = this.goToNextVideo.bind(this);
        this.translateSliderTime = this.translateSliderTime.bind(this);
        this.share = this.share.bind(this);
        this.copySQL = this.copySQL.bind(this);
        this.onFullScreenChange = this.onFullScreenChange.bind(this);
        this.onGrabFrame = this.onGrabFrame.bind(this);
        this.onFilter = this.onFilter.bind(this);
        this.loadAndSetPitchData = this.loadAndSetPitchData.bind(this);
        this.loadAndSetPitchHeatmap = this.loadAndSetPitchHeatmap.bind(this);
        this.loadAndSetVideoMetadata = this.loadAndSetVideoMetadata.bind(this);
        this.onVideoAngleSelect = this.onVideoAngleSelect.bind(this);
        this.onWindowResize = this.onWindowResize.bind(this);
        this.onVideoContentKeyDown = this.onVideoContentKeyDown.bind(this);
        this.onVideoContentWheel = this.onVideoContentWheel.bind(this);
        this.onVideoEnd = this.onVideoEnd.bind(this);
        this.exportPlaylistToIPad = this.exportPlaylistToIPad.bind(this);
        this.setVideoError = this.setVideoError.bind(this);
        this.getFrameRate = this.getFrameRate.bind(this);
        this.togglePlay = this.togglePlay.bind(this);
    }
    componentDidMount() {
        var _a, _b, _c, _d;
        document.addEventListener('fullscreenchange', this.onFullScreenChange, false);
        document.addEventListener('mozfullscreenchange', this.onFullScreenChange, false);
        document.addEventListener('MSFullscreenChange', this.onFullScreenChange, false);
        document.addEventListener('webkitfullscreenchange', this.onFullScreenChange, false);
        window.addEventListener('resize', this.onWindowResize, false);
        (_a = this.videoContentContainerRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('wheel', this.onVideoContentWheel, false);
        (_b = this.videoControlsContainerRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('wheel', this.onVideoContentWheel, false);
        if (this.props.overrideWindowEventListeners) {
            window.addEventListener('keydown', this.onVideoContentKeyDown, false);
        }
        else {
            (_c = this.videoContentContainerRef.current) === null || _c === void 0 ? void 0 : _c.addEventListener('keydown', this.onVideoContentKeyDown, false);
            (_d = this.videoControlsContainerRef.current) === null || _d === void 0 ? void 0 : _d.addEventListener('keydown', this.onVideoContentKeyDown, false);
        }
        this.onWindowResize(true);
        if (this.state.controls[STATS])
            this.loadAndSetPitchData(this.state.filteredPlaylist[this.state.currentVideoIdx]);
        if (this.state.controls[HEATMAP])
            this.loadAndSetPitchHeatmap(this.state.filteredPlaylist[this.state.currentVideoIdx]);
        if (this.props.loadVideoMetadata)
            this.loadAndSetVideoMetadata(this.state.selectedAngle);
    }
    UNSAFE_componentWillReceiveProps(_nextProps) {
        // check for new props
        const { playlist: prevPlaylist } = this.props;
        const { playlist: nextPlaylist } = _nextProps;
        if (((prevPlaylist === null || prevPlaylist === void 0 ? void 0 : prevPlaylist.length) && prevPlaylist[0].pitchId) !== ((nextPlaylist === null || nextPlaylist === void 0 ? void 0 : nextPlaylist.length) && nextPlaylist[0].pitchId)) {
            const nextState = setNewPlaylist(_nextProps);
            this.setState(nextState);
            this.onWindowResize(true);
        }
    }
    UNSAFE_componentWillUpdate(_nextProps, nextState) {
        var _a, _b;
        // a new source was given to the video player and has not yet loaded
        // use this oppurtunity to set the size of the video player since it collapses when no video is playing
        if (((_a = nextState.selectedAngle) === null || _a === void 0 ? void 0 : _a.file) && nextState.selectedAngle.file !== ((_b = this.state.selectedAngle) === null || _b === void 0 ? void 0 : _b.file)) {
            if (!nextState.maxVideoTime)
                this.videoPlayerHeight = this.playlistContainerRef.current.offsetHeight;
            if (this.props.loadVideoMetadata)
                this.loadAndSetVideoMetadata(nextState.selectedAngle);
        }
        else if (this.state.maxVideoTime !== nextState.maxVideoTime) {
            this.videoPlayerHeight = null;
        }
    }
    componentDidUpdate(_prevProps, prevState) {
        const prevPitchVideo = prevState.filteredPlaylist[prevState.currentVideoIdx];
        const currentPitchVideo = this.state.filteredPlaylist[this.state.currentVideoIdx];
        if (prevPitchVideo !== currentPitchVideo) {
            if (this.state.controls[STATS])
                this.loadAndSetPitchData(currentPitchVideo);
            if (this.state.controls[HEATMAP])
                this.loadAndSetPitchHeatmap(currentPitchVideo);
        }
    }
    componentDidCatch(error) {
        this.setState((prevState) => ({ errors: [...prevState.errors, error] }));
    }
    componentWillUnmount() {
        var _a, _b, _c, _d;
        document.removeEventListener('fullscreenchange', this.onFullScreenChange, false);
        document.removeEventListener('mozfullscreenchange', this.onFullScreenChange, false);
        document.removeEventListener('MSFullscreenChange', this.onFullScreenChange, false);
        document.removeEventListener('webkitfullscreenchange', this.onFullScreenChange, false);
        window.removeEventListener('resize', this.onWindowResize, false);
        (_a = this.videoContentContainerRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('wheel', this.onVideoContentWheel, false);
        (_b = this.videoControlsContainerRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('wheel', this.onVideoContentWheel, false);
        if (this.props.overrideWindowEventListeners) {
            window.removeEventListener('keydown', this.onVideoContentKeyDown, false);
        }
        else {
            (_c = this.videoContentContainerRef.current) === null || _c === void 0 ? void 0 : _c.removeEventListener('keydown', this.onVideoContentKeyDown, false);
            (_d = this.videoControlsContainerRef.current) === null || _d === void 0 ? void 0 : _d.removeEventListener('keydown', this.onVideoContentKeyDown, false);
        }
    }
    onVideoLoadedData(e) {
        // allow a hook to be notified when the active clip changes
        if (this.props.onActiveVideoChanged) {
            const videoData = this.state.filteredPlaylist[this.state.currentVideoIdx];
            this.props.onActiveVideoChanged(videoData);
        }
        this.setState(({ controls, selectedAngle, metadata }, { autoPlay, showCurrentFrame }) => {
            let play = autoPlay ? 1 : false;
            if (play && showCurrentFrame && (selectedAngle === null || selectedAngle === void 0 ? void 0 : selectedAngle.file)) {
                const meta = get$2(metadata, selectedAngle.file);
                if (meta === null || meta === void 0 ? void 0 : meta.loading)
                    play = false;
            }
            if (this.props.playStateChanged) {
                this.props.playStateChanged(play === 1);
            }
            return {
                maxVideoTime: e.target.duration,
                controls: Object.assign(Object.assign({}, controls), { [PLAY_PAUSE]: play }),
            };
        });
    }
    onPlayback(e) { this.setState({ sliderTimeValue: e.target.currentTime }); }
    onSliderChange(newVal) { this.setCurrentVideoTime(newVal); }
    onVideoAngleSelect(selectedAngle) {
        this.setState((currentState) => {
            const { selectedAngle: currentSelectedAngle } = currentState;
            const newState = Object.assign({}, currentState);
            if (currentSelectedAngle !== selectedAngle) {
                newState.selectedAngle = selectedAngle;
                newState.selectedAngleLabel = selectedAngle.label;
                window.localStorage.setItem(getStorageKeyForSpecialtyPlayer(this.props.specialtyAngleKey), selectedAngle.label);
                if (currentSelectedAngle.file !== selectedAngle.file) {
                    newState.maxVideoTime = 0;
                    newState.sliderTimeValue = 0;
                    newState.errorMessage = {};
                }
            }
            return newState;
        });
    }
    onFullScreenChange() {
        const doc = document;
        const isInFullScreen = doc.webkitIsFullScreen || doc.mozFullScreen || doc.msFullscreenElement;
        this.toggleControl(FULLSCREEN, !!isInFullScreen);
    }
    onWindowResize(isInitLoad) {
        if (isInitLoad === true) {
            // setTimeout and wait for modal to display player on page before calculating with (otherwise returns 0)
            setTimeout(() => {
                if (this.playlistContainerRef.current) {
                    this.setState({ containerWidth: this.playlistContainerRef.current.offsetWidth });
                }
            });
        }
        else {
            this.setState({ containerWidth: this.playlistContainerRef.current.offsetWidth });
        }
    }
    onFilter(filteredPlaylist, filter) {
        this.setState((currentState) => {
            var _a, _b;
            const { selectedAngle, selectedAngleLabel } = currentState;
            const newState = Object.assign(Object.assign({}, currentState), { filter, filteredPlaylist, currentVideoIdx: 0 });
            const newSelectedAngle = getVideoAngle((_a = filteredPlaylist[newState.currentVideoIdx]) === null || _a === void 0 ? void 0 : _a.sources, selectedAngleLabel);
            const newSelectedData = (_b = filteredPlaylist[newState.currentVideoIdx]) === null || _b === void 0 ? void 0 : _b.data;
            // do not reset current video playback if the loaded video is the "new" video to be played
            if (newSelectedAngle.file !== selectedAngle.file) {
                newState.selectedAngle = newSelectedAngle;
                newState.selectedData = newSelectedData;
                newState.maxVideoTime = 0;
                newState.sliderTimeValue = 0;
            }
            return newState;
        });
        if (this.props.onFilter) {
            this.props.onFilter(filteredPlaylist);
        }
    }
    onVideoContentKeyDown(e) {
        var _a;
        if ((_a = (e === null || e === void 0 ? void 0 : e.target).classList) === null || _a === void 0 ? void 0 : _a.contains('reportBadVideoModalField')) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        const { keyCode } = e;
        if (keyCode === 189 || keyCode === 188 || keyCode === 109 || keyCode === 173 || keyCode === 37 || keyCode === 40) { // last frame
            this.toggleSliderEvent(STEP_BACK);
        }
        else if (keyCode === 187 || keyCode === 190 || keyCode === 107 || keyCode === 61 || keyCode === 38 || keyCode === 39) { // next frame
            this.toggleSliderEvent(STEP_FORWARD);
        }
        else if (keyCode === 32 || keyCode === 80) { // play
            this.toggleControl(PLAY_PAUSE, 1);
        }
    }
    onVideoContentWheel(e) {
        e.preventDefault();
        e.stopPropagation();
        const { pixelY } = normalizeWheel(e);
        const delta = Math.sign(pixelY);
        const frameRate = this.getFrameRate();
        if (this.state.controls[PLAY_PAUSE] && delta) {
            this.toggleControl(PLAY_PAUSE, false);
            this.setCurrentVideoTime(this.state.sliderTimeValue - (delta / frameRate));
        }
        else if (!this.state.controls[PLAY_PAUSE] && delta) {
            this.setCurrentVideoTime(this.state.sliderTimeValue - (delta / frameRate));
        }
    }
    onVideoEnd() {
        if (this.state.controls[PLAY_PAUSE]) {
            this.goToNextVideo(undefined, true);
        }
    }
    onGrabFrame() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.state.selectedAngle.file) {
                this.toggleControl(FRAME_GRAB, true);
                yield this.props.grabFrame(this.state.selectedAngle.file, this.state.sliderTimeValue);
                this.toggleControl(FRAME_GRAB, false);
            }
        });
    }
    setVideoError(translate, e) {
        var _a;
        const title = translate('components.video.could-not-play');
        const error = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.error;
        let subtitle = error === null || error === void 0 ? void 0 : error.message;
        if (!subtitle && (error === null || error === void 0 ? void 0 : error.code)) {
            subtitle = `${translate('components.video.error-code')}: ${error.code}`;
        }
        this.setState({ errorMessage: { title, subtitle } });
    }
    getFrameRate() {
        let frameRate = FRAME_RATE;
        const { metadata, selectedAngle } = this.state;
        if (selectedAngle === null || selectedAngle === void 0 ? void 0 : selectedAngle.file) {
            const meta = get$2(metadata, selectedAngle.file);
            if (meta === null || meta === void 0 ? void 0 : meta.Fps)
                frameRate = meta.Fps;
        }
        return frameRate;
    }
    loadAndSetPitchData(playlistVideo) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.props.loadPitchData && (playlistVideo === null || playlistVideo === void 0 ? void 0 : playlistVideo.pitchId)) {
                let pitchData = get$2(this.state.advancedPitchData, playlistVideo.pitchId);
                if (pitchData === undefined) {
                    try {
                        this.setState(({ advancedPitchData }) => ({ advancedPitchData: set(advancedPitchData, playlistVideo.pitchId, { loading: true }) }));
                        const { gameid, pitchseq, eventseq } = playlistVideo.data;
                        pitchData = yield this.props.loadPitchData({ gameid, pitchseq, eventseq });
                        this.setState(({ advancedPitchData }) => ({ advancedPitchData: set(advancedPitchData, playlistVideo.pitchId, pitchData) }));
                    }
                    catch (_a) {
                        this.setState(({ advancedPitchData }) => ({ advancedPitchData: set(advancedPitchData, playlistVideo.pitchId, null) }));
                    }
                }
                return pitchData;
            }
            return null;
        });
    }
    loadAndSetPitchHeatmap(playlistVideo) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.props.loadPitchHeatmap && (playlistVideo === null || playlistVideo === void 0 ? void 0 : playlistVideo.heatmapId)) {
                let heatMap = get$2(this.state.heatMaps, playlistVideo.heatmapId);
                if (heatMap === undefined) {
                    try {
                        this.setState(({ heatMaps }) => ({ heatMaps: set(heatMaps, playlistVideo.heatmapId, { loading: true }) }));
                        const { pitcherid, type, batterid, strikes, yearid, islhb, venueid, fxsubtype } = playlistVideo.data;
                        heatMap = yield this.props.loadPitchHeatmap({
                            pitcherid,
                            batterid,
                            yearid,
                            islhb,
                            pitchtype: type,
                            is2k: strikes === 2,
                            venueid,
                            fxsubtype
                        });
                        this.setState(({ heatMaps }) => ({ heatMaps: set(heatMaps, playlistVideo.heatmapId, heatMap) }));
                    }
                    catch (_a) {
                        this.setState(({ heatMaps }) => ({ heatMaps: set(heatMaps, playlistVideo.heatmapId, null) }));
                    }
                }
                return heatMap;
            }
            return null;
        });
    }
    loadAndSetVideoMetadata(source) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.props.loadVideoMetadata && (source === null || source === void 0 ? void 0 : source.file)) {
                const { file: videoUrl } = source;
                let videoData = get$2(this.state.metadata, videoUrl);
                if (videoData === undefined) {
                    try {
                        this.setState(({ metadata }) => ({ metadata: set(metadata, videoUrl, { loading: true }) }));
                        videoData = yield this.props.loadVideoMetadata(videoUrl);
                        this.setState(({ metadata, controls }, { autoPlay }) => ({
                            metadata: set(metadata, videoUrl, Object.assign({ Duration: videoData.Duration }, videoData.VideoData)),
                            controls: Object.assign(Object.assign({}, controls), { [PLAY_PAUSE]: autoPlay ? 1 : false }),
                        }));
                    }
                    catch (_a) {
                        this.setState(({ metadata }) => ({ metadata: set(metadata, videoUrl, null) }));
                    }
                }
                return videoData;
            }
            return null;
        });
    }
    goToNextVideo(idx, isVideoEnd) {
        this.setState((currentState) => {
            var _a;
            const { currentVideoIdx, filteredPlaylist, controls, selectedAngleLabel } = currentState;
            let nextVideoIdx = idx;
            if (nextVideoIdx === undefined) {
                nextVideoIdx = currentVideoIdx === filteredPlaylist.length - 1 ? 0 : currentVideoIdx + 1;
            }
            const newState = Object.assign({}, currentState);
            if (nextVideoIdx !== currentVideoIdx) {
                newState.currentVideoIdx = nextVideoIdx;
                newState.selectedAngle = getVideoAngle(filteredPlaylist[nextVideoIdx].sources, selectedAngleLabel);
                newState.selectedData = (_a = filteredPlaylist[nextVideoIdx]) === null || _a === void 0 ? void 0 : _a.data;
                newState.maxVideoTime = 0;
                newState.sliderTimeValue = 0;
                newState.errorMessage = {};
            }
            else if (isVideoEnd) {
                newState.controls = Object.assign(Object.assign({}, controls), { [PLAY_PAUSE]: false });
            }
            return newState;
        });
    }
    share(translate) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.state.selectedAngle.file) {
                yield navigator.clipboard.writeText(this.state.selectedAngle.file);
                this.setState({
                    toastMessage: translate('components.video.video-url-copied'),
                });
            }
        });
    }
    // Not translating since it is for devs
    copySQL() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-undef
            if ((_a = this.state) === null || _a === void 0 ? void 0 : _a.selectedData) {
                const data = (_b = this.state) === null || _b === void 0 ? void 0 : _b.selectedData;
                const sqlScript = `select * from games g 
                inner join events e on e.gameid = g.gameid 
                inner join pitches p on p.gameid = g.gameid and p.eventseq = e.eventseq
                left join pitchvideos pv on pv.gameid=g.gameid and pv.eventseq=e.eventseq and pv.pitchseq=p.pitchseq
                left join [input].[videoangles] va on e.istop = va.istop and g.gameid = va.gameid and p.islhp = va.islhp and p.islhb = va.islhb
                where g.gameid = ${data.gameid} and e.eventseq = ${data.eventseq} and p.pitchseq = ${data.pitchseq}`;
                yield navigator.clipboard.writeText(sqlScript);
                this.setState({
                    toastMessage: 'Video SQL Query Copied to Clipboard',
                });
            }
            else {
                this.setState({
                    toastMessage: 'Video Data Not Found',
                });
            }
        });
    }
    exportPlaylistToIPad() {
        if (!this.props.exportPlaylist)
            return;
        const clips = this.state.filteredPlaylist.reduce((acc, video) => {
            if (video.clip) {
                const playlistClip = [...video.clip];
                playlistClip.sources = video.sources || [];
                acc.push(playlistClip);
            }
            return acc;
        }, new Array());
        this.props.exportPlaylist(clips);
    }
    toggleActionMenu(e, forceShow) {
        const { target } = e;
        this.setState(({ actionMenu }) => {
            const show = forceShow === undefined ? !actionMenu.show : forceShow;
            return {
                actionMenu: { show, target: show ? target : actionMenu.target },
            };
        });
    }
    toggleControl(controlKey, value, override) {
        this.setState(({ controls, containerWidth }) => {
            let isOpen;
            if (override) {
                isOpen = override;
            }
            else {
                const prevVal = controls[controlKey];
                isOpen = (value === undefined || value === prevVal) ? !prevVal : value;
            }
            const newControlsState = Object.assign(Object.assign({}, controls), { [controlKey]: isOpen });
            const { alwaysShowPitchData, alwaysShowFilter, hidePlaylistSelector } = this.props;
            if (containerWidth < bootstrapXl) {
                if (controlKey === FILTER && isOpen) {
                    newControlsState[PLAYLIST] = false;
                }
                else if (controlKey === PLAYLIST && isOpen && !alwaysShowFilter) {
                    newControlsState[FILTER] = false;
                }
            }
            if (controlKey === FULLSCREEN && !isOpen) {
                if (alwaysShowPitchData)
                    newControlsState[STATS] = true;
                if (alwaysShowFilter)
                    newControlsState[FILTER] = true;
                if (hidePlaylistSelector || (alwaysShowFilter && containerWidth < bootstrapXl))
                    newControlsState[PLAYLIST] = false;
            }
            // make sure this is done after newControlsState is updated
            if (controlKey === PLAY_PAUSE && this.props.playStateChanged) {
                this.props.playStateChanged(newControlsState[PLAY_PAUSE] === 1);
            }
            return { controls: newControlsState };
        });
    }
    toggleFullScreenMode() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.state.controls[FULLSCREEN]) {
                const doc = document;
                if (browser$1.webkit)
                    doc.webkitExitFullscreen();
                else
                    doc.exitFullscreen();
            }
            else if (((_a = this.videoRef) === null || _a === void 0 ? void 0 : _a.current) && this.videoRef.current.webkitDisplayingFullscreen) {
                this.videoRef.current.webkitExitFullscreen();
            }
            else {
                if (browser$1.webkit) {
                    try {
                        this.playlistContainerRef.current.webkitRequestFullscreen();
                        if (!document.webkitCurrentFullScreenElement && !browser$1.tablet) {
                            this.videoRef.current.webkitEnterFullscreen();
                        }
                    }
                    catch (_b) {
                        // iphone,ipad web view: does not support requestFullscreen as of opening day 2021
                        this.videoRef.current.webkitEnterFullscreen();
                    }
                }
                else {
                    yield this.playlistContainerRef.current.requestFullscreen({ navigationUI: 'hide' });
                    if (browser$1.mobileOnly) { // lock screen landscape on android when fullscreen
                        try {
                            yield window.screen.orientation.lock('landscape');
                        }
                        catch ( /* not supported */_c) { /* not supported */ }
                    }
                }
                this.setState(({ controls }) => ({ controls: Object.assign(Object.assign({}, controls), { [PLAYLIST]: false, [FILTER]: false }) }));
            }
        });
    }
    toggleHeatmap(currentVideo) {
        this.toggleControl(HEATMAP);
        this.loadAndSetPitchHeatmap(currentVideo);
        setTimeout(() => {
            window.localStorage.setItem(LOCAL_STORAGE_HEATMAP_KEY, (!!this.state.controls[HEATMAP]).toString());
        });
    }
    togglePlay() {
        // Play state uses false/1/2, so we must specify explicitly
        if (this.state.controls[PLAY_PAUSE] === 1) {
            this.toggleControl(PLAY_PAUSE, false);
        }
        else {
            this.toggleControl(PLAY_PAUSE, 1);
        }
    }
    toggleMute() {
        this.toggleControl(MUTE);
        setTimeout(() => {
            window.localStorage.setItem(LOCAL_STORAGE_MUTE_KEY, (!!this.state.controls[MUTE]).toString());
        });
    }
    toggleSliderEvent(key) {
        if (key === PLAY_FROM_BEGINNING) {
            this.setCurrentVideoTime(0);
        }
        else if (key === STEP_BACK || key === STEP_FORWARD) {
            if (this.state.controls[PLAY_PAUSE])
                this.toggleControl(PLAY_PAUSE, false);
            const frameRate = this.getFrameRate();
            // convert to frames and add/subtract frame
            let toFrame = (frameRate * this.state.sliderTimeValue) + (key === STEP_FORWARD ? 1 : -1);
            toFrame = Math.min(Math.max(toFrame, 0), frameRate * this.state.maxVideoTime);
            // set video time in seconds
            this.setCurrentVideoTime(toFrame / frameRate);
        }
    }
    toggleStats(currentVideo) {
        this.toggleControl(STATS);
        this.loadAndSetPitchData(currentVideo);
        setTimeout(() => {
            window.localStorage.setItem(LOCAL_STORAGE_DATA_VIEW_KEY, (!!this.state.controls[STATS]).toString());
        });
    }
    translateSliderTime(currentTime) {
        let retVal = '00:00:00';
        if (this.state.maxVideoTime && currentTime >= 0) {
            retVal = dayjs().startOf('hour').add(this.state.maxVideoTime - currentTime, 's').format('mm:ss:SSS');
            retVal = retVal.substring(0, retVal.length - 1); // dayjs only supports 3 character milliseconds, so delete last number
        }
        return retVal;
    }
    render() {
        var _a, _b, _c, _d;
        // This determines which of the ways the translation
        // class might be provided to us, either via props from the caller
        // or instantiated using the HOC
        let translate = null;
        if (this.props.translate) {
            translate = this.props.translate;
        }
        else if (this.props.t) {
            translate = this.props.t;
        }
        const { containerWidth, controls } = this.state;
        const currentVideo = this.state.filteredPlaylist[this.state.currentVideoIdx] || {};
        const isFullScreenMode = !!controls[FULLSCREEN];
        const isMobileView = containerWidth < bootstrapMd || browser$1.mobileOnly;
        const isFullScreenView = isFullScreenMode || isMobileView;
        const pitchData = currentVideo.pitchId ? get$2(this.state.advancedPitchData, currentVideo.pitchId) : null;
        const angleOptions = ((_a = currentVideo.sources) === null || _a === void 0 ? void 0 : _a.map((s) => (Object.assign(Object.assign({}, s), { name: s.label })))) || [];
        let maxVideoHeight;
        let minVideoHeight;
        if (!isFullScreenMode) {
            maxVideoHeight = this.props.maxHeight ? this.props.maxHeight : window.innerHeight;
            maxVideoHeight = maxVideoHeight
                - headerHeight
                - (isMobileView ? footerHeight.mobile : footerHeight.desktop)
                - (controls[STATS] ? statsContainerHeight : 0)
                - (isMobileView ? videoMaxSizePadding.mobile : videoMaxSizePadding.desktop);
            if (containerWidth && !isMobileView && maxVideoHeight > 600) {
                // use calculatued 16/9 ratio as height to avoid black bars at top and bottom
                minVideoHeight = Math.min(600, containerWidth * 9 / 16);
            }
        }
        let containerHeight;
        if (isFullScreenMode)
            containerHeight = '100%';
        else if (this.videoPlayerHeight)
            containerHeight = `${this.videoPlayerHeight}px`;
        // declare reused components
        const statsContent = (controls[STATS] && (React.createElement(videoStatsMemo, { loading: pitchData === null || pitchData === void 0 ? void 0 : pitchData.loading, data: (pitchData && !pitchData.loading) ? pitchData : undefined, isFullScreenMode: isFullScreenView, containerWidth: containerWidth, isMobileView: isMobileView })));
        const videoFilter = (controls[FILTER] && (React.createElement(VideoFilter$1, { playlist: this.props.playlist, onFilter: this.onFilter, filter: this.state.filter, isFullScreenMode: isFullScreenView && !(isMobileView && this.props.alwaysShowFilter), isMobileView: isMobileView, hideDisplay: () => this.toggleControl(FILTER, false) })));
        const videoPlayist = (controls[PLAYLIST] && (React.createElement(VideoPlaylist$1, { playlist: this.state.filteredPlaylist, activeIdx: this.state.currentVideoIdx, onVideoClick: this.goToNextVideo, isFullScreenMode: isFullScreenView, hideDisplay: () => this.toggleControl(PLAYLIST, false) })));
        const angleSelector = angleOptions.length > 1 && (React.createElement(DropdownInput, { className: "me-4", size: "md", options: angleOptions, value: this.state.selectedAngle.label, onSelect: this.onVideoAngleSelect, drop: isFullScreenView ? 'up' : undefined }));
        const playButton = (React.createElement(VideoPlayerButton$1, { className: "high-use", title: translate('components.video.play'), icon: "play", onClick: () => this.toggleControl(PLAY_PAUSE, 1), isActive: controls[PLAY_PAUSE] === 1 }));
        const fastForwardButton = (React.createElement(VideoPlayerButton$1, { title: translate('components.video.play-2'), icon: "forward", onClick: () => this.toggleControl(PLAY_PAUSE, 2), isActive: controls[PLAY_PAUSE] === 2 }));
        const nextVideoButton = this.state.filteredPlaylist.length > 1 && (React.createElement(VideoPlayerButton$1, { title: translate('components.video.go-to-next'), icon: "next", onClick: () => this.goToNextVideo() }));
        const nextFrameButton = (React.createElement(VideoPlayerButton$1, { className: "high-use", icon: "step-forward", title: translate('components.video.step-forward'), onClick: () => this.toggleSliderEvent(STEP_FORWARD) }));
        const prevFrameButton = (React.createElement(VideoPlayerButton$1, { className: "high-use", icon: "step-backward", title: translate('components.video.step-backward'), onClick: () => this.toggleSliderEvent(STEP_BACK) }));
        const playFromStartButton = (React.createElement(VideoPlayerButton$1, { title: translate('components.video.play-from-beginning'), icon: "step-backward2", onClick: () => this.toggleSliderEvent(PLAY_FROM_BEGINNING) }));
        const filterButton = (React.createElement(VideoPlayerButton$1, { title: translate('components.video.filter-playlist'), icon: this.state.filteredPlaylist.length !== this.props.playlist.length ? 'filter-solid' : 'filter-hollow', isActive: !!controls[FILTER], onClick: () => this.toggleControl(FILTER), disabled: this.props.playlist.length <= 1 }));
        const playlistButton = (React.createElement(VideoPlayerButton$1, { title: translate('components.video.show-playlist'), icon: "list2", isActive: !!controls[PLAYLIST], onClick: () => this.toggleControl(PLAYLIST) }));
        const statsButton = this.props.loadPitchData && (React.createElement(VideoPlayerButton$1, { title: translate('components.video.show-pitch-statistics'), icon: "stats", isActive: !!controls[STATS], onClick: () => this.toggleStats(currentVideo) }));
        const loopButton = (isActionMenuItem) => {
            if (isActionMenuItem ? isFullScreenView : !containerWidth)
                return null;
            if (isActionMenuItem ? containerWidth >= bootstrapLg : !isFullScreenView && containerWidth < bootstrapLg)
                return null;
            return (React.createElement(VideoPlayerButton$1, { title: translate('components.video.loop'), icon: "loop", onClick: () => this.toggleControl(LOOP), isActive: !!controls[LOOP], showLabel: isActionMenuItem }));
        };
        const heatmapButton = this.props.loadPitchHeatmap && (React.createElement(VideoPlayerButton$1, { title: translate('components.video.show-heatmap'), icon: "fire", isActive: !!controls[HEATMAP], onClick: () => this.toggleHeatmap(currentVideo) }));
        let currentFrame = null;
        if (this.props.showCurrentFrame && ((_b = this.state.selectedAngle) === null || _b === void 0 ? void 0 : _b.file)) {
            const meta = get$2(this.state.metadata, this.state.selectedAngle.file);
            if (meta && !meta.loading) {
                currentFrame = !!meta.Fps && (React.createElement(StyledVideoFrameDisplay, null, format(meta.Fps * this.state.sliderTimeValue, 0)));
            }
        }
        return (React.createElement(StyledVideoPlaylistContainer, { ref: this.playlistContainerRef, style: { height: containerHeight }, "$roundCorners": this.props.roundCorners },
            !isMobileView && isFullScreenMode && (React.createElement(VideoPlaylistTabs, { playlist: this.state.filteredPlaylist, activeIdx: this.state.currentVideoIdx, toggleStats: () => this.toggleStats(currentVideo), onVideoClick: this.goToNextVideo, isStatsOpen: !!controls[STATS], loadPitchData: this.props.loadPitchData, isFullScreenMode: isFullScreenMode, statsContent: statsContent })),
            isMobileView && (React.createElement(StyledMobileHeader, null,
                React.createElement("div", null, currentVideo.title),
                currentVideo.description && React.createElement("small", null, currentVideo.description),
                statsContent)),
            !isFullScreenView && (React.createElement(StyledVideoPlaylistHeader, { "$width": containerWidth },
                React.createElement(StyledVideoControlsSection, { "$width": containerWidth },
                    React.createElement("div", null,
                        React.createElement("h4", null, currentVideo.title),
                        currentVideo.description && React.createElement("label", null,
                            React.createElement("small", null, currentVideo.description)))),
                React.createElement(StyledVideoControlsSection, { "$width": containerWidth },
                    angleSelector,
                    !this.props.alwaysShowPitchData && !this.props.hideHeatmap && statsButton,
                    !this.props.hideHeatmap && heatmapButton,
                    !this.props.alwaysShowFilter && !this.props.hideFilter && filterButton,
                    !this.props.hidePlaylistSelector && playlistButton))),
            React.createElement(StyledVideoPlayer$1, null,
                this.state.toastMessage && (React.createElement(ToastNotification, { message: this.state.toastMessage, header: translate('components.video.share'), clearMessage: () => this.setState({ toastMessage: '' }) })),
                React.createElement(StyledVideoContainer$1, { "$fullscreen": isFullScreenMode, onClick: (e) => this.toggleActionMenu(e, false) },
                    React.createElement("div", { className: "d-flex flex-row justify-content-center w-100 h-100 flex-grow-1" },
                        React.createElement(StyledVideoContentContainer, { ref: this.videoContentContainerRef, tabIndex: 0 },
                            React.createElement(Video, { onClick: () => this.toggleControl(PLAY_PAUSE, 1), setCurrentTime: (setCurrentTimeFn) => { this.setCurrentVideoTime = setCurrentTimeFn; }, onPlayback: this.onPlayback, onVideoEnd: this.onVideoEnd, onVideoLoad: this.onVideoLoadedData, onVideoError: (e) => this.setVideoError(translate, e), play: controls[PLAY_PAUSE], loop: !!controls[LOOP], mute: !!controls[MUTE], src: this.state.selectedAngle.file, autoPlay: this.props.autoPlay, maxHeight: maxVideoHeight, minHeight: minVideoHeight, videoRef: (el) => { this.videoRef = el; } }),
                            !this.state.selectedAngle.file && (React.createElement(StyledVideoNotFound, null,
                                React.createElement("label", null, translate('components.video.no-videos-found')))),
                            this.state.errorMessage.title && (React.createElement(StyledVideoError, null,
                                React.createElement("label", null, this.state.errorMessage.title),
                                this.state.errorMessage.subtitle && React.createElement("label", null, this.state.errorMessage.subtitle))),
                            (this.videoPlayerHeight && !this.state.errorMessage.title) && React.createElement(LoadingSpinner$1, null),
                            currentFrame,
                            !!controls[GRID_SIZE] && (React.createElement(VideoPlayerGrid$1, { onClick: () => this.toggleControl(PLAY_PAUSE, 1), gridSize: controls[GRID_SIZE], containerWidth: this.videoContentContainerRef.current.offsetWidth, containerHeight: this.videoContentContainerRef.current.offsetHeight })),
                            controls[HEATMAP] && currentVideo.heatmapId && !this.state.errorMessage.title && (React.createElement(VideoPlayerHeatmap$1, { heatmap: get$2(this.state.heatMaps, currentVideo.heatmapId), plateX: (pitchData === null || pitchData === void 0 ? void 0 : pitchData.platex) || ((_c = currentVideo.data) === null || _c === void 0 ? void 0 : _c.platex), plateZ: (pitchData === null || pitchData === void 0 ? void 0 : pitchData.platez) || ((_d = currentVideo.data) === null || _d === void 0 ? void 0 : _d.platez) }))),
                        !isMobileView && videoFilter,
                        !isMobileView && videoPlayist),
                    !isFullScreenView && statsContent,
                    isFullScreenView && (React.createElement(React.Fragment, null,
                        React.createElement(StyledFullScreenVideoControls, { "$left": true, "$width": containerWidth },
                            React.createElement(StyledFullScreenVideoControlsSection, { "$width": containerWidth, "$has5Buttons": (!isMobileView || !this.props.alwaysShowFilter) && !!heatmapButton },
                                (!isMobileView || !this.props.alwaysShowFilter) && filterButton,
                                heatmapButton,
                                playlistButton,
                                playFromStartButton,
                                prevFrameButton)),
                        React.createElement(StyledFullScreenVideoControls, { "$right": true, "$width": containerWidth },
                            React.createElement(StyledFullScreenVideoControlsSection, { "$width": containerWidth, "$has5Buttons": (!isMobileView || !this.props.alwaysShowFilter) && !!heatmapButton },
                                playButton,
                                fastForwardButton,
                                nextVideoButton,
                                nextFrameButton))))),
                React.createElement(StyledVideoControls, { ref: this.videoControlsContainerRef, "$width": containerWidth },
                    React.createElement(StyledVideoControlsSection, { "$width": containerWidth },
                        React.createElement(VideoPlayerButton$1, { title: translate('components.video.mute'), icon: "mute", onClick: this.toggleMute, isActive: !!controls[MUTE] })),
                    isFullScreenView && (React.createElement(StyledVideoControlsSection, { "$width": containerWidth }, angleSelector)),
                    React.createElement(StyledVideoControlsSection, { "$width": containerWidth, className: "flex-grow-1" },
                        React.createElement(ProgressSlider, { max: this.state.maxVideoTime, value: this.state.sliderTimeValue, onChange: this.onSliderChange }),
                        React.createElement("label", null, this.translateSliderTime(this.state.sliderTimeValue))),
                    !isFullScreenView && (React.createElement(StyledVideoControlsSection, { "$width": containerWidth },
                        playFromStartButton,
                        prevFrameButton,
                        nextFrameButton,
                        playButton,
                        fastForwardButton,
                        nextVideoButton)),
                    React.createElement(StyledVideoControlsSection, { "$width": containerWidth },
                        !isMobileView && (React.createElement("div", { ref: this.actionMenuRef },
                            React.createElement(Overlay, { show: this.state.actionMenu.show, target: this.state.actionMenu.target, container: this.actionMenuRef.current, containerPadding: 20, placement: "top" },
                                React.createElement(StyledActionMenuPopover, null,
                                    React.createElement(StyledActionMenuPopover.Body, null,
                                        this.props.exportPlaylist && (React.createElement(VideoPlayerButton$1, { title: translate('components.video.create-playlist'), icon: "link", onClick: this.exportPlaylistToIPad, showLabel: true })),
                                        !this.props.hideShare && (React.createElement(VideoPlayerButton$1, { title: translate('components.video.share'), icon: "share2", onClick: () => this.share(translate), showLabel: true })),
                                        this.props.showCopySQL && (React.createElement(VideoPlayerButton$1, { title: `${translate('components.video.copy')} SQL`, icon: "keyboard", onClick: this.copySQL, showLabel: true })),
                                        !this.props.hideDownload
                                            && (React.createElement(DownloadVideosModal$1, { download: this.props.download, playlist: this.state.filteredPlaylist, modalContainer: this.playlistContainerRef })),
                                        React.createElement(SelectGridSizeModal, { onSelectGridSize: (gridSize) => this.toggleControl(GRID_SIZE, gridSize), modalContainer: this.playlistContainerRef, isActive: !!controls[GRID_SIZE] }),
                                        React.createElement(ReportBadVideoModal, { modalContainer: this.playlistContainerRef, isActive: !!controls[REPORT_BAD_VIDEO], onClick: () => controls[PLAY_PAUSE] && this.toggleControl(PLAY_PAUSE, false), reportBadVideo: this.props.reportBadVideo, currentVideo: currentVideo, selectedAngle: this.state.selectedAngle, errors: this.state.errors }),
                                        !this.props.hideFrameGrab
                                            && (React.createElement(VideoPlayerButton$1, { title: translate('components.video.frame-grab'), icon: "target", loading: !!controls[FRAME_GRAB], onClick: this.onGrabFrame, showLabel: true })),
                                        loopButton(true)))),
                            React.createElement(VideoPlayerButton$1, { title: translate('components.video.open-actions'), icon: "open-menu", onClick: this.toggleActionMenu, disabled: !this.state.selectedAngle.file }))),
                        isMobileView && statsButton,
                        loopButton(false),
                        React.createElement(VideoPlayerButton$1, { title: translate('components.video.fullscreen'), icon: isFullScreenMode ? 'shrink' : 'enlarge', onClick: this.toggleFullScreenMode })))),
            isMobileView && videoFilter,
            isMobileView && videoPlayist));
    }
}
VideoPlayer.defaultProps = {
    autoPlay: true,
    overrideWindowEventListeners: false,
    alwaysShowPitchData: false,
    alwaysShowFilter: false,
    hidePlaylistSelector: false,
    showCurrentFrame: false,
    showCopySQL: false,
    hideFilter: false,
    hideHeatmap: false,
    hidePitchData: false,
    hideShare: false,
    hideDownload: false,
    hideFrameGrab: false,
    // eslint-disable-next-line react/default-props-match-prop-types
    specialtyAngleKey: '',
    overrideAngleKey: '',
};
var VideoPlayer$1 = withTranslation('translation', { withRef: true })(VideoPlayer);

const videoPlayerBorderRadius = 4;
const maxModalWidth = 0.925;
const maxModalContentWidth = 1280;
const StyledDialog = styled(ModalDialog) `
    &&& {
        max-width: ${maxModalWidth * 100}%;
        @media screen and (min-width: ${maxModalContentWidth * (1 / maxModalWidth)}px) {
            max-width: ${maxModalContentWidth}px;
        }
    }
    && {
        > .modal-content {
            border: none;
            background: transparent;
            text-align: center;
        }
    }
    .modal-border-top {
        border-top-left-radius: ${videoPlayerBorderRadius}px;
        border-top-right-radius: ${videoPlayerBorderRadius}px;
    }
    .modal-border-bottom {
        border-bottom-left-radius: ${videoPlayerBorderRadius}px;
        border-bottom-right-radius: ${videoPlayerBorderRadius}px;
    }
`;
const StyledVideoContainer = styled.div `
    border-radius: 0.3rem;
    && {
        > .spinner-border {
            margin-top: 25%;
        }
    }
`;
const VideoModal = ({ children, onHide, container, show = false, loading = false, restoreFocus = true }) => (React.createElement(Modal, { show: show, onHide: onHide, size: "lg", dialogAs: StyledDialog, container: container, restoreFocus: restoreFocus },
    React.createElement(StyledVideoContainer, null,
        loading && React.createElement(LoadingSpinner$1, null),
        !loading && children)));

const VideoPlayerModal = (_a) => {
    var { onHide, container, playlist, show = false, restoreFocus = true } = _a, rest = __rest(_a, ["onHide", "container", "playlist", "show", "restoreFocus"]);
    return (React.createElement(VideoModal, { show: show, onHide: onHide, container: container, loading: !playlist, restoreFocus: restoreFocus },
        React.createElement(VideoPlayer$1, Object.assign({ playlist: playlist || [], overrideWindowEventListeners: true }, rest, { onHide: onHide }))));
};

const StyledPlaySvg = styled.svg `
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 10px calc(50% - 50px);
    top: 0;
    left: 0;
    display: block;
    opacity: 0.95;
    cursor: pointer;
    transition: opacity 150ms;
    position: absolute;
`;
const VideoOverlayPlayButton = () => (React.createElement(StyledPlaySvg, { className: "screenonly", viewBox: "0 0 200 200", "aria-label": "Play video" },
    React.createElement("circle", { cx: "100", cy: "100", r: "90", fill: "rgba(77,77,77,0.4)", strokeWidth: "7", stroke: "rgba(255,255,255,0.3)" }),
    React.createElement("polygon", { points: "70, 55 70, 145 145, 100", fill: "rgba(255,255,255,0.6)" })));

const SimpleVideoPlayer = (props) => (React.createElement(Video, Object.assign({ controls: true }, props)));

const SimpleVideoPlayerModal = (_a) => {
    var { show, onHide, container, src } = _a, rest = __rest(_a, ["show", "onHide", "container", "src"]);
    return (React.createElement(VideoModal, { show: show, onHide: onHide, container: container, loading: !src },
        React.createElement(SimpleVideoPlayer, Object.assign({ src: src }, rest))));
};

const buildSeries$7 = (translate, type, videos) => {
    const markerRadius = 4;
    const series = [
        {
            data: [],
            type: 'scatter',
            name: translate('baseball.hits_other'),
            index: 1,
            id: 'hit',
            marker: { symbol: 'circle',
                radius: markerRadius,
                lineColor: '#0000ff',
                fillColor: '#ffffff',
                lineWidth: 1 },
        },
        { data: [],
            type: 'scatter',
            name: translate('baseball.outs_other'),
            index: 2,
            id: 'out',
            marker: { symbol: 'diamond',
                radius: markerRadius,
                lineColor: '#0000ff' } },
        {
            data: [],
            type: 'scatter',
            name: translate('baseball.abbr-reach-error'),
            index: 3,
            id: 'roe',
            marker: { symbol: 'triangle',
                radius: markerRadius,
                lineColor: '#0000ff',
                fillColor: '#ffffff',
                lineWidth: 1 },
        },
        {
            data: [],
            type: 'scatter',
            name: translate('baseball.home-run'),
            index: 4,
            id: 'hr',
            marker: { symbol: 'square',
                radius: markerRadius,
                lineColor: '#0000ff',
                fillColor: '#ffffff',
                lineWidth: 1 },
        },
    ];
    const isIFHit = (p) => p.hittypecode === 'G' || p.hittypecode === 'B' || (p.distance !== null && p.distance < 150);
    const filteredData = videos.filter((d) => (type === 'infield' ? isIFHit(d) : !isIFHit(d)) && d.islastpitch);
    filteredData.forEach((d) => {
        var _a, _b, _c, _d;
        const point = Object.assign({}, d);
        const tooltip = [];
        point.name = `${d.batter} ${translate('baseball.abbr-versus')} ${d.pitcher} - ${dateTranslate(translate, d.gamedate)}`;
        const tooltipRow1 = [];
        tooltipRow1.push(`${d.hittype !== null ? hitType(d.hittype, true, translate) : ''} ${baseEvent(d.baseevent, true, undefined, translate)} ${dateTranslate(translate, d.gamedate)}`);
        if (d.hittypecode === 'F' && d.distance)
            tooltipRow1.push(`${d.distance.toFixed(1)} ${translate('components.video.filters.abbr-feet')}`);
        if (d.hittypecode === 'F' && d.hangtime)
            tooltipRow1.push(`${d.hangtime} ${translate('components.video.filters.abbr-seconds')}`);
        tooltip.push(tooltipRow1.join(', '));
        tooltip.push(`${d.istop ? translate('baseball.abbr-top') : translate('baseball.abbr-bottom')} ${d.inning}, ${d.outsbefore} ${translate('baseball.outs_one')} ${d.balls}-${d.strikes} ${translate('baseball.count')}`);
        if (d.pitchtype && d.velocity) {
            tooltip.push(`${pitchType(d.pitchtype, undefined, undefined, translate)}, ${translate('format.abbr-mph', { value: format(d.velocity) })}`);
        }
        point.tooltip = tooltip.join('<br />');
        switch (d.baseevent) {
            case 0:
            case 1:
            case 2:
            case 3:
                (_a = series[0].data) === null || _a === void 0 ? void 0 : _a.push(point);
                break;
            case 8:
            case 11:
            case 12:
            case 13:
                (_b = series[1].data) === null || _b === void 0 ? void 0 : _b.push(point);
                break;
            case 14:
                (_c = series[2].data) === null || _c === void 0 ? void 0 : _c.push(point);
                break;
            case 4:
                (_d = series[3].data) === null || _d === void 0 ? void 0 : _d.push(point);
                break;
        }
    });
    return series.filter((s) => { var _a; return (_a = s.data) === null || _a === void 0 ? void 0 : _a.length; }).map((s) => {
        var _a;
        return (Object.assign(Object.assign({}, s), { data: (_a = s === null || s === void 0 ? void 0 : s.data) === null || _a === void 0 ? void 0 : _a.map((d) => (Object.assign({ x: d.ballinplayx, y: d.ballinplayy }, d))) }));
    });
};
const SprayChart$2 = ({ type, videos, onClick, sizeMultiplier }) => {
    const { t: translate } = useTranslation();
    const seriesData = buildSeries$7(translate, type, videos);
    return (React.createElement(SprayChart$3, { type: type, seriesData: seriesData, onClick: onClick, enableLegend: true, enableZoom: true, sizeMultiplier: sizeMultiplier, preventLegendSeriesHover: true }));
};

const StrikeZone$2 = ({ playlist, onClick, height, type, size }) => {
    const { t: translate } = useTranslation();
    let strikeZoneSeries = [];
    const getPlayResult = (play) => {
        // Last Pitch
        const fielderEvents = ['Batted Out', 'Single', 'Double', 'Triple'];
        if (play.result && fielderEvents.indexOf(play.result) > -1) {
            return play.result === 'Batted Out'
                ? `${play.hittype_desc} ${translate('common.to')} ${play.fielderposition}`
                : `${play.result}, ${play.hittype_desc} ${translate('common.to')} ${play.fielderposition}`;
        }
        return play.result || play.pitchresult;
    };
    const buildStrikeZoneSeries = (plays, pitchLocationType) => {
        let series;
        if (pitchLocationType === 'pitchTypes') {
            const pitchTypes = Array.from(new Set(plays.map((p) => Number(p.fxpitchtypeid))));
            series = pitchTypes.map((ptype, index) => {
                const name = pitchType(ptype, true, undefined, translate);
                const color = pitchTypeColor(ptype, translate);
                const data = plays.filter((play) => play.fxpitchtypeid === ptype).map((play) => {
                    const result = getPlayResult(play);
                    return {
                        x: play.platex,
                        y: play.platez,
                        name: result,
                        url: play.url,
                        gameid: play.gameid,
                        eventseq: play.eventseq,
                        pitchseq: play.pitchseq,
                        id: `${play.gameid}_${play.eventseq}_${play.pitchseq}`,
                    };
                });
                return { index, data, name, id: name, color, marker: { symbol: 'circle', radius: 4 }, type: 'scatter' };
            });
        }
        else {
            if (!plays || !plays.length)
                return [];
            const hits = {
                data: [],
                type: 'scatter',
                name: translate('components.video.hard-hit'),
                index: 1,
                id: 'hit',
                color: '#0000ff',
                marker: { symbol: 'diamond', radius: 4, lineColor: '#0000ff', fillColor: '#ffffff', lineWidth: 2 }
            };
            const battedouts = {
                data: [],
                type: 'scatter',
                name: translate('components.video.hard-batted-out'),
                index: 2,
                id: 'out',
                color: '#0000ff',
                marker: { symbol: 'triangle', radius: 5 }
            };
            const swingingstrikes = {
                data: [],
                type: 'scatter',
                name: translate('components.video.swinging-strike'),
                index: 3,
                id: 'swing',
                color: '#ff0000',
                marker: { symbol: 'diamond', radius: 5 }
            };
            const fouls = {
                data: [],
                type: 'scatter',
                name: translate('components.video.foul'),
                index: 4,
                id: 'foul',
                color: '#ff0000',
                marker: { symbol: 'square', radius: 4, lineColor: '#ff0000', fillColor: '#ffffff', lineWidth: 2 }
            };
            const balls = {
                data: [],
                type: 'scatter',
                name: translate('baseball.balls_one'),
                index: 5,
                id: 'ball',
                color: '#00ff00',
                marker: { symbol: 'circle', radius: 5 }
            };
            const calledstrikes = {
                data: [],
                type: 'scatter',
                name: translate('components.video.called-strike'),
                index: 6,
                id: 'stk',
                color: '#ff0000',
                marker: { symbol: 'circle', radius: 5 }
            };
            const weakhits = {
                data: [],
                type: 'scatter',
                name: translate('components.video.weak-hit'),
                index: 7,
                id: 'wkhit',
                color: '#ffa500',
                marker: { symbol: 'diamond', radius: 4, lineColor: '#ffa500', fillColor: '#ffffff', lineWidth: 2 }
            };
            const weakbattedouts = {
                data: [],
                type: 'scatter',
                name: translate('components.video.weak-batted-out'),
                index: 8,
                id: 'wkout',
                color: '#ffa500',
                marker: { symbol: 'triangle', radius: 5 }
            };
            for (let i = 0; i < plays.length; ++i) {
                const play = plays[i];
                if (play.platex && play.platez) {
                    const result = play.resultid;
                    const event = play.baseevent;
                    const point = {
                        x: play.platex,
                        y: play.platez,
                        name: '',
                        tooltip: `${''
                            + `${translate('common.date')}:`}${dateTranslate(translate, play.gamedate)}<br />`
                            + `${translate('components.video.pitch-type')}: ${play.pitchtype}<br />${play.velocity ? `${play.velocity} MPH<br/>` : ''}${play.istop ? `${translate('baseball.abbr-top')} ` : `${translate('baseball.abbr-bottom')} `}${play.inning}, ${play.outsbefore} ${translate('baseball.outs_one')}, ${play.balls}-${play.strikes}<br />${translate('baseball.pitcher_one')}: ${play.pitcher} ${play.islastpitch && (result === 14 || result === 15)
                                ? `<br />${play.hittype ? hitType(play.hittype, false, translate) : ''} ${baseEvent(event, undefined, undefined, translate)}
                                ${play.exitvelo ? `, ${translate('components.video.exit-velo')} ${format(play.exitvelo)}` : ''}`
                                : ''}`,
                        url: play.url,
                        gameid: play.gameid,
                        eventseq: play.eventseq,
                        pitchseq: play.pitchseq,
                    };
                    if ((result === 14 || result === 15) && event > 0 && event < 5 && play.wellhit === 1) {
                        hits.data.push(point);
                    }
                    else if ((result === 14 || result === 15) && play.wellhit === 1 && (event === 8 || (event > 10 && event < 16))) {
                        battedouts.data.push(point);
                    }
                    else if (result === 1) {
                        balls.data.push(point);
                    }
                    else if (result === 4) {
                        calledstrikes.data.push(point);
                    }
                    else if (result === 6 || result === 5 || result === 7) {
                        swingingstrikes.data.push(point);
                    }
                    else if (result >= 8 && result <= 13) {
                        fouls.data.push(point);
                    }
                    else if ((result === 14 || result === 15) && event > 0 && event < 5 && play.wellhit === 0) {
                        weakhits.data.push(point);
                    }
                    else if ((result === 14 || result === 15) && play.wellhit === 0 && (event === 8 || (event > 10 && event < 16))) {
                        weakbattedouts.data.push(point);
                    }
                }
            }
            series = [hits, battedouts, swingingstrikes, fouls, balls, calledstrikes, weakhits, weakbattedouts];
            series = series.filter((x) => x.data.length > 0);
        }
        return series;
    };
    if (playlist && playlist.length > 0) {
        strikeZoneSeries = buildStrikeZoneSeries(playlist, type);
    }
    return (React.createElement(StrikeZone$3, { enableZoom: true, showlegend: true, legendposition: "below", seriesData: strikeZoneSeries, showbatter: false, onClick: onClick, height: height, size: size, preventLegendSeriesHover: true, ignoreLocalStorageChartLegend: false }));
};

const StyledScore = styled.div `
    > div {
        display: flex;
        justify-content: space-evenly;
        > span {
            font-weight: bold;
            font-size: 0.9em;
        }
    }
`;
const PitchTable = ({ playlist, onClick }) => {
    const { t: translate } = useTranslation();
    const getPlayResult = (play) => {
        // Last Pitch
        const fielderEvents = ['Batted Out', 'Single', 'Double', 'Triple'];
        if (play.result !== null && fielderEvents.indexOf(play.result) > -1) {
            return play.result === 'Batted Out'
                ? `${play.hittype_desc} ${translate('common.to')} ${play.fielderposition}`
                : `${play.result}, ${play.hittype_desc} ${translate('common.to')} ${play.fielderposition}`;
        }
        return play.result || play.pitchresult;
    };
    const pitchColumns = [
        { id: 'videoplaylist', title: null, type: COLUMN_TYPES.NODE },
        { id: 'inn', title: translate('baseball.abbr-inning'), transform: (row) => `${row.istop ? translate('baseball.abbr-top-alt') : translate('baseball.abbr-bottom-alt')}${row.inning}`, type: COLUMN_TYPES.TEXT },
        {
            id: 'batter',
            title: translate('baseball.batter'),
            transform: (row) => `${row.batter_lastname}, ${row.batter_usesname.charAt(0)}`,
            type: COLUMN_TYPES.TEXT,
        },
        {
            id: 'batterhand',
            title: translate('baseball.bats'),
            transform: (row) => {
                if (row.bats === 2)
                    return translate('baseball.abbr-left');
                return translate('baseball.abbr-right');
            },
            type: COLUMN_TYPES.TEXT,
        },
        { id: 'outs', title: translate('baseball.outs_other'), transform: (row) => (React.createElement("span", null, row.outsbefore)), type: COLUMN_TYPES.NODE },
        {
            id: 'run',
            title: translate('components.video.run'),
            transform: (row) => (React.createElement(BaseRunners, { baseState: row.bcbefore, emptyColor: "#98CBFF", height: 20, width: 30 })),
            type: COLUMN_TYPES.NODE,
        },
        {
            id: 'score',
            title: translate('baseball.score'),
            transform: (row) => (React.createElement(StyledScore, null,
                React.createElement("div", null,
                    React.createElement("span", null, row.awayteam_abbr),
                    React.createElement("span", null, row.awayteam_score)),
                React.createElement("div", null,
                    React.createElement("span", null, row.hometeam_abbr),
                    React.createElement("span", null, row.hometeam_score)))),
            type: COLUMN_TYPES.NODE,
        },
        { id: 'count', title: translate('baseball.abbr-count'), transform: (row) => `${row.balls}-${row.strikes}`, type: COLUMN_TYPES.TEXT },
        // eslint-disable-next-line max-len
        { id: 'pitchtype', title: translate('components.video.pitch-type'), transform: (row) => `${pitchType(row.fxpitchtypeid, false, '', translate)}${row.fxsubtype != null ? ` (${pitchSubType(row.fxsubtype, false, '', translate)})` : ''}`, type: COLUMN_TYPES.TEXT },
        { id: 'velocity', title: translate('components.video.pitch-velo'), transform: (row) => row.velocity, precision: 1 },
        {
            id: 'pitchlocation',
            title: translate('components.video.pitch-location'),
            transform: (row) => (row.locationx && row.locationy
                ? (React.createElement(PitchLocation$1, { size: 30, locations: [{ locationx: row.locationx, locationy: row.locationy }], emptyColor: "#98CBFF" })) : React.createElement(React.Fragment, null)),
            type: COLUMN_TYPES.NODE,
        },
        {
            id: 'hittype',
            title: translate('components.video.hit-type'),
            transform: (row) => (row.hittype !== null ? hitType(row.hittype, false, translate) : '--'),
            type: COLUMN_TYPES.TEXT,
        },
        { id: 'hitvelocity', title: translate('components.video.exit-velo'), transform: (row) => row.hitvelocity, precision: 1 },
        { id: 'launchangle', title: translate('components.video.launch-angle'), transform: (row) => row.vertla, precision: 1 },
        {
            id: 'hitlocation',
            title: translate('components.video.hit-location'),
            transform: (row) => (row.hittype !== null ? (React.createElement(HitLocation, { width: 40, height: 30, ballinplayx: row.ballinplayx, ballinplayy: row.ballinplayy, ishr: row.result === 'Home Run' })) : null),
            type: COLUMN_TYPES.TEXT,
        },
        { id: 'result', title: translate('components.video.result'), transform: (row) => getPlayResult(row), type: COLUMN_TYPES.TEXT },
    ];
    const pitchRows = playlist && playlist.length
        ? playlist.map((p) => {
            const videoplaylist = (React.createElement(VideoButton, { onClick: () => onClick(p) }));
            return Object.assign(Object.assign({}, p), { videoplaylist });
        }) : [];
    return React.createElement(DataTable, { sortable: false, columns: pitchColumns, rows: pitchRows });
};

const StyledSprayChartContainer = styled.div `
    margin: 0 auto 0;
    width: 100% !important;
    height: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const VideoPlayerCol = styled(Col$1) `
    .video-playlist-container {
        height: 100%;
    }
`;
const StyledVideoPlayer = styled(VideoPlayer) `
    height: 100%;

    .video-playlist-container {
        height: 100%;
    }
`;
const StyledTabPanel = styled.div `
    border: ${tabTheme.border};
    ${(props) => (props.isInTabs ? 'border-top: none;' : '')}
`;
const VideoPlayerAdvanced = forwardRef((_a, ref) => {
    var { playlist, onHide, isLargeView = false, hideFilter = false } = _a, rest = __rest(_a, ["playlist", "onHide", "isLargeView", "hideFilter"]);
    const { t: translate } = useTranslation();
    const pitchLocationOptions = [{ name: translate('components.video.results'), value: 'results' }, { name: translate('components.video.pitch-types'), value: 'pitchTypes' }];
    const sprayChartOptions = [{ name: translate('components.video.infield'), value: 'infield' }, { name: translate('components.video.outfield'), value: 'outfield' }];
    const ITEMS_PER_PAGE = 500;
    const [selectedPitchLocation, setSelectedPitchLocation] = useState('results');
    const [selectedSprayChart, setSelectedSprayChart] = useState('infield');
    const [filteredVideos, setFilteredVideos] = useState(playlist);
    const [sortedModalPlaylist, setSortedModalPlaylist] = useState(playlist);
    const [showVideoPlayerModal, setShowVideoPlayerModal] = useState(false);
    const [activeTabKey, setActiveTabKey] = useState('pitchLocation');
    const [currentPage, setCurrentPage] = useState(1);
    const usePagination = filteredVideos.length > 1000;
    const onTabSelect = ({ key }) => setActiveTabKey(key);
    const videoPlayerModalContainer = useRef(null);
    const videoPlayerRef = useRef(null);
    useImperativeHandle(ref, () => ({
        setFilteredVideos: (p, f) => {
            var _a;
            (_a = videoPlayerRef === null || videoPlayerRef === void 0 ? void 0 : videoPlayerRef.current) === null || _a === void 0 ? void 0 : _a.onFilter(p, f);
        },
    }));
    const goToVideo = (pitchInfo) => {
        var _a;
        const { gameid, pitchseq, eventseq } = pitchInfo;
        const index = filteredVideos.findIndex((v) => v.data.gameid === gameid && v.data.pitchseq === pitchseq && v.data.eventseq === eventseq);
        if (index > -1) {
            (_a = videoPlayerRef === null || videoPlayerRef === void 0 ? void 0 : videoPlayerRef.current) === null || _a === void 0 ? void 0 : _a.goToNextVideo(index);
            if (browser$1.mobileOnly) {
                const end = filteredVideos.slice(undefined, index - 1);
                const start = filteredVideos.slice(index, undefined);
                const np = start.concat(end);
                setSortedModalPlaylist(np);
                setShowVideoPlayerModal(true);
            }
        }
    };
    const onFilter = (p) => {
        setFilteredVideos(p);
    };
    useEffect(() => {
        setFilteredVideos(playlist);
        setSortedModalPlaylist(playlist);
    }, [playlist]);
    const InnerStrikeZone = () => (React.createElement(StyledTabPanel, { isInTabs: isLargeView, className: `flex-grow-1 bg-white d-flex flex-column justify-content-center ${isLargeView ? 'rounded-bottom' : 'rounded'}`, style: { zIndex: 0 } },
        React.createElement("div", { className: "mt-5 d-flex justify-content-center" },
            React.createElement(ToggleButtons, { name: "togglestrike", options: pitchLocationOptions, value: selectedPitchLocation, onChange: (value) => setSelectedPitchLocation(value) })),
        React.createElement("div", { className: "flex-grow-1 d-flex align-items-center mt-2" },
            React.createElement(StrikeZone$2, { type: selectedPitchLocation, playlist: filteredVideos.map((p) => p.data), onClick: (pitchInfo) => goToVideo(pitchInfo), size: isLargeView ? 'sm' : 'lg', height: isLargeView ? 350 : 435 }))));
    const InnerSprayChart = () => (React.createElement(StyledTabPanel, { isInTabs: isLargeView, className: `flex-grow-1 bg-white d-flex flex-column justify-content-center h-100 ${isLargeView ? 'rounded-bottom' : 'rounded'}`, style: { zIndex: 0 } },
        React.createElement("div", { className: "mt-5 d-flex justify-content-center" },
            React.createElement(ToggleButtons, { name: "togglespray", options: sprayChartOptions, value: selectedSprayChart, onChange: (value) => setSelectedSprayChart(value) })),
        React.createElement(StyledSprayChartContainer, null,
            React.createElement(SprayChart$2, { type: selectedSprayChart, videos: filteredVideos.map((p) => p.data), onClick: (p) => goToVideo(p), sizeMultiplier: isLargeView ? 2 : 1.3 }))));
    const tabs = [
        {
            title: translate('components.video.pitch-location'),
            key: 'pitchLocation',
            component: () => React.createElement(InnerStrikeZone, null),
        },
        {
            title: translate('components.video.spray-chart'),
            key: 'sprayChart',
            component: () => React.createElement(InnerSprayChart, null),
            className: 'me-0',
        },
    ];
    const activeTab = tabs.find(({ key }) => key === activeTabKey);
    return (React.createElement("div", null,
        React.createElement("div", { ref: videoPlayerModalContainer }),
        React.createElement(Row$1, null,
            React.createElement(VideoPlayerCol, { sm: isLargeView ? 9 : 12 }, browser$1.mobileOnly ? (React.createElement(VideoPlayerModal, Object.assign({ playlist: sortedModalPlaylist, show: showVideoPlayerModal, onHide: () => setShowVideoPlayerModal(false), container: videoPlayerModalContainer }, rest))) : React.createElement(StyledVideoPlayer, Object.assign({ playlist: playlist, onFilter: onFilter, onHide: onHide, ref: videoPlayerRef, hideFilter: hideFilter }, rest, { translate: translate }))),
            isLargeView && (React.createElement(Col$1, { sm: 3, className: "ps-0" },
                React.createElement("div", { className: "d-flex flex-column h-100" },
                    React.createElement(TabContainer, null, tabs.map((t) => {
                        const { key, title } = t;
                        return (React.createElement(Tab, { key: key, active: t === activeTab, onClick: () => onTabSelect(t), className: `flex-grow-1 ${t.className}` }, title));
                    })), activeTab === null || activeTab === void 0 ? void 0 :
                    activeTab.component())))),
        !isLargeView
            && (React.createElement(Row$1, { className: "mt-4" },
                React.createElement(Col$1, { sm: 5 },
                    React.createElement(InnerStrikeZone, null)),
                React.createElement(Col$1, { sm: 7 },
                    React.createElement("div", { className: "h-100" },
                        React.createElement(InnerSprayChart, null))))),
        React.createElement(Row$1, { className: "mt-3" },
            React.createElement(Col$1, { sm: 12 },
                React.createElement(PitchTable, { playlist: usePagination
                        ? filteredVideos.slice(ITEMS_PER_PAGE * (currentPage - 1), currentPage * ITEMS_PER_PAGE).map((p) => p.data)
                        : filteredVideos.map((p) => p.data), onClick: (pitchInfo) => goToVideo(pitchInfo) }),
                usePagination && (React.createElement(DataTablePagination, { onPageChange: setCurrentPage, totalItems: filteredVideos.length, itemsPerPage: ITEMS_PER_PAGE, page: currentPage }))))));
});

const StyledVideoSearchFormInputContainer = styled.div `
    display: flex;
    align-items: center;
    flex: 1;
    > label {
        min-width: 50px;
        flex-basis: 50px;
        flex-grow: 0;
        margin: 0 7.5px 0 0;
    }
    .d-flex & + & > label { 
        margin-left: 15px;
    }
    > div {
        flex-grow: 1;
        display: flex;
        align-items: center;
        > div {
            flex: 1;
        }
        > span {
            flex: 0;
        }
    }
    .dropdown > .btn {
        width: 100%;
    }
`;
const ChildrenWrapper = styled.div `
    min-width: 0;
`;
const VideoSearchFormInputContainer = ({ label, children }) => (React.createElement(StyledVideoSearchFormInputContainer, null,
    React.createElement("label", null, label),
    React.createElement(ChildrenWrapper, null, children)));

/* eslint-disable max-len */
const formElementMargin = '7.5px';
const StyledActionButtons = styled.div `
    display: flex;
    justify-content: space-between;
    margin-top: 0.75rem;
    > div {
        display: flex;
        flex-direction: column;
    }
`;
const StyledVideoSearchForm = styled(Form) `
    > div + div {
        margin-top: ${formElementMargin};
    }

    .start-date {
        left: -50px;
    }
`;
const StyledWideDropdown = styled(DropdownInput) `
    min-width: 0;
    .dropdown {
        min-width: 0;
    }

    button.dropdown-toggle {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
        position: relative;
        text-align: left;
        padding: 0.375rem 1rem 0.375rem 0.5rem !important;

        &::after {
            position: absolute;
            right: 8px;
            top: 14px;
        }
    }
`;
const VideoSearchForm = ({ yearId, onSubmit, onCreate, onUpdate, onDelete, onClear, form, levelId = 8, initForm: init, playerSearch: PlayerSearch, teamSearch: TeamSearch, hideSavedSearches = false, showClear = false, searchButtonTitle = '', showCancel = false, onCancel, hideAmateurLevels, }) => {
    const { t: translate } = useTranslation();
    const initForm = Object.assign({ Type: 1, YearID: yearId, LevelID: levelId }, init);
    const [search, setSearchParams] = useState(initForm);
    const [batter, setBatter] = useState();
    const [pitcher, setPitcher] = useState();
    const [catcher, setCatcher] = useState();
    const [battingTeam, setBattingTeam] = useState();
    const [pitchingTeam, setPitchingTeam] = useState();
    const searchButtonTitleUse = searchButtonTitle === '' ? translate('components.search.view-search-results') : searchButtonTitle;
    const allOpt = { name: translate('common.all'), value: null };
    const pitchTypes = PITCH_TYPES(translate).filter(({ id }) => id > 0).sort((a, b) => a.sortorder - b.sortorder).map((p) => (Object.assign(Object.assign({}, p), { value: p.id })));
    const pitchSubTypes = PITCH_SUB_TYPES(translate).filter(({ id }) => id > 0).sort((a, b) => a.sortorder - b.sortorder).map((p) => (Object.assign(Object.assign({}, p), { value: p.id })));
    const fxTypeOpts = [allOpt, ...pitchTypes.filter(({ isfxtype }) => isfxtype)];
    const fxSubTypeOpts = [allOpt, ...pitchSubTypes.filter(({ typeid }) => search.FXPitchType != null && typeid === search.FXPitchType)];
    const pitchTypeOpts = [allOpt, ...pitchTypes.filter(({ value }) => value <= 8 || value === 11)];
    const filteredLevels = hideAmateurLevels ? LEVELS.filter((x) => x.id < 31 || x.id > 41) : LEVELS; // we want to hide 31-41 levels in this case (not allowed in the dropdown)
    const levelOpts = [
        allOpt,
        ...filteredLevels.filter((l) => l.id > 0).sort((a, b) => a.sortorder - b.sortorder).map((l) => ({ name: l.name, value: l.id })),
    ];
    const batsOpts = [allOpt, { value: 0, name: translate('baseball.right') }, { value: 1, name: translate('baseball.left') }];
    const throwsOpts = [allOpt, { value: 0, name: translate('baseball.right') }, { value: 1, name: translate('baseball.left') }];
    const eventOpts = [
        allOpt,
        ...BASE_EVENTS(translate).filter(({ id }) => id % 100 > 0).map((l) => ({ name: `${l.altName || l.name} [${l.abbr}]`, value: l.id })),
    ];
    const outsOpts = [allOpt, ...[0, 1, 2].map((o) => ({ name: o.toString(), value: o }))];
    const inningsOpts = [allOpt, ...Array(22).fill(undefined).map((_, idx) => ({ name: idx + 1, value: idx + 1 }))];
    useEffect(() => {
        const searchParams = form || initForm;
        setSearchParams(searchParams);
        setBatter(searchParams.Batter);
        setPitcher(searchParams.Pitcher);
        setCatcher(searchParams.Catcher);
        setBattingTeam(searchParams.BattingTeam);
        setPitchingTeam(searchParams.PitchingTeam);
    }, [form]); // eslint-disable-line react-hooks/exhaustive-deps
    const onSearchModelChange = (name, value) => setSearchParams((p) => (Object.assign(Object.assign({}, p), { [name]: value })));
    const onDropdownChange = (name) => ({ value }, keyVal) => {
        const searchValue = value !== undefined ? value : keyVal;
        if (name === 'FXPitchType')
            onSearchModelChange('FXSubType', null);
        return onSearchModelChange(name, searchValue);
    };
    const onDatePickerSelect = (name) => (val) => {
        onSearchModelChange('YearID', null);
        onSearchModelChange(name, val);
    };
    const onYearChange = () => ({ value }, keyVal) => {
        const searchValue = value !== undefined ? value : keyVal;
        onSearchModelChange('YearID', searchValue);
        onSearchModelChange('StartDate', null);
        onSearchModelChange('EndDate', null);
    };
    const onInputChange = (name) => (e) => onSearchModelChange(name, e.currentTarget.value);
    const getDropdownValue = (opts, formVal) => opts.find(({ value }) => {
        if (value === null || value === undefined)
            return formVal === null || formVal === undefined;
        return value === formVal;
    });
    const mappedSearchForm = Object.assign(Object.assign({}, search), { BatterID: batter === null || batter === void 0 ? void 0 : batter.PlayerID, PitcherID: pitcher === null || pitcher === void 0 ? void 0 : pitcher.PlayerID, CatcherID: catcher === null || catcher === void 0 ? void 0 : catcher.PlayerID, BattingTeamID: battingTeam === null || battingTeam === void 0 ? void 0 : battingTeam.TeamID, PitchingTeamID: pitchingTeam === null || pitchingTeam === void 0 ? void 0 : pitchingTeam.TeamID, Pitcher: pitcher !== null && pitcher !== void 0 ? pitcher : undefined, Catcher: catcher !== null && catcher !== void 0 ? catcher : undefined, Batter: batter !== null && batter !== void 0 ? batter : undefined, BattingTeam: battingTeam !== null && battingTeam !== void 0 ? battingTeam : undefined, PitchingTeam: pitchingTeam !== null && pitchingTeam !== void 0 ? pitchingTeam : undefined });
    const onFormSubmit = () => onSubmit(mappedSearchForm);
    const createSavedSearch = () => onCreate(mappedSearchForm);
    const updateSavedSearch = () => onUpdate(mappedSearchForm);
    const deleteSavedSearch = () => onDelete(form.VideoSearchID);
    const videoYearsOpts = [...(Array(yearId - 2002).fill(undefined).map((_, idx) => ({ name: yearId - idx })))];
    const disableUpdateSearchButton = (form === search
        && form.BattingTeam === battingTeam
        && form.PitchingTeam === pitchingTeam
        && form.Batter === batter
        && form.Pitcher === pitcher);
    const resetForm = () => {
        setSearchParams(Object.assign(Object.assign({}, initForm), { LastXGames: '', LastXPas: '' }));
        setBatter(null);
        setPitcher(null);
        setCatcher(null);
        setBattingTeam(null);
        setPitchingTeam(null);
    };
    const filtersApplied = [
        !!search.StartDate,
        !!search.EndDate,
        !!search.PitchType,
        !!search.FXPitchType,
        !!search.BaseEvent,
        !(search.Outs === undefined || search.Outs === null),
        !!search.Inning,
        !(search.Throws === undefined || search.Throws === null),
        !(search.Bats === undefined || search.Bats === null),
        !!search.LastXGames,
        !!search.LastXPas,
        !!battingTeam,
        !!pitchingTeam,
        !!batter,
        !!pitcher,
    ];
    const numFiltersApplied = filtersApplied.filter((x) => x).length;
    const needsMoreFilters = (!!search.LevelID && (numFiltersApplied === 0)) || (!search.LevelID && ((numFiltersApplied <= 1) && !batter && !pitcher));
    return (React.createElement(StyledVideoSearchForm, null,
        React.createElement(VideoSearchFormInputContainer, { label: translate('components.search.single-year') },
            React.createElement(StyledWideDropdown, { options: videoYearsOpts, onSelect: onYearChange(), value: search.YearID, children: undefined, align: "end" })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('common.date') },
            React.createElement(DatePicker, { value: search.StartDate, onSelect: onDatePickerSelect('StartDate'), calendarClassName: "start-date" }),
            React.createElement("span", null, "\u00A0-\u00A0"),
            React.createElement(DatePicker, { value: search.EndDate, onSelect: onDatePickerSelect('EndDate'), alignRight: true })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.level_one') },
            React.createElement(StyledWideDropdown, { options: levelOpts, onSelect: onDropdownChange('LevelID'), value: getDropdownValue(levelOpts, search.LevelID), children: undefined })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('components.search.pitch-type') },
            React.createElement(DropdownInput, { options: pitchTypeOpts, onSelect: onDropdownChange('PitchType'), value: getDropdownValue(pitchTypeOpts, search.PitchType), children: undefined, align: "end" })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('components.search.fx-pitch-type') },
            React.createElement(DropdownInput, { options: fxTypeOpts, onSelect: onDropdownChange('FXPitchType'), value: getDropdownValue(fxTypeOpts, search.FXPitchType), align: "end", children: undefined })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('components.search.fx-sub-type') },
            React.createElement(DropdownInput, { options: fxSubTypeOpts, onSelect: onDropdownChange('FXSubType'), value: getDropdownValue(fxSubTypeOpts, search.FXSubType), align: "end", children: undefined })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('components.search.batting-team') },
            React.createElement(TeamSearch, { onSelect: setBattingTeam, onClear: () => setBattingTeam(null), value: battingTeam === null || battingTeam === void 0 ? void 0 : battingTeam.FullName })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('components.search.pitching-team') },
            React.createElement(TeamSearch, { onSelect: setPitchingTeam, onClear: () => setPitchingTeam(null), value: pitchingTeam === null || pitchingTeam === void 0 ? void 0 : pitchingTeam.FullName })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('components.search.event') },
            React.createElement(StyledWideDropdown, { options: eventOpts, onSelect: onDropdownChange('BaseEvent'), value: getDropdownValue(eventOpts, search.BaseEvent), children: undefined, align: "end" })),
        React.createElement("div", { className: "d-flex" },
            React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.outs_other') },
                React.createElement(DropdownInput, { options: outsOpts, onSelect: onDropdownChange('Outs'), value: getDropdownValue(outsOpts, search.Outs), children: undefined })),
            React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.inning') },
                React.createElement(DropdownInput, { options: inningsOpts, onSelect: onDropdownChange('Inning'), value: getDropdownValue(inningsOpts, search.Inning), children: undefined, align: "end" }))),
        React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.batter') },
            React.createElement(PlayerSearch, { isPitcher: false, onSelect: setBatter, onClear: () => setBatter(null), value: batter === null || batter === void 0 ? void 0 : batter.FullName })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.pitcher_one') },
            React.createElement(PlayerSearch, { isPitcher: true, onSelect: setPitcher, onClear: () => setPitcher(null), value: pitcher === null || pitcher === void 0 ? void 0 : pitcher.FullName })),
        React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.catcher_one') },
            React.createElement(PlayerSearch, { isCatcher: true, onSelect: setCatcher, onClear: () => setCatcher(null), value: catcher === null || catcher === void 0 ? void 0 : catcher.FullName })),
        React.createElement("div", { className: "d-flex" },
            React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.bats') },
                React.createElement(DropdownInput, { options: batsOpts, onSelect: onDropdownChange('Bats'), value: getDropdownValue(batsOpts, search.Bats), children: undefined })),
            React.createElement(VideoSearchFormInputContainer, { label: translate('baseball.throws') },
                React.createElement(DropdownInput, { options: throwsOpts, onSelect: onDropdownChange('Throws'), value: getDropdownValue(throwsOpts, search.Throws), align: "end", children: undefined }))),
        React.createElement("div", { className: "d-flex" },
            React.createElement(VideoSearchFormInputContainer, { label: React.createElement(React.Fragment, null,
                    translate('components.search.last'),
                    " ",
                    React.createElement("i", null, "X"),
                    " ",
                    translate('components.search.games')) },
                React.createElement(Form.Control, { type: "number", size: "sm", min: 1, max: 32767, value: search.LastXGames, onChange: onInputChange('LastXGames') })),
            React.createElement(VideoSearchFormInputContainer, { label: React.createElement(React.Fragment, null,
                    translate('components.search.last'),
                    " ",
                    React.createElement("i", null, "X"),
                    " ",
                    translate('components.search.abbr-plate-app')) },
                React.createElement(Form.Control, { type: "number", size: "sm", min: 1, max: 32767, value: search.LastXPas, onChange: onInputChange('LastXPas') }))),
        React.createElement("hr", { className: "mb-1" }),
        needsMoreFilters && !!search.LevelID && React.createElement("div", { className: "text-muted d-flex justify-content-end" }, translate('components.search.please-add-more-value')),
        needsMoreFilters && !search.LevelID && React.createElement("div", { className: "text-muted d-flex justify-content-end" }, translate('components.search.please-add-two-criteria')),
        React.createElement(StyledActionButtons, null,
            React.createElement("div", null, showClear && (React.createElement(Button, { onClick: resetForm }, translate('components.search.clear')))),
            !hideSavedSearches && (React.createElement("div", null,
                React.createElement(Button, { variant: "success", disabled: needsMoreFilters, onClick: createSavedSearch }, translate('components.search.create-saved-search')),
                !!form && (React.createElement(React.Fragment, null,
                    React.createElement(Button, { variant: "secondary", disabled: disableUpdateSearchButton, onClick: updateSavedSearch }, translate('components.search.update-saved-search')),
                    React.createElement(Button, { variant: "danger", onClick: deleteSavedSearch }, translate('components.search.delete-saved-search')))))),
            React.createElement("div", { className: "d-flex align-items-center flex-row" },
                showCancel && React.createElement(Button, { onClick: onCancel, className: "me-2" }, translate('common.cancel')),
                React.createElement(Button, { variant: "primary", disabled: needsMoreFilters, onClick: onFormSubmit }, searchButtonTitleUse),
                !hideSavedSearches && onClear && React.createElement(Button, { variant: "default", onClick: onClear }, translate('components.search.view-saved-searches'))))));
};

const StyledVideoSearchFormHeader = styled.div `
    ${sideContentHeader}
    flex-grow: 0;
`;
const StyledVideoSearchInputSection = styled.div `
    width: ${sideContentWidth}px;
    display: flex;
    flex-direction: column;
    background-color: white;
    & {
        height: 100%;
    }
    form {
        padding: ${videoFilterPadding};
        flex-grow: 1;
    }
`;
const VideoSearchInputSection = ({ children, isExpanded, toggleSearchPanel }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(StyledVideoSearchInputSection, null,
        React.createElement(StyledVideoSearchFormHeader, { onClick: toggleSearchPanel },
            React.createElement("div", { className: "d-flex align-items-center justify-content-between" },
                React.createElement("h4", null, translate('common.search')),
                React.createElement(Icon, { icon: `chevron-${isExpanded ? 'up' : 'down'}`, size: "1.5em", color: styles.theme.background.mariner }))),
        children));
};

const EnterVideoSearchNameModal = (_a) => {
    var { onSave, onHide } = _a, rest = __rest(_a, ["onSave", "onHide"]);
    const { t: translate } = useTranslation();
    const [name, setName] = useState(null);
    const onResolve = () => {
        if (name) {
            onSave({ Name: name });
            setName(null);
        }
    };
    const onModalHide = () => {
        setName(null);
        onHide();
    };
    return (React.createElement(BaseDialogModal, Object.assign({ resolveTxt: translate('common.save'), closeTxt: translate('common.cancel'), onResolve: onResolve, onHide: onModalHide }, rest),
        React.createElement(Form, null,
            React.createElement(Row, null,
                React.createElement(Col, { sm: 12 },
                    React.createElement("p", null, translate('components.search.please-enter-name')))),
            React.createElement(Form.Group, { as: Row, controlId: "videoSearchName" },
                React.createElement(Form.Label, { column: true, sm: 2 },
                    translate('components.search.name'),
                    ":"),
                React.createElement(Col, { sm: 10 },
                    React.createElement(Form.Control, { type: "text", size: "sm", onChange: (e) => setName(e.currentTarget.value), required: true }))))));
};

const StyledSearchListFilterValue = styled(Col).attrs({ xs: 'auto' }) `
    white-space: nowrap;
    label {
        font-weight: 400;
        margin: 2.5px 5px 2.5px 0;
    }
`;
const StyledSearchListCard = styled(Card$1).attrs({ body: true }) `
    font-weight: 500;
    font-size: 1.15em;
    & + & {
        margin-top: 10px;
    }
    &:hover, &:active {
        cursor: pointer;
        background-color: #ECECEC;
    }
`;
const StyledSavedSearchList = styled.div `
    padding: ${styles.theme.margin.body};
    h5 {
        text-align: center;
    }
    .spinner-border {
        display: block;
        margin: auto;
    }
`;
const SavedSearchList = ({ savedSearches, onSelect }) => {
    const { t: translate } = useTranslation();
    const savedSearchFilters = [
        { key: 'Batter.FullName', label: translate('baseball.batter') },
        { key: 'Pitcher.FullName', label: translate('baseball.pitcher_one') },
        { key: 'BattingTeam.FullName', label: translate('components.search.batting-team') },
        { key: 'PitchingTeam.FullName', label: translate('components.search.pitching-team') },
        { key: 'YearID', label: translate('common.year') },
        { key: 'Date', label: translate('common.date'), transform: ({ StartDate, EndDate }) => ((StartDate && EndDate) ? `${date(StartDate)} - ${date(EndDate)}` : null) },
        { key: 'LevelID', label: translate('baseball.level_one'), transform: ({ LevelID }) => { var _a; return (LevelID ? (_a = LEVELS.find((l) => l.id === LevelID)) === null || _a === void 0 ? void 0 : _a.abbr : null); } },
        // eslint-disable-next-line no-nested-ternary
        { key: 'Bats', label: translate('components.search.filter.batter-hand'), transform: ({ Bats }) => (Bats ? Bats === 1 ? translate('baseball.rhh') : Bats === 2 ? translate('baseball.lhh') : translate('baseball.switch') : null) },
        // eslint-disable-next-line no-nested-ternary
        { key: 'Throws', label: translate('components.search.filter.pitcher-hand'), transform: ({ Throws }) => (Throws ? Throws === 1 ? translate('baseball.rhp') : Throws === 2 ? translate('baseball.lhp') : translate('baseball.switch') : null) },
        { key: 'PitchType', label: translate('components.video.filters.pitch-type'), transform: ({ PitchType }) => pitchType(PitchType, undefined, undefined, translate) },
        { key: 'FXPitchType', label: translate('components.video.filters.fx-pitch-type'), transform: ({ FXPitchType }) => pitchType(FXPitchType, undefined, undefined, translate) },
        { key: 'FXSubType', label: translate('components.video.filters.fx-sub-type'), transform: ({ FXSubType }) => pitchSubType(FXSubType, undefined, undefined, translate) },
        { key: 'Outs', label: translate('baseball.outs_other') },
        { key: 'Inning', label: translate('baseball.inning') },
        { key: 'LastXGames', label: translate('components.video.filters.last-x-games') },
        { key: 'LastXPas', label: translate('components.video.filters.last-x-pa') },
        { key: 'BaseEvent', label: translate('components.search.event'), transform: ({ BaseEvent }) => { var _a; return (BaseEvent ? (_a = BASE_EVENTS(translate).find((b) => b.id === BaseEvent)) === null || _a === void 0 ? void 0 : _a.name : null); } },
    ];
    return (React.createElement(StyledSavedSearchList, null,
        React.createElement("h4", null, translate('components.search.saved-searches')),
        !savedSearches && React.createElement(LoadingSpinner$1, null),
        savedSearches && !savedSearches.length && React.createElement("h5", null, translate('components.search.no-searches-found')), savedSearches === null || savedSearches === void 0 ? void 0 :
        savedSearches.map((ss) => (React.createElement(StyledSearchListCard, { key: ss.VideoSearchID, onClick: () => onSelect(ss.VideoSearchID, ss) },
            React.createElement(Row, { className: "align-items-center" },
                React.createElement(Col, { md: 4, lg: 2 }, ss.Name),
                React.createElement(Col, { md: 8, lg: 10 },
                    React.createElement(Row, null, savedSearchFilters.map(({ key, label, transform }) => {
                        const value = transform ? transform(ss) : get$2(ss, key);
                        if (value === null || value === undefined)
                            return null;
                        if (key === 'YearID' && ss.StartDate && ss.EndDate)
                            return null;
                        return (React.createElement(StyledSearchListFilterValue, { key: key },
                            React.createElement("label", null,
                                label,
                                ":"),
                            value));
                    })))))))));
};

/* const playlistColumns = [
    { id: 'idx', type: columnTypes.TEXT, transform: ({ title }) => title.split(' ')[0] },
    { id: 'data.pitcher', type: columnTypes.TEXT, title: 'Pitcher' },
    { id: 'data.batter', type: columnTypes.TEXT, title: 'Batter' },
    { id: 'date', type: columnTypes.TEXT, title: 'Date', transform: ({ data }) => date(data.gamedate) },
    { id: 'inning', type: columnTypes.TEXT, title: 'Inning', transform: ({ data }) => `${data.istop ? 'Top' : 'Bot'} ${data.inning}` },
    { id: 'data.outsbefore', title: 'Outs' },
    { id: 'count', type: columnTypes.TEXT, title: 'Count', transform: ({ data }) => `${data.balls}-${data.strikes}` },
    { id: 'pitchtype', type: columnTypes.TEXT, title: 'Pitch Type', transform: ({ data }) => data.fxpitchtype || data.pitchtype },
    { id: 'result', type: columnTypes.TEXT, title: 'Result', transform: ({ data }) => data.result || data.pitchresult },
]; */
const StyledLoadingVideoOverlay = styled.div `
    position: absolute;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.25);
    z-index: 1;
`;
const StyledVideoSearchContainer = styled(Container$k).attrs({ fluid: true }) `
    &,
    >.row.g-0,
    >.row.g-0 > .col > div,
    ${StyledVideoFilterContainer},
    ${StyledLoadingVideoOverlay},
    ${StyledVideoPlaylistContainer}
    {
        height: 100%;
    }
`;
const StyledSearchCol = styled(Col) `
    z-index: 2;
`;
const VideoSearch = ({ yearId, search, create, update, delete: remove, savedSearches, initSearch, modalContainer, defaultLevelId, videoPlayer: VideoPlayer, playerSearch, teamSearch, alwaysShowFilter = true, hideSavedSearches = false, hideDownload = false, hideShare = false, hideFrameGrab = false, hideAmateurLevels = false, }) => {
    const { t: translate } = useTranslation();
    const [searching, setSearching] = useState(false);
    const [saving, setSaving] = useState(false);
    const [showConfirmDeleteID, setShowConfirmDeleteID] = useState(null);
    const [showNameFormModel, setShowNameFormModel] = useState(null);
    const [expandSearchPanel, setExpandSearchPanel] = useState(false);
    const [playlist, setPlaylist] = useState(null);
    const [activeSavedSearchId, setActiveSavedSearchId] = useState(null);
    const searchVideos = (formData) => __awaiter(void 0, void 0, void 0, function* () {
        setPlaylist(null);
        setSearching(true);
        const resp = yield search(formData);
        setPlaylist(resp);
        setSearching(false);
    });
    const updateSavedSearch = (formData) => __awaiter(void 0, void 0, void 0, function* () {
        setSaving(true);
        yield update(formData);
        setSaving(false);
    });
    const onCreate = (formData) => setShowNameFormModel(formData);
    const onEnterNameModalHide = () => setShowNameFormModel(null);
    const createSavedSearch = (enterNameFormData) => __awaiter(void 0, void 0, void 0, function* () {
        onEnterNameModalHide();
        setSaving(true);
        const newSearch = yield create(Object.assign(showNameFormModel !== null ? showNameFormModel : {}, enterNameFormData));
        setActiveSavedSearchId(newSearch.VideoSearchID);
        setSaving(false);
    });
    const onDelete = (savedSearchId) => setShowConfirmDeleteID(savedSearchId);
    const onDeleteModalHide = () => setShowConfirmDeleteID(null);
    const deleteSavedSearch = () => __awaiter(void 0, void 0, void 0, function* () {
        onDeleteModalHide();
        setSaving(true);
        yield remove(showConfirmDeleteID);
        setActiveSavedSearchId(null);
        setSaving(false);
    });
    const onPlaylistClear = () => {
        setPlaylist(null);
        setActiveSavedSearchId(null);
    };
    const activeSearch = savedSearches === null || savedSearches === void 0 ? void 0 : savedSearches.find(({ VideoSearchID }) => VideoSearchID === activeSavedSearchId);
    return (React.createElement(StyledVideoSearchContainer, { "$hideFilters": expandSearchPanel },
        React.createElement(ConfirmModal, { message: `${translate('components.search.are-you-sure-delete')}:\n${activeSearch === null || activeSearch === void 0 ? void 0 : activeSearch.Name}?`, onConfirm: deleteSavedSearch, onHide: onDeleteModalHide, show: !!showConfirmDeleteID, container: modalContainer }),
        React.createElement(EnterVideoSearchNameModal, { onSave: createSavedSearch, onHide: onEnterNameModalHide, show: !!showNameFormModel, container: modalContainer }),
        React.createElement(Row, { className: "flex-nowrap g-0" },
            React.createElement(StyledSearchCol, { xs: "auto" },
                React.createElement(VideoSearchInputSection, { isExpanded: !playlist || expandSearchPanel, toggleSearchPanel: () => setExpandSearchPanel(!expandSearchPanel) },
                    React.createElement(VideoSearchForm, { onSubmit: searchVideos, onCreate: onCreate, onUpdate: updateSavedSearch, onDelete: onDelete, onClear: playlist ? onPlaylistClear : undefined, yearId: yearId, searching: searching, saving: saving, playerSearch: playerSearch, teamSearch: teamSearch, levelId: defaultLevelId, initForm: initSearch, form: activeSearch, hideSavedSearches: hideSavedSearches, hideAmateurLevels: hideAmateurLevels }))),
            React.createElement(Col, null,
                (searching || saving) && (React.createElement(StyledLoadingVideoOverlay, null,
                    React.createElement(LoadingSpinner$1, null))),
                playlist && (React.createElement("div", null,
                    React.createElement(VideoPlayer, { playlist: playlist, alwaysShowFilter: alwaysShowFilter, hideShare: hideShare, hideDownload: hideDownload, hideFrameGrab: hideFrameGrab }))),
                !playlist && !hideSavedSearches && (React.createElement(SavedSearchList, { savedSearches: savedSearches, onSelect: setActiveSavedSearchId }))))));
};

const minMaxTransform = (unit) => (value) => `${value.min} - ${value.max} ${unit}`;
const yesNoTransform = (value) => value;
const arrayTransform = (value) => value.join(', ');
const baseRunnersTransform = (value) => {
    switch (value) {
        case 1: return '1B';
        case 2: return '2B';
        case 3: return '1B, 2B';
        case 4: return '3B';
        case 5: return '1B, 3B';
        case 6: return '2B, 3B';
        case 7: return '1B, 2B, 3B';
        default: return '';
    }
};
const hitLocationTransform = (value) => {
    const locations = [
        { isinfieldbip: true, distance: { max: 60 }, label: 'PIT' },
        { isinfieldbip: true, angleto2b: { max: -22.5 }, distance: { min: 60 }, label: '3B' },
        { isinfieldbip: true, angleto2b: { min: -22.5, max: 0 }, distance: { min: 60 }, label: 'SS' },
        { isinfieldbip: true, angleto2b: { min: 0, max: 22.5 }, distance: { min: 60 }, label: '2B' },
        { isinfieldbip: true, angleto2b: { min: 22.5 }, distance: { min: 60 }, label: '1B' },
        { isinfieldbip: false, angleto2b: { max: -27 }, label: 'LF' },
        { isinfieldbip: false, angleto2b: { min: -27, max: -9 }, label: 'LCF' },
        { isinfieldbip: false, angleto2b: { min: -9, max: 9 }, label: 'CF' },
        { isinfieldbip: false, angleto2b: { min: 9, max: 27 }, label: 'RCF' },
        { isinfieldbip: false, angleto2b: { min: 27 }, label: 'RF' },
        { ishr: true, angleto2b: { max: -15 }, label: 'HR-LF' },
        { ishr: true, angleto2b: { min: -15, max: 15 }, label: 'HR-CF' },
        { ishr: true, angleto2b: { min: 15 }, label: 'HR-RF' }
    ];
    return value.map((v) => {
        var _a;
        return (_a = locations.find((l) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return l.isinfieldbip === v.isinfieldbip
                && l.ishr === v.ishr
                && ((_a = l.distance) === null || _a === void 0 ? void 0 : _a.min) === ((_b = v.distance) === null || _b === void 0 ? void 0 : _b.min)
                && ((_c = l.distance) === null || _c === void 0 ? void 0 : _c.max) === ((_d = v.distance) === null || _d === void 0 ? void 0 : _d.max)
                && ((_e = l.angleto2b) === null || _e === void 0 ? void 0 : _e.min) === ((_f = v.angleto2b) === null || _f === void 0 ? void 0 : _f.min)
                && ((_g = l.angleto2b) === null || _g === void 0 ? void 0 : _g.max) === ((_h = v.angleto2b) === null || _h === void 0 ? void 0 : _h.max);
        })) === null || _a === void 0 ? void 0 : _a.label;
    })
        .filter((x) => x)
        .join(', ');
};
const searchFilters = (translate) => [
    { field: 'pitcherHand', title: translate('components.search.filter.pitcher-hand'), transform: (value) => ({ 0: translate('baseball.rhp'), 1: translate('baseball.lhp') }[value]) },
    { field: 'batterHand', title: translate('components.search.filter.batter-hand'), transform: (value) => ({ 0: translate('baseball.rhh'), 1: translate('baseball.lhh') }[value]) },
    { field: 'balls', title: `${translate('baseball.count')} (${translate('baseball.balls_other')})`, transform: (value) => value.sort((a, b) => a - b).join(', ') },
    { field: 'strikes', title: `${translate('baseball.count')} (${translate('baseball.strikes_other')})`, transform: (value) => value.sort((a, b) => a - b).join(', ') },
    { field: 'outsbefore', title: translate('baseball.outs_other'), transform: (value) => value.sort((a, b) => a - b).join(', ') },
    { field: 'hasRunners', title: translate('components.search.filter.baserunners'), transform: (value) => ({ 0: translate('components.search.none-on'), 1: translate('components.search.some-on') }[value]) },
    { field: 'bcbefore', title: translate('components.search.filter.baserunners'), transform: baseRunnersTransform },
    { field: 'type', title: translate('components.search.pitch-type'), transform: (value) => value.map((p) => { var _a; return (_a = PITCH_TYPES(translate).find((pt) => pt.id === p)) === null || _a === void 0 ? void 0 : _a.abbr; }).join(', ') },
    { field: 'velocity', title: translate('components.search.filter.pitch-velo'), transform: minMaxTransform(translate('components.search.abbr-mph')) },
    { field: 'spinrate', title: translate('components.search.filter.spin-rate'), transform: minMaxTransform(translate('components.search.abbr-rpm')) },
    { field: 'breakz54', title: translate('components.search.filter.vertical-break'), transform: minMaxTransform(translate('components.search.abbr-inches')) },
    { field: 'breakx54', title: translate('components.search.filter.horizontal-break'), transform: minMaxTransform(translate('components.search.abbr-inches')) },
    { field: 'initposx_55', title: translate('components.search.filter.horizontal-release'), transform: minMaxTransform(translate('components.search.abbr-ft')) },
    { field: 'initposz_55', title: translate('components.search.filter.vertical-release'), transform: minMaxTransform(translate('components.search.abbr-ft')) },
    { field: 'rvactualNorm', title: translate('components.search.filter.rv-era'), transform: minMaxTransform(translate('components.search.abbr-era')) },
    { field: 'rvexpNorm', title: translate('components.search.filter.expected-rv-era'), transform: minMaxTransform(translate('components.search.abbr-era')) },
    { field: 'rvpitchfxNorm', title: translate('components.search.filter.pfx-era'), transform: minMaxTransform(translate('components.search.abbr-era')) },
    { field: 'rvbreakNorm', title: translate('components.search.filter.break-era'), transform: minMaxTransform(translate('components.search.abbr-era')) },
    { field: 'rvstuffNorm', title: translate('components.search.filter.stuff-era'), transform: minMaxTransform(translate('components.search.abbr-era')) },
    { field: 'rvlocNorm', title: translate('components.search.filter.location-era'), transform: minMaxTransform(translate('components.search.abbr-era')) },
    { field: 'hittype', title: translate('components.search.filter.hit-type'), transform: (value) => value.map((v) => ({ 0: translate('baseball.pitchresult.abbr-groundball'), 1: translate('baseball.pitchresult.abbr-flyball'), 2: translate('baseball.pitchresult.abbr-linedrive'), 3: translate('baseball.pitchresult.abbr-popup') }[v])).join(', ') },
    { field: 'hitLocations', title: translate('components.search.filter.hit-location'), transform: hitLocationTransform },
    { field: 'hitvelocity', title: translate('components.search.filter.exit-velo'), transform: minMaxTransform(translate('components.search.abbr-mph')) },
    { field: 'contactResult', title: translate('components.search.filter.contact-result-bip'), transform: minMaxTransform(translate('components.search.abbr-r100')) },
    { field: 'contactQuality', title: translate('components.search.filter.contact-quality-bip'), transform: minMaxTransform(translate('components.search.abbr-r100')) },
    { field: 'vertla', title: translate('components.search.filter.vertical-launch-angle'), transform: minMaxTransform(translate('components.search.abbr-degree')) },
    { field: 'horizla', title: translate('components.search.filter.horizontal-launch-angle'), transform: minMaxTransform(translate('components.search.abbr-degree')) },
    { field: 'zonedepth', title: translate('components.search.filter.zone-depth'), transform: minMaxTransform(translate('components.search.abbr-ft')) },
    { field: 'swinging', title: translate('components.search.filter.swinging'), transform: yesNoTransform },
    { field: 'swingingFirstPitch', title: translate('components.search.filter.swinging-first-pitch'), transform: yesNoTransform },
    { field: 'swingingInZone', title: translate('components.search.filter.swinging-in-zone'), transform: yesNoTransform },
    { field: 'chase', title: translate('components.search.filter.chase'), transform: yesNoTransform },
    { field: 'miss', title: translate('components.search.filter.miss'), transform: yesNoTransform },
    { field: 'missInZone', title: translate('components.search.filter.miss-in-zone'), transform: yesNoTransform },
    { field: 'inZone', title: translate('components.search.filter.in-zone'), transform: yesNoTransform },
    { field: 'strikeout', title: translate('components.search.filter.strikeout'), transform: yesNoTransform },
    { field: 'unintentionalWalk', title: translate('components.search.filter.unintentional-walk'), transform: yesNoTransform },
    { field: 'swds', title: translate('components.search.filter.score'), transform: minMaxTransform(translate('components.search.abbr-points')) },
    { field: 'swingDecisionScoreShouldSwing', title: `${translate('components.search.filter.score')} (${translate('components.search.filter.should-swing')})`, transform: minMaxTransform(translate('components.search.abbr-points')) },
    { field: 'swingDecisionScoreShouldTake', title: `${translate('components.search.filter.score')} (${translate('components.search.filter.should-take')})`, transform: minMaxTransform(translate('components.search.abbr-points')) },
    { field: 'fapproach', title: translate('components.search.filter.fielder-approach'), transform: arrayTransform },
    { field: 'fmethod', title: translate('components.search.filter.fielding-method'), transform: arrayTransform },
    { field: 'fmove', title: translate('components.search.filter.fielder-movement'), transform: arrayTransform },
    { field: 'fthrow', title: translate('components.search.filter.fielder-throw'), transform: arrayTransform },
    { field: 'diffopps', title: translate('components.search.filter.difficulty-opps'), transform: arrayTransform },
    { field: 'diffmade', title: translate('components.search.filter.difficulty-made'), transform: arrayTransform },
    { field: 'hasShift', title: translate('components.search.filter.has-shift'), transform: yesNoTransform },
    { field: 'runnersOn', title: translate('components.search.filter.runners-on'), transform: yesNoTransform },
    { field: 'throwvelo', title: translate('components.search.filter.throw-velocity'), transform: minMaxTransform(translate('components.search.abbr-mph')) },
    { field: 'exchange', title: translate('components.search.filter.exchange'), transform: minMaxTransform(translate('components.search.abbr-seconds')) },
    { field: 'startingdepth', title: translate('components.search.filter.starting-depth'), transform: minMaxTransform(translate('components.search.abbr-ft')) },
    { field: 'routeeffic', title: translate('components.search.filter.route-efficiency'), transform: minMaxTransform('%') },
    { field: 'firststep', title: translate('components.search.filter.first-step'), transform: minMaxTransform(translate('components.search.abbr-seconds')) },
    { field: 'firststepeffic', title: translate('components.search.filter.first-step-eff'), transform: minMaxTransform('deg') },
    { field: 'topspeed', title: translate('components.search.filter.top-speed'), transform: minMaxTransform(translate('components.search.abbr-mph')) },
    { field: 'sprintspeed', title: translate('components.search.filter.sprint-speed'), transform: minMaxTransform(translate('components.search.abbr-ft-s')) },
    { field: 'distcovered', title: translate('components.search.filter.distance-covered'), transform: minMaxTransform(translate('components.search.abbr-ft')) },
    { field: 'topacceladj', title: translate('components.search.filter.top-acceleration'), transform: minMaxTransform('m/s<sup>2</sup>') },
    { field: 'catchprobability', title: translate('components.search.filter.catch-probability'), transform: minMaxTransform('%') },
    { field: 'outProbability', title: translate('components.search.filter.out-probability'), transform: minMaxTransform('%') },
    { field: 'hangtime', title: translate('components.search.filter.hang-time'), transform: minMaxTransform(translate('components.search.abbr-seconds')) },
    { field: 'inning', title: translate('baseball.inning'), transform: arrayTransform },
    { field: 'sourceLabels', title: translate('components.search.filter.video-angle'), transform: arrayTransform },
];
const SavedSearchFilterColumn = ({ row }) => {
    var _a;
    const { t: translate } = useTranslation();
    const filters = JSON.parse(row.Filters || '{}') || {};
    const entries = Object.entries(filters).filter(([key, value]) => !!searchFilters(translate).find((sf) => sf.field === key)
        && !isSelectAllValue(value)
        && (!Array.isArray(value) || !value.every((v) => isSelectAllValue(v))));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "d-flex flex-wrap" }, entries
            .map(([key, value], index) => {
            const field = searchFilters(translate).find((sf) => sf.field === key);
            if (!field)
                return null;
            return (React.createElement("div", { className: "d-flex flex-shrink-0", key: key },
                React.createElement("label", { className: "font-weight-bold mb-0" },
                    field.title,
                    ":"),
                "\u00A0",
                React.createElement("span", { dangerouslySetInnerHTML: { __html: field.transform(value) } }),
                index + 1 < entries.length && React.createElement("span", null, ",\u00A0")));
        })),
        ((_a = filters.pitchLocations) === null || _a === void 0 ? void 0 : _a.length) && (React.createElement(PitchLocation$1, { size: 30, locations: filters.pitchLocations, emptyColor: "#98CBFF" }))));
};

const SavedSearchCriteriaColumn = ({ row }) => {
    const { t: translate } = useTranslation();
    const searchCriteria = [
        { key: 'Batter.FullName', label: translate('baseball.batter') },
        { key: 'Pitcher.FullName', label: translate('baseball.pitcher_one') },
        { key: 'Catcher.FullName', label: translate('baseball.catcher_one') },
        { key: 'BattingTeam.FullName', label: translate('components.search.batting-team') },
        { key: 'PitchingTeam.FullName', label: translate('components.search.pitching-team') },
        { key: 'YearID', label: translate('common.year') },
        { key: 'Date', label: translate('common.date'), transform: ({ StartDate, EndDate }) => ((StartDate && EndDate) ? `${dateTranslate(translate, StartDate)} - ${dateTranslate(translate, EndDate)}` : null) },
        { key: 'LevelID', label: translate('baseball.level_one'), transform: ({ LevelID }) => { var _a; return (LevelID ? (_a = LEVELS.find((l) => l.id === LevelID)) === null || _a === void 0 ? void 0 : _a.abbr : null); } },
        { key: 'Bats', label: translate('components.search.filter.batter-hand'), transform: ({ Bats }) => (Bats !== null ? `${Bats === 1 ? translate('baseball.lhh') : translate('baseball.rhh')}` : null) },
        { key: 'Throws', label: translate('components.search.filter.pitcher-hand'), transform: ({ Throws }) => (Throws !== null ? `${Throws === 1 ? translate('baseball.lhp') : translate('baseball.rhp')}` : null) },
        { key: 'PitchType', label: translate('components.search.pitch-type'), transform: ({ PitchType }) => pitchType(PitchType, undefined, undefined, translate) },
        { key: 'FXPitchType', label: translate('components.search.fx-pitch-type'), transform: ({ FXPitchType }) => pitchType(FXPitchType, undefined, undefined, translate) },
        { key: 'FXSubType', label: translate('components.search.fx-sub-type'), transform: ({ FXSubType }) => pitchSubType(FXSubType, undefined, undefined, translate) },
        { key: 'Outs', label: translate('baseball.outs_other') },
        { key: 'Inning', label: translate('baseball.inning') },
        { key: 'LastXGames', label: `${translate('components.search.last')} X ${translate('components.search.games')}` },
        { key: 'LastXPas', label: `${translate('components.search.last')} X ${translate('components.search.abbr-plate-app')}` },
        { key: 'BaseEvent', label: translate('components.search.event'), transform: ({ BaseEvent }) => { var _a; return (BaseEvent ? (_a = BASE_EVENTS(translate).find((b) => b.id === BaseEvent)) === null || _a === void 0 ? void 0 : _a.name : null); } },
    ];
    const criteria = searchCriteria.map(({ key, label, transform }) => {
        const value = transform ? transform(row) : get$2(row, key);
        if (value === null || value === undefined)
            return null;
        if (key === 'YearID' && row.StartDate && row.EndDate)
            return null;
        return (React.createElement(React.Fragment, { key: key },
            React.createElement("label", { className: "font-weight-bold mb-0" },
                label,
                ":"),
            "\u00A0",
            value));
    }).filter((x) => x);
    return (React.createElement("div", { className: "d-flex flex-wrap" }, criteria.map((c, index) => React.createElement("div", { className: "d-flex flex-shrink-0", key: c === null || c === void 0 ? void 0 : c.key },
        c,
        index + 1 < criteria.length && React.createElement("span", null, ",\u00A0")))));
};

/* eslint-disable max-len */
const StyledCard$2 = styled(Card$1) `
    .field-column {
        width: 37.5%;
    }
`;
const SavedSearchTable = ({ rows, onEdit, onDelete, onVideoClick }) => {
    const { t: translate } = useTranslation();
    const columns = [
        { id: 'play', title: null, type: COLUMN_TYPES.NODE, transform: (row) => React.createElement(VideoButton, { onClick: () => onVideoClick(row) }) },
        { id: 'Name',
            title: translate('components.search.name'),
            type: COLUMN_TYPES.NODE,
            headerClass: 'w-25',
            transform: (row) => (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "font-weight-bold d-flex align-items-center" },
                    React.createElement("span", null, row.Name),
                    React.createElement(Button, { variant: "link", onClick: () => onEdit(row), className: "d-flex align-items-center ms-1" },
                        React.createElement(Icon, { icon: "nyy-pencil", size: "1em" }))),
                React.createElement("div", { className: "text-muted" },
                    translate('components.search.created'),
                    ": ",
                    dateTranslate(translate, row.CreatedDate)))) },
        { id: 'searchCriteria',
            title: translate('components.search.search-criteria'),
            type: COLUMN_TYPES.NODE,
            transform: (row) => React.createElement(SavedSearchCriteriaColumn, { row: row }),
            headerClass: 'field-column' },
        { id: 'filters', title: translate('components.search.filters'), type: COLUMN_TYPES.NODE, transform: (row) => React.createElement(SavedSearchFilterColumn, { row: row }), headerClass: 'field-column' },
        { id: 'delete',
            title: null,
            type: COLUMN_TYPES.NODE,
            transform: (row) => (React.createElement(Button, { onClick: () => onDelete(row) }, translate('common.delete'))) },
    ];
    return (React.createElement(StyledCard$2, { className: "p-4 mb-3" },
        React.createElement(DataTable, { sortable: false, columns: columns, rows: rows, hover: false })));
};

// Our hook
function useDebounce(value, delay) {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        // Set debouncedValue to value (passed in) after the specified delay
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        // Return a cleanup function that will be called every time ...
        // ... useEffect is re-called. useEffect will only be re-called ...
        // ... if value changes (see the inputs array below).
        // This is how we prevent debouncedValue from changing if value is ...
        // ... changed within the delay period. Timeout gets cleared and restarted.
        // To put it in context, if the user is typing within our app's ...
        // ... search box, we don't want the debouncedValue to update until ...
        // ... they've stopped typing for more than 500ms.
        return () => {
            clearTimeout(handler);
        };
    }, 
    // Only re-call effect if value changes
    // You could also add the "delay" var to inputs array if you ...
    // ... need to be able to change that dynamically.
    [delay, value]);
    return debouncedValue;
}

const StyledInputContainer$1 = styled.div `&& {
    display: flex;
    align-items: center;
    input {
        background: #ffffff url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='14px' height='14px' viewBox='0 0 14 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3Eelements/search icon%3C/title%3E%3Cg id='elements/search-icon' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M2.882 5.955 C2.882 4.26 4.261 2.882 5.955 2.882 C7.65 2.882 9.029 4.26 9.029 5.955 C9.029 7.65 7.65 9.0285 5.955 9.0285 C4.261 9.0285 2.882 7.65 2.882 5.955 L2.882 5.955 Z M12.7035 11.3725 L10.0595 8.729 C10.5965 7.9365 10.911 6.982 10.911 5.955 C10.911 3.2225 8.6875 1 5.955 1 C3.223 1 1 3.2225 1 5.955 C1 8.6875 3.223 10.9105 5.955 10.9105 C6.982 10.9105 7.937 10.596 8.729 10.059 L11.3725 12.703 L12.7035 11.3725 Z' id='Fill-4' fill='%23A6A6A6'%3E%3C/path%3E%3C/g%3E%3C/svg%3E") no-repeat 5px;
        padding: .375rem 1.5rem;
        font-size: 14px;
    }
}`;
const StyledLoadingSpinner = styled.div `&& {
    margin-left: -20px;
    height: 15px;
    width: 15px;
    cursor: pointer;
    background: transparent url(${spinnerImg}) no-repeat center;
    background-color: white;
}`;
const StyledClearButton$2 = styled.div `&& {
    margin-left: -20px;
    height: 15px;
    width: 15px;
    cursor: pointer;
    background: transparent url(${searchReset}) no-repeat center;
}`;
const SearchInput = ({ onChange, onClear, searchCriteria = '', isLoading = false, id }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(StyledInputContainer$1, null,
        React.createElement(FormControl, { placeholder: `${translate('common.search')}...`, onChange: onChange, value: searchCriteria, id: id }),
        isLoading && React.createElement(StyledLoadingSpinner, null),
        !isLoading && searchCriteria.length > 0 && React.createElement(StyledClearButton$2, { onClick: onClear })));
};

var searchResultTypes;
(function (searchResultTypes) {
    searchResultTypes["PLAYER"] = "player";
    searchResultTypes["PLAYER_AM"] = "player_amateur";
    searchResultTypes["PLAYER_INT"] = "player_int";
    searchResultTypes["TEAM"] = "team";
    searchResultTypes["TEAM_AM"] = "team_amateur";
    searchResultTypes["COACH"] = "coach";
    searchResultTypes["UMPIRE"] = "umpire";
    searchResultTypes["AGENT"] = "agent";
    searchResultTypes["AGENCY"] = "agency";
    searchResultTypes["USER"] = "user";
    searchResultTypes["FACILITY"] = "facility";
    searchResultTypes["LEAGUE"] = "league";
    searchResultTypes["VENUE"] = "venue";
})(searchResultTypes || (searchResultTypes = {}));

const { PLAYER: PLAYER$1, PLAYER_AM: PLAYER_AM$1, PLAYER_INT: PLAYER_INT$1, TEAM: TEAM$1, TEAM_AM: TEAM_AM$1, COACH: COACH$1, UMPIRE: UMPIRE$1, AGENT: AGENT$1, AGENCY: AGENCY$1, USER: USER$1, FACILITY: FACILITY$1, LEAGUE: LEAGUE$1, VENUE } = searchResultTypes;
const StyledName = styled.span `&&{
    font-weight: bold;
    color: ${theme.background.astronaut};
    text-align: left;
}`;
const StyledListItem = styled(BootstrapButton) `&&{
    font-size: ${browser$1.mobile ? '18px' : '1em'};
    -webkit-text-size-adjust: 100%;
    display: flex;
    justify-content: space-between;
    text-decoration: none;
    color: ${theme.fontColors.doveGray};
    padding: 2px;
    width: 100%;
    &:hover, &:focus {
        cursor: pointer;
        background-color: ${theme.fontColors.dodgerBlue};
        color: white;
        text-decoration: none;
        outline: none;
        box-shadow: none;
        span {
            color: white !important;
        }
    }
    > span:first-child {
        flex-grow: 1;
        white-space: nowrap;
        margin-right: 5px;
    }
    > span:last-child {
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: normal;
        color: #888;
    }
}`;
const SearchResultsItem = ({ item, type, suppressTypeNameInResults, onSelect }) => {
    var _a, _b;
    const { t: translate } = useTranslation();
    let key = '';
    let name = '';
    const info = [];
    let href = '';
    switch (type) {
        case PLAYER$1: {
            key = `${PLAYER$1}-${item.PlayerID}`;
            href = `/bbops/player/index.rails?id=${item.PlayerID}`;
            name = `${item.UsesName} ${item.LastName}`;
            if (item.Organization)
                info.push(item.Organization.Abbr);
            if (item.Team)
                info.push(item.Team.FullName);
            if (!item.Active)
                info.push('inactive');
            if (item.Country && item.IsInternational)
                info.push(item.Country.Name);
            info.push(positionName(item.PrimaryPosition, translate));
            break;
        }
        case PLAYER_AM$1: {
            key = `player-am-${item.PlayerID}`;
            href = `/bbops/player/index.rails?id=${item.PlayerID}`;
            name = `${item.UsesName} ${item.LastName}`;
            if (item.School)
                info.push(item.School.SchoolName);
            else if (item.Team)
                info.push(item.Team.FullName);
            else if (item.College)
                info.push(item.College);
            else if (item.Organization)
                info.push(item.Organization.Abbr);
            if (!item.Active)
                info.push('inactive');
            else if (item.Class)
                info.push(hsClassName(item.Class, false, translate));
            info.push(positionName(item.PrimaryPosition, translate));
            break;
        }
        case PLAYER_INT$1: {
            key = `player-int-${item.PlayerID}`;
            href = `/bbops/player/index.rails?id=${item.PlayerID}`;
            name = `${item.UsesName} ${item.LastName}`;
            if (item.Country)
                info.push(item.Country.Name);
            info.push(positionName(item.PrimaryPosition, translate));
            break;
        }
        case TEAM$1: {
            key = `team-${item.TeamID}`;
            href = `/bbops/team/index.rails?id=${item.TeamID}`;
            name = item.FullName;
            if (item.Organization)
                info.push(item.Organization.Abbr);
            if (item.Level)
                info.push(item.Level.Abbr);
            break;
        }
        case TEAM_AM$1: {
            key = `team-am-${item.TeamID}`;
            href = `/bbops/team/index.rails?id=${item.TeamID}`;
            name = item.FullName;
            if (item.Level)
                info.push(item.Level.Abbr);
            break;
        }
        case COACH$1: {
            key = `coach-${item.CoachID}`;
            href = `/bbops/player/index.rails?id=${item.Player.PlayerID}`;
            name = `${item.Player.UsesName} ${item.Player.LastName}`;
            if (!item.EndDate) {
                if (item.Team) {
                    if (item.Team.Organization)
                        info.push(item.Team.Organization.Abbr);
                    info.push(`${item.Team.City} ${item.Team.Name}`);
                }
            }
            else
                info.push('inactive');
            info.push(item.Job);
            break;
        }
        case UMPIRE$1: {
            key = `umpire-${item.UmpireID}`;
            href = `/bbops/umpire/index.rails?id=${item.UmpireID}`;
            name = `${item.FirstName} ${item.LastName}`;
            info.push(`${translate('components.search.umpire')}`);
            break;
        }
        case AGENT$1: {
            key = `agent-${item.AgentID}`;
            href = `/bbops/agent/agent.rails?id=${item.AgentID}`;
            name = `${item.FirstName} ${item.LastName}`;
            info.push((_b = (_a = item.Agency) === null || _a === void 0 ? void 0 : _a.FirmName) !== null && _b !== void 0 ? _b : '--');
            break;
        }
        case AGENCY$1: {
            key = `agency-${item.AgencyID}`;
            href = `/bbops/agent/agency.rails?id=${item.AgencyID}`;
            name = item.FirmName;
            info.push(`${translate('components.search.agency')}`);
            break;
        }
        case USER$1: {
            key = `user-${item.UserName}`;
            href = `/bbops/personnel/index.rails?username=${item.UserName}`;
            name = item.FullName;
            info.push(item.Title);
            if (item.Department)
                info.push(item.Department.Name);
            break;
        }
        case FACILITY$1: {
            key = `facility-${item.FacilityId}`;
            href = `/bbops/facility/index.rails#/${item.FacilityId}`;
            name = item.FacilityName;
            if (item.FacilityType)
                info.push(item.FacilityType.Name);
            break;
        }
        case LEAGUE$1: {
            key = `league-${item.LeagueID}`;
            // href = `/bbops/facility/index.rails#/${item.FacilityId}`;
            name = item.Name;
            if (item.Level)
                info.push(item.Level.Name);
            break;
        }
        case VENUE: {
            key = `venue-${item.VenueID}`;
            name = item.Name;
            if (!suppressTypeNameInResults)
                info.push(`(${translate('components.search.venue')})`);
            if (item.Team)
                info.push(item.Team.FullName);
            if (item.City && item.State)
                info.push(item.City, item.State);
            break;
        }
    }
    return (
    // the css classes here are leveraged by keypress listeners in SearchResults, and by automation tests, modify them with great care
    React.createElement(StyledListItem, { className: "search-results--item", key: key, href: onSelect ? undefined : href, variant: "link", onClick: onSelect ? () => onSelect(item) : undefined },
        React.createElement(StyledName, null, name),
        React.createElement("span", null, info.join(', '))));
};

const StyledSearchResultsContainer = styled.div `
    margin-top: 1em;
    :first-child {
        margin-top: 4px;
    }
    h2 {
        color: ${theme.fontColors.doveGray};
        font-size: 1em;
        font-weight: bold;
        margin-bottom: 0;
        padding: 2px 0;
    }
`;
const StyledSearchResultsList = styled.div `
    padding: 0px 5px;
    max-height: 20vh;
    overflow-x: hidden;
    overflor-y: auto;
`;
const SearchResultsList = ({ items, type, label = '' }) => (
// the css classes here are leveraged by keypress listeners in SearchResults, and by automation tests, modify them with great care
React.createElement(StyledSearchResultsContainer, { className: `search-results-list search-results-list--${type}` },
    React.createElement("h2", null, label),
    React.createElement(StyledSearchResultsList, null,
        React.createElement("div", null, (items !== null && items !== void 0 ? items : []).map((item, index) => React.createElement(SearchResultsItem, { key: `${type}-${index}`, item: item, type: type }))))));

const { PLAYER, PLAYER_AM, PLAYER_INT, TEAM, TEAM_AM, COACH, UMPIRE, AGENT, AGENCY, USER, FACILITY, LEAGUE } = searchResultTypes;
const StyledModal = styled(BaseModal) `
    .modal-content {
        max-height: calc(100dvh - 100px);
        overflow-y: auto;
    }
`;
const StyledModalBody = styled(BaseModal.Body) `
    && {
        padding 0px;
    }
`;
const StyledResultsContainer = styled.div `
    display: flex;
    .search-list {
        width: 50%;
        padding: 10px;
        h1 {
            text-align: center;
            background-color: ${theme.background.astronaut};
            color: white;
            font-size: 1em;
            padding: 2px 0;
        }
    }
`;
const StyledModalFooter = styled(BaseModal.Footer) `
    && {
        background-color: #EDEDED;
        font-weight: bold;
        padding: 0;

        .form-check {
            margin: 0px 10px;
        }

        .form-check-input {
            margin-top: 0.2rem;
            margin-left: -1rem;
        }

        .form-check-label {
            margin-top: 3px;
            margin-left: 5px;
        }
    }
`;
const SearchResults = ({ show, onHide, onToggleInactive, searchResultsContainer, results, }) => {
    var _a, _b, _c, _d, _e;
    const { t: translate } = useTranslation();
    const [searchResults, setSearchResults] = useState(results);
    const [showInactive, setShowInactive] = useState(false);
    const [isListenerActive, setIsListenerActive] = useState(false);
    useEffect(() => {
        setSearchResults(results);
        return () => {
            setSearchResults(undefined);
        };
    }, [results, setSearchResults]);
    const resultBuckets = [
        {
            type: PLAYER,
            pro: true,
            results: (_a = searchResults === null || searchResults === void 0 ? void 0 : searchResults.players) === null || _a === void 0 ? void 0 : _a.filter((player) => !player.IsAmateur && !player.IsInternational),
            label: translate('components.search.players'),
        },
        {
            type: TEAM,
            pro: true,
            results: (_b = searchResults === null || searchResults === void 0 ? void 0 : searchResults.teams) === null || _b === void 0 ? void 0 : _b.filter((team) => !team.IsAmateur),
            label: translate('components.search.teams'),
        },
        {
            type: COACH,
            pro: true,
            results: searchResults === null || searchResults === void 0 ? void 0 : searchResults.coaches,
            label: translate('components.search.coaches'),
        },
        {
            type: UMPIRE,
            pro: true,
            results: searchResults === null || searchResults === void 0 ? void 0 : searchResults.umpires,
            label: translate('components.search.umpires'),
        },
        {
            type: AGENCY,
            pro: true,
            results: searchResults === null || searchResults === void 0 ? void 0 : searchResults.agencies,
            label: translate('components.search.agencies'),
        },
        {
            type: AGENT,
            pro: true,
            results: searchResults === null || searchResults === void 0 ? void 0 : searchResults.agents,
            label: translate('components.search.agents'),
        },
        {
            type: USER,
            pro: true,
            results: searchResults === null || searchResults === void 0 ? void 0 : searchResults.users,
            label: translate('components.search.personnel'),
        },
        {
            type: FACILITY,
            pro: true,
            results: searchResults === null || searchResults === void 0 ? void 0 : searchResults.facilities,
            label: translate('components.search.facilities'),
        },
        {
            type: LEAGUE,
            pro: true,
            results: searchResults === null || searchResults === void 0 ? void 0 : searchResults.leagues,
            label: translate('components.search.leagues'),
        },
        {
            type: PLAYER_AM,
            pro: false,
            results: (_c = searchResults === null || searchResults === void 0 ? void 0 : searchResults.players) === null || _c === void 0 ? void 0 : _c.filter((player) => player.IsAmateur),
            label: translate('components.search.domestic'),
        },
        {
            type: PLAYER_INT,
            pro: false,
            results: (_d = searchResults === null || searchResults === void 0 ? void 0 : searchResults.players) === null || _d === void 0 ? void 0 : _d.filter((player) => player.IsInternational),
            label: translate('components.search.international'),
        },
        {
            type: TEAM_AM,
            pro: false,
            results: (_e = searchResults === null || searchResults === void 0 ? void 0 : searchResults.teams) === null || _e === void 0 ? void 0 : _e.filter((team) => team.IsAmateur),
            label: translate('components.search.teams'),
        },
    ].filter((b) => { var _a; return (_a = b.results) === null || _a === void 0 ? void 0 : _a.length; });
    const toggleInactive = (event) => {
        setShowInactive(event.currentTarget.checked);
        onToggleInactive(event);
    };
    useEffect(() => {
        setIsListenerActive(show !== null && show !== void 0 ? show : false);
    }, [show, setIsListenerActive]);
    const getActiveElementListType = (activeElem) => {
        var _a;
        const currentList = activeElem.closest('.search-results-list');
        const cssTypeName = [...((_a = currentList === null || currentList === void 0 ? void 0 : currentList.classList) !== null && _a !== void 0 ? _a : [])].find((c) => c.startsWith('search-results-list--'));
        return cssTypeName === null || cssTypeName === void 0 ? void 0 : cssTypeName.replace('search-results-list--', '');
    };
    const handleKeyDown = (event) => {
        var _a, _b, _c, _d;
        const activeElem = document.activeElement;
        switch (event.key) {
            case 'Tab': {
                // jump to the first result of the next list
                event.stopPropagation();
                event.preventDefault();
                if (!((_a = activeElem === null || activeElem === void 0 ? void 0 : activeElem.classList) === null || _a === void 0 ? void 0 : _a.contains('search-results--item'))) {
                    // no item is focused, focus the first one we can find
                    document.getElementsByClassName('search-results--item')[0].focus();
                }
                else {
                    // item is currently focused, focus on the first result in the next available list
                    const currentList = activeElem.closest('.search-results-list');
                    const allLists = document.getElementsByClassName('search-results-list');
                    const currentIndex = Array.from(allLists).indexOf(currentList);
                    const targetIndex = currentIndex + 1;
                    if (allLists[targetIndex]) {
                        allLists[targetIndex].getElementsByClassName('search-results--item')[0].focus();
                    }
                    else {
                        allLists[0].getElementsByClassName('search-results--item')[0].focus();
                    }
                }
                break;
            }
            case 'ArrowRight': {
                // if focused on a pro list, jump to the first result of the first amateur list
                if (!((_b = activeElem === null || activeElem === void 0 ? void 0 : activeElem.classList) === null || _b === void 0 ? void 0 : _b.contains('search-results--item')))
                    break;
                event.stopPropagation();
                event.preventDefault();
                const activeListType = getActiveElementListType(activeElem);
                const bucket = resultBuckets.find((b) => b.type === activeListType);
                if (bucket === null || bucket === void 0 ? void 0 : bucket.pro) {
                    const firstAmatBucket = resultBuckets.find((b) => !b.pro);
                    if (firstAmatBucket) {
                        document.getElementsByClassName(`search-results-list--${firstAmatBucket.type}`)[0]
                            .getElementsByClassName('search-results--item')[0].focus();
                    }
                }
                break;
            }
            case 'ArrowLeft': {
                // if focused on a pro list, jump to the first result of the first amateur list
                if (!((_c = activeElem === null || activeElem === void 0 ? void 0 : activeElem.classList) === null || _c === void 0 ? void 0 : _c.contains('search-results--item')))
                    break;
                event.stopPropagation();
                event.preventDefault();
                const activeListType = getActiveElementListType(activeElem);
                const bucket = resultBuckets.find((b) => b.type === activeListType);
                if (!(bucket === null || bucket === void 0 ? void 0 : bucket.pro)) {
                    const firstProBucket = resultBuckets.find((b) => b.pro);
                    if (firstProBucket) {
                        document.getElementsByClassName(`search-results-list--${firstProBucket.type}`)[0]
                            .getElementsByClassName('search-results--item')[0].focus();
                    }
                }
                break;
            }
            case 'ArrowDown':
            case 'ArrowUp': {
                // go to the next/previous result item in the dom, if it exists
                event.stopPropagation();
                event.preventDefault();
                if (!((_d = activeElem === null || activeElem === void 0 ? void 0 : activeElem.classList) === null || _d === void 0 ? void 0 : _d.contains('search-results--item'))) {
                    // no item is focused, focus the first one we can find
                    if (event.key === 'ArrowDown')
                        document.getElementsByClassName('search-results--item')[0].focus();
                    break;
                }
                const allItems = document.getElementsByClassName('search-results--item');
                const currentIndex = Array.from(allItems).indexOf(activeElem);
                const targetIndex = currentIndex + (event.key === 'ArrowDown' ? 1 : -1);
                if (allItems[targetIndex])
                    allItems[targetIndex].focus();
                break;
            }
        }
    };
    useEffect(() => {
        if (isListenerActive)
            document.addEventListener('keydown', handleKeyDown);
        else
            document.removeEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isListenerActive]);
    return resultBuckets.some((b) => { var _a; return (_a = b.results) === null || _a === void 0 ? void 0 : _a.length; }) ? (React.createElement(StyledModal, { size: "lg", show: show, onHide: onHide, animation: false, enforceFocus: false, container: searchResultsContainer },
        React.createElement(StyledModalBody, null,
            React.createElement(StyledResultsContainer, null,
                React.createElement("div", { className: "search-list search-list--pro" },
                    React.createElement("h1", { className: "my-0" }, translate('components.search.pro')),
                    React.createElement("div", null, resultBuckets.filter((b) => b.pro).map((b) => (React.createElement(SearchResultsList, { key: b.type, items: b.results, type: b.type, label: b.label }))))),
                React.createElement("div", { className: "search-list search-list--amateur" },
                    React.createElement("h1", { className: "my-0" }, translate('components.search.amateur')),
                    React.createElement("div", null, resultBuckets.filter((b) => !b.pro).map((b) => (React.createElement(SearchResultsList, { key: b.type, items: b.results, type: b.type, label: b.label }))))))),
        React.createElement(StyledModalFooter, null,
            React.createElement(Form.Check, { type: "checkbox", label: translate('components.search.include-inactive-players'), id: "search-toggle-inactive", 
                // onClick={onToggleInactive}
                checked: showInactive, onChange: toggleInactive })))) : (React.createElement(StyledModal, { size: "sm", show: show, onHide: onHide, animation: false, enforceFocus: false, container: searchResultsContainer, autoFocus: false },
        React.createElement(BaseModal.Body, null,
            React.createElement("div", null,
                translate('components.search.no-results-found'),
                "...")),
        React.createElement(StyledModalFooter, null,
            React.createElement(Form.Check, { type: "checkbox", label: translate('components.search.include-inactive-players'), id: "search-toggle-inactive", 
                // onClick={onToggleInactive}
                checked: showInactive, onChange: toggleInactive }))));
};

const Search = ({ search: searchFn, results, onHide, onClear, doCloseSearch, searchResultsContainer, isLoading = false }) => {
    const [searchCriteria, setSearchCriteria] = useState('');
    const [showInactive, setShowInactive] = useState(false);
    const resultsShow = !!results;
    const dbSearchCriteria = useDebounce(searchCriteria, 500);
    const shouldDoFetch = dbSearchCriteria.length >= 3;
    useEffect(() => {
        searchFn(dbSearchCriteria, { isactive: !showInactive }, shouldDoFetch);
    }, [searchFn, dbSearchCriteria, shouldDoFetch, showInactive]);
    useEffect(() => {
        var _a;
        if (results) {
            (_a = document.getElementById('searchInputField')) === null || _a === void 0 ? void 0 : _a.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resultsShow]);
    useEffect(() => {
        if (doCloseSearch) {
            setSearchCriteria('');
            setShowInactive(false);
        }
    }, [doCloseSearch, setSearchCriteria]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SearchInput, { onChange: (event) => setSearchCriteria(event.target.value), onClear: () => { setSearchCriteria(''); onClear(); }, isLoading: isLoading, searchCriteria: searchCriteria, id: "searchInputField" }),
        React.createElement(SearchResults, { show: !!results, onHide: () => { setSearchCriteria(''); onClear(); if (onHide)
                onHide(); }, onToggleInactive: (event) => setShowInactive(event.target.checked), searchResultsContainer: searchResultsContainer, results: results })));
};

const StyledPopover = styled(Popover) `
    max-height: 160px;
    overflow-y: auto;
    .arrow {
        display: none !important;
    }
`;
const StyledSelectedValue = styled.div `
    font-size: 14px;
    background-color: ${theme.fontColors.dodgerBlue};
    color: white;
    padding: 4px;
    border-radius: 2px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: calc(100% - 48px);
`;
const StyledTypeSearch = styled.div `
    position: relative;
    ${StyledPopover} {
        width: 100%;
        max-width: unset;
    }
    ${StyledSelectedValue} {
        position: absolute;
        left: 25px;
        top: 5px;
    }
`;
const BaseSearchByType = ({ type, search: searchFn, results, onClear, onHide, onSelect, value, isLoading = false }) => {
    const [searchCriteria, setSearchCriteria] = useState('');
    const [searchResultsOverlayTarget, setTarget] = useState();
    const searchResultsOverlayRef = useRef(null);
    const dbSearchCriteria = useDebounce(searchCriteria, 500);
    useEffect(() => {
        const shouldDoFetch = !!dbSearchCriteria && dbSearchCriteria.length >= 3;
        if (!value && searchCriteria)
            searchFn(dbSearchCriteria, shouldDoFetch);
    }, [searchFn, searchCriteria, dbSearchCriteria, value]);
    useEffect(() => {
        if (!value) {
            setSearchCriteria('');
            if (onClear)
                onClear();
            if (onHide)
                onHide();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    const onItemSelect = onSelect ? (item) => {
        onSelect(item);
        if (onHide)
            onHide();
    } : undefined;
    const onSearchInputChange = (e) => {
        setSearchCriteria(e.target.value);
        setTarget(e.target);
    };
    const onSearchInputClear = () => {
        setSearchCriteria('');
        if (onClear)
            onClear();
        if (onHide)
            onHide();
    };
    return (React.createElement(StyledTypeSearch, { ref: searchResultsOverlayRef, "$searchInputValue": value },
        React.createElement(SearchInput, { onChange: onSearchInputChange, onClear: onSearchInputClear, isLoading: isLoading, searchCriteria: value || searchCriteria }),
        !!value && React.createElement(StyledSelectedValue, null, value),
        React.createElement(Overlay, { show: results && !isLoading, target: searchResultsOverlayTarget, placement: "bottom-start", container: searchResultsOverlayRef.current, rootClose: true, onHide: onHide },
            React.createElement(StyledPopover, { id: "player-search" },
                React.createElement(StyledPopover.Body, null, !!results && results.map((item) => (React.createElement(SearchResultsItem, { key: item.key, item: item, type: type, suppressTypeNameInResults: true, onSelect: onItemSelect }))))))));
};

const PlayerSearch = (_a) => {
    var { results } = _a, rest = __rest(_a, ["results"]);
    const players = results === null || results === void 0 ? void 0 : results.players.map((p) => (Object.assign(Object.assign({}, p), { key: p.PlayerID })));
    return (React.createElement(BaseSearchByType, Object.assign({ type: searchResultTypes.PLAYER, results: players }, rest)));
};

const TeamSearch = (_a) => {
    var { results } = _a, rest = __rest(_a, ["results"]);
    const teams = results === null || results === void 0 ? void 0 : results.teams.map((p) => (Object.assign(Object.assign({}, p), { key: p.TeamID })));
    return (React.createElement(BaseSearchByType, Object.assign({ type: searchResultTypes.TEAM, results: teams }, rest)));
};

const LeagueSearch = (_a) => {
    var { results } = _a, rest = __rest(_a, ["results"]);
    const leagues = results === null || results === void 0 ? void 0 : results.leagues.map((p) => (Object.assign(Object.assign({}, p), { key: p.LeagueID })));
    return (React.createElement(BaseSearchByType, Object.assign({ type: searchResultTypes.LEAGUE, results: leagues }, rest)));
};

const VenueSearch = (_a) => {
    var { results } = _a, rest = __rest(_a, ["results"]);
    const venues = results === null || results === void 0 ? void 0 : results.venues.map((p) => (Object.assign(Object.assign({}, p), { key: p.VenueID })));
    return (React.createElement(BaseSearchByType, Object.assign({ type: searchResultTypes.VENUE, results: venues }, rest)));
};

const FilterGroupWrapper = styled.div `
    border-bottom: 1px solid ${theme.border.alto};
    flex-grow: 1;
    position: relative;
`;
const FilterGroupTitle = styled.h5 `
    color: ${theme.fontColors.darkBlue};
    margin-bottom: 0 !important;
    font-size: 13.75px !important;
`;
const StyledGroupButton = styled(Button) `
    padding: 7px 9px !important;
`;
const FilterGroupChildWrapper = styled.div `
    padding: 0 10px 40px;
`;
const AccordionFilterGroup = ({ title, filter, filterKeys, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const numAppliedFilters = Object.entries(filter)
        .filter(([key]) => { var _a; return (_a = filterKeys === null || filterKeys === void 0 ? void 0 : filterKeys.includes(key)) !== null && _a !== void 0 ? _a : true; })
        .filter(([, f]) => {
        const filterAsArray = Array.isArray(f) ? f : [f];
        return filterAsArray.some((x) => !isSelectAllValue(x));
    }).length;
    const completeTitle = `${title}${numAppliedFilters ? ` (${numAppliedFilters})` : ''}`;
    return (React.createElement(FilterGroupWrapper, null,
        React.createElement(StyledGroupButton, { variant: "link", className: "d-flex justify-content-between align-items-center text-primary w-100", onClick: () => setIsOpen(!isOpen) },
            React.createElement(FilterGroupTitle, null, completeTitle),
            React.createElement(Icon, { icon: `chevron-${isOpen ? 'up' : 'down'}`, size: "1.25em", color: theme.fontColors.dodgerBlue })),
        isOpen && (React.createElement(FilterGroupChildWrapper, null, children))));
};

/* eslint-disable no-nested-ternary */
const StyledAccoridonFilterSection = styled.div `
    padding: 12px 0 0;
    text-align: left;
    label {
        font-size: 11px;
        padding-right: 7px;
        text-align: right;
        color: ${(props) => (props.isInvalidRange ? '#dc3545'
    : props.isFiltered ? theme.fontColors.dodgerBlue : theme.fontColors.tundora)};
    }
    .filter-title {
        margin-bottom:2px;
        text-align: left;
        label {
            font-weight: bold;
            margin-bottom: 0;
            width: initial;
        }
    }
`;
const AccoridonFilterSection = ({ title, children, playlist, filter, requiredFields, className }) => {
    var _a, _b;
    const fields = Array.isArray(requiredFields) ? requiredFields : [requiredFields];
    const hasAnyDataWithFields = playlist.some(({ data }) => fields.every((f) => data[f] !== null && data[f] !== undefined));
    const isFiltered = Object.entries(filter)
        .filter(([key]) => { var _a; return (_a = requiredFields === null || requiredFields === void 0 ? void 0 : requiredFields.includes(key)) !== null && _a !== void 0 ? _a : true; })
        .some(([, f]) => {
        const filterAsArray = Array.isArray(f) ? f : [f];
        return filterAsArray.some((x) => !isSelectAllValue(x));
    });
    const isInvalidRange = !Array.isArray(requiredFields) && ((_a = filter[requiredFields]) === null || _a === void 0 ? void 0 : _a.min) !== undefined && ((_b = filter[requiredFields]) === null || _b === void 0 ? void 0 : _b.max) !== undefined
        && +filter[requiredFields].min > +filter[requiredFields].max;
    return (React.createElement(React.Fragment, null, hasAnyDataWithFields && (React.createElement(StyledAccoridonFilterSection, { className: className, isFiltered: isFiltered, isInvalidRange: isInvalidRange },
        React.createElement("div", { className: "filter-title" },
            React.createElement("label", null, title)),
        children))));
};

const BasicFilters = ({ playlist, filter, onChange }) => {
    const { t: translate } = useTranslation();
    const pitchTypeOptions = PITCH_TYPES(translate)
        .filter((p) => p.sortorder > 0 && p.sortorder < 20)
        .sort((a, b) => a.sortorder - b.sortorder)
        .map((p) => ({ name: p.abbr, value: p.id }));
    const filterKeys = ['pitcherHand', 'batterHand', 'balls', 'strikes', 'outsbefore', 'bcbefore', 'hasRunners', 'type'];
    const lhpOptions = [{ name: translate('baseball.lhp'), value: 1 }, { name: translate('baseball.rhp'), value: 0 }];
    const lhbOptions = [{ name: translate('baseball.lhh'), value: 1 }, { name: translate('baseball.rhh'), value: 0 }];
    return (React.createElement(AccordionFilterGroup, { title: translate('components.video.filters.basic-filters'), filter: filter, filterKeys: filterKeys },
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.pither-hand'), playlist: playlist, requiredFields: "pitcherHand", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "pitcherHand", onChange: onChange, options: lhpOptions, playlist: playlist, type: "radio" })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.batter-hand'), playlist: playlist, requiredFields: "batterHand", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "batterHand", onChange: onChange, options: lhbOptions, playlist: playlist, type: "radio" })),
        React.createElement(AccoridonFilterSection, { title: `${translate('baseball.count')} (${translate('baseball.balls_other')})`, playlist: playlist, requiredFields: "balls", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "balls", onChange: onChange, options: [0, 1, 2, 3], playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: `${translate('baseball.count')} (${translate('baseball.strikes_other')})`, playlist: playlist, requiredFields: "strikes", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "strikes", onChange: onChange, options: [0, 1, 2], playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('baseball.outs_other'), playlist: playlist, requiredFields: "outsbefore", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "outsbefore", onChange: onChange, options: [0, 1, 2], playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.baserunners'), playlist: playlist, requiredFields: ['bcbefore', 'hasRunners'], filter: filter },
            React.createElement(VideoFilterBaseRunners, { playlist: playlist, filter: filter, onChange: onChange, rows: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.pitch-type'), playlist: playlist, requiredFields: "type", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "type", onChange: onChange, options: pitchTypeOptions, playlist: playlist, rows: 3, ignoreSort: true }))));
};

const KeyPadRow = ({ padKeys }) => (React.createElement(Row$1, { className: "border-top m-0" },
    React.createElement(Col$1, { className: "text-center p-0" },
        React.createElement(Button$1, { className: "py-3 w-100 h-100 text-dark h1 mb-0", variant: "link", onClick: padKeys[0].onClick }, padKeys[0].label)),
    React.createElement(Col$1, { className: "border-left border-right text-center p-0" },
        React.createElement(Button$1, { className: "py-3 w-100 h-100 text-dark h1 mb-0", variant: "link", onClick: padKeys[1].onClick }, padKeys[1].label)),
    React.createElement(Col$1, { className: "text-center p-0" },
        React.createElement(Button$1, { className: "py-3 w-100 h-100 text-dark h1 mb-0", variant: "link", onClick: padKeys[2].onClick }, padKeys[2].label))));
const KeyPadModal = forwardRef((_a, ref) => {
    var { unit, onDone, min, max, minimumFractionDigits } = _a, rest = __rest(_a, ["unit", "onDone", "min", "max", "minimumFractionDigits"]);
    const { t: translate } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [value, setValue] = useState('');
    const [isNegative, setIsNegative] = useState(false);
    const [isFirstKeyPress, setIsFirstKeyPress] = useState(false);
    const numValue = Number(`${isNegative ? '-' : ''}${value}`);
    useImperativeHandle(ref, () => ({
        show: (v) => {
            setValue(Math.abs(v).toLocaleString(undefined, { minimumFractionDigits, maximumFractionDigits: 10 }).replace(/,/g, ''));
            setShowModal(true);
            setIsNegative(v < 0);
            setIsFirstKeyPress(true);
        },
    }));
    const addDigit = (digit) => {
        const newNum = isFirstKeyPress ? digit : `${value}${digit}`;
        if (!isNaN(Number(newNum))) {
            if (isFirstKeyPress) {
                setIsFirstKeyPress(false);
                setIsNegative(false);
            }
            setValue(newNum);
        }
    };
    const handleDone = () => {
        onDone(numValue.toString());
        setShowModal(false);
    };
    const clear = () => {
        setIsNegative(false);
        setValue('');
    };
    const addDecimal = () => {
        if (!value || isFirstKeyPress) {
            setValue('0.');
            if (isFirstKeyPress) {
                setIsFirstKeyPress(false);
                setIsNegative(false);
            }
        }
        else {
            addDigit('.');
        }
    };
    const handleNegative = () => {
        if (isFirstKeyPress) {
            setIsFirstKeyPress(false);
            setValue('');
            setIsNegative(true);
        }
        else {
            setIsNegative(!isNegative);
        }
    };
    const keys = [
        [{ key: 1, label: '1', onClick: () => addDigit('1') }, { label: '2', onClick: () => addDigit('2') }, { label: '3', onClick: () => addDigit('3') }],
        [{ key: 2, label: '4', onClick: () => addDigit('4') }, { label: '5', onClick: () => addDigit('5') }, { label: '6', onClick: () => addDigit('6') }],
        [{ key: 3, label: '7', onClick: () => addDigit('7') }, { label: '8', onClick: () => addDigit('8') }, { label: '9', onClick: () => addDigit('9') }],
        [{ key: 4, label: '.', onClick: addDecimal }, { label: '0', onClick: () => addDigit('0') }, {
                label: React.createElement("div", { className: "text-dark" },
                    " ",
                    React.createElement(Icon, { icon: "nyy-plus-minus", size: "1em", color: "rgb(52, 58, 64)" }),
                    " "),
                onClick: handleNegative,
            }],
    ];
    const isNumAboveMin = isNaN(numValue) || !value || (min === undefined || Number(numValue) > min);
    const isNumUnderMax = isNaN(numValue) || !value || (max === undefined || Number(numValue) < max);
    const isNumValid = !isNaN(numValue) && !!value && isNumAboveMin && isNumUnderMax;
    return (React.createElement(BaseModal, Object.assign({ onHide: () => setShowModal(false), size: "sm", className: "h-100 d-flex align-items-center", show: showModal }, rest),
        React.createElement(Card$2, null,
            React.createElement("div", { className: "py-3" },
                !isNumAboveMin && React.createElement("div", { className: "text-danger d-flex justify-content-center" }, translate('components.video.filters.max-greater-min')),
                !isNumUnderMax && React.createElement("div", { className: "text-danger d-flex justify-content-center" }, translate('components.video.filters.min-less-than-max')),
                React.createElement("div", { className: `h1 mt-2 d-flex justify-content-center align-items-baseline ${value ? '' : 'text-black-50'}` },
                    isNegative ? '-' : '',
                    value || '00.0',
                    React.createElement("span", { className: "ms-1 text-muted h6", style: { fontSize: '0.5em' }, dangerouslySetInnerHTML: { __html: unit } }))),
            keys.map((k) => React.createElement(KeyPadRow, { padKeys: k, key: k[0].key })),
            React.createElement(Row$1, { className: "border-top m-0 py-3" },
                React.createElement(Col$1, null,
                    React.createElement(Button$1, { variant: "light", onClick: () => setShowModal(false) }, translate('common.cancel'))),
                React.createElement(Col$1, null,
                    React.createElement(Button$1, { variant: "secondary", onClick: clear }, translate('common.clear'))),
                React.createElement(Col$1, null,
                    React.createElement(Button$1, { variant: "primary", onClick: handleDone, disabled: !isNumValid }, translate('common.done')))))));
});

const KeyPadRange = ({ unit, filter, name, onChange, playlist, modalContainer, minimumFractionDigits = 0, useKeyPad = true }) => {
    var _a, _b;
    const [isMaxOpen, setIsMaxOpen] = useState(false);
    const [minLimit, setMinLimit] = useState(undefined);
    const [maxLimit, setMaxLimit] = useState(undefined);
    const modalRef = useRef(null);
    let min = 0;
    let max = 0;
    const pitchesWithData = playlist.filter(({ data }) => isNumber$2(data[name]));
    if (pitchesWithData.length) {
        min = Math.min(...pitchesWithData.map(({ data }) => data[name]));
        max = Math.max(...pitchesWithData.map(({ data }) => data[name]));
    }
    const defaultNum = (num, decimalPlaces = 0, roundingFunc) => {
        const roundedNum = roundingFunc(num * (Math.pow(10, decimalPlaces))) / (Math.pow(10, decimalPlaces));
        return roundedNum.toLocaleString(undefined, { minimumFractionDigits, maximumFractionDigits: minimumFractionDigits });
    };
    const parseString = (num) => parseFloat(num.replace(/,/g, ''));
    let minValue = filter[name] ? (_a = filter[name].min) === null || _a === void 0 ? void 0 : _a.toLocaleString(undefined, { minimumFractionDigits, maximumFractionDigits: 10 })
        : defaultNum(min, minimumFractionDigits, Math.floor);
    let maxValue = filter[name] ? (_b = filter[name].max) === null || _b === void 0 ? void 0 : _b.toLocaleString(undefined, { minimumFractionDigits, maximumFractionDigits: 10 })
        : defaultNum(max, minimumFractionDigits, Math.ceil);
    if (!useKeyPad) {
        minValue = minValue.replace(/,/g, '');
        maxValue = maxValue.replace(/,/g, '');
    }
    const openMin = () => {
        var _a;
        (_a = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) === null || _a === void 0 ? void 0 : _a.show(parseString(minValue));
        setIsMaxOpen(false);
        setMaxLimit(parseString(maxValue));
        setMinLimit(undefined);
    };
    const openMax = () => {
        var _a;
        (_a = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) === null || _a === void 0 ? void 0 : _a.show(parseString(maxValue));
        setIsMaxOpen(true);
        setMinLimit(parseString(minValue));
        setMaxLimit(undefined);
    };
    const onDone = (value) => {
        if (isMaxOpen) {
            onChange(parseFloat(value), `${name}.max`);
            onChange(parseString(minValue), `${name}.min`);
        }
        else {
            onChange(parseFloat(value), `${name}.min`);
            onChange(parseString(maxValue), `${name}.max`);
        }
    };
    const handleInput = (e, isMin) => {
        e.preventDefault();
        const { value } = e.currentTarget;
        if (value.split('').filter((c) => c === '.').length > 1
            || value.split('').some((s, i) => s === '-' && i)
            || value.split('').some((s) => !['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '-'].includes(s))) {
            return;
        }
        if (isMin) {
            onChange(value, `${name}.min`);
            onChange(parseString(maxValue), `${name}.max`);
        }
        else {
            onChange(value, `${name}.max`);
            onChange(parseString(minValue), `${name}.min`);
        }
    };
    const isInvalid = parseString(minValue) >= parseString(maxValue);
    return (React.createElement("div", null,
        React.createElement("div", { className: "d-flex align-items-center" },
            React.createElement(Form$1.Control, { type: "text", size: "sm", onClick: useKeyPad ? openMin : undefined, value: useKeyPad ? minValue === null || minValue === void 0 ? void 0 : minValue.toLocaleString(undefined, { minimumFractionDigits }) : minValue, onChange: (e) => handleInput(e, true), readOnly: useKeyPad, className: "bg-white", isInvalid: isInvalid }),
            React.createElement("span", { className: "mx-3" }, "to"),
            React.createElement(Form$1.Control, { type: "text", size: "sm", onClick: useKeyPad ? openMax : undefined, value: useKeyPad ? maxValue === null || maxValue === void 0 ? void 0 : maxValue.toLocaleString(undefined, { minimumFractionDigits }) : maxValue, onChange: (e) => handleInput(e, false), readOnly: useKeyPad, className: "bg-white", isInvalid: isInvalid }),
            React.createElement("span", { className: "ms-2", style: { minWidth: '27px' }, dangerouslySetInnerHTML: { __html: unit } })),
        React.createElement(KeyPadModal, { container: modalContainer, onDone: onDone, unit: unit, ref: modalRef, min: minLimit, max: maxLimit, minimumFractionDigits: minimumFractionDigits })));
};

const StyledAdvancedIconContainer$1 = styled.div `
    width: 100%;
    margin-bottom: ${filterMarginBottom};
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
        margin-left: ${filterMarginBottom};
        margin-right: ${filterMarginBottom};
    }
    label {
        white-space: nowrap;
    }
`;
const filterKeys$3 = ['pitchLocations', 'velocity', 'spinrate', 'breakz54', 'breakx54', 'initposx_55',
    'initposz_55', 'rvactualNorm', 'rvexpNorm', 'rvpitchfxNorm', 'rvbreakNorm', 'rvstuffNorm', 'rvlocNorm'];
const PitchingFilters = ({ playlist, filter, onChange, modalContainer, useKeyPad }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(AccordionFilterGroup, { title: translate('components.video.filters.pitching-filters'), filter: filter, filterKeys: filterKeys$3 },
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.pitching-filters'), playlist: playlist, requiredFields: ['locationx', 'locationy'], filter: filter },
            React.createElement(StyledAdvancedIconContainer$1, null,
                React.createElement(VideoFilterPitchLocation, { playlist: playlist, locations: filter.pitchLocations, onChange: onChange }))),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.pitch-velo'), playlist: playlist, requiredFields: "velocity", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, unit: translate('components.video.filters.abbr-miles-hour'), filter: filter, name: "velocity", onChange: onChange, playlist: playlist, modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.vertical-break'), playlist: playlist, requiredFields: "breakz54", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "breakz54", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-inches'), modalContainer: modalContainer, minimumFractionDigits: 1 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.horizontal-break'), playlist: playlist, requiredFields: "breakx54", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "breakx54", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-inches'), modalContainer: modalContainer, minimumFractionDigits: 1 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.horizontal-release'), playlist: playlist, requiredFields: "initposx_55", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "initposx_55", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-feet'), modalContainer: modalContainer, minimumFractionDigits: 1 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.vertical-release'), playlist: playlist, requiredFields: "initposz_55", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "initposz_55", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-feet'), modalContainer: modalContainer, minimumFractionDigits: 1 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.rv-era'), playlist: playlist, requiredFields: "rvactualNorm", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "rvactualNorm", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-earned-run-avg'), modalContainer: modalContainer, minimumFractionDigits: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.expected-rv-era'), playlist: playlist, requiredFields: "rvexpNorm", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "rvexpNorm", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-earned-run-avg'), modalContainer: modalContainer, minimumFractionDigits: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.pfx-era'), playlist: playlist, requiredFields: "rvpitchfxNorm", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "rvpitchfxNorm", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-earned-run-avg'), modalContainer: modalContainer, minimumFractionDigits: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.break-era'), playlist: playlist, requiredFields: "rvbreakNorm", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "rvbreakNorm", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-earned-run-avg'), modalContainer: modalContainer, minimumFractionDigits: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.stuff-era'), playlist: playlist, requiredFields: "rvstuffNorm", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "rvstuffNorm", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-earned-run-avg'), modalContainer: modalContainer, minimumFractionDigits: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.location-era'), playlist: playlist, requiredFields: "rvlocNorm", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "rvlocNorm", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-earned-run-avg'), modalContainer: modalContainer, minimumFractionDigits: 2 }))));
};

const StyledAdvancedIconContainer = styled.div `
    width: 100%;
    margin-bottom: ${filterMarginBottom};
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
        margin-left: ${filterMarginBottom};
        margin-right: ${filterMarginBottom};
    }
    label {
        white-space: nowrap;
    }
`;
const StyledHitLocationContainer = styled(StyledAdvancedIconContainer) `
    position: relative;
    && {
        .btn-group {
            position: static;
            .btn {
                position: absolute;
                &:nth-of-type(1) { left: 0; } 
                &:nth-of-type(3) { left: 40px; } 
                &:nth-of-type(2) { left: 201px; } 
                &:nth-of-type(4) { left: 161px; } 
                &:nth-of-type(1), &:nth-of-type(2) { bottom: 55px; } 
                &:nth-of-type(3), &:nth-of-type(4) { bottom: 5px; }
            }
        }
    }
    &&&& {
        .btn-group .btn {
            margin: 0;
        }
    }
`;
const filterKeys$2 = ['hitLocations', 'hitvelocity', 'hittype', 'contactResult', 'contactQuality', 'vertla', 'horizla', 'zonedepth',
    'swinging', 'swingingFirstPitch', 'swingingInZone', 'chase', 'miss', 'missInZone', 'inZone', 'strikeout', 'unintentionalWalk',
    'swds', 'swingDecisionScoreShouldSwing', 'swingDecisionScoreShouldTake'];
const HittingFilters = ({ playlist, filter, onChange, modalContainer, useKeyPad }) => {
    const { t: translate } = useTranslation();
    const hitTypeOptions = [{ name: translate('baseball.pitchresult.abbr-groundball'), value: 0 }, { name: translate('baseball.pitchresult.abbr-flyball'), value: 1 }, { name: translate('baseball.pitchresult.abbr-popup'), value: 3 }, { name: translate('baseball.pitchresult.abbr-popup'), value: 2 }];
    return (React.createElement(AccordionFilterGroup, { title: translate('components.video.filters.hitting-filters'), filter: filter, filterKeys: filterKeys$2 },
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.hit-location'), playlist: playlist, requiredFields: ['hittype', 'isinfieldbip', 'distance', 'angleto2b', 'ishr'], filter: filter },
            React.createElement("div", null,
                React.createElement(StyledHitLocationContainer, null,
                    React.createElement(HitLocationSelect, { data: playlist.map((x) => x.data), value: filter.hitLocations, onChange: (value) => onChange(value, 'hitLocations'), emptyColor: theme.border.mercury }),
                    React.createElement(VideoFilterToggleButton, { filter: filter, name: "hittype", onChange: onChange, options: hitTypeOptions, playlist: playlist, includeAll: false })))),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.exit-velo'), playlist: playlist, requiredFields: "hitvelocity", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "hitvelocity", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-miles-hour'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: `${translate('components.video.filters.contact-result')} (${translate('components.video.filters.r100-bip')})`, playlist: playlist, requiredFields: "contactResult", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "contactResult", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.r100'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: `${translate('components.video.filters.contact-quality')} (${translate('components.video.filters.r100-bip')})`, playlist: playlist, requiredFields: "contactQuality", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "contactQuality", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.r100'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.vert-launch-angle'), playlist: playlist, requiredFields: "vertla", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "vertla", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-degrees'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.horizontal-launch-angle'), playlist: playlist, requiredFields: "horizla", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "horizla", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-degrees'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.zone-depth'), playlist: playlist, requiredFields: "zonedepth", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "zonedepth", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-feet'), modalContainer: modalContainer, minimumFractionDigits: 1 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.swinging'), playlist: playlist, requiredFields: "swinging", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "swinging", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.swinging-first-pitch'), playlist: playlist, requiredFields: "swingingFirstPitch", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "swingingFirstPitch", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.swinging-in-zone'), playlist: playlist, requiredFields: "swingingInZone", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "swingingInZone", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.chase'), playlist: playlist, requiredFields: "chase", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "chase", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.miss'), playlist: playlist, requiredFields: "miss", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "miss", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.miss-in-zone'), playlist: playlist, requiredFields: "missInZone", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "missInZone", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.in-zone'), playlist: playlist, requiredFields: "inZone", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "inZone", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.strikeout'), playlist: playlist, requiredFields: "strikeout", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "strikeout", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.unintentional-walk'), playlist: playlist, requiredFields: "unintentionalWalk", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "unintentionalWalk", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.score'), playlist: playlist, requiredFields: "swds", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "swds", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-points'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: `${translate('components.video.filters.score')} (${translate('components.video.filters.should-swing')})`, playlist: playlist, requiredFields: "swingDecisionScoreShouldSwing", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "swingDecisionScoreShouldSwing", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-points'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: `${translate('components.video.filters.score')} (${translate('components.video.filters.should-take')})`, playlist: playlist, requiredFields: "swingDecisionScoreShouldTake", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "swingDecisionScoreShouldTake", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-points'), modalContainer: modalContainer }))));
};

const filterKeys$1 = ['fapproach', 'fmethod', 'fmove', 'fthrow', 'diffopps', 'diffmade', 'hasShift', 'runnersOn', 'throwvelo', 'exchange',
    'startingdepth', 'routeeffic', 'firststep', 'firststepeffic', 'topspeed', 'sprintspeed', 'distcovered', 'topacceladj',
    'catchprobability', 'outProbability', 'hangtime'];
const FieldingFilters = ({ playlist, filter, onChange, modalContainer, useKeyPad }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(AccordionFilterGroup, { title: translate('components.video.filters.fielding-filters'), filter: filter, filterKeys: filterKeys$1 },
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.fielder-approach'), playlist: playlist, requiredFields: "fapproach", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fapproach", onChange: onChange, options: [translate('components.video.filters.stand'), translate('components.video.filters.sprint'), translate('components.video.filters.dive'), translate('components.video.filters.jog'), translate('components.video.filters.jump'), translate('components.video.filters.slide')], playlist: playlist, width: 50 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.fielding-method'), playlist: playlist, requiredFields: "fmethod", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fmethod", onChange: onChange, options: [translate('components.video.filters.backhand'), translate('components.video.filters.barehand'), translate('components.video.filters.forehand'), translate('components.video.filters.no-touch'), translate('components.video.filters.over-shoulder')], playlist: playlist, width: 95, rows: 3 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.fielder-movement'), playlist: playlist, requiredFields: "fmove", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fmove", onChange: onChange, options: [translate('components.video.filters.back'), translate('components.video.filters.forward'), translate('components.video.filters.right'), translate('components.video.filters.left'), translate('components.video.filters.no-move')], playlist: playlist, width: 85, rows: 3 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.fielder-throw'), playlist: playlist, requiredFields: "fthrow", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "fthrow", onChange: onChange, options: [translate('components.video.filters.feet-planted'), translate('components.video.filters.on-move'), translate('components.video.filters.jump-throw'), translate('components.video.filters.from-ground'), translate('components.video.filters.glove-flip')], playlist: playlist, width: 120, rows: 5 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.difficulty-opps'), playlist: playlist, requiredFields: "diffopps", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "diffopps", onChange: onChange, options: [1, 4, 2, 5, 3], playlist: playlist, rows: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.difficulty-made'), playlist: playlist, requiredFields: "diffmade", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "diffmade", onChange: onChange, options: [1, 4, 2, 5, 3], playlist: playlist, rows: 2 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.has-shift'), playlist: playlist, requiredFields: "hasShift", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "hasShift", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.runners-on'), playlist: playlist, requiredFields: "runnersOn", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "runnersOn", onChange: onChange, options: [translate('common.yes'), translate('common.no')], type: "radio", playlist: playlist })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.throw-velocity'), playlist: playlist, requiredFields: "throwvelo", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "throwvelo", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-miles-hour'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.exchange'), playlist: playlist, requiredFields: "exchange", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "exchange", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-seconds'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.starting-depth'), playlist: playlist, requiredFields: "startingdepth", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "startingdepth", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-feet'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.route-efficiency'), playlist: playlist, requiredFields: "routeeffic", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "routeeffic", onChange: onChange, playlist: playlist, unit: "%", modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.first-step'), playlist: playlist, requiredFields: "firststep", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "firststep", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-seconds'), modalContainer: modalContainer, minimumFractionDigits: 1 })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.first-step-efficiency'), playlist: playlist, requiredFields: "firststepeffic", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "firststepeffic", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-degrees'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.top-speed'), playlist: playlist, requiredFields: "topspeed", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "topspeed", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-miles-hour'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.sprint-speed'), playlist: playlist, requiredFields: "sprintspeed", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "sprintspeed", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-feet-seconds'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.distance-covered'), playlist: playlist, requiredFields: "distcovered", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "distcovered", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-feet'), modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.top-acceleration'), playlist: playlist, requiredFields: "topacceladj", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "topacceladj", onChange: onChange, playlist: playlist, unit: `${translate('components.video.filters.abbr-meter-second')}<sup>2</sup>`, modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.catch-probability'), playlist: playlist, requiredFields: "catchprobability", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "catchprobability", onChange: onChange, playlist: playlist, unit: "%", modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.out-probability'), playlist: playlist, requiredFields: "outProbability", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "outProbability", onChange: onChange, playlist: playlist, unit: "%", modalContainer: modalContainer })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.hang-time'), playlist: playlist, requiredFields: "hangtime", filter: filter },
            React.createElement(KeyPadRange, { useKeyPad: useKeyPad, filter: filter, name: "hangtime", onChange: onChange, playlist: playlist, unit: translate('components.video.filters.abbr-seconds'), modalContainer: modalContainer, minimumFractionDigits: 1 }))));
};

const filterKeys = ['inning', 'sourceLabels'];
const OtherFilters = ({ playlist, filter, onChange }) => {
    const { t: translate } = useTranslation();
    const sourceLabelOptions = Array
        .from((new Set(playlist.map((v) => { var _a, _b; return (_b = (_a = v.data.sourceLabels) === null || _a === void 0 ? void 0 : _a.filter((l) => l)) !== null && _b !== void 0 ? _b : []; }).flat())))
        .sort((a, b) => a.localeCompare(b));
    return (React.createElement(AccordionFilterGroup, { title: translate('components.video.filters.other-filters'), filter: filter, filterKeys: filterKeys },
        React.createElement(AccoridonFilterSection, { title: translate('baseball.inning'), playlist: playlist, requiredFields: "inning", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "inning", onChange: onChange, options: [1, 2, 3, 4, 5, 6, 7, 8, 9, { name: '10+', value: 10 }], playlist: playlist, rows: 3, ignoreSort: true })),
        React.createElement(AccoridonFilterSection, { title: translate('components.video.filters.video-angle'), playlist: playlist, requiredFields: "sourceLabels", filter: filter },
            React.createElement(VideoFilterToggleButton, { filter: filter, name: "sourceLabels", onChange: onChange, options: sourceLabelOptions, playlist: playlist, width: 200, rows: sourceLabelOptions.length, ignoreSort: true }))));
};

const SearchData = styled.div `
    padding: 7.5px 10px;
`;
const VideoSearchTitleWrapper = styled.div `
    position: relative;
`;
const VideoSearchWrapper = styled.div `
    border-bottom: 1px solid ${theme.border.alto};

    & label {
        margin: 0;
    }
`;
const TitleButton = styled(Button) `
    position: absolute;
    top: 2px;
    right: 1px;
`;
const FilterGroupActions = styled.div `
    width: 280px;
    position: fixed;
    bottom: 22px;
    left: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: -7.5px -10px 0;
    padding: 7.5px 10px;
    border-top: 1px solid ${theme.border.alto};
    background-color: white;
    z-index: 1;
`;
const SearchFormField = ({ title, value }) => (React.createElement("div", { className: "mb-1" },
    React.createElement("span", { className: "text-muted" }, title),
    ": ",
    React.createElement("span", { className: "font-weight-bold" }, value)));
const getDate = (searchForm) => {
    let date = searchForm.StartDate ? dayjs(searchForm.StartDate).format('MM/DD/YYYY') : '';
    date += searchForm.StartDate && searchForm.EndDate ? '-' : '';
    date += searchForm.EndDate ? dayjs(searchForm.EndDate).format('MM/DD/YYYY') : '';
    return date;
};
const AccordionFilters = forwardRef(({ yearId, onSubmit, onCreate, onUpdate, onDelete, onClear, playerSearch, teamSearch, form, levelId, initForm, saving, searching, hideSavedSearches, showClear, searchButtonTitle, playlist, filter: appliedFilter, onFilter, showFilters, showSearch, showCancel, modalContainer, title, goToSearch, useKeyPad, hideAmateurLevels }, ref) => {
    var _a, _b;
    const { t: translate } = useTranslation();
    const [isEditingInitSearch, setIsEditingInitSearch] = useState(true);
    const [searchForm, setSearchForm] = useState(null);
    const [filter, setFilter] = useState(appliedFilter);
    const [showInvalidFilterModal, setShowInvalidFilterModal] = useState(false);
    const [invalidFilters, setInvalidFilters] = useState([]);
    useImperativeHandle(ref, () => ({
        setSearchForm: (sf) => {
            setSearchForm(sf);
        },
        setFilter: (f) => {
            setFilter(f);
        },
        setIsEditingInitSearch: (v) => {
            setIsEditingInitSearch(v);
        },
    }));
    const onSearch = (sf) => {
        setIsEditingInitSearch(false);
        setSearchForm(sf);
        setFilter({});
        onSubmit(sf);
    };
    const onChange = (value, name, isMultiselect) => setFilter((tempFilter) => {
        var _a;
        let newValue = value;
        if (isMultiselect) {
            // scenario 1: all options are deselected
            if (Array.isArray(newValue) && !newValue.length) {
                newValue = [-1];
            }
            else {
                const newDestinctOptions = newValue.filter((v) => !isSelectAllValue(v));
                if (newDestinctOptions.length) {
                    const numOldDistinctOptions = ((_a = tempFilter[name]) === null || _a === void 0 ? void 0 : _a.filter((v) => !isSelectAllValue(v)).length) || 0;
                    // scenario 2: Only "All" was checked and user selects an individual value to filter by
                    if (!numOldDistinctOptions)
                        newValue = newDestinctOptions;
                    // scenario 3: options were filtered, and user wants to go back to "All"
                    else if (numOldDistinctOptions && Array.isArray(newValue) && newValue.length > newDestinctOptions.length)
                        newValue = [-1];
                    // scenario 4: multiple non-"All" values are selected
                    // (do nothing)
                }
            }
        }
        return set(tempFilter, name, newValue);
    });
    const onClearAll = () => {
        setFilter({});
        onFilter(playlist, {});
    };
    const onCancel = () => {
        setIsEditingInitSearch(false);
        setSearchForm(Object.assign(Object.assign({}, searchForm), { Batter: searchForm === null || searchForm === void 0 ? void 0 : searchForm.Batter, Pitcher: searchForm === null || searchForm === void 0 ? void 0 : searchForm.Pitcher, Catcher: searchForm === null || searchForm === void 0 ? void 0 : searchForm.Catcher, BattingTeam: searchForm === null || searchForm === void 0 ? void 0 : searchForm.BattingTeam, PitchingTeam: searchForm === null || searchForm === void 0 ? void 0 : searchForm.PitchingTeam }));
    };
    const onEdit = () => {
        setIsEditingInitSearch(true);
        goToSearch();
    };
    const getFilterTitle = (filterKey) => ({
        velocity: translate('components.video.filters.pitch-velo'),
        spinrate: translate('components.video.filters.spin-rate'),
        breakz54: translate('components.video.filters.vertical-break'),
        breakx54: translate('components.video.filters.horizontal-break'),
        initposx_55: translate('components.video.filters.horizontal-release'),
        initposz_55: translate('components.video.filters.vertical-release'),
        rvactualNorm: translate('components.video.filters.rv-era'),
        rvexpNorm: translate('components.video.filters.expected-rv-era'),
        rvpitchfxNorm: translate('components.video.filters.pfx-era'),
        rvbreakNorm: translate('components.video.filters.break-era'),
        rvstuffNorm: translate('components.video.filters.stuff-era'),
        rvlocNorm: translate('components.video.filters.location-era'),
        hitvelocity: translate('components.video.filters.exit-velo'),
        contactResult: `${translate('components.video.filters.contact-result')} (${translate('components.video.filters.r100-bip')})`,
        contactQuality: `${translate('components.video.filters.contact-quality')} (${translate('components.video.filters.r100-bip')})`,
        vertla: translate('components.video.filters.vert-launch-angle'),
        horizla: translate('components.video.filters.horizontal-launch-angle'),
        zonedepth: translate('components.video.filters.zone-depth'),
        swds: translate('components.video.filters.score'),
        swingDecisionScoreShouldSwing: `${translate('components.video.filters.score')} (${translate('components.video.filters.should-swing')})`,
        swingDecisionScoreShouldTake: `${translate('components.video.filters.score')} (${translate('components.video.filters.should-take')})`,
        throwvelo: translate('components.video.filters.throw-velocity'),
        exchange: translate('components.video.filters.exchange'),
        startingdepth: translate('components.video.filters.starting-depth'),
        routeeffic: translate('components.video.filters.route-efficiency'),
        firststep: translate('components.video.filters.first-step'),
        firststepeffic: translate('components.video.filters.first-step-efficiency'),
        topspeed: translate('components.video.filters.top-speed'),
        sprintspeed: translate('components.video.filters.sprint-speed'),
        distcovered: translate('components.video.filters.distance-covered'),
        topacceladj: translate('components.video.filters.top-acceleration'),
        catchprobability: translate('components.video.filters.catch-probability'),
        outProbability: translate('components.video.filters.out-probability'),
        hangtime: translate('components.video.filters.hang-time'),
    }[filterKey]);
    const onApply = () => __awaiter(void 0, void 0, void 0, function* () {
        const badFilters = [];
        Object.entries(filter).forEach(([key, value]) => {
            if ((value === null || value === void 0 ? void 0 : value.min) !== undefined && (value === null || value === void 0 ? void 0 : value.max) !== undefined && +value.min >= +value.max) {
                const filterTitle = getFilterTitle(key);
                if (filterTitle) {
                    badFilters.push(filterTitle);
                }
            }
        });
        if (badFilters.length) {
            setInvalidFilters(badFilters);
            setShowInvalidFilterModal(true);
            return;
        }
        yield goToSearch();
        onFilter(playlist, filter);
    });
    return (React.createElement("div", { className: "flex-grow-1 position-relative d-inline-flex flex-column", ref: modalContainer },
        React.createElement("div", { className: "flex-grow-1 d-inline-flex flex-column" },
            React.createElement(VideoSearchTitleWrapper, null,
                title,
                showSearch && !isEditingInitSearch && (React.createElement(TitleButton, { variant: "link", className: "font-weight-bold", onClick: onEdit }, translate('common.edit')))),
            showSearch && (React.createElement(React.Fragment, null,
                React.createElement(VideoSearchWrapper, null,
                    React.createElement("div", { className: isEditingInitSearch ? '' : 'd-none' },
                        React.createElement(VideoSearchForm, { yearId: yearId, onSubmit: onSearch, onCreate: onCreate, onUpdate: onUpdate, onDelete: onDelete, onClear: onClear, playerSearch: playerSearch, teamSearch: teamSearch, form: searchForm || form, levelId: levelId, initForm: initForm, saving: saving, searching: searching, hideSavedSearches: hideSavedSearches, showClear: showClear, searchButtonTitle: searchButtonTitle, showCancel: showCancel, onCancel: onCancel, hideAmateurLevels: hideAmateurLevels })),
                    React.createElement(SearchData, { className: isEditingInitSearch ? 'd-none' : '' },
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.YearID) && React.createElement(SearchFormField, { title: translate('common.year'), value: searchForm.YearID }),
                        ((searchForm === null || searchForm === void 0 ? void 0 : searchForm.StartDate) || (searchForm === null || searchForm === void 0 ? void 0 : searchForm.EndDate)) && React.createElement(SearchFormField, { title: translate('common.date'), value: getDate(searchForm) }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.LevelID) && React.createElement(SearchFormField, { title: translate('baseball.level_one'), value: (_a = LEVELS.find((l) => l.id === searchForm.LevelID)) === null || _a === void 0 ? void 0 : _a.abbr }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.PitchType) && React.createElement(SearchFormField, { title: translate('components.video.filters.pitch-type'), value: pitchType(searchForm.PitchType, undefined, undefined, translate) }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.FXPitchType) && React.createElement(SearchFormField, { title: translate('components.video.filters.fx-pitch-type'), value: pitchType(searchForm.FXPitchType, undefined, undefined, translate) }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.FXSubType) && React.createElement(SearchFormField, { title: translate('components.video.filters.fx-sub-type'), value: pitchSubType(searchForm.FXSubType, undefined, undefined, translate) }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.BattingTeam) && React.createElement(SearchFormField, { title: translate('components.video.filters.batting-team'), value: searchForm.BattingTeam.FullName }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.PitchingTeam) && React.createElement(SearchFormField, { title: translate('components.video.filters.pitching-team'), value: searchForm.PitchingTeam.FullName }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.BaseEvent)
                            && React.createElement(SearchFormField, { title: translate('components.video.filters.base-event'), value: (_b = BASE_EVENTS(translate).find((b) => b.id === (searchForm === null || searchForm === void 0 ? void 0 : searchForm.BaseEvent))) === null || _b === void 0 ? void 0 : _b.name }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Outs) !== undefined && (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Outs) != null && React.createElement(SearchFormField, { title: translate('baseball.outs_other'), value: searchForm.Outs }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Inning) && React.createElement(SearchFormField, { title: translate('baseball.inning'), value: searchForm.Inning }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Batter) && React.createElement(SearchFormField, { title: translate('baseball.batter'), value: searchForm.Batter.FullName }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Pitcher) && React.createElement(SearchFormField, { title: translate('baseball.pitcher_one'), value: searchForm.Pitcher.FullName }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Catcher) && React.createElement(SearchFormField, { title: translate('baseball.catcher_one'), value: searchForm.Catcher.FullName }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Bats) !== undefined && (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Bats) != null
                            && React.createElement(SearchFormField, { title: translate('baseball.bats'), value: searchForm.Bats === 1 ? translate('baseball.left') : translate('baseball.right') }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Throws) !== undefined && (searchForm === null || searchForm === void 0 ? void 0 : searchForm.Throws) != null
                            && React.createElement(SearchFormField, { title: translate('baseball.throws'), value: searchForm.Throws === 1 ? translate('baseball.left') : translate('baseball.right') }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.LastXGames) && React.createElement(SearchFormField, { title: translate('components.video.filters.last-x-games'), value: searchForm.LastXGames }),
                        (searchForm === null || searchForm === void 0 ? void 0 : searchForm.LastXPas) && React.createElement(SearchFormField, { title: translate('components.video.filters.last-x-pa'), value: searchForm.LastXPas }))),
                showFilters && !isEditingInitSearch && (React.createElement("div", { className: "flex-grow-1", style: { paddingBottom: '40px' } },
                    React.createElement(BasicFilters, { filter: filter, playlist: playlist, onChange: onChange }),
                    React.createElement(PitchingFilters, { filter: filter, playlist: playlist, onChange: onChange, modalContainer: modalContainer, useKeyPad: useKeyPad }),
                    React.createElement(HittingFilters, { filter: filter, playlist: playlist, onChange: onChange, modalContainer: modalContainer, useKeyPad: useKeyPad }),
                    React.createElement(FieldingFilters, { filter: filter, playlist: playlist, onChange: onChange, modalContainer: modalContainer, useKeyPad: useKeyPad }),
                    React.createElement(OtherFilters, { filter: filter, playlist: playlist, onChange: onChange }),
                    React.createElement(FilterGroupActions, null,
                        React.createElement(Button, { onClick: onClearAll }, translate('common.clear')),
                        React.createElement(Button, { variant: "primary", onClick: onApply }, translate('common.apply')))))))),
        React.createElement(BaseModal, { show: showInvalidFilterModal, onHide: () => setShowInvalidFilterModal(false), container: modalContainer },
            React.createElement(BaseModal.Body, null,
                translate('components.video.filters.filters-invalid'),
                ":",
                React.createElement("ul", null, invalidFilters.map((i) => React.createElement("li", { key: i }, i)))))));
});

const StyledFilterPill = styled.button `
    font-size: 12px;
    background-color: ${(props) => (props.$isDisabled ? '#eeeeee' : 'white')};
    color: ${(props) => (props.$isDisabled ? '#8f8f8f' : '#303030')}
`;
const StyledFilterPillWrapper = styled.div `
    display: grid;
    gap: 0.5rem;
    grid-template-columns: repeat(${(props) => Math.ceil(props.$columns / 2)}, minmax(0, 1fr));

    @media (min-width: 1200px) {
        grid-template-columns: repeat(${(props) => props.$columns}, minmax(0, 1fr));
    }
`;
const getSvg = (id, options, disabled) => () => { var _a; return (_a = options.find((o) => o.id === id)) === null || _a === void 0 ? void 0 : _a.svg({ disabled }); };
const LiveFilterPills = ({ className, filter, options, setFilter }) => {
    const updateFilter = (id) => {
        if (filter.includes(id)) {
            setFilter(filter.filter((x) => x !== id));
        }
        else {
            setFilter([id, ...filter]);
        }
    };
    const isOptionDisabled = (id) => !filter.includes(id);
    return (React.createElement(StyledFilterPillWrapper, { className: className, "$columns": options.length }, options.map((t) => (React.createElement(StyledFilterPill, { "$isDisabled": isOptionDisabled(t.id), onClick: () => updateFilter(t.id), key: t.id, className: "py-1 px-2 border rounded d-flex align-items-center fw-bold" },
        getSvg(t.id, options, isOptionDisabled(t.id))(),
        React.createElement("span", { className: "ms-2" }, t.name))))));
};

const ALL_VALUE$1 = -1;
const OUT_ZONE_VALUE = 0;
const IN_ZONE_VALUE = 1;
const SHOWING_RESULTS_VALUE$1 = 0;
const SHOWING_PITCH_TYPES_VALUE$1 = 1;
const SHOWING_PITCH_TYPES_EXTENDED_VALUE$1 = 2;
const ALL_FB_VALUE = 1;
const ALL_NON_FB_VALUE = 0;
const HOME_VALUE = -2;
const AWAY_VALUE = -3;
const PITCH_TYPES_HITMON = (translate) => [
    {
        id: 9,
        name: translate('baseball.pitches.fastball-2-alt'),
        abbr: translate('baseball.pitches.abbr-fastball-2'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#e31a1c', fill: disabled ? '#747474' : '#e31a1c', strokeWidth: "2" }))),
    },
    {
        id: 10,
        name: translate('baseball.pitches.fastball-4-alt'),
        abbr: translate('baseball.pitches.abbr-fastball-4'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#ff7f00', fill: disabled ? '#747474' : '#ff7f00', strokeWidth: "2" }))),
    },
    {
        id: 2,
        name: translate('baseball.pitches.curveball'),
        abbr: translate('baseball.pitches.abbr-curveball'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#a6cee3', fill: disabled ? '#747474' : '#a6cee3', strokeWidth: "2" }))),
    },
    {
        id: 4,
        name: translate('baseball.pitches.changeup_one'),
        abbr: translate('baseball.pitches.abbr-changeup'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#33a02c', fill: disabled ? '#747474' : '#33a02c', strokeWidth: "2" }))),
    },
    {
        id: 8,
        name: translate('baseball.pitches.cutter'),
        abbr: translate('baseball.pitches.abbr-cutter'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#6a3d9a', fill: disabled ? '#747474' : '#6a3d9a', strokeWidth: "2" }))),
    },
    {
        id: 3,
        name: translate('baseball.pitches.slider'),
        abbr: translate('baseball.pitches.abbr-slider'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#1f78b4', fill: disabled ? '#747474' : '#1f78b4', strokeWidth: "2" }))),
    },
    {
        id: 3033,
        name: translate('baseball.pitchsubtypes.slider.gyro'),
        abbr: translate('components.hitting-monitor.slider-gyro'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#713f12', fill: disabled ? '#747474' : '#713f12', strokeWidth: "2" }))),
    },
    {
        id: 3034,
        name: translate('baseball.pitchsubtypes.slider.sweeper'),
        abbr: translate('components.hitting-monitor.slider-sweeper'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#06b6d4', fill: disabled ? '#747474' : '#06b6d4', strokeWidth: "2" }))),
    },
    {
        id: 6,
        name: translate('baseball.pitches.knuckleball'),
        abbr: translate('baseball.pitches.abbr-knuckleball'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#fb9a99', fill: disabled ? '#747474' : '#fb9a99', strokeWidth: "2" }))),
    },
    {
        id: 7,
        name: translate('baseball.pitches.splitter'),
        abbr: translate('baseball.pitches.abbr-splitter'),
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#cab2d6', fill: disabled ? '#747474' : '#cab2d6', strokeWidth: "2" }))),
    },
];
const RESULT_TYPES$1 = (translate) => [
    {
        id: 1,
        name: translate ? translate('components.hitmon.resulttype.hard-hit') : 'Hard Hit',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-hard-hit') : 'HH',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : 'transparent', stroke: disabled ? '#747474' : '#0000ff', d: "M 6 1 L 11 6 6 11 1 6 6 1 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    {
        id: 2,
        name: translate ? translate('components.hitmon.resulttype.hard-batted-out') : 'Hard Batted Out',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-hard-batted-out') : 'HBO',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : '#0000ff', stroke: disabled ? '#747474' : '#0000ff', d: "M 6 1 L 11 11 1 11 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    {
        id: 3,
        name: translate ? translate('components.hitmon.resulttype.ball') : 'Ball',
        abbr: translate ? translate('components.hitmon.resulttype.ball') : 'Ball',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#00ff00', fill: disabled ? '#747474' : '#00ff00', strokeWidth: "2" }))),
    },
    {
        id: 4,
        name: translate ? translate('components.hitmon.resulttype.called-strike') : 'Called Strike',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-called-strike') : 'CS',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#ff0000', fill: disabled ? '#747474' : '#ff0000', strokeWidth: "2" }))),
    },
    {
        id: 5,
        name: translate ? translate('components.hitmon.resulttype.swinging-strike') : 'Swinging Strike',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-swinging-strike') : 'SS',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : '#ff0000', stroke: disabled ? '#747474' : '#ff0000', d: "M 6 0 L 12 6 6 12 0 6 6 0 Z", visibility: "inherit", strokeWidth: "0" }))),
    },
    {
        id: 6,
        name: translate ? translate('components.hitmon.resulttype.foul') : 'Foul',
        abbr: translate ? translate('components.hitmon.resulttype.foul') : 'Foul',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : 'transparent', stroke: disabled ? '#747474' : '#ff0000', d: "M 1 1 L 11 1 11 11 1 11 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    {
        id: 7,
        name: translate ? translate('components.hitmon.resulttype.weak-hit') : 'Weak Hit',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-weak-hit') : 'WH',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : 'transparent', stroke: disabled ? '#747474' : '#ffa500', d: "M 6 1 L 11 6 6 11 1 6 6 1 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    {
        id: 8,
        name: translate ? translate('components.hitmon.resulttype.weak-batted-out') : 'Weak Batted Out',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-weak-batted-out') : 'WBO',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : '#ffa500', stroke: disabled ? '#747474' : '#ffa500', d: "M 6 1 L 11 11 1 11 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
];
const PERSPECTIVE_TYPES$1 = {
    hitter: 1,
    pitcher: 2,
};
const ALL_ATTACK_VALUE$1 = -2;
const ALL_2K_VALUE$1 = -3;
const COUNTS$1 = [
    { id: 0, name: '0-0', balls: 0, strikes: 0 },
    { id: 1, name: '1-0', balls: 1, strikes: 0 },
    { id: 2, name: '2-0', balls: 2, strikes: 0 },
    { id: 3, name: '3-0', balls: 3, strikes: 0 },
    { id: 4, name: '0-1', balls: 0, strikes: 1 },
    { id: 5, name: '1-1', balls: 1, strikes: 1 },
    { id: 6, name: '2-1', balls: 2, strikes: 1 },
    { id: 7, name: '3-1', balls: 3, strikes: 1 },
    { id: 8, name: '0-2', balls: 0, strikes: 2 },
    { id: 9, name: '1-2', balls: 1, strikes: 2 },
    { id: 10, name: '2-2', balls: 2, strikes: 2 },
    { id: 11, name: '3-2', balls: 3, strikes: 2 },
];
const PitchFilterValues = {
    getBaseState: (baseState, translate) => {
        switch (baseState) {
            case -1:
                return translate ? translate('common.all') : 'All';
            case 0:
                return translate ? translate('components.hitmon.empty') : 'Empty';
            case 1:
                return translate ? translate('baseball.abbr-runners-in-position') : 'RISP';
            case 2:
                return translate ? translate('baseball.abbr-runners-on') : 'Runners On';
            default:
                return '';
        }
    },
    getBatterHand: (batterHand, translate) => {
        switch (batterHand) {
            case -1:
                return translate ? translate('common.all') : 'All';
            case 1:
                return translate ? translate('baseball.rhh') : 'RHH';
            case 2:
                return translate ? translate('baseball.lhh') : 'LHH';
            default:
                return '';
        }
    },
    getPitcherRole: (pitcherRole, translate) => {
        switch (pitcherRole) {
            case -1:
                return translate ? translate('common.all') : 'All';
            case 1:
                return translate ? translate('baseball.positions.abbr-pitcher-starting') : 'SP';
            case 2:
                return translate ? translate('baseball.positions.abbr-pitcher-relief') : 'RP';
            default:
                return '';
        }
    },
    getPitchCounts: (counts, translate) => {
        if (counts.indexOf(-1) >= 0)
            return translate ? translate('common.all') : 'All';
        if (counts.indexOf(-2) >= 0)
            return translate ? translate('components.hitmon.all-attack') : 'All Attack';
        if (counts.indexOf(-3) >= 0)
            return translate ? translate('components.hitmon.all-2k') : 'All 2K';
        return COUNTS$1.filter((c) => counts.indexOf(c.id) >= 0).map((c) => c.name).join(', ');
    },
    getPitchResults: (results, translate) => {
        if (results.indexOf(-1) >= 0)
            return translate ? translate('common.all') : 'All';
        return RESULT_TYPES$1(translate).filter((c) => results.indexOf(c.id) >= 0).map((c) => c.name).join(', ');
    },
    getPitchZone: (zone, translate) => {
        switch (zone) {
            case -1:
                return translate ? translate('common.all') : 'All';
            case 0:
                return translate ? translate('components.search.filter.in-zone') : 'In Zone';
            case 1:
                return translate ? translate('components.hitmon.out-zone') : 'Out Zone';
            default:
                return '';
        }
    },
};

const PitchLocation = ({ filter, setFilter, perspective }) => {
    const { t: translate } = useTranslation();
    const getPitcherPerspectivePitchLocation = (loc) => (Object.assign(Object.assign({}, loc), { locationx: 6 - loc.locationx }));
    const perspectivePitchLocation = perspective === PERSPECTIVE_TYPES$1.hitter ? filter.pitchLocation
        : filter.pitchLocation.map(getPitcherPerspectivePitchLocation);
    return (React.createElement("div", { className: "d-flex justify-content-center ms-2" },
        React.createElement("div", null,
            React.createElement("div", null, translate('components.hitmon.location')),
            React.createElement(PitchLocation$1, { locations: perspectivePitchLocation, onChange: (e) => setFilter(Object.assign(Object.assign({}, filter), { pitchLocation: perspective === PERSPECTIVE_TYPES$1.hitter ? e : e.map(getPitcherPerspectivePitchLocation) })) }),
            React.createElement("div", { className: "d-flex justify-content-center" },
                React.createElement("img", { src: homeplate, alt: "Home Plate", height: 20, width: 50, style: { marginTop: '10px', transform: perspective === PERSPECTIVE_TYPES$1.hitter ? '' : 'scaleY(-1)' } })))));
};

const StyledToggleButtons$a = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const StyledVerticalToggleButtons = styled(StyledToggleButtons$a) `
    flex-direction: column;

    label {
        margin-top: 4px;
    }
`;
const PitchZone = ({ filter, setFilter }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("div", { style: { marginBottom: '-4px' } }, translate('components.hitmon.zone')),
            React.createElement(StyledVerticalToggleButtons, { type: "radio", "$btnWidth": 80, name: "zone", options: [
                    { name: translate('common.all'), value: ALL_VALUE$1 },
                    { name: translate('components.hitmon.in-zone'), value: IN_ZONE_VALUE },
                    { name: translate('components.hitmon.out-zone'), value: OUT_ZONE_VALUE },
                ], separated: true, value: filter.zoneLocation, onChange: (e) => setFilter(Object.assign(Object.assign({}, filter), { zoneLocation: e })) }))));
};

const StyledToggleButtons$9 = styled(ToggleButtons) `
    display: grid !important;
    grid-template-columns: min-content repeat(${(props) => props.$numCols - 1}, minmax(0, 1fr));
    row-gap: 0.25rem;

    ${(props) => (props.$disabled ? `
        opacity : 0.5;
        pointer-events: none;
    ` : '')}

    .btn {
        width: ${(props) => props.$btnWidth}px;

        ${(props) => (props.$hasAll ? `&:first-of-type {
            display: block;
            width: 40px;
            grid-row: span ${props.$numRows} / span ${props.$numRows};
        }` : '')}
    }
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const StyledToggleButtonsWithAll$1 = styled(StyledToggleButtons$9) `
    display: inline-grid !important;
    grid-template-columns: min-content repeat(${(props) => props.$numCols - 1}, minmax(0, 1fr));
    row-gap: 0.25rem;

    .btn {
        width: ${(props) => props.$btnWidth}px;
&:first-of-type {
            display: block;
            width: 40px;
            grid-row: span ${(props) => props.$numRows} / span ${(props) => props.$numRows};
        }
    }
`;
const PitchTypes = ({ className, filter, setFilter, availablePitchTypes }) => {
    const { t: translate } = useTranslation();
    const setFilterWithAll = (e) => {
        let newVal = [];
        if (!e.length || (e.includes(ALL_VALUE$1) && !filter.pitchTypes.includes(ALL_VALUE$1))) {
            newVal = [ALL_VALUE$1];
        }
        else if ((e.includes(ALL_FB_VALUE) && !filter.pitchTypes.includes(ALL_FB_VALUE))) {
            newVal = [ALL_FB_VALUE];
        }
        else if ((e.includes(ALL_NON_FB_VALUE) && !filter.pitchTypes.includes(ALL_NON_FB_VALUE))) {
            newVal = [ALL_NON_FB_VALUE];
        }
        else {
            newVal = e.filter((x) => x !== ALL_VALUE$1 && x !== ALL_FB_VALUE && x !== ALL_NON_FB_VALUE);
            // eslint-disable-next-line max-len
            if (newVal.includes(3) && !filter.pitchTypes.includes(3)) {
                if (!newVal.includes(3033) && availablePitchTypes.has(3033))
                    newVal.push(3033);
                if (!newVal.includes(3034) && availablePitchTypes.has(3034))
                    newVal.push(3034);
            }
        }
        setFilter(Object.assign(Object.assign({}, filter), { pitchTypes: newVal }));
    };
    const isShowingResults = filter.showing === SHOWING_RESULTS_VALUE$1;
    const isShowingPitchTypesExtended = filter.showing === SHOWING_PITCH_TYPES_EXTENDED_VALUE$1;
    return (React.createElement("div", { className: className },
        React.createElement("div", null, translate('components.hitmon.pitch-types')),
        React.createElement(StyledToggleButtonsWithAll$1, { "$numCols": 6, "$numRows": 2, "$btnWidth": 45, "$disabled": !isShowingResults || isShowingPitchTypesExtended, type: "checkbox", name: "pitchTypes", options: [{ name: translate('common.all'), value: ALL_VALUE$1 }].concat(PITCH_TYPES_HITMON(translate).map((pt) => ({ name: pt.abbr, value: pt.id, disabled: !availablePitchTypes.has(pt.id) }))), separated: true, value: filter.showing === SHOWING_PITCH_TYPES_VALUE$1 || filter.showing === SHOWING_PITCH_TYPES_EXTENDED_VALUE$1
                ? [] : filter.pitchTypes, onChange: (e) => setFilterWithAll(e) }),
        React.createElement(StyledToggleButtons$9, { type: "checkbox", name: "pitchTypes-fb", options: [
                { name: translate('components.hitmon.all-fb'), value: ALL_FB_VALUE },
                { name: translate('components.hitmon.all-non-fb'), value: ALL_NON_FB_VALUE },
            ], separated: true, "$btnWidth": 145, "$numCols": 2, "$numRows": 1, "$disabled": !isShowingResults || isShowingPitchTypesExtended, value: filter.showing === SHOWING_PITCH_TYPES_VALUE$1 || filter.showing === SHOWING_PITCH_TYPES_EXTENDED_VALUE$1
                ? [] : filter.pitchTypes, onChange: (e) => setFilterWithAll(e), className: "mt-1" })));
};

const StyledToggleButtons$8 = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const StyledToggleButtonsWithAll = styled(StyledToggleButtons$8) `
    display: inline-grid !important;
    grid-template-columns: min-content repeat(${(props) => props.$numCols - 1}, minmax(0, 1fr));
    row-gap: 0.25rem;

    .btn {
        width: ${(props) => props.$btnWidth}px;

        &:first-of-type {
            display: block;
            width: 40px;
            grid-row: span ${(props) => props.$numRows} / span ${(props) => props.$numRows};
        }
    }
`;
const PitchResults = ({ filter, setFilter, availableResultTypes }) => {
    const { t: translate } = useTranslation();
    const setFilterWithAll = (key, e) => {
        var _a;
        let newVal = [];
        if (!e.length || (e.includes(ALL_VALUE$1) && !((_a = filter[key]) === null || _a === void 0 ? void 0 : _a.includes(ALL_VALUE$1)))) {
            newVal = [ALL_VALUE$1];
        }
        else {
            newVal = e.filter((x) => x !== ALL_VALUE$1);
        }
        setFilter(Object.assign(Object.assign({}, filter), { [key]: newVal }));
    };
    const isShowingResults = filter.showing === SHOWING_RESULTS_VALUE$1;
    const isShowingPitchTypesExtended = filter.showing === SHOWING_PITCH_TYPES_EXTENDED_VALUE$1;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('components.hitmon.results')),
        React.createElement(StyledToggleButtonsWithAll, { "$numCols": 5, "$numRows": 2, "$btnWidth": 52, "$disabled": isShowingResults || isShowingPitchTypesExtended, type: "checkbox", name: "result", options: [{ name: translate('common.all'), value: ALL_VALUE$1 }].concat(RESULT_TYPES$1(translate).map((rt) => ({ name: rt.abbr, value: rt.id, disabled: !availableResultTypes.has(rt.id) }))), separated: true, value: filter.showing === SHOWING_RESULTS_VALUE$1 || filter.showing === SHOWING_PITCH_TYPES_EXTENDED_VALUE$1
                ? [] : filter.result, onChange: (e) => setFilterWithAll('result', e) })));
};

const StyledCountSelect = styled(CountSelect) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
`;
const PitchCounts = ({ filter, setFilter }) => {
    const { t: translate } = useTranslation();
    const isShowingPitchTypesExtended = filter.showing === SHOWING_PITCH_TYPES_EXTENDED_VALUE$1;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('baseball.count')),
        React.createElement(StyledCountSelect, { "$disabled": isShowingPitchTypesExtended, counts: isShowingPitchTypesExtended ? [] : filter.counts, setCounts: (newVal) => setFilter(Object.assign(Object.assign({}, filter), { counts: newVal })) })));
};

const StyledToggleButtons$7 = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const BaseState = ({ filter, setFilter }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('components.hitmon.base-state')),
        React.createElement(StyledToggleButtons$7, { type: "radio", name: "baseState", options: [
                { name: translate('common.all'), value: ALL_VALUE$1 },
                { name: translate('components.hitmon.empty'), value: 0 },
                { name: translate('baseball.abbr-runners-in-position'), value: 1 },
                { name: translate('baseball.abbr-runners-on'), value: 2 },
            ], separated: true, value: filter.baseState, onChange: (e) => setFilter(Object.assign(Object.assign({}, filter), { baseState: e })) })));
};

const StyledToggleButtons$6 = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const PitcherHand = ({ filter, setFilter, isSwitch }) => {
    const { t: translate } = useTranslation();
    const setPitcherHand = (e) => {
        if (isSwitch && e !== ALL_VALUE$1) {
            setFilter(Object.assign(Object.assign({}, filter), { pitcherHand: e, batterHand: 3 - e }));
        }
        else {
            setFilter(Object.assign(Object.assign({}, filter), { pitcherHand: e }));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null, translate('components.hitmon.pitcher-hand')),
        React.createElement(StyledToggleButtons$6, { type: "radio", name: "pitcherHand", options: [
                { name: translate('common.all'), value: ALL_VALUE$1 },
                { name: translate('baseball.lhp'), value: 2 },
                { name: translate('baseball.rhp'), value: 1 },
            ], separated: true, value: filter.pitcherHand, onChange: setPitcherHand })));
};

const StyledToggleButtons$5 = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const BatterHand = ({ filter, setFilter, isPitching }) => {
    const { t: translate } = useTranslation();
    const optionArray = [];
    if (isPitching === true)
        optionArray.push({ name: translate('common.all'), value: -1 });
    optionArray.push({ name: translate('baseball.lhh'), value: 2 });
    optionArray.push({ name: translate('baseball.rhh'), value: 1 });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('components.hitmon.batter-hand')),
        React.createElement(StyledToggleButtons$5, { type: "radio", name: "batterHand", options: optionArray, separated: true, value: filter.batterHand, onChange: (e) => setFilter(Object.assign(Object.assign({}, filter), { batterHand: e })) })));
};

const StyledToggleButtons$4 = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const Showing = ({ filter, setFilter }) => {
    const { t: translate } = useTranslation();
    const setShowing = (e) => {
        setFilter(Object.assign(Object.assign({}, filter), { result: e === SHOWING_RESULTS_VALUE$1 ? RESULT_TYPES$1(translate).map((r) => r.id) : [ALL_VALUE$1], pitchTypes: e === SHOWING_PITCH_TYPES_VALUE$1 || e === SHOWING_PITCH_TYPES_EXTENDED_VALUE$1
                ? PITCH_TYPES_HITMON(translate).map((pt) => pt.id) : [ALL_VALUE$1], counts: e === SHOWING_PITCH_TYPES_EXTENDED_VALUE$1 ? [ALL_VALUE$1] : filter.counts, showing: e }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null, translate('components.hitmon.showing')),
        React.createElement(StyledToggleButtons$4, { type: "radio", name: "showing", options: [
                { name: translate('components.hitmon.results'), value: SHOWING_RESULTS_VALUE$1 },
                { name: translate('components.hitmon.pitch-types'), value: SHOWING_PITCH_TYPES_VALUE$1 },
                { name: translate('components.hitmon.pitch-types-extended'), value: SHOWING_PITCH_TYPES_EXTENDED_VALUE$1 },
            ], separated: true, value: filter.showing, onChange: setShowing })));
};

var InputField = ({ className, label, children }) => (React.createElement("div", { className: `${className} d-flex align-items-center` },
    React.createElement("span", { className: "me-1 text-end", style: { minWidth: 45 } }, label),
    children));

const StyledToggleButtons$3 = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const Park = ({ filter, setFilter, parks }) => {
    var _a, _b;
    const { t: translate } = useTranslation();
    const optionArray = [
        { name: translate('common.all'), value: -1 },
        { name: translate('baseball.home'), value: HOME_VALUE },
        { name: translate('baseball.away'), value: AWAY_VALUE },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('components.hitmon.park')),
        React.createElement(StyledToggleButtons$3, { type: "radio", name: "park", options: optionArray, separated: true, value: filter.park, onChange: (e) => setFilter(Object.assign(Object.assign({}, filter), { park: e })) }),
        parks && (React.createElement(Form$1.Select, { value: (_b = (_a = filter.park) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '', onChange: (e) => setFilter(Object.assign(Object.assign({}, filter), { park: +e.target.value || ALL_VALUE$1 })), className: "mt-2", size: "sm" },
            React.createElement("option", null, translate('components.hitmon.select-park')),
            parks.map((p) => React.createElement("option", { key: p.venueid, value: p.venueid }, p.venuename))))));
};

const StyledTextControl = styled(Form$1.Control) `
    max-width: 80px;

    @media (min-width: 1367px) {
        max-width: 60px;
        &.form-control {
            padding: 0 0.25rem !important;
            min-height: unset !important;
        }
    }
`;
const StyledFilterWrapper$1 = styled.div `
    max-width: 1500px;
    margin: 0 auto;
`;
const HittingMonitorFilter = ({ filter, setFilter, isSwitch, availablePitchTypes, availableResultTypes, perspective, hideBatterHand, hidePitcherHand, hideLastPAs, maxPAs, parks, }) => {
    const { t: translate } = useTranslation();
    const [isOpen, setIsOpen] = useState(true);
    const STEP_LAST_PAS = 50;
    const isNumber = (x) => /^-?\d*\.?\d*$/.test(x);
    const updateFilter = (key, value) => {
        setFilter(Object.assign(Object.assign({}, filter), { [key]: value }));
    };
    const onLastPaChange = (x) => {
        if (isNumber(x)) {
            const rounded = Math.round(x);
            if (maxPAs && rounded > maxPAs) {
                updateFilter('lastPAs', maxPAs);
            }
            else {
                updateFilter('lastPAs', rounded);
            }
        }
    };
    const handleNumInput = (e, key) => {
        const { value } = e.currentTarget;
        if (!isNumber(value)) {
            e.preventDefault();
        }
        else {
            updateFilter(key, value);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "border rounded py-2 px-3" },
            React.createElement("div", { className: "d-flex justify-content-end" },
                React.createElement(Button, { variant: "primary", onClick: () => setIsOpen(!isOpen) },
                    isOpen ? translate('common.hide') : translate('common.show'),
                    " ",
                    translate('components.hitmon.all-filters'))),
            isOpen && (React.createElement(StyledFilterWrapper$1, { className: "mt-1" },
                React.createElement("div", { className: "d-flex flex-wrap justify-content-between" },
                    React.createElement("div", { className: "mx-2 mb-3" },
                        React.createElement(Showing, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand }),
                        React.createElement(BaseState, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand }),
                        React.createElement(PitchCounts, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                    React.createElement("div", { className: "mx-2 mb-3" },
                        React.createElement(PitchResults, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand }),
                        React.createElement(PitchTypes, { className: "mt-4", filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                    React.createElement("div", { className: "mx-2 mb-3" },
                        !hidePitcherHand
                            && (React.createElement(PitcherHand, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                        isSwitch && !hideBatterHand && (React.createElement(BatterHand, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                        React.createElement(Park, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand, parks: parks })),
                    React.createElement("div", { className: "mx-2 mb-3 d-flex" },
                        React.createElement("div", null,
                            React.createElement(PitchZone, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                        React.createElement("div", { className: "d-flex justify-content-center ms-2" },
                            React.createElement("div", null,
                                React.createElement(PitchLocation, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand }))))),
                React.createElement("div", { className: "d-flex flex-wrap align-items-center justify-content-around mt-4" },
                    React.createElement(InputField, { label: `${translate('components.hitmon.abbr-velocity')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minVelo, onChange: (e) => handleNumInput(e, 'minVelo') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxVelo, onChange: (e) => handleNumInput(e, 'maxVelo') })),
                    React.createElement(InputField, { label: `${translate('components.hitmon.abbr-launch-angle')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minLa, onChange: (e) => handleNumInput(e, 'minLa') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxLa, onChange: (e) => handleNumInput(e, 'maxLa') })),
                    React.createElement(InputField, { label: `${translate('components.hitmon.abbr-exit-velo')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minEv, onChange: (e) => handleNumInput(e, 'minEv') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxEv, onChange: (e) => handleNumInput(e, 'maxEv') })),
                    React.createElement(InputField, { label: `${translate('components.hitmon.horiz-pull-angle')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minHorizLa, onChange: (e) => handleNumInput(e, 'minHorizLa') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxHorizLa, onChange: (e) => handleNumInput(e, 'maxHorizLa') })),
                    React.createElement(InputField, { label: `${translate('baseball.break-x')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minBreakX, onChange: (e) => handleNumInput(e, 'minBreakX') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxBreakX, onChange: (e) => handleNumInput(e, 'maxBreakX') })),
                    React.createElement(InputField, { label: `${translate('baseball.break-z')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minBreakZ, onChange: (e) => handleNumInput(e, 'minBreakZ') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxBreakZ, onChange: (e) => handleNumInput(e, 'maxBreakZ') })),
                    React.createElement(InputField, { label: `${translate('components.hitmon.abbr-release-x')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minRelX, onChange: (e) => handleNumInput(e, 'minRelX') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxRelX, onChange: (e) => handleNumInput(e, 'maxRelX') })),
                    React.createElement(InputField, { label: `${translate('components.hitmon.abbr-release-z')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minRelZ, onChange: (e) => handleNumInput(e, 'minRelZ') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxRelZ, onChange: (e) => handleNumInput(e, 'maxRelZ') })),
                    React.createElement(InputField, { label: `${translate('components.hitmon.arm-angle')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minArmAngle, onChange: (e) => handleNumInput(e, 'minArmAngle') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxArmAngle, onChange: (e) => handleNumInput(e, 'maxArmAngle') })),
                    React.createElement(InputField, { label: `${translate('components.hitmon.gyro-degree')}:`, className: "mb-2 mx-2" },
                        React.createElement(StyledTextControl, { value: filter.minGyroDegree, onChange: (e) => handleNumInput(e, 'minGyroDegree') }),
                        React.createElement("span", { className: "mx-2" }, translate('common.to')),
                        React.createElement(StyledTextControl, { value: filter.maxGyroDegree, onChange: (e) => handleNumInput(e, 'maxGyroDegree') }))),
                !hideLastPAs && (React.createElement("div", { className: "d-flex flex-wrap justify-content-between" },
                    React.createElement("div", { className: "mx-2 mb-3", style: { width: '325px' } },
                        React.createElement("span", { className: "mb-2" },
                            `${translate('components.search.last-x-pas')}`,
                            React.createElement(Slider, { min: STEP_LAST_PAS, max: maxPAs || (2 * STEP_LAST_PAS), inputDirection: "right", step: STEP_LAST_PAS, value: filter.lastPAs, margin: 0, onChange: onLastPaChange, start: filter.lastPAs || STEP_LAST_PAS })))))))),
        React.createElement(LiveFilterPills, { className: "mt-3", filter: filter.showing === SHOWING_RESULTS_VALUE$1 ? filter.result : filter.pitchTypes, options: filter.showing === SHOWING_RESULTS_VALUE$1
                ? RESULT_TYPES$1(translate).filter((rt) => availableResultTypes.has(rt.id))
                : PITCH_TYPES_HITMON(translate).filter((pt) => availablePitchTypes.has(pt.id)), setFilter: (e) => setFilter(Object.assign(Object.assign({}, filter), { [filter.showing === SHOWING_RESULTS_VALUE$1 ? 'result' : 'pitchTypes']: e })) })));
};

const ALL_VALUE = -1;
const SHOWING_RESULTS_VALUE = 0;
const SHOWING_PITCH_TYPES_VALUE = 1;
const SHOWING_PITCH_TYPES_EXTENDED_VALUE = 2;
const RESULT_TYPES = (translate) => [
    {
        id: 1,
        name: translate ? translate('components.hitmon.resulttype.hard-hit') : 'Hard Hit',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-hard-hit') : 'HH',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : 'transparent', stroke: disabled ? '#747474' : '#0000ff', d: "M 6 1 L 11 6 6 11 1 6 6 1 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    {
        id: 2,
        name: translate ? translate('components.hitmon.resulttype.hard-batted-out') : 'Hard Batted Out',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-hard-batted-out') : 'HBO',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : '#0000ff', stroke: disabled ? '#747474' : '#0000ff', d: "M 6 1 L 11 11 1 11 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    {
        id: 3,
        name: translate ? translate('components.hitmon.resulttype.ball') : 'Ball',
        abbr: translate ? translate('components.hitmon.resulttype.ball') : 'Ball',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#00ff00', fill: disabled ? '#747474' : '#00ff00', strokeWidth: "2" }))),
    },
    {
        id: 4,
        name: translate ? translate('components.hitmon.resulttype.called-strike') : 'Called Strike',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-called-strike') : 'CS',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("circle", { cx: "6", cy: "6", r: "5", stroke: disabled ? '#747474' : '#ff0000', fill: disabled ? '#747474' : '#ff0000', strokeWidth: "2" }))),
    },
    {
        id: 5,
        name: translate ? translate('components.hitmon.resulttype.swinging-strike') : 'Swinging Strike',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-swinging-strike') : 'SS',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : '#ff0000', stroke: disabled ? '#747474' : '#ff0000', d: "M 6 0 L 12 6 6 12 0 6 6 0 Z", visibility: "inherit", strokeWidth: "0" }))),
    },
    {
        id: 6,
        name: translate ? translate('components.hitmon.resulttype.foul') : 'Foul',
        abbr: translate ? translate('components.hitmon.resulttype.foul') : 'Foul',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : 'transparent', stroke: disabled ? '#747474' : '#ff0000', d: "M 1 1 L 11 1 11 11 1 11 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    {
        id: 7,
        name: translate ? translate('components.hitmon.resulttype.weak-hit') : 'Weak Hit',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-weak-hit') : 'WH',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : 'transparent', stroke: disabled ? '#747474' : '#ffa500', d: "M 6 1 L 11 6 6 11 1 6 6 1 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
    {
        id: 8,
        name: translate ? translate('components.hitmon.resulttype.weak-batted-out') : 'Weak Batted Out',
        abbr: translate ? translate('components.hitmon.resulttype.abbr-weak-batted-out') : 'WBO',
        svg: ({ disabled }) => (React.createElement("svg", { width: "12", height: "12" },
            React.createElement("path", { fill: disabled ? '#747474' : '#ffa500', stroke: disabled ? '#747474' : '#ffa500', d: "M 6 1 L 11 11 1 11 Z", visibility: "inherit", strokeWidth: "2" }))),
    },
];
const PERSPECTIVE_TYPES = {
    hitter: 1,
    pitcher: 2,
};
const ALL_ATTACK_VALUE = -2;
const ALL_2K_VALUE = -3;
const COUNTS = [
    { id: 0, name: '0-0', balls: 0, strikes: 0 },
    { id: 1, name: '1-0', balls: 1, strikes: 0 },
    { id: 2, name: '2-0', balls: 2, strikes: 0 },
    { id: 3, name: '3-0', balls: 3, strikes: 0 },
    { id: 4, name: '0-1', balls: 0, strikes: 1 },
    { id: 5, name: '1-1', balls: 1, strikes: 1 },
    { id: 6, name: '2-1', balls: 2, strikes: 1 },
    { id: 7, name: '3-1', balls: 3, strikes: 1 },
    { id: 8, name: '0-2', balls: 0, strikes: 2 },
    { id: 9, name: '1-2', balls: 1, strikes: 2 },
    { id: 10, name: '2-2', balls: 2, strikes: 2 },
    { id: 11, name: '3-2', balls: 3, strikes: 2 },
];

const getResultTooltip$1 = (title, p, translate, showBatTracking = false) => {
    var _a, _b, _c, _d, _e, _f;
    return `
    <b>${title}</b><br />\
    ${translate('common.date')}: ${internationalizeDate(translate, p.gamedate)}<br/>\
    ${p.pitcher_lastname && p.pitcher_usesname ? `${translate('baseball.pitcher_one')}:\
         ${p.pitcher_usesname} ${p.pitcher_lastname} (${p.islhp ? 'L' : 'R'})` : ''}<br />\
    ${p.istop ? translate('baseball.abbr-top') : translate('baseball.abbr-bottom')} ${p.inning} |\
        ${translate('baseball.outs', { count: p.outs })}: ${p.outs} | ${translate('baseball.abbr-count')}: ${p.balls}-${p.strikes}<br />\
    ${p.pitchtype ? `${translate('components.hitmon.pitch-type')}: ${pitchTypeDisplayName(p, false, false, translate)}<br />` : ''}\
    ${p.velocity ? `${translate('components.hitmon.pitch-velo')}: ${format(p.velocity, 1)} mph<br />` : ''}\
    ${p.expstk_all ? `${translate('components.hitmon.abbr-strike-prob')}: ${percent(p.expstk_all, 1)}<br />` : ''}\
    ${p.bip ? `${translate('components.hitmon.abbr-exit-velo')}: 
        ${p.exitvelo ? translate('format.abbr-mph', { value: format(p.exitvelo, 1) }) : '--'}<br />` : ''}\
    ${p.launchangle ? `${translate('components.hitmon.abbr-launch-angle')}: ${format(p.launchangle, 1)}°<br />` : ''}\
    ${showBatTracking
        ? `${translate('components.charts.heading')}: ${(_b = (_a = p.heading) === null || _a === void 0 ? void 0 : _a.toFixed(1)) !== null && _b !== void 0 ? _b : '-'}<br />\
            ${translate('components.pitcher-trends.vbat')}: ${(_d = (_c = p.vbat) === null || _c === void 0 ? void 0 : _c.toFixed(1)) !== null && _d !== void 0 ? _d : '-'}<br />\
            ${translate('components.pitcher-trends.hbat')}: ${(_f = (_e = p.hbat) === null || _e === void 0 ? void 0 : _e.toFixed(1)) !== null && _f !== void 0 ? _f : '-'}`
        : ''}
`;
};
const getPitchTypeTooltip$1 = (title, p, translate, showBatTracking = false) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return `
    <b>${title}</b><br />\
    ${translate('common.date')}: ${internationalizeDate(translate, p.gamedate)}<br/>\
    ${p.pitcher_lastname && p.pitcher_usesname ? `${translate('baseball.pitcher_one')}:\
         ${p.pitcher_usesname} ${p.pitcher_lastname} (${p.islhp ? 'L' : 'R'})` : ''}<br />\
    ${p.istop ? translate('baseball.abbr-top') : translate('baseball.abbr-bottom')} ${p.inning} |\
        ${translate('baseball.outs', { count: p.outs })}: ${p.outs} | ${translate('baseball.abbr-count')}: ${p.balls}-${p.strikes}<br />\
    ${p.hitmonresulttype ? `${translate('sections.reports.pitcher.result')}: ${(_a = RESULT_TYPES(translate).find((rt) => rt.id === p.hitmonresulttype)) === null || _a === void 0 ? void 0 : _a.name}<br />` : ''}\
    ${p.velocity ? `${translate('components.hitmon.pitch-velo')}: ${format(p.velocity, 1)} mph<br />` : ''}\
    ${p.expstk_all ? `${translate('components.hitmon.abbr-strike-prob')}: ${percent(p.expstk_all, 1)}<br />` : ''}\
    ${p.bip ? `${translate('components.hitmon.abbr-exit-velo')}:
        ${p.exitvelo ? translate('format.abbr-mph', { value: format(p.exitvelo, 1) }) : '--'}<br />` : ''}\
    ${p.launchangle ? `${translate('components.hitmon.abbr-launch-angle')}: ${format(p.launchangle, 1)}°<br />` : ''}\
    ${showBatTracking
        ? `${translate('components.charts.heading')}: ${(_c = (_b = p.heading) === null || _b === void 0 ? void 0 : _b.toFixed(1)) !== null && _c !== void 0 ? _c : '-'}<br />\
            ${translate('components.pitcher-trends.vbat')}: ${(_e = (_d = p.vbat) === null || _d === void 0 ? void 0 : _d.toFixed(1)) !== null && _e !== void 0 ? _e : '-'}<br />\
            ${translate('components.pitcher-trends.hbat')}: ${(_g = (_f = p.hbat) === null || _f === void 0 ? void 0 : _f.toFixed(1)) !== null && _g !== void 0 ? _g : '-'}`
        : ''}
`;
};

const buildResultSeries$6 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.platex, y: d.platez, id: `strike_zone_${d.id}` }))) })));
const buildPitchTypesSeries$4 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.platex, y: d.platez, id: `strike_zone_${d.id}` }))) })));
const StrikeZone$1 = forwardRef(({ batterHand, showing, pitches, resultSeries, pitchTypeSeries, perspective, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, tooltipFormatter, }, ref) => {
    const { t: translate } = useTranslation();
    const innerResultSeries = useMemo(() => buildResultSeries$6(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildPitchTypesSeries$4(pitchTypeSeries), [pitchTypeSeries]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        return (showing === SHOWING_RESULTS_VALUE ? getResultTooltip$1(series.name, pitch, translate) : getPitchTypeTooltip$1(series.name, pitch, translate));
    };
    return (React.createElement(StrikeZone$3, { seriesData: showing === SHOWING_RESULTS_VALUE ? innerResultSeries : innerPitchTypeSeries, pitcherView: perspective === PERSPECTIVE_TYPES.pitcher, showlhb: batterHand === 2, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, hideAxis: true, hideGrid: true, ref: ref }));
});

const buildResultSeries$5 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.ballinplayx, y: d.ballinplayy, id: `spray_chart_${d.id}`, visible: !!(d.ballinplayx && d.ballinplayy && d.islastpitch) }))) })));
const buildPitchTypesSeries$3 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.ballinplayx, y: d.ballinplayy, id: `spray_chart_${d.id}`, visible: !!(d.ballinplayx && d.ballinplayy && d.islastpitch) }))) })));
const SprayChart$1 = forwardRef(({ showing, pitches, resultSeries, pitchTypeSeries, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, sizeMultiplier = 1, tooltipFormatter, }, ref) => {
    const { t: translate } = useTranslation();
    const innerResultSeries = useMemo(() => buildResultSeries$5(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildPitchTypesSeries$3(pitchTypeSeries), [pitchTypeSeries]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        return (showing === SHOWING_RESULTS_VALUE ? getResultTooltip$1(series.name, pitch, translate) : getPitchTypeTooltip$1(series.name, pitch, translate));
    };
    return (React.createElement("div", { className: "d-flex justify-content-center" },
        React.createElement(SprayChart$3, { type: "outfield", seriesData: showing === SHOWING_RESULTS_VALUE ? innerResultSeries : innerPitchTypeSeries, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, enableZoom: true, sizeMultiplier: sizeMultiplier, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, ref: ref })));
});

const buildResultSeries$4 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { id: `ev_la_chart_${d.id}`, visible: !!(d.exitvelo && d.launchangle) }))) })));
const buildPitchTypesSeries$2 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { id: `ev_la_chart_${d.id}`, visible: !!(d.exitvelo && d.launchangle) }))) })));
const EvLaChart = forwardRef(({ showing, pitches, resultSeries, pitchTypeSeries, backgroundType, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, size = 'lg', evLaForceBackground = undefined, tooltipFormatter, }, ref) => {
    const { t: translate } = useTranslation();
    const innerResultSeries = useMemo(() => buildResultSeries$4(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildPitchTypesSeries$2(pitchTypeSeries), [pitchTypeSeries]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        return (showing === SHOWING_RESULTS_VALUE ? getResultTooltip$1(series.name, pitch, translate) : getPitchTypeTooltip$1(series.name, pitch, translate));
    };
    return (React.createElement("div", { className: "d-flex justify-content-center" },
        React.createElement(EvLaChart$1, { seriesData: showing === SHOWING_RESULTS_VALUE ? innerResultSeries : innerPitchTypeSeries, backgroundType: backgroundType, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, size: size, ref: ref, evLaForceBackground: evLaForceBackground, tooltipFormatter: tooltipFormatter || innerTooltipFormatter })));
});

const buildSeries$6 = (series, orderedPitchTypes) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.heading, y: orderedPitchTypes.findIndex((p) => p === (d.fxsubtype || d.pitchtype)), id: `heading_chart_${d.id}` }))) })));
const pitchOrders$1 = [10, 9, 8, 33, 3, 34, 4, 7, 2];
const getPitchOrderValue$1 = (pt) => {
    const index = pitchOrders$1.indexOf(pt);
    return index > -1 ? index : 100 + pt;
};
const HeadingChart$1 = forwardRef(({ pitches, showing, resultSeries, pitchTypeSeries, tooltipFormatter, availablePitchTypes, pitchVideoFn, multiVideoFn, }, ref) => {
    const { t: translate } = useTranslation();
    const orderedPitchTypes = useMemo(() => [...availablePitchTypes].sort((a, b) => getPitchOrderValue$1(+b) - getPitchOrderValue$1(+a)), [availablePitchTypes]);
    const innerResultSeries = useMemo(() => buildSeries$6(resultSeries, orderedPitchTypes), [resultSeries, orderedPitchTypes]);
    const innerPitchTypeSeries = useMemo(() => buildSeries$6(pitchTypeSeries, orderedPitchTypes), [pitchTypeSeries, orderedPitchTypes]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        return (showing === SHOWING_RESULTS_VALUE$1
            ? getResultTooltip$1(series.name, pitch, translate, true)
            : getPitchTypeTooltip$1(series.name, pitch, translate, true));
    };
    return (React.createElement("div", { className: "flex-shrink-0" },
        React.createElement(HeadingChart$2, { seriesData: showing === SHOWING_RESULTS_VALUE$1 ? innerResultSeries : innerPitchTypeSeries, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, orderedPitchTypes: orderedPitchTypes, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: ref })));
});

const buildSeries$5 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.hbat, y: d.vbat, id: `bat_impact_chart_${d.id}` }))) })));
const BatImpactChart$1 = forwardRef(({ batterHand, showing, resultSeries, pitchTypeSeries, tooltipFormatter, pitchVideoFn, multiVideoFn, pitches, }, ref) => {
    const { t: translate } = useTranslation();
    const innerResultSeries = useMemo(() => buildSeries$5(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildSeries$5(pitchTypeSeries), [pitchTypeSeries]);
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        return (showing === SHOWING_RESULTS_VALUE$1
            ? getResultTooltip$1(series.name, pitch, translate, true)
            : getPitchTypeTooltip$1(series.name, pitch, translate, true));
    };
    return (React.createElement(BatImpactChart$2, { className: "flex-shrink-0", isLhb: batterHand === 2, seriesData: showing === SHOWING_RESULTS_VALUE$1 ? innerResultSeries : innerPitchTypeSeries, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: ref }));
});

const buildResultsSeries$1 = (translate, pitches, perspective, mouseOver, mouseOut) => {
    const series = [
        {
            hitmonResultType: 1,
            color: '#0000ff',
            marker: { symbol: 'diamond', radius: 4, lineColor: '#0000ff', fillColor: '#ffffff', lineWidth: 2, states: { hover: { radiusPlus: 10 } } },
        },
        {
            hitmonResultType: 2,
            color: '#0000ff',
            marker: { symbol: 'triangle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
        },
        {
            hitmonResultType: 3,
            color: '#00ff00',
            marker: { symbol: 'circle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
        },
        {
            hitmonResultType: 4,
            color: '#ff0000',
            marker: { symbol: 'circle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
        },
        {
            hitmonResultType: 5,
            color: '#ff0000',
            marker: { symbol: 'diamond', radius: 6, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
        },
        {
            hitmonResultType: 6,
            color: '#ff0000',
            marker: { symbol: 'square', radius: 4, lineColor: '#ff0000', fillColor: '#ffffff', lineWidth: 2, states: { hover: { radiusPlus: 10 } } },
        },
        {
            hitmonResultType: 7,
            color: '#ffa500',
            marker: { symbol: 'diamond', radius: 4, lineColor: '#ffa500', fillColor: '#ffffff', lineWidth: 2, states: { hover: { radiusPlus: 10 } } },
        },
        {
            hitmonResultType: 8,
            color: '#ffa500',
            marker: { symbol: 'triangle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
        },
    ];
    return series.filter((s) => RESULT_TYPES(translate).some((rt) => rt.id === s.hitmonResultType)).map((s) => {
        var _a, _b;
        const hitmonResultType = RESULT_TYPES(translate).find((rt) => rt.id === s.hitmonResultType);
        return Object.assign(Object.assign({}, s), { id: (_a = hitmonResultType === null || hitmonResultType === void 0 ? void 0 : hitmonResultType.name) !== null && _a !== void 0 ? _a : '', name: (_b = hitmonResultType === null || hitmonResultType === void 0 ? void 0 : hitmonResultType.name) !== null && _b !== void 0 ? _b : '', data: pitches.filter((p) => p.hitmonresulttype === s.hitmonResultType).map((p) => ({
                platex: p.platex,
                platez: p.platez,
                bip: p.bip,
                ballinplayx: p.ballinplayx,
                ballinplayy: p.ballinplayy,
                islastpitch: p.islastpitch,
                exitvelo: p.exitvelo,
                launchangle: p.launchangle,
                gameid: p.gameid,
                eventseq: p.eventseq,
                pitchseq: p.pitchseq,
                heading: p.heading,
                pitchtype: p.pitchtype,
                fxsubtype: p.fxsubtype,
                hbat: p.hbat,
                vbat: p.vbat,
                id: `${p.id}-${perspective === PERSPECTIVE_TYPES.hitter ? 'hitter' : 'pitcher'}`,
            })), point: {
                events: {
                    mouseOver,
                    mouseOut,
                },
            } });
    });
};
const buildPitchTypesSeries$1 = (translate, availablePitchTypes, pitches, perspective, mouseOver, mouseOut) => availablePitchTypes.filter((type) => PITCH_TYPES_HITMON(translate).some((pt) => pt.id === type)).map((type, index) => {
    var _a, _b;
    const pitchType = PITCH_TYPES_HITMON(translate).find((pt) => pt.id === type);
    const color = pitchSubTypeColor({ type: type > 1000 ? Math.floor(type / 1000) : type, fxsubtype: type > 1000 ? type % 1000 : null });
    const data = pitches.filter((p) => (p.fxsubtype || p.pitchtype) === type % 1000).map((p) => {
        var _a;
        return ({
            platex: p.platex,
            platez: p.platez,
            bip: p.bip,
            ballinplayx: p.ballinplayx,
            ballinplayy: p.ballinplayy,
            islastpitch: p.islastpitch,
            exitvelo: p.exitvelo,
            launchangle: p.launchangle,
            gameid: p.gameid,
            eventseq: p.eventseq,
            pitchseq: p.pitchseq,
            heading: p.heading,
            pitchtype: p.pitchtype,
            fxsubtype: (_a = p.fxsubtype) !== null && _a !== void 0 ? _a : 0,
            hbat: p.hbat,
            vbat: p.vbat,
            id: `${p.id}-${perspective === PERSPECTIVE_TYPES.hitter ? 'hitter' : 'pitcher'}`,
        });
    });
    return {
        index,
        data,
        name: (_a = pitchType === null || pitchType === void 0 ? void 0 : pitchType.name) !== null && _a !== void 0 ? _a : '',
        id: (_b = pitchType === null || pitchType === void 0 ? void 0 : pitchType.name) !== null && _b !== void 0 ? _b : '',
        color,
        marker: { symbol: 'circle', radius: 4, lineWidth: 1, lineColor: '#fff', states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
        point: {
            events: {
                mouseOver,
                mouseOut,
            },
        },
    };
});
const perspectiveOptions = (translate) => [
    { name: translate('components.hitmon.hitters-perspective'), value: PERSPECTIVE_TYPES.hitter },
    { name: translate('components.hitmon.pitchers-perspective'), value: PERSPECTIVE_TYPES.pitcher },
];
const evLaBackgroundTypeOptions = (translate) => [
    { name: translate('components.hitmon.hitfx'), value: EV_LA_CHART_BACKGROUND_TYPE.hitFx },
    { name: translate('components.hitmon.actual'), value: EV_LA_CHART_BACKGROUND_TYPE.actual },
    { name: `${translate('components.hitmon.abbr-difference')}(${translate('components.hitmon.actual')} - ${translate('components.hitmon.hitfx')})`, value: EV_LA_CHART_BACKGROUND_TYPE.diff },
];
const StyledToggleButtons$2 = styled(ToggleButtons) `
    label.btn {
        background-color: transparent !important;
        color: #254c75 !important;
        font-size: 11px !important;
        border: 1px solid #254c75 !important;
        padding: 0.2rem 0.5rem;
    }
    label:first-of-type {
        border-top-left-radius: 4px !important;
        border-bottom-left-radius: 4px !important;
    }
    .btn-check:checked + .btn {
        background-color: #254c75 !important;
        color: white !important;
    }
`;
const AllCharts$1 = ({ isLoading, batterHand, showing, pitches, perspective, setPerspective, pitchVideoFn, multiVideoFn, videoPlayerModal: VideoPlayerModal, modalContainer, evLaChartSize = 'lg', sprayChartSizeMultipler = 1, hidePerspectiveToggle = false, hideStrikeZone = false, hideSprayChart = false, hideEvLaChart = false, evLaForceBackground = undefined, tooltipFormatter, showBatTrackingCharts = false, availablePitchTypes, }) => {
    const { t: translate } = useTranslation();
    const sprayChartRef = useRef(null);
    const strikeZoneRef = useRef(null);
    const evLaChartRef = useRef(null);
    const headingChartRef = useRef(null);
    const lhhBatImpactChartRef = useRef(null);
    const rhhBatImpactChartRef = useRef(null);
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const mouseOver = function mouseOver() {
        var _a, _b, _c, _d, _e, _f;
        const seriesIndex = this.series.index;
        const dataIndex = this.index;
        (_a = strikeZoneRef.current) === null || _a === void 0 ? void 0 : _a.hoverPoint(seriesIndex, dataIndex);
        if (this.bip) {
            (_b = sprayChartRef.current) === null || _b === void 0 ? void 0 : _b.hoverPoint(seriesIndex, dataIndex);
        }
        if (this.exitvelo && this.launchangle) {
            (_c = evLaChartRef.current) === null || _c === void 0 ? void 0 : _c.hoverPoint(seriesIndex, dataIndex);
        }
        if (this.heading) {
            (_d = headingChartRef.current) === null || _d === void 0 ? void 0 : _d.hoverPoint(seriesIndex, dataIndex);
        }
        if (this.vbat && this.hbat) {
            (_e = lhhBatImpactChartRef.current) === null || _e === void 0 ? void 0 : _e.hoverPoint(seriesIndex, dataIndex);
            (_f = rhhBatImpactChartRef.current) === null || _f === void 0 ? void 0 : _f.hoverPoint(seriesIndex, dataIndex);
        }
    };
    const mouseOut = function mouseOut() {
        var _a, _b, _c, _d, _e, _f;
        const seriesIndex = this.series.index;
        const dataIndex = this.index;
        (_a = strikeZoneRef.current) === null || _a === void 0 ? void 0 : _a.resetHoverPoint(seriesIndex, dataIndex);
        if (this.bip) {
            (_b = sprayChartRef.current) === null || _b === void 0 ? void 0 : _b.resetHoverPoint(seriesIndex, dataIndex);
        }
        if (this.exitvelo && this.launchangle) {
            (_c = evLaChartRef.current) === null || _c === void 0 ? void 0 : _c.resetHoverPoint(seriesIndex, dataIndex);
        }
        if (this.heading) {
            (_d = headingChartRef.current) === null || _d === void 0 ? void 0 : _d.resetHoverPoint(seriesIndex, dataIndex);
        }
        if (this.vbat && this.hbat) {
            (_e = lhhBatImpactChartRef.current) === null || _e === void 0 ? void 0 : _e.resetHoverPoint(seriesIndex, dataIndex);
            (_f = rhhBatImpactChartRef.current) === null || _f === void 0 ? void 0 : _f.resetHoverPoint(seriesIndex, dataIndex);
        }
    };
    const resultSeries = useMemo(() => buildResultsSeries$1(translate, pitches, perspective, mouseOver, mouseOut), [translate, pitches, perspective]);
    const pitchTypeSeries = useMemo(() => buildPitchTypesSeries$1(translate, availablePitchTypes, pitches, perspective, mouseOver, mouseOut), [translate, availablePitchTypes, pitches, perspective]);
    const [evLaBackgroundType, setEvLaBackgroundType] = useState(evLaForceBackground !== null && evLaForceBackground !== void 0 ? evLaForceBackground : EV_LA_CHART_BACKGROUND_TYPE.hitFx);
    const innerPitchVideoFn = (gameid, eventseq, pitchseq) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            setVideoPlaylist(null);
            const playlist = yield pitchVideoFn(gameid, eventseq, pitchseq);
            setVideoPlaylist(playlist);
            return playlist;
        }
        catch (_a) {
            setIsVideoPlayerOpen(false);
        }
        return [];
    });
    const innerMultiVideoFn = (playlistPitches) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            setVideoPlaylist(null);
            const playlist = yield multiVideoFn(playlistPitches);
            setVideoPlaylist(playlist);
            return playlist;
        }
        catch (_b) {
            setIsVideoPlayerOpen(false);
        }
        return [];
    });
    if (isLoading) {
        return (React.createElement("div", { className: "d-flex justify-content-center py-5" },
            React.createElement(LoadingSpinner$1, null)));
    }
    return (React.createElement("div", null,
        React.createElement("div", { className: "d-flex flex-wrap justify-content-around" },
            !hideStrikeZone && (React.createElement("div", { className: "d-flex flex-column justify-content-between align-items-center mb-3 mx-2" },
                React.createElement(StrikeZone$1, { batterHand: batterHand, showing: showing, pitches: pitches, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, perspective: perspective, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, modalContainer: modalContainer, ref: strikeZoneRef, tooltipFormatter: tooltipFormatter }),
                !hidePerspectiveToggle && (React.createElement(StyledToggleButtons$2, { name: "perspective", options: perspectiveOptions(translate), value: perspective, onChange: setPerspective })))),
            !hideSprayChart && (React.createElement("div", { className: "mb-3" },
                React.createElement(SprayChart$1, { showing: showing, pitches: pitches, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, modalContainer: modalContainer, ref: sprayChartRef, sizeMultiplier: sprayChartSizeMultipler, tooltipFormatter: tooltipFormatter }))),
            !hideEvLaChart && (React.createElement("div", { className: "d-flex flex-column justify-content-between align-items-center mb-3 mx-2" },
                React.createElement(EvLaChart, { showing: showing, pitches: pitches, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, backgroundType: evLaBackgroundType, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn, modalContainer: modalContainer, ref: evLaChartRef, size: evLaChartSize, tooltipFormatter: tooltipFormatter }),
                !evLaForceBackground && (React.createElement(StyledToggleButtons$2, { name: "background", options: evLaBackgroundTypeOptions(translate), value: evLaBackgroundType, onChange: setEvLaBackgroundType, className: "mt-3" }))))),
        showBatTrackingCharts && (React.createElement("div", { className: "d-flex flex-wrap flex-grow-1 justify-content-center align-items-end mt-5" },
            React.createElement(HeadingChart$1, { ref: headingChartRef, showing: showing, pitches: pitches, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, availablePitchTypes: availablePitchTypes.map((pt) => pt % 1000), pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn }),
            React.createElement("div", { style: { width: 200, flexShrink: 1 } }),
            (batterHand === 2 || batterHand === 3) && (React.createElement(BatImpactChart$1, { ref: lhhBatImpactChartRef, batterHand: 2, showing: showing, pitches: pitches, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn })),
            (batterHand === 1 || batterHand === 3) && (React.createElement(BatImpactChart$1, { ref: rhhBatImpactChartRef, batterHand: 1, showing: showing, pitches: pitches, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter, pitchVideoFn: innerPitchVideoFn, multiVideoFn: innerMultiVideoFn })))),
        React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: () => setIsVideoPlayerOpen(false), playlist: videoPlaylist, container: modalContainer })));
};

const getColumns$2 = (translate, showLevelAverages, showBatTrackingStats, onPlayAll) => [
    ...(onPlayAll
        ? [{ id: 'playAll', type: COLUMN_TYPES.NODE, transform: (row) => (row.abbr ? ' ' : React.createElement(VideoButton, { color: "#244c74", onClick: onPlayAll })) }]
        : []),
    ...(showLevelAverages ? [{ id: 'abbr', title: '', type: COLUMN_TYPES.NODE, transform: (row) => (row.abbr ? `${row.abbr} Avg` : '') }] : []),
    { id: 'pitches', title: translate('baseball.pitches_other') },
    { id: 'sw', title: translate('components.hitmon.abbr-swing-pct'), statistic: 'Sw', type: COLUMN_TYPES.PERCENT, precision: 1 },
    { id: 'swinz', title: translate('components.hitmon.abbr-swing-in-zone-pct'), statistic: 'SwInZon', type: COLUMN_TYPES.PERCENT, precision: 1 },
    { id: 'ch', title: translate('components.hitmon.abbr-chase-pct'), statistic: 'Ch', type: COLUMN_TYPES.PERCENT, precision: 1 },
    { id: 'ms', title: translate('components.hitmon.abbr-miss-pct'), statistic: 'Ms', type: COLUMN_TYPES.PERCENT, precision: 1 },
    ...(showBatTrackingStats ? [
        { id: 'trkswg', title: 'Trk Swg', statistic: 'TrackedSwings', type: COLUMN_TYPES.NUMBER },
        { id: 'batspd', title: 'Bat Spd', statistic: 'BatSpeed', type: COLUMN_TYPES.NUMBER, precision: 1 },
        { id: 'atkangle', title: 'Att Ang', statistic: 'AttackAngle', type: COLUMN_TYPES.NUMBER, precision: 1 },
        { id: 'heading', title: 'Head', statistic: 'Heading', type: COLUMN_TYPES.NUMBER, precision: 1 },
        { id: 'baracc', title: 'Bar Acc BIP', statistic: 'BarrelAccuracy', type: COLUMN_TYPES.NUMBER, precision: 1 },
        { id: 'barracch', title: 'Bar Acc H BIP', statistic: 'BarrelAccH', type: COLUMN_TYPES.NUMBER, precision: 1 },
        { id: 'barraccv', title: 'Bar Acc V BIP', statistic: 'BarrelAccV', type: COLUMN_TYPES.NUMBER, precision: 1 },
        { id: 'battilt', title: 'Bat Tilt', statistic: 'BatTilt', type: COLUMN_TYPES.NUMBER, precision: 1 },
        { id: 'hbat', title: 'Hbat', statistic: 'HBat', type: COLUMN_TYPES.NUMBER, precision: 2 },
        { id: 'vbat', title: 'Vbat', statistic: 'VBat', type: COLUMN_TYPES.NUMBER, precision: 2 },
    ] : []),
    { id: 'ev', title: translate('components.hitmon.abbr-exit-velo'), statistic: 'ExitVelo', type: COLUMN_TYPES.NUMBER, precision: 1 },
    { id: 'vla', title: translate('components.hitmon.abbr-vla'), statistic: 'VertLA', type: COLUMN_TYPES.NUMBER, precision: 1 },
    { id: 'slg', title: translate('components.hitmon.abbr-slugging'), statistic: 'SLG', type: COLUMN_TYPES.RATE },
    { id: 'cq', title: translate('components.hitmon.abbr-contact-quality'), statistic: 'ContactQuality', type: COLUMN_TYPES.NUMBER, precision: 1 },
    { id: 'ervops', title: translate('components.hitmon.expected-ops'), statistic: 'ExpOPS', type: COLUMN_TYPES.RATE },
];
const getRows$3 = (pitches = [], levelAverages) => {
    var _a;
    return [{
            pitches: pitches.length,
            sw: ratio(pitches.filter((p) => p.sw).length, pitches.length),
            swinz: ratio(pitches.filter((p) => p.swinz).length, pitches.filter((p) => p.inz).length),
            ch: ratio(pitches.filter((p) => p.ch).length, pitches.filter((p) => !p.inz).length),
            ms: ratio(pitches.filter((p) => p.ms).length, pitches.filter((p) => p.sw).length),
            ev: ratio(pitches.reduce((all, p) => all + p.exitvelo, 0), pitches.filter((p) => p.exitvelo).length),
            vla: pitches.filter((p) => p.launchangle).map((p) => p.launchangle).reduce((sum, v) => (sum + v), 0) / pitches.filter((p) => p.launchangle).length,
            slg: slg(pitches.filter((p) => p.b1).length, pitches.filter((p) => p.b2).length, pitches.filter((p) => p.b3).length, pitches.filter((p) => p.hr).length, pitches.filter((p) => p.ab).length),
            cq: pitches.length ? 100 * ((_a = ratio(pitches.reduce((all, p) => all + p.rvheopsbip, 0), pitches.reduce((all, p) => all + p.biprvdenom, 0))) !== null && _a !== void 0 ? _a : 0) : null,
            ervops: ((3.9 * (pitches.reduce((all, p) => all + p.ervpitch, 0) / pitches.length) * 3.284000) + 0.7592),
            trkswg: pitches.filter((p) => p.pwbatspdinz || p.pwbatspdoutz).length,
            batspd: ratio(pitches.reduce((all, p) => { var _a, _b; return all + ((_a = p.batspdinz) !== null && _a !== void 0 ? _a : 0) + ((_b = p.batspdoutz) !== null && _b !== void 0 ? _b : 0); }, 0), pitches.filter((p) => p.pwbatspdinz || p.pwbatspdoutz).length),
            atkangle: ratio(pitches.reduce((all, p) => { var _a, _b; return all + ((_a = p.atkanginz) !== null && _a !== void 0 ? _a : 0) + ((_b = p.atkangoutz) !== null && _b !== void 0 ? _b : 0); }, 0), pitches.filter((p) => p.pwatkanginz || p.pwatkangoutz).length),
            heading: ratio(pitches.reduce((all, p) => { var _a, _b; return all + ((_a = p.fbhead) !== null && _a !== void 0 ? _a : 0) + ((_b = p.nfbhead) !== null && _b !== void 0 ? _b : 0); }, 0), pitches.filter((p) => p.pwfbhead || p.pwnfbhead).length),
            baracc: rvPerN(pitches.reduce((all, p) => { var _a; return all + ((_a = p.barracc) !== null && _a !== void 0 ? _a : 0); }, 0), pitches.filter((p) => p.pawbarracc).length, 100),
            barracch: rvPerN(pitches.reduce((all, p) => all + p.barracch, 0), pitches.filter((p) => p.pawbarracch).length, 100),
            barraccv: rvPerN(pitches.reduce((all, p) => all + p.barraccv, 0), pitches.filter((p) => p.pawbarraccv).length, 100),
            battilt: ratio(pitches.reduce((all, p) => { var _a, _b; return all + ((_a = p.battiltinz) !== null && _a !== void 0 ? _a : 0) + ((_b = p.battiltoutz) !== null && _b !== void 0 ? _b : 0); }, 0), pitches.filter((p) => p.pwbattiltinz || p.pwbattiltoutz).length),
            hbat: ratio(pitches.reduce((all, p) => all + p.hbat, 0), pitches.filter((p) => p.pwhbat).length),
            vbat: ratio(pitches.reduce((all, p) => all + p.vbat, 0), pitches.filter((p) => p.pwvbat).length),
        }].concat(levelAverages);
};
const StatsTable$1 = ({ pitches, isLoadingLevelAverages, levelAverages, enableLevelAverages = false, getLevelAverages, levels, statTooltip, showBatTrackingStats = false, enablePlayAllInStatsTable, videoPlayerModal: VideoPlayerModal, modalContainer, multiVideoFn, }) => {
    const { t: translate } = useTranslation();
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const innerMultiVideoFn = (playlistPitches) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            setVideoPlaylist(null);
            const playlist = yield multiVideoFn(playlistPitches.map((p) => ({ gameid: p.gameid, eventseq: p.eventseq, pitchseq: p.pitchseq })));
            setVideoPlaylist(playlist);
            return playlist;
        }
        catch (_a) {
            setIsVideoPlayerOpen(false);
        }
        return [];
    });
    return (React.createElement("div", { className: "text-center" },
        React.createElement(DataTable, { columns: getColumns$2(translate, !!levelAverages.length, showBatTrackingStats, enablePlayAllInStatsTable ? () => innerMultiVideoFn(pitches) : undefined), rows: getRows$3(pitches, levelAverages), statTooltip: statTooltip, rowClass: (r) => ('abbr' in r && !!r.abbr ? 'fw-bold' : '') }),
        !levelAverages.length && enableLevelAverages && (React.createElement("div", { style: { border: '1px solid #ADB0B2', borderTop: 0 }, className: "p-1" }, isLoadingLevelAverages ? React.createElement(LoadingSpinner$1, { size: "sm", style: { margin: '3px 0' } }) : (React.createElement(Button, { variant: "primary", onClick: getLevelAverages, disabled: !levels.filter((l) => l !== 7).length }, translate('components.hitmon.get-level-averages'))))),
        VideoPlayerModal && enablePlayAllInStatsTable && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: () => setIsVideoPlayerOpen(false), playlist: videoPlaylist, container: modalContainer }))));
};

var getCleanPitches$1 = (pitches) => {
    let cleanPitches = [];
    if (pitches) {
        cleanPitches = pitches.filter((p) => p.locationx && p.locationy).map((p) => ({
            id: `${p.gameid}_${p.eventseq}_${p.pitchseq}`,
            gameid: p.gameid,
            gamedate: p.gamedate,
            eventseq: p.eventseq,
            pitchseq: p.pitchseq,
            pitchtype: p.pitchtype,
            fxtype: p.fxtype,
            fxsubtype: p.fxsubtype,
            pitcher_lastname: p.pitcher_lastname,
            pitcher_usesname: p.pitcher_usesname,
            inning: p.inning,
            istop: p.istop,
            outs: p.outs,
            baseevent: p.baseevent,
            balls: p.balls,
            strikes: p.strikes,
            pitchresult: p.pitchresult,
            islastpitch: p.islastpitch,
            velocity: p.velocity,
            breakx: p.breakx || p.breakx54,
            breakz: p.breakz || p.breakz54,
            initposx: p.initposx,
            initposz: p.initposz,
            armangle: p.armangle,
            expstk_all: p.expstk_all,
            exppit_all: p.exppit_all,
            stk: p.stk,
            tkstk: p.tkstk,
            expstk: p.expstk,
            tk: p.tk,
            gb: p.gb,
            bip: p.bip,
            ms: p.ms,
            ch: p.ch,
            sw: p.sw,
            inz: p.inz,
            swinz: p.swinz,
            so: p.so,
            islhb: p.islhb,
            islhp: p.islhp,
            platex: p.platex,
            platez: p.platez,
            exitvelo: p.exitvelo,
            launchangle: p.launchangle,
            horizla: p.horizla,
            hittype: p.hittype,
            resultid: p.resultid,
            bcbefore: p.bcbefore,
            hitmonresulttype: p.hitmonresulttype,
            locationx: p.locationx,
            locationy: p.locationy,
            ballinplayx: p.ballinplayx,
            ballinplayy: p.ballinplayy,
            b1: p.b1,
            b2: p.b2,
            b3: p.b3,
            hr: p.hr,
            ab: p.ab,
            rvheopsbip: p.rvheopsbip,
            biprvdenom: p.biprvdenom,
            ervpitch: p.ervpitch,
            pawrv: p.pawrv,
            rvheops: p.rvheops,
            catcherid: p.catcherid,
            vsteamid: p.vsteamid,
            lastxpa: p.lastxpa,
            gyrodegree: p.gyrodegree,
            heading: p.heading,
            hbat: p.hbat,
            vbat: p.vbat,
            batspdinz: p.batspdinz,
            pwbatspdinz: p.pwbatspdinz,
            batspdoutz: p.batspdoutz,
            pwbatspdoutz: p.pwbatspdoutz,
            atkanginz: p.atkanginz,
            pwatkanginz: p.pwatkanginz,
            atkangoutz: p.atkangoutz,
            pwatkangoutz: p.pwatkangoutz,
            fbhead: p.fbhead,
            pwfbhead: p.pwfbhead,
            nfbhead: p.nfbhead,
            pwnfbhead: p.pwnfbhead,
            battiltinz: p.battiltinz,
            pwbattiltinz: p.pwbattiltinz,
            battiltoutz: p.battiltoutz,
            pwbattiltoutz: p.pwbattiltoutz,
            barracc: p.barracc,
            pawbarracc: p.pawbarracc,
            barracch: p.barracch,
            pawbarracch: p.pawbarracch,
            barraccv: p.barraccv,
            pawbarraccv: p.pawbarraccv,
            pwhbat: p.pwhbat,
            pwvbat: p.pwvbat,
            ishome: p.ishome,
            venueid: p.venueid,
            venuename: p.venuename,
        }));
    }
    const cleanPitchMap = {};
    for (let i = 0; i < 5; i++) {
        for (let j = 0; j < 5; j++) {
            cleanPitchMap[`${i + 1}.${j + 1}`] = [];
        }
    }
    cleanPitches.forEach((p) => {
        cleanPitchMap[`${p.locationx}.${p.locationy}`].push(p);
    });
    return { cleanPitches, cleanPitchMap };
};

const isNumber$1 = (val) => val !== '' && val !== '-' && !!val && !isNaN(val);
const isGreaterThanOrEqualTo$1 = (num, filterVal) => {
    if (!isNumber$1(filterVal) || filterVal === undefined || filterVal === null) {
        return true;
    }
    if (!isNumber$1(num) || num === undefined || num === null) {
        return false;
    }
    return num >= filterVal;
};
const isLessThanOrEqualTo$1 = (num, filterVal) => {
    if (!isNumber$1(filterVal) || filterVal === undefined || filterVal === null) {
        return true;
    }
    if (!isNumber$1(num) || num === undefined || num === null) {
        return false;
    }
    return num <= filterVal;
};
var filterPitches$1 = (cleanPitchMap, liveFilter, isSwitch) => {
    const locationPitches = liveFilter.pitchLocation.length
        ? Object.entries(cleanPitchMap)
            .filter(([key]) => liveFilter.pitchLocation.map((pl) => `${pl.locationx}.${pl.locationy}`).includes(key))
            .reduce((all, [, val]) => all.concat(val), [])
        : Object.values(cleanPitchMap).reduce((all, locPitches) => all.concat(locPitches), []);
    return locationPitches.filter((p) => (liveFilter.baseState === ALL_VALUE
        || (liveFilter.baseState === 0 && p.bcbefore === 0)
        || (liveFilter.baseState === 1 && p.bcbefore > 1)
        || (liveFilter.baseState === 2 && p.bcbefore > 0))
        && (liveFilter.counts.includes(ALL_VALUE)
            || (liveFilter.counts.includes(ALL_ATTACK_VALUE) && p.strikes < 2)
            || (liveFilter.counts.includes(ALL_2K_VALUE) && p.strikes === 2)
            || liveFilter.counts.some((c) => p.balls === c % 4 && p.strikes === Math.floor(c / 4)))
        && (liveFilter.result.includes(ALL_VALUE) || liveFilter.result.includes(p.hitmonresulttype))
        // eslint-disable-next-line max-len
        && ((liveFilter.pitchTypes.includes(ALL_VALUE)
            || (liveFilter.pitchTypes.includes(ALL_FB_VALUE) && [9, 10].includes(p.pitchtype))
            || (liveFilter.pitchTypes.includes(ALL_NON_FB_VALUE) && ![9, 10].includes(p.pitchtype))
            || liveFilter.pitchTypes.includes(p.fxsubtype != null && p.fxsubtype > 0 ? (p.pitchtype * 1000) + p.fxsubtype : p.pitchtype)
            // eslint-disable-next-line max-len
            || (!(p.pitchtype === 3 && (p.fxsubtype === 34 || p.fxsubtype === 33)) && liveFilter.pitchTypes.filter((x) => x < 1000 && p.fxsubtype != null && p.pitchtype === x).length > 0)))
        && (liveFilter.pitcherHand === ALL_VALUE || p.islhp === (liveFilter.pitcherHand === 2))
        && (!isSwitch || p.islhb === (liveFilter.batterHand === 2))
        && (liveFilter.zoneLocation === ALL_VALUE || (p.inz === liveFilter.zoneLocation && !!p.exppit_all))
        && isGreaterThanOrEqualTo$1(p.velocity, liveFilter.minVelo) && isLessThanOrEqualTo$1(p.velocity, liveFilter.maxVelo)
        && isGreaterThanOrEqualTo$1(p.launchangle, liveFilter.minLa) && isLessThanOrEqualTo$1(p.launchangle, liveFilter.maxLa)
        && isGreaterThanOrEqualTo$1(p.exitvelo, liveFilter.minEv) && isLessThanOrEqualTo$1(p.exitvelo, liveFilter.maxEv)
        && isGreaterThanOrEqualTo$1(p.horizla, liveFilter.minHorizLa) && isLessThanOrEqualTo$1(p.horizla, liveFilter.maxHorizLa)
        && isGreaterThanOrEqualTo$1(p.breakx, liveFilter.minBreakX) && isLessThanOrEqualTo$1(p.breakx, liveFilter.maxBreakX)
        && isGreaterThanOrEqualTo$1(p.breakz, liveFilter.minBreakZ) && isLessThanOrEqualTo$1(p.breakz, liveFilter.maxBreakZ)
        && isGreaterThanOrEqualTo$1(p.initposx, liveFilter.minRelX) && isLessThanOrEqualTo$1(p.initposx, liveFilter.maxRelX)
        && isGreaterThanOrEqualTo$1(p.initposz, liveFilter.minRelZ) && isLessThanOrEqualTo$1(p.initposz, liveFilter.maxRelZ)
        && isGreaterThanOrEqualTo$1(p.armangle, liveFilter.minArmAngle) && isLessThanOrEqualTo$1(p.armangle, liveFilter.maxArmAngle)
        && isGreaterThanOrEqualTo$1(p.gyrodegree, liveFilter.minGyroDegree) && isLessThanOrEqualTo$1(p.gyrodegree, liveFilter.maxGyroDegree)
        && isLessThanOrEqualTo$1(p.lastxpa, liveFilter.lastPAs)
        && (liveFilter.park === ALL_VALUE || (liveFilter.park === HOME_VALUE && p.ishome) || (liveFilter.park === AWAY_VALUE && !p.ishome)
            || liveFilter.park === p.venueid));
};

const StyledTable = styled.table `
    width: 100%;
    text-align: center;
     tr:first-child td {
        border-top: 0;
      }
    tr td:first-child {
        border-left: 0;
    }
    tr:last-child td {
        border-bottom: 0;
    }
    tr td:last-child {
        border-right: 0;
    }

    td {
        border: 1px solid #dee2e6;
        padding: 0.5rem;
    }
`;
const StyledSectionTitle = styled.div `
    font-size: 1.25rem;
`;
const StyledRotatedSectionTitle = styled(StyledSectionTitle) `
    width: 100%;
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    white-space: nowrap;
`;
const StyledToggleButtons$1 = styled(ToggleButtons) `
    label.btn {
        background-color: transparent !important;
        color: #254c75 !important;
        font-size: 11px !important;
        border: 1px solid #254c75 !important;
        padding: 0.2rem 0.5rem;
    }
    label:first-of-type {
        border-top-left-radius: 4px !important;
        border-bottom-left-radius: 4px !important;
    }
    .btn-check:checked + .btn {
        background-color: #254c75 !important;
        color: white !important;
    }
`;
const COLUMNS = (translate) => [
    { title: translate('components.hitmon.called-strikes'), isValid: (pitch) => pitch.hitmonresulttype === 4 },
    { title: translate('components.hitmon.swinging-strikes'), isValid: (pitch) => pitch.hitmonresulttype === 5 },
    { title: translate('components.hitmon.weak-contact'), isValid: (pitch) => [7, 8].includes(pitch.hitmonresulttype) },
    { title: translate('components.hitmon.hard-contact'), isValid: (pitch) => [1, 2].includes(pitch.hitmonresulttype) },
];
const ROWS = (translate) => [
    { title: translate('components.hitmon.attack-counts'), isValid: (pitch) => pitch.strikes < 2 },
    { title: translate('components.hitmon.two-strike-counts'), isValid: (pitch) => pitch.strikes === 2 },
];
const PERSPECTIVE_OPTIONS = (translate) => [
    { name: translate('components.hitmon.hitters-perspective'), value: PERSPECTIVE_TYPES.hitter },
    { name: translate('components.hitmon.pitchers-perspective'), value: PERSPECTIVE_TYPES.pitcher },
];
const GridCharts = ({ isLoading, perspective, setPerspective, batterHand, pitches, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, hidePerspectiveToggle = false, tooltipFormatter, availablePitchTypes, }) => {
    const { t: translate } = useTranslation();
    const getSeries = (row, column) => buildPitchTypesSeries$1(translate, availablePitchTypes, pitches.filter((pitch) => row.isValid(pitch) && column.isValid(pitch)), perspective).map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.platex, y: d.platez }))) })));
    const innerTooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        return getResultTooltip$1(series.name, pitch, translate);
    };
    if (isLoading) {
        return (React.createElement("div", { className: "d-flex justify-content-center py-5" },
            React.createElement(LoadingSpinner$1, null)));
    }
    return (React.createElement("div", null,
        React.createElement(StyledTable, null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", { width: 40 }),
                    COLUMNS(translate).map((column) => (React.createElement("td", { key: column.title },
                        React.createElement(StyledSectionTitle, null, column.title))))),
                ROWS(translate).map((row) => (React.createElement("tr", { key: row.title },
                    React.createElement("td", null,
                        React.createElement(StyledRotatedSectionTitle, null, row.title)),
                    COLUMNS(translate).map((column) => (React.createElement("td", { key: `${row.title}-${column.title}` },
                        React.createElement(StrikeZone$3, { seriesData: getSeries(row, column), pitcherView: perspective === PERSPECTIVE_TYPES.pitcher, showlhb: batterHand === 2, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, hideGrid: true, hideAxis: true, size: "sm" }))))))))),
        !hidePerspectiveToggle && (React.createElement("div", { className: "d-flex justify-content-center mt-2" },
            React.createElement(StyledToggleButtons$1, { name: "perspective", options: PERSPECTIVE_OPTIONS(translate), value: perspective, onChange: setPerspective })))));
};

const StyledVideoButton = styled(VideoButton) `
    > span {
        font-size: 13px !important;
    }
`;
const HittingMonitor = ({ className, isLoading, liveFilter, setLiveFilter, pitches, player, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, evLaChartSize = 'lg', sprayChartSizeMultipler = 1, initialPerspective = PERSPECTIVE_TYPES.hitter, hidePerspectiveToggle = false, hideStrikeZone = false, hideSprayChart = false, hideEvLaChart = false, hidePitcherHand = false, hideBatterHand = false, enableLevelAverages = false, getLevelAverages, statTooltip, levelAveragesAbortController, levels, evLaForceBackground, playAll, hideStatsTable = false, tooltipFormatter, hideLastPAs, maxPAs, showBatTrackingStats = false, enablePlayAllInStatsTable = false, }) => {
    const { t: translate } = useTranslation();
    const [perspective, setPerspective] = useState(initialPerspective);
    const [filteredPitches, setFilteredPitches] = useState([]);
    const [isLoadingLevelAverages, setIsLoadingLevelAverages] = useState(false);
    const [levelAverages, setLevelAverages] = useState([]);
    const { cleanPitches, cleanPitchMap } = useMemo(() => getCleanPitches$1(pitches), [pitches]);
    // eslint-disable-next-line max-len
    const availablePitchTypes = useMemo(() => new Set(cleanPitches.map((p) => (p.fxsubtype != null && p.fxsubtype !== 0 ? (p.pitchtype * 1000) + p.fxsubtype : p.pitchtype))), [cleanPitches]);
    const availableResultTypes = useMemo(() => new Set(cleanPitches.map((p) => p.hitmonresulttype)), [cleanPitches]);
    const isSwitch = useMemo(() => (player === null || player === void 0 ? void 0 : player.Bats) === 3 || (cleanPitches.some((p) => p.islhb) && cleanPitches.some((p) => !p.islhb)), [player === null || player === void 0 ? void 0 : player.Bats, cleanPitches]);
    const parks = useMemo(() => Array.from(cleanPitches.reduce((all, p) => {
        if (p.venueid && !all.has(p.venueid)) {
            all.set(p.venueid, { venueid: p.venueid, venuename: p.venuename });
        }
        return all;
    }, new Map()).values()).sort((a, b) => (a.venuename.localeCompare(b.venuename))), [cleanPitches]);
    useEffect(() => {
        setFilteredPitches(filterPitches$1(cleanPitchMap, liveFilter, isSwitch));
        setLevelAverages([]);
        if (levelAveragesAbortController) {
            levelAveragesAbortController.abort();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cleanPitchMap, liveFilter]);
    useEffect(() => {
        if (liveFilter.park && liveFilter.park > 0 && !parks.some((p) => p.venueid === liveFilter.park)) {
            setLiveFilter(Object.assign(Object.assign({}, liveFilter), { park: ALL_VALUE }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parks]);
    const innerGetLevelAverages = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoadingLevelAverages(true);
            const response = yield getLevelAverages();
            setLevelAverages(response.levelaverages);
        }
        finally {
            setIsLoadingLevelAverages(false);
        }
    });
    return (React.createElement("div", { className: `${className} bg-white` },
        React.createElement(HittingMonitorFilter, { filter: liveFilter, setFilter: setLiveFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand, hideLastPAs: hideLastPAs, maxPAs: maxPAs, parks: parks }),
        React.createElement("div", { className: "mt-4" },
            playAll && (React.createElement(StyledVideoButton, { icon: translate('common.all'), onClick: () => playAll(liveFilter.showing === SHOWING_PITCH_TYPES_EXTENDED_VALUE
                    ? filteredPitches.filter((p) => [1, 2, 4, 5, 7, 8].includes(p.hitmonresulttype))
                    : [...filteredPitches]), color: styles.theme.background.astronaut, size: "4em" })),
            [SHOWING_RESULTS_VALUE, SHOWING_PITCH_TYPES_VALUE].includes(liveFilter.showing)
                ? (React.createElement(AllCharts$1, { isLoading: isLoading, pitches: filteredPitches, batterHand: liveFilter.batterHand, showing: liveFilter.showing, perspective: perspective, setPerspective: setPerspective, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, evLaChartSize: evLaChartSize, sprayChartSizeMultipler: sprayChartSizeMultipler, hidePerspectiveToggle: hidePerspectiveToggle, hideStrikeZone: hideStrikeZone, hideSprayChart: hideSprayChart, hideEvLaChart: hideEvLaChart, evLaForceBackground: evLaForceBackground, tooltipFormatter: tooltipFormatter, showBatTrackingCharts: showBatTrackingStats, availablePitchTypes: Array.from(availablePitchTypes) }))
                : (React.createElement(GridCharts, { isLoading: isLoading, pitches: filteredPitches, batterHand: liveFilter.batterHand, perspective: perspective, setPerspective: setPerspective, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, hidePerspectiveToggle: hidePerspectiveToggle, tooltipFormatter: tooltipFormatter, availablePitchTypes: Array.from(availablePitchTypes) }))),
        !isLoading && !hideStatsTable && (React.createElement("div", { className: "mt-4" },
            React.createElement(StatsTable$1, { pitches: filteredPitches, isLoadingLevelAverages: isLoadingLevelAverages, levelAverages: levelAverages, enableLevelAverages: enableLevelAverages, getLevelAverages: innerGetLevelAverages, statTooltip: statTooltip, levels: levels, showBatTrackingStats: showBatTrackingStats, enablePlayAllInStatsTable: enablePlayAllInStatsTable, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, multiVideoFn: multiVideoFn })))));
};

({
    showing: 0,
    baseState: ALL_VALUE,
    counts: [ALL_VALUE],
    result: RESULT_TYPES(null).map((rt) => rt.id),
    pitchTypes: [ALL_VALUE],
    pitcherHand: ALL_VALUE,
    batterHand: null,
    zoneLocation: ALL_VALUE,
    pitchLocation: [],
    minVelo: '',
    maxVelo: '',
    minLa: '',
    maxLa: '',
    minEv: '',
    maxEv: '',
    minHorizLa: '',
    maxHorizLa: '',
    minBreakX: '',
    maxBreakX: '',
    minBreakZ: '',
    maxBreakZ: '',
    minArmAngle: '',
    maxArmAngle: '',
    park: ALL_VALUE,
    lastPAs: 100,
});

const sections = (translate) => [
    {
        name: translate('components.hitmon.ntiles.overall'),
        stats: [
            {
                name: translate('components.hitmon.ntiles.hitfx-ops'),
                key: 'hitfxops',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, true)),
            },
            {
                name: translate('components.hitmon.ntiles.strikeout-rate'),
                abbr: `${translate('baseball.abbr-strikeout-k')}%`,
                key: 'krate',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
            {
                name: translate('components.hitmon.ntiles.walk-rate'),
                abbr: `${translate('baseball.abbr-walk')}%`,
                key: 'ubbrate',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
            {
                name: translate('components.hitmon.ntiles.abbr-average'),
                key: 'avg',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, true)),
            },
            {
                name: translate('components.hitmon.ntiles.abbr-slugging'),
                key: 'slg',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, true)),
            },
            {
                name: translate('components.hitmon.ntiles.abbr-on-base'),
                key: 'obp',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, true)),
            },
            {
                name: translate('components.hitmon.ntiles.abbr-wops'),
                key: 'wops',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, true)),
            },
        ],
    },
    {
        name: translate('components.hitmon.ntiles.swing-decisions'),
        stats: [
            {
                name: translate('components.hitmon.ntiles.swing-decision-score'),
                abbr: translate('components.hitmon.ntiles.abbr-swing-decision-score'),
                key: 'swds',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 1)),
            },
            {
                name: translate('components.hitmon.ntiles.should-swing-decision-score'),
                abbr: translate('components.hitmon.ntiles.abbr-should-swing-decision-score'),
                key: 'swdssw',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 1)),
            },
            {
                name: translate('components.hitmon.ntiles.should-take-decision-score'),
                abbr: translate('components.hitmon.ntiles.abbr-should-take-decision-score'),
                key: 'swdstk',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 1)),
            },
            {
                name: translate('components.hitmon.ntiles.k-zone-pct'),
                abbr: translate('components.hitmon.ntiles.abbr-zone-pct'),
                key: 'kzon',
                lowText: translate('components.hitmon.ntiles.low'),
                highText: translate('components.hitmon.ntiles.high'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
            {
                name: translate('components.hitmon.ntiles.swing-pct-in-zone'),
                abbr: translate('components.hitmon.ntiles.abbr-swing-pct-in-zone'),
                key: 'swinz',
                lowText: translate('components.hitmon.ntiles.low'),
                highText: translate('components.hitmon.ntiles.high'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
            {
                name: translate('components.hitmon.ntiles.chase-rate'),
                abbr: translate('components.hitmon.ntiles.abbr-chase-rate'),
                key: 'ch',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
            {
                name: translate('components.hitmon.ntiles.swing-rate'),
                abbr: translate('components.hitmon.ntiles.abbr-swing-rate'),
                key: 'sw',
                lowText: translate('components.hitmon.ntiles.low'),
                highText: translate('components.hitmon.ntiles.high'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
            {
                name: translate('components.hitmon.ntiles.fastball-pct'),
                abbr: translate('components.hitmon.ntiles.abbr-fastball-pct'),
                key: 'fbl',
                lowText: translate('components.hitmon.ntiles.low'),
                highText: translate('components.hitmon.ntiles.high'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
        ],
    },
    {
        name: translate('components.hitmon.ntiles.contact-quailty'),
        stats: [
            {
                name: translate('components.hitmon.ntiles.contact-quailty'),
                abbr: translate('components.hitmon.ntiles.abbr-contact-quailty'),
                key: 'cq',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 1)),
            },
            {
                name: translate('components.hitmon.ntiles.contact-results'),
                abbr: translate('components.hitmon.ntiles.abbr-contact-results'),
                key: 'cr',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 1)),
            },
            {
                name: translate('components.hitmon.ntiles.exit-velo'),
                abbr: translate('components.hitmon.ntiles.abbr-exit-velo'),
                key: 'hitvelo',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 0)),
                units: ' mph',
            },
            {
                name: translate('components.hitmon.ntiles.pct-over-95'),
                abbr: translate('components.hitmon.ntiles.abbr-pct-over-95'),
                key: 'pct95',
                lowText: translate('components.hitmon.ntiles.low'),
                highText: translate('components.hitmon.ntiles.high'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
            {
                name: translate('components.hitmon.ntiles.launch-angle-95'),
                abbr: translate('components.hitmon.ntiles.abbr-launch-angle-95'),
                key: 'vertla95',
                lowText: translate('components.hitmon.ntiles.low'),
                highText: translate('components.hitmon.ntiles.high'),
                formatter: (v) => Number(format(v, 0)),
                units: ' deg',
            },
            {
                name: translate('components.hitmon.ntiles.miss-pct-in-zone'),
                abbr: translate('components.hitmon.ntiles.abbr-miss-pct-in-zone'),
                key: 'msinz',
                lowText: translate('components.hitmon.ntiles.poor'),
                highText: translate('components.hitmon.ntiles.great'),
                formatter: (v) => Number(format(v, 0)),
                units: '%',
            },
        ],
    },
];

const mapNtilesSeries = (data, sections) => {
    let series = [];
    if (data && sections && data.player[0] && data.percentiles[0]) {
        const playerdata = data.player[0];
        const ntiles = data.percentiles[0];
        series = sections.map((section, ix) => ({
            type: 'scatter',
            name: section.name,
            index: ix,
            data: section.stats.map((stat) => {
                var _a;
                return (Object.assign(Object.assign({}, stat), { name: stat.abbr || stat.name, y: playerdata[`${stat.key}_ntile`], value: stat.formatter(playerdata[stat.key]), units: (_a = stat.units) !== null && _a !== void 0 ? _a : '', statistic: stat.statistic, ntileData: {
                        statname: stat.name,
                        percentile: format(playerdata[`${stat.key}_ntile`], 0),
                        p25: stat.formatter(ntiles[`${stat.key}_p25`]),
                        p50: stat.formatter(ntiles[`${stat.key}_p50`]),
                        p75: stat.formatter(ntiles[`${stat.key}_p75`]),
                    } }));
            }),
        }));
    }
    return series;
};
const HittingNtilesCharts = ({ isLoading, data, sections: sections$1, statTooltip, }) => {
    const { t: translate } = useTranslation();
    const useSections = sections$1 !== null && sections$1 !== void 0 ? sections$1 : sections(translate);
    const ntilesSeries = useMemo(() => mapNtilesSeries(data, useSections), [data, useSections]);
    return (React.createElement("div", { className: "d-flex flex-wrap justify-content-center" },
        !isLoading && ntilesSeries.map((series) => (React.createElement("div", { className: "p-2 flex-fill", key: series.index },
            React.createElement(NtilesChart, { seriesData: [series], width: 300, title: series.name, statTooltip: statTooltip })))),
        !isLoading && ntilesSeries.length === 0 && (React.createElement("h5", null, translate('components.hitmon.no-data')))));
};

var getCleanPitches = (pitches) => {
    let cleanPitches = [];
    if (pitches) {
        cleanPitches = pitches.filter((p) => p.locationx && p.locationy && p.exppit_all === 1).map((p) => (Object.assign(Object.assign({}, p), { id: `${p.gameid}_${p.eventseq}_${p.pitchseq}` })));
    }
    const cleanPitchMap = {};
    for (let i = 0; i < 5; i++) {
        for (let j = 0; j < 5; j++) {
            cleanPitchMap[`${i + 1}.${j + 1}`] = [];
        }
    }
    cleanPitches.forEach((p) => {
        cleanPitchMap[`${p.locationx}.${p.locationy}`].push(p);
    });
    return { cleanPitches, cleanPitchMap };
};

const isNumber = (val) => val !== '' && val !== '-' && !!val && !isNaN(val);
const isGreaterThanOrEqualTo = (num, filterVal) => {
    if (!isNumber(filterVal) || filterVal === undefined || filterVal === null) {
        return true;
    }
    if (!isNumber(num) || num === undefined || num === null) {
        return false;
    }
    return num >= filterVal;
};
const isLessThanOrEqualTo = (num, filterVal) => {
    if (!isNumber(filterVal) || filterVal === undefined || filterVal === null) {
        return true;
    }
    if (!isNumber(num) || num === undefined || num === null) {
        return false;
    }
    return num <= filterVal;
};
var filterPitches = (cleanPitchMap, liveFilter) => {
    const locationPitches = liveFilter.pitchLocation.length
        ? Object.entries(cleanPitchMap)
            .filter(([key]) => liveFilter.pitchLocation.map((pl) => `${pl.locationx}.${pl.locationy}`).includes(key))
            .reduce((all, [, val]) => all.concat(val), [])
        : Object.values(cleanPitchMap).reduce((all, locPitches) => all.concat(locPitches), []);
    return locationPitches.filter((p) => (liveFilter.baseState === ALL_VALUE$1
        || (liveFilter.baseState === 0 && p.bcbefore === 0)
        || (liveFilter.baseState === 1 && p.bcbefore > 1)
        || (liveFilter.baseState === 2 && p.bcbefore > 0))
        && (liveFilter.counts.includes(ALL_VALUE$1)
            || (liveFilter.counts.includes(ALL_ATTACK_VALUE$1) && p.strikes < 2)
            || (liveFilter.counts.includes(ALL_2K_VALUE$1) && p.strikes === 2)
            || liveFilter.counts.some((c) => p.balls === c % 4 && p.strikes === Math.floor(c / 4)))
        && (liveFilter.result.includes(ALL_VALUE$1) || liveFilter.result.includes(p.hitmonresulttype))
        // eslint-disable-next-line max-len
        && ((liveFilter.pitchTypes.includes(ALL_VALUE$1)
            || (liveFilter.pitchTypes.includes(ALL_FB_VALUE) && [9, 10].includes(p.pitchtype))
            || (liveFilter.pitchTypes.includes(ALL_NON_FB_VALUE) && ![9, 10].includes(p.pitchtype))
            || liveFilter.pitchTypes.includes(p.fxsubtype != null && p.fxsubtype > 0 ? (p.pitchtype * 1000) + p.fxsubtype : p.pitchtype)
            // eslint-disable-next-line max-len
            || (!(p.pitchtype === 3 && (p.fxsubtype === 34 || p.fxsubtype === 33)) && liveFilter.pitchTypes.filter((x) => x < 1000 && p.fxsubtype != null && p.pitchtype === x).length > 0)))
        && (liveFilter.batterHand === ALL_VALUE$1 || ((liveFilter.batterHand === 2) === p.islhb))
        && (liveFilter.zoneLocation === ALL_VALUE$1 || (p.inz === liveFilter.zoneLocation && !!p.exppit_all))
        && isGreaterThanOrEqualTo(p.velocity, liveFilter.minVelo) && isLessThanOrEqualTo(p.velocity, liveFilter.maxVelo)
        && isGreaterThanOrEqualTo(p.launchangle, liveFilter.minLa) && isLessThanOrEqualTo(p.launchangle, liveFilter.maxLa)
        && isGreaterThanOrEqualTo(p.exitvelo, liveFilter.minEv) && isLessThanOrEqualTo(p.exitvelo, liveFilter.maxEv)
        && isGreaterThanOrEqualTo(p.horizla, liveFilter.minHorizLa) && isLessThanOrEqualTo(p.horizla, liveFilter.maxHorizLa)
        && isGreaterThanOrEqualTo(p.breakx, liveFilter.minBreakX) && isLessThanOrEqualTo(p.breakx, liveFilter.maxBreakX)
        && isGreaterThanOrEqualTo(p.breakz, liveFilter.minBreakZ) && isLessThanOrEqualTo(p.breakz, liveFilter.maxBreakZ)
        && isGreaterThanOrEqualTo(p.initposx, liveFilter.minRelX) && isLessThanOrEqualTo(p.initposx, liveFilter.maxRelX)
        && isGreaterThanOrEqualTo(p.initposz, liveFilter.minRelZ) && isLessThanOrEqualTo(p.initposz, liveFilter.maxRelZ)
        && isGreaterThanOrEqualTo(p.armangle, liveFilter.minArmAngle) && isLessThanOrEqualTo(p.armangle, liveFilter.maxArmAngle)
        && isGreaterThanOrEqualTo(p.gyrodegree, liveFilter.minGyroDegree) && isLessThanOrEqualTo(p.gyrodegree, liveFilter.maxGyroDegree)
        && isLessThanOrEqualTo(p.lastxpa, liveFilter.lastPAs)
        && (liveFilter.park === ALL_VALUE$1 || (liveFilter.park === HOME_VALUE && p.ishome) || (liveFilter.park === AWAY_VALUE && !p.ishome)
            || liveFilter.park === p.venueid));
};

styled.div `
    max-width: 1500px;
    margin: 0 auto;
`;

const defaultPitchBreakdownFilter = {
    showing: 1,
    baseState: ALL_VALUE$1,
    counts: [ALL_VALUE$1],
    result: [ALL_VALUE$1],
    pitchTypes: [ALL_VALUE$1],
    pitcherHand: ALL_VALUE$1,
    batterHand: ALL_VALUE$1,
    zoneLocation: ALL_VALUE$1,
    pitchLocation: [],
    minVelo: '',
    maxVelo: '',
    minLa: '',
    maxLa: '',
    minEv: '',
    maxEv: '',
    minBreakX: '',
    maxBreakX: '',
    minBreakZ: '',
    maxBreakZ: '',
    minArmAngle: '',
    maxArmAngle: '',
    pitcherRole: ALL_VALUE$1,
    startDate: new Date(`${(new Date()).getFullYear() - 1}-01-01 00:00:00`),
    endDate: new Date(),
    years: [
        { name: `${(new Date()).getFullYear() - 2}`, value: (new Date()).getFullYear() - 2, checked: false },
        { name: `${(new Date()).getFullYear() - 1}`, value: (new Date()).getFullYear() - 1, checked: false },
        { name: `${(new Date()).getFullYear()}`, value: (new Date()).getFullYear(), checked: true },
    ],
};
const defaultHittingMonitorFilter = {
    showing: 0,
    baseState: ALL_VALUE$1,
    counts: [ALL_VALUE$1],
    result: RESULT_TYPES$1(null).map((rt) => rt.id),
    pitchTypes: [ALL_VALUE$1],
    pitcherHand: ALL_VALUE$1,
    batterHand: null,
    park: ALL_VALUE$1,
    zoneLocation: ALL_VALUE$1,
    pitchLocation: [],
    minVelo: '',
    maxVelo: '',
    minLa: '',
    maxLa: '',
    minEv: '',
    maxEv: '',
    minHorizLa: '',
    maxHorizLa: '',
    minBreakX: '',
    maxBreakX: '',
    minBreakZ: '',
    maxBreakZ: '',
    minArmAngle: '',
    maxArmAngle: '',
    minGyroDegree: '',
    maxGyroDegree: '',
    pitcherRole: ALL_VALUE$1,
};

const StyledToggleButtons = styled(ToggleButtons) `
    ${(props) => (props.$disabled ? `
    opacity : 0.5;
    pointer-events: none;
    ` : '')}
    & .btn {
        font-size: 0.8rem !important;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${(props) => props.$btnWidth}px;
        white-space: nowrap;
    }

    & .btn-check:not(:checked) + .btn {
        color: #204b76 !important;
        background-color: #eeeeee !important;
    }
`;
const PitcherRole = ({ filter, setFilter }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('sections.reports.pitcher.role')),
        React.createElement(StyledToggleButtons, { type: "radio", name: "pitcherRole", options: [
                { name: translate('common.all'), value: -1 },
                { name: translate('baseball.positions.abbr-pitcher-relief'), value: 2 },
                { name: translate('baseball.positions.abbr-pitcher-starting'), value: 1 },
            ], separated: true, value: filter.pitcherRole, onChange: (e) => setFilter(Object.assign(Object.assign({}, filter), { pitcherRole: e })) })));
};

const StyledCheckboxDropdown = styled(CheckboxDropdownInput) `
    .dropdown-toggle {
        min-width: 135px;
    }
`;
const YearDropdown = ({ filter, setFilter, yearsSortDescending }) => {
    const { t: translate } = useTranslation();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onYearDropdownChange = (o, key, e) => {
        const newYears = filter.years.map((lo) => (Object.assign(Object.assign({}, lo), { checked: lo.name === o.name ? e.target.checked : !!lo.checked })));
        setFilter(Object.assign(Object.assign({}, filter), { years: newYears }));
    };
    const selectedYears = filter.years.filter((l) => !!l.checked);
    let yearPlaceholder = '';
    if (selectedYears.length === 1) {
        yearPlaceholder = selectedYears[0].name;
    }
    else if (selectedYears.length === 0) {
        yearPlaceholder = 'All';
    }
    else {
        let consecutive = true;
        let diff = parseInt(selectedYears[0].value);
        selectedYears.forEach((y) => {
            if (Math.abs(diff - parseInt(y.value)) > 1) {
                consecutive = false;
            }
            else {
                diff = parseInt(y.value);
            }
        });
        if (consecutive) {
            if (yearsSortDescending === true) {
                yearPlaceholder = `${selectedYears[selectedYears.length - 1].value}-${selectedYears[0].value}`;
            }
            else {
                yearPlaceholder = `${selectedYears[0].value}-${selectedYears[selectedYears.length - 1].value}`;
            }
        }
        else {
            yearPlaceholder = `${selectedYears.length} ${translate('common.years')}`;
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3" }, translate('sections.reports.pitcher.show-player-seasons')),
        React.createElement("div", { className: "d-flex align-items-center me-4" },
            React.createElement(StyledCheckboxDropdown, { value: filter.years, onChange: onYearDropdownChange, options: filter.years, titleOverrideFormat: true, title: yearPlaceholder, style: { width: 90 } }))));
};

const StyledFilterWrapper = styled.div `
    max-width: 1500px;
    margin: 0 auto;
`;
const FiltersDiv = styled.div `
    align-items: baseline;
`;
const PitchBreakdownFilter = ({ filter, setFilter, isSwitch, availablePitchTypes, availableResultTypes, perspective, hideBatterHand, hidePitcherHand, enableYears = false, yearsSortDescending = false }) => {
    const { t: translate } = useTranslation();
    const [isOpen, setIsOpen] = useState(true);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "border rounded py-2 px-3" },
            React.createElement("div", { className: "d-flex justify-content-end" },
                React.createElement(Button, { variant: "primary", onClick: () => setIsOpen(!isOpen) },
                    isOpen ? translate('common.hide') : translate('common.show'),
                    " ",
                    translate('components.search.filters'))),
            isOpen && (React.createElement(StyledFilterWrapper, { className: "mt-1" },
                React.createElement(FiltersDiv, { className: "d-flex justify-content-between" },
                    React.createElement("div", { className: "mx-2 mb-3" },
                        React.createElement(BaseState, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand }),
                        React.createElement(BatterHand, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand, isPitching: true }),
                        React.createElement(PitcherRole, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand }),
                        enableYears === true && (React.createElement("div", null,
                            React.createElement(YearDropdown, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, yearsSortDescending: yearsSortDescending })))),
                    React.createElement("div", { className: "mx-2 mb-3" },
                        React.createElement(PitchCounts, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand }),
                        React.createElement(PitchResults, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                    React.createElement("div", { className: "mx-2 mb-3 d-flex flex-column" },
                        React.createElement("div", { className: "d-flex" },
                            React.createElement("div", null,
                                React.createElement(PitchZone, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })),
                            React.createElement("div", { className: "d-flex justify-content-center ms-2" },
                                React.createElement("div", null,
                                    React.createElement(PitchLocation, { filter: filter, setFilter: setFilter, isSwitch: isSwitch, availablePitchTypes: availablePitchTypes, availableResultTypes: availableResultTypes, perspective: perspective, hidePitcherHand: hidePitcherHand, hideBatterHand: hideBatterHand })))))))))));
};

const buildSeries$4 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.platex, y: d.platez, id: `strike_zone_${d.id}` }))) })));
const StrikeZone = forwardRef(({ batterHand, showing, resultSeries, pitchTypeSeries, tooltipFormatter, pitchVideoFn, multiVideoFn, }, ref) => {
    const innerResultSeries = useMemo(() => buildSeries$4(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildSeries$4(pitchTypeSeries), [pitchTypeSeries]);
    return (React.createElement(StrikeZone$3, { seriesData: showing === SHOWING_RESULTS_VALUE$1 ? innerResultSeries : innerPitchTypeSeries, pitcherView: true, showlhb: batterHand === 2, tooltipFormatter: tooltipFormatter, hideAxis: true, hideGrid: true, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: ref }));
});

const buildSeries$3 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.ballinplayx, y: d.ballinplayy, visible: !!(d.ballinplayx && d.ballinplayy && d.islastpitch), id: `spray_chart_${d.id}` }))) })));
const SprayChart = forwardRef(({ showing, resultSeries, pitchTypeSeries, tooltipFormatter, pitchVideoFn, multiVideoFn, }, ref) => {
    const innerResultSeries = useMemo(() => buildSeries$3(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildSeries$3(pitchTypeSeries), [pitchTypeSeries]);
    return (React.createElement(SprayChart$3, { type: "outfield", seriesData: showing === SHOWING_RESULTS_VALUE$1 ? innerResultSeries : innerPitchTypeSeries, tooltipFormatter: tooltipFormatter, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, enableZoom: true, ref: ref }));
});

const buildSeries$2 = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.breakx, y: d.breakz, id: `break_chart_${d.id}` }))) })));
const BreakChart = forwardRef(({ showing, resultSeries, pitchTypeSeries, tooltipFormatter, minMaxCoordinate, pitchVideoFn, multiVideoFn, }, ref) => {
    const innerResultSeries = useMemo(() => buildSeries$2(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildSeries$2(pitchTypeSeries), [pitchTypeSeries]);
    return (React.createElement(PitchBreakPlotChart, { pitches: [], seriesData: showing === SHOWING_RESULTS_VALUE$1 ? innerResultSeries : innerPitchTypeSeries, height: 420, width: 420, tooltipFormatter: tooltipFormatter, minMaxCoordinate: minMaxCoordinate, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: ref }));
});

const buildSeries$1 = (series, orderedPitchTypes) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.heading, y: orderedPitchTypes.findIndex((p) => p === (d.fxsubtype || d.pitchtype)), id: `heading_chart_${d.id}` }))) })));
const pitchOrders = [10, 9, 8, 33, 3, 34, 4, 7, 2];
const getPitchOrderValue = (pt) => {
    const index = pitchOrders.indexOf(pt);
    return index > -1 ? index : 100 + pt;
};
const HeadingChart = forwardRef(({ showing, resultSeries, pitchTypeSeries, tooltipFormatter, availablePitchTypes, pitchVideoFn, multiVideoFn, }, ref) => {
    const orderedPitchTypes = useMemo(() => [...availablePitchTypes].sort((a, b) => getPitchOrderValue(+b) - getPitchOrderValue(+a)), [availablePitchTypes]);
    const innerResultSeries = useMemo(() => buildSeries$1(resultSeries, orderedPitchTypes), [resultSeries, orderedPitchTypes]);
    const innerPitchTypeSeries = useMemo(() => buildSeries$1(pitchTypeSeries, orderedPitchTypes), [pitchTypeSeries, orderedPitchTypes]);
    return (React.createElement("div", { className: "flex-shrink-0" },
        React.createElement(HeadingChart$2, { seriesData: showing === SHOWING_RESULTS_VALUE$1 ? innerResultSeries : innerPitchTypeSeries, tooltipFormatter: tooltipFormatter, orderedPitchTypes: orderedPitchTypes, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: ref })));
});

const buildSeries = (series) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.hbat, y: d.vbat, id: `bat_impact_chart_${d.id}` }))) })));
const BatImpactChart = forwardRef(({ batterHand, showing, resultSeries, pitchTypeSeries, tooltipFormatter, pitchVideoFn, multiVideoFn, }, ref) => {
    const innerResultSeries = useMemo(() => buildSeries(resultSeries), [resultSeries]);
    const innerPitchTypeSeries = useMemo(() => buildSeries(pitchTypeSeries), [pitchTypeSeries]);
    return (React.createElement(BatImpactChart$2, { className: "flex-shrink-0", isLhb: batterHand === 2, seriesData: showing === SHOWING_RESULTS_VALUE$1 ? innerResultSeries : innerPitchTypeSeries, tooltipFormatter: tooltipFormatter, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: ref }));
});

const getResultTooltip = (title, p, translate, showBatTracking = false) => {
    var _a, _b, _c, _d, _e, _f;
    return `
    <b>${title}</b><br />\
    ${translate('common.date')}: ${internationalizeDate(translate, p.gamedate)}<br/>\
    ${p.batter_lastname && p.batter_usesname ? `${translate('baseball.batter')}:\
        ${p.batter_usesname} ${p.batter_lastname} (${p.islhb ? 'L' : 'R'})` : ''}<br />\
    ${p.istop ? translate('baseball.abbr-top') : translate('baseball.abbr-bottom')} ${p.inning} |\
    ${translate('baseball.outs', { count: p.outs })}: ${p.outs} | ${translate('baseball.abbr-count')}: ${p.balls}-${p.strikes}<br />\
    ${p.pitchtype ? `${translate('components.hitmon.pitch-type')}: ${pitchTypeDisplayName(p, false, false, translate)}<br />` : ''}\
    ${p.velocity ? `${translate('components.hitmon.pitch-velo')}: ${format(p.velocity, 1)} mph<br />` : ''}\
    ${p.gyrodegree ? `${translate('components.pitcher-trends.gyrodegree')}: ${format(p.gyrodegree)}<br />` : ''}\
    ${p.spindirectionclock ? `${translate('sections.reports.pitcher.spin-dir')}: ${p.spindirectionclock}<br />` : ''}\
    ${translate('baseball.break-x')}: ${format(p.breakx, 1)}<br />\
    ${translate('baseball.break-z')}: ${format(p.breakz, 1)}<br />\
    ${p.rvstuff ? `${translate('sections.reports.pitcher.stuff-era')}: ${format(rvERA(p.rvstuff), 2)}<br />` : ''}\
    ${p.rvpitchfx ? `${translate('sections.reports.pitcher.pfx-era')}: ${format(rvERA(p.rvpitchfx), 2)}<br />` : ''}\
    ${p.expstk_all ? `${translate('components.hitmon.abbr-strike-prob')}: ${percent(p.expstk_all, 1)}<br />` : ''}\
    ${p.bip ? `${translate('components.hitmon.abbr-exit-velo')}:
        ${p.exitvelo ? translate('format.abbr-mph', { value: format(p.exitvelo, 1) }) : '--'}<br />` : ''}\
    ${showBatTracking
        ? `${translate('components.charts.heading')}: ${(_b = (_a = p.heading) === null || _a === void 0 ? void 0 : _a.toFixed(1)) !== null && _b !== void 0 ? _b : '-'}<br />\
            ${translate('components.pitcher-trends.vbat')}: ${(_d = (_c = p.vbat) === null || _c === void 0 ? void 0 : _c.toFixed(1)) !== null && _d !== void 0 ? _d : '-'}<br />\
            ${translate('components.pitcher-trends.hbat')}: ${(_f = (_e = p.hbat) === null || _e === void 0 ? void 0 : _e.toFixed(1)) !== null && _f !== void 0 ? _f : '-'}`
        : ''}\
`;
};
const getPitchTypeTooltip = (title, p, translate, showBatTracking = false) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return `
    <b>${title}</b><br />\
    ${translate('common.date')}: ${internationalizeDate(translate, p.gamedate)}<br/>\
    ${p.batter_lastname && p.batter_usesname ? `${translate('baseball.batter')}:\
        ${p.batter_usesname} ${p.batter_lastname} (${p.islhb ? 'L' : 'R'})` : ''}<br />\
    ${p.istop ? translate('baseball.abbr-top') : translate('baseball.abbr-bottom')} ${p.inning} |\
    ${translate('baseball.outs', { count: p.outs })}: ${p.outs} | ${translate('baseball.abbr-count')}: ${p.balls}-${p.strikes}<br />\
    ${p.hitmonresulttype ? `${translate('sections.reports.pitcher.result')}:\
        ${(_a = RESULT_TYPES$1(translate).find((rt) => rt.id === p.hitmonresulttype)) === null || _a === void 0 ? void 0 : _a.name}<br />` : ''}\
    ${p.velocity ? `${translate('components.hitmon.pitch-velo')}: ${format(p.velocity, 1)} mph<br />` : ''}\
    ${p.gyrodegree ? `${translate('components.pitcher-trends.gyrodegree')}: ${format(p.gyrodegree)}<br />` : ''}\
    ${p.spindirectionclock ? `${translate('sections.reports.pitcher.spin-dir')}: ${p.spindirectionclock}<br />` : ''}\
    ${translate('baseball.break-x')}: ${format(p.breakx, 1)}<br />\
    ${translate('baseball.break-z')}: ${format(p.breakz, 1)}<br />\
    ${p.rvstuff ? `${translate('sections.reports.pitcher.stuff-era')}: ${format(rvERA(p.rvstuff), 2)}<br />` : ''}\
    ${p.rvpitchfx ? `${translate('sections.reports.pitcher.pfx-era')}: ${format(rvERA(p.rvpitchfx), 2)}<br />` : ''}\
    ${p.expstk_all ? `${translate('components.hitmon.abbr-strike-prob')}: ${percent(p.expstk_all, 1)}<br />` : ''}\
    ${p.bip ? `${translate('components.hitmon.abbr-exit-velo')}:
        ${p.exitvelo ? translate('format.abbr-mph', { value: format(p.exitvelo, 1) }) : '--'}<br />` : ''}\
    ${showBatTracking
        ? `${translate('components.charts.heading')}: ${(_c = (_b = p.heading) === null || _b === void 0 ? void 0 : _b.toFixed(1)) !== null && _c !== void 0 ? _c : '-'}<br />\
            ${translate('components.pitcher-trends.vbat')}: ${(_e = (_d = p.vbat) === null || _d === void 0 ? void 0 : _d.toFixed(1)) !== null && _e !== void 0 ? _e : '-'}<br />\
            ${translate('components.pitcher-trends.hbat')}: ${(_g = (_f = p.hbat) === null || _f === void 0 ? void 0 : _f.toFixed(1)) !== null && _g !== void 0 ? _g : '-'}`
        : ''}\
`;
};

/* eslint-disable react/no-this-in-sfc */
const buildResultsSeries = (translate, pitches, mouseOver, mouseOut) => {
    const resultSeries = [
        {
            hitmonResultType: 1,
            color: '#0000ff',
            marker: {
                symbol: 'diamond',
                radius: 4,
                lineColor: '#0000ff',
                fillColor: '#ffffff',
                lineWidth: 2,
                states: { hover: { radiusPlus: 10, lineColor: '#0000ff' } },
            },
            data: [],
        },
        {
            hitmonResultType: 2,
            color: '#0000ff',
            marker: { symbol: 'triangle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
            data: [],
        },
        {
            hitmonResultType: 3,
            color: '#00ff00',
            marker: { symbol: 'circle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
            data: [],
        },
        {
            hitmonResultType: 4,
            color: '#ff0000',
            marker: { symbol: 'circle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
            data: [],
        },
        {
            hitmonResultType: 5,
            color: '#ff0000',
            marker: { symbol: 'diamond', radius: 6, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
            data: [],
        },
        {
            hitmonResultType: 6,
            color: '#ff0000',
            marker: {
                symbol: 'square',
                radius: 4,
                lineColor: '#ff0000',
                fillColor: '#ffffff',
                lineWidth: 2,
                states: { hover: { radiusPlus: 10, lineColor: '#ff0000' } }
            },
            data: [],
        },
        {
            hitmonResultType: 7,
            color: '#ffa500',
            marker: {
                symbol: 'diamond',
                radius: 4,
                lineColor: '#ffa500',
                fillColor: '#ffffff',
                lineWidth: 2,
                states: { hover: { radiusPlus: 10, lineColor: '#ffa500' } },
            },
            data: [],
        },
        {
            hitmonResultType: 8,
            color: '#ffa500',
            marker: { symbol: 'triangle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
            data: [],
        },
    ].map((s) => {
        var _a, _b;
        const hitmonResultType = RESULT_TYPES$1(translate).find((rt) => rt.id === s.hitmonResultType);
        return Object.assign(Object.assign({}, s), { id: (_a = hitmonResultType === null || hitmonResultType === void 0 ? void 0 : hitmonResultType.name) !== null && _a !== void 0 ? _a : '', name: (_b = hitmonResultType === null || hitmonResultType === void 0 ? void 0 : hitmonResultType.name) !== null && _b !== void 0 ? _b : '', point: {
                events: {
                    mouseOver,
                    mouseOut,
                },
            } });
    });
    pitches.forEach((p) => {
        var _a;
        (_a = resultSeries[p.hitmonresulttype - 1]) === null || _a === void 0 ? void 0 : _a.data.push({
            id: p.id,
            pitchtype: p.pitchtype,
            fxsubtype: p.fxsubtype,
            platex: p.platex,
            platez: p.platez,
            breakx: p.breakx,
            breakz: p.breakz,
            bip: p.bip,
            ballinplayx: p.ballinplayx,
            ballinplayy: p.ballinplayy,
            islastpitch: p.islastpitch,
            gameid: p.gameid,
            eventseq: p.eventseq,
            pitchseq: p.pitchseq,
            hbat: p.hbat,
            vbat: p.vbat,
            heading: p.heading,
        });
    });
    return resultSeries;
};
const buildPitchTypesSeries = (translate, pitches, availablePitchTypes, mouseOver, mouseOut) => availablePitchTypes
    .map((apt) => {
    var _a, _b, _c, _d, _e, _f;
    const pitchType = PITCH_TYPES_HITMON(translate).find((pt) => pt.id % 1000 === apt);
    return {
        id: (_a = pitchType === null || pitchType === void 0 ? void 0 : pitchType.name) !== null && _a !== void 0 ? _a : '',
        name: (_b = pitchType === null || pitchType === void 0 ? void 0 : pitchType.name) !== null && _b !== void 0 ? _b : '',
        color: pitchSubTypeColor({
            type: ((_c = pitchType === null || pitchType === void 0 ? void 0 : pitchType.id) !== null && _c !== void 0 ? _c : 0) > 1000 ? Math.floor(((_d = pitchType === null || pitchType === void 0 ? void 0 : pitchType.id) !== null && _d !== void 0 ? _d : 0) / 1000) : pitchType === null || pitchType === void 0 ? void 0 : pitchType.id,
            fxsubtype: ((_e = pitchType === null || pitchType === void 0 ? void 0 : pitchType.id) !== null && _e !== void 0 ? _e : 0) > 1000 ? ((_f = pitchType === null || pitchType === void 0 ? void 0 : pitchType.id) !== null && _f !== void 0 ? _f : 0) % 1000 : null,
        }),
        marker: { symbol: 'circle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
        point: {
            events: {
                mouseOver,
                mouseOut,
            },
        },
        data: pitches.filter((p) => (pitchType === null || pitchType === void 0 ? void 0 : pitchType.id) === (p.fxsubtype != null && p.fxsubtype > 0 ? (p.pitchtype * 1000) + p.fxsubtype : p.pitchtype))
            .map((p) => ({
            id: p.id,
            pitchtype: p.pitchtype,
            fxsubtype: p.fxsubtype,
            platex: p.platex,
            platez: p.platez,
            breakx: p.breakx,
            breakz: p.breakz,
            bip: p.bip,
            ballinplayx: p.ballinplayx,
            ballinplayy: p.ballinplayy,
            islastpitch: p.islastpitch,
            gameid: p.gameid,
            eventseq: p.eventseq,
            pitchseq: p.pitchseq,
            hbat: p.hbat,
            vbat: p.vbat,
            heading: p.heading,
        })),
    };
});
const AllCharts = ({ batterHand, showing, pitches, pitchVideoFn, multiVideoFn, tooltipFormatter, minMaxBreakChartCoordinate, availablePitchTypes, hideBatTrackingStats, }) => {
    const { t: translate } = useTranslation();
    const strikeZoneRef = useRef(null);
    const sprayChartRef = useRef(null);
    const breakChartRef = useRef(null);
    const headingChartRef = useRef(null);
    const batImpactChartRef = useRef(null);
    const mouseOver = function mouseOver() {
        var _a, _b, _c, _d, _e;
        const seriesIndex = this.series.index;
        const dataIndex = this.index;
        (_a = strikeZoneRef.current) === null || _a === void 0 ? void 0 : _a.hoverPoint(seriesIndex, dataIndex);
        if (this.bip) {
            (_b = sprayChartRef.current) === null || _b === void 0 ? void 0 : _b.hoverPoint(seriesIndex, dataIndex);
        }
        (_c = breakChartRef.current) === null || _c === void 0 ? void 0 : _c.hoverPoint(seriesIndex, dataIndex);
        if (this.heading) {
            (_d = headingChartRef.current) === null || _d === void 0 ? void 0 : _d.hoverPoint(seriesIndex, dataIndex);
        }
        if (this.vbat && this.hbat) {
            (_e = batImpactChartRef.current) === null || _e === void 0 ? void 0 : _e.hoverPoint(seriesIndex, dataIndex);
        }
    };
    const mouseOut = function mouseOut() {
        var _a, _b, _c, _d, _e;
        const seriesIndex = this.series.index;
        const dataIndex = this.index;
        (_a = strikeZoneRef.current) === null || _a === void 0 ? void 0 : _a.resetHoverPoint(seriesIndex, dataIndex);
        if (this.bip) {
            (_b = sprayChartRef.current) === null || _b === void 0 ? void 0 : _b.resetHoverPoint(seriesIndex, dataIndex);
        }
        (_c = breakChartRef.current) === null || _c === void 0 ? void 0 : _c.resetHoverPoint(seriesIndex, dataIndex);
        if (this.heading) {
            (_d = headingChartRef.current) === null || _d === void 0 ? void 0 : _d.resetHoverPoint(seriesIndex, dataIndex);
        }
        if (this.vbat && this.hbat) {
            (_e = batImpactChartRef.current) === null || _e === void 0 ? void 0 : _e.resetHoverPoint(seriesIndex, dataIndex);
        }
    };
    const resultSeries = useMemo(() => buildResultsSeries(translate, pitches, mouseOver, mouseOut), [translate, pitches]);
    const pitchTypeSeries = useMemo(() => buildPitchTypesSeries(translate, pitches, availablePitchTypes, mouseOver, mouseOut), [translate, pitches, availablePitchTypes]);
    const getInnerTooltipFormatter = (showBatTracking = false) => (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        return (showing === SHOWING_RESULTS_VALUE$1 ? getResultTooltip(series.name, pitch, translate, showBatTracking)
            : getPitchTypeTooltip(series.name, pitch, translate, showBatTracking));
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "d-flex flex-wrap justify-content-around align-items-center" },
            React.createElement("div", { className: "d-flex flex-column align-items-center mb-3 mx-2 justify-content-center" },
                React.createElement(StrikeZone, { ref: strikeZoneRef, batterHand: batterHand, showing: showing, resultSeries: resultSeries !== null && resultSeries !== void 0 ? resultSeries : [], pitchTypeSeries: pitchTypeSeries !== null && pitchTypeSeries !== void 0 ? pitchTypeSeries : [], tooltipFormatter: tooltipFormatter || getInnerTooltipFormatter(), pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn })),
            React.createElement("div", { className: "mb-5" },
                React.createElement(SprayChart, { ref: sprayChartRef, showing: showing, resultSeries: resultSeries !== null && resultSeries !== void 0 ? resultSeries : [], pitchTypeSeries: pitchTypeSeries !== null && pitchTypeSeries !== void 0 ? pitchTypeSeries : [], tooltipFormatter: tooltipFormatter || getInnerTooltipFormatter(), pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn })),
            React.createElement(BreakChart, { ref: breakChartRef, showing: showing, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter || getInnerTooltipFormatter(), minMaxCoordinate: minMaxBreakChartCoordinate, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn })),
        !hideBatTrackingStats && (React.createElement("div", { className: "d-flex flex-wrap justify-content-center align-items-end mt-5" },
            React.createElement(HeadingChart, { ref: headingChartRef, showing: showing, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter || getInnerTooltipFormatter(true), availablePitchTypes: availablePitchTypes.map((pt) => pt % 1000), pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn }),
            React.createElement("div", { style: { width: 200, flexShrink: 1 } }),
            React.createElement(BatImpactChart, { ref: batImpactChartRef, batterHand: batterHand, showing: showing, resultSeries: resultSeries, pitchTypeSeries: pitchTypeSeries, tooltipFormatter: tooltipFormatter || getInnerTooltipFormatter(true), pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn })))));
};

const getColumns$1 = (translate, showLevelAverages, isLhp, hideBatTrackingStats, onPlayAll) => [
    ...(onPlayAll
        ? [{ id: 'playAll', type: COLUMN_TYPES.NODE, transform: (row) => (row.abbr ? ' ' : React.createElement(VideoButton, { color: "#244c74", onClick: onPlayAll })) }]
        : []),
    ...(showLevelAverages ? [{
            id: 'abbr',
            title: '',
            type: COLUMN_TYPES.NODE,
            transform: (row) => (row.abbr ? `${isLhp ? translate('baseball.lhp') : translate('baseball.rhp')} ${row.abbr} Avg` : ''),
        }] : []),
    { id: 'pitches', title: translate('baseball.pitches_other') },
    { id: 'velocity', title: translate('sections.reports.pitcher.abbr-velo'), transform: (r) => ratio(r.velocity, r.pitches), precision: 1 },
    { id: 'breakx', title: translate('baseball.break-x'), statistic: 'BreakX', transform: (r) => ratio(r.breakx, r.pitches), precision: 1 },
    { id: 'breakz', title: translate('baseball.break-z'), statistic: 'BreakZ', transform: (r) => ratio(r.breakz, r.pitches), precision: 1 },
    { id: 'spin', title: translate('data.spin-rate'), statistic: 'SpinRate', transform: (r) => ratio(r.spinrate, r.pitches) },
    {
        id: 'kzon',
        title: translate('baseball.abbr-strikezone'),
        statistic: 'KZon',
        type: COLUMN_TYPES.PERCENT,
        transform: (r) => ratio(r.inz, r.inz + r.outz),
    },
    {
        id: 'ch',
        title: translate('components.hitmon.abbr-chase-pct'),
        statistic: 'Ch',
        type: COLUMN_TYPES.PERCENT,
        transform: (r) => ratio(r.ch, r.outz),
    },
    { id: 'swdec', title: translate('baseball.abbr-swingdecision'), statistic: 'Swds', transform: (r) => ratio(r.swds, r.swdspit), precision: 1 },
    {
        id: 'stk',
        title: translate('sections.reports.pitcher.abbr-strike'),
        statistic: 'Stk',
        type: COLUMN_TYPES.PERCENT,
        transform: (r) => ratio(r.stk, r.pitches),
    },
    {
        id: 'ms',
        title: translate('sections.reports.pitcher.abbr-miss'),
        statistic: 'Ms',
        type: COLUMN_TYPES.PERCENT,
        transform: (r) => ratio(r.ms, r.sw),
    },
    {
        id: 'gb',
        title: translate('baseball.abbr-groundball-pct'),
        statistic: 'GBPercent',
        type: COLUMN_TYPES.PERCENT,
        transform: (r) => ratio(r.gb, r.bip),
    },
    {
        id: 'cr',
        title: 'CR',
        statistic: 'ContactResults',
        transform: (r) => (r.biprvdenom > 0 ? normalize(r.rvhitfxactualbip, r.biprvdenom, 100) : null),
        precision: 1,
    },
    {
        id: 'cq',
        title: 'CQ',
        statistic: 'ContactQuality',
        transform: (r) => (r.biprvdenom > 0 ? normalize(r.rvhitfxpitbip, r.biprvdenom, 100) : null),
        precision: 1,
    },
    ...(hideBatTrackingStats ? [] : [{ id: 'trkswg', title: 'Trk Swg', statistic: 'TrackedSwings', transform: (r) => r.pwbatspdinz + r.pwbatspdoutz },
        {
            id: 'head',
            title: 'Head',
            statistic: 'Heading',
            transform: (r) => ratio(r.fbhead + r.nfbhead, r.pwfbhead + r.pwnfbhead),
            precision: 1,
        },
        {
            id: 'headplusminus',
            title: 'Head +/-',
            statistic: 'HeadPMPit',
            // transform: (r: StatRow) => ((r.pwadjhead ?? 0) === 0 ? null : (ratio(r.fbhead + r.nfbhead, r.pwfbhead + r.pwnfbhead) ?? 0) - (ratio(r.adjhead, r.pwadjhead) ?? 0)),
            transform: (r) => { var _a, _b; return (((_a = r.pwheadpm) !== null && _a !== void 0 ? _a : 0) === 0 ? null : (_b = ratio(r.headpm, r.pwheadpm)) !== null && _b !== void 0 ? _b : 0); },
            precision: 1,
        },
        { id: 'hbat', title: 'Hbat', statistic: 'Hbat', transform: (r) => ratio(r.hbat, r.pwhbat), precision: 2 },
        { id: 'vbat', title: 'Vbat', statistic: 'Vbat', transform: (r) => ratio(r.vbat, r.pwvbat), precision: 2 },
        {
            id: 'baraccbip',
            title: 'Bar Acc BIP',
            statistic: 'BarrelAccuracy',
            headerClass: 'border-end',
            cellClass: 'border-end',
            transform: (r) => rvPerN(r.barracc, r.pawbarracc, 100),
            precision: 1,
        }]),
    { id: 'rvera', title: 'RV ERA', statistic: 'rvERA', transform: (r) => { var _a; return rvERA((_a = ratio(r.rvactual, r.pitches)) !== null && _a !== void 0 ? _a : 0); }, precision: 2 },
    { id: 'ervera', title: 'eRV ERA', statistic: 'eRVERA', transform: (r) => { var _a; return rvERA((_a = ratio(r.ervpitch, r.pitches)) !== null && _a !== void 0 ? _a : 0); }, precision: 2 },
    { id: 'pitchfxera', title: 'PFX ERA', statistic: 'PitchFXERA', transform: (r) => { var _a; return rvERA((_a = ratio(r.rvpitchfx, r.pitches)) !== null && _a !== void 0 ? _a : 0); }, precision: 2 },
];
const getRows$2 = (pitches = [], levelAverages) => [pitches.reduce((all, p) => {
        var _a, _b, _c, _d;
        all.pitches += 1;
        all.velocity += p.velocity;
        all.inz += p.inz;
        all.outz += p.outz;
        all.breakx += p.breakx;
        all.breakz += p.breakz;
        all.spinrate += p.spinrate;
        all.ch += p.ch;
        all.swds += p.swds;
        all.swdspit += p.swdspit;
        all.stk += p.stk;
        all.ms += p.ms;
        all.sw += p.sw;
        all.gb += p.gb;
        all.bip += p.bip;
        all.biprvdenom += p.biprvdenom;
        all.rvhitfxactualbip += p.rvhitfxactualbip;
        all.rvhitfxpitbip += p.rvhitfxpitbip;
        all.pwbatspdinz += p.pwbatspdinz;
        all.pwbatspdoutz += p.pwbatspdoutz;
        all.fbhead += p.fbhead;
        all.nfbhead += p.nfbhead;
        all.pwfbhead += p.pwfbhead;
        all.pwnfbhead += p.pwnfbhead;
        all.hbat += p.hbat;
        all.pwhbat += isNumber$3(p.hbat) ? 1 : 0;
        all.pwvbat += isNumber$3(p.vbat) ? 1 : 0;
        all.vbat += p.vbat;
        all.barracc += p.barracc;
        all.pawbarracc += p.pawbarracc;
        all.rvactual += p.rvactual;
        all.ervpitch += p.ervpitch;
        all.rvpitchfx += p.rvpitchfx;
        all.adjhead += p.adjhead;
        all.pwadjhead += (_a = p.pwadjhead) !== null && _a !== void 0 ? _a : 0;
        all.headpm += (isNumber$3((_b = p.fbhead) !== null && _b !== void 0 ? _b : p.nfbhead) && isNumber$3(p.adjhead)) ? ((_c = p.fbhead) !== null && _c !== void 0 ? _c : p.nfbhead) - p.adjhead : 0;
        all.pwheadpm += (isNumber$3((_d = p.fbhead) !== null && _d !== void 0 ? _d : p.nfbhead) && isNumber$3(p.adjhead)) ? 1 : 0;
        return all;
    }, {
        pitches: 0,
        velocity: 0,
        breakx: 0,
        breakz: 0,
        spinrate: 0,
        inz: 0,
        outz: 0,
        ch: 0,
        swds: 0,
        swdspit: 0,
        stk: 0,
        ms: 0,
        sw: 0,
        gb: 0,
        bip: 0,
        biprvdenom: 0,
        rvhitfxactualbip: 0,
        rvhitfxpitbip: 0,
        pwbatspdinz: 0,
        pwbatspdoutz: 0,
        fbhead: 0,
        nfbhead: 0,
        pwfbhead: 0,
        pwnfbhead: 0,
        hbat: 0,
        vbat: 0,
        pwhbat: 0,
        pwvbat: 0,
        barracc: 0,
        pawbarracc: 0,
        rvactual: 0,
        ervpitch: 0,
        rvpitchfx: 0,
        adjhead: 0,
        pwadjhead: 0,
        headpm: 0,
        pwheadpm: 0,
    })].concat(levelAverages);
const StatsTable = ({ pitches, isLoadingLevelAverages, levelAverages, enableLevelAverages = false, getLevelAverages, levels, statTooltip, isLhp, hideBatTrackingStats = false, enablePlayAllInStatsTable, videoPlayerModal: VideoPlayerModal, modalContainer, multiVideoFn, }) => {
    const { t: translate } = useTranslation();
    const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false);
    const [videoPlaylist, setVideoPlaylist] = useState(null);
    const innerMultiVideoFn = (playlistPitches) => __awaiter(void 0, void 0, void 0, function* () {
        setIsVideoPlayerOpen(true);
        try {
            setVideoPlaylist(null);
            const playlist = yield multiVideoFn(playlistPitches.map((p) => ({ gameid: p.gameid, eventseq: p.eventseq, pitchseq: p.pitchseq })));
            setVideoPlaylist(playlist);
            return playlist;
        }
        catch (_a) {
            setIsVideoPlayerOpen(false);
        }
        return [];
    });
    return (React.createElement("div", { className: "text-center" },
        React.createElement(DataTable, { columns: getColumns$1(translate, !!levelAverages.length, isLhp, hideBatTrackingStats, enablePlayAllInStatsTable ? () => innerMultiVideoFn(pitches) : undefined), rows: getRows$2(pitches, levelAverages), statTooltip: statTooltip, rowClass: (r) => ('abbr' in r && !!r.abbr ? 'fw-bold' : '') }),
        !levelAverages.length && enableLevelAverages && (React.createElement("div", { style: { border: '1px solid #ADB0B2', borderTop: 0 }, className: "p-1" }, isLoadingLevelAverages ? React.createElement(LoadingSpinner$1, { size: "sm", style: { margin: '3px 0' } }) : (React.createElement(Button, { variant: "primary", onClick: getLevelAverages, disabled: !levels.filter((l) => l !== 7).length }, translate('components.hitmon.get-level-averages'))))),
        VideoPlayerModal && enablePlayAllInStatsTable && (React.createElement(VideoPlayerModal, { show: isVideoPlayerOpen, onHide: () => setIsVideoPlayerOpen(false), playlist: videoPlaylist, container: modalContainer }))));
};

const PitchingMonitor = ({ liveFilter, setLiveFilter, pitches, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, tooltipFormatter, maxPAs, levels, enableLevelAverages, getLevelAverages, statTooltip, levelAveragesAbortController, isLhp = false, hideBatTrackingStats = false, enablePlayAllInStatsTable = false, }) => {
    const { t: translate } = useTranslation();
    const [filteredPitches, setFilteredPitches] = useState([]);
    const [isLoadingLevelAverages, setIsLoadingLevelAverages] = useState(false);
    const [levelAverages, setLevelAverages] = useState([]);
    const { cleanPitches, cleanPitchMap } = useMemo(() => getCleanPitches(pitches), [pitches]);
    const availablePitchTypes = useMemo(() => new Set(cleanPitches.map((p) => p.fxsubtype || p.pitchtype)), [cleanPitches]);
    const filterAvailablePitchTypes = useMemo(() => new Set(cleanPitches
        .map((p) => (p.fxsubtype != null && p.fxsubtype !== 0 ? (p.pitchtype * 1000) + p.fxsubtype : p.pitchtype))), [cleanPitches]);
    const availableResultTypes = useMemo(() => new Set(cleanPitches.map((p) => p.hitmonresulttype)), [cleanPitches]);
    const parks = useMemo(() => Array.from(cleanPitches.reduce((all, p) => {
        if (p.venueid && !all.has(p.venueid)) {
            all.set(p.venueid, { venueid: p.venueid, venuename: p.venuename });
        }
        return all;
    }, new Map()).values()).sort((a, b) => (a.venuename.localeCompare(b.venuename))), [cleanPitches]);
    const minMaxBreakChartCoordinate = useMemo(() => Math.ceil((pitches !== null && pitches !== void 0 ? pitches : [])
        .reduce((max, p) => Math.max(max, Math.abs(p.breakx || 0), Math.abs(p.breakz || 0)), 0) + 1), [pitches]);
    useEffect(() => {
        setFilteredPitches(filterPitches(cleanPitchMap, liveFilter));
        setLevelAverages([]);
        if (levelAveragesAbortController) {
            levelAveragesAbortController.abort();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cleanPitchMap, liveFilter]);
    useEffect(() => {
        if (maxPAs)
            setLiveFilter(Object.assign(Object.assign({}, liveFilter), { lastPAs: maxPAs }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [maxPAs]);
    useEffect(() => {
        if (liveFilter.park && liveFilter.park > 0 && !parks.some((p) => p.venueid === liveFilter.park)) {
            setLiveFilter(Object.assign(Object.assign({}, liveFilter), { park: ALL_VALUE$1 }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parks]);
    const innerGetLevelAverages = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoadingLevelAverages(true);
            const response = yield getLevelAverages();
            setLevelAverages(response.levelaverages);
        }
        finally {
            setIsLoadingLevelAverages(false);
        }
    });
    const innerTooltipFormatter = (series, point) => {
        const pitch = cleanPitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch)
            return '';
        return (liveFilter.showing === SHOWING_RESULTS_VALUE$1 ? getResultTooltip(series.name, pitch, translate)
            : getPitchTypeTooltip(series.name, pitch, translate));
    };
    return (React.createElement("div", null,
        React.createElement(HittingMonitorFilter, { hideBatterHand: false, hidePitcherHand: true, isSwitch: true, filter: liveFilter, setFilter: setLiveFilter, availablePitchTypes: filterAvailablePitchTypes, availableResultTypes: availableResultTypes, perspective: PERSPECTIVE_TYPES$1.pitcher, maxPAs: maxPAs, parks: parks }),
        React.createElement("div", { className: "mt-4" }, [SHOWING_RESULTS_VALUE$1, SHOWING_PITCH_TYPES_VALUE$1].includes(liveFilter.showing)
            ? (React.createElement(AllCharts, { pitches: filteredPitches, batterHand: liveFilter.batterHand, showing: liveFilter.showing, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, tooltipFormatter: tooltipFormatter, minMaxBreakChartCoordinate: minMaxBreakChartCoordinate, availablePitchTypes: Array.from(availablePitchTypes), hideBatTrackingStats: hideBatTrackingStats }))
            : (React.createElement(GridCharts, { pitches: filteredPitches, batterHand: liveFilter.batterHand, perspective: PERSPECTIVE_TYPES$1.pitcher, setPerspective: () => { }, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, hidePerspectiveToggle: true, tooltipFormatter: tooltipFormatter || innerTooltipFormatter, availablePitchTypes: Array.from(filterAvailablePitchTypes) }))),
        React.createElement("div", { className: "mt-4" },
            React.createElement(StatsTable, { pitches: filteredPitches, isLoadingLevelAverages: isLoadingLevelAverages, levelAverages: levelAverages, enableLevelAverages: enableLevelAverages, getLevelAverages: innerGetLevelAverages, statTooltip: statTooltip, levels: levels, isLhp: isLhp, hideBatTrackingStats: hideBatTrackingStats, enablePlayAllInStatsTable: enablePlayAllInStatsTable, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, multiVideoFn: multiVideoFn }))));
};

var defaultFilter = {
    showing: 0,
    baseState: ALL_VALUE$1,
    counts: [ALL_VALUE$1],
    result: RESULT_TYPES$1(null).map((rt) => rt.id),
    pitchTypes: [ALL_VALUE$1],
    pitcherHand: ALL_VALUE$1,
    batterHand: 1,
    zoneLocation: ALL_VALUE$1,
    pitchLocation: [],
    minVelo: '',
    maxVelo: '',
    minLa: '',
    maxLa: '',
    minEv: '',
    maxEv: '',
    minHorizLa: '',
    maxHorizLa: '',
    minBreakX: '',
    maxBreakX: '',
    minBreakZ: '',
    maxBreakZ: '',
    minArmAngle: '',
    maxArmAngle: '',
    minGyroDegree: '',
    maxGyroDegree: '',
    pitcherRole: ALL_VALUE$1,
    balls: [],
    strikes: [],
    minRelX: '',
    maxRelX: '',
    minRelZ: '',
    maxRelZ: '',
    startDate: undefined,
    endDate: undefined,
    lastPAs: 100,
    park: ALL_VALUE$1,
};

const DATE_RANGE = {
    ONE_MONTH: 1,
    THREE_MONTHS: 2,
    ONE_YEAR: 3,
    YTD: 4,
    TWO_YEARS: 5,
    THREE_YEARS: 6,
    FIVE_YEARS: 7,
    ONE_WEEK: 8,
    THREE_WEEKS: 9,
};
const SCALE_GROUP = {
    OPS: 1,
    PERCENT: 2,
    VELOCITY: 3,
    DEGREES: 4,
    SCORE: 5,
    MILLISECONDS: 6,
    INCHES: 7,
    BARREL_RELEASE_EFFICIENCY: 8,
    STAB_INDEX: 9,
    WEIGHT: 10,
    VELOCITY_METRIC: 11,
    FORCE: 12,
    POWER: 13,
    BODYWEIGHTS: 14,
    PERCENT_DIFF: 15,
};
const pitchGroupMap = {
    1: 'FB',
    2: 'BB',
    3: 'OS',
};
const chartColors$1 = [
    '#3366cc',
    '#dc3912',
    '#ff9900',
    '#109618',
    '#990099',
    '#0099c6',
    '#dd4477',
    '#66aa00',
    '#b82e2e',
    '#316395',
    '#994499',
    '#22aa99',
    '#aaaa11',
    '#6633cc',
    '#e67300',
    '#8b0707',
    '#651067',
    '#329262',
    '#5574a6',
    '#3b3eac',
    '#b77322',
    '#16d620',
    '#b91383',
    '#f4359e',
    '#9c5935',
    '#a9c413',
    '#2a778d',
    '#668d1c',
    '#bea413',
    '#0c5922',
    '#743411',
];
const trendStats = (translate, showBatTracking) => [
    {
        id: 'hfx',
        name: translate('components.trends.hitfx-ops'),
        transformTrend: (t) => opsRV(t.rvheops, t.pawrv + 0.0),
        formatter: (v) => format(v, true),
        scaleGroup: SCALE_GROUP.OPS,
        keyField: 'rvheops',
    }, {
        id: 'hfx-rhp',
        name: `${translate('components.trends.hitfx-ops')} ${translate('baseball.vs-rhp')}`,
        transformTrend: (t) => opsRV(t.rvheops_rhp, t.pawrv_rhp + 0.0),
        formatter: (v) => format(v, true),
        scaleGroup: SCALE_GROUP.OPS,
        keyField: 'rvheops_rhp',
    }, {
        id: 'hfx-lhp',
        name: `${translate('components.trends.hitfx-ops')} ${translate('baseball.vs-lhp')}`,
        transformTrend: (t) => opsRV(t.rvheops_lhp, t.pawrv_lhp + 0.0),
        formatter: (v) => format(v, true),
        scaleGroup: SCALE_GROUP.OPS,
        keyField: 'rvheops_lhp',
    }, {
        id: 'age-adj',
        name: `${translate('components.trends.abbr-age-adjusted')} ${translate('components.trends.hitfx-ops')}`,
        transformTrend: (t) => (t.rvaaops === null ? null : opsRV(t.rvaaops, t.pawrv + 0.0)),
        formatter: (v) => format(v, true),
        scaleGroup: SCALE_GROUP.OPS,
        keyField: 'rvaaops',
    }, {
        id: 'age-adj-rhp',
        name: `${translate('components.trends.abbr-age-adjusted')} ${translate('components.trends.hitfx-ops')} ${translate('baseball.vs-rhp')}`,
        transformTrend: (t) => (t.rvaaops_rhp === null ? null : opsRV(t.rvaaops_rhp, t.pawrv_rhp + 0.0)),
        formatter: (v) => format(v, true),
        scaleGroup: SCALE_GROUP.OPS,
        keyField: 'rvaaops_rhp',
    }, {
        id: 'age-adj-lhp',
        name: `${translate('components.trends.abbr-age-adjusted')} ${translate('components.trends.hitfx-ops')} ${translate('baseball.vs-lhp')}`,
        transformTrend: (t) => (t.rvaaops_lhp === null ? null : opsRV(t.rvaaops_lhp, t.pawrv_lhp + 0.0)),
        formatter: (v) => format(v, true),
        scaleGroup: SCALE_GROUP.OPS,
        keyField: 'rvaaops_lhp',
    }, {
        id: 'ubb',
        name: `${translate('baseball.abbr-walk-ubb')}%`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.ubb, t.pa),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'ubb-rhp',
        name: `${translate('baseball.abbr-walk-ubb')}% ${translate('baseball.vs-rhp')}`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.ubb_rhp, t.pa_rhp),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'ubb-lhp',
        name: `${translate('baseball.abbr-walk-ubb')}% ${translate('baseball.vs-lhp')}`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.ubb_lhp, t.pa_lhp),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'k',
        name: `${translate('baseball.abbr-strikeout-k')}%`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.so, t.pa),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'k-rhp',
        name: `${translate('baseball.abbr-strikeout-k')}% ${translate('baseball.vs-rhp')}`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.so_rhp, t.pa_rhp),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'k-lhp',
        name: `${translate('baseball.abbr-strikeout-k')}% ${translate('baseball.vs-lhp')}`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.so_lhp, t.pa_lhp),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'contactquality-rhp',
        name: `${translate('components.trends.contact-quality')} ${translate('baseball.vs-rhp')}`,
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => rvPerN(t.rvheopsbip_rhp, t.biprvdenom_rhp, 100),
        formatter: (v) => format(v, 1),
        keyField: 'rvheopsbip_rhp',
    }, {
        id: 'contactquality-lhp',
        name: `${translate('components.trends.contact-quality')} ${translate('baseball.vs-lhp')}`,
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => rvPerN(t.rvheopsbip_lhp, t.biprvdenom_lhp, 100),
        formatter: (v) => format(v, 1),
        keyField: 'rvheopsbip_lhp',
    }, {
        id: 'ageadjcontactquality-rhp',
        name: `${translate('components.trends.abbr-age-adjusted')} ${translate('components.trends.contact-quality')} ${translate('baseball.vs-rhp')}`,
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => rvPerN(t.rvaaopsbip_rhp, t.biprvdenom_rhp, 100),
        formatter: (v) => format(v, 1),
        keyField: 'rvaaopsbip_rhp',
    }, {
        id: 'ageadjcontactquality-lhp',
        name: `${translate('components.trends.abbr-age-adjusted')} ${translate('components.trends.contact-quality')} ${translate('baseball.vs-lhp')}`,
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => rvPerN(t.rvaaopsbip_lhp, t.biprvdenom_lhp, 100),
        formatter: (v) => format(v, 1),
        keyField: 'rvaaopsbip_lhp',
    }, {
        id: 'wops',
        name: translate('components.trends.abbr-wops'),
        scaleGroup: SCALE_GROUP.OPS,
        transformTrend: (t) => opsRV(t.rvhitfxactual, t.pawrv + 0.0),
        formatter: (v) => format(v, true),
        keyField: 'rvhitfxactual',
    }, {
        id: 'contactresults',
        name: translate('components.trends.contact-results'),
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => rvPerN(t.rvhitfxactualbip, t.biprvdenom, 100),
        formatter: (v) => format(v, 1),
        keyField: 'rvhitfxactualbip',
    }, {
        id: 'hitvelo105',
        name: '% > 105',
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.hitvelocity100, t.pawhitvelocity),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'horizla94',
        name: `${translate('components.trends.horiz-pull')} > 95`,
        scaleGroup: SCALE_GROUP.DEGREES,
        transformTrend: (t) => ratio(t.horizla94, t.hitvelocity90),
        formatter: (v) => format(v, 1),
    }, {
        id: 'gbfb',
        name: translate('components.trends.abbr-gf-ratio'),
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => gbFb(t.gb, t.fb, t.pop),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'gbpull',
        name: `${translate('components.trends.abbr-gb-pull')}%`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.gbpull, t.gbpull + t.gbaway),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'swfirstp',
        name: `${translate('components.trends.swing-first-pitch')} %`,
        transformTrend: (t) => ratio(t.firstpsw, t.firstp),
        formatter: (v) => (v ? percent(v, 1) : null),
        scaleGroup: SCALE_GROUP.PERCENT,
    }, {
        id: 'fblup',
        name: `${translate('components.trends.abbr-fbl-up')} %`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.fblup, t.fblwlocation),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'fblin',
        name: `${translate('components.trends.abbr-fbl-in')} %`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.fblin, t.fblwlocation),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'allin',
        name: `${translate('components.trends.abbr-all-in')} %`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.allin, t.pitwlocation),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'msch',
        name: translate('components.trends.miss-chase'),
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => { var _a; return 1 - ((_a = ratio(t.cnoutz, t.ch)) !== null && _a !== void 0 ? _a : 0); },
        formatter: (v) => (v ? percent(v, 1) : null),
    }, ...showBatTracking ? [
        {
            id: 'sfxcq',
            name: 'SFX CQ',
            scaleGroup: SCALE_GROUP.SCORE,
            transformTrend: (t) => rvPerN(t.fbswingfxcqinz, t.pawfbswingfxcqinz, 100),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'sfxmiss',
            name: 'SFX Miss',
            scaleGroup: SCALE_GROUP.PERCENT,
            transformTrend: (t) => ratio(t.fbswingfxmsinz + t.fbswingfxmsoutz, t.pwfbswingfxmsinz + t.pwfbswingfxmsoutz),
            formatter: (v) => (v ? percent(v, 1) : null),
        },
        {
            id: 'batspdinz',
            name: 'Bat Spd',
            scaleGroup: SCALE_GROUP.VELOCITY,
            transformTrend: (t) => ratio(t.batspdinz, t.pwbatspdinz),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'batspdheadadjinz',
            name: 'Head Adj Bat Spd',
            scaleGroup: SCALE_GROUP.VELOCITY,
            transformTrend: (t) => ratio(t.batspdheadadjinz, t.pwbatspdheadadjinz),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'batspdwadjinz',
            name: 'Wt Adj Bat Spd',
            scaleGroup: SCALE_GROUP.VELOCITY,
            transformTrend: (t) => ratio(t.batspdwadjinz, t.pwbatspdwadjinz),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'barreff',
            name: 'Bar Rel Eff',
            scaleGroup: SCALE_GROUP.SCORE,
            transformTrend: (t) => ratio(t.barreff, t.pwbarreff),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'atkanginz',
            name: 'Att Ang',
            scaleGroup: SCALE_GROUP.DEGREES,
            transformTrend: (t) => ratio(t.atkanginz, t.pwatkanginz),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'atkangheadadjinz',
            name: 'Head Adj Att Ang',
            scaleGroup: SCALE_GROUP.DEGREES,
            transformTrend: (t) => ratio(t.atkangheadadjinz, t.pwatkangheadadjinz),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'fbhead',
            name: 'FB Head',
            scaleGroup: SCALE_GROUP.DEGREES,
            transformTrend: (t) => ratio(t.fbhead, t.pwfbhead),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'nfbhead',
            name: 'nFB Head',
            scaleGroup: SCALE_GROUP.DEGREES,
            transformTrend: (t) => ratio(t.nfbhead, t.pwnfbhead),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'adjhead',
            name: 'Adj Head',
            scaleGroup: SCALE_GROUP.DEGREES,
            transformTrend: (t) => ratio(t.adjhead, t.pwadjhead),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'battiltinz',
            name: 'Bat Tilt',
            scaleGroup: SCALE_GROUP.DEGREES,
            transformTrend: (t) => ratio(t.battiltinz, t.pwbattiltinz),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'habvballinz',
            name: 'Hands Abv Ball',
            scaleGroup: SCALE_GROUP.INCHES,
            transformTrend: (t) => ratio(t.habvballinz, t.pwhabvballinz),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'barracc',
            name: 'Bar Acc BIP',
            scaleGroup: SCALE_GROUP.SCORE,
            transformTrend: (t) => rvPerN(t.barracc, t.pawbarracc, 100),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'barracch',
            name: 'Bar Acc H BIP',
            scaleGroup: SCALE_GROUP.SCORE,
            transformTrend: (t) => rvPerN(t.barracch, t.pawbarracch, 100),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'barraccv',
            name: 'Bar Acc V BIP',
            scaleGroup: SCALE_GROUP.SCORE,
            transformTrend: (t) => rvPerN(t.barraccv, t.pawbarraccv, 100),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'hbat',
            name: 'H Bat',
            scaleGroup: SCALE_GROUP.INCHES,
            transformTrend: (t) => ratio(t.hbat, t.pwhbat),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'hbatadj',
            name: 'Adj H Bat',
            scaleGroup: SCALE_GROUP.INCHES,
            transformTrend: (t) => ratio(t.hbatadj, t.pwhbatadj),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'vbat',
            name: 'V Bat',
            scaleGroup: SCALE_GROUP.INCHES,
            transformTrend: (t) => ratio(t.vbat, t.pwvbat),
            formatter: (v) => (v ? format(v, 1) : null),
        }, {
            id: 'vbatadj',
            name: 'Adj V Bat',
            scaleGroup: SCALE_GROUP.INCHES,
            transformTrend: (t) => ratio(t.vbatadj, t.pwvbatadj),
            formatter: (v) => (v ? format(v, 1) : null),
        }
    ] : [],
];
const forcePlateJumpStats = (translate) => [{
        id: 'mass',
        name: translate('components.trends.mass'),
        scaleGroup: SCALE_GROUP.WEIGHT,
        transformForcePlate: (fp) => fp.mass,
        formatter: (v) => format(v, 1),
        keyField: 'mass',
        axisMin: 150,
        axisMax: 270,
    }, {
        id: 'peakvelo',
        name: translate('components.trends.peak-velo'),
        scaleGroup: SCALE_GROUP.VELOCITY_METRIC,
        transformForcePlate: (fp) => fp.peakvelo,
        formatter: (v) => format(v, 2),
        keyField: 'peakvelo',
        axisMin: 2.5,
        axisMax: 3.6,
    }, {
        id: 'peakforce',
        name: translate('components.trends.peak-force'),
        scaleGroup: SCALE_GROUP.FORCE,
        transformForcePlate: (fp) => fp.peakforce,
        formatter: (v) => format(v, 1),
        keyField: 'peakforce',
        axisMin: 370,
        axisMax: 800,
    }, {
        id: 'peakforce_bw',
        name: translate('components.trends.peak-force-bw'),
        scaleGroup: SCALE_GROUP.BODYWEIGHTS,
        transformForcePlate: (fp) => fp.peakforce_bw,
        formatter: (v) => format(v, 2),
        keyField: 'peakforce_bw',
        axisMin: 2.0,
        axisMax: 3.6,
    }, {
        id: 'peakpower',
        name: translate('components.trends.peak-power'),
        scaleGroup: SCALE_GROUP.POWER,
        transformForcePlate: (fp) => fp.peakpower,
        formatter: (v) => format(v, 1),
        keyField: 'peakpower',
        axisMin: 3700,
        axisMax: 8500,
    }, {
        id: 'peakpower_bw',
        name: translate('components.trends.peak-power-bw'),
        scaleGroup: SCALE_GROUP.BODYWEIGHTS,
        transformForcePlate: (fp) => fp.peakpower_bw,
        formatter: (v) => format(v, 1),
        keyField: 'peakpower_bw',
        axisMin: 19.0,
        axisMax: 37.0,
    }, {
        id: 'asymmetryavgbraking',
        name: translate('components.trends.asymmetry-avg-braking'),
        scaleGroup: SCALE_GROUP.PERCENT_DIFF,
        transformForcePlate: (fp) => fp.asymmetryavgbraking,
        formatter: (v) => format(v, 1),
        keyField: 'asymmetryavgbraking',
        axisMin: -35,
        axisMax: 35,
    }];
const pitchTypeTrendStats = (translate) => [{
        id: 'kzon',
        name: `${translate('baseball.abbr-strikezone')}%`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.inz, t.inz + t.outz),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'swinz',
        name: `${translate('components.trends.swing-in-zone')} %`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.swinz, t.inz),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'ch',
        name: `${translate('components.trends.chase')} %`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.ch, t.outz),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'swds',
        name: translate('components.trends.swing-decisions'),
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => ratio(t.swds, t.swdspit),
        formatter: (v) => format(v, 1),
    }, {
        id: 'swdssw',
        name: translate('components.trends.sw-dec-should-swing'),
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => ratio(t.swdssw, t.swdsswpit),
        formatter: (v) => format(v, 1),
    }, {
        id: 'swdstk',
        name: translate('components.trends.sw-dec-should-take'),
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => ratio(t.swdstk, t.swdstkpit),
        formatter: (v) => format(v, 1),
    }, {
        id: 'ms',
        name: `${translate('components.trends.miss')} %`,
        transformTrend: (t) => missPct(t.sw, t.cn),
        formatter: (v) => (v ? percent(v, 1) : null),
        scaleGroup: SCALE_GROUP.PERCENT,
    }, {
        id: 'msinzon',
        name: translate('components.trends.miss-in-zone'),
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => missPct(t.swinz, t.cninz),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'inplay',
        name: `${translate('components.trends.in-play')} %`,
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.inplay, t.pa),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'ageadjcontactquality',
        name: `${translate('components.trends.abbr-age-adjusted')} ${translate('components.trends.contact-quality')}`,
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => rvPerN(t.rvaaopsbip, t.biprvdenom, 100),
        formatter: (v) => format(v, 1),
        keyField: 'rvaaopsbip',
    }, {
        id: 'contactquality',
        name: translate('components.trends.contact-quality'),
        scaleGroup: SCALE_GROUP.SCORE,
        transformTrend: (t) => rvPerN(t.rvheopsbip, t.biprvdenom, 100),
        formatter: (v) => format(v, 1),
    }, {
        id: 'hitvelocity',
        name: translate('components.trends.exit-velo'),
        scaleGroup: SCALE_GROUP.VELOCITY,
        transformTrend: (t) => ratio(t.hitvelocity, t.pawhitvelocity),
        formatter: (v) => format(v, 1),
    }, {
        id: 'hitvelo95',
        name: '% > 95',
        scaleGroup: SCALE_GROUP.PERCENT,
        transformTrend: (t) => ratio(t.hitvelocity90, t.pawhitvelocity),
        formatter: (v) => (v ? percent(v, 1) : null),
    }, {
        id: 'vertla94',
        name: `${translate('components.trends.abbr-vert-launch')} > 95`,
        scaleGroup: SCALE_GROUP.DEGREES,
        transformTrend: (t) => ratio(t.vertla94, t.hitvelocity90),
        formatter: (v) => format(v, 1),
    }, {
        id: 'ervops',
        name: translate('components.trends.abbr-ervops'),
        scaleGroup: SCALE_GROUP.OPS,
        // note: these are the HitFX OPS constants, multiplied by 3.9 pitches per PA
        transformTrend: (t) => (3.9 * (t.ervpitch / t.pitches) * 3.284000) + 0.7592,
        formatter: (v) => format(v, true),
    }, {
        id: 'sw',
        name: `${translate('components.trends.swing')} %`,
        transformTrend: (t) => swingPct(t.sw, t.pitches, t.iballs, t.pitchouts),
        formatter: (v) => (v ? percent(v, 1) : null),
        scaleGroup: SCALE_GROUP.PERCENT,
    }, {
        id: 'pitchpercentage',
        name: `${translate('baseball.pitches_one')} %`,
        transformTrend: (t) => { var _a; return (_a = t.pitchpercentage) !== null && _a !== void 0 ? _a : null; },
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitchpercentage',
        scaleGroup: SCALE_GROUP.PERCENT,
    }, {
        id: 'ch2k',
        name: translate('components.trends.chase2k'),
        transformTrend: (t) => ratio(t.ch2k, t.pit2k),
        formatter: (v) => (v ? percent(v, 1) : null),
        scaleGroup: SCALE_GROUP.PERCENT,
    }, {
        id: 'sw2k',
        name: translate('components.trends.swing2k'),
        transformTrend: (t) => ratio(t.sw2k, t.pit2k),
        formatter: (v) => (v ? percent(v, 1) : null),
        scaleGroup: SCALE_GROUP.PERCENT,
    }];
const blastSwingStats = (translate) => [{
        id: 'maxbarrspeed',
        name: translate('components.trends.max-barrel-speed'),
        scaleGroup: SCALE_GROUP.VELOCITY,
        transformBlastSwing: (bs) => bs.maxbarrspeed,
        formatter: (v) => format(v, 1),
        keyField: 'maxbarrspeed',
    }, {
        id: 'maxbarrhandspeedratio',
        name: translate('components.trends.barrel-release-efficiency'),
        scaleGroup: SCALE_GROUP.BARREL_RELEASE_EFFICIENCY,
        transformBlastSwing: (bs) => bs.maxbarrhandspeedratio,
        formatter: (v) => format(v, 1),
        keyField: 'maxbarrhandspeedratio',
    }, {
        id: 'maxpretrigvba',
        name: translate('components.trends.max-pre-trigger-vertical-bat'),
        scaleGroup: SCALE_GROUP.DEGREES,
        transformBlastSwing: (bs) => bs.maxpretrigvba,
        formatter: (v) => format(v, 1),
        keyField: 'maxpretrigvba',
    }, {
        id: 'onplaneeff',
        name: translate('components.trends.on-plane-efficiency'),
        scaleGroup: SCALE_GROUP.PERCENT,
        transformBlastSwing: (bs) => ratio(bs.onplaneeff, 100),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'onplaneeff',
    }, {
        id: 'attang',
        name: translate('components.trends.attack-angle'),
        scaleGroup: SCALE_GROUP.DEGREES,
        transformBlastSwing: (bs) => bs.attang,
        formatter: (v) => format(v, 1),
        keyField: 'attang',
    }, {
        id: 'battiltatimpact',
        name: translate('components.trends.bat-tilt-at-impact'),
        scaleGroup: SCALE_GROUP.DEGREES,
        transformBlastSwing: (bs) => bs.battiltatimpact,
        formatter: (v) => format(v, 1),
        keyField: 'battiltatimpact',
        reversed: true,
    }, {
        id: 'barrelcast',
        name: translate('components.trends.barrel-cast'),
        scaleGroup: SCALE_GROUP.INCHES,
        transformBlastSwing: (bs) => bs.barrelcast,
        formatter: (v) => format(v, 1),
        keyField: 'barrelcast',
    }, {
        id: 'barreldump',
        name: translate('components.trends.barrel-dump'),
        scaleGroup: SCALE_GROUP.MILLISECONDS,
        transformBlastSwing: (bs) => bs.barreldump,
        formatter: (v) => format(v, 1),
        keyField: 'barreldump',
    }, {
        id: 'maxhandspeed',
        name: translate('components.trends.hand-speed'),
        scaleGroup: SCALE_GROUP.VELOCITY,
        transformBlastSwing: (bs) => bs.maxhandspeed,
        formatter: (v) => format(v, 1),
        keyField: 'maxhandspeed',
    }, {
        id: 'timetoeff',
        name: translate('components.trends.time-to-efficiency'),
        scaleGroup: SCALE_GROUP.PERCENT,
        transformBlastSwing: (bs) => bs.timetoeff,
        formatter: (v) => format(v, 1),
        keyField: 'timetoeff',
    }, {
        id: 'stabindexmeantm',
        name: translate('components.trends.stab-index'),
        scaleGroup: SCALE_GROUP.STAB_INDEX,
        transformBlastSwing: (bs) => bs.stabindexmeantm,
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'stabindexmeantm',
    }, {
        id: 'batwaggle',
        name: translate('components.trends.bat-waggle'),
        scaleGroup: SCALE_GROUP.INCHES,
        transformBlastSwing: (bs) => bs.batwaggle,
        formatter: (v) => format(v, 1),
        keyField: 'batwaggle',
    }, {
        id: 'barrelpump',
        name: translate('components.trends.barrel-pump'),
        scaleGroup: SCALE_GROUP.INCHES,
        transformBlastSwing: (bs) => bs.barrelpump,
        formatter: (v) => format(v, 2),
        keyField: 'barrelpump',
    }, {
        id: 'barrelpumpfreq',
        name: translate('components.trends.barrel-pump-frequency'),
        scaleGroup: SCALE_GROUP.PERCENT,
        transformBlastSwing: (bs) => bs.barrelpumpfreq,
        formatter: (v) => (v ? percent(v, 0) : null),
        keyField: 'barrelpumpfreq',
    }, {
        id: 'triggertoimpact',
        name: translate('components.trends.trigger-to-impact'),
        scaleGroup: SCALE_GROUP.MILLISECONDS,
        transformBlastSwing: (bs) => bs.triggertoimpact,
        formatter: (v) => format(v, 0),
        keyField: 'triggertoimpact',
    }];
const TRENDS_STATS = (translate, showBatTracking) => trendStats(translate, showBatTracking).map((s) => ({
    id: s.id,
    name: s.name,
    pitchType: null,
    transformTrend: s.transformTrend,
    formatter: s.formatter,
    scaleGroup: s.scaleGroup,
    keyField: s.keyField,
    axisMin: s.axisMin,
    axisMax: s.axisMax,
})).concat(pitchTypeTrendStats(translate).reduce((all, s) => all.concat([1, 2, 3, null]
    .map((pt) => ({
    id: `${s.id}${pt ? `-${pt}` : ''}`,
    name: `${s.name}${pt ? ` - ${pitchGroupMap[pt]}` : ''}`,
    pitchType: pt !== null && pt !== void 0 ? pt : null,
    transformTrend: s.transformTrend,
    formatter: s.formatter,
    scaleGroup: s.scaleGroup,
    keyField: s.keyField,
    axisMin: s.axisMin,
    axisMax: s.axisMax,
}))), [])).concat(blastSwingStats(translate).map((bs) => ({
    id: bs.id,
    isBlast: true,
    name: bs.name,
    pitchType: null,
    transformBlastSwing: bs.transformBlastSwing,
    formatter: bs.formatter,
    scaleGroup: bs.scaleGroup,
    keyField: bs.keyField,
    reversed: bs.reversed,
})))
    .concat(forcePlateJumpStats(translate).map((fp) => ({
    id: fp.id,
    isForcePlate: true,
    name: fp.name,
    pitchType: null,
    transformForcePlate: fp.transformForcePlate,
    formatter: fp.formatter,
    scaleGroup: fp.scaleGroup,
    keyField: fp.keyField,
    axisMin: fp.axisMin,
    axisMax: fp.axisMax,
})))
    .map((s, index) => (Object.assign(Object.assign({}, s), { color: chartColors$1[index % chartColors$1.length] })));

const StyledToggleButtonGroup = styled(ToggleButtonGroup$1) `
    &.btn-group {
        label.btn.btn-primary {
            background-color: white;
            color: ${styles.theme.fontColors.metallicBlue};
            border: 1px solid #dee2e6;
            font-weight: 400;
            font-size: 0.825rem;
            padding: 0.125rem 0.75rem;
        }

        .btn-check:checked + .btn {
            background-color: ${styles.theme.background.mariner};
            color: white;
            font-weight: 600;
        }
    }
`;
const options = [
    { value: DATE_RANGE.ONE_WEEK, label: '1W' },
    { value: DATE_RANGE.THREE_WEEKS, label: '3W' },
    { value: DATE_RANGE.ONE_MONTH, label: '1M' },
    { value: DATE_RANGE.THREE_MONTHS, label: '3M' },
    { value: DATE_RANGE.ONE_YEAR, label: '1Y' },
    { value: DATE_RANGE.YTD, label: 'YTD' },
    { value: DATE_RANGE.TWO_YEARS, label: '2Y' },
    { value: DATE_RANGE.THREE_YEARS, label: '3Y' },
    { value: DATE_RANGE.FIVE_YEARS, label: '5Y' },
];
const DateRangeButtonGroup = ({ value, onChange, dateOptions = [1, 2, 3, 4, 5, 6, 7] }) => {
    const filteredDateOptions = options.filter((o) => (dateOptions === null || dateOptions === void 0 ? void 0 : dateOptions.indexOf(o.value)) >= 0);
    return (React.createElement(StyledToggleButtonGroup, { type: "radio", name: "date-range-options", value: value, onChange: onChange }, filteredDateOptions.map((o) => (React.createElement(ToggleButton$1, { id: `date-range-option-${o.value}`, value: o.value, key: o.value }, o.label)))));
};

const StyledCheck = styled(Form$1.Check) `
    font-size: 0.825rem;
    .form-check-label {
        position: relative;
        top: 2px;
    }
    &.form-check-inline {
        min-height: 0;
    }
`;
const ChartDisplayOptions = ({ showLevelChanges, setShowLevelChanges, showAdjustments, setShowAdjustments }) => {
    const { t: translate } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledCheck, { inline: true, type: "checkbox", id: "level-change", label: translate('components.trends.level-change'), checked: showLevelChanges, onChange: () => setShowLevelChanges(!showLevelChanges) }),
        React.createElement(StyledCheck, { inline: true, type: "checkbox", id: "adjustments", label: translate('components.trends.adjutments'), checked: showAdjustments, onChange: () => setShowAdjustments(!showAdjustments) })));
};

/* eslint-disable max-len */
const StyledDataPointMenu$1 = styled.div `
    font-size: 0.875rem;
    width: 200px;
    z-index: 1;
    flex-shrink: 0;
    max-height: calc(100% - 56px);
`;
const GroupTitle$1 = styled.h5 `
    padding: 4px 0 !important;
    color: ${theme.fontColors.darkBlue};
    margin-bottom: 0 !important;
    font-size: 13.75px !important;
`;
const StyledStat$3 = styled.div `
    display: flex;
    align-items: center;
    color: ${(props) => (props.$disabled ? theme.fontColors.tundora : theme.fontColors.darkBlue)};
    border: 1px solid ${(props) => props.$borderColor};
    background-color: ${(props) => (props.$disabled ? '#d4d4d4' : 'white')};
    font-weight: 600;
    padding: 0.25rem 0.5rem;
    margin-right: 4px;
    font-size: 0.75rem;
    cursor: pointer;
    border-radius: 4px;

    &:hover {
        color: white;
        background-color: ${theme.background.cerulean};
    }
`;
const StyledColorMarker$1 = styled.div `
    background-color: ${(props) => props.$color};
    height: 8px;
    width: 8px;
    border-radius: 9999px;
    flex-shrink: 0;
`;
const StyledInputContainer = styled.div `&& {
    display: flex;
    align-items: center;
}`;
const StyledClearButton$1 = styled.div `&& {
    margin-left: -20px;
    height: 15px;
    width: 15px;
    cursor: pointer;
    background: transparent url(${searchReset}) no-repeat center;
}`;
const StatSection$1 = ({ id, title, trendStats, selectedStats, selectStat, className }) => {
    const { t: translate } = useTranslation();
    const [query, setQuery] = useState('');
    const [scrolledToStart, setScrolledToStart] = useState(false);
    const count = trendStats.filter((ts) => selectedStats.some((ss) => ts.id === ss.id)).length;
    const filteredTrendStats = trendStats.filter((ts) => !query || ts.name.toLowerCase().includes(query.toLowerCase()));
    useEffect(() => {
        if (trendStats && !scrolledToStart && selectedStats.length) {
            const statsInSection = selectedStats.filter((ss) => trendStats.some((ts) => ts.id === ss.id));
            const firstSelectedId = statsInSection.length ? statsInSection[0].id : null;
            if (firstSelectedId) {
                const firstSelectedElement = document.getElementById(`selected-stat-${firstSelectedId}`);
                const wrapperElement = document.getElementById(id);
                if (firstSelectedElement) {
                    wrapperElement === null || wrapperElement === void 0 ? void 0 : wrapperElement.scrollTo({ top: (firstSelectedElement === null || firstSelectedElement === void 0 ? void 0 : firstSelectedElement.offsetTop) - firstSelectedElement.getBoundingClientRect().height - 37 });
                    setScrolledToStart(true);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trendStats]);
    return (React.createElement("div", { className: `border-bottom d-flex flex-column ${className}`, style: { maxHeight: '50%' } },
        React.createElement(GroupTitle$1, null,
            title,
            " (",
            count,
            ")"),
        React.createElement(StyledInputContainer, null,
            React.createElement(Form$1.Control, { placeholder: `${translate('common.filter')} ${title}...`, size: "sm", value: query, onChange: (e) => setQuery(e.target.value), style: { fontSize: 12, marginBottom: 2 } }),
            query.length > 0 && React.createElement(StyledClearButton$1, { onClick: () => setQuery('') })),
        React.createElement("div", { className: "overflow-auto flex-grow-1", id: id }, filteredTrendStats.map((s) => {
            const disabled = !selectedStats.some((ss) => ss.id === s.id);
            return (React.createElement(StyledStat$3, { key: s.id, onClick: () => selectStat(s), "$disabled": disabled, "$borderColor": disabled ? theme.fontColors.silverChalice : s.color, className: "mt-1", id: `selected-stat-${s.id}` },
                React.createElement(StyledColorMarker$1, { "$color": disabled ? theme.fontColors.silverChalice : s.color, className: "me-2" }),
                s.name));
        }))));
};
const DataPointMenu$1 = ({ trends, blastSwings, forcePlateJumps, stats, setStats, setHasTrends, setHasBlast, setHasForcePlate, showTrends = true, showBlast = true, showForcePlate = false, showBatTracking = false }) => {
    const { t: translate } = useTranslation();
    const filteredStats = TRENDS_STATS(translate, showBatTracking).filter((ts) => ts.keyField === undefined
        || trends.some((t) => ts.pitchType === t.pitchtype && !!t[ts.keyField])
        || blastSwings.some((bs) => !!bs[ts.keyField])
        || forcePlateJumps.some((fp) => !!fp[ts.keyField]))
        .sort((a, b) => (a.name.localeCompare(b.name)));
    const selectStat = (ts) => {
        setStats(stats.some((s) => s.id === ts.id)
            ? stats.filter((s) => s.id !== ts.id)
            : [
                ...stats,
                ts,
            ]);
    };
    useEffect(() => {
        setHasTrends(stats.some((s) => !s.isBlast && !s.isForcePlate));
    }, [stats, setHasTrends]);
    useEffect(() => {
        setHasBlast(stats.some((s) => !!s.isBlast));
    }, [stats, setHasBlast]);
    useEffect(() => {
        setHasForcePlate(stats.some((s) => !!s.isForcePlate));
    }, [stats, setHasForcePlate]);
    return (React.createElement(StyledDataPointMenu$1, { className: "position-relative" },
        showTrends && (React.createElement(StatSection$1, { id: "batting-stats-section", title: translate('components.trends.batting-stats'), selectedStats: stats, trendStats: filteredStats.filter((s) => !s.isBlast && !s.isForcePlate), selectStat: selectStat })),
        showBlast && (React.createElement(StatSection$1, { id: "blast-stats-section", title: translate('components.trends.blast-stats'), selectedStats: stats, trendStats: filteredStats.filter((s) => s.isBlast), selectStat: selectStat, className: "mt-2" })),
        showForcePlate && (React.createElement(StatSection$1, { id: "force-plate-section", title: translate('components.trends.force-plate-jumps'), selectedStats: stats, trendStats: filteredStats.filter((s) => s.isForcePlate), selectStat: selectStat, className: "mt-2" }))));
};

/* eslint-disable no-nested-ternary */
BrokenAxis(Highcharts$1);
// eslint-disable-next-line max-len
const getTrendsSeries$1 = (trendData, enableMarkers = false, opacity = 1.0, type = 'spline', showInLegend = true) => trendData.map((td) => {
    const years = [];
    for (let i = 0; i < td.data.length - 1; i++) {
        if ((new Date(td.data[i].x)).getFullYear() !== (new Date(td.data[i + 1].x)).getFullYear()) {
            years.push((new Date(td.data[i + 1].x)).getFullYear());
        }
    }
    const data = td.data.concat(years.map((y) => ({
        x: new Date(`${y}-01-01`).getTime(),
        y: null,
        name: '',
    }))).sort((a, b) => a.x - b.x);
    return Object.assign(Object.assign({}, td), { data,
        type, marker: {
            enabled: enableMarkers,
            symbol: 'circle',
        }, showInLegend, yAxis: td.scaleGroup.toString(), opacity });
});
// eslint-disable-next-line max-len
const getTrendsData$1 = (translate, trends, blastSwings, forcePlateJumps, selectedStats, isLinear) => {
    const data = selectedStats.map((s) => ({
        id: s.id,
        name: s.name,
        scaleGroup: s.scaleGroup,
        color: s.color,
        axisMin: s.axisMin,
        axisMax: s.axisMax,
        reversed: s.reversed,
        // eslint-disable-next-line no-nested-ternary
        data: s.isBlast ? blastSwings.map((bs, i) => {
            var _a;
            return ({
                name: bs.swingdate,
                x: isLinear ? i : (new Date(bs.swingdate)).getTime(),
                y: s.transformBlastSwing ? s.transformBlastSwing(bs) : null,
                tooltip: `${dateTimeTranslate(translate, (new Date(bs.swingdate)).getTime())}<br/>${s.name}: 
        ${s.formatter(s.transformBlastSwing ? (_a = s.transformBlastSwing(bs)) !== null && _a !== void 0 ? _a : undefined : undefined)}`,
            });
        }) : s.isForcePlate ? forcePlateJumps.map((fp, i) => {
            var _a;
            return ({
                name: fp.testdate,
                x: isLinear ? i : (new Date(fp.testdate)).getTime(),
                y: s.transformForcePlate ? s.transformForcePlate(fp) : null,
                tooltip: `${dateTranslate(translate, (new Date(fp.testdate)).getTime())}<br />${s.name}:
        ${s.formatter(s.transformForcePlate ? (_a = s.transformForcePlate(fp)) !== null && _a !== void 0 ? _a : undefined : undefined)}`,
            });
        }) : trends.filter((t) => t.pitchtype === s.pitchType).map((t, i) => {
            var _a;
            return ({
                name: t.gamedate,
                x: isLinear ? i : (new Date(t.gamedate)).getTime(),
                y: s.transformTrend ? s.transformTrend(t) : null,
                // eslint-disable-next-line max-len
                tooltip: `${dateTranslate(translate, (new Date(t.gamedate)).getTime())}<br/>${s.name}: ${s.formatter(s.transformTrend ? (_a = s.transformTrend(t)) !== null && _a !== void 0 ? _a : undefined : undefined)}`,
            });
        }),
    }));
    const groupMap = {};
    data.forEach((d) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const values = d.data.map((t) => t.y).filter((y) => !!y);
        const defaultMin = -30; // Fallback for no values
        const defaultMax = 30; // Fallback for no values
        if (groupMap[d.scaleGroup] && values.length) {
            groupMap[d.scaleGroup] = {
                id: d.id,
                min: Math.min((_b = (_a = groupMap[d.scaleGroup]) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : Number.MAX_VALUE, (_c = d.axisMin) !== null && _c !== void 0 ? _c : Number.MAX_VALUE, ...values),
                max: Math.max((_e = (_d = groupMap[d.scaleGroup]) === null || _d === void 0 ? void 0 : _d.max) !== null && _e !== void 0 ? _e : Number.MIN_VALUE, (_f = d.axisMax) !== null && _f !== void 0 ? _f : Number.MIN_VALUE, ...values),
                reversed: d.reversed,
            };
        }
        else {
            groupMap[d.scaleGroup] = {
                id: d.id,
                min: values.length ? Math.min(...values) : ((_g = d.axisMin) !== null && _g !== void 0 ? _g : defaultMin),
                max: values.length ? Math.max(...values) : ((_h = d.axisMax) !== null && _h !== void 0 ? _h : defaultMax),
                reversed: d.reversed,
            };
        }
    });
    return { data: data.filter((d) => d.data.length), groupMap };
};
// eslint-disable-next-line max-len
const getPlotLine = (translate, selectedStats, trends, blastSwings, forcePlateJumps) => selectedStats.map((s) => {
    var _a, _b, _c;
    return ({
        id: s.id,
        value: s.isBlast && blastSwings !== undefined ? (s.transformBlastSwing ? (_a = s.transformBlastSwing(blastSwings)) !== null && _a !== void 0 ? _a : undefined : undefined)
            : (s.isForcePlate && forcePlateJumps !== undefined ? (s.transformForcePlate ? (_b = s.transformForcePlate(forcePlateJumps)) !== null && _b !== void 0 ? _b : undefined : undefined)
                : (s.transformTrend && trends !== undefined ? (_c = s.transformTrend(trends)) !== null && _c !== void 0 ? _c : undefined : undefined)),
        color: s.color,
        dashStyle: 'Dash',
        label: {
            text: `${s.name} ${translate('components.trends.positional-average')}`,
            align: 'right',
        },
    });
});
const getBreaks$1 = (trendData) => {
    const breaks = [];
    const allDates = trendData.reduce((all, td) => all.concat(td.data.map((d) => new Date(d.x))), []).sort((a, b) => a.getTime() - b.getTime());
    for (let i = 0; i < allDates.length - 1; i++) {
        if (allDates[i].getFullYear() !== allDates[i + 1].getFullYear()) {
            breaks.push({
                from: allDates[i].getTime(),
                to: allDates[i + 1].getTime(),
                breakSize: (allDates[i + 1].getTime() - allDates[i].getTime()) / 5,
            });
        }
    }
    return breaks;
};
const TrendsChart$1 = ({ isLoading, showLevelChanges, showAdjustments, trends, blastSwings, forcePlateJumps, forcePlateJumpsAvg, forcePlateScatter, levelChanges, adjustments, selectedStats, setSelectedStats, height = 600, enableMarkers, connectNulls = true, linearXAxis = false, }) => {
    var _a;
    const { t: translate } = useTranslation();
    const SCALE_GROUP_FORMAT_MAP = {
        [SCALE_GROUP.OPS]: (v) => format(v, true),
        [SCALE_GROUP.PERCENT]: (v) => percent(v, 1),
        [SCALE_GROUP.VELOCITY]: (v) => `${translate('format.abbr-mph', { value: format(v, 1) })}`,
        [SCALE_GROUP.DEGREES]: (v) => `${format(v, 1)}°`,
        [SCALE_GROUP.SCORE]: (v) => format(v, 1),
        [SCALE_GROUP.WEIGHT]: (v) => `${format(v, 0)}`,
        [SCALE_GROUP.FORCE]: (v) => `${format(v, 0)}`,
        [SCALE_GROUP.VELOCITY_METRIC]: (v) => `${format(v, 2)}`,
        [SCALE_GROUP.POWER]: (v) => `${format(v, 0)}`,
        [SCALE_GROUP.BODYWEIGHTS]: (v) => format(v, 2),
        [SCALE_GROUP.PERCENT_DIFF]: (v) => format(v, 0),
    };
    const SCALE_GROUP_LABEL_MAP = {
        [SCALE_GROUP.OPS]: translate('components.trends.abbr-ops'),
        [SCALE_GROUP.PERCENT]: translate('components.trends.percent'),
        [SCALE_GROUP.VELOCITY]: translate('components.trends.velocity'),
        [SCALE_GROUP.DEGREES]: translate('components.trends.degrees'),
        [SCALE_GROUP.SCORE]: translate('components.trends.decision-score'),
        [SCALE_GROUP.INCHES]: translate('components.trends.inches'),
        [SCALE_GROUP.MILLISECONDS]: translate('components.trends.milliseconds'),
        [SCALE_GROUP.BARREL_RELEASE_EFFICIENCY]: translate('components.trends.barrel-release-efficiency'),
        [SCALE_GROUP.STAB_INDEX]: translate('components.trends.stab-index'),
        [SCALE_GROUP.WEIGHT]: translate('components.trends.mass-with-units'),
        [SCALE_GROUP.FORCE]: translate('components.trends.force-with-units'),
        [SCALE_GROUP.VELOCITY_METRIC]: translate('components.trends.velocity-with-units'),
        [SCALE_GROUP.POWER]: translate('components.trends.power-with-units'),
        [SCALE_GROUP.BODYWEIGHTS]: translate('components.trends.bodyweights'),
        [SCALE_GROUP.PERCENT_DIFF]: translate('components.trends.percent-diff'),
    };
    const { data, groupMap } = getTrendsData$1(translate, trends, blastSwings, forcePlateJumps, selectedStats, linearXAxis);
    const scatterData = getTrendsData$1(translate, [], [], forcePlateScatter, selectedStats, linearXAxis);
    const avgPlotLines = getPlotLine(translate, selectedStats, undefined, undefined, forcePlateJumpsAvg);
    const chartConfig = {
        title: {
            text: undefined,
        },
        chart: {
            type: 'spline',
            height,
        },
        series: [...getTrendsSeries$1(data, enableMarkers), ...getTrendsSeries$1(scatterData.data, true, 0.75, 'scatter', false)],
        plotOptions: {
            spline: {
                connectNulls,
            },
            series: {
                events: {
                    hide(v) {
                        setSelectedStats(selectedStats.filter((s) => s.id !== v.target.options.id));
                    },
                },
            },
        },
        xAxis: {
            type: linearXAxis ? 'linear' : 'datetime',
            plotLines: (showLevelChanges ? levelChanges.map((lc) => ({
                value: new Date(lc.gamedate).getTime(),
                color: '#B9B9B9',
                width: 1,
                dashStyle: 'Dash',
                label: {
                    text: lc.level_abbr,
                    verticalAlign: 'top',
                    y: 10,
                    x: 12,
                    rotation: 270,
                    textAlign: 'right',
                    style: {
                        color: '#A2A2A2',
                    },
                },
            })) : []).concat(showAdjustments ? adjustments.map((adj) => ({
                value: new Date(adj.adoptiondate).getTime(),
                color: '#B9B9B9',
                width: 1,
                dashStyle: 'Dash',
                label: {
                    text: `<div title="${adj.description}">${adj.category}</div>`,
                    verticalAlign: 'top',
                    y: 10,
                    x: 12,
                    rotation: 270,
                    textAlign: 'right',
                    style: {
                        color: '#A2A2A2',
                    },
                    useHTML: true,
                },
            })) : []),
            labels: linearXAxis ? {} : {
                formatter() {
                    return date(this.value);
                },
            },
            breaks: getBreaks$1(data),
        },
        yAxis: Object.entries(groupMap).sort(([key1], [key2]) => +key1 - +key2).map(([key, value], index) => {
            var _a;
            return ({
                id: key.toString(),
                title: {
                    text: (_a = SCALE_GROUP_LABEL_MAP[+key]) !== null && _a !== void 0 ? _a : '',
                },
                min: value.min,
                max: value.max,
                reversed: value.reversed,
                opposite: !!index,
                labels: {
                    formatter() {
                        var _a, _b, _c, _d;
                        return (_d = (SCALE_GROUP_FORMAT_MAP[+key] ? (_b = (_a = SCALE_GROUP_FORMAT_MAP[+key](this.value)) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '' : (_c = this.value) === null || _c === void 0 ? void 0 : _c.toString())) !== null && _d !== void 0 ? _d : '';
                    },
                },
                plotLines: avgPlotLines.filter((pl) => pl.id === value.id),
            });
        }),
        tooltip: {
            formatter() {
                return this.point.tooltip;
            },
        },
    };
    return (React.createElement("div", { className: "position-relative" }, isLoading ? (React.createElement("div", { className: "position-absolute d-flex justify-content-center align-items-center py-5", style: { inset: 0 } },
        React.createElement(LoadingSpinner$1, null)))
        : (((_a = chartConfig.series) === null || _a === void 0 ? void 0 : _a.length)
            ? React.createElement(BaseChart, { immutable: true, options: chartConfig })
            : React.createElement("div", { className: "text-muted py-5 fs-6 d-flex justify-content-center" }, "No Data Available."))));
};

const Trends = (_a) => {
    var { isLoading, initialShowLevelChange = true, initialShowAdjustments = true, trends, blastSwings, forcePlateJumps, forcePlateJumpsAvg, forcePlateScatter = [], levelChanges, adjustments, dateRange, setDateRange, setHasTrends, setHasBlast, setHasForcePlate, showTrends = true, showBlast = true, showForcePlate = false, showBatTracking = false, enableMarkers, dateOptions, disableDisplayOptions = false, connectNulls = true, defaultStatId, height = 800, marginBottom = 600, suppressOptions, linearXAxis = false } = _a, rest = __rest(_a, ["isLoading", "initialShowLevelChange", "initialShowAdjustments", "trends", "blastSwings", "forcePlateJumps", "forcePlateJumpsAvg", "forcePlateScatter", "levelChanges", "adjustments", "dateRange", "setDateRange", "setHasTrends", "setHasBlast", "setHasForcePlate", "showTrends", "showBlast", "showForcePlate", "showBatTracking", "enableMarkers", "dateOptions", "disableDisplayOptions", "connectNulls", "defaultStatId", "height", "marginBottom", "suppressOptions", "linearXAxis"]);
    const { t: translate } = useTranslation();
    const defaultStat = TRENDS_STATS(translate, showBatTracking).filter((st) => {
        if (defaultStatId)
            return st.id === defaultStatId;
        if (showForcePlate && !showTrends)
            return (st.id === 'peakvelo' || st.id === 'mass');
        return st.id === 'hfx';
    });
    const [showLevelChanges, setShowLevelChanges] = useState(initialShowLevelChange);
    const [showAdjustments, setShowAdjustments] = useState(initialShowAdjustments);
    const [selectedStats, setSelectedStats] = useState(defaultStat);
    const trendsWithPitchPercentage = trends.map((t) => {
        var _a, _b;
        return (Object.assign(Object.assign({}, t), { pitchpercentage: t.pitchtype ? t.pitches / ((_b = (_a = trends.find((x) => x.gameid === t.gameid && x.pitchtype === null)) === null || _a === void 0 ? void 0 : _a.pitches) !== null && _b !== void 0 ? _b : 1) : null }));
    });
    return (React.createElement("div", Object.assign({ className: "border rounded p-3 mt-3 bg-white d-flex position-relative", style: { height, marginBottom } }, rest),
        React.createElement(DataPointMenu$1, { stats: selectedStats, setStats: setSelectedStats, trends: trendsWithPitchPercentage, blastSwings: blastSwings, forcePlateJumps: forcePlateJumps, setHasTrends: setHasTrends, setHasBlast: setHasBlast, setHasForcePlate: setHasForcePlate, showTrends: showTrends, showBlast: showBlast, showForcePlate: showForcePlate, showBatTracking: showBatTracking }),
        React.createElement("div", { className: "flex-grow-1" },
            !suppressOptions && (React.createElement("div", { className: "mb-5" },
                React.createElement("div", { className: "d-flex justify-content-center position-absolute", style: { inset: 'auto 0' } },
                    React.createElement(DateRangeButtonGroup, { value: dateRange, onChange: setDateRange, dateOptions: dateOptions })),
                !disableDisplayOptions && (React.createElement("div", { className: "position-absolute end-0 mt-1" },
                    React.createElement(ChartDisplayOptions, { showLevelChanges: showLevelChanges, setShowLevelChanges: setShowLevelChanges, showAdjustments: showAdjustments, setShowAdjustments: setShowAdjustments }))))),
            React.createElement("div", null,
                React.createElement(TrendsChart$1, { isLoading: isLoading, showLevelChanges: showLevelChanges, showAdjustments: showAdjustments, trends: trendsWithPitchPercentage, blastSwings: blastSwings, levelChanges: levelChanges, adjustments: adjustments, selectedStats: selectedStats, setSelectedStats: setSelectedStats, forcePlateJumps: forcePlateJumps, forcePlateJumpsAvg: forcePlateJumpsAvg, forcePlateScatter: forcePlateScatter, enableMarkers: enableMarkers, connectNulls: connectNulls, linearXAxis: linearXAxis })))));
};

var ScaleGroup;
(function (ScaleGroup) {
    ScaleGroup[ScaleGroup["PERCENT"] = 0] = "PERCENT";
    ScaleGroup[ScaleGroup["ERA"] = 1] = "ERA";
    ScaleGroup[ScaleGroup["SCORE"] = 2] = "SCORE";
    ScaleGroup[ScaleGroup["VELOCITY"] = 3] = "VELOCITY";
    ScaleGroup[ScaleGroup["DEGREES"] = 4] = "DEGREES";
    ScaleGroup[ScaleGroup["INCHES"] = 5] = "INCHES";
    ScaleGroup[ScaleGroup["FEET"] = 6] = "FEET";
    ScaleGroup[ScaleGroup["SPIN_RATE"] = 7] = "SPIN_RATE";
})(ScaleGroup || (ScaleGroup = {}));

const chartColors = [
    '#3366cc',
    '#dc3912',
    '#ff9900',
    '#109618',
    '#990099',
    '#0099c6',
    '#dd4477',
    '#66aa00',
    '#b82e2e',
    '#316395',
    '#994499',
    '#22aa99',
    '#aaaa11',
    '#6633cc',
    '#e67300',
    '#8b0707',
    '#651067',
    '#329262',
    '#5574a6',
    '#3b3eac',
    '#b77322',
    '#16d620',
    '#b91383',
    '#f4359e',
    '#9c5935',
    '#a9c413',
    '#2a778d',
    '#668d1c',
    '#bea413',
    '#0c5922',
    '#743411',
];
const hitfxERA = (rvhitfxpit, pawrv) => {
    if (!pawrv)
        return null;
    return 4.6062 + ((rvhitfxpit / pawrv) * 37.42133) + ((Math.pow((rvhitfxpit / pawrv), 2)) * 88.77471);
};
const pitchfxERA = (rvpitchfx, pitchfxwrv) => {
    const r = ratio(rvpitchfx, pitchfxwrv);
    if (r)
        return 4.4695 + (-136.900000 * r);
    return null;
};
const rvPer100BIP = (rv, bip) => normalize(rv, bip, 100);
const TREND_STATS = (pitchTypes, translate) => [{
        id: 'era',
        name: translate('components.pitcher-trends.era'),
        transformTrend: (t) => era(t.er, t.outs),
        formatter: (v) => (v ? format(v, 2) : null),
        keyField: 'outs',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'hitfxera',
        name: translate('components.pitcher-trends.hitfxera'),
        transformTrend: (t) => hitfxERA(t.rvhitfxpitalt, t.pawrv),
        formatter: (v) => (v ? format(v, 2) : null),
        keyField: 'pawrv',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'pitchfxera',
        name: translate('components.pitcher-trends.pitchfxera'),
        transformTrend: (t) => pitchfxERA(t.rvpitchfx, t.pitchfxwrv),
        formatter: (v) => (v ? format(v, 2) : null),
        keyField: 'pitchfxwrv',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'breakera',
        name: translate('components.pitcher-trends.breakera'),
        transformTrend: (t) => pitchfxERA(t.rvpitchfxbreak, t.pitchfxwrv),
        formatter: (v) => (v ? format(v, 2) : null),
        keyField: 'pitchfxwrv',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'stuffera',
        name: translate('components.pitcher-trends.stuffera'),
        transformTrend: (t) => pitchfxERA(t.rvpitchfxstuff, t.pitchfxwrv),
        formatter: (v) => (v ? format(v, 2) : null),
        keyField: 'pitchfxwrv',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'ncaabreakera',
        name: translate('components.pitcher-trends.ncaabreakera'),
        transformTrend: (t) => pitchfxERA(t.rvbreak_ncaa, t.pitchfxwrv),
        formatter: (v) => (v ? format(v, 2) : null),
        keyField: 'pitchfxwrv',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'ncaastuffera',
        name: translate('components.pitcher-trends.ncaastuffera'),
        transformTrend: (t) => pitchfxERA(t.rvstuff_ncaa, t.pitchfxwrv),
        formatter: (v) => (v ? format(v, 2) : null),
        keyField: 'pitchfxwrv',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'contactresults',
        name: translate('components.pitcher-trends.contactresults'),
        transformTrend: (t) => rvPer100BIP(t.rvhitfxactualbip, t.biprvdenom),
        formatter: (v) => (v ? format(v, 1) : null),
        keyField: 'biprvdenom',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.SCORE,
    }, {
        id: 'contactquality',
        name: translate('components.pitcher-trends.contactquality'),
        transformTrend: (t) => rvPer100BIP(t.rvhitfxpitbip, t.biprvdenom),
        formatter: (v) => (v ? format(v, 1) : null),
        keyField: 'biprvdenom',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.SCORE,
    }, {
        id: 'exitvelo',
        name: translate('components.pitcher-trends.exitvelo'),
        transformTrend: (t) => ratio(t.hitvelocity, t.pawhitvelocity),
        formatter: (v) => format(v, 1),
        keyField: 'pawhitvelocity',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.VELOCITY,
    }, {
        id: 'vertlaunchangle',
        name: translate('components.pitcher-trends.vertlaunchangle'),
        transformTrend: (t) => ratio(t.vertla, t.pawhitvelocity),
        formatter: (v) => format(v, 1),
        keyField: 'hitvelocity90',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.DEGREES,
    }, {
        id: 'wellhitpct',
        name: translate('components.pitcher-trends.wellhitpct'),
        transformTrend: (t) => ratio(t.wellhit, t.pawhitfx),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pawhitfx',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'gbpct',
        name: translate('components.pitcher-trends.gbpct'),
        transformTrend: (t) => ratio(t.gb, t.ld + t.gb + t.fb + t.pop),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'gb',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'poppct',
        name: translate('components.pitcher-trends.poppct'),
        transformTrend: (t) => ratio(t.pop, t.ld + t.gb + t.fb + t.pop),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pop',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'gbpullpct',
        name: translate('components.pitcher-trends.gbpullpct'),
        transformTrend: (t) => ratio(t.gbpull, t.gbpull + t.gbaway),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'flypullpct',
        name: translate('components.pitcher-trends.flypullpct'),
        transformTrend: (t) => ratio((t.fbpull + t.ldpull + t.poppull), (t.fbpull + t.fbaway + t.ldpull + t.ldaway + t.poppull + t.popaway)),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'firstpstk',
        name: translate('components.pitcher-trends.firstpstk'),
        transformTrend: (t) => ratio(t.firstpstk, t.firstp),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'firstp',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'stkpct',
        name: translate('components.pitcher-trends.stkpct'),
        transformTrend: (t) => ratio(t.strikes, t.pitches - t.pitchouts - t.iballs),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'calledstkpct',
        name: translate('components.pitcher-trends.calledstkpct'),
        transformTrend: (t) => ratio(t.tkstk, t.pitches - t.pitchouts - t.iballs),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'swingingstkpct',
        name: translate('components.pitcher-trends.swingingstkpct'),
        transformTrend: (t) => ratio(t.swinging, t.pitches - t.pitchouts - t.iballs),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'foulpct',
        name: translate('components.pitcher-trends.foulpct'),
        transformTrend: (t) => ratio(t.foul, t.pitches - t.pitchouts - t.iballs),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'inplaypct',
        name: translate('components.pitcher-trends.inplaypct'),
        transformTrend: (t) => ratio(t.inplay, t.pitches - t.pitchouts - t.iballs),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'kzon',
        name: translate('components.pitcher-trends.kzon'),
        transformTrend: (t) => ratio(t.inz, t.inz + t.outz),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'inz',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'kzon2k',
        name: translate('components.pitcher-trends.kzonlessthan2k'),
        transformTrend: (t) => ratio(t.inzl2k, t.inzl2k + t.outzl2k),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'inzl2k',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'closepitchpct',
        name: translate('components.pitcher-trends.closepitchpct'),
        transformTrend: (t) => ratio(t.closepitch, t.pitwspsz),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitwspsz',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'wastepitchpct',
        name: translate('components.pitcher-trends.wastepitchpct'),
        transformTrend: (t) => ratio(t.noncomppitches, t.pitwspsz),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitwspsz',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'swpct',
        name: translate('components.pitcher-trends.swpct'),
        transformTrend: (t) => ratio(t.sw, t.pitches - t.pitchouts - t.iballs),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'swinzpct',
        name: translate('components.pitcher-trends.swinzpct'),
        transformTrend: (t) => ratio(t.swinz, t.inz),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'inz',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'chpct',
        name: translate('components.pitcher-trends.chpct'),
        transformTrend: (t) => ratio(t.ch, t.outz),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'outz',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'mspct',
        name: translate('components.pitcher-trends.mspct'),
        transformTrend: (t) => ratio(t.sw - t.cn, t.sw),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'sw',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'mschpct',
        name: translate('components.pitcher-trends.mschpct'),
        transformTrend: (t) => ratio(t.swoutz - t.cnoutz, t.swoutz),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'swoutz',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'sopct',
        name: translate('components.pitcher-trends.sopct'),
        transformTrend: (t) => ratio(t.so, t.pa),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pa',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'ubbpct',
        name: translate('components.pitcher-trends.ubbpct'),
        transformTrend: (t) => ratio(t.ubb, t.pa),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pa',
        isOverall: true,
        isByPitchType: false,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'pitchPerc',
        name: translate('components.pitcher-trends.pitch-percent'),
        transformTrend: (t) => ratio(t.pitches, t.totalpitches),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'totalpitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'velocity',
        name: translate('components.pitcher-trends.velocity'),
        transformTrend: (t) => ratio(t.velocity, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.VELOCITY,
    }, {
        id: 'pitchup',
        name: translate('components.pitcher-trends.pitchup'),
        transformTrend: (t) => ratio(t.pitchup, t.pitches),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'pitchin',
        name: translate('components.pitcher-trends.pitchin'),
        transformTrend: (t) => ratio(t.pitchin, t.pitches),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'msinzpct',
        name: translate('components.pitcher-trends.msinzpct'),
        transformTrend: (t) => ratio(t.swinz - t.cninz, t.swinz),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'swinz',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'kopppct',
        name: translate('components.pitcher-trends.put-away-pct'),
        transformTrend: (t) => ratio(t.so, t.kopp),
        formatter: (v) => (v ? percent(v, 1) : null),
        keyField: 'kopp',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.PERCENT,
    }, {
        id: 'breakx',
        name: translate('components.pitcher-trends.breakx'),
        transformTrend: (t) => ratio(t.breakx, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.INCHES,
    }, {
        id: 'breakz',
        name: translate('components.pitcher-trends.breakz'),
        transformTrend: (t) => ratio(t.breakz, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.INCHES,
    }, {
        id: 'ncaabreakx',
        name: translate('components.pitcher-trends.ncaabreakx'),
        transformTrend: (t) => ratio(t.ncaabreakxadj, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.INCHES,
    }, {
        id: 'ncaabreakz',
        name: translate('components.pitcher-trends.ncaabreakz'),
        transformTrend: (t) => ratio(t.ncaabreakzadj, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.INCHES,
    }, {
        id: 'spinrate',
        name: translate('components.pitcher-trends.spinrate'),
        transformTrend: (t) => ratio(t.spinrate, t.pitches),
        formatter: (v) => format(v, 0),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.SPIN_RATE,
    }, {
        id: 'extension',
        name: translate('components.pitcher-trends.extension'),
        transformTrend: (t) => ratio(t.extension, t.pitches),
        formatter: (v) => format(v, 2),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.FEET,
    }, {
        id: 'gyrodegree',
        name: translate('components.pitcher-trends.gyrodegree'),
        transformTrend: (t) => ratio(t.gyrodegree, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.DEGREES,
    }, {
        id: 'initposx',
        name: translate('components.pitcher-trends.initposx'),
        transformTrend: (t) => ratio(t.initposx, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.FEET,
    }, {
        id: 'initposz',
        name: translate('components.pitcher-trends.initposz'),
        transformTrend: (t) => ratio(t.initposz, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.FEET,
    }, {
        id: 'armangle',
        name: translate('components.pitcher-trends.armangle'),
        transformTrend: (t) => ratio(t.armangle, t.pitches),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.DEGREES,
    }, {
        id: 'rvera',
        name: translate('components.pitcher-trends.rvera'),
        transformTrend: (t) => pitchfxERA(t.rvactual, t.pitchfxwrv),
        formatter: (v) => format(v, 2),
        keyField: 'pitchfxwrv',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'ervera',
        name: translate('components.pitcher-trends.ervera'),
        transformTrend: (t) => pitchfxERA(t.rvexp, t.pitchfxwrv),
        formatter: (v) => format(v, 2),
        keyField: 'pitchfxwrv',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'locera',
        name: translate('components.pitcher-trends.locera'),
        transformTrend: (t) => pitchfxERA(t.rvloc, t.pitchfxwrv),
        formatter: (v) => format(v, 2),
        keyField: 'pitchfxwrv',
        isOverall: false,
        isByPitchType: true,
        scaleGroup: ScaleGroup.ERA,
    }, {
        id: 'head',
        name: translate('components.pitcher-trends.head'),
        // eslint-disable-next-line no-nested-ternary
        transformTrend: (t) => (t.pitchtype === -1 ? ratio(t.fbhead + t.nfbhead, t.pwfbhead + t.pwnfbhead) : (t.pitchtype === 9 || t.pitchtype === 10 ? ratio(t.fbhead, t.pwfbhead) : ratio(t.nfbhead, t.pwnfbhead))),
        formatter: (v) => format(v, 1),
        keyField: 'pitches',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.DEGREES,
    }, {
        id: 'hbat',
        name: translate('components.pitcher-trends.hbat'),
        transformTrend: (t) => ratio(t.hbat, t.pwhbat),
        formatter: (v) => format(v, 2),
        keyField: 'pwhbat',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.INCHES,
    }, {
        id: 'vbat',
        name: translate('components.pitcher-trends.vbat'),
        transformTrend: (t) => ratio(t.vbat, t.pwvbat),
        formatter: (v) => format(v, 2),
        keyField: 'pwvbat',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.INCHES,
    }, {
        id: 'baraccbip',
        name: translate('components.pitcher-trends.baraccbip'),
        transformTrend: (t) => rvPerN(t.barracc, t.pawbarracc, 100),
        formatter: (v) => format(v, 1),
        keyField: 'pwvbat',
        isOverall: true,
        isByPitchType: true,
        scaleGroup: ScaleGroup.SCORE,
    }].reduce((all, ts) => all.concat([
    ...(ts.isOverall ? [{
            id: ts.id,
            name: ts.name,
            statName: ts.name,
            transformTrend: ts.transformTrend,
            formatter: ts.formatter,
            keyField: ts.keyField,
            pitchType: -1,
            scaleGroup: ts.scaleGroup,
        }] : []),
    ...(ts.isByPitchType ? pitchTypes.map((pt) => ({
        id: `${ts.id}-${pt}`,
        statName: ts.name,
        name: `${ts.name} - ${pitchTypeOrSubType(pt, true, '', translate)}`,
        transformTrend: ts.transformTrend,
        formatter: ts.formatter,
        keyField: ts.keyField,
        pitchType: pt,
        scaleGroup: ts.scaleGroup,
    })) : []),
]), []).reduce((all, ts) => all.concat([-1, 0, 1].map((islhb) => (Object.assign(Object.assign({}, ts), { id: `${ts.id}-${islhb}`, name: `${ts.name}${{
        [-1]: '',
        0: ` ${translate('baseball.abbr-versus')} ${translate('baseball.abbr-right')}`,
        1: ` ${translate('baseball.abbr-versus')} ${translate('baseball.abbr-left')}`,
    }[islhb]}`, islhb })))), []).map((ts, index) => (Object.assign(Object.assign({}, ts), { color: chartColors[index % chartColors.length] })));

const StyledDataPointMenu = styled.div `
    font-size: 0.875rem;
    width: 200px;
    z-index: 1;
    flex-shrink: 0;
    max-height: calc(100% - 56px);
    position: relative;
`;
const GroupTitle = styled.h5 `
    padding: 4px 0 !important;
    color: ${theme.fontColors.darkBlue};
    margin-bottom: 0 !important;
    font-size: 13.75px !important;
`;
const StyledClearButton = styled.div `&& {
    margin-left: -20px;
    height: 15px;
    width: 15px;
    cursor: pointer;
    background: transparent url(${searchReset}) no-repeat center;
}`;
const StyledStat$2 = styled.div `
    display: flex;
    align-items: center;
    color: ${(props) => (props.$disabled ? theme.fontColors.tundora : theme.fontColors.darkBlue)};
    border: 1px solid ${(props) => props.$borderColor};
    background-color: ${(props) => (props.$disabled ? '#d4d4d4' : 'white')};
    font-weight: 600;
    padding: 0.25rem 0.5rem;
    margin-right: 4px;
    font-size: 0.75rem;
    cursor: pointer;
    border-radius: 4px;

    &:hover {
        color: white;
        background-color: ${theme.background.cerulean};
    }
`;
const StyledColorMarker = styled.div `
    background-color: ${(props) => props.$color};
    height: 8px;
    width: 8px;
    border-radius: 9999px;
    flex-shrink: 0;
`;
const StatSection = ({ id, title, trendStats, selectedStats, selectStat, className }) => {
    const { t: translate } = useTranslation();
    const [query, setQuery] = useState('');
    const [scrolledToStart, setScrolledToStart] = useState(false);
    const count = trendStats.filter((ts) => selectedStats.some((ss) => ts.id === ss.id)).length;
    const filteredTrendStats = trendStats.filter((ts) => !query || ts.name.toLowerCase().includes(query.toLowerCase()));
    useEffect(() => {
        if (trendStats && !scrolledToStart && selectedStats.length) {
            const statsInSection = selectedStats.filter((ss) => trendStats.some((ts) => ts.id === ss.id));
            const firstSelectedId = statsInSection.length ? statsInSection[0].id : null;
            if (firstSelectedId) {
                const firstSelectedElement = document.getElementById(`selected-stat-${firstSelectedId}`);
                const wrapperElement = document.getElementById(id);
                if (firstSelectedElement) {
                    wrapperElement === null || wrapperElement === void 0 ? void 0 : wrapperElement.scrollTo({ top: (firstSelectedElement === null || firstSelectedElement === void 0 ? void 0 : firstSelectedElement.offsetTop) - firstSelectedElement.getBoundingClientRect().height - 37 });
                    setScrolledToStart(true);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trendStats]);
    return (React.createElement("div", { className: `border-bottom d-flex flex-column ${className}`, style: { maxHeight: '100%' } },
        React.createElement(GroupTitle, null,
            title,
            " (",
            count,
            ")"),
        React.createElement("div", { className: "d-flex align-items-center" },
            React.createElement(Form.Control, { placeholder: `${translate('common.filter')} ${title}...`, size: "sm", value: query, onChange: (e) => setQuery(e.target.value), style: { fontSize: 12, marginBottom: 2 } }),
            query.length > 0 && React.createElement(StyledClearButton, { onClick: () => setQuery('') })),
        React.createElement("div", { className: "overflow-auto flex-grow-1", id: id }, filteredTrendStats.map((s) => {
            const disabled = !selectedStats.some((ss) => ss.id === s.id);
            return (React.createElement(StyledStat$2, { key: s.id, onClick: () => selectStat(s), "$disabled": disabled, "$borderColor": disabled ? theme.fontColors.silverChalice : s.color, className: "mt-1", id: `selected-stat-${s.id}` },
                React.createElement(StyledColorMarker, { "$color": disabled ? theme.fontColors.silverChalice : s.color, className: "me-2" }),
                s.name));
        }))));
};
const DataPointMenu = ({ trends, stats, setStats, pitchTypes }) => {
    const { t: translate } = useTranslation();
    const filteredStats = TREND_STATS(pitchTypes, translate).filter((ts) => ts.keyField === undefined
        || trends.some((t) => ts.pitchType === t.pitchtype && !!ts.keyField && !!t[ts.keyField]))
        .sort((a, b) => {
        if (a.statName !== b.statName)
            return a.statName.localeCompare(b.statName);
        if (a.pitchType !== b.pitchType)
            return a.pitchType - b.pitchType;
        return a.islhb - b.islhb;
    });
    const selectStat = (ts) => {
        setStats(stats.some((s) => s.id === ts.id)
            ? stats.filter((s) => s.id !== ts.id)
            : [
                ...stats,
                ts,
            ]);
    };
    return (React.createElement(StyledDataPointMenu, null,
        React.createElement(StatSection, { id: "overall-section", title: translate('components.pitcher-trends.pitching-stats'), selectedStats: stats, trendStats: filteredStats, selectStat: selectStat })));
};

/* eslint-disable no-nested-ternary */
BrokenAxis(Highcharts$1);
// eslint-disable-next-line max-len
const getTrendsSeries = (trendData, enableMarkers = false, opacity = 1.0, type = 'spline', showInLegend = true) => trendData.map((td) => {
    const years = [];
    for (let i = 0; i < td.data.length - 1; i++) {
        if ((new Date(td.data[i].x)).getFullYear() !== (new Date(td.data[i + 1].x)).getFullYear()) {
            years.push((new Date(td.data[i + 1].x)).getFullYear());
        }
    }
    const data = td.data.concat(years.map((y) => ({
        x: new Date(`${y}-01-01`).getTime(),
        y: null,
        name: '',
    }))).sort((a, b) => a.x - b.x);
    return Object.assign(Object.assign({}, td), { data,
        type, marker: {
            enabled: enableMarkers,
            symbol: 'circle',
        }, showInLegend, yAxis: td.scaleGroup.toString(), opacity });
});
// eslint-disable-next-line max-len
const getTrendsData = (translate, trends, selectedStats) => {
    const data = selectedStats.map((s) => ({
        id: s.id,
        name: s.name,
        scaleGroup: s.scaleGroup,
        color: s.color,
        axisMin: s.axisMin,
        axisMax: s.axisMax,
        reversed: s.reversed,
        // eslint-disable-next-line no-nested-ternary
        data: trends.filter((t) => t.pitchtype === s.pitchType && t.islhb === s.islhb).map((t) => {
            var _a;
            return ({
                name: t.gamedate,
                x: (new Date(t.gamedate)).getTime(),
                y: s.transformTrend ? s.transformTrend(t) : null,
                // eslint-disable-next-line max-len
                tooltip: `${dateTranslate(translate, (new Date(t.gamedate)).getTime())}<br/>${s.name}: ${s.formatter(s.transformTrend ? (_a = s.transformTrend(t)) !== null && _a !== void 0 ? _a : undefined : undefined)}`,
            });
        }),
    }));
    const groupMap = {};
    data.forEach((d) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const values = d.data.map((t) => t.y).filter((y) => !!y);
        if (groupMap[d.scaleGroup] && values.length) {
            groupMap[d.scaleGroup] = {
                id: d.id,
                min: Math.min((_b = (_a = groupMap[d.scaleGroup]) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : Number.MAX_VALUE, (_c = d.axisMin) !== null && _c !== void 0 ? _c : Number.MAX_VALUE, ...values),
                max: Math.max((_e = (_d = groupMap[d.scaleGroup]) === null || _d === void 0 ? void 0 : _d.max) !== null && _e !== void 0 ? _e : Number.MIN_VALUE, (_f = d.axisMax) !== null && _f !== void 0 ? _f : Number.MIN_VALUE, ...values),
                reversed: d.reversed,
            };
        }
        else {
            groupMap[d.scaleGroup] = {
                id: d.id,
                min: Math.min((_g = d.axisMin) !== null && _g !== void 0 ? _g : Number.MAX_VALUE, ...values),
                max: Math.max((_h = d.axisMax) !== null && _h !== void 0 ? _h : Number.MIN_VALUE, ...values),
                reversed: d.reversed,
            };
        }
    });
    return { data: data.filter((d) => d.data.length), groupMap };
};
const getBreaks = (trendData) => {
    const breaks = [];
    const allDates = trendData.reduce((all, td) => all.concat(td.data.map((d) => new Date(d.x))), []).sort((a, b) => a.getTime() - b.getTime());
    for (let i = 0; i < allDates.length - 1; i++) {
        if (allDates[i].getFullYear() !== allDates[i + 1].getFullYear()) {
            breaks.push({
                from: allDates[i].getTime(),
                to: allDates[i + 1].getTime(),
                breakSize: (allDates[i + 1].getTime() - allDates[i].getTime()) / 5,
            });
        }
    }
    return breaks;
};
const TrendsChart = ({ isLoading, showLevelChanges, showAdjustments, trends, levelChanges, adjustments, selectedStats, setSelectedStats, height = 600, enableMarkers, connectNulls = true, }) => {
    var _a;
    const { t: translate } = useTranslation();
    const SCALE_GROUP_FORMAT_MAP = {
        [ScaleGroup.PERCENT]: (v) => percent(v, 1),
        [ScaleGroup.SCORE]: (v) => format(v, 1),
        [ScaleGroup.ERA]: (v) => format(v, 2),
        [ScaleGroup.VELOCITY]: (v) => `${translate('format.abbr-mph', { value: format(v, 1) })}`,
        [ScaleGroup.DEGREES]: (v) => `${format(v, 1)}°`,
        [ScaleGroup.INCHES]: (v) => `${format(v, 1)}in`,
        [ScaleGroup.FEET]: (v) => `${format(v, 2)}ft`,
        [ScaleGroup.SPIN_RATE]: (v) => `${format(v, 0)}rpm`,
    };
    const SCALE_GROUP_LABEL_MAP = {
        [ScaleGroup.PERCENT]: translate('components.trends.percent'),
        [ScaleGroup.SCORE]: translate('components.trends.decision-score'),
        [ScaleGroup.ERA]: translate('components.trends.era'),
        [ScaleGroup.VELOCITY]: translate('components.trends.velocity'),
        [ScaleGroup.DEGREES]: translate('components.trends.degrees'),
        [ScaleGroup.INCHES]: translate('components.trends.inches'),
        [ScaleGroup.FEET]: translate('components.trends.feet'),
        [ScaleGroup.SPIN_RATE]: translate('components.trends.spin-rate'),
    };
    const { data, groupMap } = getTrendsData(translate, trends, selectedStats);
    const chartConfig = {
        title: {
            text: undefined,
        },
        chart: {
            type: 'spline',
            height,
        },
        series: [...getTrendsSeries(data, enableMarkers)],
        plotOptions: {
            spline: {
                connectNulls,
            },
            series: {
                events: {
                    hide(v) {
                        setSelectedStats(selectedStats.filter((s) => { var _a, _b; return s.id !== ((_b = (_a = v === null || v === void 0 ? void 0 : v.target) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.id); }));
                    },
                },
            },
        },
        xAxis: {
            type: 'datetime',
            plotLines: (showLevelChanges ? levelChanges.map((lc) => ({
                value: new Date(lc.gamedate).getTime(),
                color: '#B9B9B9',
                width: 1,
                dashStyle: 'Dash',
                label: {
                    text: lc.level_abbr,
                    verticalAlign: 'top',
                    y: 10,
                    x: 12,
                    rotation: 270,
                    textAlign: 'right',
                    style: {
                        color: '#A2A2A2',
                    },
                },
            })) : []).concat(showAdjustments ? adjustments.map((adj) => ({
                value: new Date(adj.adoptiondate).getTime(),
                color: '#B9B9B9',
                width: 1,
                dashStyle: 'Dash',
                label: {
                    text: `<div title="${adj.description}">${adj.category}</div>`,
                    verticalAlign: 'top',
                    y: 10,
                    x: 12,
                    rotation: 270,
                    textAlign: 'right',
                    style: {
                        color: '#A2A2A2',
                    },
                    useHTML: true,
                },
            })) : []),
            labels: {
                formatter() {
                    return date(this.value);
                },
            },
            breaks: getBreaks(data),
        },
        yAxis: Object.entries(groupMap).sort(([key1], [key2]) => +key1 - +key2)
            .map(([key, value], index) => {
            var _a;
            return ({
                id: key.toString(),
                title: {
                    text: (_a = SCALE_GROUP_LABEL_MAP[+key]) !== null && _a !== void 0 ? _a : '',
                },
                min: value.min,
                max: value.max,
                reversed: value.reversed,
                opposite: !!index,
                labels: {
                    formatter() {
                        var _a, _b, _c, _d;
                        return (_d = (SCALE_GROUP_FORMAT_MAP[+key] ? (_b = (_a = SCALE_GROUP_FORMAT_MAP[+key](this.value)) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '' : (_c = this.value) === null || _c === void 0 ? void 0 : _c.toString())) !== null && _d !== void 0 ? _d : '';
                    },
                },
            });
        }),
        tooltip: {
            formatter() {
                return this.point.tooltip;
            },
        },
    };
    return (React.createElement("div", { className: "position-relative" }, isLoading ? (React.createElement("div", { className: "position-absolute d-flex justify-content-center align-items-center py-5", style: { inset: 0 } },
        React.createElement(LoadingSpinner$1, null)))
        : (((_a = chartConfig.series) === null || _a === void 0 ? void 0 : _a.length)
            ? React.createElement(BaseChart, { immutable: true, options: chartConfig })
            : React.createElement("div", { className: "text-muted py-5 fs-6 d-flex justify-content-center" }, "No Data Available."))));
};

const PitcherTrends = ({ isLoading, initialShowLevelChange = true, initialShowAdjustments = true, trends, pitchTypes, dateRange, setDateRange, dateOptions, levelChanges, adjustments, height = 800, }) => {
    const { t: translate } = useTranslation();
    const [selectedStats, setSelectedStats] = useState(TREND_STATS([], translate)
        .filter((ts) => ts.id === 'hitfxera--1' && ts.pitchType === -1 && ts.islhb === -1));
    const [showLevelChanges, setShowLevelChanges] = useState(initialShowLevelChange);
    const [showAdjustments, setShowAdjustments] = useState(initialShowAdjustments);
    return (React.createElement("div", { className: "border rounded p-3 mt-3 bg-white d-flex position-relative", style: { height } },
        React.createElement(DataPointMenu, { trends: trends, stats: selectedStats, setStats: setSelectedStats, pitchTypes: pitchTypes }),
        React.createElement("div", { className: "flex-grow-1" },
            React.createElement("div", { className: "mb-5" },
                React.createElement("div", { className: "d-flex justify-content-center position-absolute", style: { inset: 'auto 0' } },
                    React.createElement(DateRangeButtonGroup, { value: dateRange, onChange: setDateRange, dateOptions: dateOptions })),
                React.createElement("div", { className: "position-absolute end-0 mt-1" },
                    React.createElement(ChartDisplayOptions, { showLevelChanges: showLevelChanges, setShowLevelChanges: setShowLevelChanges, showAdjustments: showAdjustments, setShowAdjustments: setShowAdjustments }))),
            React.createElement("div", null,
                React.createElement(TrendsChart, { isLoading: isLoading, trends: trends, showLevelChanges: showLevelChanges, showAdjustments: showAdjustments, levelChanges: levelChanges, adjustments: adjustments, selectedStats: selectedStats, setSelectedStats: setSelectedStats })))));
};

const StyledMenu = styled.div `
    background-color: white;
    width: ${(props) => props.$width}px;
    height: 100%;
    border-right: 1px solid ${styles.theme.border.alto};
    overflow: auto;
    flex-shrink: 0;
`;
const StyledHeader$1 = styled.div `
    position: sticky;
    top: 0;
    background-color: white;
    height: 40px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    font-size: 14px;
    padding: 0 10px;
    font-weight: 700;
    color: ${styles.theme.fontColors.doveGray};
    border-bottom: 1px solid ${styles.theme.border.alto};
`;
const StyledDaySummary = styled.button `
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    padding: 10px;
    border-bottom: 1px solid ${styles.theme.border.alto};
    width: 100%;
    text-align: left;
    background-color: ${(props) => (props.$isSelected ? '#E6F5FF' : 'white')}
`;
const StyledDaySummaryTitle = styled.div `
    font-size: 16px;
    font-weight: 700;
    color: ${styles.theme.fontColors.darkBlue};
`;
const StyledDaySummarySubtitle = styled.div `
    font-weight: 700;
    font-size: 14px;
    color: ${styles.theme.fontColors.doveGray};
`;
const StyledSummaryData = styled.div `
    font-size: 13px;
    margin-top: 2px;
`;
const StyledMenuItem = styled.div `
    margin-top: 2px;
`;
const MenuItemKey = styled(StyledMenuItem) `
    font-weight: bold;
`;
const MenuItemValue = styled(StyledMenuItem) `
    color: ${styles.theme.fontColors.mineShaft}
`;
const getOpponent = (ds) => {
    if (!ds.gameid) {
        return '';
    }
    return ds.teamid === ds.hometeamid ? `VS. ${ds.awayabbr}` : `@ ${ds.homeabbr}`;
};
const Menu = ({ daySummaries, selectedDaySummaryId, setSelectedDaySummaryId, menuItemComponent: MenuItem, width = 250, hideMenuTitle }) => (React.createElement(StyledMenu, { "$width": width },
    !hideMenuTitle && (React.createElement(StyledHeader$1, null, "Workload/Mechanics")),
    daySummaries.map((ds) => (React.createElement(StyledDaySummary, { key: ds.daysummaryid, "$isSelected": selectedDaySummaryId === ds.daysummaryid, onClick: () => setSelectedDaySummaryId(ds.daysummaryid) },
        React.createElement("div", { className: "d-flex justify-content-between" },
            React.createElement(StyledDaySummaryTitle, null, date(ds.date)),
            React.createElement(StyledDaySummarySubtitle, null, getOpponent(ds))),
        React.createElement(StyledSummaryData, null,
            React.createElement(MenuItem, { daySummary: ds })))))));

const StyledStat$1 = styled.div `
    background-color: ${styles.theme.background.endeavour};
    color: white;
    border-radius: 5px;
    text-align: center;
    padding: 7px 0;
`;
const StyledLabel$1 = styled.div `
    font-size: 12px;
`;
const StyledValue$1 = styled.div `
    font-size: 24px;
    font-weight: 700;
`;
const StyledStatWrapper = styled.div `
    padding: 20px;
    border-radius: 5px;
    background-color: white;
    border: 1px solid ${styles.theme.border.alto};
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(${(props) => props.$numStats / 2},minmax(0,1fr));
    @media (min-width: 992px) {
        grid-template-columns: repeat(${(props) => props.$numStats},minmax(0,1fr));
    }
`;
const Stat = ({ label, value }) => (React.createElement(StyledStat$1, null,
    React.createElement(StyledLabel$1, null, label),
    React.createElement(StyledValue$1, null, value)));
const SummaryStats = ({ summaryStats }) => (React.createElement(StyledStatWrapper, { "$numStats": summaryStats.length }, summaryStats.map((ss) => React.createElement(Stat, { label: ss.label, value: ss.value, key: ss.label }))));

const StyledCard$1 = styled.div `
    padding: 20px;
    border-radius: 5px;
    background-color: white;
    border: 1px solid ${styles.theme.border.alto};
`;
const Card = ({ children }) => React.createElement(StyledCard$1, null, children);

const StyledCardTitle = styled.div `
    font-family: ${styles.theme.font.header};
    font-weight: 700;
    font-size: 16px;
`;
const CardTitle = ({ children }) => React.createElement(StyledCardTitle, null, children);

const StyledLegend = styled.div `
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
`;
const StyledLegendMarker = styled.div `
    height: 13px;
    width: 13px;
    background-color: ${(props) => props.$color};
    margin-right: 6px;
`;
const StyledTimelineWrapper = styled.div `
    margin: 0 -14px;
`;
const ThrowTimeline = ({ throws, showLegend }) => (React.createElement(Card, null,
    React.createElement("div", { className: "d-flex justify-content-between" },
        React.createElement(CardTitle, null, "Throw Timeline"),
        showLegend && (React.createElement(StyledLegend, null,
            React.createElement("div", { className: "d-flex align-items-center" },
                React.createElement(StyledLegendMarker, { "$color": "#FF0000" }),
                "Game Throw"),
            React.createElement("div", { className: "d-flex align-items-center ms-3" },
                React.createElement(StyledLegendMarker, { "$color": "#254c75" }),
                "Other Throw")))),
    React.createElement(StyledTimelineWrapper, { className: "mt-2" },
        React.createElement(ThrowTimelineChart, { throws: throws }))));

const StyledTableWrapper = styled.div `
    font-size: 14px !important;
    text-align: center;
    &&& {
        table {
            border: 1px solid ${styles.theme.fontColors.doveGray};
            &.table thead tr th {
                background-color: white !important;
                border-top: 1px solid ${styles.theme.fontColors.doveGray};
                border-right: 1px solid ${styles.theme.fontColors.doveGray};
                border-bottom: none !important;
            }
            &.table tbody tr td {
                border-right: 1px solid ${styles.theme.fontColors.doveGray};
                box-shadow: none;
            }
            &.table tbody tr td,th {
                padding: .5rem .25rem;
            }
        }
    }
`;
const TableWrapper = ({ children, className }) => React.createElement(StyledTableWrapper, { className: className }, children);

var getInnings = (throws) => {
    const inningThrows = throws.filter((t) => t.inning);
    if (!inningThrows.length)
        return [];
    let currentInning = inningThrows[0].inning;
    let chunkIndex = 0;
    const chunks = [[inningThrows[0]]];
    for (let i = 1; i < inningThrows.length; i++) {
        const t = inningThrows[i];
        if (t.inning !== currentInning) {
            chunkIndex += 1;
            chunks[chunkIndex] = [t];
        }
        else {
            chunks[chunkIndex].push(t);
        }
        currentInning = t.inning;
    }
    return chunks;
};

var calculateInningTempo = (inning) => {
    let timeDiff = 0;
    let timeDiffCount = 0;
    for (let i = 0; i < inning.length - 1; i++) {
        timeDiff += (new Date(inning[i + 1].datetime).valueOf() - new Date(inning[i].datetime).valueOf()) / 1000;
        timeDiffCount += 1;
    }
    return { timeDiff, timeDiffCount };
};

const getRows$1 = (translate, throws) => {
    const firstWarmupIndex = throws.findIndex((t) => t.throwtype === THROW_TYPES.game || t.throwtype === THROW_TYPES.warmup);
    const innings = getInnings(throws.slice(firstWarmupIndex, throws.length));
    return innings.map((inning, index) => {
        var _a;
        const fbs = inning.filter((t) => { var _a; return [1, 9, 10].includes((_a = t.fxtype) !== null && _a !== void 0 ? _a : 0); });
        const fbRange = fbs.length
            ? `${format(Math.min(...fbs.map((t) => { var _a; return (_a = t.velocity) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER; })), 1)} – 
            ${format(Math.max(...fbs.map((t) => { var _a; return (_a = t.velocity) !== null && _a !== void 0 ? _a : Number.MIN_SAFE_INTEGER; })), 1)}`
            : '--';
        const { timeDiff, timeDiffCount } = calculateInningTempo(inning);
        let recovery;
        if (index) {
            const diff = (new Date(inning[0].datetime).valueOf() - new Date(innings[index - 1][innings[index - 1].length - 1].datetime).valueOf());
            recovery = `${format(diff / (60 * 1000), 0)}${translate('common.abbr-minute')} ${format((diff % (60 * 1000)) / 1000, 0)}${translate('common.abbr-second')}`;
        }
        else if (firstWarmupIndex > 0) {
            const diff = (new Date(inning[0].datetime).valueOf() - new Date(throws[firstWarmupIndex - 1].datetime).valueOf());
            recovery = `${format(diff / (60 * 1000), 0)}${translate('common.abbr-minute')} ${format((diff % (60 * 1000)) / 1000, 0)}${translate('common.abbr-second')}`;
        }
        return {
            inning: (_a = inning.find((t) => t.inning)) === null || _a === void 0 ? void 0 : _a.inning,
            warmups: inning.filter((t) => t.throwtype === THROW_TYPES.warmup).length,
            pitches: inning.filter((t) => t.throwtype === THROW_TYPES.game).length,
            velo: fbRange,
            tempo: timeDiffCount ? `${format(timeDiff / timeDiffCount, 1)}${translate('common.abbr-second')}` : '--',
            recovery,
        };
    });
};
const GameSummary = ({ throws }) => {
    const { t: translate } = useTranslation();
    const columns = [
        { id: 'inning', title: translate('baseball.inning'), type: COLUMN_TYPES.TEXT },
        { id: 'warmups', title: translate('components.mechanics.warmups'), type: COLUMN_TYPES.TEXT },
        { id: 'pitches', title: translate('baseball.pitches_other'), type: COLUMN_TYPES.TEXT },
        { id: 'tempo', title: translate('components.mechanics.tempo'), type: COLUMN_TYPES.TEXT },
        { id: 'recovery', title: translate('components.mechanics.recovery'), type: COLUMN_TYPES.TEXT },
        { id: 'velo', title: translate('components.mechanics.fb-velocity'), type: COLUMN_TYPES.TEXT },
    ];
    return (React.createElement(Card, null,
        React.createElement(CardTitle, null, translate('components.mechanics.game-summary')),
        React.createElement(TableWrapper, { className: "mt-3" },
            React.createElement(DataTable, { columns: columns, rows: getRows$1(translate, throws) }))));
};

const StyledHeader = styled.div `
    font-weight: bold;
    font-size: 14px;
    color: ${(props) => props.$color};
`;
const StyledChartLabel = styled.div `
    font-size: 14px;
    font-weight: 400;
    color: #333333;
`;
const StyledChartBar = styled.div `
    position: absolute;
    top: 8px;
    height: 5px;
    background-color: #CECECE;
    border-radius: 9999px;
    width: 100%;
`;
const StyledBarWrapper = styled.div `
    position: relative;
    flex-grow: 1;
    height: 21px;
`;
const StyledFbMarker = styled.div `
    position: absolute;
    height: 10px;
    background-color: #FF0000;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    left: ${(props) => props.$left}%;
    width: ${(props) => props.$width}%;
`;
const StyledOffspeedMarker = styled.div `
    position: absolute;
    top: 13px;
    height: 10px;
    background-color: #005A9C;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    left: ${(props) => props.$left}%;
    width: ${(props) => props.$width}%;
`;
const getData = (magnitudes) => {
    const mean = magnitudes.reduce((sum, v) => sum + v, 0) / magnitudes.length;
    const sd = Math.sqrt(magnitudes.map((m) => Math.pow((m - mean), 2)).reduce((sum, v) => sum + v, 0) / magnitudes.length);
    return { min: mean - sd, max: mean + sd };
};
const MagnitudeChart = ({ className, throws }) => {
    const fbMagnitudes = throws.filter((t) => { var _a; return [1, 9, 10].includes((_a = t.fxtype) !== null && _a !== void 0 ? _a : 0) && t.throwtype === THROW_TYPES.game; }).map((t) => t.magnitude);
    const offspeedMagnitudes = throws.filter((t) => { var _a; return ![1, 9, 10].includes((_a = t.fxtype) !== null && _a !== void 0 ? _a : 0) && t.throwtype === THROW_TYPES.game; }).map((t) => t.magnitude);
    const fbRange = getData(fbMagnitudes);
    const offspeedRange = getData(offspeedMagnitudes);
    const min = Math.min(fbRange.min, offspeedRange.min, 700);
    const max = Math.max(fbRange.max, offspeedRange.max, 1200);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "d-flex" },
            React.createElement(StyledHeader, { "$color": "#FF0000", className: "d-flex justify-content-end w-50 pe-2" }, "Fastball"),
            React.createElement(StyledHeader, { "$color": "#005A9C", className: "w-50 ps-2" }, "Off-Speed")),
        React.createElement("div", { className: "d-flex align-items-center mt-3" },
            React.createElement(StyledChartLabel, { className: "me-2" },
                format(min),
                " deg/s"),
            React.createElement(StyledBarWrapper, null,
                React.createElement(StyledFbMarker, { "$left": (fbRange.min - min) / (max - min) * 100, "$width": (fbRange.max - fbRange.min) / (max - min) * 100 }),
                React.createElement(StyledChartBar, null),
                React.createElement(StyledOffspeedMarker, { "$left": (offspeedRange.min - min) / (max - min) * 100, "$width": (offspeedRange.max - offspeedRange.min) / (max - min) * 100 })),
            React.createElement(StyledChartLabel, { className: "ms-2" },
                format(max),
                " deg/s"))));
};

const getTrunkRotaionParams$1 = (throws) => {
    const flexion = throws.map((t) => t.rotx).reduce((sum, v) => sum + v, 0);
    const rotation = throws.map((t) => t.roty).reduce((sum, v) => sum + v, 0);
    const tilt = throws.map((t) => t.rotz).reduce((sum, v) => sum + v, 0);
    const sum = flexion + rotation + tilt;
    return { flexion: flexion / sum, rotation: rotation / sum, tilt: tilt / sum };
};
const TrunkRotation = ({ throws }) => {
    const { t: translate } = useTranslation();
    const { rotation, flexion, tilt } = getTrunkRotaionParams$1(throws);
    return (React.createElement(Card, null,
        React.createElement(CardTitle, null, translate('components.mechanics.trunk-title')),
        React.createElement(MagnitudeChart, { className: "mt-3 mb-3", throws: throws }),
        React.createElement(TrunkRotationPieChart, { rotation: rotation, flexion: flexion, tilt: tilt, height: 300 })));
};

const StyledDataPane$1 = styled.div `
    display: inline-grid;
    gap: 1rem;
    grid-template-columns: repeat(1,minmax(0,1fr));
    flex-grow: 1;
    padding: 16px 18px;
    grid-auto-rows: fit-content(1em);
    overflow: auto;
`;
const calculateTempo = (gamePitches) => {
    const innings = getInnings(gamePitches);
    let totalTimeDiff = 0;
    let totalTimeDiffCount = 0;
    innings.forEach((inning) => {
        const { timeDiff, timeDiffCount } = calculateInningTempo(inning);
        totalTimeDiff += timeDiff;
        totalTimeDiffCount += timeDiffCount;
    });
    if (totalTimeDiffCount) {
        return `${format(totalTimeDiff / totalTimeDiffCount, 1)}s`;
    }
    return '-';
};
const DataPane$1 = ({ isLoading, playerId, daySummary, getPitcherDaySummary, hideGpsDataLabel }) => {
    const { t: translate } = useTranslation();
    const [isLoadingDaySummary, setIsLoadingDaySummary] = useState(true);
    const [throws, setThrows] = useState([]);
    useEffect(() => {
        if (playerId && (daySummary === null || daySummary === void 0 ? void 0 : daySummary.daysummaryid)) {
            const getData = () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    setIsLoadingDaySummary(true);
                    const data = yield getPitcherDaySummary(playerId, daySummary.daysummaryid);
                    setThrows(data.throws);
                }
                finally {
                    setIsLoadingDaySummary(false);
                }
            });
            getData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [playerId, daySummary === null || daySummary === void 0 ? void 0 : daySummary.daysummaryid]);
    if (isLoading || isLoadingDaySummary) {
        return (React.createElement("div", { className: "d-flex justify-content-center py-5 flex-grow-1" },
            React.createElement(LoadingSpinner$1, null)));
    }
    const firstWarmupPitchIndex = throws.findIndex((t) => t.throwtype === THROW_TYPES.warmup || t.throwtype === THROW_TYPES.game);
    const gamePitches = throws.slice(firstWarmupPitchIndex, throws.length).filter((t) => t.throwtype === THROW_TYPES.game || t.intensity >= 0.5);
    const isGameDay = throws.some((t) => t.throwtype === THROW_TYPES.game);
    const summaryStats = [
        { label: translate('components.mechanics.throw-workload'), value: format(daySummary === null || daySummary === void 0 ? void 0 : daySummary.throwworkload) },
        { label: translate('components.mechanics.total-throws'), value: daySummary === null || daySummary === void 0 ? void 0 : daySummary.throws },
        { label: translate('components.mechanics.pre-game-throws'), value: isGameDay && firstWarmupPitchIndex >= 0 ? firstWarmupPitchIndex : '-' },
        { label: translate('components.mechanics.warmup-pitches'), value: isGameDay ? (throws !== null && throws !== void 0 ? throws : []).filter((t) => t.throwtype === 3).length : '-' },
        { label: translate('components.mechanics.game-pitches'), value: isGameDay ? (throws !== null && throws !== void 0 ? throws : []).filter((t) => t.throwtype === 1).length : '-' },
        { label: translate('components.mechanics.average-tempo'), value: isGameDay ? calculateTempo(gamePitches) : '-' },
    ];
    const EmptyState = () => React.createElement("div", { className: "d-flex justify-content-center py-5 flex-grow-1" }, translate('components.mechanics.no-throwing-data'));
    return (React.createElement(StyledDataPane$1, null, throws.length ? (React.createElement(React.Fragment, null,
        !hideGpsDataLabel && React.createElement("h3", { className: "mb-0", style: { color: '#333' } }, translate('components.mechanics.gps-data')),
        React.createElement(SummaryStats, { summaryStats: summaryStats }),
        React.createElement(ThrowTimeline, { throws: throws !== null && throws !== void 0 ? throws : [], showLegend: isGameDay }),
        isGameDay && (React.createElement(Row$1, { className: "gy-3" },
            React.createElement(Col$1, { sm: 12, md: 7 },
                React.createElement(GameSummary, { throws: throws !== null && throws !== void 0 ? throws : [] })),
            React.createElement(Col$1, { sm: 12, md: 5 },
                React.createElement(TrunkRotation, { throws: throws !== null && throws !== void 0 ? throws : [] })))))) : React.createElement(EmptyState, null)));
};

const MenuItemComponent$1 = ({ daySummary }) => (React.createElement("div", { className: "d-flex" },
    React.createElement("div", { className: "d-flex", style: { width: '65%' } },
        React.createElement(MenuItemKey, null, "Throw Work:\u00A0"),
        React.createElement(MenuItemValue, null, format(daySummary.throwworkload) || '-')),
    React.createElement("div", { className: "d-flex" },
        React.createElement(MenuItemKey, null, "Throws:\u00A0"),
        React.createElement(MenuItemValue, null, daySummary.throws || '-'))));
const EmptyState$3 = () => React.createElement("div", { className: "d-flex justify-content-center py-5 flex-grow-1" }, "No data");
const Pitcher = ({ playerId, getPitcherDaySummaries, getPitcherDaySummary, hideMenuTitle, hideGpsDataLabel }) => {
    var _a;
    const [selectedDaySummaryId, setSelectedDaySummaryId] = useState(null);
    const [isLoadingDaySummaries, setIsLoadingDaySummaries] = useState(true);
    const [daySummaries, setDaySummaries] = useState([]);
    useEffect(() => {
        const getData = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            try {
                setIsLoadingDaySummaries(true);
                const data = yield getPitcherDaySummaries(playerId);
                setDaySummaries(data.daysummaries);
                setSelectedDaySummaryId((_b = (_a = data.daysummaries[0]) === null || _a === void 0 ? void 0 : _a.daysummaryid) !== null && _b !== void 0 ? _b : null);
            }
            finally {
                setIsLoadingDaySummaries(false);
            }
        });
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [playerId]);
    const selectedDaySummary = daySummaries === null || daySummaries === void 0 ? void 0 : daySummaries.find((ds) => ds.daysummaryid === selectedDaySummaryId);
    return (React.createElement("div", { className: "d-flex h-100" },
        React.createElement(Menu, { daySummaries: (_a = daySummaries) !== null && _a !== void 0 ? _a : [], selectedDaySummaryId: selectedDaySummaryId, setSelectedDaySummaryId: setSelectedDaySummaryId, menuItemComponent: MenuItemComponent$1, width: 240, hideMenuTitle: hideMenuTitle }),
        (daySummaries === null || daySummaries === void 0 ? void 0 : daySummaries.length) || isLoadingDaySummaries
            ? (React.createElement(DataPane$1, { isLoading: isLoadingDaySummaries, playerId: playerId, daySummary: selectedDaySummary, getPitcherDaySummary: getPitcherDaySummary, hideGpsDataLabel: hideGpsDataLabel }))
            : React.createElement(EmptyState$3, null)));
};

const MULTI_COLUMN_CUTOFF = 8;
const getColumns = (sprints) => [{
        id: 'sprint1',
        title: 'Sprint',
        type: COLUMN_TYPES.TEXT,
    }, {
        id: 'speed1',
        title: 'Speed (mph)',
        type: COLUMN_TYPES.TEXT,
    }, ...(sprints.length > MULTI_COLUMN_CUTOFF ? [{
            id: 'sprint2',
            title: 'Sprint',
            type: COLUMN_TYPES.TEXT,
        }, {
            id: 'speed2',
            title: 'Speed (mph)',
            type: COLUMN_TYPES.TEXT,
        }] : [])];
const formatSpeed = (speed) => (speed ? format(speed, 1) : '-');
const getRows = (sprints) => {
    if (sprints.length > MULTI_COLUMN_CUTOFF) {
        const rows = [];
        for (let i = 0; i < sprints.length / 2; i++) {
            const secondColumnIndex = Math.ceil(sprints.length / 2) + i;
            rows.push({
                sprint1: i + 1,
                speed1: formatSpeed(sprints[i].mph),
                sprint2: sprints[secondColumnIndex] ? (secondColumnIndex + 1) : undefined,
                speed2: sprints[secondColumnIndex] ? formatSpeed(sprints[secondColumnIndex].mph) : undefined,
            });
        }
        return rows;
    }
    return sprints.map((s, i) => ({
        sprint1: i + 1,
        speed1: formatSpeed(s.mph),
    }));
};
const SprintExertionsTable = ({ sprints }) => (React.createElement(TableWrapper, null,
    React.createElement(DataTable, { columns: getColumns(sprints), rows: getRows(sprints) })));

const EmptyState$2 = () => React.createElement("div", { className: "d-flex justify-content-center py-3 fs-6 text-muted" }, "No Data");
const SprintExertions = ({ sprints = [] }) => (React.createElement(Card, null,
    React.createElement(CardTitle, null, "Sprint Exertions"),
    sprints.length
        ? (React.createElement(Row$1, { className: "mt-3" },
            React.createElement(Col$1, { sm: 12, md: 4 },
                React.createElement(SprintExertionsTable, { sprints: sprints })),
            React.createElement(Col$1, { sm: 12, md: 8 },
                React.createElement(SprintExertionsChart, { sprints: sprints })))) : React.createElement(EmptyState$2, null)));

const getTrunkRotaionParams = (swings) => {
    const flexion = swings.map((s) => s.rotx).reduce((sum, v) => sum + v, 0);
    const rotation = swings.map((s) => s.roty).reduce((sum, v) => sum + v, 0);
    const tilt = swings.map((s) => s.rotz).reduce((sum, v) => sum + v, 0);
    const sum = flexion + rotation + tilt;
    return { flexion: flexion / sum, rotation: rotation / sum, tilt: tilt / sum };
};
const EmptyState$1 = () => (React.createElement(React.Fragment, null,
    React.createElement(CardTitle, null, "Swings"),
    React.createElement("div", { className: "d-flex justify-content-center py-3 fs-6 text-muted" }, "No Data")));
const SwingMechanics = ({ swings }) => {
    const { rotation, flexion, tilt } = getTrunkRotaionParams(swings);
    return (React.createElement(Card, null, swings.length ? (React.createElement(Row$1, null,
        React.createElement(Col$1, { sm: 12, md: 4 },
            React.createElement(CardTitle, null, "Trunk Rotation Speed (Swings)"),
            React.createElement("div", { className: "mt-3" },
                React.createElement(TrunkRotationPieChart, { rotation: rotation, flexion: flexion, tilt: tilt }))),
        React.createElement(Col$1, { sm: 12, md: 8 },
            React.createElement(CardTitle, null, "Swing Timeline"),
            React.createElement("div", { className: "mt-3" },
                React.createElement(SwingTimelineChart, { swings: swings }))))) : React.createElement(EmptyState$1, null)));
};

const StyledDataPane = styled.div `
    display: inline-grid;
    gap: 1rem;
    grid-template-columns: repeat(1,minmax(0,1fr));
    flex-grow: 1;
    padding: 16px 18px;
    grid-auto-rows: fit-content(1em);
    overflow: auto;
`;
const getTopSpeed$1 = (topspeed) => (topspeed ? `${format(topspeed, 1)} mph` : '-');
const getDistance = (distance) => (distance ? `${format(distance, 1)} miles` : '-');
const DataPane = ({ isLoading, playerId, daySummary, getPositionPlayerDaySummary, hideGpsDataLabel }) => {
    var _a;
    const [isLoadingDaySummary, setIsLoadingDaySummary] = useState(true);
    const [throws, setThrows] = useState([]);
    const [swings, setSwings] = useState([]);
    const [sprints, setSprints] = useState([]);
    useEffect(() => {
        if (playerId && (daySummary === null || daySummary === void 0 ? void 0 : daySummary.daysummaryid)) {
            const getData = () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    setIsLoadingDaySummary(true);
                    const data = yield getPositionPlayerDaySummary(playerId, daySummary === null || daySummary === void 0 ? void 0 : daySummary.daysummaryid);
                    setThrows(data.throws);
                    setSwings(data.swings);
                    setSprints(data.sprints);
                }
                finally {
                    setIsLoadingDaySummary(false);
                }
            });
            getData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [playerId, daySummary === null || daySummary === void 0 ? void 0 : daySummary.daysummaryid]);
    if (isLoading || isLoadingDaySummary) {
        return (React.createElement("div", { className: "d-flex justify-content-center py-5 flex-grow-1" },
            React.createElement(LoadingSpinner$1, null)));
    }
    const summaryStats = [
        { label: 'Top Speed', value: getTopSpeed$1(daySummary === null || daySummary === void 0 ? void 0 : daySummary.topspeed) },
        { label: 'Distance', value: getDistance(daySummary === null || daySummary === void 0 ? void 0 : daySummary.distance) },
        { label: 'Movement Workload', value: format(daySummary === null || daySummary === void 0 ? void 0 : daySummary.workload) },
        { label: 'Swing Workload', value: (_a = format(daySummary === null || daySummary === void 0 ? void 0 : daySummary.swingworkload, 0)) !== null && _a !== void 0 ? _a : '-' },
        { label: 'Swings', value: swings.length || '-' },
        { label: 'Throws', value: throws.length || '-' },
    ];
    return (React.createElement(StyledDataPane, null,
        !hideGpsDataLabel && React.createElement("h3", { className: "mb-0", style: { color: '#333' } }, "GPS Data"),
        React.createElement(SummaryStats, { summaryStats: summaryStats }),
        React.createElement(SprintExertions, { sprints: sprints !== null && sprints !== void 0 ? sprints : [] }),
        React.createElement(SwingMechanics, { swings: swings !== null && swings !== void 0 ? swings : [] })));
};

const getTopSpeed = (mph) => (mph ? `${format(mph, 1)} mph` : '-');
const MenuItemComponent = ({ daySummary }) => (React.createElement("div", { className: "d-flex" },
    React.createElement("div", { className: "w-50" },
        React.createElement("div", { className: "d-flex" },
            React.createElement(MenuItemKey, null, "Top Spd:\u00A0"),
            React.createElement(MenuItemValue, null, getTopSpeed(daySummary.topspeed))),
        React.createElement("div", { className: "d-flex" },
            React.createElement(MenuItemKey, null, "Swings:\u00A0"),
            React.createElement(MenuItemValue, null, daySummary.swings || '-'))),
    React.createElement("div", null,
        React.createElement("div", { className: "d-flex" },
            React.createElement(MenuItemKey, null, "Movt Work:\u00A0"),
            React.createElement(MenuItemValue, null, format(daySummary.workload) || '-')),
        React.createElement("div", { className: "d-flex" },
            React.createElement(MenuItemKey, null, "Swing Work:\u00A0"),
            React.createElement(MenuItemValue, null, format(daySummary.swingworkload) || '-')))));
const EmptyState = () => React.createElement("div", { className: "d-flex justify-content-center py-5 flex-grow-1" }, "No data");
const PositionPlayer = ({ playerId, getPositionPlayerDaySummaries, getPositionPlayerDaySummary, hideMenuTitle, hideGpsDataLabel }) => {
    var _a;
    const [selectedDaySummaryId, setSelectedDaySummaryId] = useState(null);
    const [isLoadingDaySummaries, setIsLoadingDaySummaries] = useState(true);
    const [daySummaries, setDaySummaries] = useState([]);
    useEffect(() => {
        const getData = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            try {
                setIsLoadingDaySummaries(true);
                const data = yield getPositionPlayerDaySummaries(playerId);
                setDaySummaries(data.daysummaries);
                setSelectedDaySummaryId((_b = (_a = data.daysummaries[0]) === null || _a === void 0 ? void 0 : _a.daysummaryid) !== null && _b !== void 0 ? _b : null);
            }
            finally {
                setIsLoadingDaySummaries(false);
            }
        });
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [playerId]);
    const selectedDaySummary = daySummaries.find((ds) => ds.daysummaryid === selectedDaySummaryId);
    return (React.createElement("div", { className: "d-flex h-100" },
        React.createElement(Menu, { daySummaries: (_a = daySummaries) !== null && _a !== void 0 ? _a : [], selectedDaySummaryId: selectedDaySummaryId, setSelectedDaySummaryId: setSelectedDaySummaryId, menuItemComponent: MenuItemComponent, width: 270, hideMenuTitle: hideMenuTitle }),
        daySummaries.length || isLoadingDaySummaries
            ? (React.createElement(DataPane, { isLoading: isLoadingDaySummaries, playerId: playerId, daySummary: selectedDaySummary, getPositionPlayerDaySummary: getPositionPlayerDaySummary, hideGpsDataLabel: hideGpsDataLabel }))
            : React.createElement(EmptyState, null)));
};

const MechanicsAndWorkload = ({ isPitcher, playerId, getPitcherDaySummaries, getPitcherDaySummary, getPositionPlayerDaySummaries, getPositionPlayerDaySummary, hideMenuTitle, hideGpsDataLabel }) => (isPitcher
    ? (React.createElement(Pitcher, { playerId: playerId, getPitcherDaySummaries: getPitcherDaySummaries, getPitcherDaySummary: getPitcherDaySummary, hideMenuTitle: hideMenuTitle, hideGpsDataLabel: hideGpsDataLabel }))
    : (React.createElement(PositionPlayer, { playerId: playerId, getPositionPlayerDaySummaries: getPositionPlayerDaySummaries, getPositionPlayerDaySummary: getPositionPlayerDaySummary, hideMenuTitle: hideMenuTitle, hideGpsDataLabel: hideGpsDataLabel })));

/* eslint-disable max-len */
const CircleIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    " ",
    React.createElement("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    " ");
const SquareIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H3.6C3.26863 21 3 20.7314 3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6Z", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const LineIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M3 20L21 4", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const ArrowIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M3 12H22M22 12L19 9M22 12L19 15", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const AddTextIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, viewBox: "0 0 24 24", strokeWidth: "1.5" },
    React.createElement("path", { d: "M12 8L12 16M12 8H8M12 8H16", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M21 13.5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V13.5M21 10.5V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V10.5", strokeWidth: "1.5", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M19.5 13.5V10.5H22.5V13.5H19.5Z", strokeWidth: "1.5", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M1.5 13.5V10.5H4.5V13.5H1.5Z", strokeWidth: "1.5", strokeLinejoin: "round" }));
const EditTextIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M19 7V5L5 5V7", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M12 5L12 19M12 19H10M12 19H14", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const BoldIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "2.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M12 11.6667H8M12 11.6667C12 11.6667 15.3333 11.6667 15.3333 8.33333C15.3333 5.00002 12 5 12 5C12 5 12 5 12 5H8.6C8.26863 5 8 5.26863 8 5.6V11.6667M12 11.6667C12 11.6667 16 11.6667 16 15.3333C16 19 12 19 12 19C12 19 12 19 12 19H8.6C8.26863 19 8 18.7314 8 18.4V11.6667", strokeWidth: "2.5" }));
const ItalicsIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M11 5L14 5M17 5L14 5M14 5L10 19M10 19L7 19M10 19L13 19", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const UnderlineIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M16 5V11C16 13.2091 14.2091 15 12 15V15C9.79086 15 8 13.2091 8 11V5", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M6 19L18 19", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const TransparentFillIcon = ({ height, width }) => React.createElement("svg", { fill: "black", height: height, width: width, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H3.6C3.26863 21 3 20.7314 3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6Z", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4 20L20 4", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", stroke: "red" }));
const TransparentStrokeIcon = ({ height, width }) => React.createElement("svg", { stroke: "black", fill: "none", height: height, width: width, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H3.6C3.26863 21 3 20.7314 3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6Z", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4 20L20 4", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", stroke: "red" }));
const StrokeWidthIcon = ({ height, width }) => React.createElement("svg", { height: height, width: width, viewBox: "0 0 48 48" },
    " ",
    React.createElement("g", null,
        " ",
        React.createElement("rect", { x: "4", y: "8", width: "40", height: "2", rx: "1", ry: "1" }),
        " ",
        React.createElement("rect", { x: "4", y: "20", width: "40", height: "5", rx: "1", ry: "1" }),
        " ",
        React.createElement("rect", { x: "4", y: "32", width: "40", height: "10", rx: "1", ry: "1" }),
        " "),
    " ");
const CheckIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M5 13L9 17L19 7", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const AddShapeIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => (React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    " ",
    React.createElement("circle", { cx: "10", cy: "10", r: "8", fill: "transparent", stroke: "black", strokeWidth: "1.5" }),
    " ",
    React.createElement("rect", { x: "9", y: "9", width: "13", height: "13", fill: "white", stroke: "black", strokeWidth: "1.5" }),
    " "));
const BringToFrontIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => (React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    " ",
    React.createElement("rect", { x: "1.5", y: "1.5", width: "10", height: "10", fill: "white", stroke: "black", strokeWidth: "1.5" }),
    " ",
    React.createElement("rect", { x: "13.5", y: "13.5", width: "10", height: "10", fill: "white", stroke: "black", strokeWidth: "1.5" }),
    " ",
    React.createElement("rect", { x: "7", y: "7", width: "10", height: "10", fill: "black", stroke: "black", strokeWidth: "1.5" }),
    " "));
const SendToBackIcon = ({ height, width, fill = 'none', stroke = 'currentColor' }) => (React.createElement("svg", { height: height, width: width, fill: fill, stroke: stroke, strokeWidth: "1.5", viewBox: "0 0 24 24" },
    " ",
    React.createElement("rect", { x: "7", y: "7", width: "10", height: "10", fill: "black", stroke: "black", strokeWidth: "1.5" }),
    " ",
    React.createElement("rect", { x: "1.5", y: "1.5", width: "10", height: "10", fill: "white", stroke: "black", strokeWidth: "1.5" }),
    " ",
    React.createElement("rect", { x: "13.5", y: "13.5", width: "10", height: "10", fill: "white", stroke: "black", strokeWidth: "1.5" }),
    " "));

var ELEMENT_TYPE;
(function (ELEMENT_TYPE) {
    ELEMENT_TYPE[ELEMENT_TYPE["RECTANGLE"] = 0] = "RECTANGLE";
    ELEMENT_TYPE[ELEMENT_TYPE["ELLIPSE"] = 1] = "ELLIPSE";
    ELEMENT_TYPE[ELEMENT_TYPE["LINE"] = 2] = "LINE";
    ELEMENT_TYPE[ELEMENT_TYPE["TEXT"] = 3] = "TEXT";
    ELEMENT_TYPE[ELEMENT_TYPE["ARROW"] = 4] = "ARROW";
})(ELEMENT_TYPE || (ELEMENT_TYPE = {}));
const ELEMENTS = [
    { label: 'rectangle', type: ELEMENT_TYPE.RECTANGLE, icon: SquareIcon },
    { label: 'ellipse', type: ELEMENT_TYPE.ELLIPSE, icon: CircleIcon },
    { label: 'line', type: ELEMENT_TYPE.LINE, icon: LineIcon },
    { label: 'arrow', type: ELEMENT_TYPE.ARROW, icon: ArrowIcon },
];
var COLOR;
(function (COLOR) {
    COLOR[COLOR["TRANSPARENT"] = 0] = "TRANSPARENT";
    COLOR[COLOR["BLACK"] = 1] = "BLACK";
    COLOR[COLOR["RED"] = 2] = "RED";
    COLOR[COLOR["ORANGE"] = 3] = "ORANGE";
    COLOR[COLOR["YELLOW"] = 4] = "YELLOW";
    COLOR[COLOR["GREEN"] = 5] = "GREEN";
    COLOR[COLOR["BLUE"] = 6] = "BLUE";
    COLOR[COLOR["PURPLE"] = 7] = "PURPLE";
})(COLOR || (COLOR = {}));
const COLORS = [
    { type: COLOR.TRANSPARENT, colorCode: 'transparent' },
    { type: COLOR.BLACK, colorCode: 'black' },
    { type: COLOR.RED, colorCode: '#e31a1c' },
    { type: COLOR.ORANGE, colorCode: '#ff7f00' },
    { type: COLOR.YELLOW, colorCode: '#fde047' },
    { type: COLOR.GREEN, colorCode: '#33a02c' },
    { type: COLOR.BLUE, colorCode: '#1f78b4' },
    { type: COLOR.PURPLE, colorCode: '#6a3d9a' },
];
const FONT_SIZE_OPTIONS = [8, 10, 12, 14, 16, 18, 20, 24, 30, 36, 42, 48, 54, 60, 72, 120];
const STROKE_WIDTH_OPTIONS = [1, 2, 3, 4, 6, 8, 12];
const ICON_SIZE = '1.25em';

const AddTextButton = ({ height, width, elements, setElements, selectedFontColor, idCounter, setIdCounter, setSelectedElementId, selectedFontSize, }) => {
    const { t: translate } = useTranslation();
    const addText = () => {
        var _a;
        const newId = `TEXT-${idCounter}`;
        setElements([...elements, {
                id: newId,
                type: ELEMENT_TYPE.TEXT,
                x: width / 2,
                y: height / 2,
                text: translate('image-markup.enter-text'),
                fill: (_a = COLORS.find((c) => c.type === selectedFontColor)) === null || _a === void 0 ? void 0 : _a.colorCode,
                fontSize: selectedFontSize,
            }]);
        setIdCounter((id) => id + 1);
        setSelectedElementId(newId);
    };
    return React.createElement(Button$1, { className: "d-flex align-items-center", variant: "", onClick: addText },
        React.createElement(AddTextIcon, { height: ICON_SIZE, width: ICON_SIZE }));
};

const StyledDropdown$4 = styled(Dropdown$1) `
    .btn {
        min-height: 23px;
        min-width: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .dropdown-menu {
        min-width: auto !important;
    }
`;
const AddShapeDropdown = ({ height, width, elements, setElements, idCounter, setIdCounter, selectedStroke, selectedStrokeWidth, selectedFill, setSelectedElementId, }) => {
    const addShape = (elementType) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const newId = `${(_a = ELEMENTS.find((s) => s.type === elementType)) === null || _a === void 0 ? void 0 : _a.label}-${idCounter}`;
        let newShape;
        switch (elementType) {
            case ELEMENT_TYPE.RECTANGLE:
                newShape = {
                    type: elementType,
                    x: (width / 2) - (width / 20),
                    y: (height / 2) - (height / 20),
                    width: width / 10,
                    height: width / 10,
                    stroke: (_b = COLORS.find((c) => c.type === selectedStroke)) === null || _b === void 0 ? void 0 : _b.colorCode,
                    strokeWidth: selectedStrokeWidth,
                    fill: (_c = COLORS.find((c) => c.type === selectedFill)) === null || _c === void 0 ? void 0 : _c.colorCode,
                };
                break;
            case ELEMENT_TYPE.ELLIPSE:
                newShape = {
                    type: elementType,
                    x: (width / 2),
                    y: (height / 2),
                    radiusX: width / 20,
                    radiusY: width / 20,
                    width: width / 10,
                    height: width / 10,
                    stroke: (_d = COLORS.find((c) => c.type === selectedStroke)) === null || _d === void 0 ? void 0 : _d.colorCode,
                    strokeWidth: selectedStrokeWidth,
                    fill: (_e = COLORS.find((c) => c.type === selectedFill)) === null || _e === void 0 ? void 0 : _e.colorCode,
                };
                break;
            case ELEMENT_TYPE.LINE:
            case ELEMENT_TYPE.ARROW:
                newShape = {
                    type: elementType,
                    x: 0,
                    y: 0,
                    points: [width / 4, height / 2, 3 * width / 4, height / 2],
                    stroke: (_f = COLORS.find((c) => c.type === selectedStroke)) === null || _f === void 0 ? void 0 : _f.colorCode,
                    strokeWidth: selectedStrokeWidth,
                    fill: (_g = COLORS.find((c) => c.type === selectedStroke)) === null || _g === void 0 ? void 0 : _g.colorCode,
                    tension: 1,
                };
                break;
            default:
                return;
        }
        setElements([...elements, Object.assign(Object.assign({}, newShape), { id: newId })]);
        setIdCounter((id) => id + 1);
        setSelectedElementId(newId);
    };
    return (React.createElement(StyledDropdown$4, { className: "ms-1" },
        React.createElement(Dropdown$1.Toggle, { size: "sm", variant: "" },
            React.createElement(AddShapeIcon, { height: ICON_SIZE, width: ICON_SIZE, stroke: "black" })),
        React.createElement(Dropdown$1.Menu, null, ELEMENTS.map((s) => (React.createElement(Dropdown$1.Item, { key: s.type, onClick: () => addShape(s.type) }, s.icon({ height: '1.25em', width: '1.25em' })))))));
};

const StyledDropdown$3 = styled(Dropdown$1) `
    .btn {
        min-height: 23px;
        min-width: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .dropdown-menu {
        min-width: auto !important;
    }
`;
const SelectFillDropdown = ({ elements, setElements, selectedElementId, selectedFill, setSelectedFill }) => {
    var _a;
    const setFill = (colorType) => {
        var _a;
        if (selectedElementId) {
            const newElementIndex = elements.findIndex((s) => s.id === selectedElementId);
            if (elements[newElementIndex].type !== ELEMENT_TYPE.TEXT && elements[newElementIndex].type !== ELEMENT_TYPE.ARROW) {
                const newElements = elements.slice();
                newElements[newElementIndex].fill = (_a = COLORS.find((c) => c.type === colorType)) === null || _a === void 0 ? void 0 : _a.colorCode;
                setElements(newElements);
            }
        }
        setSelectedFill(colorType);
    };
    return (React.createElement(StyledDropdown$3, null,
        React.createElement(Dropdown$1.Toggle, { size: "sm", variant: "" }, selectedFill === COLOR.TRANSPARENT
            ? React.createElement(TransparentFillIcon, { height: ICON_SIZE, width: ICON_SIZE })
            : React.createElement(SquareIcon, { height: ICON_SIZE, width: ICON_SIZE, stroke: "none", fill: (_a = COLORS.find((c) => c.type === selectedFill)) === null || _a === void 0 ? void 0 : _a.colorCode })),
        React.createElement(Dropdown$1.Menu, null, COLORS.map((c) => (React.createElement(Dropdown$1.Item, { key: c.type, onClick: () => setFill(c.type) }, c.type === COLOR.TRANSPARENT
            ? React.createElement(TransparentFillIcon, { height: ICON_SIZE, width: ICON_SIZE })
            : React.createElement(SquareIcon, { height: ICON_SIZE, width: ICON_SIZE, stroke: "none", fill: c.colorCode })))))));
};

const StyledDropdown$2 = styled(Dropdown$1) `
    .btn {
        min-height: 23px;
        min-width: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .dropdown-menu {
        min-width: auto !important;
    }
`;
const SelectStrokeDropdown = ({ elements, setElements, selectedElementId, selectedStroke, setSelectedStroke }) => {
    var _a;
    const setStroke = (colorType) => {
        var _a, _b;
        if (selectedElementId) {
            const newElementIndex = elements.findIndex((s) => s.id === selectedElementId);
            if (elements[newElementIndex].type !== ELEMENT_TYPE.TEXT) {
                const newElements = elements.slice();
                newElements[newElementIndex].stroke = (_a = COLORS.find((c) => c.type === colorType)) === null || _a === void 0 ? void 0 : _a.colorCode;
                if (elements[newElementIndex].type === ELEMENT_TYPE.ARROW) {
                    newElements[newElementIndex].fill = (_b = COLORS.find((c) => c.type === colorType)) === null || _b === void 0 ? void 0 : _b.colorCode;
                }
                setElements(newElements);
            }
        }
        setSelectedStroke(colorType);
    };
    return (React.createElement(StyledDropdown$2, null,
        React.createElement(Dropdown$1.Toggle, { size: "sm", variant: "" }, selectedStroke === COLOR.TRANSPARENT
            ? React.createElement(TransparentStrokeIcon, { height: ICON_SIZE, width: ICON_SIZE })
            : React.createElement(SquareIcon, { height: ICON_SIZE, width: ICON_SIZE, stroke: (_a = COLORS.find((c) => c.type === selectedStroke)) === null || _a === void 0 ? void 0 : _a.colorCode })),
        React.createElement(Dropdown$1.Menu, null, COLORS.map((c) => (React.createElement(Dropdown$1.Item, { key: c.type, onClick: () => setStroke(c.type) }, c.type === COLOR.TRANSPARENT
            ? React.createElement(TransparentStrokeIcon, { height: ICON_SIZE, width: ICON_SIZE })
            : React.createElement(SquareIcon, { height: ICON_SIZE, width: ICON_SIZE, stroke: c.colorCode })))))));
};

const StyledDropdown$1 = styled(Dropdown$1) `
    .btn {
        min-height: 23px;
        min-width: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .dropdown-menu {
        min-width: auto !important;
    }
`;
const SelectStrokeWidthDropdown = ({ elements, setElements, selectedElementId, selectedStrokeWidth, setSelectedStrokeWidth, }) => {
    const setStrokeWidth = (strokeWidth) => {
        if (selectedElementId) {
            const newElementIndex = elements.findIndex((s) => s.id === selectedElementId);
            if (elements[newElementIndex].type !== ELEMENT_TYPE.TEXT) {
                const newElements = elements.slice();
                newElements[newElementIndex].strokeWidth = +strokeWidth;
                setElements(newElements);
            }
        }
        setSelectedStrokeWidth(strokeWidth);
    };
    return (React.createElement(StyledDropdown$1, null,
        React.createElement(Dropdown$1.Toggle, { size: "sm", variant: "" },
            React.createElement(StrokeWidthIcon, { height: ICON_SIZE, width: ICON_SIZE })),
        React.createElement(Dropdown$1.Menu, null, STROKE_WIDTH_OPTIONS.map((o) => (React.createElement(Dropdown$1.Item, { key: o, onClick: () => setStrokeWidth(o), className: "d-flex align-items-center ps-1" },
            React.createElement("div", { style: { width: '1.25rem' }, className: "d-flex justify-content-center align-items-center me-1" }, o === selectedStrokeWidth && React.createElement(CheckIcon, null)),
            React.createElement("div", { className: "d-flex align-items-center", style: { height: '1.5rem' } },
                React.createElement("div", { style: { width: '3rem', height: o, backgroundColor: 'black' } }))))))));
};

const StyledDropdown = styled(Dropdown$1) `
    .btn {
        min-height: 23px;
        min-width: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .dropdown-menu {
        min-width: auto !important;
    }
`;
const EditTextDropdown = ({ elements, setElements, isBold, setIsBold, isItalics, setIsItalics, isUnderline, setIsUnderline, selectedFontSize, setSelectedFontSize, selectedElementId, selectedFontColor, setSelectedFontColor, }) => {
    var _a, _b;
    const updateTextStyle = (style, styleKey, isStyleApplied) => {
        const newElements = elements.slice();
        const newShapeIndex = newElements.findIndex((s) => s.id === selectedElementId);
        if (isStyleApplied === undefined) {
            newElements[newShapeIndex][styleKey] = style;
        }
        else {
            newElements[newShapeIndex][styleKey] = isStyleApplied
                ? (newElements[newShapeIndex][styleKey] || '').replaceAll(style, '')
                : `${(newElements[newShapeIndex][styleKey] || '')} ${style}`.trim();
        }
        setElements(newElements);
    };
    const isTextElementSelected = selectedElementId && ((_a = elements.find((s) => s.id === selectedElementId)) === null || _a === void 0 ? void 0 : _a.type) === ELEMENT_TYPE.TEXT;
    const toggleIsBold = () => {
        if (isTextElementSelected) {
            updateTextStyle('bold', 'fontStyle', isBold);
        }
        setIsBold((x) => !x);
    };
    const toggleIsItalics = () => {
        if (isTextElementSelected) {
            updateTextStyle('italic', 'fontStyle', isItalics);
        }
        setIsItalics((x) => !x);
    };
    const toggleIsUnderline = () => {
        if (isTextElementSelected) {
            updateTextStyle('underline', 'textDecoration', isUnderline);
        }
        setIsUnderline((x) => !x);
    };
    const onSetSelectedFontSize = (newFontSize) => {
        if (isTextElementSelected) {
            updateTextStyle(newFontSize, 'fontSize');
        }
        setSelectedFontSize(newFontSize);
    };
    const onSetSelectedFontColor = (newFontColor) => {
        var _a;
        if (isTextElementSelected) {
            updateTextStyle(((_a = COLORS.find((c) => c.type === newFontColor)) === null || _a === void 0 ? void 0 : _a.colorCode) || 'black', 'fill');
        }
        setSelectedFontColor(newFontColor);
    };
    return (React.createElement(StyledDropdown, { className: "ms-1", autoClose: "outside" },
        React.createElement(Dropdown$1.Toggle, { size: "sm", variant: "" },
            React.createElement(EditTextIcon, { height: ICON_SIZE, width: ICON_SIZE })),
        React.createElement(Dropdown$1.Menu, { className: "px-2" },
            React.createElement("div", { className: "d-flex align-items-center" },
                React.createElement(ButtonGroup, null,
                    React.createElement(Button$1, { variant: isBold ? 'primary' : 'default', onClick: toggleIsBold },
                        React.createElement(BoldIcon, { height: ICON_SIZE, width: ICON_SIZE })),
                    React.createElement(Button$1, { variant: isItalics ? 'primary' : 'default', onClick: toggleIsItalics },
                        React.createElement(ItalicsIcon, { height: ICON_SIZE, width: ICON_SIZE })),
                    React.createElement(Button$1, { variant: isUnderline ? 'primary' : 'default', onClick: toggleIsUnderline },
                        React.createElement(UnderlineIcon, { height: ICON_SIZE, width: ICON_SIZE }))),
                React.createElement(Form$1.Select, { style: { minWidth: '4rem' }, className: "ms-1", value: selectedFontSize, onChange: (e) => onSetSelectedFontSize(e.target.value), size: "sm" }, FONT_SIZE_OPTIONS.map((o) => React.createElement("option", { key: o, value: o }, o))),
                React.createElement(StyledDropdown, null,
                    React.createElement(Dropdown$1.Toggle, { size: "sm", variant: "" },
                        React.createElement(SquareIcon, { height: ICON_SIZE, width: ICON_SIZE, stroke: "none", fill: (_b = COLORS.find((c) => c.type === selectedFontColor)) === null || _b === void 0 ? void 0 : _b.colorCode })),
                    React.createElement(Dropdown$1.Menu, null, COLORS.filter((c) => c.type !== COLOR.TRANSPARENT).map((c) => (React.createElement(Dropdown$1.Item, { key: c.type, onClick: () => onSetSelectedFontColor(c.type) },
                        React.createElement(SquareIcon, { height: ICON_SIZE, width: ICON_SIZE, stroke: "none", fill: c.colorCode }))))))))));
};

const EditElementOrderButtons = ({ selectedElementId, elements, setElements }) => {
    const sendToBack = () => {
        const element = elements.splice(elements.findIndex((s) => s.id === selectedElementId), 1);
        setElements([...element, ...elements]);
    };
    const sendToFront = () => {
        const element = elements.splice(elements.findIndex((s) => s.id === selectedElementId), 1);
        setElements([...elements, ...element]);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button$1, { disabled: !selectedElementId, variant: "", onClick: sendToBack },
            React.createElement(SendToBackIcon, { height: ICON_SIZE, width: ICON_SIZE })),
        React.createElement(Button$1, { disabled: !selectedElementId, variant: "", onClick: sendToFront },
            React.createElement(BringToFrontIcon, { height: ICON_SIZE, width: ICON_SIZE }))));
};

const EditTextField = ({ element, elements, setElements }) => {
    const inputRef = useRef(null);
    useEffect(() => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    const onChange = (e) => {
        const newElements = elements.slice();
        const newElementIndex = newElements.findIndex((s) => s.id === element.id);
        newElements[newElementIndex].text = e.target.value;
        setElements(newElements);
    };
    return (React.createElement("div", null,
        React.createElement(Form$1.Control, { ref: inputRef, id: "editText", value: element.text, onChange: onChange })));
};

const Divider = () => React.createElement("div", { className: "border mx-2", style: { height: '2.5em' } });
const Toolbar = ({ height, width, elements, setElements, selectedElementId, setSelectedElementId, onSave, idCounter, setIdCounter, hasUnsavedChanges, }) => {
    const { t: translate } = useTranslation();
    const [selectedStroke, setSelectedStroke] = useState(COLOR.BLACK);
    const [selectedFill, setSelectedFill] = useState(COLOR.RED);
    const [selectedStrokeWidth, setSelectedStrokeWidth] = useState(2);
    const [selectedFontSize, setSelectedFontSize] = useState('12');
    const [isBold, setIsBold] = useState(false);
    const [isItalics, setIsItalics] = useState(false);
    const [isUnderline, setIsUnderline] = useState(false);
    const [selectedFontColor, setSelectedFontColor] = useState(COLOR.BLACK);
    const [isSaving, setIsSaving] = useState(false);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (selectedElementId) {
            const selectedElement = elements.find((e) => e.id === selectedElementId);
            if (!selectedElement)
                return;
            if (selectedElement.type === ELEMENT_TYPE.TEXT) {
                setSelectedFontSize((_a = selectedElement.fontSize) !== null && _a !== void 0 ? _a : selectedFontSize);
                setSelectedFontColor((_c = (_b = COLORS.find((c) => c.colorCode === selectedElement.fill)) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : selectedFontColor);
                setIsBold(!!((_d = selectedElement.fontStyle) === null || _d === void 0 ? void 0 : _d.includes('bold')));
                setIsItalics(!!((_e = selectedElement.fontStyle) === null || _e === void 0 ? void 0 : _e.includes('italic')));
                setIsUnderline(!!((_f = selectedElement.textDecoration) === null || _f === void 0 ? void 0 : _f.includes('underline')));
            }
            else {
                setSelectedStroke(((_g = COLORS.find((c) => c.colorCode === selectedElement.stroke)) === null || _g === void 0 ? void 0 : _g.type) || selectedStroke);
                setSelectedFill(((_h = COLORS.find((c) => c.colorCode === selectedElement.fill)) === null || _h === void 0 ? void 0 : _h.type) || selectedFill);
                setSelectedStrokeWidth((_j = selectedElement.strokeWidth) !== null && _j !== void 0 ? _j : selectedStrokeWidth);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedElementId]);
    const innerOnSave = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsSaving(true);
        yield onSave(elements);
        setIsSaving(false);
    });
    const selectedElement = elements.find((e) => e.id === selectedElementId);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "d-flex align-items-center justify-content-between border-top border-start border-end p-2 pe-3 d-print-none" },
            React.createElement("div", { className: "d-flex align-items-center" },
                React.createElement(AddShapeDropdown, { height: height, width: width, elements: elements, setElements: setElements, idCounter: idCounter, setIdCounter: setIdCounter, selectedStroke: selectedStroke, selectedFill: selectedFill, selectedStrokeWidth: selectedStrokeWidth, setSelectedElementId: setSelectedElementId }),
                React.createElement(SelectFillDropdown, { elements: elements, setElements: setElements, selectedElementId: selectedElementId, selectedFill: selectedFill, setSelectedFill: setSelectedFill }),
                React.createElement(SelectStrokeDropdown, { elements: elements, setElements: setElements, selectedElementId: selectedElementId, selectedStroke: selectedStroke, setSelectedStroke: setSelectedStroke }),
                React.createElement(SelectStrokeWidthDropdown, { elements: elements, setElements: setElements, selectedElementId: selectedElementId, selectedStrokeWidth: selectedStrokeWidth, setSelectedStrokeWidth: setSelectedStrokeWidth }),
                React.createElement(Divider, null),
                React.createElement(AddTextButton, { height: height, width: width, elements: elements, setElements: setElements, idCounter: idCounter, setIdCounter: setIdCounter, selectedFontColor: selectedFontColor, setSelectedElementId: setSelectedElementId, selectedFontSize: selectedFontSize }),
                React.createElement(EditTextDropdown, { elements: elements, setElements: setElements, isBold: isBold, setIsBold: setIsBold, isItalics: isItalics, setIsItalics: setIsItalics, isUnderline: isUnderline, setIsUnderline: setIsUnderline, selectedFontSize: selectedFontSize, setSelectedFontSize: setSelectedFontSize, selectedElementId: selectedElementId, selectedFontColor: selectedFontColor, setSelectedFontColor: setSelectedFontColor }),
                React.createElement(Divider, null),
                React.createElement(EditElementOrderButtons, { selectedElementId: selectedElementId, elements: elements, setElements: setElements })),
            React.createElement("div", { className: "position-relative d-flex justify-content-end", style: { minWidth: 90 } },
                React.createElement(Button$1, { size: "sm", variant: "primary", onClick: innerOnSave, disabled: isSaving }, isSaving ? translate('common.saving') : translate('common.save')),
                hasUnsavedChanges && React.createElement("span", { style: { fontSize: 10, top: '100%', right: 0, position: 'absolute' }, className: "text-muted" }, "Unsaved *"))),
        (selectedElement === null || selectedElement === void 0 ? void 0 : selectedElement.type) === ELEMENT_TYPE.TEXT && (React.createElement("div", { className: "d-flex align-items-center border-top border-start border-end p-2" },
            React.createElement(EditTextField, { element: selectedElement, elements: elements, setElements: setElements })))));
};

var Rectangle = ({ element, isSelected, onSelect, onChange, isEditable }) => {
    const shapeRef = React.useRef(null);
    const trRef = React.useRef(null);
    useEffect(() => {
        var _a, _b;
        if (isSelected && (trRef === null || trRef === void 0 ? void 0 : trRef.current) && (shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current)) {
            // we need to attach transformer manually
            trRef.current.nodes([shapeRef.current]);
            (_b = (_a = trRef === null || trRef === void 0 ? void 0 : trRef.current) === null || _a === void 0 ? void 0 : _a.getLayer()) === null || _b === void 0 ? void 0 : _b.batchDraw();
        }
    }, [isSelected]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Rect, Object.assign({}, element, { onClick: onSelect, onTap: onSelect, ref: shapeRef, draggable: isEditable, onDragEnd: (e) => {
                onChange(Object.assign(Object.assign({}, element), { x: e.target.x(), y: e.target.y() }));
            }, onTransformEnd: () => {
                const node = shapeRef.current;
                if (node !== null) {
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();
                    node.scaleX(1);
                    node.scaleY(1);
                    onChange(Object.assign(Object.assign({}, element), { rotation: node.rotation(), x: node.x(), y: node.y(), width: Math.max(5, node.width() * scaleX), height: Math.max(node.height() * scaleY) }));
                }
            } })),
        isSelected && (React.createElement(Transformer, { ref: trRef, flipEnabled: false, boundBoxFunc: (oldBox, newBox) => {
                if (Math.abs(newBox.width) < 5 || Math.abs(newBox.height) < 5) {
                    return oldBox;
                }
                return newBox;
            } }))));
};

var Ellipse = ({ element, isSelected, onSelect, onChange, isEditable }) => {
    const shapeRef = React.useRef(null);
    const trRef = React.useRef(null);
    useEffect(() => {
        var _a, _b;
        if (isSelected && (trRef === null || trRef === void 0 ? void 0 : trRef.current) && (shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current)) {
            // we need to attach transformer manually
            trRef.current.nodes([shapeRef.current]);
            (_b = (_a = trRef === null || trRef === void 0 ? void 0 : trRef.current) === null || _a === void 0 ? void 0 : _a.getLayer()) === null || _b === void 0 ? void 0 : _b.batchDraw();
        }
    }, [isSelected]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Ellipse$1, Object.assign({}, element, { radiusX: element.radiusX, radiusY: element.radiusY, onClick: onSelect, onTap: onSelect, ref: shapeRef, draggable: isEditable, onDragEnd: (e) => {
                onChange(Object.assign(Object.assign({}, element), { x: e.target.x(), y: e.target.y() }));
            }, onTransformEnd: () => {
                const node = shapeRef.current;
                if (node !== null) {
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();
                    node.scaleX(1);
                    node.scaleY(1);
                    onChange(Object.assign(Object.assign({}, element), { x: node.x(), y: node.y(), radiusX: node.radiusX(), radiusY: node.radiusY(), width: Math.max(5, node.width() * scaleX), height: Math.max(node.height() * scaleY), rotation: node.rotation() }));
                }
            } })),
        isSelected && (React.createElement(Transformer, { ref: trRef, flipEnabled: false, boundBoxFunc: (oldBox, newBox) => {
                if (Math.abs(newBox.width) < 5 || Math.abs(newBox.height) < 5) {
                    return oldBox;
                }
                return newBox;
            } }))));
};

const ANCHOR_WIDTH$1 = 10;
var Line = ({ element, isSelected, onSelect, onChange, isEditable }) => {
    const shapeRef = React.useRef(null);
    const anchor1Ref = React.useRef(null);
    const anchor2Ref = React.useRef(null);
    const ondragmove = () => {
        if ((anchor1Ref === null || anchor1Ref === void 0 ? void 0 : anchor1Ref.current) && (anchor2Ref === null || anchor2Ref === void 0 ? void 0 : anchor2Ref.current) && (shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current)) {
            onChange(Object.assign(Object.assign({}, element), { points: [
                    anchor1Ref.current.attrs.x + (ANCHOR_WIDTH$1 / 2) - shapeRef.current.attrs.x,
                    anchor1Ref.current.attrs.y + (ANCHOR_WIDTH$1 / 2) - shapeRef.current.attrs.y,
                    anchor2Ref.current.attrs.x + (ANCHOR_WIDTH$1 / 2) - shapeRef.current.attrs.x,
                    anchor2Ref.current.attrs.y + (ANCHOR_WIDTH$1 / 2) - shapeRef.current.attrs.y,
                ] }));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Line$1, Object.assign({ onClick: onSelect, onTap: onSelect, ref: shapeRef }, element, { draggable: isEditable, onDragMove: (e) => {
                onChange(Object.assign(Object.assign({}, element), { x: e.target.x(), y: e.target.y() }));
            }, onTransformEnd: () => {
                const node = shapeRef.current;
                if (node !== null) {
                    node.scaleX(1);
                    node.scaleY(1);
                    onChange(Object.assign(Object.assign({}, element), { x: node.x(), y: node.y(), points: node.points }));
                }
            }, hitStrokeWidth: 12 })),
        isSelected && (React.createElement(React.Fragment, null,
            React.createElement(Rect, { x: element.points[0] + element.x - (ANCHOR_WIDTH$1 / 2), y: element.points[1] + element.y - (ANCHOR_WIDTH$1 / 2), height: ANCHOR_WIDTH$1, width: ANCHOR_WIDTH$1, fill: "white", stroke: "#1ea7fd", strokeWidth: 1, draggable: true, ondragmove: ondragmove, ref: anchor1Ref }),
            React.createElement(Rect, { x: element.points[2] + element.x - (ANCHOR_WIDTH$1 / 2), y: element.points[3] + element.y - (ANCHOR_WIDTH$1 / 2), height: ANCHOR_WIDTH$1, width: ANCHOR_WIDTH$1, fill: "white", stroke: "#1ea7fd", strokeWidth: 1, draggable: true, ondragmove: ondragmove, ref: anchor2Ref })))));
};

var Text = ({ element, isSelected, onSelect, onChange, isEditable }) => {
    const shapeRef = React.useRef(null);
    const trRef = React.useRef(null);
    useEffect(() => {
        var _a, _b;
        if (isSelected && (trRef === null || trRef === void 0 ? void 0 : trRef.current) && (shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current)) {
            trRef.current.nodes([shapeRef.current]);
            (_b = (_a = trRef === null || trRef === void 0 ? void 0 : trRef.current) === null || _a === void 0 ? void 0 : _a.getLayer()) === null || _b === void 0 ? void 0 : _b.batchDraw();
        }
    }, [isSelected]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Text$1, Object.assign({ onClick: onSelect, onTap: onSelect, ref: shapeRef }, element, { draggable: isEditable, onDragEnd: (e) => {
                onChange(Object.assign(Object.assign({}, element), { x: e.target.x(), y: e.target.y() }));
            }, onTransformEnd: () => {
                const node = shapeRef.current;
                if (node !== null) {
                    const scaleX = node.scaleX();
                    node.scaleX(1);
                    node.scaleY(1);
                    onChange(Object.assign(Object.assign({}, element), { rotation: node.rotation(), x: node.x(), y: node.y(), width: Math.max(5, node.width() * scaleX) }));
                }
            } })),
        isSelected && (React.createElement(Transformer, { ref: trRef, flipEnabled: false, boundBoxFunc: (_oldBox, newBox) => {
                newBox.width = Math.max(30, newBox.width);
                return newBox;
            }, enabledAnchors: ['middle-left', 'middle-right'] }))));
};

const ANCHOR_WIDTH = 10;
var Arrow = ({ element, isSelected, onSelect, onChange, isEditable }) => {
    const shapeRef = React.useRef(null);
    const anchor1Ref = React.useRef(null);
    const anchor2Ref = React.useRef(null);
    const ondragmove = () => {
        if ((anchor1Ref === null || anchor1Ref === void 0 ? void 0 : anchor1Ref.current) && (anchor2Ref === null || anchor2Ref === void 0 ? void 0 : anchor2Ref.current) && (shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current)) {
            onChange(Object.assign(Object.assign({}, element), { points: [
                    anchor1Ref.current.attrs.x + (ANCHOR_WIDTH / 2) - shapeRef.current.attrs.x,
                    anchor1Ref.current.attrs.y + (ANCHOR_WIDTH / 2) - shapeRef.current.attrs.y,
                    anchor2Ref.current.attrs.x + (ANCHOR_WIDTH / 2) - shapeRef.current.attrs.x,
                    anchor2Ref.current.attrs.y + (ANCHOR_WIDTH / 2) - shapeRef.current.attrs.y,
                ] }));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Arrow$1, Object.assign({ points: element.points, onClick: onSelect, onTap: onSelect, ref: shapeRef }, element, { draggable: isEditable, onDragMove: (e) => {
                onChange(Object.assign(Object.assign({}, element), { x: e.target.x(), y: e.target.y() }));
            }, onTransformEnd: () => {
                const node = shapeRef.current;
                if (node !== null) {
                    node.scaleX(1);
                    node.scaleY(1);
                    onChange(Object.assign(Object.assign({}, element), { x: node.x(), y: node.y(), points: node.points }));
                }
            }, hitStrokeWidth: 12 })),
        isSelected && (React.createElement(React.Fragment, null,
            React.createElement(Rect, { x: element.points[0] + element.x - (ANCHOR_WIDTH / 2), y: element.points[1] + element.y - (ANCHOR_WIDTH / 2), height: ANCHOR_WIDTH, width: ANCHOR_WIDTH, fill: "white", stroke: "#1ea7fd", strokeWidth: 1, draggable: true, ondragmove: ondragmove, ref: anchor1Ref }),
            React.createElement(Rect, { x: element.points[2] + element.x - (ANCHOR_WIDTH / 2), y: element.points[3] + element.y - (ANCHOR_WIDTH / 2), height: ANCHOR_WIDTH, width: ANCHOR_WIDTH, fill: "white", stroke: "#1ea7fd", strokeWidth: 1, draggable: true, ondragmove: ondragmove, ref: anchor2Ref })))));
};

const StageElement = ({ element, isSelected, onSelect, onChange, isEditable }) => {
    const StageElementComponent = {
        [ELEMENT_TYPE.RECTANGLE]: Rectangle,
        [ELEMENT_TYPE.ELLIPSE]: Ellipse,
        [ELEMENT_TYPE.LINE]: Line,
        [ELEMENT_TYPE.ARROW]: Arrow,
        [ELEMENT_TYPE.TEXT]: Text,
    }[element.type];
    return (React.createElement(StageElementComponent, { isSelected: isSelected, element: element, onSelect: onSelect, onChange: onChange, isEditable: isEditable }));
};
var Stage = ({ height, width, elements, selectedElementId, setSelectedElementId, onChange, backgroundImage, isEditable }) => {
    const [image] = useImage(backgroundImage);
    const checkDeselect = (e) => {
        const clickedOnEmpty = e.target === e.target.getStage() || e.target.attrs.id === 'background';
        if (clickedOnEmpty) {
            setSelectedElementId(null);
        }
    };
    return (React.createElement(Stage$1, { width: width, height: height, className: "d-flex justify-content-center align-items-center w-100 bg-light stage-background", id: "stage", onMouseUp: checkDeselect },
        React.createElement(Layer, null,
            React.createElement(Image$1, { id: "background", image: image, height: height, width: width, onClick: checkDeselect })),
        React.createElement(Layer, null, elements.map((element) => (React.createElement(StageElement, { element: element, isSelected: element.id === selectedElementId, onSelect: () => {
                if (isEditable) {
                    setSelectedElementId(element.id);
                }
            }, onChange: onChange, isEditable: isEditable, key: element.id }))))));
};

var ImageMarkup = ({ initialElements, height = 500, width = 500, onSave = () => { }, backgroundImage, isEditable = false, }) => {
    const [elements, setElements] = useState(initialElements);
    const [selectedElementId, setSelectedElementId] = useState(null);
    const [idCounter, setIdCounter] = useState(1);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const onChange = (e) => {
        const newElements = elements.slice();
        const newElementIndex = newElements.findIndex((s) => s.id === e.id);
        newElements[newElementIndex] = e;
        setElements(newElements);
    };
    const handleKeyDown = (e) => {
        var _a;
        if (e.key === 'Backspace' && !!selectedElementId && ((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.id) !== 'editText') {
            setElements(elements.filter((s) => s.id !== selectedElementId));
            setSelectedElementId(null);
        }
    };
    useEffect(() => {
        const maxId = initialElements.reduce((max, element) => Math.max(max, +element.id.split('-')[1]), 0) + 1;
        setIdCounter(maxId);
    }, [initialElements]);
    useEffect(() => {
        if (elements !== initialElements) {
            setHasUnsavedChanges(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elements]);
    const innerOnSave = (e) => __awaiter(void 0, void 0, void 0, function* () {
        yield onSave(e);
        setHasUnsavedChanges(false);
    });
    return (React.createElement("div", { className: "d-inline-flex flex-column", onKeyUp: handleKeyDown, tabIndex: -1 },
        isEditable && (React.createElement(Toolbar, { height: height, width: width, elements: elements, setElements: setElements, selectedElementId: selectedElementId, setSelectedElementId: setSelectedElementId, onSave: innerOnSave, idCounter: idCounter, setIdCounter: setIdCounter, hasUnsavedChanges: hasUnsavedChanges })),
        React.createElement("div", { className: "border", onClick: (e) => { if (e.target.className.includes('stage-background')) {
                setSelectedElementId(null);
            } } },
            React.createElement(Stage, { elements: elements, height: height, width: width, selectedElementId: selectedElementId, setSelectedElementId: setSelectedElementId, onChange: onChange, backgroundImage: backgroundImage, isEditable: isEditable }))));
};

const colors = {
    108: { red: '#BA0021', darkRed: '#862633', midnightNavy: '#003263', silver: '#C4CED4' },
    109: { red: '#A71930', sonoranSand: '#E3D4AD', black: '#000000', turquoise: '#3EC1CC' },
    110: { orange: '#DF4601', black: '#000000', gray: '#A2AAAD', marylandPatchYellow: '#EAAA00', marylandPatchRed: '#9D2235' },
    111: { red: '#BD3039', blue: '#0D2B56' },
    112: { blue: '#0E3386', red: '#CC3433' },
    113: { red: '#C6011F', blue: '#041E42', black: '#000000', digitalCamouflageDesertSand: '#473729' },
    114: { red: '#E31937', navy: '#002B5C' },
    115: { purple: '#33006F', silver: '#C4CED4', black: '#000000' },
    116: { midnightNavy: '#182D55', orange: '#F26722' },
    117: { navy: '#002D62', orange: '#EB6E1F', lightOrange: '#F4911E', blue: '#003087', gray: '#C4CED4' },
    118: { blue: '#004687', gold: '#C09A5B', lightBlue: '#7AB2DD', brown: '#966037' },
    119: { blue: '#005A9C', red: '#EF3E42' },
    120: { red: '#AB0003', blue: '#11225B' },
    121: { blue: '#002D72', orange: '#FF5910', gray: '#888B8D' },
    133: { green: '#003831', gold: '#EFB21E' },
    134: { gold: '#FDB827', red: '#EE3A42', black: '#000000' },
    135: { brown: '#2F241D', gold: '#FFC425', sand: '#B7A99A' },
    136: { navy: '#0C2C56', green: '#005C5C', silver: '#C4CED4', red: '#D50032', blue: '#004B8D', yellow: '#FFC425', cream: '#FFF6DC' },
    137: { orange: '#FD5A1E', black: '#000000', gold: '#8B6F4E', beige: '#EE6D8AF' },
    138: { red: '#C41E3A', midnightNavy: '#000066', yellow: 'FEDB00' },
    139: { blue: '#092C5C', lightBlue: '#8FBCE6', gold: '#F5D130' },
    140: { blue: '#003278', red: '#C0111F', darkGray: '#99897C', lightGray: '#C7C2BA', lightBlue: '#6CACEE4' },
    141: { blue: '#002B5C', navy: '#1D2D5C', red: '#D50032', powderBlue: '#6CACE4' },
    142: { navy: '#002B5C', red: '#D31145', gold: '#CFAB7A', gray: '#A2AAAD' },
    143: { red: '#E81828', blue: '#003278', maroon: '#860038' },
    144: { navy: '#0C2340', scarlet: '#BA0C2F', gold: '#D29F13' },
    145: { black: '#000000', silver: '#C4CED4', blue: '#0C2340', red: '#C8102E' },
    146: { black: '#000000', blue: '#00A3E0', red: '#EF3340', slateGray: '#41748D' },
    147: { midnightNavy: '#132448', blue: '#003087', red: '#E4002B', gray: '#C4CED4' },
    158: { navy: '#13294B', gold: '#FFC72C', blue: '#003DA5' },
};
const backgrounds = {
    108: colors[108].red,
    109: colors[109].black,
    110: colors[110].black,
    111: colors[111].blue,
    112: colors[112].blue,
    113: colors[113].red,
    114: colors[114].navy,
    115: colors[115].black,
    116: colors[116].midnightNavy,
    117: colors[117].navy,
    118: colors[118].blue,
    119: colors[119].blue,
    120: colors[120].red,
    121: colors[121].blue,
    133: colors[133].green,
    134: colors[134].black,
    135: colors[135].brown,
    136: colors[136].navy,
    137: colors[137].orange,
    138: colors[138].midnightNavy,
    139: colors[139].blue,
    140: colors[140].blue,
    141: colors[141].navy,
    142: colors[142].navy,
    143: colors[143].red,
    144: colors[144].navy,
    145: colors[145].black,
    146: colors[146].blue,
    147: colors[147].midnightNavy,
    158: colors[158].navy,
};
var mlb = {
    colors,
    backgrounds,
};

const HighchartContainer$1 = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
`;
const TableCell$1 = styled.td `
  border: 1px solid #000 !important;
  padding: 20px;
  text-align: left;
  width: 75px;
  text-align: center;
  vertical-align: middle;
`;
const OverlayTable$1 = styled.table `
  border: 1px solid #000 !important;
  height: 20%;
  margin-top: auto;
  z-index: 1000;
  border-collapse: collapse;
  background: rgba(255, 255, 255, 0.8); 
`;
const TableRow$1 = styled.tr `
  border: 1px solid #000;
`;
const buildResultSeries$3 = (series, infAccChartRef) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.ballinplayx, y: d.ballinplayy, id: `spray_chart_${d.gameid}_${d.pitchseq}_${d.eventseq}`, events: {
            mouseOver(e) {
                var _a, _b, _c, _d, _e, _f, _g;
                if (((_a = e.target) === null || _a === void 0 ? void 0 : _a.ifthrowx) && ((_b = e.target) === null || _b === void 0 ? void 0 : _b.ifthrowz)) {
                    (_c = infAccChartRef.current) === null || _c === void 0 ? void 0 : _c.hoverPoint((_f = (_e = (_d = e.target) === null || _d === void 0 ? void 0 : _d.series) === null || _e === void 0 ? void 0 : _e.index) !== null && _f !== void 0 ? _f : -1, (_g = e.target) === null || _g === void 0 ? void 0 : _g.index);
                }
            },
            mouseOut(e) {
                var _a, _b, _c, _d, _e, _f, _g;
                if (((_a = e.target) === null || _a === void 0 ? void 0 : _a.ifthrowx) && ((_b = e.target) === null || _b === void 0 ? void 0 : _b.ifthrowz)) {
                    (_c = infAccChartRef.current) === null || _c === void 0 ? void 0 : _c.resetHoverPoint((_f = (_e = (_d = e.target) === null || _d === void 0 ? void 0 : _d.series) === null || _e === void 0 ? void 0 : _e.index) !== null && _f !== void 0 ? _f : -1, (_g = e.target) === null || _g === void 0 ? void 0 : _g.index);
                }
            },
        } }))) })));
const InfielderSprayChart = forwardRef(({ resultSeries, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, infAccChartRef, enableLegend, enableZoom, isGrayScale, sizeMultiplier, }, ref) => {
    const innerResultSeries = useMemo(() => buildResultSeries$3(resultSeries, infAccChartRef), [resultSeries, infAccChartRef]);
    return (React.createElement(HighchartContainer$1, { className: "d-flex justify-content-center" },
        React.createElement(SprayChart$3, { type: "infield", seriesData: innerResultSeries, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, ref: ref, enableLegend: enableLegend, enableZoom: enableZoom, isGrayScale: isGrayScale, sizeMultiplier: sizeMultiplier }),
        innerResultSeries && innerResultSeries.length > 0 && (React.createElement(OverlayTable$1, null,
            React.createElement("tbody", null,
                React.createElement(TableRow$1, null,
                    React.createElement(TableCell$1, null),
                    React.createElement(TableCell$1, null, "Out Prob %")),
                React.createElement(TableRow$1, null,
                    React.createElement(TableCell$1, { style: { backgroundColor: '#35a84c' } }),
                    React.createElement(TableCell$1, null, "90-100%")),
                React.createElement(TableRow$1, null,
                    React.createElement(TableCell$1, { style: { backgroundColor: '#34ff32' } }),
                    React.createElement(TableCell$1, null, "75-90%")),
                React.createElement(TableRow$1, null,
                    React.createElement(TableCell$1, { style: { backgroundColor: '#FFA500' } }),
                    React.createElement(TableCell$1, null, "25-75%")),
                React.createElement(TableRow$1, null,
                    React.createElement(TableCell$1, { style: { backgroundColor: '#FF0000' } }),
                    React.createElement(TableCell$1, null, "< 25%")))))));
});

const buildResultSeries$2 = (series, sprayChartRef) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.x, y: d.y, id: `inf_acc_${d.gameid}_${d.pitchseq}_${d.eventseq}`, visible: !!(d.ifthrowx && d.ifthrowz), events: {
            mouseOver(e) {
                var _a, _b, _c, _d, _e;
                (_a = sprayChartRef.current) === null || _a === void 0 ? void 0 : _a.hoverPoint((_d = (_c = (_b = e.target) === null || _b === void 0 ? void 0 : _b.series) === null || _c === void 0 ? void 0 : _c.index) !== null && _d !== void 0 ? _d : -1, (_e = e.target) === null || _e === void 0 ? void 0 : _e.index);
            },
            mouseOut(e) {
                var _a, _b, _c, _d, _e;
                (_a = sprayChartRef.current) === null || _a === void 0 ? void 0 : _a.resetHoverPoint((_d = (_c = (_b = e.target) === null || _b === void 0 ? void 0 : _b.series) === null || _c === void 0 ? void 0 : _c.index) !== null && _d !== void 0 ? _d : -1, (_e = e.target) === null || _e === void 0 ? void 0 : _e.index);
            },
        } }))) })));
const InfielderAccuracy = forwardRef(({ resultSeries, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, sprayChartRef, position, showLegend, enableZoom, width }, ref) => {
    const innerResultSeries = useMemo(() => buildResultSeries$2(resultSeries, sprayChartRef), [resultSeries, sprayChartRef]);
    return (React.createElement("div", { className: "d-flex justify-content-center" },
        React.createElement(InfielderAccuracy$1, { seriesData: innerResultSeries, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, ref: ref, position: position, showLegend: showLegend, enableZoom: enableZoom, width: width })));
});

const CardBodyContainer = styled.div `
    justify-content: center;
    display: flex;
    padding: 10px;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
`;
const InfieldPlayLogCharts = ({ sprayChartSeriesData, throwChartSeriesData, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, position, primarypos, title, isGrayScale, sprayChartSizeMultiplier, infielderWidth }) => {
    const [sprayChartData, setSprayChartData] = useState([]);
    const [throwChartData, setThrowChartData] = useState([]);
    const infAccChartRef = useRef(null);
    const sprayChartRef = useRef(null);
    useEffect(() => {
        setSprayChartData(sprayChartSeriesData);
        setThrowChartData(throwChartSeriesData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sprayChartSeriesData, throwChartSeriesData]);
    return (React.createElement("div", { className: "d-flex flex-wrap justify-content-around" },
        sprayChartSeriesData && (React.createElement("div", { className: "d-flex flex-column justify-content-between mb-2 mx-2" },
            React.createElement("h3", null,
                title,
                " Fielding"),
            React.createElement(CardBodyContainer, null,
                React.createElement(InfielderSprayChart, { type: "infield", enableLegend: true, resultSeries: sprayChartData, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, infAccChartRef: infAccChartRef, ref: sprayChartRef, isGrayScale: isGrayScale, sizeMultiplier: sprayChartSizeMultiplier })))),
        React.createElement("div", { className: "mb-2" },
            React.createElement("h3", null,
                title,
                " Throwing"),
            React.createElement(CardBodyContainer, null,
                (position === 6 || (primarypos === 6 && position === -1)) && (React.createElement(InfielderAccuracy, { position: 6, showLegend: false, resultSeries: throwChartData, enableZoom: false, modalContainer: modalContainer, sprayChartRef: sprayChartRef, videoPlayerModal: videoPlayerModal, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: infAccChartRef, width: infielderWidth })),
                (position === 4 || (primarypos === 4 && position === -1)) && (React.createElement(InfielderAccuracy, { position: 4, showLegend: false, resultSeries: throwChartData, enableZoom: false, modalContainer: modalContainer, sprayChartRef: sprayChartRef, videoPlayerModal: videoPlayerModal, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: infAccChartRef, width: infielderWidth })),
                (position === 5 || (primarypos === 5 && position === -1)) && (React.createElement(InfielderAccuracy, { position: 5, showLegend: false, resultSeries: throwChartData, enableZoom: false, modalContainer: modalContainer, sprayChartRef: sprayChartRef, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, ref: infAccChartRef, width: infielderWidth }))))));
};

const HighchartContainer = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
`;
const TableCell = styled.td `
  border: 1px solid #000 !important;
  padding: 20px;
  text-align: left;
  width: 75px;
  text-align: center;
  vertical-align: middle;
`;
const OverlayTable = styled.table `
  border: 1px solid #000 !important;
  z-index: 1000;
  height: 20%;
  margin-top: auto;
  border-collapse: collapse;
  background: rgba(255, 255, 255, 0.8); 
`;
const TableRow = styled.tr `
  border: 1px solid #000;
`;
const buildResultSeries$1 = (series, hangtimeChartRef) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.ballinplayx, y: d.ballinplayy, id: `spray_chart_${d.gameid}_${d.pitchseq}_${d.eventseq}`, events: {
            mouseOver(e) {
                var _a, _b, _c, _d, _e, _f, _g;
                if (((_a = e.target) === null || _a === void 0 ? void 0 : _a.ifthrowx) && ((_b = e.target) === null || _b === void 0 ? void 0 : _b.ifthrowz)) {
                    (_c = hangtimeChartRef.current) === null || _c === void 0 ? void 0 : _c.hoverPoint((_f = (_e = (_d = e.target) === null || _d === void 0 ? void 0 : _d.series) === null || _e === void 0 ? void 0 : _e.index) !== null && _f !== void 0 ? _f : -1, (_g = e.target) === null || _g === void 0 ? void 0 : _g.index);
                }
            },
            mouseOut(e) {
                var _a, _b, _c, _d, _e, _f, _g;
                if (((_a = e.target) === null || _a === void 0 ? void 0 : _a.ifthrowx) && ((_b = e.target) === null || _b === void 0 ? void 0 : _b.ifthrowz)) {
                    (_c = hangtimeChartRef.current) === null || _c === void 0 ? void 0 : _c.resetHoverPoint((_f = (_e = (_d = e.target) === null || _d === void 0 ? void 0 : _d.series) === null || _e === void 0 ? void 0 : _e.index) !== null && _f !== void 0 ? _f : -1, (_g = e.target) === null || _g === void 0 ? void 0 : _g.index);
                }
            },
        } }))) })));
const OutfielderSprayChart = forwardRef(({ resultSeries, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, hangtimeChartRef, enableLegend, enableZoom, isGrayScale, sizeMultiplier, }, ref) => {
    const innerResultSeries = useMemo(() => buildResultSeries$1(resultSeries, hangtimeChartRef), [resultSeries, hangtimeChartRef]);
    return (React.createElement(HighchartContainer, { className: "d-flex justify-content-center" },
        React.createElement(SprayChart$3, { type: "outfield", seriesData: innerResultSeries, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, ref: ref, enableLegend: enableLegend, enableZoom: enableZoom, isGrayScale: isGrayScale, sizeMultiplier: sizeMultiplier }),
        innerResultSeries && innerResultSeries.length > 0 && (React.createElement(OverlayTable, null,
            React.createElement("tbody", null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, null),
                    React.createElement(TableCell, null, "Out Prob %")),
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { style: { backgroundColor: '#35a84c' } }),
                    React.createElement(TableCell, null, "97-100%")),
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { style: { backgroundColor: '#34ff32' } }),
                    React.createElement(TableCell, null, "75-97%")),
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { style: { backgroundColor: '#FFA500' } }),
                    React.createElement(TableCell, null, "25-75%")),
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { style: { backgroundColor: '#FF0000' } }),
                    React.createElement(TableCell, null, "< 25%")))))));
});

const buildResultSeries = (series, sprayChartRef) => series.map((s) => (Object.assign(Object.assign({}, s), { data: s.data.map((d) => (Object.assign(Object.assign({}, d), { x: d.x, y: d.y, id: `of_hangtime_${d.gameid}_${d.pitchseq}_${d.eventseq}`, events: {
            mouseOver(e) {
                var _a, _b, _c, _d, _e;
                (_a = sprayChartRef.current) === null || _a === void 0 ? void 0 : _a.hoverPoint((_d = (_c = (_b = e.target) === null || _b === void 0 ? void 0 : _b.series) === null || _c === void 0 ? void 0 : _c.index) !== null && _d !== void 0 ? _d : -1, (_e = e.target) === null || _e === void 0 ? void 0 : _e.index);
            },
            mouseOut(e) {
                var _a, _b, _c, _d, _e;
                (_a = sprayChartRef.current) === null || _a === void 0 ? void 0 : _a.resetHoverPoint((_d = (_c = (_b = e.target) === null || _b === void 0 ? void 0 : _b.series) === null || _c === void 0 ? void 0 : _c.index) !== null && _d !== void 0 ? _d : -1, (_e = e.target) === null || _e === void 0 ? void 0 : _e.index);
            },
        } }))) })));
const OutfielderHangtimeChart = forwardRef(({ resultSeries, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, sprayChartRef, position, showLegend, enableZoom, width }, ref) => {
    const innerResultSeries = useMemo(() => buildResultSeries(resultSeries, sprayChartRef), [resultSeries, sprayChartRef]);
    return (React.createElement("div", { className: "d-flex justify-content-center" },
        React.createElement(HangtimeChart, { seriesData: innerResultSeries, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, ref: ref, position: position, showLegend: showLegend, enableZoom: enableZoom, width: width })));
});

const OutfieldPlayLogCharts = ({ sprayChartSeriesData, hangtimeChartSeriesData, firstStepAverages, pitchVideoFn, multiVideoFn, videoPlayerModal, modalContainer, title, isGrayScale, sprayChartSizeMultiplier, hangtimeChartWidth, firstStepChartWidth, }) => {
    const [sprayChartData, setSprayChartData] = useState([]);
    const [hangtimeChartData, setHangtimeChartData] = useState([]);
    const [firstStepData, setFirstStepData] = useState({
        left: {},
        forward: {},
        right: {},
        back: {},
    });
    const hangtimeChartRef = useRef(null);
    const sprayChartRef = useRef(null);
    useEffect(() => {
        setSprayChartData(sprayChartSeriesData);
        setHangtimeChartData(hangtimeChartSeriesData);
        setFirstStepData(firstStepAverages);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sprayChartSeriesData, hangtimeChartSeriesData]);
    return (React.createElement("div", { className: "d-flex flex-wrap justify-content-around" },
        sprayChartSeriesData && (React.createElement("div", { className: "d-flex flex-column justify-content-start mb-3 mx-2" },
            React.createElement("h3", null,
                title,
                " Fielding"),
            React.createElement("div", null,
                React.createElement(OutfielderSprayChart, { type: "outfield", sizeMultiplier: sprayChartSizeMultiplier, enableLegend: true, resultSeries: sprayChartData, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, videoPlayerModal: videoPlayerModal, modalContainer: modalContainer, hangtimeChartRef: hangtimeChartRef, ref: sprayChartRef, isGrayScale: isGrayScale })))),
        sprayChartSeriesData && hangtimeChartData && (React.createElement("div", { className: "d-flex flex-column justify-content-start " },
            React.createElement("h3", null, "Catch Difficulty"),
            React.createElement("div", null,
                React.createElement(OutfielderHangtimeChart, { showLegend: false, resultSeries: hangtimeChartData, enableZoom: false, modalContainer: modalContainer, sprayChartRef: sprayChartRef, videoPlayerModal: videoPlayerModal, pitchVideoFn: pitchVideoFn, multiVideoFn: multiVideoFn, ref: hangtimeChartRef, width: hangtimeChartWidth })))),
        firstStepData && (React.createElement("div", { className: "d-flex flex-column justify-content-start mb-3 mx-2" },
            React.createElement("h3", null, "First Step Chart"),
            React.createElement("div", null,
                React.createElement(FirstStepChart, { width: firstStepChartWidth, forward: firstStepData.forward, left: firstStepData.left, right: firstStepData.right, back: firstStepData.back }))))));
};

const CAMERA_VIEWS = [
    { id: 1, name: 'Broadcast', abbr: 'TV' },
    { id: 2, name: 'Center Field', abbr: 'CF' },
    { id: 3, name: 'Pitcher Open', abbr: 'PitcherSide' },
    { id: 4, name: 'Pitcher Closed', abbr: 'PitcherSide' },
    { id: 5, name: 'Pitcher Front', abbr: 'PitcherFront' },
    { id: 6, name: 'Hitter Open', abbr: 'HitterOpenSide' },
    { id: 7, name: 'Hitter Closed', abbr: 'HitterClosedSide' },
    { id: 8, name: 'Field High', abbr: 'FieldViewHigh' },
    { id: 9, name: 'Field Low', abbr: 'FieldViewLow' },
    { id: 10, name: 'Low Pitcher 1B', abbr: 'LowPitcher1B' },
    { id: 11, name: 'LH Batters View', abbr: 'BattersViewLH' },
    { id: 12, name: 'RH Batters View', abbr: 'BattersViewRH' },
    { id: 13, name: 'Tight Home', abbr: 'TightHomePlate' },
    { id: 14, name: 'Infield Side', abbr: 'InfieldSide' },
    { id: 15, name: 'Catcher Side', abbr: 'CatcherSide' },
    { id: 16, name: 'Extended Pitcher Front', abbr: 'PitcherExtendedFront' },
    { id: 17, name: 'Tight Pitcher Front', abbr: 'TightPitcherFront' },
    { id: 18, name: 'Tight Overhead Pitcher', abbr: 'TightOverheadPitcher' },
    { id: 21, name: 'Pickoff', abbr: 'Pickoff' },
    { id: 22, name: 'Tight CF', abbr: 'TightCF' },
    { id: 23, name: 'Broadcast Side', abbr: 'BroadcastSide' },
    { id: 24, name: 'Yankee Open', abbr: 'YankeeOpenSide' },
    { id: 20, name: 'Other', abbr: 'Other' },
    { id: 25, name: 'Pitcher Backside', abbr: 'PitcherBackside' },
    { id: 26, name: 'Side', abbr: 'Side' },
    { id: 27, name: 'Front', abbr: 'Front' },
    { id: 28, name: 'Back', abbr: 'Back' },
    { id: 29, name: 'Top', abbr: 'Top' },
    { id: 30, name: 'R1 Perspective', abbr: 'PerspectiveR1' },
    { id: 31, name: 'R2 Perspective', abbr: 'PerspectiveR2' },
    { id: 32, name: 'R3 Perspective', abbr: 'PerspectiveR3' },
    { id: 33, name: '1B Perspective', abbr: 'Perspective1B' },
    { id: 34, name: '2B Perspective', abbr: 'Perspective2B' },
    { id: 35, name: '3B Perspective', abbr: 'Perspective3B' },
    { id: 36, name: 'SS Perspective', abbr: 'PerspectiveSS' },
    { id: 37, name: 'LF Perspective', abbr: 'PerspectiveLF' },
    { id: 38, name: 'CF Perspective', abbr: 'PerspectiveCF' },
    { id: 39, name: 'RF Perspective', abbr: 'PerspectiveRF' },
    { id: 40, name: 'Tight Tight CF', abbr: 'TightTightCF' },
    { id: 41, name: 'Hitter Timing', abbr: 'HitterTiming' },
    { id: 42, name: 'Dead Center', abbr: 'DeadCenter' },
    { id: 43, name: 'Left Field', abbr: 'LF' },
    { id: 44, name: 'Quad 1', abbr: 'Quad1' },
    { id: 45, name: 'Quad 2', abbr: 'Quad2' },
    { id: 50, name: 'High-Speed Pitcher CF Release', abbr: 'HSPitcherCFRelease', isPitcher: true },
    { id: 51, name: 'High-Speed Pitcher Front Release', abbr: 'HSPitcherFrontRelease', isPitcher: true },
    { id: 52, name: 'High-Speed Pitcher Front', abbr: 'HSPitcherFront', isPitcher: true },
    { id: 53, name: 'High-Speed Pitcher Open', abbr: 'HSPitcherOpen', isPitcher: true },
    { id: 60, name: 'High-Speed Pitcher Closed', abbr: 'HSPitcherClosed', isPitcher: true },
    { id: 54, name: 'High-Speed Hitter Open', abbr: 'HSHitterSide', isBatter: true },
    { id: 55, name: 'High-Speed Hitter Timing', abbr: 'HSHitterTiming', isBatter: true },
    { id: 56, name: 'High-Speed Catcher Side', abbr: 'HSCatcherSide', isBatter: true },
    { id: 57, name: 'High-Speed Defense', abbr: 'HSDefense' },
    { id: 58, name: 'High-Speed Baserunning', abbr: 'HSBaserunning' },
    { id: 59, name: 'High-Speed Hitter Closed', abbr: 'HSHitterClosed', isBatter: true },
    { id: 61, name: 'High-Speed Tight Home', abbr: 'HSTightHome', isBatter: true },
    { id: 62, name: 'High-Speed Pitcher Open Release', abbr: 'HSPitcherOpenSideRelease', isPitcher: true },
    { id: 63, name: 'High-Speed Pitcher Closed Release', abbr: 'HSPitcherClosedSideRelease', isPitcher: true },
    { id: 64, name: 'High-Speed Hitter Behind', abbr: 'HSHitterBehind', isBatter: true },
    { id: 65, name: 'High-Speed Hitter Overhead', abbr: 'HSHitterOverhead', isBatter: true },
    { id: 66, name: 'High-Speed Pitcher Overhead', abbr: 'HSPitcherOverhead', isPitcher: true },
    { id: 67, name: 'High-Speed Pitcher Release', abbr: 'HSPitcherRelease', isPitcher: true },
    { id: 68, name: 'High-Speed Pitcher Behind', abbr: 'HSPitcherBehind', isPitcher: true },
    { id: 69, name: 'High-Speed Extended Pitcher Front', abbr: 'HSExtPitcherFront', isPitcher: true },
    { id: 70, name: 'Baserunning 1B', abbr: 'Baserunning1B' },
    { id: 71, name: 'Baserunning 2B', abbr: 'Baserunning2B' },
    { id: 72, name: 'Baserunning 3B', abbr: 'Baserunning3B' },
    { id: 73, name: '1B Infield Side', abbr: 'InfieldSide1B' },
    { id: 74, name: '3B Infield Side', abbr: 'InfieldSide3B' },
    { id: 75, name: 'Fly Cam', abbr: 'FlyCam' }
];
const PLAYER_VIDEO_TYPES = [
    { id: 0, name: 'Generic' },
    { id: 1, name: 'Injury' },
    { id: 2, name: 'Advance Scouting' },
    { id: 3, name: 'Ejections' },
    { id: 4, name: 'Game' },
    { id: 5, name: 'Bullpen' },
    { id: 6, name: 'BP' },
    { id: 7, name: 'Defense' },
    { id: 8, name: 'Workout / Misc' },
    // Strength Test Video Types
    { id: 20, name: 'Strength Test - Sprint 10 Yards' },
    { id: 21, name: 'Strength Test - Sprint 20 Yards' },
    { id: 22, name: 'Strength Test - Pro Agil React Glove Side' },
    { id: 23, name: 'Strength Test - Pro Agil React Arm Side' },
    // Pitcher Video Types
    { id: 101, name: 'Pitcher Grip' },
    { id: 102, name: 'Pitch Tipping' },
    { id: 103, name: 'Pitcher Release' },
    { id: 104, name: 'Slow Motion' },
    { id: 201, name: 'Physical Assessment' },
    { id: 202, name: 'General Movement Screen' },
    { id: 203, name: 'Amateur Movement Screen' },
];
const MLBAM_ANGLES = [
    { id: 'cf', name: 'MLBAM CF' },
    { id: 'hside', name: 'MLBAM High Side' },
    { id: 'hh', name: 'MLBAM High Home' },
    { id: '1bside', name: 'MLBAM 1B Hitter' },
    { id: '3bside', name: 'MLBAM 3B Hitter' },
    { id: '1bside_pit', name: 'MLBAM 1B Pitcher' },
    { id: '3bside_pit', name: 'MLBAM 3B Pitcher' },
    { id: 'pitchcast', name: 'MLBAM PitchCast' },
    { id: 'alt', name: 'MLBAM Alt Broadcast' },
];
const DIAMOND_ANGLES = [
    { id: 'hd', name: 'DIAMOND Broadcast' },
    { id: 'hh', name: 'DIAMOND High Home' },
    { id: 'cf', name: 'DIAMOND Centerfield' },
    { id: 'mv', name: 'DIAMOND MultiView' },
    { id: '1bp', name: 'DIAMOND 1B Pitcher' },
    { id: '3bp', name: 'DIAMOND 3B Pitcher' },
    { id: '1bh', name: 'DIAMOND 1B Hitter' },
    { id: '3bh', name: 'DIAMOND 3B Hitter' },
    { id: 'pc', name: 'DIAMOND PitchCast' },
];
const AUTO_PLAYLIST_TYPE = [
    { id: 0, name: 'Unknown' },
    { id: 1, name: 'Gameplan Videos' },
    { id: 2, name: 'Pitch Recognition' },
    { id: 3, name: 'Damage' },
    { id: 4, name: 'Recent Matchups' },
    { id: 5, name: 'Recent vs NY LHH' },
    { id: 6, name: 'Recent vs NY RHH' },
    { id: 7, name: 'Pitcher Pickoffs' },
    { id: 8, name: 'Pitcher Pickoff 1B' },
    { id: 9, name: 'Pitcher Pickoff 2B' },
];
const getVideoSources = (mainhd, viewNames, pitchVideoResp, userRoles, priorityAngles, isHighSpeed, isBatter = true, isPitcher = true) => {
    const batterHighSpeedAngles = CAMERA_VIEWS.filter((v) => v.id >= 50 && v.isBatter).map(({ id }) => id);
    const pitcherHighSpeedAngles = CAMERA_VIEWS.filter((v) => v.id >= 50 && v.isPitcher).map(({ id }) => id);
    const mlbamAngleNames = MLBAM_ANGLES.reduce((acc, pvt) => (Object.assign(Object.assign({}, acc), { [pvt.id]: pvt.name })), {});
    const diamondAngleNames = DIAMOND_ANGLES.reduce((acc, pvt) => (Object.assign(Object.assign({}, acc), { [pvt.id]: pvt.name })), {});
    const validAngles = isHighSpeed ? [...(isPitcher ? pitcherHighSpeedAngles : []), ...(isBatter ? batterHighSpeedAngles : [])] : null;
    let sourceLabelArrays = Object.keys(pitchVideoResp)
        .map((urlKey) => {
        const labels = [];
        if (urlKey === 'url') {
            labels.push('Main');
        }
        else if (urlKey === 'url_hd') {
            labels.push(mainhd);
            if (pitchVideoResp.view_anglea) {
                // eslint-disable-next-line eqeqeq
                if (pitchVideoResp.view_anglea == 1)
                    labels.push('CF-HD Broadcast');
                else
                    labels.push('CF-HD');
            }
        }
        else if (urlKey === 'url_sd') {
            // eslint-disable-next-line eqeqeq
            if (pitchVideoResp.view_anglea == 1)
                labels.push('CF-SD Broadcast');
            else
                labels.push('CF-SD');
        }
        else if (urlKey.startsWith('url_angle')) {
            const viewAngleId = pitchVideoResp[urlKey.replace('url_', 'view_')];
            if (viewAngleId && viewNames[viewAngleId])
                labels.push(viewNames[viewAngleId]);
            else
                labels.push(`Angle ${urlKey.replace('url_angle', '').toUpperCase()}`);
        }
        else if (urlKey.startsWith('mlbamurl')) {
            const mlbamAngleId = urlKey.replace('mlbamurl_', '');
            if (mlbamAngleId && mlbamAngleNames[mlbamAngleId])
                labels.push(mlbamAngleNames[mlbamAngleId]);
        }
        else if (urlKey.startsWith('diamondurl') && (userRoles === null || userRoles === void 0 ? void 0 : userRoles.length) && checkRoles(userRoles, 'diamondviewers')) {
            const diamondAngleId = urlKey.replace('diamondurl_', '');
            if (diamondAngleId && diamondAngleNames[diamondAngleId])
                labels.push(diamondAngleNames[diamondAngleId]);
        }
        return { labels, urlKey };
    })
        .filter((x) => {
        let includeVideoInPlaylist = !!x.labels.length && !!pitchVideoResp[x.urlKey];
        if (includeVideoInPlaylist && validAngles) {
            const viewAngleId = pitchVideoResp[x.urlKey.replace('url_', 'view_')];
            includeVideoInPlaylist = !!viewAngleId && validAngles.includes(viewAngleId);
        }
        return includeVideoInPlaylist;
    })
        .sort((a, b) => {
        let { urlKey: urlKeyA } = a;
        let { urlKey: urlKeyB } = b;
        const { labels: [labelA] } = a;
        const { labels: [labelB] } = b;
        // sort generic (a-s) angle names after defined angles (sd, hd, etc.)
        // sort (r-z) then mlbam then diamond angles at end of all other options (using label name)
        if (urlKeyA.startsWith('url_angle')) {
            if (urlKeyA.replace('url_angle', '') < 'r')
                urlKeyA = `1-${urlKeyA}`;
            else
                urlKeyA = `2-${labelA}`;
        }
        else if (urlKeyA.startsWith('mlbamurl'))
            urlKeyA = `3-${labelA}`;
        else if (urlKeyA.startsWith('diamondurl'))
            urlKeyA = `4-${labelA}`;
        else
            urlKeyA = `0-${urlKeyA}`;
        if (urlKeyB.startsWith('url_angle')) {
            if (urlKeyB.replace('url_angle', '') < 'r')
                urlKeyB = `1-${urlKeyB}`;
            else
                urlKeyB = `2-${labelB}`;
        }
        else if (urlKeyB.startsWith('mlbamurl'))
            urlKeyB = `3-${labelB}`;
        else if (urlKeyB.startsWith('diamondurl'))
            urlKeyB = `4-${labelB}`;
        else
            urlKeyB = `0-${urlKeyB}`;
        return urlKeyA.localeCompare(urlKeyB);
    })
        .map((x) => x.labels.map((l) => ({
        label: l,
        file: pitchVideoResp[x.urlKey],
    })))
        .flat();
    if (priorityAngles && priorityAngles.length) {
        sourceLabelArrays = sourceLabelArrays.sort((a, b) => {
            if (priorityAngles.indexOf(a.label) !== -1 && priorityAngles.indexOf(b.label) !== -1) {
                return priorityAngles.indexOf(a.label) - priorityAngles.indexOf(b.label);
            }
            if (priorityAngles.indexOf(a.label) !== -1) {
                return -1;
            }
            if (priorityAngles.indexOf(a.label) === -1 && priorityAngles.indexOf(b.label) === -1 && a.label === 'Main') {
                return -1;
            }
            return 1;
        });
    }
    return sourceLabelArrays.map((s, _idx, self) => {
        const duplicateLabelIdx = self.filter(({ label }) => label === s.label).indexOf(s);
        const label = s.label + (duplicateLabelIdx > 0 ? ` (${duplicateLabelIdx})` : '');
        return Object.assign(Object.assign({}, s), { label });
    });
};
const mapPlaylistFromVideoSearch = (searchResults, userRoles, priorityAngles, isHighSpeed = false, isBatter, isPitcher) => {
    const MAIN_HD = 'Main HD';
    const playerVideoTypeNames = PLAYER_VIDEO_TYPES.reduce((acc, pvt) => (Object.assign(Object.assign({}, acc), { [pvt.id]: pvt.name })), {});
    const viewNames = CAMERA_VIEWS.reduce((acc, v) => (Object.assign(Object.assign({}, acc), { [v.id]: v.name })), {});
    const playlist = searchResults === null || searchResults === void 0 ? void 0 : searchResults.videos.map((v, idx) => {
        var _a, _b, _c;
        const sources = getVideoSources(MAIN_HD, viewNames, v, userRoles, priorityAngles, isHighSpeed, isBatter, isPitcher);
        searchResults.playervideos
            .filter((playervideo) => playervideo.GameID === v.gameid && playervideo.EventSeq === v.eventseq && playervideo.PitchSeq === v.pitchseq)
            .forEach(({ VideoType, PlayerVideoID, Filename, Angle }) => {
            if (!isHighSpeed || VideoType === 104 || Angle >= 50) {
                sources.push({
                    isPlayerVideo: true,
                    type: 'video/mp4',
                    file: `https://base.yankees.com/bbops/api/playervideo/${PlayerVideoID}/stream/${Filename}`,
                    label: `${playerVideoTypeNames[VideoType]} ${viewNames[Angle]}`,
                });
            }
        });
        if (!sources.length)
            return null;
        const batter = (_a = v.batter) === null || _a === void 0 ? void 0 : _a.replace("'", '');
        const pitcher = (_b = v.pitcher) === null || _b === void 0 ? void 0 : _b.replace("'", '');
        const count = `${v.balls}-${v.strikes}`;
        const velocity = format(v.velocity, 1);
        const pr = typeof v.pitchresult === 'string' ? v.pitchresult : pitchResult(parseInt(v.pitchresult));
        const result = v.result != null ? v.result : pr;
        const hasMainHDAngle = sources.some(({ label }) => label === MAIN_HD);
        const pitchtype = getPitchTypeIdFromName(v.fxpitchtype) || getPitchTypeIdFromName(v.pitchtype);
        return {
            pitchId: (v.gameid && v.eventseq && v.pitchseq) ? `${v.gameid}.${v.eventseq}.${v.pitchseq}` : null,
            heatmapId: v.pitcherid && pitchtype ? `${v.pitcherid}.${pitchtype}.${v.batterid || v.islhb || 0}.${v.strikes === 2}.${v.yearid || 0}` : null,
            data: Object.assign(Object.assign({}, v), { type: pitchtype || undefined, rvactualNorm: rvERA(v.rvactual), rvpitchfxNorm: rvERA(v.rvpitchfx), rvbreakNorm: rvERA(v.rvbreak), rvstuffNorm: rvERA(v.rvstuff), rvlocNorm: rvERA(v.rvloc), rvexpNorm: rvERA(v.rvexp), contactResult: rvPerN(v.rvhitfxactualbip, v.biprvdenom, 100), contactQuality: rvPerN(v.rvhitfxpitbip, v.biprvdenom, 100), swinging: v.sw === 1 ? 'Yes' : 'No', swingingFirstPitch: v.sw === 1 && v.balls === 0 && v.strikes === 0 ? 'Yes' : 'No', swingingInZone: v.swinz === 1 ? 'Yes' : 'No', chase: v.ch === 1 ? 'Yes' : 'No', swingDecisionScoreShouldSwing: v.swds === v.swdssw ? v.swds : null, swingDecisionScoreShouldTake: v.swds === v.swdstk ? v.swds : null, miss: v.sw === 1 && v.cn === 0 ? 'Yes' : 'No', missInZone: v.sw === 1 && v.cn === 0 && v.inz === 1 ? 'Yes' : 'No', inZone: v.inz === 1 ? 'Yes' : 'No', strikeout: v.so === 1 ? 'Yes' : 'No', unintentionalWalk: v.ubb === 1 ? 'Yes' : 'No', runnersOn: v.bcbefore !== 0 ? 'Yes' : 'No', hasShift: v.isshift ? 'Yes' : 'No', outProbability: (_c = (v === null || v === void 0 ? void 0 : v.totalprob) * 100) !== null && _c !== void 0 ? _c : null, pitcherHand: v.islhp ? 1 : 0, batterHand: v.islhb ? 1 : 0, hasRunners: v.bcbefore ? 1 : 0, sourceLabels: sources.map(({ label }) => (label)) }),
            sources: sources.map(({ type, file, label }, i) => ({ type, file, label, default: (hasMainHDAngle ? label === MAIN_HD : i === 0) })),
            title: `${idx + 1}. ${batter} vs. ${pitcher} - ${date(v.gamedate)}`,
            description: (userRoles === null || userRoles === void 0 ? void 0 : userRoles.some((r) => ['developer', 'qadept'].includes(r)))
                // eslint-disable-next-line max-len
                ? `${v.istop ? 'Top' : 'Bot'} ${v.inning} | Out: ${v.outsbefore} | Cnt: ${count} ${pitchTypeDisplayName({ fxtype: pitchtype, fxsubtype: v.fxsubtype }) ? `| ${pitchTypeDisplayName({ fxtype: pitchtype, fxsubtype: v.fxsubtype })} ` : ''}${velocity ? ` (${velocity}) ` : ''}${v.pstrike ? `| P-Strike: ${(Number(v.pstrike) * 100).toFixed(1)}% ` : ''}| Result: ${result} | GameId: ${v.gameid}, PitchSeq: ${v.pitchseq}, EventSeq: ${v.eventseq}`
                // eslint-disable-next-line max-len
                : `${v.istop ? 'Top' : 'Bot'} ${v.inning} | Out: ${v.outsbefore} | Cnt: ${count} ${pitchTypeDisplayName({ fxtype: pitchtype, fxsubtype: v.fxsubtype }) ? `| ${pitchTypeDisplayName({ fxtype: pitchtype, fxsubtype: v.fxsubtype })} ` : ''}${velocity ? ` (${velocity}) ` : ''}${v.pstrike ? `| P-Strike: ${(Number(v.pstrike) * 100).toFixed(1)}% ` : ''}| Result: ${result}`,
            clip: sources.filter((s) => !s.isPlayerVideo).map((s) => ({
                Url: s.file,
                AngleLabel: s.label,
                GameDate: v.gamedate,
                GameID: v.gameid,
                EventSeq: v.eventseq,
                PitchSeq: v.pitchseq,
                Include: true,
                Data: JSON.stringify({
                    Batter: batter,
                    Pitcher: pitcher,
                    Inning: v.inning,
                    Outs: v.outsbefore,
                    Count: count,
                    Bats: v.islhb ? 'L' : 'R',
                    Throws: v.islhp ? 'L' : 'R',
                    Velocity: velocity || '-',
                    PitchType: v.pitchtype != null ? v.pitchtype : '-',
                    PitchSubType: v.fxsubtype,
                    Result: result,
                }),
            })),
        };
    });
    return playlist === null || playlist === void 0 ? void 0 : playlist.filter((v) => v);
};

const mapCtwb = (ctwb, pitcherId, translate = null) => {
    const { overrides, firstpitch, oz } = ctwb;
    const heatmaps = ctwb.heatmaps.map((x) => ({
        playerid: x.b,
        pitchtype: x.t,
        fxsubtype: x.st,
        y: x.y,
        x: x.x,
        code: x.c,
        // eslint-disable-next-line no-nested-ternary
        situationsplit: x.s === 0 ? 'Early' : (x.s === 1 ? 'TwoStrikes' : null),
        val: x.v,
    }));
    const repertoire = heatmaps
        .map((h) => ({ pitchtype: Number(h.pitchtype), fxsubtype: Number(h.fxsubtype) || 0 }))
        .reduce((a, c) => { !a.find((v) => v.pitchtype === c.pitchtype && v.fxsubtype === c.fxsubtype) && a.push(c); return a; }, [])
        // eslint-disable-next-line max-len
        .sort((a, b) => { var _a, _b; return (((_a = PITCH_TYPES(translate).find((x) => x.id === a.pitchtype)) === null || _a === void 0 ? void 0 : _a.sortorder) || 0) - (((_b = PITCH_TYPES(translate).find((x) => x.id === b.pitchtype)) === null || _b === void 0 ? void 0 : _b.sortorder) || 0); });
    const initOutput = {};
    const hitters = Array.from(new Set(heatmaps.map((h) => h.playerid))).reduce((hitterMaps, batterId) => {
        const earlyHeatmaps = heatmaps.filter((h) => h.playerid === batterId && h.situationsplit === 'Early');
        const lateHeatmaps = heatmaps.filter((h) => h.playerid === batterId && h.situationsplit === 'TwoStrikes');
        const earlyOverrides = overrides.filter((o) => o.BatterID === batterId && o.SituationSplit === 'Early');
        const lateOverrides = overrides.filter((o) => o.BatterID === batterId && o.SituationSplit === 'TwoStrikes');
        const hasEarlyGreenOverride = earlyOverrides.some((o) => o.GreenBox);
        const hasLateGreenOverride = lateOverrides.some((o) => o.GreenBox);
        const hasEarlyDashGreenOverride = earlyOverrides.some((o) => o.DashGreenBox);
        const hasLateDashGreenOverride = lateOverrides.some((o) => o.DashGreenBox);
        const initMap = { earlyOverrides: {}, lateOverrides: {}, earlyHeatmaps: {}, lateHeatmaps: {} };
        hitterMaps[batterId] = initMap;
        repertoire.forEach((acc) => {
            const pitchType = acc.pitchtype;
            const FXSubType = acc.fxsubtype;
            if (hitterMaps[batterId].earlyOverrides[pitchType] == null)
                hitterMaps[batterId].earlyOverrides[pitchType] = [];
            /* eslint-disable eqeqeq, object-property-newline */
            const earlyOverride = earlyOverrides.find((x) => x.PitchType === pitchType && x.FXSubType === FXSubType);
            if (earlyOverride)
                hitterMaps[batterId].earlyOverrides[pitchType][FXSubType] = earlyOverride;
            // create a synthetic override record for display purposes
            else {
                hitterMaps[batterId].earlyOverrides[pitchType][FXSubType] = {
                    BatterID: batterId, BlankBox: null, GreenBox: null, PitchType: pitchType, FXSubType, PitcherID: pitcherId, RedX: null,
                    Selected: null, KFree: null, OTZ: null, SituationSplit: 'Early', LastUpdateDate: null, LastUpdateUser: null, DashGreenBox: null,
                };
            }
            // if the model declares something should be an 0-0 pitch, and there aren't any manually set 0-0 pitches, set the synthetic record to true
            if (!earlyOverrides.some(({ Selected }) => Selected == true)) {
                const firstPitch = firstpitch.find((x) => x.batterid == batterId && x.type == pitchType && x.fxsubtype === FXSubType);
                if (firstPitch && hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].Selected == null) {
                    hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].Selected = true;
                    hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].KFree = !!firstPitch.kfree;
                }
            }
            const earlycode = earlyHeatmaps.find((x) => x.x == 0 && x.y == 0 && x.pitchtype == pitchType && x.fxsubtype === FXSubType);
            if (earlycode) {
                if (hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].GreenBox === null && earlycode.code === 2 && !hasEarlyGreenOverride) {
                    hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].GreenBox = true;
                }
                if (hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].DashGreenBox === null && earlycode.code === 1 && !hasEarlyDashGreenOverride) {
                    hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].DashGreenBox = true;
                }
                if (hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].val == null) {
                    hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].val = earlycode.val;
                }
                else {
                    hitterMaps[batterId].earlyOverrides[pitchType][FXSubType].valoverride = true;
                }
            }
            if (hitterMaps[batterId].lateOverrides[pitchType] == null)
                hitterMaps[batterId].lateOverrides[pitchType] = [];
            const lateOverride = lateOverrides.find((x) => x.PitchType == pitchType && x.FXSubType === FXSubType);
            if (lateOverride)
                hitterMaps[batterId].lateOverrides[pitchType][FXSubType] = lateOverride;
            // create a synthetic override record for display purposes
            else {
                hitterMaps[batterId].lateOverrides[pitchType][FXSubType] = {
                    BatterID: batterId, BlankBox: null, GreenBox: null, PitchType: pitchType, FXSubType, PitcherID: pitcherId, RedX: null,
                    Selected: null, KFree: null, OTZ: null, SituationSplit: 'TwoStrikes', LastUpdateDate: null, LastUpdateUser: null, DashGreenBox: null,
                };
            }
            // if the model declares something should be an OTZ pitch, and there aren't any manually set OTZ pitches, set the synthetic record to true
            if (!lateOverrides.some(({ OTZ }) => OTZ == true)) {
                const otz = oz.find((x) => x.batterid == batterId && x.type == pitchType && x.fxsubtype === FXSubType);
                if (otz && hitterMaps[batterId].lateOverrides[pitchType][FXSubType].OTZ == null) {
                    hitterMaps[batterId].lateOverrides[pitchType][FXSubType].OTZ = otz.oz;
                }
            }
            const latecode = lateHeatmaps.find((x) => x.x == 0 && x.y == 0 && x.pitchtype == pitchType && x.fxsubtype === FXSubType);
            if (latecode) {
                if (hitterMaps[batterId].lateOverrides[pitchType][FXSubType].GreenBox === null && latecode.code === 2 && !hasLateGreenOverride) {
                    hitterMaps[batterId].lateOverrides[pitchType][FXSubType].GreenBox = true;
                }
                if (hitterMaps[batterId].lateOverrides[pitchType][FXSubType].DashGreenBox === null && latecode.code === 1 && !hasLateDashGreenOverride) {
                    hitterMaps[batterId].lateOverrides[pitchType][FXSubType].DashGreenBox = true;
                }
                if (hitterMaps[batterId].lateOverrides[pitchType][FXSubType].val == null) {
                    hitterMaps[batterId].lateOverrides[pitchType][FXSubType].val = latecode.val;
                }
                else {
                    hitterMaps[batterId].lateOverrides[pitchType][FXSubType].valoverride = true;
                }
            }
            if (hitterMaps[batterId].earlyHeatmaps[pitchType] == null)
                hitterMaps[batterId].earlyHeatmaps[pitchType] = [];
            if (hitterMaps[batterId].lateHeatmaps[pitchType] == null)
                hitterMaps[batterId].lateHeatmaps[pitchType] = [];
            hitterMaps[batterId].earlyHeatmaps[pitchType][FXSubType] = earlyHeatmaps.filter((x) => x.pitchtype == pitchType && x.fxsubtype === FXSubType);
            hitterMaps[batterId].lateHeatmaps[pitchType][FXSubType] = lateHeatmaps.filter((x) => x.pitchtype == pitchType && x.fxsubtype === FXSubType);
        });
        return hitterMaps;
    }, initOutput);
    return {
        pitcherid: pitcherId,
        hitters,
        repertoire,
    };
};
const mapCtwbToPitches = (ctwb, pitcherId, pitches, translate = null) => {
    const pitcherMaps = mapCtwb(ctwb, pitcherId, translate);
    return pitches.map((p) => {
        if (pitcherMaps.pitcherid === p.pitcherid) {
            const batterMap = pitcherMaps.hitters[p.batterid];
            let heatMaps = batterMap && batterMap.lateHeatmaps;
            let overrides = batterMap && batterMap.lateOverrides;
            if (p.strikes !== 2) {
                heatMaps = batterMap && batterMap.earlyHeatmaps;
                overrides = batterMap && Object.assign({}, batterMap.earlyOverrides);
                if ((p.strikes !== 0 || p.balls !== 0) && overrides) {
                    Object.values(overrides).forEach((override) => {
                        Object.values(override).forEach((o) => {
                            o.Selected = false;
                        });
                    });
                }
            }
            return Object.assign(Object.assign({}, p), { heatMaps,
                overrides, pitcherRepertoire: pitcherMaps.repertoire });
        }
        return p;
    });
};

const handleFetchResponse = (apiResp, returnFullError = false) => {
    if (apiResp.ok) {
        const contentType = apiResp.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return apiResp.json();
        }
        return apiResp.text();
    }
    throw returnFullError ? apiResp : apiResp.statusText;
};
const callApi = (method) => (apiRoute, body, fetchOpts, returnFullError = false) => __awaiter(void 0, void 0, void 0, function* () {
    let requestBody = body;
    if (body && typeof body === 'object') {
        if (body instanceof FormData && (fetchOpts === null || fetchOpts === void 0 ? void 0 : fetchOpts.headers)) {
            // fetch will automatically set this and the corresponding boundary when given a FormData instance
            if (fetchOpts.headers instanceof Headers) {
                fetchOpts.headers.delete('Content-Type');
            }
            else {
                fetchOpts.headers = new Headers(Object.assign({}, fetchOpts.headers));
                fetchOpts.headers.delete('Content-Type');
            }
        }
        else {
            requestBody = JSON.stringify(body);
        }
    }
    const apiResp = yield fetch(apiRoute, Object.assign({ method, body: requestBody }, fetchOpts));
    return handleFetchResponse(apiResp, returnFullError);
});
const get$1 = callApi('GET');
const put$1 = callApi('PUT');
const post$1 = callApi('POST');
const remove$1 = callApi('DELETE');
const patch$1 = callApi('PATCH');

const addQueryParamsToUrl = (url, queryParams) => {
    let mappedUrl = url || '';
    if (queryParams && typeof queryParams === 'object' && Object.keys(queryParams).length) {
        const params = Object.assign({}, queryParams);
        // Strip undefined query params
        Object.keys(params).forEach((key) => {
            if (params[key] === undefined || params[key] === null) {
                delete params[key];
            }
        });
        // manipulate params for api call
        const entries = Object.entries(params).reduce((acc, [key, value]) => {
            if (Array.isArray(value))
                value.forEach((x) => acc.push([key, x.toString()]));
            else if (value instanceof Date)
                acc.push([key, value.toISOString()]);
            else
                acc.push([key, typeof value === 'string' ? value : JSON.stringify(value)]);
            return acc;
        }, new Array());
        const query = new URLSearchParams(entries).toString();
        mappedUrl += `?${query}`;
    }
    return mappedUrl;
};
const jsonDataAsMultipartForm = (jsonObj) => Object.keys(jsonObj).reduce((acc, key) => {
    const data = jsonObj[key];
    const formVal = typeof data === 'string' || data instanceof Blob ? data : JSON.stringify(data);
    acc.append(key, formVal);
    return acc;
}, new FormData());

const getDefaultFetchOpts = (fetchOptsOverrides) => (Object.assign(Object.assign({}, fetchOptsOverrides), { headers: Object.assign({ 'Content-Type': 'application/json' }, fetchOptsOverrides === null || fetchOptsOverrides === void 0 ? void 0 : fetchOptsOverrides.headers) }));
const get = (url, queryParams = null, fetchOpts = {}, returnFullError = true) => __awaiter(void 0, void 0, void 0, function* () {
    const path = addQueryParamsToUrl(url, queryParams);
    const opts = getDefaultFetchOpts(fetchOpts);
    return get$1(path, undefined, opts, returnFullError);
});
const post = (url, body = null, queryParams = null, fetchOpts = {}, returnFullError = true) => __awaiter(void 0, void 0, void 0, function* () {
    const path = addQueryParamsToUrl(url, queryParams);
    const opts = getDefaultFetchOpts(fetchOpts);
    return post$1(path, body, opts, returnFullError);
});
const put = (url, body = null, queryParams = null, fetchOpts = {}, returnFullError = true) => __awaiter(void 0, void 0, void 0, function* () {
    const path = addQueryParamsToUrl(url, queryParams);
    const opts = getDefaultFetchOpts(fetchOpts);
    return put$1(path, body, opts, returnFullError);
});
const remove = (url, queryParams = null, fetchOpts = {}, returnFullError = true) => __awaiter(void 0, void 0, void 0, function* () {
    const path = addQueryParamsToUrl(url, queryParams);
    const opts = getDefaultFetchOpts(fetchOpts);
    return remove$1(path, undefined, opts, returnFullError);
});
const patch = (url, body = null, queryParams = null, fetchOpts = {}, returnFullError = true) => __awaiter(void 0, void 0, void 0, function* () {
    const path = addQueryParamsToUrl(url, queryParams);
    const opts = getDefaultFetchOpts(fetchOpts);
    return patch$1(path, body, opts, returnFullError);
});

var api = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get: get,
    post: post,
    put: put,
    remove: remove,
    patch: patch
});

const useAbortable = (url, doFetch = true, queryParams = null, fetchOpts = {}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [response, setResponse] = useState(null);
    useEffect(() => {
        const abortController = new AbortController();
        const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                setIsLoading(true);
                const data = yield get(url, queryParams, Object.assign(Object.assign({}, fetchOpts), { signal: abortController.signal }));
                setResponse(data);
                setIsLoading(false);
            }
            catch (error) {
                if (error instanceof Error && error.name !== 'AbortError') {
                    throw error;
                }
            }
        });
        if (doFetch)
            fetchData();
        return () => {
            abortController.abort();
        };
    }, [doFetch, url, queryParams, fetchOpts]);
    return { response, isLoading, clearResponse: () => setResponse(null) };
};

const FT_PER_METER = 3.281;
const MPS_MPH = 2.237;
const IN_PER_METER = 39.37;
const HITTRAX_RESULT_TYPES = (translate) => [
    { id: -8, name: translate('components.ballcap.hittrax.line-drive-out') },
    { id: -6, name: translate('components.ballcap.hittrax.wild-pitch') },
    { id: -5, name: translate('components.ballcap.hittrax.swing-miss') },
    { id: -4, name: translate('components.ballcap.hittrax.not-calc-none') },
    { id: -3, name: translate('components.ballcap.hittrax.foul-ball') },
    { id: -2, name: translate('components.ballcap.hittrax.hit-by-pitch') },
    { id: -1, name: translate('components.ballcap.hittrax.fly-ball-out') },
    { id: 0, name: translate('components.ballcap.hittrax.out') },
    { id: 1, name: translate('components.ballcap.hittrax.single') },
    { id: 2, name: translate('components.ballcap.hittrax.double') },
    { id: 3, name: translate('components.ballcap.hittrax.triple') },
    { id: 4, name: translate('components.ballcap.hittrax.home-run') },
    { id: 5, name: translate('components.ballcap.hittrax.caught-stealing') },
];
const HITTRAX_HIT_TYPES = (translate) => [
    { id: 0, name: translate('components.ballcap.hittrax.none'), nyEnum: null },
    { id: 1, name: translate('components.ballcap.hittrax.ground-ball'), nyEnum: 0 },
    { id: 2, name: translate('components.ballcap.hittrax.line-drive'), nyEnum: 2 },
    { id: 3, name: translate('components.ballcap.hittrax.fly-ball'), nyEnum: 1 },
    { id: 4, name: translate('components.ballcap.hittrax.baltimore-chop'), nyEnum: 0 },
    { id: 5, name: translate('components.ballcap.hittrax.catcher-throw'), nyEnum: null },
];
const hittraxHitTypeNyEnum = (translate, ht) => {
    const found = HITTRAX_HIT_TYPES(translate).find((x) => x.id === ht);
    if (found === undefined)
        return null;
    return found.nyEnum;
};
const HITTRAX_FIELDER_TYPES = (translate) => [
    { id: 0, name: translate('components.ballcap.hittrax.none') },
    { id: 1, name: translate('baseball.pitcher_one'), abbr: 'P' },
    { id: 2, name: translate('baseball.catcher_one'), abbr: 'C' },
    { id: 3, name: translate('baseball.positions.first-base'), abbr: '1B' },
    { id: 4, name: translate('baseball.positions.second-base'), abbr: '2B' },
    { id: 5, name: translate('baseball.positions.third-base'), abbr: '3B' },
    { id: 6, name: translate('baseball.positions.shortstop'), abbr: 'SS' },
    { id: 7, name: translate('baseball.positions.left-field'), abbr: 'LF' },
    { id: 8, name: translate('baseball.positions.center-field'), abbr: 'CF' },
    { id: 9, name: translate('baseball.positions.right-field'), abbr: 'RF' },
];
const BALLCAP_SESSION_TYPES = (translate) => [
    { id: 0, name: translate ? translate('components.ballcap.session-type.game') : 'Game' },
    { id: 1, name: translate ? translate('components.ballcap.session-type.bullpen') : 'Bullpen' },
    { id: 2, name: translate ? translate('components.ballcap.session-type.cage') : 'Cage' },
    { id: 3, name: translate ? translate('components.ballcap.session-type.other') : 'Other' },
    { id: 4, name: translate ? translate('components.ballcap.session-type.group') : 'Group' },
    { id: 5, name: translate ? translate('components.ballcap.session-type.defense') : 'Defense' },
];
const BALLCAP_BATTER_PITCH_RESULT_TYPES = (translate) => [
    { id: 0, name: '--', abbr: '--', sortorder: 0 },
    { id: 1, name: translate ? translate('components.ballcap.pitch-result.take') : 'Take', abbr: translate ? translate('components.ballcap.pitch-result.abbr-take') : 'TK', sortorder: 1 },
    { id: 2, name: translate ? translate('components.ballcap.pitch-result.miss') : 'Miss', abbr: translate ? translate('components.ballcap.pitch-result.abbr-miss') : 'MS', sortorder: 2 },
    { id: 3, name: translate ? translate('components.ballcap.pitch-result.foul') : 'Foul', abbr: translate ? translate('components.ballcap.pitch-result.abbr-foul') : 'FL', sortorder: 3 },
    { id: 4, name: translate ? translate('components.ballcap.pitch-result.in-play') : 'In-Play', abbr: translate ? translate('components.ballcap.pitch-result.abbr-in-play') : 'IP', sortorder: 4 },
];
const BALLCAP_BATTER_CONDITION_TYPES = (translate) => [
    { id: 0, name: '--', abbr: '--', sortorder: 0 },
    { id: 1, name: translate ? translate('components.ballcap.condition.tee') : 'Tee', abbr: translate ? translate('components.ballcap.condition.abbr-tee') : 'T', sortorder: 1 },
    { id: 2, name: translate ? translate('components.ballcap.condition.side-toss') : 'Side Toss', abbr: translate ? translate('components.ballcap.condition.abbr-side-toss') : 'ST', sortorder: 2 },
    { id: 3, name: translate ? translate('components.ballcap.condition.front-toss') : 'Front Toss', abbr: translate ? translate('components.ballcap.condition.abbr-front-toss') : 'FT', sortorder: 3 },
    { id: 4, name: translate ? translate('components.ballcap.condition.short-overhand') : 'Short Overhand', abbr: translate ? translate('components.ballcap.condition.abbr-short-overhand') : 'SO', sortorder: 4 },
    { id: 5, name: translate ? translate('components.ballcap.condition.open-angle') : 'Open Angle', abbr: translate ? translate('components.ballcap.condition.abbr-open-angle') : 'OP', sortorder: 5 },
    { id: 6, name: translate ? translate('components.ballcap.condition.closed-angle') : 'Closed Angle', abbr: translate ? translate('components.ballcap.abbr-condition.closed-angle') : 'CL', sortorder: 6 },
    { id: 7, name: translate ? translate('components.ballcap.condition.batting-practice') : 'Batting Practice', abbr: translate ? translate('components.ballcap.condition.abbr-batting-practice') : 'BP', sortorder: 7 },
    { id: 8, name: translate ? translate('components.ballcap.condition.random-batting-practice') : 'Random Batting Practice', abbr: translate ? translate('components.ballcap.condition.abbr-random-batting-practice') : 'RBP', sortorder: 8 },
    { id: 9, name: translate ? translate('components.ballcap.condition.fastball-machine') : 'Fastball Machine', abbr: translate ? translate('components.ballcap.condition.abbr-fastball-machine') : 'FB', sortorder: 9 },
    { id: 10, name: translate ? translate('components.ballcap.condition.breaking-ball-machine') : 'Breaking Ball Machine', abbr: translate ? translate('components.ballcap.condition.abbr-breaking-ball-machine') : 'BB', sortorder: 10 },
    { id: 11, name: translate ? translate('components.ballcap.condition.mixed-batting-practice') : 'Mixed Batting Practice', abbr: translate ? translate('components.ballcap.condition.abbr-mixed-batting-practice') : 'MX', sortorder: 11 },
    { id: 12, name: translate ? translate('components.ballcap.condition.short-underhand') : 'Short Underhand', abbr: translate ? translate('components.ballcap.condition.abbr-short-underhand') : 'SU', sortorder: 12 },
    { id: 13, name: translate ? translate('components.ballcap.condition.baby-bear') : 'Baby Bear', abbr: translate ? translate('components.ballcap.condition.abbr-baby-bear') : 'BEAR', sortorder: 13 },
];
const BALLCAP_BATTER_BAT_TYPES = (translate) => [
    { id: 0, name: '--', abbr: '--', sortorder: 0 },
    { id: 1, name: translate ? translate('components.ballcap.bat-types.normal') : 'Normal Bat', abbr: translate ? translate('components.ballcap.bat-types.abbr-normal') : 'NB', sortorder: 1 },
    { id: 2, name: translate ? translate('components.ballcap.bat-types.skinny') : 'Skinny Bat', abbr: translate ? translate('components.ballcap.bat-types.abbr-skinny') : 'SK', sortorder: 2 },
    { id: 3, name: translate ? translate('components.ballcap.bat-types.underload') : 'Underload Bat', abbr: translate ? translate('components.ballcap.bat-types.abbr-underload') : 'UN', sortorder: 3 },
    { id: 4, name: translate ? translate('components.ballcap.bat-types.overload') : 'Overload Bat', abbr: translate ? translate('components.ballcap.bat-types.abbr-overload') : 'OV', sortorder: 4 },
    { id: 5, name: translate ? translate('components.ballcap.bat-types.heavy') : 'Heavy Bat', abbr: translate ? translate('components.ballcap.bat-types.abbr-heavy') : 'HV', sortorder: 5 },
    { id: 6, name: translate ? translate('components.ballcap.bat-types.end-loaded') : 'End-Loaded Bat', abbr: translate ? translate('components.ballcap.bat-types.abbr-end-loaded') : 'EL', sortorder: 6 },
    { id: 7, name: translate ? translate('components.ballcap.bat-types.short') : 'Short Bat', abbr: translate ? translate('components.ballcap.bat-types.abbr-short') : 'SB', sortorder: 7 },
];
const getPlateLoc = (x0, vx0, ax0, y0, vy0, ay0, z0, vz0, az0) => {
    // y = 1.4167 at the plate
    // use quadratic formula with known value of 1.4167 for y to determine the time, 
    // then use that to provide the x, y and z of the point where it crosses the plate.
    const a = ay0 / 2;
    const b = vy0;
    const c = y0 - 1.4167;
    const t1 = ((-1 * b) + Math.sqrt((Math.pow(b, 2)) - (4 * a * c))) / (2 * a);
    const t2 = ((-1 * b) - Math.sqrt((Math.pow(b, 2)) - (4 * a * c))) / (2 * a);
    // eslint-disable-next-line no-nested-ternary
    const t = t1 && t2 > 0 ? (t1 > t2 ? t2 : t1) : (t1 > 0 ? t1 : t2);
    const x = x0 + (t * vx0) + ((Math.pow(t, 2)) * 0.5 * ax0);
    const y = y0 + (t * vy0) + ((Math.pow(t, 2)) * 0.5 * ay0);
    const z = z0 + (t * vz0) + ((Math.pow(t, 2)) * 0.5 * az0);
    return { posx: x, posy: y, posz: z };
};
const rapsodo9PFitBreaks = (data, extension) => {
    const x0 = Number(data.x0);
    const vx0 = Number(data.speedX);
    const ax0 = Number(data.ax0);
    const vy0 = Number(data.speedY);
    const ay0 = Number(data.ay0);
    const z0 = Number(data.z0);
    const vz0 = Number(data.speedZ);
    const az0 = Number(data.az0);
    const ext = extension || 20.5; // use 20.5 extension (40' break) as default unless provided
    const time5055 = ((-1 * vy0) - Math.sqrt((Math.pow(vy0, 2)) - (2 * ay0 * (48.59 - (60.5 - ext))))) / ay0; // time from 50ft to 55ft
    const time50HP = ((-1 * vy0) - Math.sqrt((Math.pow(vy0, 2)) - (2 * ay0 * (48.59 - (17.0 / 12.0))))) / ay0; // Time from 50ft to home plate
    const vx55 = vx0 + (ax0 * time5055); // x velocity at 55ft
    const vz55 = vz0 + (az0 * time5055); // z velocity at 55ft
    const x55 = (0.5 * ax0 * (Math.pow(time5055, 2))) + (vx0 * time5055) + x0; // x position at 55ft
    const z55 = (0.5 * az0 * (Math.pow(time5055, 2))) + (vz0 * time5055) + z0; // z position at 55ft
    let pls = (0.5 * ax0 * (Math.pow(time50HP, 2))) + (vx0 * time50HP) + x0; // horizontal location at front of home plate
    const plh = (0.5 * az0 * (Math.pow(time50HP, 2))) + (vz0 * time50HP) + z0; // vertical location at front of home plate
    let relx = -12 * ((pls - x55) - (vx55 * (time50HP - time5055))); // horizontal movement measured from 55ft P/fx scale
    const relz = 12 * ((plh - z55) - (vz55 * (time50HP - time5055)) // vertical movement measured from 55ft P/fx scale
        + ((32.174 / 2) * (Math.pow((time50HP - time5055), 2))));
    pls *= -1;
    relx *= -1;
    const roundToTwoDecimals = (num) => Math.round(num * 100) / 100;
    return {
        PlateX: roundToTwoDecimals(pls),
        PlateZ: roundToTwoDecimals(plh),
        BreakX: roundToTwoDecimals(relx),
        BreakZ: roundToTwoDecimals(relz),
    };
};
const mapBallCapPlaylist$1 = (translation, sessionType, player, pitches, videos, isLH, extension) => {
    const views = CAMERA_VIEWS.reduce((acc, v) => {
        acc[v.id] = v.name;
        return acc;
    }, {});
    // eslint-disable-next-line array-callback-return, consistent-return
    return pitches.map((p) => {
        const sources = p.Angles.map((a) => {
            const video = videos.find((v) => v.BucketKey.endsWith(a.FileName));
            let label = `${translation ? translation('components.ballcap.angle') : 'Angle'} ${a.AngleName}`;
            if (a.RHAngleId && !isLH)
                label = views[a.RHAngleId];
            else if (a.LHAngleId && isLH)
                label = views[a.LHAngleId];
            return video && video.SignedURL && {
                file: video.SignedURL,
                label,
            };
        }).filter((a) => a);
        if (sources.length) {
            sources.sort((a, b) => a.label.localeCompare(b.label));
            sources[0].default = true;
            let title = `${translation ? translation('baseball.pitches_one') : 'Pitch'} ${p.PitchID}`;
            if (p.ClassifiedPitchType) {
                title += ` - ${pitchTypeOrSubType(p.ClassifiedPitchType)}`;
            }
            const metrics = {
                TotalSpin: '',
                GyroSpin: '',
                GyroDegree: '',
                BreakX: '',
                BreakZ: '',
                PlateX: '',
                PlateZ: '',
                Velocity: '',
            };
            const sensorMetrics = p.SensorEvents
                .filter((s) => s.SensorType !== 'SerialRadar')
                .reduce((acc, s) => (Object.assign(Object.assign({}, acc), s.Data)), {});
            if (Object.keys(sensorMetrics).length) {
                if (Number(sensorMetrics.speedConfidence) > 0.8 || (!sensorMetrics.speedConfidence && sensorMetrics.speed)) {
                    metrics.Velocity = Number(sensorMetrics.speed).toFixed(1);
                }
                if (Number(sensorMetrics.spinConfidence) >= 0.8) {
                    const breaks = rapsodo9PFitBreaks(sensorMetrics, extension);
                    metrics.TotalSpin = Number(Math.abs(sensorMetrics.spin)).toFixed();
                    metrics.GyroSpin = Number(Math.abs(sensorMetrics.rifleSpin)).toFixed();
                    metrics.GyroDegree = Number(sensorMetrics.gyroDegree).toFixed(1);
                    metrics.BreakX = Number(breaks.BreakX).toFixed(1);
                    metrics.BreakZ = Number(breaks.BreakZ).toFixed(1);
                    metrics.PlateX = Number(breaks.PlateX).toFixed(1);
                    metrics.PlateZ = Number(breaks.PlateZ).toFixed(1);
                }
            }
            const description = [];
            if (metrics.Velocity)
                description.push(`${translation ? translation('utils.video.velocity') : 'Velocity'}: ${metrics.Velocity} mph`);
            if (metrics.TotalSpin)
                description.push(`${translation ? translation('components.ballcap.spin') : 'Spin'}: ${metrics.TotalSpin} rpm`);
            if (metrics.GyroSpin)
                description.push(`${translation ? translation('components.video.gyro-spin') : 'Gyro Spin'}: ${metrics.GyroSpin} rpm`);
            if (metrics.BreakX)
                description.push(`${translation ? translation('baseball.break-x') : 'Break X'}: ${metrics.BreakX}"`);
            if (metrics.BreakZ)
                description.push(`${translation ? translation('baseball.break-z') : 'Break Z'}: ${metrics.BreakZ}"`);
            return {
                title,
                description: description.length ? description.join(' | ') : null,
                sources,
                clip: sources.map((s) => ({
                    Url: s.file,
                    AngleLabel: s.label,
                    Include: true,
                    Data: JSON.stringify(Object.assign(Object.assign({}, metrics), { Pitcher: sessionType === 1 ? `${player.UsesName} ${player.LastName}` : null, Batter: sessionType === 2 ? `${player.UsesName} ${player.LastName}` : null, PitchType: pitchTypeOrSubType(p.ClassifiedPitchType), BreakX: (sessionType === 1 && metrics.BreakX) ? (-1 * Number(metrics.BreakX)) : metrics.BreakX })),
                })),
            };
        }
    }).filter((p) => p);
};

const Styles$1 = styled.div `
  padding: 1rem;
  text-align: center;
    
  table {
    border-spacing: 0;
    border: 1px solid;
    width: 45%;
    tr:nth-child(odd) {
        background-color: #D6EEEE;
    }
    th, td {
    text-align: center;
      margin: 0;
      padding: 0.5rem;
    }
  }
  .tableTitle {
        text-align: center;
        size: 50;
    }
`;
const getHittraxDescription = (translate, Res, HT, Fld, HorzAngle) => {
    var _a, _b;
    if (Res === null)
        return null;
    const nyyHitType = hittraxHitTypeNyEnum(translate, HT);
    const hitTypeDesc = nyyHitType === null ? '' : hitType(nyyHitType, false, translate);
    const result = (_a = HITTRAX_RESULT_TYPES(translate).find((x) => x.id === Res)) === null || _a === void 0 ? void 0 : _a.name;
    const fielder = Fld && ((_b = HITTRAX_FIELDER_TYPES(translate).find((x) => x.id === Fld)) === null || _b === void 0 ? void 0 : _b.abbr);
    if (Res === 4) {
        let fieldString = '';
        if (HorzAngle > -45 && HorzAngle < -27) {
            fieldString = translate('baseball.positions.left-field');
        }
        else if (HorzAngle > -27 && HorzAngle < -9) {
            fieldString = translate('components.ballcap.left-center');
        }
        else if (HorzAngle > -9 && HorzAngle < 9) {
            fieldString = translate('baseball.positions.center-field');
        }
        else if (HorzAngle > 9 && HorzAngle < 27) {
            fieldString = translate('components.ballcap.right-center');
        }
        else if (HorzAngle > 27 && HorzAngle < 45) {
            fieldString = translate('baseball.positions.right-field');
        }
        return `${result} ${translate('common.to')} ${fieldString}`;
    }
    return `${result}, ${hitTypeDesc} ${translate('common.to')} ${fielder}`;
};
const HitTrax = ({ sensorEvent }) => {
    const { t: translate } = useTranslation();
    const velo = sensorEvent.Velo * MPS_MPH;
    const dist = sensorEvent.Dist * FT_PER_METER;
    const { Elv, Res, HT, Fld, HorzAngle } = sensorEvent;
    return (React.createElement(React.Fragment, null,
        React.createElement(Styles$1, null,
            React.createElement("div", { className: "bootstrap" },
                React.createElement("table", null,
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, translate('components.ballcap.exit-velo')),
                            React.createElement("th", null, translate('components.ballcap.launch-angle')),
                            React.createElement("th", null, translate('components.ballcap.distance')),
                            React.createElement("th", null, translate('components.ballcap.result'))),
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                " ",
                                translate('format.abbr-mph', { value: format(velo, 1) })),
                            React.createElement("td", null,
                                " ",
                                format(Elv, 1),
                                "\u00B0 "),
                            React.createElement("td", null,
                                " ",
                                translate('format.abbr-feet', { value: format(dist, 1) })),
                            React.createElement("td", null,
                                " ",
                                getHittraxDescription(translate, Res, HT, Fld, HorzAngle),
                                " "))))))));
};

/* eslint-disable react/no-this-in-sfc */
const Container$2 = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
        
    }
`;
const ZoneDepth = ({ sensorEvent }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        const chart = ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (chart == null) {
            return;
        }
        renderHomePlate(chart);
    }, [ref, sensorEvent]); // eslint-disable-line react-hooks/exhaustive-deps
    function renderHomePlate(chart) {
        const rectattr = {
            'stroke-width': 2,
            stroke: 'lightgrey',
            fill: 'none',
            zIndex: 1,
        };
        const platePath = new Array();
        platePath.push('M');
        platePath.push(chart.xAxis[0].toPixels(-8.5, false));
        platePath.push(chart.yAxis[0].toPixels(17, false));
        platePath.push('L');
        platePath.push(chart.xAxis[0].toPixels(8.5, false));
        platePath.push(chart.yAxis[0].toPixels(17, false));
        platePath.push(chart.xAxis[0].toPixels(8.5, false));
        platePath.push(chart.yAxis[0].toPixels(8.5, false));
        platePath.push(chart.xAxis[0].toPixels(0, false));
        platePath.push(chart.yAxis[0].toPixels(0, false));
        platePath.push(chart.xAxis[0].toPixels(-8.5, false));
        platePath.push(chart.yAxis[0].toPixels(8.5, false));
        platePath.push('Z');
        chart.renderer.path(platePath).attr(rectattr).add();
    }
    const xPP1 = Math.round((sensorEvent.Intersect1 * IN_PER_METER) * 10) / 10;
    const yPP3 = Math.round((sensorEvent.Intersect3 * IN_PER_METER) * 10) / 10;
    const chartConfig = {
        title: {
            text: undefined,
        },
        chart: {
            type: 'scatter',
            height: 250,
            width: 300,
            backgroundColor: 'transparent',
        },
        series: [{
                name: translate('components.ballcap.pitch'),
                data: xPP1 === 0 && yPP3 === 0 ? [] : [{
                        x: xPP1,
                        y: yPP3,
                    }],
                marker: {
                    symbol: `url(${bb18x18})`,
                },
                color: 'blue',
            }],
        xAxis: {
            min: -20,
            max: 20,
        },
        yAxis: {
            title: {
                text: translate('components.ballcap.depth-in'),
            },
            min: -10,
            max: 30,
        },
        legend: false,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Container$2, null,
            React.createElement(BaseChart, { ref: ref, options: chartConfig }))));
};

const Container$1 = styled.div `
    ${BaseChartContainer} {
        min-height: 200px;
        text-align: center;
    }
`;
const LaunchAngle = ({ sensorEvent }) => {
    const { t: translate } = useTranslation();
    const velo = Math.round((sensorEvent.Velo * MPS_MPH) * 10) / 10;
    const launchAngle = Math.round(sensorEvent.Elv * 10) / 10;
    const chartConfig = {
        chart: {
            polar: true,
            type: 'line',
            // height: 355,
            // width: 355,
            backgroundColor: 'transparent',
        },
        title: {
            text: undefined,
        },
        pane: {
            startAngle: 0,
            endAngle: 180,
        },
        xAxis: {
            min: -90,
            max: 90,
            tickInterval: 15,
            labels: {
                formatter() {
                    return (!this.isFirst && !this.isLast) ? `${this.value}°` : '';
                },
            },
            reversed: true,
            startOnTick: true,
            endOnTick: true,
            alignTicks: true,
        },
        yAxis: {
            min: 20,
            max: 120,
            tickInterval: 25,
            labels: {
                format: `{value} ${translate('components.ballcap.abbr-mph')}`,
            },
            reversedStacks: true,
        },
        tooltip: {
            formatter() {
                if (this.x !== 0 || this.y !== 0) {
                    return `<b>${this.x}°</b>, <b>${this.y} ${translate('components.ballcap.abbr-mph')}</b>`;
                }
                return false;
            },
        },
        plotOptions: {
            series: {
                pointStart: 0,
                lineWidth: 4,
                marker: {
                    symbol: `url(${bb18x18})`,
                },
                states: {
                    hover: {
                        enabled: false,
                    },
                },
            },
        },
        series: [{
                type: 'line',
                animation: false,
                name: translate('components.ballcap.exit-velo'),
                data: [{ x: 0, y: 0, marker: { enabled: false } }, { x: launchAngle, y: velo }],
            }],
        legend: {
            enabled: false,
        },
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Container$1, null,
            React.createElement(BaseChart, { options: chartConfig }))));
};

const Container = styled.div `
  
        // min-height: 200px;
        text-align: center;
        padding: 1rem;

        table, th, td {
            border-collapse: collapse;
          }
          div {
            text-align: center;
          }
       
`;
const HittraxDataPane = ({ sensorEvent }) => {
    const xStrikeZoneSeries = Math.round((sensorEvent.PP1 * FT_PER_METER) * 10) / 10;
    const yStrikeZoneSeries = Math.round((sensorEvent.PP2 * FT_PER_METER) * 10) / 10;
    const xSprayChartSeries = Math.round((sensorEvent.PE1 * FT_PER_METER) * 10) / 10;
    const ySprayChartSeries = Math.round((sensorEvent.PE3 * FT_PER_METER) * 10) / 10;
    const strikeZoneSeries = xStrikeZoneSeries === 0 && yStrikeZoneSeries === 0 ? [] : [{
            data: [{
                    x: xStrikeZoneSeries,
                    y: yStrikeZoneSeries,
                }],
            marker: {
                symbol: `url(${bb18x18})`,
                radius: 16,
            },
            states: {
                hover: {
                    enabled: false,
                },
            },
        }];
    const sprayChartSeries = [{
            data: [{
                    x: xSprayChartSeries,
                    y: ySprayChartSeries,
                }],
            marker: {
                symbol: `url(${bb18x18})`,
            },
            states: {
                hover: {
                    enabled: false,
                },
            },
        }];
    return (React.createElement(Container, null,
        React.createElement("div", null,
            React.createElement(HitTrax, { sensorEvent: sensorEvent }),
            React.createElement("table", null,
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("th", null,
                            React.createElement(ZoneDepth, { sensorEvent: sensorEvent })),
                        React.createElement("th", null,
                            React.createElement(StrikeZone$3, { seriesData: strikeZoneSeries, showSeries: true, size: "sm", height: 220, width: 150, showlegend: false, legendposition: "below", pitcherView: true, showoffgrid: true, showbatter: false, hideGrid: true }))),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement(LaunchAngle, { sensorEvent: sensorEvent })),
                        React.createElement("td", null,
                            React.createElement(SprayChart$3, { type: "outfield", seriesData: sprayChartSeries }))))))));
};

/* eslint-disable react/no-this-in-sfc */
// Sets names of the columns
const pitchRows = (translate) => [
    { name: translate('components.ballcap.velocity'), num: 0, key: 'InitSpeed', precision: 1, units: ' mph', lowText: translate('components.ballcap.slow'), highText: translate('components.ballcap.hard') },
    { name: translate('components.ballcap.horiz-break-x'), num: 0, key: 'BreakX54', precision: 1, units: '"', lowText: translate('components.ballcap.backs-up'), highText: translate('components.ballcap.sweep') },
    { name: translate('components.ballcap.vert-break-z'), num: 0, key: 'BreakZ54', precision: 1, units: '"', lowText: translate('components.ballcap.drop'), highText: translate('components.ballcap.tight') },
    { name: translate('components.ballcap.spin-rate'), num: 0, key: 'SpinRate', units: ' rpm', lowText: translate('components.ballcap.low-spin'), highText: translate('components.ballcap.high-spin') },
    { name: translate('components.ballcap.transverse-spin'), num: 0, key: 'TransverseSpin', units: ' rpm', lowText: translate('components.ballcap.low'), highText: translate('components.ballcap.high') },
    { name: translate('components.ballcap.gyro-spin'), num: 0, key: 'GyroSpin', units: ' rpm', lowText: translate('components.ballcap.low'), highText: translate('components.ballcap.high') },
];
const breakingBallRows = (translate) => [
    { name: `${translate('baseball.pitches.abbr-fastball')} ${translate('components.ballcap.velo-diff')}`, num: 0, key: 'FBVeloDiff', precision: 1, units: ' mph', lowText: translate('components.ballcap.low-sep'), highText: translate('components.ballcap.high-sep') },
    { name: `${translate('baseball.pitches.abbr-fastball')} ${translate('components.ballcap.break-x-diff')}`, num: 0, key: 'FBBreakXDiff', precision: 1, units: '"', lowText: translate('components.ballcap.high-sep'), highText: translate('components.ballcap.low-sep') },
    { name: `${translate('baseball.pitches.abbr-fastball')} ${translate('components.ballcap.break-z-diff')}`, num: 0, key: 'FBBreakZDiff', precision: 1, units: '"', lowText: translate('components.ballcap.low-sep'), highText: translate('components.ballcap.high-sep') },
];
const fastballRows = (translate) => [
    { name: translate('components.ballcap.rel-adj-break-x'), num: 0, key: 'RelAdjBreakX', precision: 1, units: '"', lowText: translate('components.ballcap.run'), highText: translate('components.ballcap.cut') },
    { name: translate('components.ballcap.rel-adj-break-z'), num: 0, key: 'RelAdjBreakZ', precision: 1, units: '"', lowText: translate('components.ballcap.sink-flat'), highText: translate('components.ballcap.ride') },
];
// -- Helper functions --
// Determines FB based on pitch type
const isFastballType = (pitchType) => [1, 9, 10].includes(pitchType);
// Calculates & Sets FB Diffs
function calculateAndSetFBDiffs(pitch, percentileStatsUpdated) {
    if (!percentileStatsUpdated.fastballs || !pitch) {
        return;
    }
    pitch.FBVeloDiff = percentileStatsUpdated.fastballs.InitSpeed - pitch.InitSpeed;
    pitch.FBBreakXDiff = percentileStatsUpdated.fastballs.BreakX54 - pitch.BreakX54;
    pitch.FBBreakZDiff = percentileStatsUpdated.fastballs.BreakZ54 - pitch.BreakZ54;
    // return pitch;
}
// Changes vals from being 0 to the current pitch vals
function changeValsForFB(rows, pitch) {
    rows.forEach((key, index) => {
        if (rows[index].key === 'InitSpeed') {
            rows[index].num = format(pitch.InitSpeed, 1);
        }
        else if (rows[index].key === 'BreakX54') {
            rows[index].num = pitch.BreakX54;
        }
        else if (rows[index].key === 'BreakZ54') {
            rows[index].num = pitch.BreakZ54;
        }
        else if (rows[index].key === 'SpinRate') {
            rows[index].num = Math.round(pitch.SpinRate).toLocaleString('en-US');
        }
        else if (rows[index].key === 'TransverseSpin') {
            rows[index].num = Math.round(pitch.TransverseSpin).toLocaleString('en-US');
        }
        else if (rows[index].key === 'GyroSpin') {
            rows[index].num = Math.round(pitch.GyroSpin).toLocaleString('en-US');
        }
        else if (rows[index].key === 'FBVeloDiff') {
            rows[index].num = pitch.FBVeloDiff.toFixed(rows[index].precision || 0);
        }
        else if (rows[index].key === 'FBBreakXDiff') {
            rows[index].num = pitch.FBBreakXDiff.toFixed(rows[index].precision || 0);
        }
        else if (rows[index].key === 'FBBreakZDiff') {
            rows[index].num = pitch.FBBreakZDiff.toFixed(rows[index].precision || 0);
        }
    });
    return rows;
}
// Changes vals from 0 to current pitch
function changeVals(rows, pitch) {
    rows.forEach((key, index) => {
        if (rows[index].key === 'InitSpeed') {
            rows[index].num = format(pitch.InitSpeed, 1);
        }
        else if (rows[index].key === 'BreakX54') {
            rows[index].num = pitch.BreakX54;
        }
        else if (rows[index].key === 'BreakZ54') {
            rows[index].num = pitch.BreakZ54;
        }
        else if (rows[index].key === 'SpinRate') {
            rows[index].num = Math.round(pitch.SpinRate).toLocaleString('en-US');
        }
        else if (rows[index].key === 'TransverseSpin') {
            rows[index].num = Math.round(pitch.TransverseSpin).toLocaleString('en-US');
        }
        else if (rows[index].key === 'GyroSpin') {
            rows[index].num = Math.round(pitch.GyroSpin).toLocaleString('en-US');
        }
        else if (rows[index].key === 'RelAdjBreakX') {
            rows[index].num = pitch.RelAdjBreakX;
        }
        else if (rows[index].key === 'RelAdjBreakZ') {
            rows[index].num = pitch.RelAdjBreakZ;
        }
    });
    return rows;
}
// Calculates Stat Percentile
function _calculateStatPercentile(statKey, value, percentileStatsUpdated) {
    if (!statKey || isNaN(value) || !percentileStatsUpdated.length) {
        return null;
    }
    const ranks = percentileStatsUpdated
        .filter((playerAvg) => playerAvg[`${statKey}_Count`] >= 50)
        .sort((a, b) => a[`${statKey}_Rank`] - b[`${statKey}_Rank`])
        .map((playerAvg) => playerAvg[statKey]);
    let rankIdx = 0;
    if (value >= ranks[ranks.length - 1]) {
        rankIdx = ranks.length;
    }
    else if (value > ranks[0]) {
        while (true) {
            rankIdx += 1;
            if (value >= ranks[rankIdx - 1] && value <= ranks[rankIdx]) {
                break;
            }
        }
    }
    return 100.0 * rankIdx / ranks.length;
}
// Maps Session Avgs
function mapSessionAverages(pitch, allSessionPitches, pitchType, statKey, averagePitchStats) {
    const mappedSessionPitches = (allSessionPitches || [])
        .filter((p) => p.PitchType === pitchType)
        .map((p) => { calculateAndSetFBDiffs(p, averagePitchStats); return p; });
    const averages = mappedSessionPitches // .concat(pitch)
        .map((p) => p && p[statKey])
        .filter((stat) => stat !== null && stat !== '' && !isNaN(stat));
    if (averages.length) {
        const total = averages.reduce((acc, stat) => acc + stat, 0.0);
        return total / averages.length;
    }
    return null;
}
// Functions to combine pitch, allSessionPitches, percentileStats
function mapPitchData(translate, pitch, allSessionPitches, averagePitchStats, percentileStatsUpdated) {
    if (!pitch) {
        return [];
    }
    // const breakZ54 = number(getRapsodo9PFitBreaks(pitch, 6.5).BreakZ, 1);
    // const breakX54 = number(getRapsodo9PFitBreaks(pitch, 6.5).BreakX, 1);
    let rows = pitchRows(translate);
    // Determines if FB or not
    if (isFastballType(pitch.PitchType)) {
        rows = rows.concat(fastballRows(translate));
        rows = changeVals(rows, pitch);
    }
    else {
        calculateAndSetFBDiffs(pitch, averagePitchStats);
        rows = rows.concat(breakingBallRows(translate));
        rows = changeValsForFB(rows, pitch);
    }
    // Adds season + session data to rows
    const avgPitchType = averagePitchStats && averagePitchStats[pitch.PitchType];
    const mappedData = rows.map((row) => (Object.assign(Object.assign({}, row), { pitch: {
            value: format(pitch[row.key], row.precision || 0),
            percentile: _calculateStatPercentile(row.key, pitch[row.key], percentileStatsUpdated),
        }, seasonAvg: avgPitchType && avgPitchType[row.key], sessionAvg: mapSessionAverages(pitch, allSessionPitches, pitch.PitchType, row.key, averagePitchStats) }))).filter((row) => row.pitch.value !== null && row.pitch.value !== undefined);
    let newData = [...mappedData];
    if (avgPitchType) {
        newData = newData.concat(mappedData.map((pitchPerc) => (Object.assign(Object.assign({}, pitchPerc), { isSeasonAvg: true, pitch: {
                value: pitchPerc.seasonAvg,
                percentile: _calculateStatPercentile(pitchPerc.key, pitchPerc.seasonAvg, percentileStatsUpdated),
            } }))));
        if (allSessionPitches && allSessionPitches.length) {
            newData = newData.concat(mappedData.map((pitchPerc) => (Object.assign(Object.assign({}, pitchPerc), { isSessionAvg: true, pitch: {
                    value: pitchPerc.sessionAvg,
                    percentile: _calculateStatPercentile(pitchPerc.key, pitchPerc.sessionAvg, percentileStatsUpdated),
                } }))));
        }
        // Define a custom symbol for percentile maarkers
        Highcharts.SVGRenderer.prototype.symbols.line = function (x, y, w, h) {
            return ['M', x + w / 2, y, 'L', x + w / 2, y + h, 'z'];
        };
        return newData.map((x) => (Object.assign(Object.assign(Object.assign({}, x), x.pitch), { y: x.pitch.percentile, marker: {
                symbol: x.isSeasonAvg ? 'line'
                    : x.isSessionAvg ? 'line'
                        : 'circle',
                lineColor: x.isSeasonAvg ? '#000080'
                    : x.isSessionAvg ? '#197EFF'
                        : 'black',
            } })));
    }
    return [];
}
const _assignPitchDataTotals = (acc, p, pKey) => {
    const statValue = p[pKey];
    const isFastball = isFastballType(p.Type);
    if (statValue) {
        if (!acc[p.Type]) {
            acc[p.Type] = {};
        }
        if (!acc[p.Type][pKey]) {
            acc[p.Type][pKey] = { total: 0, count: 0 };
        }
        if (isFastball && !acc.fastballs[pKey]) {
            acc.fastballs[pKey] = { total: 0, count: 0 };
        }
        acc[p.Type][pKey].total += statValue;
        acc[p.Type][pKey].count += 1;
        if (isFastball) {
            acc.fastballs[pKey].total += statValue;
            acc.fastballs[pKey].count += 1;
        }
    }
};
const PitchStatPercentiles = ({ width, pitch, allSessionPitches, percentileStats, allPitcherPitches, playerID }) => {
    const { t: translate } = useTranslation();
    const ref = useRef(null);
    const percentileStatsUpdated = useMemo(() => (percentileStats || [])
        .filter((avg) => avg.Type === pitch.PitchType && avg.MLBAMPlayerID !== playerID), [pitch, percentileStats, playerID]);
    const averagePitchStats = useMemo(() => {
        const ps = (allPitcherPitches || []).reduce((acc, p) => {
            _assignPitchDataTotals(acc, p, 'InitSpeed');
            _assignPitchDataTotals(acc, p, 'BreakX54');
            _assignPitchDataTotals(acc, p, 'BreakZ54');
            _assignPitchDataTotals(acc, p, 'SpinRate');
            _assignPitchDataTotals(acc, p, 'RelAdjBreakX');
            _assignPitchDataTotals(acc, p, 'RelAdjBreakZ');
            _assignPitchDataTotals(acc, p, 'TransverseSpin');
            _assignPitchDataTotals(acc, p, 'GyroSpin');
            return acc;
        }, { fastballs: {} });
        Object.keys(ps).forEach((PitchType) => {
            Object.keys(ps[PitchType]).forEach((statKey) => {
                const { total, count } = ps[PitchType][statKey] || { total: 0, count: 0 };
                ps[PitchType][statKey] = count > 0 ? total / (count + 0.0) : null;
            });
        });
        Object.keys(ps).filter((PitchType) => !isFastballType(PitchType)).forEach((PitchType) => {
            ps[PitchType].FBVeloDiff = ps.fastballs.InitSpeed - ps[PitchType].InitSpeed;
            ps[PitchType].FBBreakXDiff = ps.fastballs.BreakX54 - ps[PitchType].BreakX54;
            ps[PitchType].FBBreakZDiff = ps.fastballs.BreakZ54 - ps[PitchType].BreakZ54;
        });
        return ps;
    }, [allPitcherPitches]);
    const mappedChartData = mapPitchData(translate, pitch, allSessionPitches, averagePitchStats, percentileStatsUpdated);
    // Chart sections for x axis
    const chartSections = [
        {
            type: 'category',
            gridLineColor: '#cdcdcd',
            labels: {
                formatter() {
                    var _a;
                    // eslint-disable-next-line react/no-this-in-sfc
                    return `${((_a = mappedChartData[this.pos]) === null || _a === void 0 ? void 0 : _a.lowText) || ''}`;
                },
                align: 'center',
                style: {
                    textTransform: 'uppercase',
                    color: '#122447',
                    fontSize: 12,
                },
                x: -15,
            },
            lineColor: '#cdcdcd',
        },
        {
            type: 'category',
            gridLineColor: '#cdcdcd',
            linkedTo: 0,
            lineWidth: 0,
            labels: {
                formatter() {
                    // eslint-disable-next-line react/no-this-in-sfc
                    const { num, units } = mappedChartData[this.pos] || {};
                    return `${num}${units}` || '--';
                },
                x: -15,
                align: 'center',
                style: {
                    color: '#122447',
                    fontSize: 12,
                },
            },
        },
        {
            type: 'category',
            gridLineColor: '#cdcdcd',
            linkedTo: 0,
            lineWidth: 0,
            labels: {
                formatter() {
                    var _a;
                    // eslint-disable-next-line react/no-this-in-sfc
                    return `${((_a = mappedChartData[this.pos]) === null || _a === void 0 ? void 0 : _a.name) || ''}`;
                },
                x: -15,
                align: 'center',
                style: {
                    color: '#122447',
                    fontSize: 12,
                    fontWeight: 'bold',
                },
            },
        },
        {
            type: 'category',
            gridLineColor: '#cdcdcd',
            linkedTo: 0,
            opposite: true,
            lineColor: '#cdcdcd',
            labels: {
                formatter() {
                    var _a;
                    // eslint-disable-next-line react/no-this-in-sfc
                    return `${((_a = mappedChartData[this.pos]) === null || _a === void 0 ? void 0 : _a.highText) || ''}`;
                },
                align: 'center',
                style: {
                    textTransform: 'uppercase',
                    color: '#122447',
                    fontSize: 12,
                },
                x: 15,
            },
        },
    ];
    // Display season + session avg
    if (allSessionPitches != null) {
        chartSections.push({
            type: 'category',
            linkedTo: 0,
            lineWidth: 0,
            opposite: true,
            title: {
                text: `${translate('components.ballcap.session')} <br/> ${translate('common.abbr-average')}`,
                rotation: 0,
                align: 'high',
                reserveSpace: false,
                textAlign: 'center',
                x: -33,
                y: -15,
                style: {
                    color: '#2877D9',
                    fontWeight: 'bold',
                    fontSize: 12,
                },
            },
            labels: {
                formatter() {
                    // eslint-disable-next-line react/no-this-in-sfc
                    const { sessionAvg, precision } = mappedChartData[this.pos] || {};
                    return (sessionAvg && sessionAvg.toFixed(precision || 0)) || '--';
                },
                x: 20,
                align: 'center',
                style: {
                    color: '#2877D9',
                },
            },
        });
    }
    if (allSessionPitches != null) {
        chartSections.push({
            type: 'category',
            linkedTo: 0,
            lineWidth: 0,
            opposite: true,
            title: {
                text: `${translate('components.ballcap.season')}<br/>${translate('common.abbr-average')}`,
                rotation: 0,
                align: 'high',
                reserveSpace: false,
                textAlign: 'center',
                x: -30,
                y: -15,
                style: {
                    color: '#122447',
                    fontWeight: 'bold',
                    fontSize: 12,
                },
            },
            labels: {
                formatter() {
                    // eslint-disable-next-line react/no-this-in-sfc
                    const { seasonAvg, precision } = mappedChartData[this.pos] || {};
                    return (seasonAvg && seasonAvg.toFixed(precision || 0)) || '--';
                },
                x: 20,
                align: 'center',
                style: {
                    color: '#122447',
                },
            },
        });
    }
    const chartConfig = {
        chart: {
            width: 900,
            type: 'scatter',
            inverted: true,
            backgroundColor: 'none',
            spacing: [0, 20, 5, 0],
            spacingLeft: 5,
        },
        title: {
            text: undefined,
        },
        subtitle: {
            text: undefined,
        },
        legend: {
            enabled: false,
        },
        xAxis: chartSections,
        yAxis: {
            opposite: true,
            title: {
                text: translate('components.ballcap.percentile'),
                style: {
                    color: '#122447',
                    fontWeight: 'bold',
                    fontSize: '15px',
                },
            },
            labels: {
                format: '{value}th',
                style: {
                    color: '#122447',
                },
            },
            min: 0,
            max: 100,
            startOnTick: true,
            endOnTick: true,
            minTickInterval: 25,
            minRange: 100,
            tickInterval: 25,
            tickPositions: [0, 25, 50, 75, 100],
            minColor: '#cdcdcd',
            maxColor: '#cdcdcd',
            gridLineColor: '#cdcdcd',
            showLastLabel: false,
            showFirstLabel: false,
        },
        tooltip: {
            formatter() {
                // eslint-disable-next-line react/no-this-in-sfc
                // eslint-disable-next-line max-len
                return `${this.point.marker.symbol === 'circle' ? `${this.key}: ${this.point.num}${this.point.units}<br>` : ''}${translate('components.ballcap.percentile')}: ${format(this.y, 1)}%`;
            },
        },
        plotOptions: {
            scatter: {
                zones: [{
                        value: 25,
                        color: 'rgb(0, 122, 213)',
                    }, {
                        value: 75,
                        color: 'rgb(240, 240, 240)',
                    }, {
                        color: 'rgb(247, 46, 46)',
                    }],
                marker: {
                    enabled: true,
                    symbol: 'circle',
                    lineWidth: 1,
                    lineColor: '#222',
                    radius: 6,
                },
            },
        },
        series: [{
                data: mappedChartData,
            }],
    };
    return (React.createElement("div", { className: "d-flex justify-content-center" },
        React.createElement(BaseChart, { width: width, ref: ref, options: chartConfig, useBodyFont: false })));
};

const sizesWidth = { xs: 110, sm: 230, lg: 350, ptloc: 240 };
const sizesHeight = { xs: 90, sm: 230, lg: 350, ptloc: 278 };
const sizesAxisWidth = { xs: 125, sm: 200, lg: 300, ptloc: 218 };
const sizesAxisHeight = { xs: 125, sm: 200, lg: 300, ptloc: 218 };
const heatmapBackgroundHeight = { xs: 187, sm: 300, lg: 450, ptloc: 328 };
const heatmapBackgroundWidth = { xs: 150, sm: 248, lg: 365, ptloc: 270 };
const heatmapBackgroundX = { xs: -20, sm: -7, lg: -16, ptloc: -40 };
const heatmapBackgroundY = { xs: -49, sm: -50, lg: -75, ptloc: -10 };
const sizes = {
    width: sizesWidth,
    height: sizesHeight,
    axiswidth: sizesAxisWidth,
    axisheight: sizesAxisHeight,
    heatmapbackgroundheight: heatmapBackgroundHeight,
    heatmapbackgroundwidth: heatmapBackgroundWidth,
    heatmapbackgroundx: heatmapBackgroundX,
    heatmapbackgroundy: heatmapBackgroundY,
};
const LocationAttack = forwardRef(({ size = 'lg', minX = -2.25, maxX = 2.25, minY = 0.25, maxY = 4.75, height, showlhb = false, showlegend = false, yopposite = false, sztop = 3.41, szbottom = 1.57, pitcherView = true, showHeatMapBackground = true, heatMapBackgroundOpacity, hideGrid, showStrikeZone = false, hideAxis = false, customLegend, preventLegendSeriesHover = false, pitch, vsLHB, Split, heatmaps, }, outerRef) => {
    const ref = useRef(null);
    const [elements, setElements] = useState({});
    const [foundHeatmap, setHeatmap] = useState(true);
    const { t: translate } = useTranslation();
    useImperativeHandle(outerRef, () => ({
        hoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.markerGroup.toFront();
            (_e = (_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.chart.series[seriesIndex]) === null || _d === void 0 ? void 0 : _d.data[dataIndex]) === null || _e === void 0 ? void 0 : _e.setState('hover');
        },
        resetHoverPoint: (seriesIndex, dataIndex) => {
            var _a, _b, _c;
            (_c = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.chart.series[seriesIndex]) === null || _b === void 0 ? void 0 : _b.data[dataIndex]) === null || _c === void 0 ? void 0 : _c.setState('normal');
        },
    }));
    // Update state when prop changes through
    useEffect(() => {
        redraw();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref, showHeatMapBackground, pitcherView, pitch]);
    function redraw() {
        var _a;
        const chart = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.chart) || null;
        if (!chart)
            return;
        if (showStrikeZone)
            renderLocationAttack(chart);
        renderHeatMapBackground(chart);
    }
    const legendConfig = Object.assign({ enabled: showlegend }, customLegend);
    // if (customLegend === null || customLegend === undefined) {
    //     if (legendposition === 'float') {
    //         legendConfig.align = 'right';
    //         legendConfig.verticalAlign = 'top';
    //         legendConfig.layout = 'vertical';
    //         legendConfig.floating = true;
    //         legendConfig.x = -16;
    //         legendConfig.y = 10;
    //     } else if (legendposition === 'below') {
    //         legendConfig.align = 'center';
    //         legendConfig.floating = true;
    //         if (size && size !== 'lg') {
    //             legendConfig.itemDistance = 10;
    //             legendConfig.width = '100%';
    //         }
    //         if (size === 'sm') {
    //             legendConfig.itemWidth = 100;
    //             legendConfig.itemStyle = {
    //                 fontSize: '10px',
    //             };
    //             legendConfig.margin = 0;
    //         }
    //     }
    // }
    function renderLocationAttack(chart) {
        if (elements.strikeZone) {
            elements.strikeZone.forEach((el) => {
                el.element.remove();
            });
        }
        const x = chart.xAxis[0].toPixels(-0.833, false); // for some reason we have to add these offsets
        const y = chart.yAxis[0].toPixels(sztop, false); // for some reason we have to add these offsets
        const h = chart.yAxis[0].toPixels(szbottom, false) - chart.yAxis[0].toPixels(sztop, false);
        const w = chart.xAxis[0].toPixels(0.833, false) - chart.xAxis[0].toPixels(-0.833, false);
        const rectattr = {
            'stroke-width': 1,
            stroke: '#979595',
            fill: 'none',
            zIndex: 1,
        };
        const szoverall = chart.renderer.rect(x, y, w, h, 0).attr(rectattr).add();
        const szv1 = chart.renderer.rect(x, y, (w / 3.0), h, 0).attr(rectattr).add();
        const szv2 = chart.renderer.rect(x, y, 2 * (w / 3.0), h, 0).attr(rectattr).add();
        const szh1 = chart.renderer.rect(x, y, w, (h / 3.0), 0).attr(rectattr).add();
        const szh2 = chart.renderer.rect(x, y, w, 2 * (h / 3.0), 0).attr(rectattr).add();
        elements.strikeZone = [szoverall, szv1, szv2, szh1, szh2];
        setElements(elements);
    }
    function renderHeatMapBackground(chart) {
        if (elements.heatMap) {
            elements.heatMap.element.remove();
        }
        // Find heatmap based on Split, PitchType, and batter
        const heatmapInfo = heatmaps.find((item) => {
            if (item.IsLHB === vsLHB && item.Split === Split && item.PitchType === pitch.ClassifiedPitchType) {
                return item;
            }
            if (item.IsLHB === vsLHB && item.Split === Split && item.PitchType === pitch.ClassifiedPitchType) {
                return item;
            }
            return null;
        });
        const heatMapBackground = heatmapInfo ? base64ToBlob(heatmapInfo) : null;
        if (heatMapBackground) {
            const imgattr = {
                zIndex: 1,
                opacity: heatMapBackgroundOpacity || (hideGrid ? 0.75 : 0.45),
                scaleX: pitcherView ? 1 : -1,
                translateX: pitcherView ? 0 : sizes.heatmapbackgroundwidth[size] + (sizes.heatmapbackgroundx[size] * 2),
            };
            const heatMap = heatMapBackground && showHeatMapBackground ? chart.renderer
                .image(heatMapBackground, sizes.heatmapbackgroundx[size], sizes.heatmapbackgroundy[size], sizes.heatmapbackgroundwidth[size], sizes.heatmapbackgroundheight[size])
                .attr(imgattr)
                .add() : undefined;
            elements.heatMap = heatMap;
            setElements(elements);
            setHeatmap(true);
        }
        else {
            setHeatmap(false);
        }
    }
    let margin;
    if (size === 'ptloc')
        margin = showlhb ? [45, 0, 8, 37] : [45, 0, 8, -13];
    else if (size === 'xs')
        margin = [-18, 0, 0, -7];
    else
        margin = [0, 0, 0, 17];
    const hideChartTicksAndGrids = /* hideGrid || */ ['ptloc', 'xs'].includes(size);
    const chartConfig = {
        chart: {
            type: 'scatter',
            height: height || sizes.height[size],
            width: sizes.width[size],
            backgroundColor: undefined,
            zoomType: undefined,
            spacing: hideChartTicksAndGrids ? [0, 0, 0, 0] : [10, 10, 15, 10],
            margin,
        },
        plotOptions: {
            series: {
                marker: {
                    radius: 5,
                    symbol: 'circle',
                    lineColor: 'black',
                    lineWidth: 2,
                    fillColor: '#FFFFFF',
                },
                stickyTracking: false,
                turboThreshold: 0,
                dataLabels: {
                    allowOverlap: true,
                    // padding: 2,
                    crop: false,
                    overflow: 'justify',
                },
                states: {
                    inactive: {
                        opacity: preventLegendSeriesHover ? 1 : 0.2,
                    },
                },
            },
        },
        legend: legendConfig,
        xAxis: {
            visible: !hideAxis,
            height: sizes.axisheight[size],
            width: sizes.axisheight[size],
            min: minX,
            max: maxX,
            gridLineWidth: 0,
            tickInterval: 1,
            tickLength: hideChartTicksAndGrids ? 0 : 6,
            minorTickInterval: 0.25,
            minorTickLength: hideChartTicksAndGrids ? 0 : 4,
            minorTickWidth: hideChartTicksAndGrids ? 0 : 1,
            minorGridLineWidth: (hideGrid || hideChartTicksAndGrids) ? 0 : 1,
            minorGridLineColor: '#FCF8F8',
            minPadding: 0,
            maxPadding: 0,
            lineColor: hideChartTicksAndGrids ? 'transparent' : undefined,
            labels: {
                enabled: !hideChartTicksAndGrids,
                reserveSpace: false,
            },
        },
        yAxis: {
            visible: !hideAxis,
            height: sizes.axisheight[size],
            width: sizes.axisheight[size],
            min: minY,
            max: maxY,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 1,
            tickLength: hideChartTicksAndGrids ? 0 : 6,
            minorTickInterval: 0.25,
            minorTickLength: hideChartTicksAndGrids ? 0 : 4,
            minorTickWidth: hideChartTicksAndGrids ? 0 : 1,
            minorGridLineWidth: (hideGrid || hideChartTicksAndGrids) ? 0 : 1,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: yopposite,
            lineColor: hideChartTicksAndGrids ? 'transparent' : undefined,
            title: {
                text: null,
            },
            labels: {
                enabled: !hideChartTicksAndGrids,
                reserveSpace: false,
                x: yopposite ? 5 : -5,
            },
        },
        tooltip: {
            borderWidth: 1,
            borderColor: '#AAA',
            borderRadius: 2,
            formatter() {
                if (pitch.LocationX !== 0 && pitch.LocationZ !== 0) {
                    return `<b> ${translate('components.ballcap.pitch-type')}:  ${pitchType(pitch.ClassifiedPitchType, undefined, undefined, translate)}
                    ${translate('components.ballcap.abbr-x')}: ${format(pitch.LocationX, 1)}, ${translate('components.ballcap.abbr-z')}: ${format(pitch.LocationZ, 1)} </b>`;
                }
                return false;
            },
        },
        series: [{
                type: 'scatter',
                name: 'Pitch',
                data: [{ x: pitch.LocationX / 12, y: pitch.LocationZ / 12, color: '#BF0B23' }], // plot expects values in feet
            }],
        title: {
            align: 'center',
            text: foundHeatmap ? handedness(vsLHB) : ' ',
            style: {
                fontWeight: 'bold',
                color: '#222',
                fontSize: '15px',
            },
        },
        credits: {
            enabled: false,
        },
    };
    // Determines if LHB or RHB
    function handedness(IsLHB) {
        if (IsLHB === true) {
            return `${translate('baseball.abbr-versus')} ${translate('baseball.lhh')}`;
        }
        if (IsLHB === false) {
            return `${translate('baseball.abbr-versus')} ${translate('baseball.rhh')}`;
        }
        return '';
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null, foundHeatmap && (React.createElement(BaseChart, { ref: ref, width: sizes.width[size], options: chartConfig, useBodyFont: false })))));
});

/* eslint-disable react/no-this-in-sfc */
// Maps the current pitch and pitches of all time to chart
const mapPitchesToSeries = (translate, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
pitch, keyX, keyY, marker, opacity = 0.8, enableMouseTracking = true) => {
    const initPitchTypeGroups = {};
    const pitchTypeGroups = pitch.reduce((acc, p) => {
        if (!acc[p.PitchType])
            acc[p.PitchType] = new Array();
        if (acc[p.PitchType].length < 500 && p[keyX] !== null && p[keyY] !== null) {
            acc[p.PitchType].push({
                // ...p,
                x: parseFloat(p[keyX]),
                y: parseFloat(p[keyY]),
                color: pitchTypeColor(p.PitchType, translate),
                marker,
            });
        }
        return acc;
    }, initPitchTypeGroups);
    return Object.keys(pitchTypeGroups).map((pt) => ({
        type: 'scatter',
        data: pitchTypeGroups[pt],
        name: (pitchType(pt, undefined, undefined, translate) || pitchType(0, undefined, undefined, translate)),
        opacity,
        enableMouseTracking,
        color: pitchTypeColor(pt, translate),
    })).filter((g) => { var _a; return (_a = g === null || g === void 0 ? void 0 : g.data) === null || _a === void 0 ? void 0 : _a.length; });
};
// Adds Pitch Type to AllPitches
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const transformAllPitches = (p) => (Object.assign(Object.assign({}, p), { PitchType: p.Type, Velocity: p.InitSpeed }));
const PitchBreak = ({ pitch, keyX, keyY, keyX2, keyY2, labelX = '', labelY, minX = null, minY = null, maxX = null, maxY = null, minMaxCoordinate = 5, height = 210, width = 210, enableZoom = false, perspective = 'pitcher', allPitches = [], showlegend = false, allSessionPitches = [], }) => {
    const ref = useRef(null);
    const { t: translate } = useTranslation();
    const labelXuse = labelX === '' ? translate('components.ballcap.break-x-in') : labelX;
    const pitchSessionData = allSessionPitches.filter((p) => p.PitchType); // && (p[keyX] || p[keyX2] || p[keyY] || p[keyY2]));
    const transformedAllPitcherPitchesData = allPitches === null || allPitches === void 0 ? void 0 : allPitches.map((p) => transformAllPitches(p));
    const pitchSeries = mapPitchesToSeries(translate, [pitch], keyX, keyY, { radius: 6, lineWidth: 2, lineColor: '#333333' }, 1.0, true); // current pitch
    const pitchSessionSeries = mapPitchesToSeries(translate, pitchSessionData || [], keyX, keyY, { radius: 4, lineWidth: 1, lineColor: '#333333' }, 0.5, true); // all pitches in the session
    const allPitchSeries = mapPitchesToSeries(translate, transformedAllPitcherPitchesData || [], keyX2, keyY2, { radius: 2, lineWidth: 0 }, 0.1, false); // all-pitch series
    const pitchTypeSeries = allPitchSeries.concat(pitchSessionSeries).concat(pitchSeries);
    const xAbsVals = pitchTypeSeries.flatMap(({ data }) => data.map(({ x }) => Math.abs(x || 0)));
    const yAbsVals = pitchTypeSeries.flatMap(({ data }) => data.map(({ y }) => Math.abs(y || 0)));
    const chartScale = Math.max(minMaxCoordinate - 1, ...xAbsVals, ...yAbsVals) + 1;
    const chartConfig = {
        chart: {
            type: 'scatter',
            animation: false,
            plotBorderWidth: 1,
            zoomType: enableZoom ? 'xy' : undefined,
            backgroundColor: undefined,
            height,
            width,
        },
        title: {
            text: undefined,
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            scatter: {
                animation: false,
                stickyTracking: false,
                marker: {
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: 'white',
                        },
                    },
                },
            },
        },
        legend: {
            enabled: showlegend,
            title: {
                text: translate('components.ballcap.pitch-type'),
            },
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'bottom',
        },
        xAxis: {
            min: minX != null ? minX : -chartScale,
            max: maxX != null ? maxX : chartScale,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 5,
            tickLength: 6,
            minorTickInterval: 1,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: false,
            reversed: !perspective || perspective === 'pitcher',
            title: {
                text: labelXuse,
            },
        },
        yAxis: {
            min: minY != null ? minY : -chartScale,
            max: maxY != null ? maxY : chartScale,
            gridLineWidth: 0,
            lineWidth: 1,
            tickInterval: 5,
            tickLength: 6,
            minorTickInterval: 1,
            minorTickLength: 4,
            minorTickWidth: 1,
            minorGridLineWidth: 0,
            minorGridLineColor: '#FCF8F8',
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            opposite: false,
            title: {
                text: labelY,
            },
        },
        tooltip: {
            formatter() {
                // eslint-disable-next-line no-nested-ternary
                return keyY === 'breakz54' ? `<b>${this.series.name}</b><br><b>${labelXuse}: </b>${this.x} <br> <b>${labelY}: </b>${this.y}`
                    : keyY === 'velocity' ? `<b>${this.series.name}</b><br><b>${labelXuse}: </b>${this.x} <br> <b>${labelY}: </b>${format(this.y, 1)}`
                        : false;
            },
        },
        series: pitchTypeSeries,
    };
    return (React.createElement("div", { className: "d-flex justify-content-center" },
        React.createElement(BaseChart, { ref: ref, width: width, options: chartConfig, useBodyFont: false })));
};

const Styles = styled.div `
    padding: 5px;
    background-color: #e0e0e0;
    overflow-y: hidden;
`;
const StyledRow = styled.div `
    .custom-button {
        border: 1px solid #9b9b9b;
    }

    .selected-button {
        border: 2px solid #0077d9 !important;
    }
`;
const StyledButtonRow = styled.div `
    overflow-x: auto;
    column-gap: 5px; 
    padding: 3px 4px; 
    position: absolute; 
    top: 0; 
    width: calc(100% - 228px); 
    background-color: #e0e0e0;
    z-index: 15;
`;
const StyledStat = styled.div `
    background-color: ${styles.theme.background.endeavour};
    color: white;
    border-radius: 5px;
    text-align: center;
    padding: 7px 0;
`;
const StyledValue = styled.div `
    font-size: 24px;
    font-weight: 700;
`;
const StyledLabel = styled.div `
    font-size: 12px;
`;
const StyledCard = styled(Card$1) `
    width: 100%;
    margin-bottom: 5px;
    padding: 10px;
`;
const FullWidthButton = styled(Button) `
    && {
        height: 100%;
        text-align: left;
        boxShadow: 'rgb(0 0 0 / 50%) 0 1px 2px 0px';
        white-space: nowrap;
    }
`;
const InlineDiv = styled.div `
    display: inline-block;
    height: 50px;
`;
const clockToAngle = (clockTime) => {
    const clockParts = clockTime.split(':');
    const hours = parseInt(clockParts[0]);
    const minutes = parseInt(clockParts[1]);
    return (360 / 12 * hours) + (360 / 12 / 60 * minutes);
};
const getHittraxEventDescription = ({ Translate, Res, Fld }) => {
    var _a, _b;
    if (Res === null)
        return null;
    const result = (_a = HITTRAX_RESULT_TYPES(Translate).find((x) => x.id === Res)) === null || _a === void 0 ? void 0 : _a.name;
    const fielder = Fld && ((_b = HITTRAX_FIELDER_TYPES(Translate).find((x) => x.id === Fld)) === null || _b === void 0 ? void 0 : _b.name);
    return `${result} to ${fielder}`;
};
const getPitchData = (translate, pitch) => {
    const sensorMetrics = pitch.SensorEvents
        .find((s) => s.SensorType !== 'SerialRadar');
    if (!sensorMetrics || !Object.keys(sensorMetrics).length) {
        return Object.assign({}, pitch);
    }
    let velocity = null;
    let breaks;
    let breaks54;
    if (Number(sensorMetrics.Data.speedConfidence) > 0.8 || (!sensorMetrics.Data.speedConfidence && sensorMetrics.Data.speed)) {
        velocity = Number(sensorMetrics.Data.speed);
    }
    if (Number(sensorMetrics.Data.spinConfidence) >= 0.8) {
        breaks = getRapsodo9PFitBreaks(sensorMetrics.Data, null);
        breaks54 = getRapsodo9PFitBreaks(sensorMetrics.Data, 6.5);
    }
    else if (sensorMetrics.Data.PP1 !== undefined && sensorMetrics.Data.PP1 !== null) {
        const { PP1, PP2 } = sensorMetrics.Data;
        breaks = { PlateX: Number(PP1) * FT_PER_METER, PlateZ: Number(PP2) * FT_PER_METER };
    }
    let phi = null;
    let theta = null;
    if (sensorMetrics.Data.spinAxis) {
        phi = clockToAngle(sensorMetrics.Data.spinAxis);
        theta = Number(sensorMetrics.Data.gyroDegree || 0.0);
    }
    return Object.assign(Object.assign(Object.assign({}, pitch), sensorMetrics), { pitchtype: pitch.ClassifiedPitchType || pitch.PitchType, PitchType: pitch.ClassifiedPitchType || pitch.PitchType, velocity, Velocity: velocity, InitSpeed: velocity, platex: (breaks === null || breaks === void 0 ? void 0 : breaks.PlateX) || null, platez: (breaks === null || breaks === void 0 ? void 0 : breaks.PlateZ) || null, breakx: breaks === null || breaks === void 0 ? void 0 : breaks.BreakX, breakz: breaks === null || breaks === void 0 ? void 0 : breaks.BreakZ, breakx54: breaks54 === null || breaks54 === void 0 ? void 0 : breaks54.BreakX, breakz54: breaks54 === null || breaks54 === void 0 ? void 0 : breaks54.BreakZ, BreakX54: breaks54 === null || breaks54 === void 0 ? void 0 : breaks54.BreakX, BreakZ54: breaks54 === null || breaks54 === void 0 ? void 0 : breaks54.BreakZ, x0: Number(sensorMetrics.Data.x0) || undefined, y0: Number(sensorMetrics.Data.y0) || undefined, z0: Number(sensorMetrics.Data.z0) || undefined, vx0: Number(sensorMetrics.Data.speedX) || undefined, vy0: Number(sensorMetrics.Data.speedY) || undefined, vz0: Number(sensorMetrics.Data.speedZ) || undefined, ax0: Number(sensorMetrics.Data.ax0) || undefined, ay0: Number(sensorMetrics.Data.ay0) || undefined, az0: Number(sensorMetrics.Data.az0) || undefined, tilt: sensorMetrics.Data.spinAxis || null, spinrate: Number(sensorMetrics.Data.spin) || null, transversespin: Number(sensorMetrics.Data.sideSpin) || null, gyrospin: Number(sensorMetrics.Data.rifleSpin) || null, theta,
        phi, hittype: sensorMetrics.Data.HT !== undefined ? hittraxHitTypeNyEnum(translate, sensorMetrics.Data.HT) : null, hitvelocity: sensorMetrics.Data.Velo ? (Number(sensorMetrics.Data.Velo) * MPS_MPH) : null, ballinplayx: sensorMetrics.Data.PE1 !== null ? Number(sensorMetrics.Data.PE1) * FT_PER_METER : null, ballinplayy: sensorMetrics.Data.PE3 !== null ? Number(sensorMetrics.Data.PE3) * FT_PER_METER : null, distance: sensorMetrics.Data.Dist ? Number(sensorMetrics.Data.Dist) * FT_PER_METER : null, launchangle: sensorMetrics.Data.Elv || null, eventdescription: getHittraxEventDescription({ Translate: translate, Res: sensorMetrics.Data.Res || 0, Fld: sensorMetrics.Data.Fld || 0 }), SpinRate: Math.abs(Number(sensorMetrics.Data.spin)), GyroSpin: Math.abs(Number(sensorMetrics.Data.rifleSpin)), TransverseSpin: Math.abs(Number(sensorMetrics.Data.sideSpin)) });
};
const mapBallCapPlaylist = (translate, pitches, videos, player, isLH) => {
    const views = CAMERA_VIEWS.reduce((acc, v) => {
        acc[v.id] = v.name;
        return acc;
    }, []);
    const playlist = pitches.map((p) => {
        const sources = p.Angles.map((a) => {
            const video = videos.find((v) => v.BucketKey.endsWith(a.FileName));
            let label = `${translate('components.ballcap.angle')} ${a.AngleName}`;
            if (a.RHAngleId && !isLH)
                label = views[a.RHAngleId];
            else if (a.LHAngleId && isLH)
                label = views[a.LHAngleId];
            return {
                file: (video === null || video === void 0 ? void 0 : video.SignedURL) || '',
                label,
            };
        }).filter((a) => a.file);
        if (sources.length) {
            sources.sort((a, b) => a.label.localeCompare(b.label));
            sources[0].default = true;
            const data = Object.assign({ gameid: p.PitchID, eventseq: p.PitchID, pitchseq: p.PitchID, islhp: player.Throws === 2, islhb: player.Bats === 2 }, p);
            let title = `${translate('baseball.pitches_one')} ${p.PitchID}`;
            if (data === null || data === void 0 ? void 0 : data.pitchtype) {
                title = `${title} - ${pitchTypeOrSubType(data.pitchtype, undefined, undefined, translate)}`;
            }
            const description = [];
            if (data === null || data === void 0 ? void 0 : data.velocity)
                description.push(`${translate('components.ballcap.abbr-velocity')}: ${translate('format.abbr-mph', { value: format(data.velocity, 1) })}`);
            if (data === null || data === void 0 ? void 0 : data.hitvelocity)
                description.push(`${translate('components.ballcap.abbr-exit-velocity')}: ${translate('format.abbr-mph', { value: format(data.hitvelocity, 1) })}`);
            return {
                pitchId: p.PitchID.toString(),
                title,
                description: description.length ? description.join(' | ') : '',
                sources,
                data,
                clip: sources.map((s) => ({
                    Url: s.file,
                    AngleLabel: s.label,
                    Include: true,
                    Data: JSON.stringify(data),
                    GameDate: null,
                    GameID: null,
                    EventSeq: null,
                    PitchSeq: null,
                })),
                heatmapId: null,
            };
        }
        return null;
    }).filter((p) => p);
    return playlist;
};
const BallcapSessionDisplay = ({ data, breakplots, percentiles, allPitcherPitches, heatmaps }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { t: translate } = useTranslation();
    const { Session, Videos } = data;
    // use this collection everywhere below
    const mappedPitches = ((_a = Session === null || Session === void 0 ? void 0 : Session.Pitches) === null || _a === void 0 ? void 0 : _a.filter((p) => !p.IsDeleted).map((p) => getPitchData(translate, p))) || [];
    const [showVideoPlayerModal, setShowVideoPlayerModal] = useState(false);
    const videoPlayerModalContainer = useRef();
    const [pitch, setPitch] = useState(mappedPitches.find((p) => { var _a; return ((_a = p.Angles) === null || _a === void 0 ? void 0 : _a.length) > 0; }) || mappedPitches[0]);
    const videoPlayerRef = useRef(null);
    useEffect(() => {
        if (data) {
            setShowVideoPlayerModal(browser$1.mobileOnly);
        }
    }, [data]);
    // const [animate, setAnimate] = useState(false);
    const isLH = (Session.CaptureSessionType === 1 && ((_b = Session.Player) === null || _b === void 0 ? void 0 : _b.Throws) === 2) || (Session.CaptureSessionType === 2 && ((_c = Session.Player) === null || _c === void 0 ? void 0 : _c.Bats) === 2);
    const playlist = mapBallCapPlaylist(translate, mappedPitches, Videos, Session.Player, isLH);
    const handleClick = (clickedPitch) => {
        var _a;
        if (clickedPitch.PitchID === (pitch === null || pitch === void 0 ? void 0 : pitch.PitchID))
            return;
        setPitch(clickedPitch);
        const thisPitchIndex = playlist.findIndex((p) => p.pitchId === clickedPitch.PitchID.toString());
        if (thisPitchIndex !== -1)
            (_a = videoPlayerRef === null || videoPlayerRef === void 0 ? void 0 : videoPlayerRef.current) === null || _a === void 0 ? void 0 : _a.goToNextVideo(thisPitchIndex);
        const buttonElement = document.getElementById(`pitchselector-${clickedPitch === null || clickedPitch === void 0 ? void 0 : clickedPitch.PitchID}`);
        buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.scrollIntoView({ behavior: 'smooth' });
    };
    const getPitchDataPromise = ({ pitchseq }) => __awaiter(void 0, void 0, void 0, function* () {
        const playlistItem = playlist.find((p) => p.pitchId === pitchseq.toString());
        const { data: playlistItemData } = playlistItem;
        return new Promise((resolve, reject) => {
            if (playlistItemData)
                resolve(playlistItemData);
            reject();
        });
    });
    const loadCurrentPitch = (clip) => {
        const sessionPitch = mappedPitches.find((p) => p.PitchID === Number(clip.pitchId));
        if (!sessionPitch)
            return;
        if (sessionPitch.PitchID !== (pitch === null || pitch === void 0 ? void 0 : pitch.PitchID))
            setPitch(sessionPitch);
        const buttonElement = document.getElementById(`pitchselector-${sessionPitch === null || sessionPitch === void 0 ? void 0 : sessionPitch.PitchID}`);
        buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.scrollIntoView();
    };
    // BREAK CHARTS
    const [breakplotChart, setBreakplotChart] = useState(null);
    const [breakplotChart2, setBreakplotChart2] = useState(null);
    useEffect(() => {
        setBreakplotChart(null);
        setBreakplotChart2(null);
        const pitchTypeUse = (pitch === null || pitch === void 0 ? void 0 : pitch.ClassifiedPitchType) || (pitch === null || pitch === void 0 ? void 0 : pitch.PitchType) || null;
        if (!pitch || !pitchTypeUse)
            return;
        const fetchBreakplots = () => __awaiter(void 0, void 0, void 0, function* () {
            const resultPlots = yield breakplots(pitchTypeUse);
            const vsLHB = resultPlots.find((item) => item.IsLHB === false);
            const vsRHB = resultPlots.find((item) => item.IsLHB === true);
            if (vsLHB)
                setBreakplotChart(base64ToBlob(vsLHB));
            if (vsRHB)
                setBreakplotChart2(base64ToBlob(vsRHB));
        });
        fetchBreakplots();
    }, [pitch, breakplots]);
    // percentiles leaguewide stats callback
    const [percentileStats, setPercentileStats] = useState([]);
    useEffect(() => {
        const pitchTypeUse = (pitch === null || pitch === void 0 ? void 0 : pitch.ClassifiedPitchType) || (pitch === null || pitch === void 0 ? void 0 : pitch.PitchType) || null;
        if (!pitch || !pitchTypeUse)
            return;
        const fetchPercentilesStats = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!percentileStats.some((x) => x.PitchType === pitchTypeUse)) {
                const results = yield percentiles(pitchTypeUse);
                const updatedPercentileStats = [...percentileStats, { PitchType: pitchTypeUse, Data: results }];
                setPercentileStats(updatedPercentileStats);
            }
        });
        fetchPercentilesStats();
    }, [pitch, percentiles, percentileStats]);
    const swingTakeResultDisplay = (manualResult, sensorPerfSci) => {
        let sensorUse = null;
        let isSensorSwing = false;
        let isSensorTake = false;
        let isManualSwing = false;
        let isManualTake = false;
        if (sensorPerfSci != null) {
            sensorUse = sensorPerfSci.find((x) => { var _a; return (_a = x.Data) === null || _a === void 0 ? void 0 : _a.Model.includes('SwingDetection'); });
            if (sensorUse != null) {
                if (sensorUse.Data.Swing == true) {
                    isSensorSwing = true;
                }
                else if (sensorUse.Data.Swing == false) {
                    isSensorTake = true;
                }
            }
        }
        if (manualResult != null) {
            if (manualResult == 1) {
                isManualTake = true;
            }
            else if (manualResult > 1) {
                isManualSwing = true;
            }
        }
        if (isManualSwing) {
            return 'Swing';
        }
        if (isManualTake) {
            return 'Take';
        }
        if (isSensorSwing) {
            return 'Swing';
        }
        if (isSensorTake) {
            return 'Take';
        }
        return 'Swing Unknown';
    };
    const trackmanSensorEvent = (_d = pitch === null || pitch === void 0 ? void 0 : pitch.SensorEvents) === null || _d === void 0 ? void 0 : _d.find((e) => e.SensorType === 'Trackman');
    const hittraxSensorEvent = (_e = pitch === null || pitch === void 0 ? void 0 : pitch.SensorEvents) === null || _e === void 0 ? void 0 : _e.find((ev) => ev.SensorType === 'HitTrax');
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledRow, null,
            React.createElement(StyledButtonRow, { className: "d-flex flex-row" }, mappedPitches.map((p) => {
                var _a, _b, _c;
                const htEvent = (_a = p.SensorEvents) === null || _a === void 0 ? void 0 : _a.find((ev) => ev.SensorType === 'HitTrax');
                const tmEvent = (_b = p.SensorEvents) === null || _b === void 0 ? void 0 : _b.find((e) => e.SensorType === 'Trackman');
                const psEvent = (_c = p.SensorEvents) === null || _c === void 0 ? void 0 : _c.filter((e) => e.SensorType === 'PerformanceScience'); // filter not find because there could be multiple
                return (React.createElement(InlineDiv, { key: `pitchButton-${p.PitchID}` },
                    React.createElement(FullWidthButton, { variant: "light", id: `pitchselector-${p.PitchID}`, onClick: () => handleClick(p), className: `${(pitch === null || pitch === void 0 ? void 0 : pitch.PitchID) === p.PitchID ? 'selected-button' : 'custom-button'}` },
                        React.createElement(Row$1, null,
                            React.createElement(Col$1, null,
                                React.createElement("span", { style: { fontWeight: 'bold', fontSize: '14px' } },
                                    translate('baseball.pitches_one'),
                                    " ",
                                    p.PitchID))),
                        ((psEvent && psEvent.length > 0) || p.BatterPitchResultType) && (React.createElement(Row$1, null,
                            React.createElement(Col$1, null,
                                React.createElement("span", { style: { fontWeight: 'lighter', fontSize: '12px' } }, swingTakeResultDisplay(p.BatterPitchResultType, psEvent))))),
                        tmEvent && (React.createElement(Row$1, null,
                            React.createElement(Col$1, null,
                                React.createElement("span", { style: { fontWeight: 'lighter', fontSize: '12px' } },
                                    pitchTypeOrSubType(p.PitchType || p.ClassifiedPitchType, true, undefined, translate) || '--',
                                    " ",
                                    translate('format.abbr-mph', { value: format(tmEvent.Data.speed, 0) }))))),
                        htEvent && htEvent.Data && htEvent.Data.Velo != undefined && htEvent.Data.Velo > 0 && (React.createElement(Row$1, null,
                            React.createElement(Col$1, null,
                                React.createElement("span", { style: { fontWeight: 'lighter', fontSize: '12px' } },
                                    translate('components.ballcap.abbr-exit-velocity'),
                                    ": ",
                                    translate('format.abbr-mph', { value: format(htEvent.Data.Velo * MPS_MPH, 1) }))))))));
            }))),
        React.createElement(Styles, null,
            React.createElement("div", { className: "d-flex align-items-center", style: { gap: '10px', paddingTop: browser$1.mobile ? '50px' : '70px' } },
                Session.Pitches.find((p) => { var _a; return ((_a = p.Angles) === null || _a === void 0 ? void 0 : _a.length) > 0; }) && (React.createElement("div", { className: "flex-grow-1", style: { display: ((_f = pitch === null || pitch === void 0 ? void 0 : pitch.Angles) === null || _f === void 0 ? void 0 : _f.length) > 0 ? 'block' : 'none' } },
                    !showVideoPlayerModal && (React.createElement(Card$1, { border: "secondary" },
                        React.createElement(VideoPlayer$1, { playlist: playlist, hideDownload: true, hideShare: true, hideFilter: true, hideFrameGrab: true, loadPitchData: getPitchDataPromise, onActiveVideoChanged: loadCurrentPitch, ref: videoPlayerRef }))),
                    showVideoPlayerModal && (React.createElement(VideoPlayerModal, { playlist: playlist, show: !!playlist, onHide: () => setShowVideoPlayerModal(false), container: videoPlayerModalContainer, hideDownload: true, hideShare: true, hideFilter: true, hideFrameGrab: true, loadPitchData: getPitchDataPromise, onActiveVideoChanged: loadCurrentPitch })))),
                pitch && (breakplotChart || breakplotChart2) && (React.createElement("div", null,
                    React.createElement(StyledCard, null,
                        breakplotChart && (React.createElement("div", { className: "d-flex justify-content-center" },
                            React.createElement("img", { src: breakplotChart, style: { width: 'auto', maxHeight: '227px' }, alt: "" }))),
                        breakplotChart2 && (React.createElement("div", { className: "d-flex justify-content-center" },
                            React.createElement("img", { src: breakplotChart2, style: { width: 'auto', maxHeight: '227px' }, alt: "" }))))))),
            trackmanSensorEvent && (React.createElement("div", { className: "d-flex flex-row justify-content-between" }, [
                { Title: translate('components.ballcap.abbr-velocity'), Value: format(pitch.velocity, 1) },
                {
                    Title: translate('components.ballcap.pitch-type'),
                    Value: pitchTypeOrSubType(pitch.PitchType, true, undefined, translate),
                },
                { Title: translate('components.ballcap.total-spin'), Value: (Math.round(pitch.spinrate || 0).toLocaleString('en-US')) },
                { Title: translate('components.ballcap.gyro-spin'), Value: (Math.round(pitch.gyrospin || 0).toLocaleString('en-US')) },
                { Title: translate('components.ballcap.gyro-degree'), Value: `${format(pitch.theta, 1)}°` },
                { Title: translate('components.ballcap.vert-break-z'), Value: `${format(pitch.breakz54, 1)}"` },
                { Title: translate('components.ballcap.horiz-break-x'), Value: `${format(pitch.breakx54, 1)}"` },
                { Title: translate('components.ballcap.tilt'), Value: pitch.tilt },
            ].map((stat) => (React.createElement(StyledStat, { key: stat.Title, bg: "primary", text: "white", style: { height: '3.2rem', width: '8.1rem', textAlign: 'center', margin: '5px' } },
                React.createElement(StyledLabel, null, stat.Title),
                React.createElement(StyledValue, null, stat.Value)))))),
            pitch && percentileStats && allPitcherPitches && trackmanSensorEvent && (React.createElement("div", null,
                React.createElement(StyledCard, { className: "mb-2 d-flex flex-column justify-content-center", style: { padding: '20px' } },
                    React.createElement(PitchStatPercentiles, { pitch: pitch, allSessionPitches: mappedPitches.filter((p) => { var _a; return (_a = p.SensorEvents) === null || _a === void 0 ? void 0 : _a.find((e) => e.SensorType === 'Trackman'); }), percentileStats: (_g = percentileStats.find((p) => p.PitchType === pitch.ClassifiedPitchType)) === null || _g === void 0 ? void 0 : _g.Data, allPitcherPitches: allPitcherPitches, playerID: data.Session.Player.MLBAMPlayerID, height: 300 })))),
            pitch && trackmanSensorEvent && (React.createElement(StyledCard, { className: "d-flex flex-row justify-content-around", style: { padding: '15px' } },
                React.createElement(Row$1, null,
                    React.createElement(Col$1, null,
                        React.createElement("div", null,
                            React.createElement(PitchBreak, { height: 300, width: 300, enableZoom: false, showlegend: false, labelY: `${translate('baseball.break-z')} (in)`, keyX: "breakx54", keyY: "breakz54", keyX2: "BreakX54", keyY2: "BreakZ54", minMaxCoordinate: 20, pitch: pitch, allSessionPitches: mappedPitches, allPitches: allPitcherPitches }))),
                    React.createElement(Col$1, null,
                        React.createElement("div", null,
                            React.createElement(PitchBreak, { height: 300, width: 300, enableZoom: false, showlegend: false, labelY: `${translate('components.ballcap.velocity')} (mph)`, minX: -20, maxX: 20, minY: 80, maxY: 100, keyX: "breakx54", keyY: "velocity", keyX2: "BreakX54", keyY2: "Velocity", pitch: pitch, allSessionPitches: mappedPitches, allPitches: allPitcherPitches })))))),
            pitch && pitch.SensorEvents && trackmanSensorEvent && (React.createElement(StyledCard, null,
                React.createElement(Row$1, { className: "text-center" },
                    React.createElement(Col$1, null,
                        React.createElement("h3", null, translate('components.ballcap.attack'))),
                    React.createElement(Col$1, null,
                        React.createElement("h3", null, translate('components.ballcap.two-strikes')))),
                React.createElement(Row$1, { xs: 4 },
                    React.createElement(Col$1, null,
                        React.createElement(LocationAttack, { size: "sm", yopposite: true, showlhb: false, pitcherView: true, showoffgrid: false, enableHeatMapBackground: true, hideGrid: true, showbatter: false, hideAxis: true, heatMapBackgroundOpacity: 1, pitch: pitch, vsLHB: true, Split: "Early", heatmaps: heatmaps })),
                    React.createElement(Col$1, null,
                        React.createElement(LocationAttack, { size: "sm", yopposite: true, showlhb: false, pitcherView: true, showoffgrid: false, enableHeatMapBackground: true, hideGrid: true, showbatter: false, hideAxis: true, heatMapBackgroundOpacity: 1, pitch: pitch, vsLHB: false, Split: "Early", heatmaps: heatmaps })),
                    React.createElement(Col$1, null,
                        React.createElement(LocationAttack, { size: "sm", yopposite: true, showlhb: false, pitcherView: true, showoffgrid: false, enableHeatMapBackground: true, hideGrid: true, showbatter: false, hideAxis: true, heatMapBackgroundOpacity: 1, pitch: pitch, vsLHB: true, Split: "TwoStrikes", heatmaps: heatmaps })),
                    React.createElement(Col$1, null,
                        React.createElement(LocationAttack, { size: "sm", yopposite: true, showlhb: false, pitcherView: true, showoffgrid: false, enableHeatMapBackground: true, hideGrid: true, showbatter: false, hideAxis: true, heatMapBackgroundOpacity: 1, pitch: pitch, vsLHB: false, Split: "TwoStrikes", heatmaps: heatmaps }))))),
            hittraxSensorEvent && hittraxSensorEvent.Data && (React.createElement(StyledCard, null,
                React.createElement(HittraxDataPane, { sensorEvent: hittraxSensorEvent.Data }))))));
};

// import resourcesToBackend from 'i18next-resources-to-backend';

const localStorageKey = 'localeCode';

const languageOptions = {
    en: { id: 1, title: 'English', name: 'English' },
    es: { id: 2, title: 'Español', name: 'Spanish' },
    ko: { id: 3, title: '한국어', name: 'Korean' },
    ja: { id: 4, title: '日本語', name: 'Japanese' },
};

const configParams = {
    // debug: true, // for debug
    // lng: 'en', // force lang code for debug
    fallbackLng: 'en',
    preload: ['en'],
    supportedLngs: Object.keys(languageOptions),
    backend: {
        backends: [
            // resourcesToBackend((lng) => import(`./locales/${lng}-translation.json`)), // use for local load from file
            Backend,
            Backend,
        ],
        // DEVS: If you want to load db8 version all the time just reverse these two backend array items, but don't
        // check it in!
        backendOptions: [{
            loadPath: '/api/translation/react/cdn/{{lng}}',
            customHeaders: {
                Authorization: 'Bearer COMP_LIBRARY_I18N', // this is an internal ID the API is looking for in order to let this request through
            },
        },
        {
            loadPath: '/api/translation/react/local/{{lng}}',
            customHeaders: {
                Authorization: 'Bearer COMP_LIBRARY_I18N',
            },
        }],
    },
    detection: { // make sure the detection info matches the pattern used in Player Portal config
        order: ['querystring', 'localStorage', 'sessionStorage', 'cookie', 'navigator', 'htmlTag'],
        lookupQuerystring: 'lng',
        lookupCookie: 'localeCookie',
        lookupLocalStorage: localStorageKey,
        lookupSessionStorage: localStorageKey,
        excludeCacheFor: ['cimode', ...Object.keys(languageOptions)],
    },
};

i18n
    .use(Backend)
    .use(Backend)
    .use(LanguageDetector)
    .use(ChainedBackend)
    .use(initReactI18next)
    .init(configParams);

const languageChangeRequest = (langCode) => {
    if (!langCode) {
        console.log('yankees-react-utils language change request failed - empty lang ID');
    }
    console.log('yankees-react-utils language change request to: _', langCode.trim(), '_');
    i18n.changeLanguage(langCode.trim());
    window.localStorage.setItem(localStorageKey, langCode.trim()); // write to the browser memory too (sometimes i18n doesn't do it on its own)
};

// we only need to export a small selection of images for now
const images = { lhbImgFront, rhbImgFront, headshotEmptyImg };

export { AUTO_PLAYLIST_TYPE, AccordionFilters, ActionMenuItem, BALLCAP_BATTER_BAT_TYPES, BALLCAP_BATTER_CONDITION_TYPES, BALLCAP_BATTER_PITCH_RESULT_TYPES, BALLCAP_SESSION_TYPES, BASE_EVENTS, BallcapSessionDisplay as BallCapSessionDisplay, BallSpin, BaseChart, BaseDialogModal, BaseMenuItem, BaseModal, BaseRunners, BatImpactChart$2 as BatImpactChart, BreakComponentsChart, Button, CAMERA_VIEWS, CKEditorInput, COUNTS, CatcherAccuracy, CatcherDepth, CatcherTimes, CatcherWristbandHeatMap, CheckRoles, Checkbox, CheckboxDropdownInput as CheckboxDropdown, CheckboxSelect, ConfirmModal, CountSelect, DIAMOND_ANGLES, DataTable, DataTableCell, DataTableHeaderCell, DatePicker, DefaultButtonAlt, DropdownInput as Dropdown, DropdownMenu, EV_LA_CHART_BACKGROUND_TYPE, EvLaChart$1 as EvLaChart, FirstStepChart, FormInputContainer, GasGaugeChart, GlobalStyle, GloveLocation, GyroSeamChart, HEATMAP_MODELS, HangtimeChart, HeadingChart$2 as HeadingChart, HeatMap, HitLocation, HitLocationSelect, HitTrax, HittingMonitor, HittingMonitorFilter, HittingNtilesCharts, HittraxDataPane, HomePlateChart, Icon, IconToggleButtons, ImageMarkup, InfieldPlayLogCharts, InfielderAccuracy$1 as InfielderAccuracy, LEVELS, LaunchAngle, LeagueSearch, LineChart, LiveFilterPills, LoadingSpinner$1 as LoadingSpinner, MLBAM_ANGLES, MechanicsAndWorkload, MultiSelect, NavMenuItem, NtilesChart, ObjectiveMetricChart, OutfieldPlayLogCharts, PERSPECTIVE_TYPES, PITCH_SUB_TYPES, PITCH_TYPES, PLAYER_VIDEO_TYPES, DataTablePagination as Pagination, PercentageCircle, PercentileChart, PerformanceScienceAsymmetryChart, PerformanceScienceAthleticIndexChart, PerformanceScienceBoxChart, PerformanceScienceFilledCircle, PerformanceScienceProjectabilityBarChart, PerformanceScienceSymmetryChart, PitchBreakPlotChart, PitchBreakdownFilter, PitchChart, PitchFilterValues, PitchLocation$1 as PitchLocation, PitchTypes, PitcherStrengthsPercentiles, PitcherTrends, PitchingMonitor, PlayerName, PlayerSearch, RESULT_TYPES, RadioButton, Range, ReceivingChart, ReportNote, SavedSearchList, SavedSearchTable, ScatterPlotChart, ScreenOnly, SeamOrientationChart, Search, SelectListModal, SimpleVideoPlayer, SimpleVideoPlayerModal, Slider, LoadingSpinner as SmallSpinner, SprayChart$3 as SprayChart, SprintExertionsChart, StatTooltip, StateTabs, StrikeZone$3 as StrikeZone, Subtabs, SwingTimelineChart, Switch, THROW_TYPES, TRANSLATION_CONTEXTS, DATE_RANGE as TRENDS_DATE_RANGE, Tab, TabContainer, TabPanel, StyledTable$1 as Table, TeamSearch, ThreeSixtyBreakdownChart, ThrowTimelineChart, ToastNotification, ToggleButtons, Trends, TrunkRotationPieChart, VenueSearch, VideoButton, VideoFilterToggleButton, VideoOverlayPlayButton, VideoPlayer$1 as VideoPlayer, VideoPlayerAdvanced, VideoPlayerModal, VideoSearch, VideoSearchForm, WebGLPathDisplay, WedgeChart, ZoneDepth, age, avg, babip, base64ToBlob, baseEvent, browser$1 as browser, cBA, catcherAccuracyScore, checkRoles, checkUserName, COLUMN_TYPES as columnTypes, api as data, date, dateTime, dateTimeTranslate, dateTranslate, defaultHittingMonitorFilter, defaultPitchBreakdownFilter, defaultFilter as defaultPitchingMonitorFilter, degreesToClock, elide, era, extraStrikesPer100, filterPlaylistFromParams, formatSalary, formatSalaryMillions, framingRuns, framingRuns120, framingStk, freeAgentYear, gbFb, getPitchTypeIdFromName, getPlateLoc, getResultTooltip$1 as getResultTooltip, grade, h2hStk, handedness, height, hitType, hits, hsClassName, images, inRange, innings, internationalizeDate, isNumber$2 as isNumber, jsonDataAsMultipartForm, languageChangeRequest, languageOptions, lob, localStorageKey, mapBallCapPlaylist$1 as mapBallCapPlaylist, mapCtwb, mapCtwbToPitches, mapPitchPaths, mapPlaylistFromVideoSearch, mean, meanMap, minInnRequirement as minInn, missPct, mlb, normalize, format as number, obp, ops, opsRV, ordinal, per100IP, per9IP, perIP, percent, pitchResult, pitchSubType, pitchSubTypeColor, pitchType, pitchTypeColor, pitchTypeDisplayName, pitchTypeOrSubType, plusMinus, positionAbbrToInt, positionLongName, positionName, rapsodo9PFitBreaks, ratio, repertoireColor, rosterState, rvERA, rvPerN, screenOnlyStyle, sec, slg, styles, swingPct, textColorForHexBackground, textColorForRgbBackground, useAbortable, useDebounce, validAge, wOBA, whip, xL, xW, yesNo };
